/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 268);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-05-11T18:29Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.0",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			return elem.textContent;
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented
// as part of Sizzle so let's maintain them in the 3.x line
// for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["createDynamicHTML"] = createDynamicHTML;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doAjax", function() { return doAjax; });
/* harmony export (immutable) */ __webpack_exports__["showCustomLoader"] = showCustomLoader;
/* harmony export (immutable) */ __webpack_exports__["removeCustomLoader"] = removeCustomLoader;
/* harmony export (immutable) */ __webpack_exports__["showLoader"] = showLoader;
/* harmony export (immutable) */ __webpack_exports__["showToast"] = showToast;
/* harmony export (immutable) */ __webpack_exports__["showGlobalToast"] = showGlobalToast;
/* harmony export (immutable) */ __webpack_exports__["hideLoader"] = hideLoader;
/* harmony export (immutable) */ __webpack_exports__["displayError"] = displayError;
/* harmony export (immutable) */ __webpack_exports__["showModal"] = showModal;
/* harmony export (immutable) */ __webpack_exports__["hideModal"] = hideModal;
/* harmony export (immutable) */ __webpack_exports__["detectmob"] = detectmob;
/* harmony export (immutable) */ __webpack_exports__["getSelectedGuests"] = getSelectedGuests;
/* harmony export (immutable) */ __webpack_exports__["updateCartSummary"] = updateCartSummary;
/* harmony export (immutable) */ __webpack_exports__["updateCouponSummary"] = updateCouponSummary;
/* harmony export (immutable) */ __webpack_exports__["updateProductSummary"] = updateProductSummary;
/* harmony export (immutable) */ __webpack_exports__["pdpGetSelectedData"] = pdpGetSelectedData;
/* harmony export (immutable) */ __webpack_exports__["checkboxCheck"] = checkboxCheck;
/* harmony export (immutable) */ __webpack_exports__["returnAjaxData"] = returnAjaxData;
/* harmony export (immutable) */ __webpack_exports__["getBookingBuddyModalUrl"] = getBookingBuddyModalUrl;
/* harmony export (immutable) */ __webpack_exports__["getBookingBuddyModalHtml"] = getBookingBuddyModalHtml;
/* harmony export (immutable) */ __webpack_exports__["setSailingContextCookie"] = setSailingContextCookie;
/* harmony export (immutable) */ __webpack_exports__["setCarnivalGiftingBookingCookie"] = setCarnivalGiftingBookingCookie;
/* harmony export (immutable) */ __webpack_exports__["validateEmail"] = validateEmail;
/* harmony export (immutable) */ __webpack_exports__["validateDob"] = validateDob;
/* harmony export (immutable) */ __webpack_exports__["updateHeaderCartWidget"] = updateHeaderCartWidget;
/* harmony export (immutable) */ __webpack_exports__["updateHeaderFavoriteWidget"] = updateHeaderFavoriteWidget;
/* harmony export (immutable) */ __webpack_exports__["seeMoreLess"] = seeMoreLess;
/* harmony export (immutable) */ __webpack_exports__["updateFacetData"] = updateFacetData;
/* harmony export (immutable) */ __webpack_exports__["getFocusableElements"] = getFocusableElements;
/* harmony export (immutable) */ __webpack_exports__["sasEvents"] = sasEvents;
/* harmony export (immutable) */ __webpack_exports__["removeParam"] = removeParam;
/* harmony export (immutable) */ __webpack_exports__["isElementPartiallyInViewport"] = isElementPartiallyInViewport;
/* harmony export (immutable) */ __webpack_exports__["debounce"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["ajaxForCruiseCashCartAmount"] = ajaxForCruiseCashCartAmount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__);





/* eslint-disable */
// Closest - Polyfill for IE8+
if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i,
        el = this;
    do {
      i = matches.length;
      while (--i >= 0 && matches.item(i) !== el) {};
    } while (i < 0 && (el = el.parentElement));
    return el;
  };
}

// includes - Polyfill for IE11+
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';

    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

// includes - Polyfill for IE11+
// From https://github.com/latusinski/polyfill-array-includes/blob/master/array-includes.js
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function value(searchElement, fromIndex) {

      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}
/* eslint-enable */

function createDynamicHTML(staticHTML, jsonData, otherOptions) {
  var templateScript = __WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js__["compile"](staticHTML);
  var html = templateScript(jsonData);
  return html;
}

var doAjax = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(inputDataObj) {
    var result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return $.ajax(inputDataObj);

          case 3:
            result = _context.sent;
            return _context.abrupt('return', result);

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', _context.t0);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function doAjax(_x) {
    return _ref.apply(this, arguments);
  };
}();

// export function showCustomLoader(elementID) {
//   const getDynamicID = `#${elementID}`;
//   $(getDynamicID).append('<div class="newCustomLoader"><img src="/_ui/responsive/ccl/assets/images/customLoader.gif" alt="custom loader image"/></div>');
// }

// export function removeCustomLoader(elementID) {
//   const getDynamicID = `#${elementID}`;
//   $(getDynamicID).find('.newCustomLoader').remove();
// }

function showCustomLoader(elementID) {
  var getDynamicID = '#' + elementID;
  $(getDynamicID).append('<div class="customLoader-Ajax"></div>');
}

function removeCustomLoader(elementID) {
  var getDynamicID = '#' + elementID;
  $(getDynamicID).find('.customLoader-Ajax').remove();
}

function showLoader() {
  var getLoader = $('.loader');
  getLoader.empty().append('<div class="loading"><div><span role="alert" aria-live="polite">Loading...</span></div><img src="/_ui/responsive/ccl/assets/images/customLoader.gif" alt="custom loader image"/></div>');
  getLoader.show();
  $('#overlay').show();
}

function showToast(element) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
  var errMsg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Something went wrong, Please try again.';

  var x = $(element);
  x.html(errMsg);
  x.addClass('show');
  setTimeout(function () {
    x.className = x.removeClass('show');
  }, time);
}

function showGlobalToast(element) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4000;
  var msg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Something went wrong, Please try again.';

  var x = $(element);
  x.html(msg);
  x.addClass('show');
  setTimeout(function () {
    x.className = x.removeClass('show');
  }, time);
}

function hideLoader() {
  $('.loader').hide();
  $('#overlay').hide();
}

function displayError(err) {
  var cartAPIError = { customError: err };
  hideLoader();
  console.log(cartAPIError);
}

function showModal(modalID) {
  $('#' + modalID).modal();
}

function hideModal(modalID) {
  $('#' + modalID).modal('hide');
}

function detectmob() {
  if (window.innerWidth < 1024) {
    return true;
  }
  return false;
}

function getSelectedGuests(selectedItems) {
  var tempArr = [];
  $.each(selectedItems, function (index, value) {
    value.split('-');
    if (!tempArr.includes(value.split('-')[0])) {
      tempArr.push(value.split('-')[0]);
    }
  });

  var productCard = [];
  $.each(tempArr, function (index, value) {
    var temp = selectedItems.filter(function (x) {
      return x.split('-')[0] === value;
    });
    var g = [];
    $.each(temp, function (i, v) {
      g.push({
        bookingId: v.split('-')[1],
        guestId: v.split('-')[2]
      });
    });
    productCard.push({
      variantId: value,
      guestList: g
    });
  });

  return productCard;
}

function updateCartSummary(orderSummary) {
  if (orderSummary) {
    var currencySymbol = orderSummary.currency ? orderSummary.currency : '$';
    $('.cart-summary-subtotal')[0].innerHTML = '' + currencySymbol + orderSummary.subTotal;
    $('.cart-summary-gratuities')[0].innerHTML = '' + currencySymbol + orderSummary.gratuities;
    if ($('.cart-summary-surcharges').length) {
      $('.cart-summary-surcharges')[0].innerHTML = '' + currencySymbol + orderSummary.portSurcharges;
    }
    if (!orderSummary.checkoutDisabled) {
      $('.proceed-to-checkout-btn').removeAttr('disabled');
    }
    $('.cart-summary-totaltax')[0].innerHTML = orderSummary.hideTax ? 'TBD' : '' + currencySymbol + orderSummary.totalTax;
    $('.cart-summary-servicefee')[0].innerHTML = '' + currencySymbol + orderSummary.serviceFeesTotal;
    if ($('.placeOrderCartSummary').length) {
      $('.total-cost')[0].innerHTML = '' + currencySymbol + orderSummary.totalPriceWithTax;
      if ($('.sticky-total').length) {
        $('.sticky-total')[0].innerHTML = 'Total: ' + currencySymbol + orderSummary.totalPriceWithTax;
      }
    } else {
      $('.total-cost')[0].innerHTML = '' + currencySymbol + orderSummary.totalPrice;
      if ($('.sticky-total').length) {
        $('.sticky-total')[0].innerHTML = 'Total: ' + currencySymbol + orderSummary.totalPrice + ' <img src="/_ui/responsive/ccl/assets/icons/down_blue.svg" alt="arrow image" class="sticky-total-arrow">';
      }
    }
  }
}

function updateCouponSummary(response) {
  if (response.couponDetails) {
    var temp = '';
    $('.promo-added').empty();
    $.each(response.couponDetails, function (i, v) {
      if (v.couponAmount) {
        v.couponAmount = v.couponAmount.toFixed(2);
        temp += '<div class="promo-applied row-' + v.couponCode + '">\n          <div class="inner-promo-applied">\n            <div class="show-promo">PROMO:<span class="promo-code-text" aria-live="assertive" role="alert" aria-label="promo ' + v.couponCode + ' applied">' + v.couponCode + '</span>\n            <a href="#" class="remove-promo" aria-label="remove applied promo ' + v.couponCode + '" data-promocode="' + v.couponCode + '">Remove</a>\n            </div>\n            <div class="discount">-$' + v.couponAmount + '</div>\n          </div>\n          <div class="remove-error-div"></div>\n        </div>';
        // $(`.promo-applied.row-${v.couponCode} .discount`)[0].innerHTML = `-$${v.couponAmount.toFixed(2)}`;
      } else {
        $('.promo-applied.row-' + v.couponCode + ' .discount').hide();
      }
    });
    $('.promo-added').append(temp);
    $('.promo-added').show();
  }
}

function updateProductSummary(orderSummary) {
  if (orderSummary && orderSummary.allProductDetails) {
    var currencySymbol = orderSummary.currency ? orderSummary.currency : '$';
    $.each(orderSummary.allProductDetails, function (i, v) {
      var tempHtml = '';

      if ($('.cart-summary-item-' + v.productId + ' .cart-card-body .price').length) {
        $('.cart-summary-item-' + v.productId + ' .cart-card-body .price')[0].innerHTML = '' + currencySymbol + v.toPrice;
      }
      // Hide/Show wheelchair text on cart product
      if ($('.card-' + v.productId + ' .is-wheelchair').length) {
        if (v.specialService) {
          $('.card-' + v.productId + ' .is-wheelchair').show();
        } else {
          $('.card-' + v.productId + ' .is-wheelchair').hide();
        }
      }
      if ($('.card-' + v.productId + ' .cart-card-body .price').length) {
        $('.card-' + v.productId + ' .cart-card-body .price')[0].innerHTML = '' + currencySymbol + v.toPrice;
        if (v.fromPrice && v.toPrice !== v.fromPrice) {
          $('.card-' + v.productId + ' .cart-card-body .price').attr('role', 'textbox');
          $('.card-' + v.productId + ' .cart-card-body .price').attr('aria-label', 'is from ' + currencySymbol + v.toPrice + ' now');
        }
      }
      if ($('.card-' + v.productId + ' .cart-card-body .from-price').length) {
        if (v.showStrikeOutPrice && v.toPrice !== v.fromPrice) {
          $('.card-' + v.productId + ' .cart-card-body .from-price')[0].innerHTML = 'From <span role=\'textbox\' aria-label=\'was from ' + currencySymbol + v.fromPrice + ' before\'>' + currencySymbol + v.fromPrice + '</span>';
        } else if (!v.promotionsDetail.length) {
          $('.card-' + v.productId + ' .cart-card-body .from-price')[0].innerHTML = '';
        }
      }

      if ($('.card-' + v.productId + ' .cart-card-body .cart-product-qty-' + v.productId).length) {
        $('.card-' + v.productId + ' .cart-card-body .cart-product-qty-' + v.productId)[0].innerHTML = v.quantityAdded;
      }

      $.each(v.promotionsDetail, function (ind, val) {
        tempHtml += '<div class="savings-wrap">\n                      <img src="/_ui/responsive/ccl/assets/icons/tag.svg" alt="savings-tag">\n                      <div class="list-item savings">' + val.promoDescription + '</div>\n                    </div>';
      });
      if ($('.card-' + v.productId + ' .cart-card-body .savings-wrap-container').length) {
        $('.card-' + v.productId + ' .cart-card-body .savings-wrap-container')[0].innerHTML = tempHtml;
      }
    });
  }
}

function pdpGetSelectedData() {
  var bookingIds = [];
  var guestIds = [];
  var ageCodes = [];
  var qty = $('.pdpQty').data('pdpqty');
  var checkedLength = $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]:checked').length;
  $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each(function (index, element) {
    if (!element.checked) {
      $('.common-pdp-error-message .error').hide();
      if (qty === checkedLength) {
        element.disabled = true;
        element.parentElement.classList.add('stateroom-disabled');
        $('.common-pdp-error-message .error').html("There are not enough spots to accommodate other stateroom's guest.").show();
      } else if (element.dataset.conflict === 'false') {
        element.disabled = false;
        element.parentElement.classList.remove('stateroom-disabled');
      }
    }
  });

  $('.custom-checkbox input[type="checkbox"]:checked').each(function (index, element) {
    if (element.hasAttribute('data-bookingid') && !$(element).hasClass('dining-stateroom-disable')) {
      bookingIds.push(element.getAttribute('data-bookingid'));
    }
  });

  if ($('.custom-checkbox .guests-check input[type="checkbox"]').length) {
    $('.custom-checkbox .guests-check input[type="checkbox"]:checked').each(function (i, elem) {
      if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled') && !$(elem).hasClass('dining-guest-disable')) {
        guestIds.push(elem.getAttribute('data-guestid'));
      }
      if (elem.hasAttribute('data-agecode') && elem.getAttribute('data-agecode') !== '' && !$(elem).prop('disabled')) {
        ageCodes.push(elem.getAttribute('data-agecode'));
      }
    });
    $('.pdp-add-to-cart-btn').attr('data-agecodes', ageCodes.toString());
    $('.pdp-add-to-cart-btn').attr('data-guestIds', guestIds.toString());
  }

  $('.pdp-add-to-cart-btn').attr('data-bookingIds', bookingIds.toString());
  if (bookingIds.length && !$('.pdp-add-to-cart-btn').hasClass('atc-xdining')) {
    $('.pdp-add-to-cart-btn').removeAttr('disabled');
  } else {
    $('.pdp-add-to-cart-btn').attr('disabled', 'disabled');
  }
}

function checkboxCheck() {
  // Auto Select Single Stateroom
  if (!$('.c-cart').length && !$('.dining-atc-modal-dialog').length) {
    var stateroomLength = $('.stateroom-info .parent-check').length;
    if (stateroomLength === 1) {
      if (!$('.stateroom-info .parent-check').prop('disabled')) {
        setTimeout(function () {
          $('.stateroom-info input.parent-check').trigger('click');
        }, 800);
      }
    }
  }

  $(document.body).on('click', '.custom-control.custom-checkbox.stateroom-check > input', function (event) {
    $(event.currentTarget.offsetParent).find('.booking-dropdown .guests-check input').each(function (index, element) {
      if (!element.closest('.stateroom-disabled')) {
        element.checked = event.currentTarget.checked;
      }
    });
    pdpGetSelectedData();
  });

  $(document.body).on('click', '.booking-dropdown .guests-check input', function (event) {
    var disableGuestsLength = $(event.currentTarget.offsetParent.offsetParent).find('.booking-dropdown .stateroom-disabled').length;
    var notAllChildsChecked = $(event.currentTarget.offsetParent.offsetParent).find('.booking-dropdown .custom-control-input').not(':checked').length - disableGuestsLength === $(event.currentTarget.offsetParent.offsetParent).find('.booking-dropdown .custom-control-input').length - disableGuestsLength;
    $(event.currentTarget).closest('.stateroom-check')[0].firstElementChild.checked = !notAllChildsChecked;
    var stateRoom = $(event.target).closest('.stateroom-check');
    if (stateRoom.find('.booking-dropdown .guests-check input:checked').not(':disabled').length === 0) {
      stateRoom.find('.parent-check').prop('checked', false);
    } else {
      stateRoom.find('.parent-check').prop('checked', true);
    }
    pdpGetSelectedData();
  });
}

function returnAjaxData(ajaxResponse) {
  return ajaxResponse;
}

function getBookingBuddyModalUrl(statusCode) {
  if (statusCode) {
    return '/_ui/responsive/ccl/assets/templates/booking-buddy/bb-modal-status-' + statusCode + '.html';
  }
  return '/_ui/responsive/ccl/assets/templates/booking-buddy/bb-modal-status-initial.html';
}

function getBookingBuddyModalHtml(statusCode, returnData) {
  var ajaxUrl = getBookingBuddyModalUrl(statusCode);
  $.ajax({
    type: 'GET',
    url: ajaxUrl
  }).done(function (response) {
    returnData(response);
  }).fail(function () {
    console.log('error while loading booking buddy html');
  });
}

function setSailingContextCookie(sailingId) {
  __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"]('SailingContextCookie');
  __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"]('SailingContextCookie', sailingId);
}

function setCarnivalGiftingBookingCookie(userId, requestParams) {
  __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"]('carnivalGiftingBookingCookie-' + userId);
  __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"]('carnivalGiftingBookingCookie-' + userId, requestParams);
}

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(String(email).toLowerCase());
}

function validateDob(input) {
  var pattern = /^(0?[1-9]|1[012])[-](0?[1-9]|[12][0-9]|3[01])[-]\d{4}$/;
  return pattern.test(input);
}

function updateHeaderCartWidget(response) {
  if (response.totalItemsCount && response.totalItemsCount > 0) {
    if ($('.c-cart').length) {
      $('.items-in-icon').attr('src', '/_ui/responsive/ccl/assets/icons/itemsincart.svg');
    } else {
      $('.items-in-icon').attr('src', '/_ui/responsive/ccl/assets/icons/cart.svg');
    }

    $('span.items-in-cart').html(response.totalItemsCount).show();
    $('span.items-in-cart').parents('.fav-wrap a').attr('aria-label', 'items in cart are ' + response.totalItemsCount);
    $('span.items-in-cart').parents('.cart-mob a').attr('aria-label', 'items in cart are ' + response.totalItemsCount);
  } else if (response.removeSuccess) {
    $('.items-in-icon').attr('src', '/_ui/responsive/ccl/assets/icons/cart.svg');
    $('span.items-in-cart').hide();
  }
}

function updateHeaderFavoriteWidget(response) {
  // {"wishlistItemCount":3,"redirectionURL":null,"productAdded":true,"productRemoved":false}
  $('span.items-in-favorite').addClass('black-color').removeClass('d-none');
  $('span.items-in-favorite').html(response.wishlistItemCount).show();
}

function splitText(text, textLimit) {
  var first = text.substring(0, textLimit);
  var spaceStr = 0;
  var secondString = '';
  if (text.substr(textLimit, 1) === ' ') {
    spaceStr = 1;
  }
  var second = text.substring(textLimit);
  var aux = second.substring(0, second.indexOf(' '));
  first = first.substring(0, textLimit) + aux;
  var spaceIndex = second.indexOf(' ');
  second = ' ' + second.substring(spaceIndex + 1);
  secondString = spaceStr === 0 ? second.trim() : second;
  var bothTextes = [first, secondString];
  return bothTextes;
}

function seeMoreLess(paraClassName, prodTitle) {
  /* eslint-disable */
  var textLimit = 300;
  if ($(paraClassName).parents('.expectation').length > 0) {
    textLimit = 150;
  }
  $(paraClassName).each(function (index, element) {
    if (Object.prototype.toString.call(paraClassName) !== '[object String]') {
      paraClassName = '.' + paraClassName[0].classList[0];
    }
    var text = $(element).text();
    if (text.length > textLimit) {
      var textArray = splitText(text, textLimit);
      element.innerHTML = textArray[0];
      $(element).append('<span class=\'show-more\'>&nbsp;&nbsp;<a href=\'javascript:;\' aria-live="assertive" class=\'morelink\' aria-expanded=\'false\' aria-label=\'Read more information about ' + prodTitle + '\'>Read More <img src=\'/_ui/responsive/ccl/assets/icons/down_blue.svg\' alt=\'down arrow\'></a></span>');
      $(element).append('<span style="display: none" class=\'rest-of-description\'>' + textArray[1] + '</span>');
      $(element).append('<span style="display: none" class=\'red show-less\'>&nbsp;&nbsp;<a href=\'javascript:;\' aria-expanded=\'true\' aria-label=\'Read less information about ' + prodTitle + '\' class=\'morelink\'>Read Less <img src=\'/_ui/responsive/ccl/assets/icons/up_blue.svg\' alt=\'down arrow\'></a></span>');
    } else {
      element.innerHTML = text;
    }
    /* eslint-enable */
    $($(element).children('.show-more')).click(function (e) {
      $(e.currentTarget).parents(paraClassName).children('.rest-of-description').show();
      $(e.currentTarget).parents(paraClassName).children('.show-less').show();
      $(e.currentTarget).parents(paraClassName).children('.show-less').addClass('ccl-ada-focus');
      $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink').hide();
      $(e.currentTarget).parents(paraClassName).children('.rest-of-description').focus();
      setTimeout(function () {
        $(e.currentTarget).parents(paraClassName).children('.show-less').children('.morelink').addClass('ada-element-focus');
        $(e.currentTarget).parents(paraClassName).children('.show-less').children('.morelink').focus();
      }, 500);

      $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink').removeAttr('aria-label');
    });

    $($(element).children('.red.show-less')).click(function (e) {
      $(e.currentTarget).parents(paraClassName).children('.rest-of-description').hide();
      $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink').show();
      $(e.currentTarget).parents(paraClassName).children('.show-more').addClass('ccl-ada-focus');
      $(e.currentTarget).parents(paraClassName).children('.show-less').hide();
      // $(e.currentTarget).parents(paraClassName).children('.show-more').focus();
      setTimeout(function () {
        $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink').addClass('ada-element-focus');
        $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink').focus();

        $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink').attr('aria-label', 'Clickable Read more information about ' + prodTitle + ' collapsed link');
      }, 500);
    });
  });
}
function updateFacetData(excursionsCountForFacet) {
  for (var i = 0; i < excursionsCountForFacet.length; i++) {
    if (excursionsCountForFacet[i].excursionCartMessage && excursionsCountForFacet[i].excursionOrderMessage) {
      $('.' + excursionsCountForFacet[i].code).find('.excursionCart').text(excursionsCountForFacet[i].excursionCartMessage);
      $('.' + excursionsCountForFacet[i].code).find('.excursionOrder').text(excursionsCountForFacet[i].excursionOrderMessage);
      $('.' + excursionsCountForFacet[i].code).find('.excursionCart').removeClass('show-excursion');
      $('.' + excursionsCountForFacet[i].code).find('.excursionOrder').removeClass('show-excursion');
    } else if (excursionsCountForFacet[i].excursionCartMessage) {
      $('.' + excursionsCountForFacet[i].code).find('.excursionCart').text(excursionsCountForFacet[i].excursionCartMessage);
      $('.' + excursionsCountForFacet[i].code).find('.excursionCart').removeClass('show-excursion');
    } else if (excursionsCountForFacet[i].excursionOrderMessage) {
      $('.' + excursionsCountForFacet[i].code).find('.excursionOrder').text(excursionsCountForFacet[i].excursionOrderMessage);
      $('.' + excursionsCountForFacet[i].code).find('.excursionOrder').removeClass('show-excursion');
    }
  }
}

function getFocusableElements(modalEl, pos) {
  var tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled):not([class*="d-none"])';
  var firstFocusable = modalEl.find(tabbables).first();
  var lastFocusable = modalEl.find(tabbables).last();
  return pos === 'last' ? lastFocusable : firstFocusable;
}

function sasEvents(eventName, data) {
  // SAS event
  var isSasEnabled = $('body').find('#isSasEnabled').val();
  if (isSasEnabled === 'true' || isSasEnabled === true) {
    setTimeout(function () {
      if (data && typeof window.ci360 !== 'undefined') {
        window.ci360(eventName, data);
      }
    }, 100);
  }
}

function removeParam(key, sourceURL) {
  var rtn = sourceURL.split('?')[0];
  var param = void 0;
  var paramsArr = [];
  var queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
  if (queryString !== '') {
    paramsArr = queryString.split('&');
    for (var i = paramsArr.length - 1; i >= 0; i -= 1) {
      /* eslint-disable */
      param = paramsArr[i].split('=')[0];
      /* eslint-enable */
      if (param === key) {
        paramsArr.splice(i, 1);
      }
    }
    rtn = rtn + '?' + paramsArr.join('&');
  }
  return rtn;
}

function isElementPartiallyInViewport(el) {
  var rect = el[0].getBoundingClientRect();
  // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowWidth = window.innerWidth || document.documentElement.clientWidth;

  // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
  var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

  return vertInView && horInView;
}

function debounce(fn, delay) {
  var timeoutID = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeoutID) clearTimeout(timeoutID);
    timeoutID = setTimeout(function () {
      fn.apply(undefined, args);
    }, delay);
  };
}

function ajaxForCruiseCashCartAmount() {
  return $.ajax({
    type: 'GET',
    url: '/shop/CruiseCashCartAmount'
  }).done(function (response) {
    localStorage.setItem('cruisecashcartamount', response);
  }).fail(function () {
    console.log('Something went wrong on cruise ');
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(287), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(58)('wks');
var uid = __webpack_require__(39);
var Symbol = __webpack_require__(12).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(8);
var ctx = __webpack_require__(27);
var hide = __webpack_require__(21);
var has = __webpack_require__(23);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(80);
var toPrimitive = __webpack_require__(54);
var dP = Object.defineProperty;

exports.f = __webpack_require__(18) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(24)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(29);
module.exports = __webpack_require__(18) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(69);
var defined = __webpack_require__(52);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(53);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(52);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(82);
var enumBugKeys = __webpack_require__(59);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(288);


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(290);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(23);
var TAG = __webpack_require__(11)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(121);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(130);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(123)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(67)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(22);
var dPs = __webpack_require__(125);
var enumBugKeys = __webpack_require__(59);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(68)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(98).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(51);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(58)('keys');
var uid = __webpack_require__(39);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var global = __webpack_require__(12);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(33) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(11);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(8);
var LIBRARY = __webpack_require__(33);
var wksExt = __webpack_require__(60);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(33);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(81);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(30);
var $iterCreate = __webpack_require__(124);
var setToStringTag = __webpack_require__(40);
var getPrototypeOf = __webpack_require__(99);
var ITERATOR = __webpack_require__(11)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(12).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(38);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(18) && !__webpack_require__(24)(function () {
  return Object.defineProperty(__webpack_require__(68)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(23);
var toIObject = __webpack_require__(25);
var arrayIndexOf = __webpack_require__(126)(false);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(128);
var global = __webpack_require__(12);
var hide = __webpack_require__(21);
var Iterators = __webpack_require__(30);
var TO_STRING_TAG = __webpack_require__(11)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(39)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(23);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(24)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(82);
var hiddenKeys = __webpack_require__(59).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {



/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(38);
var TAG = __webpack_require__(11)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(27);
var call = __webpack_require__(103);
var isArrayIter = __webpack_require__(104);
var anObject = __webpack_require__(22);
var toLength = __webpack_require__(56);
var getIterFn = __webpack_require__(105);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/**!

 @license
 handlebars v4.7.7

Copyright (C) 2011-2019 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Handlebars"] = factory();
	else
		root["Handlebars"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _handlebarsRuntime = __webpack_require__(2);

	var _handlebarsRuntime2 = _interopRequireDefault(_handlebarsRuntime);

	// Compiler imports

	var _handlebarsCompilerAst = __webpack_require__(45);

	var _handlebarsCompilerAst2 = _interopRequireDefault(_handlebarsCompilerAst);

	var _handlebarsCompilerBase = __webpack_require__(46);

	var _handlebarsCompilerCompiler = __webpack_require__(51);

	var _handlebarsCompilerJavascriptCompiler = __webpack_require__(52);

	var _handlebarsCompilerJavascriptCompiler2 = _interopRequireDefault(_handlebarsCompilerJavascriptCompiler);

	var _handlebarsCompilerVisitor = __webpack_require__(49);

	var _handlebarsCompilerVisitor2 = _interopRequireDefault(_handlebarsCompilerVisitor);

	var _handlebarsNoConflict = __webpack_require__(44);

	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

	var _create = _handlebarsRuntime2['default'].create;
	function create() {
	  var hb = _create();

	  hb.compile = function (input, options) {
	    return _handlebarsCompilerCompiler.compile(input, options, hb);
	  };
	  hb.precompile = function (input, options) {
	    return _handlebarsCompilerCompiler.precompile(input, options, hb);
	  };

	  hb.AST = _handlebarsCompilerAst2['default'];
	  hb.Compiler = _handlebarsCompilerCompiler.Compiler;
	  hb.JavaScriptCompiler = _handlebarsCompilerJavascriptCompiler2['default'];
	  hb.Parser = _handlebarsCompilerBase.parser;
	  hb.parse = _handlebarsCompilerBase.parse;
	  hb.parseWithoutProcessing = _handlebarsCompilerBase.parseWithoutProcessing;

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_handlebarsNoConflict2['default'](inst);

	inst.Visitor = _handlebarsCompilerVisitor2['default'];

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};

	exports.__esModule = true;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _handlebarsBase = __webpack_require__(4);

	var base = _interopRequireWildcard(_handlebarsBase);

	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)

	var _handlebarsSafeString = __webpack_require__(37);

	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

	var _handlebarsException = __webpack_require__(6);

	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

	var _handlebarsUtils = __webpack_require__(5);

	var Utils = _interopRequireWildcard(_handlebarsUtils);

	var _handlebarsRuntime = __webpack_require__(38);

	var runtime = _interopRequireWildcard(_handlebarsRuntime);

	var _handlebarsNoConflict = __webpack_require__(44);

	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();

	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;

	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_handlebarsNoConflict2['default'](inst);

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj["default"] = obj;
	    return newObj;
	  }
	};

	exports.__esModule = true;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _helpers = __webpack_require__(10);

	var _decorators = __webpack_require__(30);

	var _logger = __webpack_require__(32);

	var _logger2 = _interopRequireDefault(_logger);

	var _internalProtoAccess = __webpack_require__(33);

	var VERSION = '4.7.7';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 8;
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var LAST_COMPATIBLE_COMPILER_REVISION = 7;

	exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0 <4.3.0',
	  8: '>= 4.3.0'
	};

	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';

	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};

	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}

	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,

	  logger: _logger2['default'],
	  log: _logger2['default'].log,

	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },

	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },

	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  },
	  /**
	   * Reset the memory of illegal property accesses that have already been logged.
	   * @deprecated should only be used in handlebars test-cases
	   */
	  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
	    _internalProtoAccess.resetLoggedProperties();
	  }
	};

	var log = _logger2['default'].log;

	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};

	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;

	function escapeChar(chr) {
	  return escape[chr];
	}

	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }

	  return obj;
	}

	var toString = Object.prototype.toString;

	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;

	/* eslint-enable func-style */

	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};

	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.

	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}

	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }

	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }

	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}

	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}

	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}

	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}

	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(7)['default'];

	exports.__esModule = true;
	var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      endLineNumber = undefined,
	      column = undefined,
	      endColumn = undefined;

	  if (loc) {
	    line = loc.start.line;
	    endLineNumber = loc.end.line;
	    column = loc.start.column;
	    endColumn = loc.end.column;

	    message += ' - ' + line + ':' + column;
	  }

	  var tmp = Error.prototype.constructor.call(this, message);

	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }

	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }

	  try {
	    if (loc) {
	      this.lineNumber = line;
	      this.endLineNumber = endLineNumber;

	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (_Object$defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	        Object.defineProperty(this, 'endColumn', {
	          value: endColumn,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	        this.endColumn = endColumn;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}

	Exception.prototype = new Error();

	exports['default'] = Exception;
	module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(8), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(9);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	exports.moveHelperToHooks = moveHelperToHooks;

	var _helpersBlockHelperMissing = __webpack_require__(11);

	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

	var _helpersEach = __webpack_require__(12);

	var _helpersEach2 = _interopRequireDefault(_helpersEach);

	var _helpersHelperMissing = __webpack_require__(25);

	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

	var _helpersIf = __webpack_require__(26);

	var _helpersIf2 = _interopRequireDefault(_helpersIf);

	var _helpersLog = __webpack_require__(27);

	var _helpersLog2 = _interopRequireDefault(_helpersLog);

	var _helpersLookup = __webpack_require__(28);

	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

	var _helpersWith = __webpack_require__(29);

	var _helpersWith2 = _interopRequireDefault(_helpersWith);

	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}

	function moveHelperToHooks(instance, helperName, keepHelper) {
	  if (instance.helpers[helperName]) {
	    instance.hooks[helperName] = instance.helpers[helperName];
	    if (!keepHelper) {
	      delete instance.helpers[helperName];
	    }
	  }
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;

	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }

	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }

	      return fn(context, options);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }

	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;

	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }

	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }

	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;

	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }

	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }

	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else if (global.Symbol && context[global.Symbol.iterator]) {
	        var newContext = [];
	        var iterator = context[global.Symbol.iterator]();
	        for (var it = iterator.next(); !it.done; it = iterator.next()) {
	          newContext.push(it.value);
	        }
	        context = newContext;
	        for (var j = context.length; i < j; i++) {
	          execIteration(i, i, i === context.length - 1);
	        }
	      } else {
	        (function () {
	          var priorKey = undefined;

	          _Object$keys(context).forEach(function (key) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          });
	          if (priorKey !== undefined) {
	            execIteration(priorKey, i - 1, true);
	          }
	        })();
	      }
	    }

	    if (i === 0) {
	      ret = inverse(this);
	    }

	    return ret;
	  });
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(14), __esModule: true };

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(15);
	module.exports = __webpack_require__(21).Object.keys;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(16);

	__webpack_require__(18)('keys', function($keys){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(17);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(19)
	  , core    = __webpack_require__(21)
	  , fails   = __webpack_require__(24);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(20)
	  , core      = __webpack_require__(21)
	  , ctx       = __webpack_require__(22)
	  , PROTOTYPE = 'prototype';

	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(23);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#if requires exactly one argument');
	    }
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }

	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });

	  instance.registerHelper('unless', function (conditional, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#unless requires exactly one argument');
	    }
	    return instance.helpers['if'].call(this, conditional, {
	      fn: options.inverse,
	      inverse: options.fn,
	      hash: options.hash
	    });
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }

	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;

	    instance.log.apply(instance, args);
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field, options) {
	    if (!obj) {
	      // Note for 5.0: Change to "obj == null" in 5.0
	      return obj;
	    }
	    return options.lookupProperty(obj, field);
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (arguments.length != 2) {
	      throw new _exception2['default']('#with requires exactly one argument');
	    }
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    var fn = options.fn;

	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }

	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;

	var _decoratorsInline = __webpack_require__(31);

	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }

	    props.partials[options.args[0]] = options.fn;

	    return ret;
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',

	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }

	    return level;
	  },

	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);

	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      // eslint-disable-next-line no-console
	      if (!console[method]) {
	        method = 'log';
	      }

	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }

	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};

	exports['default'] = logger;
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$create = __webpack_require__(34)['default'];

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	exports.__esModule = true;
	exports.createProtoAccessControl = createProtoAccessControl;
	exports.resultIsAllowed = resultIsAllowed;
	exports.resetLoggedProperties = resetLoggedProperties;

	var _createNewLookupObject = __webpack_require__(36);

	var _logger = __webpack_require__(32);

	var logger = _interopRequireWildcard(_logger);

	var loggedProperties = _Object$create(null);

	function createProtoAccessControl(runtimeOptions) {
	  var defaultMethodWhiteList = _Object$create(null);
	  defaultMethodWhiteList['constructor'] = false;
	  defaultMethodWhiteList['__defineGetter__'] = false;
	  defaultMethodWhiteList['__defineSetter__'] = false;
	  defaultMethodWhiteList['__lookupGetter__'] = false;

	  var defaultPropertyWhiteList = _Object$create(null);
	  // eslint-disable-next-line no-proto
	  defaultPropertyWhiteList['__proto__'] = false;

	  return {
	    properties: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
	      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
	    },
	    methods: {
	      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
	      defaultValue: runtimeOptions.allowProtoMethodsByDefault
	    }
	  };
	}

	function resultIsAllowed(result, protoAccessControl, propertyName) {
	  if (typeof result === 'function') {
	    return checkWhiteList(protoAccessControl.methods, propertyName);
	  } else {
	    return checkWhiteList(protoAccessControl.properties, propertyName);
	  }
	}

	function checkWhiteList(protoAccessControlForType, propertyName) {
	  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
	    return protoAccessControlForType.whitelist[propertyName] === true;
	  }
	  if (protoAccessControlForType.defaultValue !== undefined) {
	    return protoAccessControlForType.defaultValue;
	  }
	  logUnexpecedPropertyAccessOnce(propertyName);
	  return false;
	}

	function logUnexpecedPropertyAccessOnce(propertyName) {
	  if (loggedProperties[propertyName] !== true) {
	    loggedProperties[propertyName] = true;
	    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
	  }
	}

	function resetLoggedProperties() {
	  _Object$keys(loggedProperties).forEach(function (propertyName) {
	    delete loggedProperties[propertyName];
	  });
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(35), __esModule: true };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(9);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$create = __webpack_require__(34)['default'];

	exports.__esModule = true;
	exports.createNewLookupObject = createNewLookupObject;

	var _utils = __webpack_require__(5);

	/**
	 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
	 * The resulting object can be used with "object[property]" to check if a property exists
	 * @param {...object} sources a varargs parameter of source objects that will be merged
	 * @returns {object}
	 */

	function createNewLookupObject() {
	  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }

	  return _utils.extend.apply(undefined, [_Object$create(null)].concat(sources));
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';

	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}

	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};

	exports['default'] = SafeString;
	module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$seal = __webpack_require__(39)['default'];

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;

	var _utils = __webpack_require__(5);

	var Utils = _interopRequireWildcard(_utils);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _base = __webpack_require__(4);

	var _helpers = __webpack_require__(10);

	var _internalWrapHelper = __webpack_require__(43);

	var _internalProtoAccess = __webpack_require__(33);

	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;

	  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
	    return;
	  }

	  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
	    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	  } else {
	    // Use the embedded version info since the runtime doesn't know about this revision yet
	    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	  }
	}

	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }

	  templateSpec.main.decorator = templateSpec.main_d;

	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as pseudo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);

	  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
	  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	    partial = env.VM.resolvePartial.call(this, partial, context, options);

	    var extendedOptions = Utils.extend({}, options, {
	      hooks: this.hooks,
	      protoAccessControl: this.protoAccessControl
	    });

	    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, extendedOptions);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }

	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }

	  // Just add water
	  var container = {
	    strict: function strict(obj, name, loc) {
	      if (!obj || !(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
	          loc: loc
	        });
	      }
	      return container.lookupProperty(obj, name);
	    },
	    lookupProperty: function lookupProperty(parent, propertyName) {
	      var result = parent[propertyName];
	      if (result == null) {
	        return result;
	      }
	      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	        return result;
	      }

	      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
	        return result;
	      }
	      return undefined;
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        var result = depths[i] && container.lookupProperty(depths[i], name);
	        if (result != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },

	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,

	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },

	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },

	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    mergeIfNeeded: function mergeIfNeeded(param, common) {
	      var obj = param || common;

	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }

	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: _Object$seal({}),

	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };

	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var data = options.data;

	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }

	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }

	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }

	  ret.isTop = true;

	  ret._setup = function (options) {
	    if (!options.partial) {
	      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
	      wrapHelpersToPassLookupProperty(mergedHelpers, container);
	      container.helpers = mergedHelpers;

	      if (templateSpec.usePartial) {
	        // Use mergeIfNeeded here to prevent compiling global partials multiple times
	        container.partials = container.mergeIfNeeded(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = Utils.extend({}, env.decorators, options.decorators);
	      }

	      container.hooks = {};
	      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

	      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
	      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
	      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
	    } else {
	      container.protoAccessControl = options.protoAccessControl; // internal option
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	      container.hooks = options.hooks;
	    }
	  };

	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }

	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}

	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }

	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }

	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}

	/**
	 * This is currently part of the official API, therefore implementation details should not be changed.
	 */

	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}

	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }

	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }

	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }

	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}

	function noop() {
	  return '';
	}

	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}

	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}

	function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
	  _Object$keys(mergedHelpers).forEach(function (helperName) {
	    var helper = mergedHelpers[helperName];
	    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
	  });
	}

	function passLookupPropertyOption(helper, container) {
	  var lookupProperty = container.lookupProperty;
	  return _internalWrapHelper.wrapHelper(helper, function (options) {
	    return Utils.extend({ lookupProperty: lookupProperty }, options);
	  });
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(41);
	module.exports = __webpack_require__(21).Object.seal;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(42);

	__webpack_require__(18)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.wrapHelper = wrapHelper;

	function wrapHelper(helper, transformOptionsFn) {
	  if (typeof helper !== 'function') {
	    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
	    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
	    return helper;
	  }
	  var wrapper = function wrapper() /* dynamic arguments */{
	    var options = arguments[arguments.length - 1];
	    arguments[arguments.length - 1] = transformOptionsFn(options);
	    return helper.apply(this, arguments);
	  };
	  return wrapper;
	}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	exports.__esModule = true;

	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	var AST = {
	  // Public API used to evaluate derived attributes regarding AST nodes
	  helpers: {
	    // a mustache is definitely a helper if:
	    // * it is an eligible helper, and
	    // * it has at least one parameter or hash segment
	    helperExpression: function helperExpression(node) {
	      return node.type === 'SubExpression' || (node.type === 'MustacheStatement' || node.type === 'BlockStatement') && !!(node.params && node.params.length || node.hash);
	    },

	    scopedId: function scopedId(path) {
	      return (/^\.|this\b/.test(path.original)
	      );
	    },

	    // an ID is simple if it only has one part, and that part is not
	    // `..` or `this`.
	    simpleId: function simpleId(path) {
	      return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
	    }
	  }
	};

	// Must be exported as an object rather than the root of the module as the jison lexer
	// must modify the object to operate properly.
	exports['default'] = AST;
	module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	exports.__esModule = true;
	exports.parseWithoutProcessing = parseWithoutProcessing;
	exports.parse = parse;

	var _parser = __webpack_require__(47);

	var _parser2 = _interopRequireDefault(_parser);

	var _whitespaceControl = __webpack_require__(48);

	var _whitespaceControl2 = _interopRequireDefault(_whitespaceControl);

	var _helpers = __webpack_require__(50);

	var Helpers = _interopRequireWildcard(_helpers);

	var _utils = __webpack_require__(5);

	exports.parser = _parser2['default'];

	var yy = {};
	_utils.extend(yy, Helpers);

	function parseWithoutProcessing(input, options) {
	  // Just return if an already-compiled AST was passed in.
	  if (input.type === 'Program') {
	    return input;
	  }

	  _parser2['default'].yy = yy;

	  // Altering the shared object here, but this is ok as parser is a sync operation
	  yy.locInfo = function (locInfo) {
	    return new yy.SourceLocation(options && options.srcName, locInfo);
	  };

	  var ast = _parser2['default'].parse(input);

	  return ast;
	}

	function parse(input, options) {
	  var ast = parseWithoutProcessing(input, options);
	  var strip = new _whitespaceControl2['default'](options);

	  return strip.accept(ast);
	}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	// File ignored in coverage tests via setting in .istanbul.yml
	/* Jison generated parser */
	"use strict";

	exports.__esModule = true;
	var handlebars = (function () {
	    var parser = { trace: function trace() {},
	        yy: {},
	        symbols_: { "error": 2, "root": 3, "program": 4, "EOF": 5, "program_repetition0": 6, "statement": 7, "mustache": 8, "block": 9, "rawBlock": 10, "partial": 11, "partialBlock": 12, "content": 13, "COMMENT": 14, "CONTENT": 15, "openRawBlock": 16, "rawBlock_repetition0": 17, "END_RAW_BLOCK": 18, "OPEN_RAW_BLOCK": 19, "helperName": 20, "openRawBlock_repetition0": 21, "openRawBlock_option0": 22, "CLOSE_RAW_BLOCK": 23, "openBlock": 24, "block_option0": 25, "closeBlock": 26, "openInverse": 27, "block_option1": 28, "OPEN_BLOCK": 29, "openBlock_repetition0": 30, "openBlock_option0": 31, "openBlock_option1": 32, "CLOSE": 33, "OPEN_INVERSE": 34, "openInverse_repetition0": 35, "openInverse_option0": 36, "openInverse_option1": 37, "openInverseChain": 38, "OPEN_INVERSE_CHAIN": 39, "openInverseChain_repetition0": 40, "openInverseChain_option0": 41, "openInverseChain_option1": 42, "inverseAndProgram": 43, "INVERSE": 44, "inverseChain": 45, "inverseChain_option0": 46, "OPEN_ENDBLOCK": 47, "OPEN": 48, "mustache_repetition0": 49, "mustache_option0": 50, "OPEN_UNESCAPED": 51, "mustache_repetition1": 52, "mustache_option1": 53, "CLOSE_UNESCAPED": 54, "OPEN_PARTIAL": 55, "partialName": 56, "partial_repetition0": 57, "partial_option0": 58, "openPartialBlock": 59, "OPEN_PARTIAL_BLOCK": 60, "openPartialBlock_repetition0": 61, "openPartialBlock_option0": 62, "param": 63, "sexpr": 64, "OPEN_SEXPR": 65, "sexpr_repetition0": 66, "sexpr_option0": 67, "CLOSE_SEXPR": 68, "hash": 69, "hash_repetition_plus0": 70, "hashSegment": 71, "ID": 72, "EQUALS": 73, "blockParams": 74, "OPEN_BLOCK_PARAMS": 75, "blockParams_repetition_plus0": 76, "CLOSE_BLOCK_PARAMS": 77, "path": 78, "dataName": 79, "STRING": 80, "NUMBER": 81, "BOOLEAN": 82, "UNDEFINED": 83, "NULL": 84, "DATA": 85, "pathSegments": 86, "SEP": 87, "$accept": 0, "$end": 1 },
	        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
	        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 0], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
	        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {

	            var $0 = $$.length - 1;
	            switch (yystate) {
	                case 1:
	                    return $$[$0 - 1];
	                    break;
	                case 2:
	                    this.$ = yy.prepareProgram($$[$0]);
	                    break;
	                case 3:
	                    this.$ = $$[$0];
	                    break;
	                case 4:
	                    this.$ = $$[$0];
	                    break;
	                case 5:
	                    this.$ = $$[$0];
	                    break;
	                case 6:
	                    this.$ = $$[$0];
	                    break;
	                case 7:
	                    this.$ = $$[$0];
	                    break;
	                case 8:
	                    this.$ = $$[$0];
	                    break;
	                case 9:
	                    this.$ = {
	                        type: 'CommentStatement',
	                        value: yy.stripComment($$[$0]),
	                        strip: yy.stripFlags($$[$0], $$[$0]),
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 10:
	                    this.$ = {
	                        type: 'ContentStatement',
	                        original: $$[$0],
	                        value: $$[$0],
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 11:
	                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
	                    break;
	                case 12:
	                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1] };
	                    break;
	                case 13:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
	                    break;
	                case 14:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
	                    break;
	                case 15:
	                    this.$ = { open: $$[$0 - 5], path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 16:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 17:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 18:
	                    this.$ = { strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]), program: $$[$0] };
	                    break;
	                case 19:
	                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$),
	                        program = yy.prepareProgram([inverse], $$[$0 - 1].loc);
	                    program.chained = true;

	                    this.$ = { strip: $$[$0 - 2].strip, program: program, chain: true };

	                    break;
	                case 20:
	                    this.$ = $$[$0];
	                    break;
	                case 21:
	                    this.$ = { path: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 2], $$[$0]) };
	                    break;
	                case 22:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 23:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 24:
	                    this.$ = {
	                        type: 'PartialStatement',
	                        name: $$[$0 - 3],
	                        params: $$[$0 - 2],
	                        hash: $$[$0 - 1],
	                        indent: '',
	                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 25:
	                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
	                    break;
	                case 26:
	                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 4], $$[$0]) };
	                    break;
	                case 27:
	                    this.$ = $$[$0];
	                    break;
	                case 28:
	                    this.$ = $$[$0];
	                    break;
	                case 29:
	                    this.$ = {
	                        type: 'SubExpression',
	                        path: $$[$0 - 3],
	                        params: $$[$0 - 2],
	                        hash: $$[$0 - 1],
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 30:
	                    this.$ = { type: 'Hash', pairs: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 31:
	                    this.$ = { type: 'HashPair', key: yy.id($$[$0 - 2]), value: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 32:
	                    this.$ = yy.id($$[$0 - 1]);
	                    break;
	                case 33:
	                    this.$ = $$[$0];
	                    break;
	                case 34:
	                    this.$ = $$[$0];
	                    break;
	                case 35:
	                    this.$ = { type: 'StringLiteral', value: $$[$0], original: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 36:
	                    this.$ = { type: 'NumberLiteral', value: Number($$[$0]), original: Number($$[$0]), loc: yy.locInfo(this._$) };
	                    break;
	                case 37:
	                    this.$ = { type: 'BooleanLiteral', value: $$[$0] === 'true', original: $$[$0] === 'true', loc: yy.locInfo(this._$) };
	                    break;
	                case 38:
	                    this.$ = { type: 'UndefinedLiteral', original: undefined, value: undefined, loc: yy.locInfo(this._$) };
	                    break;
	                case 39:
	                    this.$ = { type: 'NullLiteral', original: null, value: null, loc: yy.locInfo(this._$) };
	                    break;
	                case 40:
	                    this.$ = $$[$0];
	                    break;
	                case 41:
	                    this.$ = $$[$0];
	                    break;
	                case 42:
	                    this.$ = yy.preparePath(true, $$[$0], this._$);
	                    break;
	                case 43:
	                    this.$ = yy.preparePath(false, $$[$0], this._$);
	                    break;
	                case 44:
	                    $$[$0 - 2].push({ part: yy.id($$[$0]), original: $$[$0], separator: $$[$0 - 1] });this.$ = $$[$0 - 2];
	                    break;
	                case 45:
	                    this.$ = [{ part: yy.id($$[$0]), original: $$[$0] }];
	                    break;
	                case 46:
	                    this.$ = [];
	                    break;
	                case 47:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 48:
	                    this.$ = [];
	                    break;
	                case 49:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 50:
	                    this.$ = [];
	                    break;
	                case 51:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 58:
	                    this.$ = [];
	                    break;
	                case 59:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 64:
	                    this.$ = [];
	                    break;
	                case 65:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 70:
	                    this.$ = [];
	                    break;
	                case 71:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 78:
	                    this.$ = [];
	                    break;
	                case 79:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 82:
	                    this.$ = [];
	                    break;
	                case 83:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 86:
	                    this.$ = [];
	                    break;
	                case 87:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 90:
	                    this.$ = [];
	                    break;
	                case 91:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 94:
	                    this.$ = [];
	                    break;
	                case 95:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 98:
	                    this.$ = [$$[$0]];
	                    break;
	                case 99:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 100:
	                    this.$ = [$$[$0]];
	                    break;
	                case 101:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	            }
	        },
	        table: [{ 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 14: [1, 12], 15: [1, 20], 16: 17, 19: [1, 23], 24: 15, 27: 16, 29: [1, 21], 34: [1, 22], 39: [2, 2], 44: [2, 2], 47: [2, 2], 48: [1, 13], 51: [1, 14], 55: [1, 18], 59: 19, 60: [1, 24] }, { 1: [2, 1] }, { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] }, { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] }, { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] }, { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] }, { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] }, { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] }, { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] }, { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] }, { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 15: [2, 48], 17: 39, 18: [2, 48] }, { 20: 41, 56: 40, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 44, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] }, { 20: 45, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 41, 56: 48, 64: 42, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [2, 78], 49: 49, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] }, { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] }, { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] }, { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] }, { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] }, { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] }, { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] }, { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] }, { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 50] }, { 72: [1, 35], 86: 51 }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 52: 52, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] }, { 25: 53, 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 54, 47: [2, 54] }, { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] }, { 13: 62, 15: [1, 20], 18: [1, 61] }, { 33: [2, 86], 57: 63, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] }, { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] }, { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] }, { 20: 64, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 65, 47: [1, 66] }, { 30: 67, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] }, { 33: [2, 64], 35: 68, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] }, { 21: 69, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] }, { 33: [2, 90], 61: 70, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] }, { 20: 74, 33: [2, 80], 50: 71, 63: 72, 64: 75, 65: [1, 43], 69: 73, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 72: [1, 79] }, { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 50] }, { 20: 74, 53: 80, 54: [2, 84], 63: 81, 64: 75, 65: [1, 43], 69: 82, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 83, 47: [1, 66] }, { 47: [2, 55] }, { 4: 84, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 47: [2, 20] }, { 20: 85, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 86, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 26: 87, 47: [1, 66] }, { 47: [2, 57] }, { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] }, { 15: [2, 49], 18: [2, 49] }, { 20: 74, 33: [2, 88], 58: 88, 63: 89, 64: 75, 65: [1, 43], 69: 90, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 65: [2, 94], 66: 91, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] }, { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] }, { 20: 92, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 31: 93, 33: [2, 60], 63: 94, 64: 75, 65: [1, 43], 69: 95, 70: 76, 71: 77, 72: [1, 78], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 66], 36: 96, 63: 97, 64: 75, 65: [1, 43], 69: 98, 70: 76, 71: 77, 72: [1, 78], 75: [2, 66], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 22: 99, 23: [2, 52], 63: 100, 64: 75, 65: [1, 43], 69: 101, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 74, 33: [2, 92], 62: 102, 63: 103, 64: 75, 65: [1, 43], 69: 104, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 105] }, { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] }, { 33: [2, 81] }, { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] }, { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] }, { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 106, 72: [1, 107], 75: [2, 30] }, { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 108], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] }, { 54: [1, 109] }, { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] }, { 54: [2, 85] }, { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] }, { 38: 55, 39: [1, 57], 43: 56, 44: [1, 58], 45: 111, 46: 110, 47: [2, 76] }, { 33: [2, 70], 40: 112, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] }, { 47: [2, 18] }, { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] }, { 33: [1, 113] }, { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] }, { 33: [2, 89] }, { 20: 74, 63: 115, 64: 75, 65: [1, 43], 67: 114, 68: [2, 96], 69: 116, 70: 76, 71: 77, 72: [1, 78], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 117] }, { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] }, { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] }, { 33: [2, 61], 75: [2, 61] }, { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] }, { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] }, { 33: [2, 67], 75: [2, 67] }, { 23: [1, 123] }, { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] }, { 23: [2, 53] }, { 33: [1, 124] }, { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] }, { 33: [2, 93] }, { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] }, { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] }, { 73: [1, 108] }, { 20: 74, 63: 125, 64: 75, 65: [1, 43], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] }, { 47: [2, 19] }, { 47: [2, 77] }, { 20: 74, 33: [2, 72], 41: 126, 63: 127, 64: 75, 65: [1, 43], 69: 128, 70: 76, 71: 77, 72: [1, 78], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] }, { 68: [1, 129] }, { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] }, { 68: [2, 97] }, { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] }, { 33: [1, 130] }, { 33: [2, 63] }, { 72: [1, 132], 76: 131 }, { 33: [1, 133] }, { 33: [2, 69] }, { 15: [2, 12], 18: [2, 12] }, { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] }, { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] }, { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] }, { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] }, { 33: [2, 73], 75: [2, 73] }, { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] }, { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] }, { 72: [1, 137], 77: [1, 136] }, { 72: [2, 100], 77: [2, 100] }, { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] }, { 33: [1, 138] }, { 33: [2, 75] }, { 33: [2, 32] }, { 72: [2, 101], 77: [2, 101] }, { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] }],
	        defaultActions: { 4: [2, 1], 54: [2, 55], 56: [2, 20], 60: [2, 57], 73: [2, 81], 82: [2, 85], 86: [2, 18], 90: [2, 89], 101: [2, 53], 104: [2, 93], 110: [2, 19], 111: [2, 77], 116: [2, 97], 119: [2, 63], 122: [2, 69], 135: [2, 75], 136: [2, 32] },
	        parseError: function parseError(str, hash) {
	            throw new Error(str);
	        },
	        parse: function parse(input) {
	            var self = this,
	                stack = [0],
	                vstack = [null],
	                lstack = [],
	                table = this.table,
	                yytext = "",
	                yylineno = 0,
	                yyleng = 0,
	                recovering = 0,
	                TERROR = 2,
	                EOF = 1;
	            this.lexer.setInput(input);
	            this.lexer.yy = this.yy;
	            this.yy.lexer = this.lexer;
	            this.yy.parser = this;
	            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
	            var yyloc = this.lexer.yylloc;
	            lstack.push(yyloc);
	            var ranges = this.lexer.options && this.lexer.options.ranges;
	            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
	            function popStack(n) {
	                stack.length = stack.length - 2 * n;
	                vstack.length = vstack.length - n;
	                lstack.length = lstack.length - n;
	            }
	            function lex() {
	                var token;
	                token = self.lexer.lex() || 1;
	                if (typeof token !== "number") {
	                    token = self.symbols_[token] || token;
	                }
	                return token;
	            }
	            var symbol,
	                preErrorSymbol,
	                state,
	                action,
	                a,
	                r,
	                yyval = {},
	                p,
	                len,
	                newState,
	                expected;
	            while (true) {
	                state = stack[stack.length - 1];
	                if (this.defaultActions[state]) {
	                    action = this.defaultActions[state];
	                } else {
	                    if (symbol === null || typeof symbol == "undefined") {
	                        symbol = lex();
	                    }
	                    action = table[state] && table[state][symbol];
	                }
	                if (typeof action === "undefined" || !action.length || !action[0]) {
	                    var errStr = "";
	                    if (!recovering) {
	                        expected = [];
	                        for (p in table[state]) if (this.terminals_[p] && p > 2) {
	                            expected.push("'" + this.terminals_[p] + "'");
	                        }
	                        if (this.lexer.showPosition) {
	                            errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
	                        } else {
	                            errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
	                        }
	                        this.parseError(errStr, { text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected });
	                    }
	                }
	                if (action[0] instanceof Array && action.length > 1) {
	                    throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
	                }
	                switch (action[0]) {
	                    case 1:
	                        stack.push(symbol);
	                        vstack.push(this.lexer.yytext);
	                        lstack.push(this.lexer.yylloc);
	                        stack.push(action[1]);
	                        symbol = null;
	                        if (!preErrorSymbol) {
	                            yyleng = this.lexer.yyleng;
	                            yytext = this.lexer.yytext;
	                            yylineno = this.lexer.yylineno;
	                            yyloc = this.lexer.yylloc;
	                            if (recovering > 0) recovering--;
	                        } else {
	                            symbol = preErrorSymbol;
	                            preErrorSymbol = null;
	                        }
	                        break;
	                    case 2:
	                        len = this.productions_[action[1]][1];
	                        yyval.$ = vstack[vstack.length - len];
	                        yyval._$ = { first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column };
	                        if (ranges) {
	                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
	                        }
	                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
	                        if (typeof r !== "undefined") {
	                            return r;
	                        }
	                        if (len) {
	                            stack = stack.slice(0, -1 * len * 2);
	                            vstack = vstack.slice(0, -1 * len);
	                            lstack = lstack.slice(0, -1 * len);
	                        }
	                        stack.push(this.productions_[action[1]][0]);
	                        vstack.push(yyval.$);
	                        lstack.push(yyval._$);
	                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	                        stack.push(newState);
	                        break;
	                    case 3:
	                        return true;
	                }
	            }
	            return true;
	        }
	    };
	    /* Jison generated lexer */
	    var lexer = (function () {
	        var lexer = { EOF: 1,
	            parseError: function parseError(str, hash) {
	                if (this.yy.parser) {
	                    this.yy.parser.parseError(str, hash);
	                } else {
	                    throw new Error(str);
	                }
	            },
	            setInput: function setInput(input) {
	                this._input = input;
	                this._more = this._less = this.done = false;
	                this.yylineno = this.yyleng = 0;
	                this.yytext = this.matched = this.match = '';
	                this.conditionStack = ['INITIAL'];
	                this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
	                if (this.options.ranges) this.yylloc.range = [0, 0];
	                this.offset = 0;
	                return this;
	            },
	            input: function input() {
	                var ch = this._input[0];
	                this.yytext += ch;
	                this.yyleng++;
	                this.offset++;
	                this.match += ch;
	                this.matched += ch;
	                var lines = ch.match(/(?:\r\n?|\n).*/g);
	                if (lines) {
	                    this.yylineno++;
	                    this.yylloc.last_line++;
	                } else {
	                    this.yylloc.last_column++;
	                }
	                if (this.options.ranges) this.yylloc.range[1]++;

	                this._input = this._input.slice(1);
	                return ch;
	            },
	            unput: function unput(ch) {
	                var len = ch.length;
	                var lines = ch.split(/(?:\r\n?|\n)/g);

	                this._input = ch + this._input;
	                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
	                //this.yyleng -= len;
	                this.offset -= len;
	                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	                this.match = this.match.substr(0, this.match.length - 1);
	                this.matched = this.matched.substr(0, this.matched.length - 1);

	                if (lines.length - 1) this.yylineno -= lines.length - 1;
	                var r = this.yylloc.range;

	                this.yylloc = { first_line: this.yylloc.first_line,
	                    last_line: this.yylineno + 1,
	                    first_column: this.yylloc.first_column,
	                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
	                };

	                if (this.options.ranges) {
	                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	                }
	                return this;
	            },
	            more: function more() {
	                this._more = true;
	                return this;
	            },
	            less: function less(n) {
	                this.unput(this.match.slice(n));
	            },
	            pastInput: function pastInput() {
	                var past = this.matched.substr(0, this.matched.length - this.match.length);
	                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
	            },
	            upcomingInput: function upcomingInput() {
	                var next = this.match;
	                if (next.length < 20) {
	                    next += this._input.substr(0, 20 - next.length);
	                }
	                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
	            },
	            showPosition: function showPosition() {
	                var pre = this.pastInput();
	                var c = new Array(pre.length + 1).join("-");
	                return pre + this.upcomingInput() + "\n" + c + "^";
	            },
	            next: function next() {
	                if (this.done) {
	                    return this.EOF;
	                }
	                if (!this._input) this.done = true;

	                var token, match, tempMatch, index, col, lines;
	                if (!this._more) {
	                    this.yytext = '';
	                    this.match = '';
	                }
	                var rules = this._currentRules();
	                for (var i = 0; i < rules.length; i++) {
	                    tempMatch = this._input.match(this.rules[rules[i]]);
	                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                        match = tempMatch;
	                        index = i;
	                        if (!this.options.flex) break;
	                    }
	                }
	                if (match) {
	                    lines = match[0].match(/(?:\r\n?|\n).*/g);
	                    if (lines) this.yylineno += lines.length;
	                    this.yylloc = { first_line: this.yylloc.last_line,
	                        last_line: this.yylineno + 1,
	                        first_column: this.yylloc.last_column,
	                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length };
	                    this.yytext += match[0];
	                    this.match += match[0];
	                    this.matches = match;
	                    this.yyleng = this.yytext.length;
	                    if (this.options.ranges) {
	                        this.yylloc.range = [this.offset, this.offset += this.yyleng];
	                    }
	                    this._more = false;
	                    this._input = this._input.slice(match[0].length);
	                    this.matched += match[0];
	                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
	                    if (this.done && this._input) this.done = false;
	                    if (token) return token;else return;
	                }
	                if (this._input === "") {
	                    return this.EOF;
	                } else {
	                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), { text: "", token: null, line: this.yylineno });
	                }
	            },
	            lex: function lex() {
	                var r = this.next();
	                if (typeof r !== 'undefined') {
	                    return r;
	                } else {
	                    return this.lex();
	                }
	            },
	            begin: function begin(condition) {
	                this.conditionStack.push(condition);
	            },
	            popState: function popState() {
	                return this.conditionStack.pop();
	            },
	            _currentRules: function _currentRules() {
	                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	            },
	            topState: function topState() {
	                return this.conditionStack[this.conditionStack.length - 2];
	            },
	            pushState: function begin(condition) {
	                this.begin(condition);
	            } };
	        lexer.options = {};
	        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {

	            function strip(start, end) {
	                return yy_.yytext = yy_.yytext.substring(start, yy_.yyleng - end + start);
	            }

	            var YYSTATE = YY_START;
	            switch ($avoiding_name_collisions) {
	                case 0:
	                    if (yy_.yytext.slice(-2) === "\\\\") {
	                        strip(0, 1);
	                        this.begin("mu");
	                    } else if (yy_.yytext.slice(-1) === "\\") {
	                        strip(0, 1);
	                        this.begin("emu");
	                    } else {
	                        this.begin("mu");
	                    }
	                    if (yy_.yytext) return 15;

	                    break;
	                case 1:
	                    return 15;
	                    break;
	                case 2:
	                    this.popState();
	                    return 15;

	                    break;
	                case 3:
	                    this.begin('raw');return 15;
	                    break;
	                case 4:
	                    this.popState();
	                    // Should be using `this.topState()` below, but it currently
	                    // returns the second top instead of the first top. Opened an
	                    // issue about it at https://github.com/zaach/jison/issues/291
	                    if (this.conditionStack[this.conditionStack.length - 1] === 'raw') {
	                        return 15;
	                    } else {
	                        strip(5, 9);
	                        return 'END_RAW_BLOCK';
	                    }

	                    break;
	                case 5:
	                    return 15;
	                    break;
	                case 6:
	                    this.popState();
	                    return 14;

	                    break;
	                case 7:
	                    return 65;
	                    break;
	                case 8:
	                    return 68;
	                    break;
	                case 9:
	                    return 19;
	                    break;
	                case 10:
	                    this.popState();
	                    this.begin('raw');
	                    return 23;

	                    break;
	                case 11:
	                    return 55;
	                    break;
	                case 12:
	                    return 60;
	                    break;
	                case 13:
	                    return 29;
	                    break;
	                case 14:
	                    return 47;
	                    break;
	                case 15:
	                    this.popState();return 44;
	                    break;
	                case 16:
	                    this.popState();return 44;
	                    break;
	                case 17:
	                    return 34;
	                    break;
	                case 18:
	                    return 39;
	                    break;
	                case 19:
	                    return 51;
	                    break;
	                case 20:
	                    return 48;
	                    break;
	                case 21:
	                    this.unput(yy_.yytext);
	                    this.popState();
	                    this.begin('com');

	                    break;
	                case 22:
	                    this.popState();
	                    return 14;

	                    break;
	                case 23:
	                    return 48;
	                    break;
	                case 24:
	                    return 73;
	                    break;
	                case 25:
	                    return 72;
	                    break;
	                case 26:
	                    return 72;
	                    break;
	                case 27:
	                    return 87;
	                    break;
	                case 28:
	                    // ignore whitespace
	                    break;
	                case 29:
	                    this.popState();return 54;
	                    break;
	                case 30:
	                    this.popState();return 33;
	                    break;
	                case 31:
	                    yy_.yytext = strip(1, 2).replace(/\\"/g, '"');return 80;
	                    break;
	                case 32:
	                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");return 80;
	                    break;
	                case 33:
	                    return 85;
	                    break;
	                case 34:
	                    return 82;
	                    break;
	                case 35:
	                    return 82;
	                    break;
	                case 36:
	                    return 83;
	                    break;
	                case 37:
	                    return 84;
	                    break;
	                case 38:
	                    return 81;
	                    break;
	                case 39:
	                    return 75;
	                    break;
	                case 40:
	                    return 77;
	                    break;
	                case 41:
	                    return 72;
	                    break;
	                case 42:
	                    yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, '$1');return 72;
	                    break;
	                case 43:
	                    return 'INVALID';
	                    break;
	                case 44:
	                    return 5;
	                    break;
	            }
	        };
	        lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]+?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/];
	        lexer.conditions = { "mu": { "rules": [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], "inclusive": false }, "emu": { "rules": [2], "inclusive": false }, "com": { "rules": [6], "inclusive": false }, "raw": { "rules": [3, 4, 5], "inclusive": false }, "INITIAL": { "rules": [0, 1, 44], "inclusive": true } };
	        return lexer;
	    })();
	    parser.lexer = lexer;
	    function Parser() {
	        this.yy = {};
	    }Parser.prototype = parser;parser.Parser = Parser;
	    return new Parser();
	})();exports["default"] = handlebars;
	module.exports = exports["default"];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _visitor = __webpack_require__(49);

	var _visitor2 = _interopRequireDefault(_visitor);

	function WhitespaceControl() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	  this.options = options;
	}
	WhitespaceControl.prototype = new _visitor2['default']();

	WhitespaceControl.prototype.Program = function (program) {
	  var doStandalone = !this.options.ignoreStandalone;

	  var isRoot = !this.isRootSeen;
	  this.isRootSeen = true;

	  var body = program.body;
	  for (var i = 0, l = body.length; i < l; i++) {
	    var current = body[i],
	        strip = this.accept(current);

	    if (!strip) {
	      continue;
	    }

	    var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot),
	        _isNextWhitespace = isNextWhitespace(body, i, isRoot),
	        openStandalone = strip.openStandalone && _isPrevWhitespace,
	        closeStandalone = strip.closeStandalone && _isNextWhitespace,
	        inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

	    if (strip.close) {
	      omitRight(body, i, true);
	    }
	    if (strip.open) {
	      omitLeft(body, i, true);
	    }

	    if (doStandalone && inlineStandalone) {
	      omitRight(body, i);

	      if (omitLeft(body, i)) {
	        // If we are on a standalone node, save the indent info for partials
	        if (current.type === 'PartialStatement') {
	          // Pull out the whitespace from the final line
	          current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
	        }
	      }
	    }
	    if (doStandalone && openStandalone) {
	      omitRight((current.program || current.inverse).body);

	      // Strip out the previous content node if it's whitespace only
	      omitLeft(body, i);
	    }
	    if (doStandalone && closeStandalone) {
	      // Always strip the next node
	      omitRight(body, i);

	      omitLeft((current.inverse || current.program).body);
	    }
	  }

	  return program;
	};

	WhitespaceControl.prototype.BlockStatement = WhitespaceControl.prototype.DecoratorBlock = WhitespaceControl.prototype.PartialBlockStatement = function (block) {
	  this.accept(block.program);
	  this.accept(block.inverse);

	  // Find the inverse program that is involed with whitespace stripping.
	  var program = block.program || block.inverse,
	      inverse = block.program && block.inverse,
	      firstInverse = inverse,
	      lastInverse = inverse;

	  if (inverse && inverse.chained) {
	    firstInverse = inverse.body[0].program;

	    // Walk the inverse chain to find the last inverse that is actually in the chain.
	    while (lastInverse.chained) {
	      lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
	    }
	  }

	  var strip = {
	    open: block.openStrip.open,
	    close: block.closeStrip.close,

	    // Determine the standalone candiacy. Basically flag our content as being possibly standalone
	    // so our parent can determine if we actually are standalone
	    openStandalone: isNextWhitespace(program.body),
	    closeStandalone: isPrevWhitespace((firstInverse || program).body)
	  };

	  if (block.openStrip.close) {
	    omitRight(program.body, null, true);
	  }

	  if (inverse) {
	    var inverseStrip = block.inverseStrip;

	    if (inverseStrip.open) {
	      omitLeft(program.body, null, true);
	    }

	    if (inverseStrip.close) {
	      omitRight(firstInverse.body, null, true);
	    }
	    if (block.closeStrip.open) {
	      omitLeft(lastInverse.body, null, true);
	    }

	    // Find standalone else statments
	    if (!this.options.ignoreStandalone && isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
	      omitLeft(program.body);
	      omitRight(firstInverse.body);
	    }
	  } else if (block.closeStrip.open) {
	    omitLeft(program.body, null, true);
	  }

	  return strip;
	};

	WhitespaceControl.prototype.Decorator = WhitespaceControl.prototype.MustacheStatement = function (mustache) {
	  return mustache.strip;
	};

	WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function (node) {
	  /* istanbul ignore next */
	  var strip = node.strip || {};
	  return {
	    inlineStandalone: true,
	    open: strip.open,
	    close: strip.close
	  };
	};

	function isPrevWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = body.length;
	  }

	  // Nodes that end with newlines are considered whitespace (but are special
	  // cased for strip operations)
	  var prev = body[i - 1],
	      sibling = body[i - 2];
	  if (!prev) {
	    return isRoot;
	  }

	  if (prev.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
	  }
	}
	function isNextWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = -1;
	  }

	  var next = body[i + 1],
	      sibling = body[i + 2];
	  if (!next) {
	    return isRoot;
	  }

	  if (next.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
	  }
	}

	// Marks the node to the right of the position as omitted.
	// I.e. {{foo}}' ' will mark the ' ' node as omitted.
	//
	// If i is undefined, then the first child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitRight(body, i, multiple) {
	  var current = body[i == null ? 0 : i + 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) {
	    return;
	  }

	  var original = current.value;
	  current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
	  current.rightStripped = current.value !== original;
	}

	// Marks the node to the left of the position as omitted.
	// I.e. ' '{{foo}} will mark the ' ' node as omitted.
	//
	// If i is undefined then the last child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitLeft(body, i, multiple) {
	  var current = body[i == null ? body.length - 1 : i - 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) {
	    return;
	  }

	  // We omit the last node if it's whitespace only and not preceded by a non-content node.
	  var original = current.value;
	  current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
	  current.leftStripped = current.value !== original;
	  return current.leftStripped;
	}

	exports['default'] = WhitespaceControl;
	module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	function Visitor() {
	  this.parents = [];
	}

	Visitor.prototype = {
	  constructor: Visitor,
	  mutating: false,

	  // Visits a given value. If mutating, will replace the value if necessary.
	  acceptKey: function acceptKey(node, name) {
	    var value = this.accept(node[name]);
	    if (this.mutating) {
	      // Hacky sanity check: This may have a few false positives for type for the helper
	      // methods but will generally do the right thing without a lot of overhead.
	      if (value && !Visitor.prototype[value.type]) {
	        throw new _exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
	      }
	      node[name] = value;
	    }
	  },

	  // Performs an accept operation with added sanity check to ensure
	  // required keys are not removed.
	  acceptRequired: function acceptRequired(node, name) {
	    this.acceptKey(node, name);

	    if (!node[name]) {
	      throw new _exception2['default'](node.type + ' requires ' + name);
	    }
	  },

	  // Traverses a given array. If mutating, empty respnses will be removed
	  // for child elements.
	  acceptArray: function acceptArray(array) {
	    for (var i = 0, l = array.length; i < l; i++) {
	      this.acceptKey(array, i);

	      if (!array[i]) {
	        array.splice(i, 1);
	        i--;
	        l--;
	      }
	    }
	  },

	  accept: function accept(object) {
	    if (!object) {
	      return;
	    }

	    /* istanbul ignore next: Sanity code */
	    if (!this[object.type]) {
	      throw new _exception2['default']('Unknown type: ' + object.type, object);
	    }

	    if (this.current) {
	      this.parents.unshift(this.current);
	    }
	    this.current = object;

	    var ret = this[object.type](object);

	    this.current = this.parents.shift();

	    if (!this.mutating || ret) {
	      return ret;
	    } else if (ret !== false) {
	      return object;
	    }
	  },

	  Program: function Program(program) {
	    this.acceptArray(program.body);
	  },

	  MustacheStatement: visitSubExpression,
	  Decorator: visitSubExpression,

	  BlockStatement: visitBlock,
	  DecoratorBlock: visitBlock,

	  PartialStatement: visitPartial,
	  PartialBlockStatement: function PartialBlockStatement(partial) {
	    visitPartial.call(this, partial);

	    this.acceptKey(partial, 'program');
	  },

	  ContentStatement: function ContentStatement() /* content */{},
	  CommentStatement: function CommentStatement() /* comment */{},

	  SubExpression: visitSubExpression,

	  PathExpression: function PathExpression() /* path */{},

	  StringLiteral: function StringLiteral() /* string */{},
	  NumberLiteral: function NumberLiteral() /* number */{},
	  BooleanLiteral: function BooleanLiteral() /* bool */{},
	  UndefinedLiteral: function UndefinedLiteral() /* literal */{},
	  NullLiteral: function NullLiteral() /* literal */{},

	  Hash: function Hash(hash) {
	    this.acceptArray(hash.pairs);
	  },
	  HashPair: function HashPair(pair) {
	    this.acceptRequired(pair, 'value');
	  }
	};

	function visitSubExpression(mustache) {
	  this.acceptRequired(mustache, 'path');
	  this.acceptArray(mustache.params);
	  this.acceptKey(mustache, 'hash');
	}
	function visitBlock(block) {
	  visitSubExpression.call(this, block);

	  this.acceptKey(block, 'program');
	  this.acceptKey(block, 'inverse');
	}
	function visitPartial(partial) {
	  this.acceptRequired(partial, 'name');
	  this.acceptArray(partial.params);
	  this.acceptKey(partial, 'hash');
	}

	exports['default'] = Visitor;
	module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.SourceLocation = SourceLocation;
	exports.id = id;
	exports.stripFlags = stripFlags;
	exports.stripComment = stripComment;
	exports.preparePath = preparePath;
	exports.prepareMustache = prepareMustache;
	exports.prepareRawBlock = prepareRawBlock;
	exports.prepareBlock = prepareBlock;
	exports.prepareProgram = prepareProgram;
	exports.preparePartialBlock = preparePartialBlock;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	function validateClose(open, close) {
	  close = close.path ? close.path.original : close;

	  if (open.path.original !== close) {
	    var errorNode = { loc: open.path.loc };

	    throw new _exception2['default'](open.path.original + " doesn't match " + close, errorNode);
	  }
	}

	function SourceLocation(source, locInfo) {
	  this.source = source;
	  this.start = {
	    line: locInfo.first_line,
	    column: locInfo.first_column
	  };
	  this.end = {
	    line: locInfo.last_line,
	    column: locInfo.last_column
	  };
	}

	function id(token) {
	  if (/^\[.*\]$/.test(token)) {
	    return token.substring(1, token.length - 1);
	  } else {
	    return token;
	  }
	}

	function stripFlags(open, close) {
	  return {
	    open: open.charAt(2) === '~',
	    close: close.charAt(close.length - 3) === '~'
	  };
	}

	function stripComment(comment) {
	  return comment.replace(/^\{\{~?!-?-?/, '').replace(/-?-?~?\}\}$/, '');
	}

	function preparePath(data, parts, loc) {
	  loc = this.locInfo(loc);

	  var original = data ? '@' : '',
	      dig = [],
	      depth = 0;

	  for (var i = 0, l = parts.length; i < l; i++) {
	    var part = parts[i].part,

	    // If we have [] syntax then we do not treat path references as operators,
	    // i.e. foo.[this] resolves to approximately context.foo['this']
	    isLiteral = parts[i].original !== part;
	    original += (parts[i].separator || '') + part;

	    if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
	      if (dig.length > 0) {
	        throw new _exception2['default']('Invalid path: ' + original, { loc: loc });
	      } else if (part === '..') {
	        depth++;
	      }
	    } else {
	      dig.push(part);
	    }
	  }

	  return {
	    type: 'PathExpression',
	    data: data,
	    depth: depth,
	    parts: dig,
	    original: original,
	    loc: loc
	  };
	}

	function prepareMustache(path, params, hash, open, strip, locInfo) {
	  // Must use charAt to support IE pre-10
	  var escapeFlag = open.charAt(3) || open.charAt(2),
	      escaped = escapeFlag !== '{' && escapeFlag !== '&';

	  var decorator = /\*/.test(open);
	  return {
	    type: decorator ? 'Decorator' : 'MustacheStatement',
	    path: path,
	    params: params,
	    hash: hash,
	    escaped: escaped,
	    strip: strip,
	    loc: this.locInfo(locInfo)
	  };
	}

	function prepareRawBlock(openRawBlock, contents, close, locInfo) {
	  validateClose(openRawBlock, close);

	  locInfo = this.locInfo(locInfo);
	  var program = {
	    type: 'Program',
	    body: contents,
	    strip: {},
	    loc: locInfo
	  };

	  return {
	    type: 'BlockStatement',
	    path: openRawBlock.path,
	    params: openRawBlock.params,
	    hash: openRawBlock.hash,
	    program: program,
	    openStrip: {},
	    inverseStrip: {},
	    closeStrip: {},
	    loc: locInfo
	  };
	}

	function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
	  if (close && close.path) {
	    validateClose(openBlock, close);
	  }

	  var decorator = /\*/.test(openBlock.open);

	  program.blockParams = openBlock.blockParams;

	  var inverse = undefined,
	      inverseStrip = undefined;

	  if (inverseAndProgram) {
	    if (decorator) {
	      throw new _exception2['default']('Unexpected inverse block on decorator', inverseAndProgram);
	    }

	    if (inverseAndProgram.chain) {
	      inverseAndProgram.program.body[0].closeStrip = close.strip;
	    }

	    inverseStrip = inverseAndProgram.strip;
	    inverse = inverseAndProgram.program;
	  }

	  if (inverted) {
	    inverted = inverse;
	    inverse = program;
	    program = inverted;
	  }

	  return {
	    type: decorator ? 'DecoratorBlock' : 'BlockStatement',
	    path: openBlock.path,
	    params: openBlock.params,
	    hash: openBlock.hash,
	    program: program,
	    inverse: inverse,
	    openStrip: openBlock.strip,
	    inverseStrip: inverseStrip,
	    closeStrip: close && close.strip,
	    loc: this.locInfo(locInfo)
	  };
	}

	function prepareProgram(statements, loc) {
	  if (!loc && statements.length) {
	    var firstLoc = statements[0].loc,
	        lastLoc = statements[statements.length - 1].loc;

	    /* istanbul ignore else */
	    if (firstLoc && lastLoc) {
	      loc = {
	        source: firstLoc.source,
	        start: {
	          line: firstLoc.start.line,
	          column: firstLoc.start.column
	        },
	        end: {
	          line: lastLoc.end.line,
	          column: lastLoc.end.column
	        }
	      };
	    }
	  }

	  return {
	    type: 'Program',
	    body: statements,
	    strip: {},
	    loc: loc
	  };
	}

	function preparePartialBlock(open, program, close, locInfo) {
	  validateClose(open, close);

	  return {
	    type: 'PartialBlockStatement',
	    name: open.path,
	    params: open.params,
	    hash: open.hash,
	    program: program,
	    openStrip: open.strip,
	    closeStrip: close && close.strip,
	    loc: this.locInfo(locInfo)
	  };
	}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable new-cap */

	'use strict';

	var _Object$create = __webpack_require__(34)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.Compiler = Compiler;
	exports.precompile = precompile;
	exports.compile = compile;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _utils = __webpack_require__(5);

	var _ast = __webpack_require__(45);

	var _ast2 = _interopRequireDefault(_ast);

	var slice = [].slice;

	function Compiler() {}

	// the foundHelper register will disambiguate helper lookup from finding a
	// function in a context. This is necessary for mustache compatibility, which
	// requires that context functions in blocks are evaluated by blockHelperMissing,
	// and then proceed as if the resulting value was provided to blockHelperMissing.

	Compiler.prototype = {
	  compiler: Compiler,

	  equals: function equals(other) {
	    var len = this.opcodes.length;
	    if (other.opcodes.length !== len) {
	      return false;
	    }

	    for (var i = 0; i < len; i++) {
	      var opcode = this.opcodes[i],
	          otherOpcode = other.opcodes[i];
	      if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
	        return false;
	      }
	    }

	    // We know that length is the same between the two arrays because they are directly tied
	    // to the opcode behavior above.
	    len = this.children.length;
	    for (var i = 0; i < len; i++) {
	      if (!this.children[i].equals(other.children[i])) {
	        return false;
	      }
	    }

	    return true;
	  },

	  guid: 0,

	  compile: function compile(program, options) {
	    this.sourceNode = [];
	    this.opcodes = [];
	    this.children = [];
	    this.options = options;
	    this.stringParams = options.stringParams;
	    this.trackIds = options.trackIds;

	    options.blockParams = options.blockParams || [];

	    options.knownHelpers = _utils.extend(_Object$create(null), {
	      helperMissing: true,
	      blockHelperMissing: true,
	      each: true,
	      'if': true,
	      unless: true,
	      'with': true,
	      log: true,
	      lookup: true
	    }, options.knownHelpers);

	    return this.accept(program);
	  },

	  compileProgram: function compileProgram(program) {
	    var childCompiler = new this.compiler(),
	        // eslint-disable-line new-cap
	    result = childCompiler.compile(program, this.options),
	        guid = this.guid++;

	    this.usePartial = this.usePartial || result.usePartial;

	    this.children[guid] = result;
	    this.useDepths = this.useDepths || result.useDepths;

	    return guid;
	  },

	  accept: function accept(node) {
	    /* istanbul ignore next: Sanity code */
	    if (!this[node.type]) {
	      throw new _exception2['default']('Unknown type: ' + node.type, node);
	    }

	    this.sourceNode.unshift(node);
	    var ret = this[node.type](node);
	    this.sourceNode.shift();
	    return ret;
	  },

	  Program: function Program(program) {
	    this.options.blockParams.unshift(program.blockParams);

	    var body = program.body,
	        bodyLength = body.length;
	    for (var i = 0; i < bodyLength; i++) {
	      this.accept(body[i]);
	    }

	    this.options.blockParams.shift();

	    this.isSimple = bodyLength === 1;
	    this.blockParams = program.blockParams ? program.blockParams.length : 0;

	    return this;
	  },

	  BlockStatement: function BlockStatement(block) {
	    transformLiteralToPath(block);

	    var program = block.program,
	        inverse = block.inverse;

	    program = program && this.compileProgram(program);
	    inverse = inverse && this.compileProgram(inverse);

	    var type = this.classifySexpr(block);

	    if (type === 'helper') {
	      this.helperSexpr(block, program, inverse);
	    } else if (type === 'simple') {
	      this.simpleSexpr(block);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('blockValue', block.path.original);
	    } else {
	      this.ambiguousSexpr(block, program, inverse);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('ambiguousBlockValue');
	    }

	    this.opcode('append');
	  },

	  DecoratorBlock: function DecoratorBlock(decorator) {
	    var program = decorator.program && this.compileProgram(decorator.program);
	    var params = this.setupFullMustacheParams(decorator, program, undefined),
	        path = decorator.path;

	    this.useDecorators = true;
	    this.opcode('registerDecorator', params.length, path.original);
	  },

	  PartialStatement: function PartialStatement(partial) {
	    this.usePartial = true;

	    var program = partial.program;
	    if (program) {
	      program = this.compileProgram(partial.program);
	    }

	    var params = partial.params;
	    if (params.length > 1) {
	      throw new _exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
	    } else if (!params.length) {
	      if (this.options.explicitPartialContext) {
	        this.opcode('pushLiteral', 'undefined');
	      } else {
	        params.push({ type: 'PathExpression', parts: [], depth: 0 });
	      }
	    }

	    var partialName = partial.name.original,
	        isDynamic = partial.name.type === 'SubExpression';
	    if (isDynamic) {
	      this.accept(partial.name);
	    }

	    this.setupFullMustacheParams(partial, program, undefined, true);

	    var indent = partial.indent || '';
	    if (this.options.preventIndent && indent) {
	      this.opcode('appendContent', indent);
	      indent = '';
	    }

	    this.opcode('invokePartial', isDynamic, partialName, indent);
	    this.opcode('append');
	  },
	  PartialBlockStatement: function PartialBlockStatement(partialBlock) {
	    this.PartialStatement(partialBlock);
	  },

	  MustacheStatement: function MustacheStatement(mustache) {
	    this.SubExpression(mustache);

	    if (mustache.escaped && !this.options.noEscape) {
	      this.opcode('appendEscaped');
	    } else {
	      this.opcode('append');
	    }
	  },
	  Decorator: function Decorator(decorator) {
	    this.DecoratorBlock(decorator);
	  },

	  ContentStatement: function ContentStatement(content) {
	    if (content.value) {
	      this.opcode('appendContent', content.value);
	    }
	  },

	  CommentStatement: function CommentStatement() {},

	  SubExpression: function SubExpression(sexpr) {
	    transformLiteralToPath(sexpr);
	    var type = this.classifySexpr(sexpr);

	    if (type === 'simple') {
	      this.simpleSexpr(sexpr);
	    } else if (type === 'helper') {
	      this.helperSexpr(sexpr);
	    } else {
	      this.ambiguousSexpr(sexpr);
	    }
	  },
	  ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
	    var path = sexpr.path,
	        name = path.parts[0],
	        isBlock = program != null || inverse != null;

	    this.opcode('getContext', path.depth);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    path.strict = true;
	    this.accept(path);

	    this.opcode('invokeAmbiguous', name, isBlock);
	  },

	  simpleSexpr: function simpleSexpr(sexpr) {
	    var path = sexpr.path;
	    path.strict = true;
	    this.accept(path);
	    this.opcode('resolvePossibleLambda');
	  },

	  helperSexpr: function helperSexpr(sexpr, program, inverse) {
	    var params = this.setupFullMustacheParams(sexpr, program, inverse),
	        path = sexpr.path,
	        name = path.parts[0];

	    if (this.options.knownHelpers[name]) {
	      this.opcode('invokeKnownHelper', params.length, name);
	    } else if (this.options.knownHelpersOnly) {
	      throw new _exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
	    } else {
	      path.strict = true;
	      path.falsy = true;

	      this.accept(path);
	      this.opcode('invokeHelper', params.length, path.original, _ast2['default'].helpers.simpleId(path));
	    }
	  },

	  PathExpression: function PathExpression(path) {
	    this.addDepth(path.depth);
	    this.opcode('getContext', path.depth);

	    var name = path.parts[0],
	        scoped = _ast2['default'].helpers.scopedId(path),
	        blockParamId = !path.depth && !scoped && this.blockParamIndex(name);

	    if (blockParamId) {
	      this.opcode('lookupBlockParam', blockParamId, path.parts);
	    } else if (!name) {
	      // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
	      this.opcode('pushContext');
	    } else if (path.data) {
	      this.options.data = true;
	      this.opcode('lookupData', path.depth, path.parts, path.strict);
	    } else {
	      this.opcode('lookupOnContext', path.parts, path.falsy, path.strict, scoped);
	    }
	  },

	  StringLiteral: function StringLiteral(string) {
	    this.opcode('pushString', string.value);
	  },

	  NumberLiteral: function NumberLiteral(number) {
	    this.opcode('pushLiteral', number.value);
	  },

	  BooleanLiteral: function BooleanLiteral(bool) {
	    this.opcode('pushLiteral', bool.value);
	  },

	  UndefinedLiteral: function UndefinedLiteral() {
	    this.opcode('pushLiteral', 'undefined');
	  },

	  NullLiteral: function NullLiteral() {
	    this.opcode('pushLiteral', 'null');
	  },

	  Hash: function Hash(hash) {
	    var pairs = hash.pairs,
	        i = 0,
	        l = pairs.length;

	    this.opcode('pushHash');

	    for (; i < l; i++) {
	      this.pushParam(pairs[i].value);
	    }
	    while (i--) {
	      this.opcode('assignToHash', pairs[i].key);
	    }
	    this.opcode('popHash');
	  },

	  // HELPERS
	  opcode: function opcode(name) {
	    this.opcodes.push({
	      opcode: name,
	      args: slice.call(arguments, 1),
	      loc: this.sourceNode[0].loc
	    });
	  },

	  addDepth: function addDepth(depth) {
	    if (!depth) {
	      return;
	    }

	    this.useDepths = true;
	  },

	  classifySexpr: function classifySexpr(sexpr) {
	    var isSimple = _ast2['default'].helpers.simpleId(sexpr.path);

	    var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);

	    // a mustache is an eligible helper if:
	    // * its id is simple (a single part, not `this` or `..`)
	    var isHelper = !isBlockParam && _ast2['default'].helpers.helperExpression(sexpr);

	    // if a mustache is an eligible helper but not a definite
	    // helper, it is ambiguous, and will be resolved in a later
	    // pass or at runtime.
	    var isEligible = !isBlockParam && (isHelper || isSimple);

	    // if ambiguous, we can possibly resolve the ambiguity now
	    // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
	    if (isEligible && !isHelper) {
	      var _name = sexpr.path.parts[0],
	          options = this.options;
	      if (options.knownHelpers[_name]) {
	        isHelper = true;
	      } else if (options.knownHelpersOnly) {
	        isEligible = false;
	      }
	    }

	    if (isHelper) {
	      return 'helper';
	    } else if (isEligible) {
	      return 'ambiguous';
	    } else {
	      return 'simple';
	    }
	  },

	  pushParams: function pushParams(params) {
	    for (var i = 0, l = params.length; i < l; i++) {
	      this.pushParam(params[i]);
	    }
	  },

	  pushParam: function pushParam(val) {
	    var value = val.value != null ? val.value : val.original || '';

	    if (this.stringParams) {
	      if (value.replace) {
	        value = value.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.');
	      }

	      if (val.depth) {
	        this.addDepth(val.depth);
	      }
	      this.opcode('getContext', val.depth || 0);
	      this.opcode('pushStringParam', value, val.type);

	      if (val.type === 'SubExpression') {
	        // SubExpressions get evaluated and passed in
	        // in string params mode.
	        this.accept(val);
	      }
	    } else {
	      if (this.trackIds) {
	        var blockParamIndex = undefined;
	        if (val.parts && !_ast2['default'].helpers.scopedId(val) && !val.depth) {
	          blockParamIndex = this.blockParamIndex(val.parts[0]);
	        }
	        if (blockParamIndex) {
	          var blockParamChild = val.parts.slice(1).join('.');
	          this.opcode('pushId', 'BlockParam', blockParamIndex, blockParamChild);
	        } else {
	          value = val.original || value;
	          if (value.replace) {
	            value = value.replace(/^this(?:\.|$)/, '').replace(/^\.\//, '').replace(/^\.$/, '');
	          }

	          this.opcode('pushId', val.type, value);
	        }
	      }
	      this.accept(val);
	    }
	  },

	  setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
	    var params = sexpr.params;
	    this.pushParams(params);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    if (sexpr.hash) {
	      this.accept(sexpr.hash);
	    } else {
	      this.opcode('emptyHash', omitEmpty);
	    }

	    return params;
	  },

	  blockParamIndex: function blockParamIndex(name) {
	    for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
	      var blockParams = this.options.blockParams[depth],
	          param = blockParams && _utils.indexOf(blockParams, name);
	      if (blockParams && param >= 0) {
	        return [depth, param];
	      }
	    }
	  }
	};

	function precompile(input, options, env) {
	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + input);
	  }

	  options = options || {};
	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var ast = env.parse(input, options),
	      environment = new env.Compiler().compile(ast, options);
	  return new env.JavaScriptCompiler().compile(environment, options);
	}

	function compile(input, options, env) {
	  if (options === undefined) options = {};

	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
	  }

	  options = _utils.extend({}, options);
	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var compiled = undefined;

	  function compileInput() {
	    var ast = env.parse(input, options),
	        environment = new env.Compiler().compile(ast, options),
	        templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
	    return env.template(templateSpec);
	  }

	  // Template is only compiled on first use and cached after that point.
	  function ret(context, execOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled.call(this, context, execOptions);
	  }
	  ret._setup = function (setupOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._setup(setupOptions);
	  };
	  ret._child = function (i, data, blockParams, depths) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._child(i, data, blockParams, depths);
	  };
	  return ret;
	}

	function argEquals(a, b) {
	  if (a === b) {
	    return true;
	  }

	  if (_utils.isArray(a) && _utils.isArray(b) && a.length === b.length) {
	    for (var i = 0; i < a.length; i++) {
	      if (!argEquals(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	}

	function transformLiteralToPath(sexpr) {
	  if (!sexpr.path.parts) {
	    var literal = sexpr.path;
	    // Casting to string here to make false and 0 literal values play nicely with the rest
	    // of the system.
	    sexpr.path = {
	      type: 'PathExpression',
	      data: false,
	      depth: 0,
	      parts: [literal.original + ''],
	      original: literal.original + '',
	      loc: literal.loc
	    };
	  }
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$keys = __webpack_require__(13)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _base = __webpack_require__(4);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _utils = __webpack_require__(5);

	var _codeGen = __webpack_require__(53);

	var _codeGen2 = _interopRequireDefault(_codeGen);

	function Literal(value) {
	  this.value = value;
	}

	function JavaScriptCompiler() {}

	JavaScriptCompiler.prototype = {
	  // PUBLIC API: You can override these methods in a subclass to provide
	  // alternative compiled forms for name lookup and buffering semantics
	  nameLookup: function nameLookup(parent, name /*,  type */) {
	    return this.internalNameLookup(parent, name);
	  },
	  depthedLookup: function depthedLookup(name) {
	    return [this.aliasable('container.lookup'), '(depths, ', JSON.stringify(name), ')'];
	  },

	  compilerInfo: function compilerInfo() {
	    var revision = _base.COMPILER_REVISION,
	        versions = _base.REVISION_CHANGES[revision];
	    return [revision, versions];
	  },

	  appendToBuffer: function appendToBuffer(source, location, explicit) {
	    // Force a source as this simplifies the merge logic.
	    if (!_utils.isArray(source)) {
	      source = [source];
	    }
	    source = this.source.wrap(source, location);

	    if (this.environment.isSimple) {
	      return ['return ', source, ';'];
	    } else if (explicit) {
	      // This is a case where the buffer operation occurs as a child of another
	      // construct, generally braces. We have to explicitly output these buffer
	      // operations to ensure that the emitted code goes in the correct location.
	      return ['buffer += ', source, ';'];
	    } else {
	      source.appendToBuffer = true;
	      return source;
	    }
	  },

	  initializeBuffer: function initializeBuffer() {
	    return this.quotedString('');
	  },
	  // END PUBLIC API
	  internalNameLookup: function internalNameLookup(parent, name) {
	    this.lookupPropertyFunctionIsUsed = true;
	    return ['lookupProperty(', parent, ',', JSON.stringify(name), ')'];
	  },

	  lookupPropertyFunctionIsUsed: false,

	  compile: function compile(environment, options, context, asObject) {
	    this.environment = environment;
	    this.options = options;
	    this.stringParams = this.options.stringParams;
	    this.trackIds = this.options.trackIds;
	    this.precompile = !asObject;

	    this.name = this.environment.name;
	    this.isChild = !!context;
	    this.context = context || {
	      decorators: [],
	      programs: [],
	      environments: []
	    };

	    this.preamble();

	    this.stackSlot = 0;
	    this.stackVars = [];
	    this.aliases = {};
	    this.registers = { list: [] };
	    this.hashes = [];
	    this.compileStack = [];
	    this.inlineStack = [];
	    this.blockParams = [];

	    this.compileChildren(environment, options);

	    this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
	    this.useBlockParams = this.useBlockParams || environment.useBlockParams;

	    var opcodes = environment.opcodes,
	        opcode = undefined,
	        firstLoc = undefined,
	        i = undefined,
	        l = undefined;

	    for (i = 0, l = opcodes.length; i < l; i++) {
	      opcode = opcodes[i];

	      this.source.currentLocation = opcode.loc;
	      firstLoc = firstLoc || opcode.loc;
	      this[opcode.opcode].apply(this, opcode.args);
	    }

	    // Flush any trailing content that might be pending.
	    this.source.currentLocation = firstLoc;
	    this.pushSource('');

	    /* istanbul ignore next */
	    if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
	      throw new _exception2['default']('Compile completed with content left on stack');
	    }

	    if (!this.decorators.isEmpty()) {
	      this.useDecorators = true;

	      this.decorators.prepend(['var decorators = container.decorators, ', this.lookupPropertyFunctionVarDeclaration(), ';\n']);
	      this.decorators.push('return fn;');

	      if (asObject) {
	        this.decorators = Function.apply(this, ['fn', 'props', 'container', 'depth0', 'data', 'blockParams', 'depths', this.decorators.merge()]);
	      } else {
	        this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n');
	        this.decorators.push('}\n');
	        this.decorators = this.decorators.merge();
	      }
	    } else {
	      this.decorators = undefined;
	    }

	    var fn = this.createFunctionContext(asObject);
	    if (!this.isChild) {
	      var ret = {
	        compiler: this.compilerInfo(),
	        main: fn
	      };

	      if (this.decorators) {
	        ret.main_d = this.decorators; // eslint-disable-line camelcase
	        ret.useDecorators = true;
	      }

	      var _context = this.context;
	      var programs = _context.programs;
	      var decorators = _context.decorators;

	      for (i = 0, l = programs.length; i < l; i++) {
	        if (programs[i]) {
	          ret[i] = programs[i];
	          if (decorators[i]) {
	            ret[i + '_d'] = decorators[i];
	            ret.useDecorators = true;
	          }
	        }
	      }

	      if (this.environment.usePartial) {
	        ret.usePartial = true;
	      }
	      if (this.options.data) {
	        ret.useData = true;
	      }
	      if (this.useDepths) {
	        ret.useDepths = true;
	      }
	      if (this.useBlockParams) {
	        ret.useBlockParams = true;
	      }
	      if (this.options.compat) {
	        ret.compat = true;
	      }

	      if (!asObject) {
	        ret.compiler = JSON.stringify(ret.compiler);

	        this.source.currentLocation = { start: { line: 1, column: 0 } };
	        ret = this.objectLiteral(ret);

	        if (options.srcName) {
	          ret = ret.toStringWithSourceMap({ file: options.destName });
	          ret.map = ret.map && ret.map.toString();
	        } else {
	          ret = ret.toString();
	        }
	      } else {
	        ret.compilerOptions = this.options;
	      }

	      return ret;
	    } else {
	      return fn;
	    }
	  },

	  preamble: function preamble() {
	    // track the last context pushed into place to allow skipping the
	    // getContext opcode when it would be a noop
	    this.lastContext = 0;
	    this.source = new _codeGen2['default'](this.options.srcName);
	    this.decorators = new _codeGen2['default'](this.options.srcName);
	  },

	  createFunctionContext: function createFunctionContext(asObject) {
	    // istanbul ignore next

	    var _this = this;

	    var varDeclarations = '';

	    var locals = this.stackVars.concat(this.registers.list);
	    if (locals.length > 0) {
	      varDeclarations += ', ' + locals.join(', ');
	    }

	    // Generate minimizer alias mappings
	    //
	    // When using true SourceNodes, this will update all references to the given alias
	    // as the source nodes are reused in situ. For the non-source node compilation mode,
	    // aliases will not be used, but this case is already being run on the client and
	    // we aren't concern about minimizing the template size.
	    var aliasCount = 0;
	    _Object$keys(this.aliases).forEach(function (alias) {
	      var node = _this.aliases[alias];
	      if (node.children && node.referenceCount > 1) {
	        varDeclarations += ', alias' + ++aliasCount + '=' + alias;
	        node.children[0] = 'alias' + aliasCount;
	      }
	    });

	    if (this.lookupPropertyFunctionIsUsed) {
	      varDeclarations += ', ' + this.lookupPropertyFunctionVarDeclaration();
	    }

	    var params = ['container', 'depth0', 'helpers', 'partials', 'data'];

	    if (this.useBlockParams || this.useDepths) {
	      params.push('blockParams');
	    }
	    if (this.useDepths) {
	      params.push('depths');
	    }

	    // Perform a second pass over the output to merge content when possible
	    var source = this.mergeSource(varDeclarations);

	    if (asObject) {
	      params.push(source);

	      return Function.apply(this, params);
	    } else {
	      return this.source.wrap(['function(', params.join(','), ') {\n  ', source, '}']);
	    }
	  },
	  mergeSource: function mergeSource(varDeclarations) {
	    var isSimple = this.environment.isSimple,
	        appendOnly = !this.forceBuffer,
	        appendFirst = undefined,
	        sourceSeen = undefined,
	        bufferStart = undefined,
	        bufferEnd = undefined;
	    this.source.each(function (line) {
	      if (line.appendToBuffer) {
	        if (bufferStart) {
	          line.prepend('  + ');
	        } else {
	          bufferStart = line;
	        }
	        bufferEnd = line;
	      } else {
	        if (bufferStart) {
	          if (!sourceSeen) {
	            appendFirst = true;
	          } else {
	            bufferStart.prepend('buffer += ');
	          }
	          bufferEnd.add(';');
	          bufferStart = bufferEnd = undefined;
	        }

	        sourceSeen = true;
	        if (!isSimple) {
	          appendOnly = false;
	        }
	      }
	    });

	    if (appendOnly) {
	      if (bufferStart) {
	        bufferStart.prepend('return ');
	        bufferEnd.add(';');
	      } else if (!sourceSeen) {
	        this.source.push('return "";');
	      }
	    } else {
	      varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());

	      if (bufferStart) {
	        bufferStart.prepend('return buffer + ');
	        bufferEnd.add(';');
	      } else {
	        this.source.push('return buffer;');
	      }
	    }

	    if (varDeclarations) {
	      this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
	    }

	    return this.source.merge();
	  },

	  lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
	    return '\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    '.trim();
	  },

	  // [blockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // On stack, after: return value of blockHelperMissing
	  //
	  // The purpose of this opcode is to take a block of the form
	  // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
	  // replace it on the stack with the result of properly
	  // invoking blockHelperMissing.
	  blockValue: function blockValue(name) {
	    var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs(name, 0, params);

	    var blockName = this.popStack();
	    params.splice(1, 0, blockName);

	    this.push(this.source.functionCall(blockHelperMissing, 'call', params));
	  },

	  // [ambiguousBlockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // Compiler value, before: lastHelper=value of last found helper, if any
	  // On stack, after, if no lastHelper: same as [blockValue]
	  // On stack, after, if lastHelper: value
	  ambiguousBlockValue: function ambiguousBlockValue() {
	    // We're being a bit cheeky and reusing the options value from the prior exec
	    var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs('', 0, params, true);

	    this.flushInline();

	    var current = this.topStack();
	    params.splice(1, 0, current);

	    this.pushSource(['if (!', this.lastHelper, ') { ', current, ' = ', this.source.functionCall(blockHelperMissing, 'call', params), '}']);
	  },

	  // [appendContent]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  //
	  // Appends the string value of `content` to the current buffer
	  appendContent: function appendContent(content) {
	    if (this.pendingContent) {
	      content = this.pendingContent + content;
	    } else {
	      this.pendingLocation = this.source.currentLocation;
	    }

	    this.pendingContent = content;
	  },

	  // [append]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Coerces `value` to a String and appends it to the current buffer.
	  //
	  // If `value` is truthy, or 0, it is coerced into a string and appended
	  // Otherwise, the empty string is appended
	  append: function append() {
	    if (this.isInline()) {
	      this.replaceStack(function (current) {
	        return [' != null ? ', current, ' : ""'];
	      });

	      this.pushSource(this.appendToBuffer(this.popStack()));
	    } else {
	      var local = this.popStack();
	      this.pushSource(['if (', local, ' != null) { ', this.appendToBuffer(local, undefined, true), ' }']);
	      if (this.environment.isSimple) {
	        this.pushSource(['else { ', this.appendToBuffer("''", undefined, true), ' }']);
	      }
	    }
	  },

	  // [appendEscaped]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Escape `value` and append it to the buffer
	  appendEscaped: function appendEscaped() {
	    this.pushSource(this.appendToBuffer([this.aliasable('container.escapeExpression'), '(', this.popStack(), ')']));
	  },

	  // [getContext]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  // Compiler value, after: lastContext=depth
	  //
	  // Set the value of the `lastContext` compiler value to the depth
	  getContext: function getContext(depth) {
	    this.lastContext = depth;
	  },

	  // [pushContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext, ...
	  //
	  // Pushes the value of the current context onto the stack.
	  pushContext: function pushContext() {
	    this.pushStackLiteral(this.contextName(this.lastContext));
	  },

	  // [lookupOnContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext[name], ...
	  //
	  // Looks up the value of `name` on the current context and pushes
	  // it onto the stack.
	  lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
	    var i = 0;

	    if (!scoped && this.options.compat && !this.lastContext) {
	      // The depthed query is expected to handle the undefined logic for the root level that
	      // is implemented below, so we evaluate that directly in compat mode
	      this.push(this.depthedLookup(parts[i++]));
	    } else {
	      this.pushContext();
	    }

	    this.resolvePath('context', parts, i, falsy, strict);
	  },

	  // [lookupBlockParam]
	  //
	  // On stack, before: ...
	  // On stack, after: blockParam[name], ...
	  //
	  // Looks up the value of `parts` on the given block param and pushes
	  // it onto the stack.
	  lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
	    this.useBlockParams = true;

	    this.push(['blockParams[', blockParamId[0], '][', blockParamId[1], ']']);
	    this.resolvePath('context', parts, 1);
	  },

	  // [lookupData]
	  //
	  // On stack, before: ...
	  // On stack, after: data, ...
	  //
	  // Push the data lookup operator
	  lookupData: function lookupData(depth, parts, strict) {
	    if (!depth) {
	      this.pushStackLiteral('data');
	    } else {
	      this.pushStackLiteral('container.data(data, ' + depth + ')');
	    }

	    this.resolvePath('data', parts, 0, true, strict);
	  },

	  resolvePath: function resolvePath(type, parts, i, falsy, strict) {
	    // istanbul ignore next

	    var _this2 = this;

	    if (this.options.strict || this.options.assumeObjects) {
	      this.push(strictLookup(this.options.strict && strict, this, parts, type));
	      return;
	    }

	    var len = parts.length;
	    for (; i < len; i++) {
	      /* eslint-disable no-loop-func */
	      this.replaceStack(function (current) {
	        var lookup = _this2.nameLookup(current, parts[i], type);
	        // We want to ensure that zero and false are handled properly if the context (falsy flag)
	        // needs to have the special handling for these values.
	        if (!falsy) {
	          return [' != null ? ', lookup, ' : ', current];
	        } else {
	          // Otherwise we can use generic falsy handling
	          return [' && ', lookup];
	        }
	      });
	      /* eslint-enable no-loop-func */
	    }
	  },

	  // [resolvePossibleLambda]
	  //
	  // On stack, before: value, ...
	  // On stack, after: resolved value, ...
	  //
	  // If the `value` is a lambda, replace it on the stack by
	  // the return value of the lambda
	  resolvePossibleLambda: function resolvePossibleLambda() {
	    this.push([this.aliasable('container.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
	  },

	  // [pushStringParam]
	  //
	  // On stack, before: ...
	  // On stack, after: string, currentContext, ...
	  //
	  // This opcode is designed for use in string mode, which
	  // provides the string value of a parameter along with its
	  // depth rather than resolving it immediately.
	  pushStringParam: function pushStringParam(string, type) {
	    this.pushContext();
	    this.pushString(type);

	    // If it's a subexpression, the string result
	    // will be pushed after this opcode.
	    if (type !== 'SubExpression') {
	      if (typeof string === 'string') {
	        this.pushString(string);
	      } else {
	        this.pushStackLiteral(string);
	      }
	    }
	  },

	  emptyHash: function emptyHash(omitEmpty) {
	    if (this.trackIds) {
	      this.push('{}'); // hashIds
	    }
	    if (this.stringParams) {
	      this.push('{}'); // hashContexts
	      this.push('{}'); // hashTypes
	    }
	    this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
	  },
	  pushHash: function pushHash() {
	    if (this.hash) {
	      this.hashes.push(this.hash);
	    }
	    this.hash = { values: {}, types: [], contexts: [], ids: [] };
	  },
	  popHash: function popHash() {
	    var hash = this.hash;
	    this.hash = this.hashes.pop();

	    if (this.trackIds) {
	      this.push(this.objectLiteral(hash.ids));
	    }
	    if (this.stringParams) {
	      this.push(this.objectLiteral(hash.contexts));
	      this.push(this.objectLiteral(hash.types));
	    }

	    this.push(this.objectLiteral(hash.values));
	  },

	  // [pushString]
	  //
	  // On stack, before: ...
	  // On stack, after: quotedString(string), ...
	  //
	  // Push a quoted version of `string` onto the stack
	  pushString: function pushString(string) {
	    this.pushStackLiteral(this.quotedString(string));
	  },

	  // [pushLiteral]
	  //
	  // On stack, before: ...
	  // On stack, after: value, ...
	  //
	  // Pushes a value onto the stack. This operation prevents
	  // the compiler from creating a temporary variable to hold
	  // it.
	  pushLiteral: function pushLiteral(value) {
	    this.pushStackLiteral(value);
	  },

	  // [pushProgram]
	  //
	  // On stack, before: ...
	  // On stack, after: program(guid), ...
	  //
	  // Push a program expression onto the stack. This takes
	  // a compile-time guid and converts it into a runtime-accessible
	  // expression.
	  pushProgram: function pushProgram(guid) {
	    if (guid != null) {
	      this.pushStackLiteral(this.programExpression(guid));
	    } else {
	      this.pushStackLiteral(null);
	    }
	  },

	  // [registerDecorator]
	  //
	  // On stack, before: hash, program, params..., ...
	  // On stack, after: ...
	  //
	  // Pops off the decorator's parameters, invokes the decorator,
	  // and inserts the decorator into the decorators list.
	  registerDecorator: function registerDecorator(paramSize, name) {
	    var foundDecorator = this.nameLookup('decorators', name, 'decorator'),
	        options = this.setupHelperArgs(name, paramSize);

	    this.decorators.push(['fn = ', this.decorators.functionCall(foundDecorator, '', ['fn', 'props', 'container', options]), ' || fn;']);
	  },

	  // [invokeHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // Pops off the helper's parameters, invokes the helper,
	  // and pushes the helper's return value onto the stack.
	  //
	  // If the helper is not found, `helperMissing` is called.
	  invokeHelper: function invokeHelper(paramSize, name, isSimple) {
	    var nonHelper = this.popStack(),
	        helper = this.setupHelper(paramSize, name);

	    var possibleFunctionCalls = [];

	    if (isSimple) {
	      // direct call to helper
	      possibleFunctionCalls.push(helper.name);
	    }
	    // call a function from the input object
	    possibleFunctionCalls.push(nonHelper);
	    if (!this.options.strict) {
	      possibleFunctionCalls.push(this.aliasable('container.hooks.helperMissing'));
	    }

	    var functionLookupCode = ['(', this.itemsSeparatedBy(possibleFunctionCalls, '||'), ')'];
	    var functionCall = this.source.functionCall(functionLookupCode, 'call', helper.callParams);
	    this.push(functionCall);
	  },

	  itemsSeparatedBy: function itemsSeparatedBy(items, separator) {
	    var result = [];
	    result.push(items[0]);
	    for (var i = 1; i < items.length; i++) {
	      result.push(separator, items[i]);
	    }
	    return result;
	  },
	  // [invokeKnownHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // This operation is used when the helper is known to exist,
	  // so a `helperMissing` fallback is not required.
	  invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
	    var helper = this.setupHelper(paramSize, name);
	    this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
	  },

	  // [invokeAmbiguous]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of disambiguation
	  //
	  // This operation is used when an expression like `{{foo}}`
	  // is provided, but we don't know at compile-time whether it
	  // is a helper or a path.
	  //
	  // This operation emits more code than the other options,
	  // and can be avoided by passing the `knownHelpers` and
	  // `knownHelpersOnly` flags at compile-time.
	  invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
	    this.useRegister('helper');

	    var nonHelper = this.popStack();

	    this.emptyHash();
	    var helper = this.setupHelper(0, name, helperCall);

	    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

	    var lookup = ['(', '(helper = ', helperName, ' || ', nonHelper, ')'];
	    if (!this.options.strict) {
	      lookup[0] = '(helper = ';
	      lookup.push(' != null ? helper : ', this.aliasable('container.hooks.helperMissing'));
	    }

	    this.push(['(', lookup, helper.paramsInit ? ['),(', helper.paramsInit] : [], '),', '(typeof helper === ', this.aliasable('"function"'), ' ? ', this.source.functionCall('helper', 'call', helper.callParams), ' : helper))']);
	  },

	  // [invokePartial]
	  //
	  // On stack, before: context, ...
	  // On stack after: result of partial invocation
	  //
	  // This operation pops off a context, invokes a partial with that context,
	  // and pushes the result of the invocation back.
	  invokePartial: function invokePartial(isDynamic, name, indent) {
	    var params = [],
	        options = this.setupParams(name, 1, params);

	    if (isDynamic) {
	      name = this.popStack();
	      delete options.name;
	    }

	    if (indent) {
	      options.indent = JSON.stringify(indent);
	    }
	    options.helpers = 'helpers';
	    options.partials = 'partials';
	    options.decorators = 'container.decorators';

	    if (!isDynamic) {
	      params.unshift(this.nameLookup('partials', name, 'partial'));
	    } else {
	      params.unshift(name);
	    }

	    if (this.options.compat) {
	      options.depths = 'depths';
	    }
	    options = this.objectLiteral(options);
	    params.push(options);

	    this.push(this.source.functionCall('container.invokePartial', '', params));
	  },

	  // [assignToHash]
	  //
	  // On stack, before: value, ..., hash, ...
	  // On stack, after: ..., hash, ...
	  //
	  // Pops a value off the stack and assigns it to the current hash
	  assignToHash: function assignToHash(key) {
	    var value = this.popStack(),
	        context = undefined,
	        type = undefined,
	        id = undefined;

	    if (this.trackIds) {
	      id = this.popStack();
	    }
	    if (this.stringParams) {
	      type = this.popStack();
	      context = this.popStack();
	    }

	    var hash = this.hash;
	    if (context) {
	      hash.contexts[key] = context;
	    }
	    if (type) {
	      hash.types[key] = type;
	    }
	    if (id) {
	      hash.ids[key] = id;
	    }
	    hash.values[key] = value;
	  },

	  pushId: function pushId(type, name, child) {
	    if (type === 'BlockParam') {
	      this.pushStackLiteral('blockParams[' + name[0] + '].path[' + name[1] + ']' + (child ? ' + ' + JSON.stringify('.' + child) : ''));
	    } else if (type === 'PathExpression') {
	      this.pushString(name);
	    } else if (type === 'SubExpression') {
	      this.pushStackLiteral('true');
	    } else {
	      this.pushStackLiteral('null');
	    }
	  },

	  // HELPERS

	  compiler: JavaScriptCompiler,

	  compileChildren: function compileChildren(environment, options) {
	    var children = environment.children,
	        child = undefined,
	        compiler = undefined;

	    for (var i = 0, l = children.length; i < l; i++) {
	      child = children[i];
	      compiler = new this.compiler(); // eslint-disable-line new-cap

	      var existing = this.matchExistingProgram(child);

	      if (existing == null) {
	        this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children
	        var index = this.context.programs.length;
	        child.index = index;
	        child.name = 'program' + index;
	        this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
	        this.context.decorators[index] = compiler.decorators;
	        this.context.environments[index] = child;

	        this.useDepths = this.useDepths || compiler.useDepths;
	        this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
	        child.useDepths = this.useDepths;
	        child.useBlockParams = this.useBlockParams;
	      } else {
	        child.index = existing.index;
	        child.name = 'program' + existing.index;

	        this.useDepths = this.useDepths || existing.useDepths;
	        this.useBlockParams = this.useBlockParams || existing.useBlockParams;
	      }
	    }
	  },
	  matchExistingProgram: function matchExistingProgram(child) {
	    for (var i = 0, len = this.context.environments.length; i < len; i++) {
	      var environment = this.context.environments[i];
	      if (environment && environment.equals(child)) {
	        return environment;
	      }
	    }
	  },

	  programExpression: function programExpression(guid) {
	    var child = this.environment.children[guid],
	        programParams = [child.index, 'data', child.blockParams];

	    if (this.useBlockParams || this.useDepths) {
	      programParams.push('blockParams');
	    }
	    if (this.useDepths) {
	      programParams.push('depths');
	    }

	    return 'container.program(' + programParams.join(', ') + ')';
	  },

	  useRegister: function useRegister(name) {
	    if (!this.registers[name]) {
	      this.registers[name] = true;
	      this.registers.list.push(name);
	    }
	  },

	  push: function push(expr) {
	    if (!(expr instanceof Literal)) {
	      expr = this.source.wrap(expr);
	    }

	    this.inlineStack.push(expr);
	    return expr;
	  },

	  pushStackLiteral: function pushStackLiteral(item) {
	    this.push(new Literal(item));
	  },

	  pushSource: function pushSource(source) {
	    if (this.pendingContent) {
	      this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
	      this.pendingContent = undefined;
	    }

	    if (source) {
	      this.source.push(source);
	    }
	  },

	  replaceStack: function replaceStack(callback) {
	    var prefix = ['('],
	        stack = undefined,
	        createdStack = undefined,
	        usedLiteral = undefined;

	    /* istanbul ignore next */
	    if (!this.isInline()) {
	      throw new _exception2['default']('replaceStack on non-inline');
	    }

	    // We want to merge the inline statement into the replacement statement via ','
	    var top = this.popStack(true);

	    if (top instanceof Literal) {
	      // Literals do not need to be inlined
	      stack = [top.value];
	      prefix = ['(', stack];
	      usedLiteral = true;
	    } else {
	      // Get or create the current stack name for use by the inline
	      createdStack = true;
	      var _name = this.incrStack();

	      prefix = ['((', this.push(_name), ' = ', top, ')'];
	      stack = this.topStack();
	    }

	    var item = callback.call(this, stack);

	    if (!usedLiteral) {
	      this.popStack();
	    }
	    if (createdStack) {
	      this.stackSlot--;
	    }
	    this.push(prefix.concat(item, ')'));
	  },

	  incrStack: function incrStack() {
	    this.stackSlot++;
	    if (this.stackSlot > this.stackVars.length) {
	      this.stackVars.push('stack' + this.stackSlot);
	    }
	    return this.topStackName();
	  },
	  topStackName: function topStackName() {
	    return 'stack' + this.stackSlot;
	  },
	  flushInline: function flushInline() {
	    var inlineStack = this.inlineStack;
	    this.inlineStack = [];
	    for (var i = 0, len = inlineStack.length; i < len; i++) {
	      var entry = inlineStack[i];
	      /* istanbul ignore if */
	      if (entry instanceof Literal) {
	        this.compileStack.push(entry);
	      } else {
	        var stack = this.incrStack();
	        this.pushSource([stack, ' = ', entry, ';']);
	        this.compileStack.push(stack);
	      }
	    }
	  },
	  isInline: function isInline() {
	    return this.inlineStack.length;
	  },

	  popStack: function popStack(wrapped) {
	    var inline = this.isInline(),
	        item = (inline ? this.inlineStack : this.compileStack).pop();

	    if (!wrapped && item instanceof Literal) {
	      return item.value;
	    } else {
	      if (!inline) {
	        /* istanbul ignore next */
	        if (!this.stackSlot) {
	          throw new _exception2['default']('Invalid stack pop');
	        }
	        this.stackSlot--;
	      }
	      return item;
	    }
	  },

	  topStack: function topStack() {
	    var stack = this.isInline() ? this.inlineStack : this.compileStack,
	        item = stack[stack.length - 1];

	    /* istanbul ignore if */
	    if (item instanceof Literal) {
	      return item.value;
	    } else {
	      return item;
	    }
	  },

	  contextName: function contextName(context) {
	    if (this.useDepths && context) {
	      return 'depths[' + context + ']';
	    } else {
	      return 'depth' + context;
	    }
	  },

	  quotedString: function quotedString(str) {
	    return this.source.quotedString(str);
	  },

	  objectLiteral: function objectLiteral(obj) {
	    return this.source.objectLiteral(obj);
	  },

	  aliasable: function aliasable(name) {
	    var ret = this.aliases[name];
	    if (ret) {
	      ret.referenceCount++;
	      return ret;
	    }

	    ret = this.aliases[name] = this.source.wrap(name);
	    ret.aliasable = true;
	    ret.referenceCount = 1;

	    return ret;
	  },

	  setupHelper: function setupHelper(paramSize, name, blockHelper) {
	    var params = [],
	        paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
	    var foundHelper = this.nameLookup('helpers', name, 'helper'),
	        callContext = this.aliasable(this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : (container.nullContext || {})');

	    return {
	      params: params,
	      paramsInit: paramsInit,
	      name: foundHelper,
	      callParams: [callContext].concat(params)
	    };
	  },

	  setupParams: function setupParams(helper, paramSize, params) {
	    var options = {},
	        contexts = [],
	        types = [],
	        ids = [],
	        objectArgs = !params,
	        param = undefined;

	    if (objectArgs) {
	      params = [];
	    }

	    options.name = this.quotedString(helper);
	    options.hash = this.popStack();

	    if (this.trackIds) {
	      options.hashIds = this.popStack();
	    }
	    if (this.stringParams) {
	      options.hashTypes = this.popStack();
	      options.hashContexts = this.popStack();
	    }

	    var inverse = this.popStack(),
	        program = this.popStack();

	    // Avoid setting fn and inverse if neither are set. This allows
	    // helpers to do a check for `if (options.fn)`
	    if (program || inverse) {
	      options.fn = program || 'container.noop';
	      options.inverse = inverse || 'container.noop';
	    }

	    // The parameters go on to the stack in order (making sure that they are evaluated in order)
	    // so we need to pop them off the stack in reverse order
	    var i = paramSize;
	    while (i--) {
	      param = this.popStack();
	      params[i] = param;

	      if (this.trackIds) {
	        ids[i] = this.popStack();
	      }
	      if (this.stringParams) {
	        types[i] = this.popStack();
	        contexts[i] = this.popStack();
	      }
	    }

	    if (objectArgs) {
	      options.args = this.source.generateArray(params);
	    }

	    if (this.trackIds) {
	      options.ids = this.source.generateArray(ids);
	    }
	    if (this.stringParams) {
	      options.types = this.source.generateArray(types);
	      options.contexts = this.source.generateArray(contexts);
	    }

	    if (this.options.data) {
	      options.data = 'data';
	    }
	    if (this.useBlockParams) {
	      options.blockParams = 'blockParams';
	    }
	    return options;
	  },

	  setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
	    var options = this.setupParams(helper, paramSize, params);
	    options.loc = JSON.stringify(this.source.currentLocation);
	    options = this.objectLiteral(options);
	    if (useRegister) {
	      this.useRegister('options');
	      params.push('options');
	      return ['options=', options];
	    } else if (params) {
	      params.push(options);
	      return '';
	    } else {
	      return options;
	    }
	  }
	};

	(function () {
	  var reservedWords = ('break else new var' + ' case finally return void' + ' catch for switch while' + ' continue function this with' + ' default if throw' + ' delete in try' + ' do instanceof typeof' + ' abstract enum int short' + ' boolean export interface static' + ' byte extends long super' + ' char final native synchronized' + ' class float package throws' + ' const goto private transient' + ' debugger implements protected volatile' + ' double import public let yield await' + ' null true false').split(' ');

	  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

	  for (var i = 0, l = reservedWords.length; i < l; i++) {
	    compilerWords[reservedWords[i]] = true;
	  }
	})();

	/**
	 * @deprecated May be removed in the next major version
	 */
	JavaScriptCompiler.isValidJavaScriptVariableName = function (name) {
	  return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
	};

	function strictLookup(requireTerminal, compiler, parts, type) {
	  var stack = compiler.popStack(),
	      i = 0,
	      len = parts.length;
	  if (requireTerminal) {
	    len--;
	  }

	  for (; i < len; i++) {
	    stack = compiler.nameLookup(stack, parts[i], type);
	  }

	  if (requireTerminal) {
	    return [compiler.aliasable('container.strict'), '(', stack, ', ', compiler.quotedString(parts[i]), ', ', JSON.stringify(compiler.source.currentLocation), ' )'];
	  } else {
	    return stack;
	  }
	}

	exports['default'] = JavaScriptCompiler;
	module.exports = exports['default'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* global define */
	'use strict';

	var _Object$keys = __webpack_require__(13)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var SourceNode = undefined;

	try {
	  /* istanbul ignore next */
	  if (false) {
	    // We don't support this in AMD environments. For these environments, we asusme that
	    // they are running on the browser and thus have no need for the source-map library.
	    var SourceMap = require('source-map');
	    SourceNode = SourceMap.SourceNode;
	  }
	} catch (err) {}
	/* NOP */

	/* istanbul ignore if: tested but not covered in istanbul due to dist build  */
	if (!SourceNode) {
	  SourceNode = function (line, column, srcFile, chunks) {
	    this.src = '';
	    if (chunks) {
	      this.add(chunks);
	    }
	  };
	  /* istanbul ignore next */
	  SourceNode.prototype = {
	    add: function add(chunks) {
	      if (_utils.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src += chunks;
	    },
	    prepend: function prepend(chunks) {
	      if (_utils.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src = chunks + this.src;
	    },
	    toStringWithSourceMap: function toStringWithSourceMap() {
	      return { code: this.toString() };
	    },
	    toString: function toString() {
	      return this.src;
	    }
	  };
	}

	function castChunk(chunk, codeGen, loc) {
	  if (_utils.isArray(chunk)) {
	    var ret = [];

	    for (var i = 0, len = chunk.length; i < len; i++) {
	      ret.push(codeGen.wrap(chunk[i], loc));
	    }
	    return ret;
	  } else if (typeof chunk === 'boolean' || typeof chunk === 'number') {
	    // Handle primitives that the SourceNode will throw up on
	    return chunk + '';
	  }
	  return chunk;
	}

	function CodeGen(srcFile) {
	  this.srcFile = srcFile;
	  this.source = [];
	}

	CodeGen.prototype = {
	  isEmpty: function isEmpty() {
	    return !this.source.length;
	  },
	  prepend: function prepend(source, loc) {
	    this.source.unshift(this.wrap(source, loc));
	  },
	  push: function push(source, loc) {
	    this.source.push(this.wrap(source, loc));
	  },

	  merge: function merge() {
	    var source = this.empty();
	    this.each(function (line) {
	      source.add(['  ', line, '\n']);
	    });
	    return source;
	  },

	  each: function each(iter) {
	    for (var i = 0, len = this.source.length; i < len; i++) {
	      iter(this.source[i]);
	    }
	  },

	  empty: function empty() {
	    var loc = this.currentLocation || { start: {} };
	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
	  },
	  wrap: function wrap(chunk) {
	    var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || { start: {} } : arguments[1];

	    if (chunk instanceof SourceNode) {
	      return chunk;
	    }

	    chunk = castChunk(chunk, this, loc);

	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
	  },

	  functionCall: function functionCall(fn, type, params) {
	    params = this.generateList(params);
	    return this.wrap([fn, type ? '.' + type + '(' : '(', params, ')']);
	  },

	  quotedString: function quotedString(str) {
	    return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028') // Per Ecma-262 7.3 + 7.8.4
	    .replace(/\u2029/g, '\\u2029') + '"';
	  },

	  objectLiteral: function objectLiteral(obj) {
	    // istanbul ignore next

	    var _this = this;

	    var pairs = [];

	    _Object$keys(obj).forEach(function (key) {
	      var value = castChunk(obj[key], _this);
	      if (value !== 'undefined') {
	        pairs.push([_this.quotedString(key), ':', value]);
	      }
	    });

	    var ret = this.generateList(pairs);
	    ret.prepend('{');
	    ret.add('}');
	    return ret;
	  },

	  generateList: function generateList(entries) {
	    var ret = this.empty();

	    for (var i = 0, len = entries.length; i < len; i++) {
	      if (i) {
	        ret.add(',');
	      }

	      ret.add(castChunk(entries[i], this));
	    }

	    return ret;
	  },

	  generateArray: function generateArray(entries) {
	    var ret = this.generateList(entries);
	    ret.prepend('[');
	    ret.add(']');

	    return ret;
	  }
	};

	exports['default'] = CodeGen;
	module.exports = exports['default'];

/***/ })
/******/ ])
});
;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(12).document;
module.exports = document && document.documentElement;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(23);
var toObject = __webpack_require__(28);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(38);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(41);
var createDesc = __webpack_require__(29);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(54);
var has = __webpack_require__(23);
var IE8_DOM_DEFINE = __webpack_require__(80);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(18) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(22);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(30);
var ITERATOR = __webpack_require__(11)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(87);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(30);
module.exports = __webpack_require__(8).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(11)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(146), __esModule: true };

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(122), __esModule: true };

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
__webpack_require__(83);
module.exports = __webpack_require__(60).f('iterator');


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(51);
var defined = __webpack_require__(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(55);
var descriptor = __webpack_require__(29);
var setToStringTag = __webpack_require__(40);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(21)(IteratorPrototype, __webpack_require__(11)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(22);
var getKeys = __webpack_require__(34);

module.exports = __webpack_require__(18) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(25);
var toLength = __webpack_require__(56);
var toAbsoluteIndex = __webpack_require__(127);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(51);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(129);
var step = __webpack_require__(100);
var Iterators = __webpack_require__(30);
var toIObject = __webpack_require__(25);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(67)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(131), __esModule: true };

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(132);
__webpack_require__(86);
__webpack_require__(135);
__webpack_require__(136);
module.exports = __webpack_require__(8).Symbol;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(12);
var has = __webpack_require__(23);
var DESCRIPTORS = __webpack_require__(18);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(81);
var META = __webpack_require__(84).KEY;
var $fails = __webpack_require__(24);
var shared = __webpack_require__(58);
var setToStringTag = __webpack_require__(40);
var uid = __webpack_require__(39);
var wks = __webpack_require__(11);
var wksExt = __webpack_require__(60);
var wksDefine = __webpack_require__(61);
var enumKeys = __webpack_require__(133);
var isArray = __webpack_require__(101);
var anObject = __webpack_require__(22);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(28);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(54);
var createDesc = __webpack_require__(29);
var _create = __webpack_require__(55);
var gOPNExt = __webpack_require__(134);
var $GOPD = __webpack_require__(102);
var $GOPS = __webpack_require__(62);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(34);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(85).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(41).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(33)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(21)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(41);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(25);
var gOPN = __webpack_require__(85).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('asyncIterator');


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(61)('observable');


/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(53);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(21);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(317), __esModule: true };

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(15);
var core = __webpack_require__(8);
var fails = __webpack_require__(24);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(143), __esModule: true };

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(15);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(145) });


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(18);
var getKeys = __webpack_require__(34);
var gOPS = __webpack_require__(62);
var pIE = __webpack_require__(41);
var toObject = __webpack_require__(28);
var IObject = __webpack_require__(69);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(24)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(50);
__webpack_require__(147);
module.exports = __webpack_require__(8).Array.from;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(27);
var $export = __webpack_require__(15);
var toObject = __webpack_require__(28);
var call = __webpack_require__(103);
var isArrayIter = __webpack_require__(104);
var toLength = __webpack_require__(56);
var createProperty = __webpack_require__(148);
var getIterFn = __webpack_require__(105);

$export($export.S + $export.F * !__webpack_require__(106)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(29);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(168);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(22);
var aFunction = __webpack_require__(53);
var SPECIES = __webpack_require__(11)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(27);
var invoke = __webpack_require__(293);
var html = __webpack_require__(98);
var cel = __webpack_require__(68);
var global = __webpack_require__(12);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(38)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(22);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(138);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(12);
var core = __webpack_require__(8);
var dP = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(18);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(367), __esModule: true };

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// SCSS - Dependency
__webpack_require__(269);

// JS - Dependency
__webpack_require__(270);

// HBS - Base Layout
__webpack_require__(390);

// HBS - Pages
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(393);

// HBS - Components

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// const $ = require('jquery/dist/jquery.js');

// window.jQuery = $;
// window.$ = $;

var LazyLoadTempInstance = __webpack_require__(271);

CCL.lazyLoadInstance = new LazyLoadTempInstance();

__webpack_require__(272);
__webpack_require__(273);
__webpack_require__(277);
__webpack_require__(278);
__webpack_require__(279);
__webpack_require__(280);
__webpack_require__(281);
__webpack_require__(282);
__webpack_require__(283);
__webpack_require__(284);
__webpack_require__(285);
__webpack_require__(286);
__webpack_require__(298);
__webpack_require__(305);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(4);
__webpack_require__(308);
__webpack_require__(309);
__webpack_require__(310);
__webpack_require__(311);
__webpack_require__(312);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(316);
__webpack_require__(319);
__webpack_require__(320);
__webpack_require__(321);
__webpack_require__(322);
__webpack_require__(323);
__webpack_require__(324);
__webpack_require__(325);
__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(328);
__webpack_require__(329);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(332);
__webpack_require__(333);
__webpack_require__(334);
__webpack_require__(335);
__webpack_require__(336);
__webpack_require__(337);
__webpack_require__(338);
__webpack_require__(339);
__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(342);
__webpack_require__(343);
__webpack_require__(344);
__webpack_require__(345);
__webpack_require__(346);
__webpack_require__(347);
__webpack_require__(348);
__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(352);
__webpack_require__(353);
__webpack_require__(354);
__webpack_require__(355);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
__webpack_require__(359);
__webpack_require__(360);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(363);
__webpack_require__(364);
__webpack_require__(365);
__webpack_require__(366);
__webpack_require__(385);
__webpack_require__(386);
__webpack_require__(387);
__webpack_require__(388);
__webpack_require__(389);

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).LazyLoad=t()}(this,(function(){"use strict";function n(){return n=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i])}return n},n.apply(this,arguments)}var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),i=t&&"IntersectionObserver"in window,o=t&&"classList"in document.createElement("p"),a=t&&window.devicePixelRatio>1,r={elements_selector:".lazy",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_bg_set:"bg-set",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:!0,unobserve_entered:!1,cancel_on_exit:!0,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:!1,restore_on_error:!1},c=function(t){return n({},r,t)},l=function(n,t){var e,i="LazyLoad::Initialized",o=new n(t);try{e=new CustomEvent(i,{detail:{instance:o}})}catch(n){(e=document.createEvent("CustomEvent")).initCustomEvent(i,!1,!1,{instance:o})}window.dispatchEvent(e)},u="src",s="srcset",d="sizes",f="poster",_="llOriginalAttrs",g="data",v="loading",b="loaded",m="applied",p="error",h="native",E="data-",I="ll-status",y=function(n,t){return n.getAttribute(E+t)},k=function(n){return y(n,I)},w=function(n,t){return function(n,t,e){var i="data-ll-status";null!==e?n.setAttribute(i,e):n.removeAttribute(i)}(n,0,t)},A=function(n){return w(n,null)},L=function(n){return null===k(n)},O=function(n){return k(n)===h},x=[v,b,m,p],C=function(n,t,e,i){n&&(void 0===i?void 0===e?n(t):n(t,e):n(t,e,i))},N=function(n,t){o?n.classList.add(t):n.className+=(n.className?" ":"")+t},M=function(n,t){o?n.classList.remove(t):n.className=n.className.replace(new RegExp("(^|\\s+)"+t+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},z=function(n){return n.llTempImage},T=function(n,t){if(t){var e=t._observer;e&&e.unobserve(n)}},R=function(n,t){n&&(n.loadingCount+=t)},G=function(n,t){n&&(n.toLoadCount=t)},j=function(n){for(var t,e=[],i=0;t=n.children[i];i+=1)"SOURCE"===t.tagName&&e.push(t);return e},D=function(n,t){var e=n.parentNode;e&&"PICTURE"===e.tagName&&j(e).forEach(t)},H=function(n,t){j(n).forEach(t)},V=[u],F=[u,f],B=[u,s,d],J=[g],P=function(n){return!!n[_]},S=function(n){return n[_]},U=function(n){return delete n[_]},$=function(n,t){if(!P(n)){var e={};t.forEach((function(t){e[t]=n.getAttribute(t)})),n[_]=e}},q=function(n,t){if(P(n)){var e=S(n);t.forEach((function(t){!function(n,t,e){e?n.setAttribute(t,e):n.removeAttribute(t)}(n,t,e[t])}))}},K=function(n,t,e){N(n,t.class_applied),w(n,m),e&&(t.unobserve_completed&&T(n,t),C(t.callback_applied,n,e))},Q=function(n,t,e){N(n,t.class_loading),w(n,v),e&&(R(e,1),C(t.callback_loading,n,e))},W=function(n,t,e){e&&n.setAttribute(t,e)},X=function(n,t){W(n,d,y(n,t.data_sizes)),W(n,s,y(n,t.data_srcset)),W(n,u,y(n,t.data_src))},Y={IMG:function(n,t){D(n,(function(n){$(n,B),X(n,t)})),$(n,B),X(n,t)},IFRAME:function(n,t){$(n,V),W(n,u,y(n,t.data_src))},VIDEO:function(n,t){H(n,(function(n){$(n,V),W(n,u,y(n,t.data_src))})),$(n,F),W(n,f,y(n,t.data_poster)),W(n,u,y(n,t.data_src)),n.load()},OBJECT:function(n,t){$(n,J),W(n,g,y(n,t.data_src))}},Z=["IMG","IFRAME","VIDEO","OBJECT"],nn=function(n,t){!t||function(n){return n.loadingCount>0}(t)||function(n){return n.toLoadCount>0}(t)||C(n.callback_finish,t)},tn=function(n,t,e){n.addEventListener(t,e),n.llEvLisnrs[t]=e},en=function(n,t,e){n.removeEventListener(t,e)},on=function(n){return!!n.llEvLisnrs},an=function(n){if(on(n)){var t=n.llEvLisnrs;for(var e in t){var i=t[e];en(n,e,i)}delete n.llEvLisnrs}},rn=function(n,t,e){!function(n){delete n.llTempImage}(n),R(e,-1),function(n){n&&(n.toLoadCount-=1)}(e),M(n,t.class_loading),t.unobserve_completed&&T(n,e)},cn=function(n,t,e){var i=z(n)||n;on(i)||function(n,t,e){on(n)||(n.llEvLisnrs={});var i="VIDEO"===n.tagName?"loadeddata":"load";tn(n,i,t),tn(n,"error",e)}(i,(function(o){!function(n,t,e,i){var o=O(t);rn(t,e,i),N(t,e.class_loaded),w(t,b),C(e.callback_loaded,t,i),o||nn(e,i)}(0,n,t,e),an(i)}),(function(o){!function(n,t,e,i){var o=O(t);rn(t,e,i),N(t,e.class_error),w(t,p),C(e.callback_error,t,i),e.restore_on_error&&q(t,B),o||nn(e,i)}(0,n,t,e),an(i)}))},ln=function(n,t,e){!function(n){return Z.indexOf(n.tagName)>-1}(n)?function(n,t,e){!function(n){n.llTempImage=document.createElement("IMG")}(n),cn(n,t,e),function(n){P(n)||(n[_]={backgroundImage:n.style.backgroundImage})}(n),function(n,t,e){var i=y(n,t.data_bg),o=y(n,t.data_bg_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage='url("'.concat(r,'")'),z(n).setAttribute(u,r),Q(n,t,e))}(n,t,e),function(n,t,e){var i=y(n,t.data_bg_multi),o=y(n,t.data_bg_multi_hidpi),r=a&&o?o:i;r&&(n.style.backgroundImage=r,K(n,t,e))}(n,t,e),function(n,t,e){var i=y(n,t.data_bg_set);if(i){var o=i.split("|"),a=o.map((function(n){return"image-set(".concat(n,")")}));n.style.backgroundImage=a.join(),""===n.style.backgroundImage&&(a=o.map((function(n){return"-webkit-image-set(".concat(n,")")})),n.style.backgroundImage=a.join()),K(n,t,e)}}(n,t,e)}(n,t,e):function(n,t,e){cn(n,t,e),function(n,t,e){var i=Y[n.tagName];i&&(i(n,t),Q(n,t,e))}(n,t,e)}(n,t,e)},un=function(n){n.removeAttribute(u),n.removeAttribute(s),n.removeAttribute(d)},sn=function(n){D(n,(function(n){q(n,B)})),q(n,B)},dn={IMG:sn,IFRAME:function(n){q(n,V)},VIDEO:function(n){H(n,(function(n){q(n,V)})),q(n,F),n.load()},OBJECT:function(n){q(n,J)}},fn=function(n,t){(function(n){var t=dn[n.tagName];t?t(n):function(n){if(P(n)){var t=S(n);n.style.backgroundImage=t.backgroundImage}}(n)})(n),function(n,t){L(n)||O(n)||(M(n,t.class_entered),M(n,t.class_exited),M(n,t.class_applied),M(n,t.class_loading),M(n,t.class_loaded),M(n,t.class_error))}(n,t),A(n),U(n)},_n=["IMG","IFRAME","VIDEO"],gn=function(n){return n.use_native&&"loading"in HTMLImageElement.prototype},vn=function(n,t,e){n.forEach((function(n){return function(n){return n.isIntersecting||n.intersectionRatio>0}(n)?function(n,t,e,i){var o=function(n){return x.indexOf(k(n))>=0}(n);w(n,"entered"),N(n,e.class_entered),M(n,e.class_exited),function(n,t,e){t.unobserve_entered&&T(n,e)}(n,e,i),C(e.callback_enter,n,t,i),o||ln(n,e,i)}(n.target,n,t,e):function(n,t,e,i){L(n)||(N(n,e.class_exited),function(n,t,e,i){e.cancel_on_exit&&function(n){return k(n)===v}(n)&&"IMG"===n.tagName&&(an(n),function(n){D(n,(function(n){un(n)})),un(n)}(n),sn(n),M(n,e.class_loading),R(i,-1),A(n),C(e.callback_cancel,n,t,i))}(n,t,e,i),C(e.callback_exit,n,t,i))}(n.target,n,t,e)}))},bn=function(n){return Array.prototype.slice.call(n)},mn=function(n){return n.container.querySelectorAll(n.elements_selector)},pn=function(n){return function(n){return k(n)===p}(n)},hn=function(n,t){return function(n){return bn(n).filter(L)}(n||mn(t))},En=function(n,e){var o=c(n);this._settings=o,this.loadingCount=0,function(n,t){i&&!gn(n)&&(t._observer=new IntersectionObserver((function(e){vn(e,n,t)}),function(n){return{root:n.container===document?null:n.container,rootMargin:n.thresholds||n.threshold+"px"}}(n)))}(o,this),function(n,e){t&&(e._onlineHandler=function(){!function(n,t){var e;(e=mn(n),bn(e).filter(pn)).forEach((function(t){M(t,n.class_error),A(t)})),t.update()}(n,e)},window.addEventListener("online",e._onlineHandler))}(o,this),this.update(e)};return En.prototype={update:function(n){var t,o,a=this._settings,r=hn(n,a);G(this,r.length),!e&&i?gn(a)?function(n,t,e){n.forEach((function(n){-1!==_n.indexOf(n.tagName)&&function(n,t,e){n.setAttribute("loading","lazy"),cn(n,t,e),function(n,t){var e=Y[n.tagName];e&&e(n,t)}(n,t),w(n,h)}(n,t,e)})),G(e,0)}(r,a,this):(o=r,function(n){n.disconnect()}(t=this._observer),function(n,t){t.forEach((function(t){n.observe(t)}))}(t,o)):this.loadAll(r)},destroy:function(){this._observer&&this._observer.disconnect(),t&&window.removeEventListener("online",this._onlineHandler),mn(this._settings).forEach((function(n){U(n)})),delete this._observer,delete this._settings,delete this._onlineHandler,delete this.loadingCount,delete this.toLoadCount},loadAll:function(n){var t=this,e=this._settings;hn(n,e).forEach((function(n){T(n,t),ln(n,e,t)}))},restoreAll:function(){var n=this._settings;mn(n).forEach((function(t){fn(t,n)}))}},En.load=function(n,t){var e=c(t);ln(n,e)},En.resetStatus=function(n){A(n)},t&&function(n,t){if(t)if(t.length)for(var e,i=0;e=t[i];i+=1)l(n,e);else l(n,t)}(En,window.lazyLoadOptions),En}));


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
!function(t,e){ true?e(exports,__webpack_require__(3),__webpack_require__(120)):"function"==typeof define&&define.amd?define(["exports","jquery","popper.js"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).bootstrap={},t.jQuery,t.Popper)}(this,(function(t,e,n){"use strict";function i(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var o=i(e),a=i(n);function s(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function l(t,e,n){return e&&s(t.prototype,e),n&&s(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function r(){return r=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t},r.apply(this,arguments)}function u(t,e){return u=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},u(t,e)}var f="transitionend";var d={TRANSITION_END:"bsTransitionEnd",getUID:function(t){do{t+=~~(1e6*Math.random())}while(document.getElementById(t));return t},getSelectorFromElement:function(t){var e=t.getAttribute("data-target");if(!e||"#"===e){var n=t.getAttribute("href");e=n&&"#"!==n?n.trim():""}try{return document.querySelector(e)?e:null}catch(t){return null}},getTransitionDurationFromElement:function(t){if(!t)return 0;var e=o.default(t).css("transition-duration"),n=o.default(t).css("transition-delay"),i=parseFloat(e),a=parseFloat(n);return i||a?(e=e.split(",")[0],n=n.split(",")[0],1e3*(parseFloat(e)+parseFloat(n))):0},reflow:function(t){return t.offsetHeight},triggerTransitionEnd:function(t){o.default(t).trigger(f)},supportsTransitionEnd:function(){return Boolean(f)},isElement:function(t){return(t[0]||t).nodeType},typeCheckConfig:function(t,e,n){for(var i in n)if(Object.prototype.hasOwnProperty.call(n,i)){var o=n[i],a=e[i],s=a&&d.isElement(a)?"element":null===(l=a)||"undefined"==typeof l?""+l:{}.toString.call(l).match(/\s([a-z]+)/i)[1].toLowerCase();if(!new RegExp(o).test(s))throw new Error(t.toUpperCase()+': Option "'+i+'" provided type "'+s+'" but expected type "'+o+'".')}var l},findShadowRoot:function(t){if(!document.documentElement.attachShadow)return null;if("function"==typeof t.getRootNode){var e=t.getRootNode();return e instanceof ShadowRoot?e:null}return t instanceof ShadowRoot?t:t.parentNode?d.findShadowRoot(t.parentNode):null},jQueryDetection:function(){if("undefined"==typeof o.default)throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");var t=o.default.fn.jquery.split(" ")[0].split(".");if(t[0]<2&&t[1]<9||1===t[0]&&9===t[1]&&t[2]<1||t[0]>=4)throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")}};d.jQueryDetection(),o.default.fn.emulateTransitionEnd=function(t){var e=this,n=!1;return o.default(this).one(d.TRANSITION_END,(function(){n=!0})),setTimeout((function(){n||d.triggerTransitionEnd(e)}),t),this},o.default.event.special[d.TRANSITION_END]={bindType:f,delegateType:f,handle:function(t){if(o.default(t.target).is(this))return t.handleObj.handler.apply(this,arguments)}};var c="bs.alert",h=o.default.fn.alert,g=function(){function t(t){this._element=t}var e=t.prototype;return e.close=function(t){var e=this._element;t&&(e=this._getRootElement(t)),this._triggerCloseEvent(e).isDefaultPrevented()||this._removeElement(e)},e.dispose=function(){o.default.removeData(this._element,c),this._element=null},e._getRootElement=function(t){var e=d.getSelectorFromElement(t),n=!1;return e&&(n=document.querySelector(e)),n||(n=o.default(t).closest(".alert")[0]),n},e._triggerCloseEvent=function(t){var e=o.default.Event("close.bs.alert");return o.default(t).trigger(e),e},e._removeElement=function(t){var e=this;if(o.default(t).removeClass("show"),o.default(t).hasClass("fade")){var n=d.getTransitionDurationFromElement(t);o.default(t).one(d.TRANSITION_END,(function(n){return e._destroyElement(t,n)})).emulateTransitionEnd(n)}else this._destroyElement(t)},e._destroyElement=function(t){o.default(t).detach().trigger("closed.bs.alert").remove()},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(c);i||(i=new t(this),n.data(c,i)),"close"===e&&i[e](this)}))},t._handleDismiss=function(t){return function(e){e&&e.preventDefault(),t.close(this)}},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();o.default(document).on("click.bs.alert.data-api",'[data-dismiss="alert"]',g._handleDismiss(new g)),o.default.fn.alert=g._jQueryInterface,o.default.fn.alert.Constructor=g,o.default.fn.alert.noConflict=function(){return o.default.fn.alert=h,g._jQueryInterface};var m="bs.button",p=o.default.fn.button,_="active",v='[data-toggle^="button"]',y='input:not([type="hidden"])',b=".btn",E=function(){function t(t){this._element=t,this.shouldAvoidTriggerChange=!1}var e=t.prototype;return e.toggle=function(){var t=!0,e=!0,n=o.default(this._element).closest('[data-toggle="buttons"]')[0];if(n){var i=this._element.querySelector(y);if(i){if("radio"===i.type)if(i.checked&&this._element.classList.contains(_))t=!1;else{var a=n.querySelector(".active");a&&o.default(a).removeClass(_)}t&&("checkbox"!==i.type&&"radio"!==i.type||(i.checked=!this._element.classList.contains(_)),this.shouldAvoidTriggerChange||o.default(i).trigger("change")),i.focus(),e=!1}}this._element.hasAttribute("disabled")||this._element.classList.contains("disabled")||(e&&this._element.setAttribute("aria-pressed",!this._element.classList.contains(_)),t&&o.default(this._element).toggleClass(_))},e.dispose=function(){o.default.removeData(this._element,m),this._element=null},t._jQueryInterface=function(e,n){return this.each((function(){var i=o.default(this),a=i.data(m);a||(a=new t(this),i.data(m,a)),a.shouldAvoidTriggerChange=n,"toggle"===e&&a[e]()}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();o.default(document).on("click.bs.button.data-api",v,(function(t){var e=t.target,n=e;if(o.default(e).hasClass("btn")||(e=o.default(e).closest(b)[0]),!e||e.hasAttribute("disabled")||e.classList.contains("disabled"))t.preventDefault();else{var i=e.querySelector(y);if(i&&(i.hasAttribute("disabled")||i.classList.contains("disabled")))return void t.preventDefault();"INPUT"!==n.tagName&&"LABEL"===e.tagName||E._jQueryInterface.call(o.default(e),"toggle","INPUT"===n.tagName)}})).on("focus.bs.button.data-api blur.bs.button.data-api",v,(function(t){var e=o.default(t.target).closest(b)[0];o.default(e).toggleClass("focus",/^focus(in)?$/.test(t.type))})),o.default(window).on("load.bs.button.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-toggle="buttons"] .btn')),e=0,n=t.length;e<n;e++){var i=t[e],o=i.querySelector(y);o.checked||o.hasAttribute("checked")?i.classList.add(_):i.classList.remove(_)}for(var a=0,s=(t=[].slice.call(document.querySelectorAll('[data-toggle="button"]'))).length;a<s;a++){var l=t[a];"true"===l.getAttribute("aria-pressed")?l.classList.add(_):l.classList.remove(_)}})),o.default.fn.button=E._jQueryInterface,o.default.fn.button.Constructor=E,o.default.fn.button.noConflict=function(){return o.default.fn.button=p,E._jQueryInterface};var T="carousel",w="bs.carousel",C=o.default.fn[T],S="active",N="next",D="prev",A="slid.bs.carousel",I=".active.carousel-item",k={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0,touch:!0},O={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean",touch:"boolean"},j={TOUCH:"touch",PEN:"pen"},P=function(){function t(t,e){this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this.touchTimeout=null,this.touchStartX=0,this.touchDeltaX=0,this._config=this._getConfig(e),this._element=t,this._indicatorsElement=this._element.querySelector(".carousel-indicators"),this._touchSupported="ontouchstart"in document.documentElement||navigator.maxTouchPoints>0,this._pointerEvent=Boolean(window.PointerEvent||window.MSPointerEvent),this._addEventListeners()}var e=t.prototype;return e.next=function(){this._isSliding||this._slide(N)},e.nextWhenVisible=function(){var t=o.default(this._element);!document.hidden&&t.is(":visible")&&"hidden"!==t.css("visibility")&&this.next()},e.prev=function(){this._isSliding||this._slide(D)},e.pause=function(t){t||(this._isPaused=!0),this._element.querySelector(".carousel-item-next, .carousel-item-prev")&&(d.triggerTransitionEnd(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null},e.cycle=function(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config.interval&&!this._isPaused&&(this._updateInterval(),this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))},e.to=function(t){var e=this;this._activeElement=this._element.querySelector(I);var n=this._getItemIndex(this._activeElement);if(!(t>this._items.length-1||t<0))if(this._isSliding)o.default(this._element).one(A,(function(){return e.to(t)}));else{if(n===t)return this.pause(),void this.cycle();var i=t>n?N:D;this._slide(i,this._items[t])}},e.dispose=function(){o.default(this._element).off(".bs.carousel"),o.default.removeData(this._element,w),this._items=null,this._config=null,this._element=null,this._interval=null,this._isPaused=null,this._isSliding=null,this._activeElement=null,this._indicatorsElement=null},e._getConfig=function(t){return t=r({},k,t),d.typeCheckConfig(T,t,O),t},e._handleSwipe=function(){var t=Math.abs(this.touchDeltaX);if(!(t<=40)){var e=t/this.touchDeltaX;this.touchDeltaX=0,e>0&&this.prev(),e<0&&this.next()}},e._addEventListeners=function(){var t=this;this._config.keyboard&&o.default(this._element).on("keydown.bs.carousel",(function(e){return t._keydown(e)})),"hover"===this._config.pause&&o.default(this._element).on("mouseenter.bs.carousel",(function(e){return t.pause(e)})).on("mouseleave.bs.carousel",(function(e){return t.cycle(e)})),this._config.touch&&this._addTouchEventListeners()},e._addTouchEventListeners=function(){var t=this;if(this._touchSupported){var e=function(e){t._pointerEvent&&j[e.originalEvent.pointerType.toUpperCase()]?t.touchStartX=e.originalEvent.clientX:t._pointerEvent||(t.touchStartX=e.originalEvent.touches[0].clientX)},n=function(e){t._pointerEvent&&j[e.originalEvent.pointerType.toUpperCase()]&&(t.touchDeltaX=e.originalEvent.clientX-t.touchStartX),t._handleSwipe(),"hover"===t._config.pause&&(t.pause(),t.touchTimeout&&clearTimeout(t.touchTimeout),t.touchTimeout=setTimeout((function(e){return t.cycle(e)}),500+t._config.interval))};o.default(this._element.querySelectorAll(".carousel-item img")).on("dragstart.bs.carousel",(function(t){return t.preventDefault()})),this._pointerEvent?(o.default(this._element).on("pointerdown.bs.carousel",(function(t){return e(t)})),o.default(this._element).on("pointerup.bs.carousel",(function(t){return n(t)})),this._element.classList.add("pointer-event")):(o.default(this._element).on("touchstart.bs.carousel",(function(t){return e(t)})),o.default(this._element).on("touchmove.bs.carousel",(function(e){return function(e){t.touchDeltaX=e.originalEvent.touches&&e.originalEvent.touches.length>1?0:e.originalEvent.touches[0].clientX-t.touchStartX}(e)})),o.default(this._element).on("touchend.bs.carousel",(function(t){return n(t)})))}},e._keydown=function(t){if(!/input|textarea/i.test(t.target.tagName))switch(t.which){case 37:t.preventDefault(),this.prev();break;case 39:t.preventDefault(),this.next()}},e._getItemIndex=function(t){return this._items=t&&t.parentNode?[].slice.call(t.parentNode.querySelectorAll(".carousel-item")):[],this._items.indexOf(t)},e._getItemByDirection=function(t,e){var n=t===N,i=t===D,o=this._getItemIndex(e),a=this._items.length-1;if((i&&0===o||n&&o===a)&&!this._config.wrap)return e;var s=(o+(t===D?-1:1))%this._items.length;return-1===s?this._items[this._items.length-1]:this._items[s]},e._triggerSlideEvent=function(t,e){var n=this._getItemIndex(t),i=this._getItemIndex(this._element.querySelector(I)),a=o.default.Event("slide.bs.carousel",{relatedTarget:t,direction:e,from:i,to:n});return o.default(this._element).trigger(a),a},e._setActiveIndicatorElement=function(t){if(this._indicatorsElement){var e=[].slice.call(this._indicatorsElement.querySelectorAll(".active"));o.default(e).removeClass(S);var n=this._indicatorsElement.children[this._getItemIndex(t)];n&&o.default(n).addClass(S)}},e._updateInterval=function(){var t=this._activeElement||this._element.querySelector(I);if(t){var e=parseInt(t.getAttribute("data-interval"),10);e?(this._config.defaultInterval=this._config.defaultInterval||this._config.interval,this._config.interval=e):this._config.interval=this._config.defaultInterval||this._config.interval}},e._slide=function(t,e){var n,i,a,s=this,l=this._element.querySelector(I),r=this._getItemIndex(l),u=e||l&&this._getItemByDirection(t,l),f=this._getItemIndex(u),c=Boolean(this._interval);if(t===N?(n="carousel-item-left",i="carousel-item-next",a="left"):(n="carousel-item-right",i="carousel-item-prev",a="right"),u&&o.default(u).hasClass(S))this._isSliding=!1;else if(!this._triggerSlideEvent(u,a).isDefaultPrevented()&&l&&u){this._isSliding=!0,c&&this.pause(),this._setActiveIndicatorElement(u),this._activeElement=u;var h=o.default.Event(A,{relatedTarget:u,direction:a,from:r,to:f});if(o.default(this._element).hasClass("slide")){o.default(u).addClass(i),d.reflow(u),o.default(l).addClass(n),o.default(u).addClass(n);var g=d.getTransitionDurationFromElement(l);o.default(l).one(d.TRANSITION_END,(function(){o.default(u).removeClass(n+" "+i).addClass(S),o.default(l).removeClass("active "+i+" "+n),s._isSliding=!1,setTimeout((function(){return o.default(s._element).trigger(h)}),0)})).emulateTransitionEnd(g)}else o.default(l).removeClass(S),o.default(u).addClass(S),this._isSliding=!1,o.default(this._element).trigger(h);c&&this.cycle()}},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this).data(w),i=r({},k,o.default(this).data());"object"==typeof e&&(i=r({},i,e));var a="string"==typeof e?e:i.slide;if(n||(n=new t(this,i),o.default(this).data(w,n)),"number"==typeof e)n.to(e);else if("string"==typeof a){if("undefined"==typeof n[a])throw new TypeError('No method named "'+a+'"');n[a]()}else i.interval&&i.ride&&(n.pause(),n.cycle())}))},t._dataApiClickHandler=function(e){var n=d.getSelectorFromElement(this);if(n){var i=o.default(n)[0];if(i&&o.default(i).hasClass("carousel")){var a=r({},o.default(i).data(),o.default(this).data()),s=this.getAttribute("data-slide-to");s&&(a.interval=!1),t._jQueryInterface.call(o.default(i),a),s&&o.default(i).data(w).to(s),e.preventDefault()}}},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return k}}]),t}();o.default(document).on("click.bs.carousel.data-api","[data-slide], [data-slide-to]",P._dataApiClickHandler),o.default(window).on("load.bs.carousel.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-ride="carousel"]')),e=0,n=t.length;e<n;e++){var i=o.default(t[e]);P._jQueryInterface.call(i,i.data())}})),o.default.fn[T]=P._jQueryInterface,o.default.fn[T].Constructor=P,o.default.fn[T].noConflict=function(){return o.default.fn[T]=C,P._jQueryInterface};var L="collapse",R="bs.collapse",x=o.default.fn[L],q="show",F="collapse",Q="collapsing",B="collapsed",H="width",U='[data-toggle="collapse"]',M={toggle:!0,parent:""},W={toggle:"boolean",parent:"(string|element)"},V=function(){function t(t,e){this._isTransitioning=!1,this._element=t,this._config=this._getConfig(e),this._triggerArray=[].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#'+t.id+'"],[data-toggle="collapse"][data-target="#'+t.id+'"]'));for(var n=[].slice.call(document.querySelectorAll(U)),i=0,o=n.length;i<o;i++){var a=n[i],s=d.getSelectorFromElement(a),l=[].slice.call(document.querySelectorAll(s)).filter((function(e){return e===t}));null!==s&&l.length>0&&(this._selector=s,this._triggerArray.push(a))}this._parent=this._config.parent?this._getParent():null,this._config.parent||this._addAriaAndCollapsedClass(this._element,this._triggerArray),this._config.toggle&&this.toggle()}var e=t.prototype;return e.toggle=function(){o.default(this._element).hasClass(q)?this.hide():this.show()},e.show=function(){var e,n,i=this;if(!(this._isTransitioning||o.default(this._element).hasClass(q)||(this._parent&&0===(e=[].slice.call(this._parent.querySelectorAll(".show, .collapsing")).filter((function(t){return"string"==typeof i._config.parent?t.getAttribute("data-parent")===i._config.parent:t.classList.contains(F)}))).length&&(e=null),e&&(n=o.default(e).not(this._selector).data(R))&&n._isTransitioning))){var a=o.default.Event("show.bs.collapse");if(o.default(this._element).trigger(a),!a.isDefaultPrevented()){e&&(t._jQueryInterface.call(o.default(e).not(this._selector),"hide"),n||o.default(e).data(R,null));var s=this._getDimension();o.default(this._element).removeClass(F).addClass(Q),this._element.style[s]=0,this._triggerArray.length&&o.default(this._triggerArray).removeClass(B).attr("aria-expanded",!0),this.setTransitioning(!0);var l="scroll"+(s[0].toUpperCase()+s.slice(1)),r=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,(function(){o.default(i._element).removeClass(Q).addClass("collapse show"),i._element.style[s]="",i.setTransitioning(!1),o.default(i._element).trigger("shown.bs.collapse")})).emulateTransitionEnd(r),this._element.style[s]=this._element[l]+"px"}}},e.hide=function(){var t=this;if(!this._isTransitioning&&o.default(this._element).hasClass(q)){var e=o.default.Event("hide.bs.collapse");if(o.default(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._getDimension();this._element.style[n]=this._element.getBoundingClientRect()[n]+"px",d.reflow(this._element),o.default(this._element).addClass(Q).removeClass("collapse show");var i=this._triggerArray.length;if(i>0)for(var a=0;a<i;a++){var s=this._triggerArray[a],l=d.getSelectorFromElement(s);null!==l&&(o.default([].slice.call(document.querySelectorAll(l))).hasClass(q)||o.default(s).addClass(B).attr("aria-expanded",!1))}this.setTransitioning(!0),this._element.style[n]="";var r=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,(function(){t.setTransitioning(!1),o.default(t._element).removeClass(Q).addClass(F).trigger("hidden.bs.collapse")})).emulateTransitionEnd(r)}}},e.setTransitioning=function(t){this._isTransitioning=t},e.dispose=function(){o.default.removeData(this._element,R),this._config=null,this._parent=null,this._element=null,this._triggerArray=null,this._isTransitioning=null},e._getConfig=function(t){return(t=r({},M,t)).toggle=Boolean(t.toggle),d.typeCheckConfig(L,t,W),t},e._getDimension=function(){return o.default(this._element).hasClass(H)?H:"height"},e._getParent=function(){var e,n=this;d.isElement(this._config.parent)?(e=this._config.parent,"undefined"!=typeof this._config.parent.jquery&&(e=this._config.parent[0])):e=document.querySelector(this._config.parent);var i='[data-toggle="collapse"][data-parent="'+this._config.parent+'"]',a=[].slice.call(e.querySelectorAll(i));return o.default(a).each((function(e,i){n._addAriaAndCollapsedClass(t._getTargetFromElement(i),[i])})),e},e._addAriaAndCollapsedClass=function(t,e){var n=o.default(t).hasClass(q);e.length&&o.default(e).toggleClass(B,!n).attr("aria-expanded",n)},t._getTargetFromElement=function(t){var e=d.getSelectorFromElement(t);return e?document.querySelector(e):null},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(R),a=r({},M,n.data(),"object"==typeof e&&e?e:{});if(!i&&a.toggle&&"string"==typeof e&&/show|hide/.test(e)&&(a.toggle=!1),i||(i=new t(this,a),n.data(R,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return M}}]),t}();o.default(document).on("click.bs.collapse.data-api",U,(function(t){"A"===t.currentTarget.tagName&&t.preventDefault();var e=o.default(this),n=d.getSelectorFromElement(this),i=[].slice.call(document.querySelectorAll(n));o.default(i).each((function(){var t=o.default(this),n=t.data(R)?"toggle":e.data();V._jQueryInterface.call(t,n)}))})),o.default.fn[L]=V._jQueryInterface,o.default.fn[L].Constructor=V,o.default.fn[L].noConflict=function(){return o.default.fn[L]=x,V._jQueryInterface};var z="dropdown",K="bs.dropdown",X=o.default.fn[z],Y=new RegExp("38|40|27"),$="disabled",J="show",G="dropdown-menu-right",Z="hide.bs.dropdown",tt="hidden.bs.dropdown",et="click.bs.dropdown.data-api",nt="keydown.bs.dropdown.data-api",it='[data-toggle="dropdown"]',ot=".dropdown-menu",at={offset:0,flip:!0,boundary:"scrollParent",reference:"toggle",display:"dynamic",popperConfig:null},st={offset:"(number|string|function)",flip:"boolean",boundary:"(string|element)",reference:"(string|element)",display:"string",popperConfig:"(null|object)"},lt=function(){function t(t,e){this._element=t,this._popper=null,this._config=this._getConfig(e),this._menu=this._getMenuElement(),this._inNavbar=this._detectNavbar(),this._addEventListeners()}var e=t.prototype;return e.toggle=function(){if(!this._element.disabled&&!o.default(this._element).hasClass($)){var e=o.default(this._menu).hasClass(J);t._clearMenus(),e||this.show(!0)}},e.show=function(e){if(void 0===e&&(e=!1),!(this._element.disabled||o.default(this._element).hasClass($)||o.default(this._menu).hasClass(J))){var n={relatedTarget:this._element},i=o.default.Event("show.bs.dropdown",n),s=t._getParentFromElement(this._element);if(o.default(s).trigger(i),!i.isDefaultPrevented()){if(!this._inNavbar&&e){if("undefined"==typeof a.default)throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");var l=this._element;"parent"===this._config.reference?l=s:d.isElement(this._config.reference)&&(l=this._config.reference,"undefined"!=typeof this._config.reference.jquery&&(l=this._config.reference[0])),"scrollParent"!==this._config.boundary&&o.default(s).addClass("position-static"),this._popper=new a.default(l,this._menu,this._getPopperConfig())}"ontouchstart"in document.documentElement&&0===o.default(s).closest(".navbar-nav").length&&o.default(document.body).children().on("mouseover",null,o.default.noop),this._element.focus(),this._element.setAttribute("aria-expanded",!0),o.default(this._menu).toggleClass(J),o.default(s).toggleClass(J).trigger(o.default.Event("shown.bs.dropdown",n))}}},e.hide=function(){if(!this._element.disabled&&!o.default(this._element).hasClass($)&&o.default(this._menu).hasClass(J)){var e={relatedTarget:this._element},n=o.default.Event(Z,e),i=t._getParentFromElement(this._element);o.default(i).trigger(n),n.isDefaultPrevented()||(this._popper&&this._popper.destroy(),o.default(this._menu).toggleClass(J),o.default(i).toggleClass(J).trigger(o.default.Event(tt,e)))}},e.dispose=function(){o.default.removeData(this._element,K),o.default(this._element).off(".bs.dropdown"),this._element=null,this._menu=null,null!==this._popper&&(this._popper.destroy(),this._popper=null)},e.update=function(){this._inNavbar=this._detectNavbar(),null!==this._popper&&this._popper.scheduleUpdate()},e._addEventListeners=function(){var t=this;o.default(this._element).on("click.bs.dropdown",(function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}))},e._getConfig=function(t){return t=r({},this.constructor.Default,o.default(this._element).data(),t),d.typeCheckConfig(z,t,this.constructor.DefaultType),t},e._getMenuElement=function(){if(!this._menu){var e=t._getParentFromElement(this._element);e&&(this._menu=e.querySelector(ot))}return this._menu},e._getPlacement=function(){var t=o.default(this._element.parentNode),e="bottom-start";return t.hasClass("dropup")?e=o.default(this._menu).hasClass(G)?"top-end":"top-start":t.hasClass("dropright")?e="right-start":t.hasClass("dropleft")?e="left-start":o.default(this._menu).hasClass(G)&&(e="bottom-end"),e},e._detectNavbar=function(){return o.default(this._element).closest(".navbar").length>0},e._getOffset=function(){var t=this,e={};return"function"==typeof this._config.offset?e.fn=function(e){return e.offsets=r({},e.offsets,t._config.offset(e.offsets,t._element)),e}:e.offset=this._config.offset,e},e._getPopperConfig=function(){var t={placement:this._getPlacement(),modifiers:{offset:this._getOffset(),flip:{enabled:this._config.flip},preventOverflow:{boundariesElement:this._config.boundary}}};return"static"===this._config.display&&(t.modifiers.applyStyle={enabled:!1}),r({},t,this._config.popperConfig)},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this).data(K);if(n||(n=new t(this,"object"==typeof e?e:null),o.default(this).data(K,n)),"string"==typeof e){if("undefined"==typeof n[e])throw new TypeError('No method named "'+e+'"');n[e]()}}))},t._clearMenus=function(e){if(!e||3!==e.which&&("keyup"!==e.type||9===e.which))for(var n=[].slice.call(document.querySelectorAll(it)),i=0,a=n.length;i<a;i++){var s=t._getParentFromElement(n[i]),l=o.default(n[i]).data(K),r={relatedTarget:n[i]};if(e&&"click"===e.type&&(r.clickEvent=e),l){var u=l._menu;if(o.default(s).hasClass(J)&&!(e&&("click"===e.type&&/input|textarea/i.test(e.target.tagName)||"keyup"===e.type&&9===e.which)&&o.default.contains(s,e.target))){var f=o.default.Event(Z,r);o.default(s).trigger(f),f.isDefaultPrevented()||("ontouchstart"in document.documentElement&&o.default(document.body).children().off("mouseover",null,o.default.noop),n[i].setAttribute("aria-expanded","false"),l._popper&&l._popper.destroy(),o.default(u).removeClass(J),o.default(s).removeClass(J).trigger(o.default.Event(tt,r)))}}}},t._getParentFromElement=function(t){var e,n=d.getSelectorFromElement(t);return n&&(e=document.querySelector(n)),e||t.parentNode},t._dataApiKeydownHandler=function(e){if(!(/input|textarea/i.test(e.target.tagName)?32===e.which||27!==e.which&&(40!==e.which&&38!==e.which||o.default(e.target).closest(ot).length):!Y.test(e.which))&&!this.disabled&&!o.default(this).hasClass($)){var n=t._getParentFromElement(this),i=o.default(n).hasClass(J);if(i||27!==e.which){if(e.preventDefault(),e.stopPropagation(),!i||27===e.which||32===e.which)return 27===e.which&&o.default(n.querySelector(it)).trigger("focus"),void o.default(this).trigger("click");var a=[].slice.call(n.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)")).filter((function(t){return o.default(t).is(":visible")}));if(0!==a.length){var s=a.indexOf(e.target);38===e.which&&s>0&&s--,40===e.which&&s<a.length-1&&s++,s<0&&(s=0),a[s].focus()}}}},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return at}},{key:"DefaultType",get:function(){return st}}]),t}();o.default(document).on(nt,it,lt._dataApiKeydownHandler).on(nt,ot,lt._dataApiKeydownHandler).on(et+" keyup.bs.dropdown.data-api",lt._clearMenus).on(et,it,(function(t){t.preventDefault(),t.stopPropagation(),lt._jQueryInterface.call(o.default(this),"toggle")})).on(et,".dropdown form",(function(t){t.stopPropagation()})),o.default.fn[z]=lt._jQueryInterface,o.default.fn[z].Constructor=lt,o.default.fn[z].noConflict=function(){return o.default.fn[z]=X,lt._jQueryInterface};var rt="bs.modal",ut=o.default.fn.modal,ft="modal-open",dt="fade",ct="show",ht="modal-static",gt="hidden.bs.modal",mt="show.bs.modal",pt="focusin.bs.modal",_t="resize.bs.modal",vt="click.dismiss.bs.modal",yt="keydown.dismiss.bs.modal",bt="mousedown.dismiss.bs.modal",Et=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",Tt={backdrop:!0,keyboard:!0,focus:!0,show:!0},wt={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean",show:"boolean"},Ct=function(){function t(t,e){this._config=this._getConfig(e),this._element=t,this._dialog=t.querySelector(".modal-dialog"),this._backdrop=null,this._isShown=!1,this._isBodyOverflowing=!1,this._ignoreBackdropClick=!1,this._isTransitioning=!1,this._scrollbarWidth=0}var e=t.prototype;return e.toggle=function(t){return this._isShown?this.hide():this.show(t)},e.show=function(t){var e=this;if(!this._isShown&&!this._isTransitioning){var n=o.default.Event(mt,{relatedTarget:t});o.default(this._element).trigger(n),n.isDefaultPrevented()||(this._isShown=!0,o.default(this._element).hasClass(dt)&&(this._isTransitioning=!0),this._checkScrollbar(),this._setScrollbar(),this._adjustDialog(),this._setEscapeEvent(),this._setResizeEvent(),o.default(this._element).on(vt,'[data-dismiss="modal"]',(function(t){return e.hide(t)})),o.default(this._dialog).on(bt,(function(){o.default(e._element).one("mouseup.dismiss.bs.modal",(function(t){o.default(t.target).is(e._element)&&(e._ignoreBackdropClick=!0)}))})),this._showBackdrop((function(){return e._showElement(t)})))}},e.hide=function(t){var e=this;if(t&&t.preventDefault(),this._isShown&&!this._isTransitioning){var n=o.default.Event("hide.bs.modal");if(o.default(this._element).trigger(n),this._isShown&&!n.isDefaultPrevented()){this._isShown=!1;var i=o.default(this._element).hasClass(dt);if(i&&(this._isTransitioning=!0),this._setEscapeEvent(),this._setResizeEvent(),o.default(document).off(pt),o.default(this._element).removeClass(ct),o.default(this._element).off(vt),o.default(this._dialog).off(bt),i){var a=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,(function(t){return e._hideModal(t)})).emulateTransitionEnd(a)}else this._hideModal()}}},e.dispose=function(){[window,this._element,this._dialog].forEach((function(t){return o.default(t).off(".bs.modal")})),o.default(document).off(pt),o.default.removeData(this._element,rt),this._config=null,this._element=null,this._dialog=null,this._backdrop=null,this._isShown=null,this._isBodyOverflowing=null,this._ignoreBackdropClick=null,this._isTransitioning=null,this._scrollbarWidth=null},e.handleUpdate=function(){this._adjustDialog()},e._getConfig=function(t){return t=r({},Tt,t),d.typeCheckConfig("modal",t,wt),t},e._triggerBackdropTransition=function(){var t=this,e=o.default.Event("hidePrevented.bs.modal");if(o.default(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._element.scrollHeight>document.documentElement.clientHeight;n||(this._element.style.overflowY="hidden"),this._element.classList.add(ht);var i=d.getTransitionDurationFromElement(this._dialog);o.default(this._element).off(d.TRANSITION_END),o.default(this._element).one(d.TRANSITION_END,(function(){t._element.classList.remove(ht),n||o.default(t._element).one(d.TRANSITION_END,(function(){t._element.style.overflowY=""})).emulateTransitionEnd(t._element,i)})).emulateTransitionEnd(i),this._element.focus()}},e._showElement=function(t){var e=this,n=o.default(this._element).hasClass(dt),i=this._dialog?this._dialog.querySelector(".modal-body"):null;this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.appendChild(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),o.default(this._dialog).hasClass("modal-dialog-scrollable")&&i?i.scrollTop=0:this._element.scrollTop=0,n&&d.reflow(this._element),o.default(this._element).addClass(ct),this._config.focus&&this._enforceFocus();var a=o.default.Event("shown.bs.modal",{relatedTarget:t}),s=function(){e._config.focus&&e._element.focus(),e._isTransitioning=!1,o.default(e._element).trigger(a)};if(n){var l=d.getTransitionDurationFromElement(this._dialog);o.default(this._dialog).one(d.TRANSITION_END,s).emulateTransitionEnd(l)}else s()},e._enforceFocus=function(){var t=this;o.default(document).off(pt).on(pt,(function(e){document!==e.target&&t._element!==e.target&&0===o.default(t._element).has(e.target).length&&t._element.focus()}))},e._setEscapeEvent=function(){var t=this;this._isShown?o.default(this._element).on(yt,(function(e){t._config.keyboard&&27===e.which?(e.preventDefault(),t.hide()):t._config.keyboard||27!==e.which||t._triggerBackdropTransition()})):this._isShown||o.default(this._element).off(yt)},e._setResizeEvent=function(){var t=this;this._isShown?o.default(window).on(_t,(function(e){return t.handleUpdate(e)})):o.default(window).off(_t)},e._hideModal=function(){var t=this;this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._isTransitioning=!1,this._showBackdrop((function(){o.default(document.body).removeClass(ft),t._resetAdjustments(),t._resetScrollbar(),o.default(t._element).trigger(gt)}))},e._removeBackdrop=function(){this._backdrop&&(o.default(this._backdrop).remove(),this._backdrop=null)},e._showBackdrop=function(t){var e=this,n=o.default(this._element).hasClass(dt)?dt:"";if(this._isShown&&this._config.backdrop){if(this._backdrop=document.createElement("div"),this._backdrop.className="modal-backdrop",n&&this._backdrop.classList.add(n),o.default(this._backdrop).appendTo(document.body),o.default(this._element).on(vt,(function(t){e._ignoreBackdropClick?e._ignoreBackdropClick=!1:t.target===t.currentTarget&&("static"===e._config.backdrop?e._triggerBackdropTransition():e.hide())})),n&&d.reflow(this._backdrop),o.default(this._backdrop).addClass(ct),!t)return;if(!n)return void t();var i=d.getTransitionDurationFromElement(this._backdrop);o.default(this._backdrop).one(d.TRANSITION_END,t).emulateTransitionEnd(i)}else if(!this._isShown&&this._backdrop){o.default(this._backdrop).removeClass(ct);var a=function(){e._removeBackdrop(),t&&t()};if(o.default(this._element).hasClass(dt)){var s=d.getTransitionDurationFromElement(this._backdrop);o.default(this._backdrop).one(d.TRANSITION_END,a).emulateTransitionEnd(s)}else a()}else t&&t()},e._adjustDialog=function(){var t=this._element.scrollHeight>document.documentElement.clientHeight;!this._isBodyOverflowing&&t&&(this._element.style.paddingLeft=this._scrollbarWidth+"px"),this._isBodyOverflowing&&!t&&(this._element.style.paddingRight=this._scrollbarWidth+"px")},e._resetAdjustments=function(){this._element.style.paddingLeft="",this._element.style.paddingRight=""},e._checkScrollbar=function(){var t=document.body.getBoundingClientRect();this._isBodyOverflowing=Math.round(t.left+t.right)<window.innerWidth,this._scrollbarWidth=this._getScrollbarWidth()},e._setScrollbar=function(){var t=this;if(this._isBodyOverflowing){var e=[].slice.call(document.querySelectorAll(Et)),n=[].slice.call(document.querySelectorAll(".sticky-top"));o.default(e).each((function(e,n){var i=n.style.paddingRight,a=o.default(n).css("padding-right");o.default(n).data("padding-right",i).css("padding-right",parseFloat(a)+t._scrollbarWidth+"px")})),o.default(n).each((function(e,n){var i=n.style.marginRight,a=o.default(n).css("margin-right");o.default(n).data("margin-right",i).css("margin-right",parseFloat(a)-t._scrollbarWidth+"px")}));var i=document.body.style.paddingRight,a=o.default(document.body).css("padding-right");o.default(document.body).data("padding-right",i).css("padding-right",parseFloat(a)+this._scrollbarWidth+"px")}o.default(document.body).addClass(ft)},e._resetScrollbar=function(){var t=[].slice.call(document.querySelectorAll(Et));o.default(t).each((function(t,e){var n=o.default(e).data("padding-right");o.default(e).removeData("padding-right"),e.style.paddingRight=n||""}));var e=[].slice.call(document.querySelectorAll(".sticky-top"));o.default(e).each((function(t,e){var n=o.default(e).data("margin-right");"undefined"!=typeof n&&o.default(e).css("margin-right",n).removeData("margin-right")}));var n=o.default(document.body).data("padding-right");o.default(document.body).removeData("padding-right"),document.body.style.paddingRight=n||""},e._getScrollbarWidth=function(){var t=document.createElement("div");t.className="modal-scrollbar-measure",document.body.appendChild(t);var e=t.getBoundingClientRect().width-t.clientWidth;return document.body.removeChild(t),e},t._jQueryInterface=function(e,n){return this.each((function(){var i=o.default(this).data(rt),a=r({},Tt,o.default(this).data(),"object"==typeof e&&e?e:{});if(i||(i=new t(this,a),o.default(this).data(rt,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e](n)}else a.show&&i.show(n)}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Tt}}]),t}();o.default(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',(function(t){var e,n=this,i=d.getSelectorFromElement(this);i&&(e=document.querySelector(i));var a=o.default(e).data(rt)?"toggle":r({},o.default(e).data(),o.default(this).data());"A"!==this.tagName&&"AREA"!==this.tagName||t.preventDefault();var s=o.default(e).one(mt,(function(t){t.isDefaultPrevented()||s.one(gt,(function(){o.default(n).is(":visible")&&n.focus()}))}));Ct._jQueryInterface.call(o.default(e),a,this)})),o.default.fn.modal=Ct._jQueryInterface,o.default.fn.modal.Constructor=Ct,o.default.fn.modal.noConflict=function(){return o.default.fn.modal=ut,Ct._jQueryInterface};var St=["background","cite","href","itemtype","longdesc","poster","src","xlink:href"],Nt=/^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i,Dt=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;function At(t,e,n){if(0===t.length)return t;if(n&&"function"==typeof n)return n(t);for(var i=(new window.DOMParser).parseFromString(t,"text/html"),o=Object.keys(e),a=[].slice.call(i.body.querySelectorAll("*")),s=function(t,n){var i=a[t],s=i.nodeName.toLowerCase();if(-1===o.indexOf(i.nodeName.toLowerCase()))return i.parentNode.removeChild(i),"continue";var l=[].slice.call(i.attributes),r=[].concat(e["*"]||[],e[s]||[]);l.forEach((function(t){(function(t,e){var n=t.nodeName.toLowerCase();if(-1!==e.indexOf(n))return-1===St.indexOf(n)||Boolean(Nt.test(t.nodeValue)||Dt.test(t.nodeValue));for(var i=e.filter((function(t){return t instanceof RegExp})),o=0,a=i.length;o<a;o++)if(i[o].test(n))return!0;return!1})(t,r)||i.removeAttribute(t.nodeName)}))},l=0,r=a.length;l<r;l++)s(l);return i.body.innerHTML}var It="tooltip",kt="bs.tooltip",Ot=o.default.fn.tooltip,jt=new RegExp("(^|\\s)bs-tooltip\\S+","g"),Pt=["sanitize","whiteList","sanitizeFn"],Lt="fade",Rt="show",xt="show",qt="out",Ft="hover",Qt="focus",Bt={AUTO:"auto",TOP:"top",RIGHT:"right",BOTTOM:"bottom",LEFT:"left"},Ht={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,selector:!1,placement:"top",offset:0,container:!1,fallbackPlacement:"flip",boundary:"scrollParent",customClass:"",sanitize:!0,sanitizeFn:null,whiteList:{"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","srcset","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},popperConfig:null},Ut={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"(number|string|function)",container:"(string|element|boolean)",fallbackPlacement:"(string|array)",boundary:"(string|element)",customClass:"(string|function)",sanitize:"boolean",sanitizeFn:"(null|function)",whiteList:"object",popperConfig:"(null|object)"},Mt={HIDE:"hide.bs.tooltip",HIDDEN:"hidden.bs.tooltip",SHOW:"show.bs.tooltip",SHOWN:"shown.bs.tooltip",INSERTED:"inserted.bs.tooltip",CLICK:"click.bs.tooltip",FOCUSIN:"focusin.bs.tooltip",FOCUSOUT:"focusout.bs.tooltip",MOUSEENTER:"mouseenter.bs.tooltip",MOUSELEAVE:"mouseleave.bs.tooltip"},Wt=function(){function t(t,e){if("undefined"==typeof a.default)throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._popper=null,this.element=t,this.config=this._getConfig(e),this.tip=null,this._setListeners()}var e=t.prototype;return e.enable=function(){this._isEnabled=!0},e.disable=function(){this._isEnabled=!1},e.toggleEnabled=function(){this._isEnabled=!this._isEnabled},e.toggle=function(t){if(this._isEnabled)if(t){var e=this.constructor.DATA_KEY,n=o.default(t.currentTarget).data(e);n||(n=new this.constructor(t.currentTarget,this._getDelegateConfig()),o.default(t.currentTarget).data(e,n)),n._activeTrigger.click=!n._activeTrigger.click,n._isWithActiveTrigger()?n._enter(null,n):n._leave(null,n)}else{if(o.default(this.getTipElement()).hasClass(Rt))return void this._leave(null,this);this._enter(null,this)}},e.dispose=function(){clearTimeout(this._timeout),o.default.removeData(this.element,this.constructor.DATA_KEY),o.default(this.element).off(this.constructor.EVENT_KEY),o.default(this.element).closest(".modal").off("hide.bs.modal",this._hideModalHandler),this.tip&&o.default(this.tip).remove(),this._isEnabled=null,this._timeout=null,this._hoverState=null,this._activeTrigger=null,this._popper&&this._popper.destroy(),this._popper=null,this.element=null,this.config=null,this.tip=null},e.show=function(){var t=this;if("none"===o.default(this.element).css("display"))throw new Error("Please use show on visible elements");var e=o.default.Event(this.constructor.Event.SHOW);if(this.isWithContent()&&this._isEnabled){o.default(this.element).trigger(e);var n=d.findShadowRoot(this.element),i=o.default.contains(null!==n?n:this.element.ownerDocument.documentElement,this.element);if(e.isDefaultPrevented()||!i)return;var s=this.getTipElement(),l=d.getUID(this.constructor.NAME);s.setAttribute("id",l),this.element.setAttribute("aria-describedby",l),this.setContent(),this.config.animation&&o.default(s).addClass(Lt);var r="function"==typeof this.config.placement?this.config.placement.call(this,s,this.element):this.config.placement,u=this._getAttachment(r);this.addAttachmentClass(u);var f=this._getContainer();o.default(s).data(this.constructor.DATA_KEY,this),o.default.contains(this.element.ownerDocument.documentElement,this.tip)||o.default(s).appendTo(f),o.default(this.element).trigger(this.constructor.Event.INSERTED),this._popper=new a.default(this.element,s,this._getPopperConfig(u)),o.default(s).addClass(Rt),o.default(s).addClass(this.config.customClass),"ontouchstart"in document.documentElement&&o.default(document.body).children().on("mouseover",null,o.default.noop);var c=function(){t.config.animation&&t._fixTransition();var e=t._hoverState;t._hoverState=null,o.default(t.element).trigger(t.constructor.Event.SHOWN),e===qt&&t._leave(null,t)};if(o.default(this.tip).hasClass(Lt)){var h=d.getTransitionDurationFromElement(this.tip);o.default(this.tip).one(d.TRANSITION_END,c).emulateTransitionEnd(h)}else c()}},e.hide=function(t){var e=this,n=this.getTipElement(),i=o.default.Event(this.constructor.Event.HIDE),a=function(){e._hoverState!==xt&&n.parentNode&&n.parentNode.removeChild(n),e._cleanTipClass(),e.element.removeAttribute("aria-describedby"),o.default(e.element).trigger(e.constructor.Event.HIDDEN),null!==e._popper&&e._popper.destroy(),t&&t()};if(o.default(this.element).trigger(i),!i.isDefaultPrevented()){if(o.default(n).removeClass(Rt),"ontouchstart"in document.documentElement&&o.default(document.body).children().off("mouseover",null,o.default.noop),this._activeTrigger.click=!1,this._activeTrigger.focus=!1,this._activeTrigger.hover=!1,o.default(this.tip).hasClass(Lt)){var s=d.getTransitionDurationFromElement(n);o.default(n).one(d.TRANSITION_END,a).emulateTransitionEnd(s)}else a();this._hoverState=""}},e.update=function(){null!==this._popper&&this._popper.scheduleUpdate()},e.isWithContent=function(){return Boolean(this.getTitle())},e.addAttachmentClass=function(t){o.default(this.getTipElement()).addClass("bs-tooltip-"+t)},e.getTipElement=function(){return this.tip=this.tip||o.default(this.config.template)[0],this.tip},e.setContent=function(){var t=this.getTipElement();this.setElementContent(o.default(t.querySelectorAll(".tooltip-inner")),this.getTitle()),o.default(t).removeClass("fade show")},e.setElementContent=function(t,e){"object"!=typeof e||!e.nodeType&&!e.jquery?this.config.html?(this.config.sanitize&&(e=At(e,this.config.whiteList,this.config.sanitizeFn)),t.html(e)):t.text(e):this.config.html?o.default(e).parent().is(t)||t.empty().append(e):t.text(o.default(e).text())},e.getTitle=function(){var t=this.element.getAttribute("data-original-title");return t||(t="function"==typeof this.config.title?this.config.title.call(this.element):this.config.title),t},e._getPopperConfig=function(t){var e=this;return r({},{placement:t,modifiers:{offset:this._getOffset(),flip:{behavior:this.config.fallbackPlacement},arrow:{element:".arrow"},preventOverflow:{boundariesElement:this.config.boundary}},onCreate:function(t){t.originalPlacement!==t.placement&&e._handlePopperPlacementChange(t)},onUpdate:function(t){return e._handlePopperPlacementChange(t)}},this.config.popperConfig)},e._getOffset=function(){var t=this,e={};return"function"==typeof this.config.offset?e.fn=function(e){return e.offsets=r({},e.offsets,t.config.offset(e.offsets,t.element)),e}:e.offset=this.config.offset,e},e._getContainer=function(){return!1===this.config.container?document.body:d.isElement(this.config.container)?o.default(this.config.container):o.default(document).find(this.config.container)},e._getAttachment=function(t){return Bt[t.toUpperCase()]},e._setListeners=function(){var t=this;this.config.trigger.split(" ").forEach((function(e){if("click"===e)o.default(t.element).on(t.constructor.Event.CLICK,t.config.selector,(function(e){return t.toggle(e)}));else if("manual"!==e){var n=e===Ft?t.constructor.Event.MOUSEENTER:t.constructor.Event.FOCUSIN,i=e===Ft?t.constructor.Event.MOUSELEAVE:t.constructor.Event.FOCUSOUT;o.default(t.element).on(n,t.config.selector,(function(e){return t._enter(e)})).on(i,t.config.selector,(function(e){return t._leave(e)}))}})),this._hideModalHandler=function(){t.element&&t.hide()},o.default(this.element).closest(".modal").on("hide.bs.modal",this._hideModalHandler),this.config.selector?this.config=r({},this.config,{trigger:"manual",selector:""}):this._fixTitle()},e._fixTitle=function(){var t=typeof this.element.getAttribute("data-original-title");(this.element.getAttribute("title")||"string"!==t)&&(this.element.setAttribute("data-original-title",this.element.getAttribute("title")||""),this.element.setAttribute("title",""))},e._enter=function(t,e){var n=this.constructor.DATA_KEY;(e=e||o.default(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),o.default(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusin"===t.type?Qt:Ft]=!0),o.default(e.getTipElement()).hasClass(Rt)||e._hoverState===xt?e._hoverState=xt:(clearTimeout(e._timeout),e._hoverState=xt,e.config.delay&&e.config.delay.show?e._timeout=setTimeout((function(){e._hoverState===xt&&e.show()}),e.config.delay.show):e.show())},e._leave=function(t,e){var n=this.constructor.DATA_KEY;(e=e||o.default(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),o.default(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusout"===t.type?Qt:Ft]=!1),e._isWithActiveTrigger()||(clearTimeout(e._timeout),e._hoverState=qt,e.config.delay&&e.config.delay.hide?e._timeout=setTimeout((function(){e._hoverState===qt&&e.hide()}),e.config.delay.hide):e.hide())},e._isWithActiveTrigger=function(){for(var t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1},e._getConfig=function(t){var e=o.default(this.element).data();return Object.keys(e).forEach((function(t){-1!==Pt.indexOf(t)&&delete e[t]})),"number"==typeof(t=r({},this.constructor.Default,e,"object"==typeof t&&t?t:{})).delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),d.typeCheckConfig(It,t,this.constructor.DefaultType),t.sanitize&&(t.template=At(t.template,t.whiteList,t.sanitizeFn)),t},e._getDelegateConfig=function(){var t={};if(this.config)for(var e in this.config)this.constructor.Default[e]!==this.config[e]&&(t[e]=this.config[e]);return t},e._cleanTipClass=function(){var t=o.default(this.getTipElement()),e=t.attr("class").match(jt);null!==e&&e.length&&t.removeClass(e.join(""))},e._handlePopperPlacementChange=function(t){this.tip=t.instance.popper,this._cleanTipClass(),this.addAttachmentClass(this._getAttachment(t.placement))},e._fixTransition=function(){var t=this.getTipElement(),e=this.config.animation;null===t.getAttribute("x-placement")&&(o.default(t).removeClass(Lt),this.config.animation=!1,this.hide(),this.show(),this.config.animation=e)},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(kt),a="object"==typeof e&&e;if((i||!/dispose|hide/.test(e))&&(i||(i=new t(this,a),n.data(kt,i)),"string"==typeof e)){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Ht}},{key:"NAME",get:function(){return It}},{key:"DATA_KEY",get:function(){return kt}},{key:"Event",get:function(){return Mt}},{key:"EVENT_KEY",get:function(){return".bs.tooltip"}},{key:"DefaultType",get:function(){return Ut}}]),t}();o.default.fn.tooltip=Wt._jQueryInterface,o.default.fn.tooltip.Constructor=Wt,o.default.fn.tooltip.noConflict=function(){return o.default.fn.tooltip=Ot,Wt._jQueryInterface};var Vt="bs.popover",zt=o.default.fn.popover,Kt=new RegExp("(^|\\s)bs-popover\\S+","g"),Xt=r({},Wt.Default,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'}),Yt=r({},Wt.DefaultType,{content:"(string|element|function)"}),$t={HIDE:"hide.bs.popover",HIDDEN:"hidden.bs.popover",SHOW:"show.bs.popover",SHOWN:"shown.bs.popover",INSERTED:"inserted.bs.popover",CLICK:"click.bs.popover",FOCUSIN:"focusin.bs.popover",FOCUSOUT:"focusout.bs.popover",MOUSEENTER:"mouseenter.bs.popover",MOUSELEAVE:"mouseleave.bs.popover"},Jt=function(t){var e,n;function i(){return t.apply(this,arguments)||this}n=t,(e=i).prototype=Object.create(n.prototype),e.prototype.constructor=e,u(e,n);var a=i.prototype;return a.isWithContent=function(){return this.getTitle()||this._getContent()},a.addAttachmentClass=function(t){o.default(this.getTipElement()).addClass("bs-popover-"+t)},a.getTipElement=function(){return this.tip=this.tip||o.default(this.config.template)[0],this.tip},a.setContent=function(){var t=o.default(this.getTipElement());this.setElementContent(t.find(".popover-header"),this.getTitle());var e=this._getContent();"function"==typeof e&&(e=e.call(this.element)),this.setElementContent(t.find(".popover-body"),e),t.removeClass("fade show")},a._getContent=function(){return this.element.getAttribute("data-content")||this.config.content},a._cleanTipClass=function(){var t=o.default(this.getTipElement()),e=t.attr("class").match(Kt);null!==e&&e.length>0&&t.removeClass(e.join(""))},i._jQueryInterface=function(t){return this.each((function(){var e=o.default(this).data(Vt),n="object"==typeof t?t:null;if((e||!/dispose|hide/.test(t))&&(e||(e=new i(this,n),o.default(this).data(Vt,e)),"string"==typeof t)){if("undefined"==typeof e[t])throw new TypeError('No method named "'+t+'"');e[t]()}}))},l(i,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Xt}},{key:"NAME",get:function(){return"popover"}},{key:"DATA_KEY",get:function(){return Vt}},{key:"Event",get:function(){return $t}},{key:"EVENT_KEY",get:function(){return".bs.popover"}},{key:"DefaultType",get:function(){return Yt}}]),i}(Wt);o.default.fn.popover=Jt._jQueryInterface,o.default.fn.popover.Constructor=Jt,o.default.fn.popover.noConflict=function(){return o.default.fn.popover=zt,Jt._jQueryInterface};var Gt="scrollspy",Zt="bs.scrollspy",te=o.default.fn[Gt],ee="active",ne="position",ie=".nav, .list-group",oe={offset:10,method:"auto",target:""},ae={offset:"number",method:"string",target:"(string|element)"},se=function(){function t(t,e){var n=this;this._element=t,this._scrollElement="BODY"===t.tagName?window:t,this._config=this._getConfig(e),this._selector=this._config.target+" .nav-link,"+this._config.target+" .list-group-item,"+this._config.target+" .dropdown-item",this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,o.default(this._scrollElement).on("scroll.bs.scrollspy",(function(t){return n._process(t)})),this.refresh(),this._process()}var e=t.prototype;return e.refresh=function(){var t=this,e=this._scrollElement===this._scrollElement.window?"offset":ne,n="auto"===this._config.method?e:this._config.method,i=n===ne?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),[].slice.call(document.querySelectorAll(this._selector)).map((function(t){var e,a=d.getSelectorFromElement(t);if(a&&(e=document.querySelector(a)),e){var s=e.getBoundingClientRect();if(s.width||s.height)return[o.default(e)[n]().top+i,a]}return null})).filter(Boolean).sort((function(t,e){return t[0]-e[0]})).forEach((function(e){t._offsets.push(e[0]),t._targets.push(e[1])}))},e.dispose=function(){o.default.removeData(this._element,Zt),o.default(this._scrollElement).off(".bs.scrollspy"),this._element=null,this._scrollElement=null,this._config=null,this._selector=null,this._offsets=null,this._targets=null,this._activeTarget=null,this._scrollHeight=null},e._getConfig=function(t){if("string"!=typeof(t=r({},oe,"object"==typeof t&&t?t:{})).target&&d.isElement(t.target)){var e=o.default(t.target).attr("id");e||(e=d.getUID(Gt),o.default(t.target).attr("id",e)),t.target="#"+e}return d.typeCheckConfig(Gt,t,ae),t},e._getScrollTop=function(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop},e._getScrollHeight=function(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)},e._getOffsetHeight=function(){return this._scrollElement===window?window.innerHeight:this._scrollElement.getBoundingClientRect().height},e._process=function(){var t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),n=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),t>=n){var i=this._targets[this._targets.length-1];this._activeTarget!==i&&this._activate(i)}else{if(this._activeTarget&&t<this._offsets[0]&&this._offsets[0]>0)return this._activeTarget=null,void this._clear();for(var o=this._offsets.length;o--;)this._activeTarget!==this._targets[o]&&t>=this._offsets[o]&&("undefined"==typeof this._offsets[o+1]||t<this._offsets[o+1])&&this._activate(this._targets[o])}},e._activate=function(t){this._activeTarget=t,this._clear();var e=this._selector.split(",").map((function(e){return e+'[data-target="'+t+'"],'+e+'[href="'+t+'"]'})),n=o.default([].slice.call(document.querySelectorAll(e.join(","))));n.hasClass("dropdown-item")?(n.closest(".dropdown").find(".dropdown-toggle").addClass(ee),n.addClass(ee)):(n.addClass(ee),n.parents(ie).prev(".nav-link, .list-group-item").addClass(ee),n.parents(ie).prev(".nav-item").children(".nav-link").addClass(ee)),o.default(this._scrollElement).trigger("activate.bs.scrollspy",{relatedTarget:t})},e._clear=function(){[].slice.call(document.querySelectorAll(this._selector)).filter((function(t){return t.classList.contains(ee)})).forEach((function(t){return t.classList.remove(ee)}))},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this).data(Zt);if(n||(n=new t(this,"object"==typeof e&&e),o.default(this).data(Zt,n)),"string"==typeof e){if("undefined"==typeof n[e])throw new TypeError('No method named "'+e+'"');n[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return oe}}]),t}();o.default(window).on("load.bs.scrollspy.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-spy="scroll"]')),e=t.length;e--;){var n=o.default(t[e]);se._jQueryInterface.call(n,n.data())}})),o.default.fn[Gt]=se._jQueryInterface,o.default.fn[Gt].Constructor=se,o.default.fn[Gt].noConflict=function(){return o.default.fn[Gt]=te,se._jQueryInterface};var le="bs.tab",re=o.default.fn.tab,ue="active",fe="fade",de="show",ce=".active",he="> li > .active",ge=function(){function t(t){this._element=t}var e=t.prototype;return e.show=function(){var t=this;if(!(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&o.default(this._element).hasClass(ue)||o.default(this._element).hasClass("disabled")||this._element.hasAttribute("disabled"))){var e,n,i=o.default(this._element).closest(".nav, .list-group")[0],a=d.getSelectorFromElement(this._element);if(i){var s="UL"===i.nodeName||"OL"===i.nodeName?he:ce;n=(n=o.default.makeArray(o.default(i).find(s)))[n.length-1]}var l=o.default.Event("hide.bs.tab",{relatedTarget:this._element}),r=o.default.Event("show.bs.tab",{relatedTarget:n});if(n&&o.default(n).trigger(l),o.default(this._element).trigger(r),!r.isDefaultPrevented()&&!l.isDefaultPrevented()){a&&(e=document.querySelector(a)),this._activate(this._element,i);var u=function(){var e=o.default.Event("hidden.bs.tab",{relatedTarget:t._element}),i=o.default.Event("shown.bs.tab",{relatedTarget:n});o.default(n).trigger(e),o.default(t._element).trigger(i)};e?this._activate(e,e.parentNode,u):u()}}},e.dispose=function(){o.default.removeData(this._element,le),this._element=null},e._activate=function(t,e,n){var i=this,a=(!e||"UL"!==e.nodeName&&"OL"!==e.nodeName?o.default(e).children(ce):o.default(e).find(he))[0],s=n&&a&&o.default(a).hasClass(fe),l=function(){return i._transitionComplete(t,a,n)};if(a&&s){var r=d.getTransitionDurationFromElement(a);o.default(a).removeClass(de).one(d.TRANSITION_END,l).emulateTransitionEnd(r)}else l()},e._transitionComplete=function(t,e,n){if(e){o.default(e).removeClass(ue);var i=o.default(e.parentNode).find("> .dropdown-menu .active")[0];i&&o.default(i).removeClass(ue),"tab"===e.getAttribute("role")&&e.setAttribute("aria-selected",!1)}o.default(t).addClass(ue),"tab"===t.getAttribute("role")&&t.setAttribute("aria-selected",!0),d.reflow(t),t.classList.contains(fe)&&t.classList.add(de);var a=t.parentNode;if(a&&"LI"===a.nodeName&&(a=a.parentNode),a&&o.default(a).hasClass("dropdown-menu")){var s=o.default(t).closest(".dropdown")[0];if(s){var l=[].slice.call(s.querySelectorAll(".dropdown-toggle"));o.default(l).addClass(ue)}t.setAttribute("aria-expanded",!0)}n&&n()},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(le);if(i||(i=new t(this),n.data(le,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e]()}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();o.default(document).on("click.bs.tab.data-api",'[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',(function(t){t.preventDefault(),ge._jQueryInterface.call(o.default(this),"show")})),o.default.fn.tab=ge._jQueryInterface,o.default.fn.tab.Constructor=ge,o.default.fn.tab.noConflict=function(){return o.default.fn.tab=re,ge._jQueryInterface};var me="bs.toast",pe=o.default.fn.toast,_e="hide",ve="show",ye="showing",be="click.dismiss.bs.toast",Ee={animation:!0,autohide:!0,delay:500},Te={animation:"boolean",autohide:"boolean",delay:"number"},we=function(){function t(t,e){this._element=t,this._config=this._getConfig(e),this._timeout=null,this._setListeners()}var e=t.prototype;return e.show=function(){var t=this,e=o.default.Event("show.bs.toast");if(o.default(this._element).trigger(e),!e.isDefaultPrevented()){this._clearTimeout(),this._config.animation&&this._element.classList.add("fade");var n=function(){t._element.classList.remove(ye),t._element.classList.add(ve),o.default(t._element).trigger("shown.bs.toast"),t._config.autohide&&(t._timeout=setTimeout((function(){t.hide()}),t._config.delay))};if(this._element.classList.remove(_e),d.reflow(this._element),this._element.classList.add(ye),this._config.animation){var i=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,n).emulateTransitionEnd(i)}else n()}},e.hide=function(){if(this._element.classList.contains(ve)){var t=o.default.Event("hide.bs.toast");o.default(this._element).trigger(t),t.isDefaultPrevented()||this._close()}},e.dispose=function(){this._clearTimeout(),this._element.classList.contains(ve)&&this._element.classList.remove(ve),o.default(this._element).off(be),o.default.removeData(this._element,me),this._element=null,this._config=null},e._getConfig=function(t){return t=r({},Ee,o.default(this._element).data(),"object"==typeof t&&t?t:{}),d.typeCheckConfig("toast",t,this.constructor.DefaultType),t},e._setListeners=function(){var t=this;o.default(this._element).on(be,'[data-dismiss="toast"]',(function(){return t.hide()}))},e._close=function(){var t=this,e=function(){t._element.classList.add(_e),o.default(t._element).trigger("hidden.bs.toast")};if(this._element.classList.remove(ve),this._config.animation){var n=d.getTransitionDurationFromElement(this._element);o.default(this._element).one(d.TRANSITION_END,e).emulateTransitionEnd(n)}else e()},e._clearTimeout=function(){clearTimeout(this._timeout),this._timeout=null},t._jQueryInterface=function(e){return this.each((function(){var n=o.default(this),i=n.data(me);if(i||(i=new t(this,"object"==typeof e&&e),n.data(me,i)),"string"==typeof e){if("undefined"==typeof i[e])throw new TypeError('No method named "'+e+'"');i[e](this)}}))},l(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"DefaultType",get:function(){return Te}},{key:"Default",get:function(){return Ee}}]),t}();o.default.fn.toast=we._jQueryInterface,o.default.fn.toast.Constructor=we,o.default.fn.toast.noConflict=function(){return o.default.fn.toast=pe,we._jQueryInterface},t.Alert=g,t.Button=E,t.Carousel=P,t.Collapse=V,t.Dropdown=lt,t.Modal=Ct,t.Popover=Jt,t.Scrollspy=se,t.Tab=ge,t.Toast=we,t.Tooltip=Wt,t.Util=d,Object.defineProperty(t,"__esModule",{value:!0})}));
//# sourceMappingURL=bootstrap.min.js.map

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// not "use strict" so we can declare global "Promise"

var asap = __webpack_require__(274);

if (typeof Promise === 'undefined') {
  Promise = __webpack_require__(169)
  __webpack_require__(275)
}

__webpack_require__(276);


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(168);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(169);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

// should work in any browser without browserify

if (typeof Promise.prototype.done !== 'function') {
  Promise.prototype.done = function (onFulfilled, onRejected) {
    var self = arguments.length ? this.then.apply(this, arguments) : this
    self.then(null, function (err) {
      setTimeout(function () {
        throw err
      }, 0)
    })
  }
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.WHATWGFetch = {})));
}(this, (function (exports) { 'use strict';

  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, jQuery) {/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
/**
 * Owl carousel
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 * @todo Lazy Load Icon
 * @todo prevent animationend bubling
 * @todo itemsScaleUp
 * @todo Test Zepto
 * @todo stagePadding calculate wrong active classes
 */
;(function($, window, document, undefined) {

	/**
	 * Creates a carousel.
	 * @class The Owl Carousel.
	 * @public
	 * @param {HTMLElement|jQuery} element - The element to create the carousel for.
	 * @param {Object} [options] - The options
	 */
	function Owl(element, options) {

		/**
		 * Current settings for the carousel.
		 * @public
		 */
		this.settings = null;

		/**
		 * Current options set by the caller including defaults.
		 * @public
		 */
		this.options = $.extend({}, Owl.Defaults, options);

		/**
		 * Plugin element.
		 * @public
		 */
		this.$element = $(element);

		/**
		 * Proxied event handlers.
		 * @protected
		 */
		this._handlers = {};

		/**
		 * References to the running plugins of this carousel.
		 * @protected
		 */
		this._plugins = {};

		/**
		 * Currently suppressed events to prevent them from being retriggered.
		 * @protected
		 */
		this._supress = {};

		/**
		 * Absolute current position.
		 * @protected
		 */
		this._current = null;

		/**
		 * Animation speed in milliseconds.
		 * @protected
		 */
		this._speed = null;

		/**
		 * Coordinates of all items in pixel.
		 * @todo The name of this member is missleading.
		 * @protected
		 */
		this._coordinates = [];

		/**
		 * Current breakpoint.
		 * @todo Real media queries would be nice.
		 * @protected
		 */
		this._breakpoint = null;

		/**
		 * Current width of the plugin element.
		 */
		this._width = null;

		/**
		 * All real items.
		 * @protected
		 */
		this._items = [];

		/**
		 * All cloned items.
		 * @protected
		 */
		this._clones = [];

		/**
		 * Merge values of all items.
		 * @todo Maybe this could be part of a plugin.
		 * @protected
		 */
		this._mergers = [];

		/**
		 * Widths of all items.
		 */
		this._widths = [];

		/**
		 * Invalidated parts within the update process.
		 * @protected
		 */
		this._invalidated = {};

		/**
		 * Ordered list of workers for the update process.
		 * @protected
		 */
		this._pipe = [];

		/**
		 * Current state information for the drag operation.
		 * @todo #261
		 * @protected
		 */
		this._drag = {
			time: null,
			target: null,
			pointer: null,
			stage: {
				start: null,
				current: null
			},
			direction: null
		};

		/**
		 * Current state information and their tags.
		 * @type {Object}
		 * @protected
		 */
		this._states = {
			current: {},
			tags: {
				'initializing': [ 'busy' ],
				'animating': [ 'busy' ],
				'dragging': [ 'interacting' ]
			}
		};

		$.each([ 'onResize', 'onThrottledResize' ], $.proxy(function(i, handler) {
			this._handlers[handler] = $.proxy(this[handler], this);
		}, this));

		$.each(Owl.Plugins, $.proxy(function(key, plugin) {
			this._plugins[key.charAt(0).toLowerCase() + key.slice(1)]
				= new plugin(this);
		}, this));

		$.each(Owl.Workers, $.proxy(function(priority, worker) {
			this._pipe.push({
				'filter': worker.filter,
				'run': $.proxy(worker.run, this)
			});
		}, this));

		this.setup();
		this.initialize();
	}

	/**
	 * Default options for the carousel.
	 * @public
	 */
	Owl.Defaults = {
		items: 3,
		loop: false,
		center: false,
		rewind: false,
		checkVisibility: true,

		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		freeDrag: false,

		margin: 0,
		stagePadding: 0,

		merge: false,
		mergeFit: true,
		autoWidth: false,

		startPosition: 0,
		rtl: false,

		smartSpeed: 250,
		fluidSpeed: false,
		dragEndSpeed: false,

		responsive: {},
		responsiveRefreshRate: 200,
		responsiveBaseElement: window,

		fallbackEasing: 'swing',
		slideTransition: '',

		info: false,

		nestedItemSelector: false,
		itemElement: 'div',
		stageElement: 'div',

		refreshClass: 'owl-refresh',
		loadedClass: 'owl-loaded',
		loadingClass: 'owl-loading',
		rtlClass: 'owl-rtl',
		responsiveClass: 'owl-responsive',
		dragClass: 'owl-drag',
		itemClass: 'owl-item',
		stageClass: 'owl-stage',
		stageOuterClass: 'owl-stage-outer',
		grabClass: 'owl-grab'
	};

	/**
	 * Enumeration for width.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Width = {
		Default: 'default',
		Inner: 'inner',
		Outer: 'outer'
	};

	/**
	 * Enumeration for types.
	 * @public
	 * @readonly
	 * @enum {String}
	 */
	Owl.Type = {
		Event: 'event',
		State: 'state'
	};

	/**
	 * Contains all registered plugins.
	 * @public
	 */
	Owl.Plugins = {};

	/**
	 * List of workers involved in the update process.
	 */
	Owl.Workers = [ {
		filter: [ 'width', 'settings' ],
		run: function() {
			this._width = this.$element.width();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = this._items && this._items[this.relative(this._current)];
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			this.$stage.children('.cloned').remove();
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var margin = this.settings.margin || '',
				grid = !this.settings.autoWidth,
				rtl = this.settings.rtl,
				css = {
					'width': 'auto',
					'margin-left': rtl ? margin : '',
					'margin-right': rtl ? '' : margin
				};

			!grid && this.$stage.children().css(css);

			cache.css = css;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var width = (this.width() / this.settings.items).toFixed(3) - this.settings.margin,
				merge = null,
				iterator = this._items.length,
				grid = !this.settings.autoWidth,
				widths = [];

			cache.items = {
				merge: false,
				width: width
			};

			while (iterator--) {
				merge = this._mergers[iterator];
				merge = this.settings.mergeFit && Math.min(merge, this.settings.items) || merge;

				cache.items.merge = merge > 1 || cache.items.merge;

				widths[iterator] = !grid ? this._items[iterator].width() : width * merge;
			}

			this._widths = widths;
		}
	}, {
		filter: [ 'items', 'settings' ],
		run: function() {
			var clones = [],
				items = this._items,
				settings = this.settings,
				// TODO: Should be computed from number of min width items in stage
				view = Math.max(settings.items * 2, 4),
				size = Math.ceil(items.length / 2) * 2,
				repeat = settings.loop && items.length ? settings.rewind ? view : Math.max(view, size) : 0,
				append = '',
				prepend = '';

			repeat /= 2;

			while (repeat > 0) {
				// Switch to only using appended clones
				clones.push(this.normalize(clones.length / 2, true));
				append = append + items[clones[clones.length - 1]][0].outerHTML;
				clones.push(this.normalize(items.length - 1 - (clones.length - 1) / 2, true));
				prepend = items[clones[clones.length - 1]][0].outerHTML + prepend;
				repeat -= 1;
			}

			this._clones = clones;

			$(append).addClass('cloned').appendTo(this.$stage);
			$(prepend).addClass('cloned').prependTo(this.$stage);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				size = this._clones.length + this._items.length,
				iterator = -1,
				previous = 0,
				current = 0,
				coordinates = [];

			while (++iterator < size) {
				previous = coordinates[iterator - 1] || 0;
				current = this._widths[this.relative(iterator)] + this.settings.margin;
				coordinates.push(previous + current * rtl);
			}

			this._coordinates = coordinates;
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function() {
			var padding = this.settings.stagePadding,
				coordinates = this._coordinates,
				css = {
					'width': Math.ceil(Math.abs(coordinates[coordinates.length - 1])) + padding * 2,
					'padding-left': padding || '',
					'padding-right': padding || ''
				};

			this.$stage.css(css);
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			var iterator = this._coordinates.length,
				grid = !this.settings.autoWidth,
				items = this.$stage.children();

			if (grid && cache.items.merge) {
				while (iterator--) {
					cache.css.width = this._widths[this.relative(iterator)];
					items.eq(iterator).css(cache.css);
				}
			} else if (grid) {
				cache.css.width = cache.items.width;
				items.css(cache.css);
			}
		}
	}, {
		filter: [ 'items' ],
		run: function() {
			this._coordinates.length < 1 && this.$stage.removeAttr('style');
		}
	}, {
		filter: [ 'width', 'items', 'settings' ],
		run: function(cache) {
			cache.current = cache.current ? this.$stage.children().index(cache.current) : 0;
			cache.current = Math.max(this.minimum(), Math.min(this.maximum(), cache.current));
			this.reset(cache.current);
		}
	}, {
		filter: [ 'position' ],
		run: function() {
			this.animate(this.coordinates(this._current));
		}
	}, {
		filter: [ 'width', 'position', 'items', 'settings' ],
		run: function() {
			var rtl = this.settings.rtl ? 1 : -1,
				padding = this.settings.stagePadding * 2,
				begin = this.coordinates(this.current()) + padding,
				end = begin + this.width() * rtl,
				inner, outer, matches = [], i, n;

			for (i = 0, n = this._coordinates.length; i < n; i++) {
				inner = this._coordinates[i - 1] || 0;
				outer = Math.abs(this._coordinates[i]) + padding * rtl;

				if ((this.op(inner, '<=', begin) && (this.op(inner, '>', end)))
					|| (this.op(outer, '<', begin) && this.op(outer, '>', end))) {
					matches.push(i);
				}
			}

			this.$stage.children('.active').removeClass('active');
			this.$stage.children(':eq(' + matches.join('), :eq(') + ')').addClass('active');

			this.$stage.children('.center').removeClass('center');
			if (this.settings.center) {
				this.$stage.children().eq(this.current()).addClass('center');
			}
		}
	} ];

	/**
	 * Create the stage DOM element
	 */
	Owl.prototype.initializeStage = function() {
		this.$stage = this.$element.find('.' + this.settings.stageClass);

		// if the stage is already in the DOM, grab it and skip stage initialization
		if (this.$stage.length) {
			return;
		}

		this.$element.addClass(this.options.loadingClass);

		// create stage
		this.$stage = $('<' + this.settings.stageElement + '>', {
			"class": this.settings.stageClass
		}).wrap( $( '<div/>', {
			"class": this.settings.stageOuterClass
		}));

		// append stage
		this.$element.append(this.$stage.parent());
	};

	/**
	 * Create item DOM elements
	 */
	Owl.prototype.initializeItems = function() {
		var $items = this.$element.find('.owl-item');

		// if the items are already in the DOM, grab them and skip item initialization
		if ($items.length) {
			this._items = $items.get().map(function(item) {
				return $(item);
			});

			this._mergers = this._items.map(function() {
				return 1;
			});

			this.refresh();

			return;
		}

		// append content
		this.replace(this.$element.children().not(this.$stage.parent()));

		// check visibility
		if (this.isVisible()) {
			// update view
			this.refresh();
		} else {
			// invalidate width
			this.invalidate('width');
		}

		this.$element
			.removeClass(this.options.loadingClass)
			.addClass(this.options.loadedClass);
	};

	/**
	 * Initializes the carousel.
	 * @protected
	 */
	Owl.prototype.initialize = function() {
		this.enter('initializing');
		this.trigger('initialize');

		this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl);

		if (this.settings.autoWidth && !this.is('pre-loading')) {
			var imgs, nestedSelector, width;
			imgs = this.$element.find('img');
			nestedSelector = this.settings.nestedItemSelector ? '.' + this.settings.nestedItemSelector : undefined;
			width = this.$element.children(nestedSelector).width();

			if (imgs.length && width <= 0) {
				this.preloadAutoWidthImages(imgs);
			}
		}

		this.initializeStage();
		this.initializeItems();

		// register event handlers
		this.registerEventHandlers();

		this.leave('initializing');
		this.trigger('initialized');
	};

	/**
	 * @returns {Boolean} visibility of $element
	 *                    if you know the carousel will always be visible you can set `checkVisibility` to `false` to
	 *                    prevent the expensive browser layout forced reflow the $element.is(':visible') does
	 */
	Owl.prototype.isVisible = function() {
		return this.settings.checkVisibility
			? this.$element.is(':visible')
			: true;
	};

	/**
	 * Setups the current settings.
	 * @todo Remove responsive classes. Why should adaptive designs be brought into IE8?
	 * @todo Support for media queries by using `matchMedia` would be nice.
	 * @public
	 */
	Owl.prototype.setup = function() {
		var viewport = this.viewport(),
			overwrites = this.options.responsive,
			match = -1,
			settings = null;

		if (!overwrites) {
			settings = $.extend({}, this.options);
		} else {
			$.each(overwrites, function(breakpoint) {
				if (breakpoint <= viewport && breakpoint > match) {
					match = Number(breakpoint);
				}
			});

			settings = $.extend({}, this.options, overwrites[match]);
			if (typeof settings.stagePadding === 'function') {
				settings.stagePadding = settings.stagePadding();
			}
			delete settings.responsive;

			// responsive class
			if (settings.responsiveClass) {
				this.$element.attr('class',
					this.$element.attr('class').replace(new RegExp('(' + this.options.responsiveClass + '-)\\S+\\s', 'g'), '$1' + match)
				);
			}
		}

		this.trigger('change', { property: { name: 'settings', value: settings } });
		this._breakpoint = match;
		this.settings = settings;
		this.invalidate('settings');
		this.trigger('changed', { property: { name: 'settings', value: this.settings } });
	};

	/**
	 * Updates option logic if necessery.
	 * @protected
	 */
	Owl.prototype.optionsLogic = function() {
		if (this.settings.autoWidth) {
			this.settings.stagePadding = false;
			this.settings.merge = false;
		}
	};

	/**
	 * Prepares an item before add.
	 * @todo Rename event parameter `content` to `item`.
	 * @protected
	 * @returns {jQuery|HTMLElement} - The item container.
	 */
	Owl.prototype.prepare = function(item) {
		var event = this.trigger('prepare', { content: item });

		if (!event.data) {
			event.data = $('<' + this.settings.itemElement + '/>')
				.addClass(this.options.itemClass).append(item)
		}

		this.trigger('prepared', { content: event.data });

		return event.data;
	};

	/**
	 * Updates the view.
	 * @public
	 */
	Owl.prototype.update = function() {
		var i = 0,
			n = this._pipe.length,
			filter = $.proxy(function(p) { return this[p] }, this._invalidated),
			cache = {};

		while (i < n) {
			if (this._invalidated.all || $.grep(this._pipe[i].filter, filter).length > 0) {
				this._pipe[i].run(cache);
			}
			i++;
		}

		this._invalidated = {};

		!this.is('valid') && this.enter('valid');
	};

	/**
	 * Gets the width of the view.
	 * @public
	 * @param {Owl.Width} [dimension=Owl.Width.Default] - The dimension to return.
	 * @returns {Number} - The width of the view in pixel.
	 */
	Owl.prototype.width = function(dimension) {
		dimension = dimension || Owl.Width.Default;
		switch (dimension) {
			case Owl.Width.Inner:
			case Owl.Width.Outer:
				return this._width;
			default:
				return this._width - this.settings.stagePadding * 2 + this.settings.margin;
		}
	};

	/**
	 * Refreshes the carousel primarily for adaptive purposes.
	 * @public
	 */
	Owl.prototype.refresh = function() {
		this.enter('refreshing');
		this.trigger('refresh');

		this.setup();

		this.optionsLogic();

		this.$element.addClass(this.options.refreshClass);

		this.update();

		this.$element.removeClass(this.options.refreshClass);

		this.leave('refreshing');
		this.trigger('refreshed');
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onThrottledResize = function() {
		window.clearTimeout(this.resizeTimer);
		this.resizeTimer = window.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
	};

	/**
	 * Checks window `resize` event.
	 * @protected
	 */
	Owl.prototype.onResize = function() {
		if (!this._items.length) {
			return false;
		}

		if (this._width === this.$element.width()) {
			return false;
		}

		if (!this.isVisible()) {
			return false;
		}

		this.enter('resizing');

		if (this.trigger('resize').isDefaultPrevented()) {
			this.leave('resizing');
			return false;
		}

		this.invalidate('width');

		this.refresh();

		this.leave('resizing');
		this.trigger('resized');
	};

	/**
	 * Registers event handlers.
	 * @todo Check `msPointerEnabled`
	 * @todo #261
	 * @protected
	 */
	Owl.prototype.registerEventHandlers = function() {
		if ($.support.transition) {
			this.$stage.on($.support.transition.end + '.owl.core', $.proxy(this.onTransitionEnd, this));
		}

		if (this.settings.responsive !== false) {
			this.on(window, 'resize', this._handlers.onThrottledResize);
		}

		if (this.settings.mouseDrag) {
			this.$element.addClass(this.options.dragClass);
			this.$stage.on('mousedown.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('dragstart.owl.core selectstart.owl.core', function() { return false });
		}

		if (this.settings.touchDrag){
			this.$stage.on('touchstart.owl.core', $.proxy(this.onDragStart, this));
			this.$stage.on('touchcancel.owl.core', $.proxy(this.onDragEnd, this));
		}
	};

	/**
	 * Handles `touchstart` and `mousedown` events.
	 * @todo Horizontal swipe threshold as option
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragStart = function(event) {
		var stage = null;

		if (event.which === 3) {
			return;
		}

		if ($.support.transform) {
			stage = this.$stage.css('transform').replace(/.*\(|\)| /g, '').split(',');
			stage = {
				x: stage[stage.length === 16 ? 12 : 4],
				y: stage[stage.length === 16 ? 13 : 5]
			};
		} else {
			stage = this.$stage.position();
			stage = {
				x: this.settings.rtl ?
					stage.left + this.$stage.width() - this.width() + this.settings.margin :
					stage.left,
				y: stage.top
			};
		}

		if (this.is('animating')) {
			$.support.transform ? this.animate(stage.x) : this.$stage.stop()
			this.invalidate('position');
		}

		this.$element.toggleClass(this.options.grabClass, event.type === 'mousedown');

		this.speed(0);

		this._drag.time = new Date().getTime();
		this._drag.target = $(event.target);
		this._drag.stage.start = stage;
		this._drag.stage.current = stage;
		this._drag.pointer = this.pointer(event);

		$(document).on('mouseup.owl.core touchend.owl.core', $.proxy(this.onDragEnd, this));

		$(document).one('mousemove.owl.core touchmove.owl.core', $.proxy(function(event) {
			var delta = this.difference(this._drag.pointer, this.pointer(event));

			$(document).on('mousemove.owl.core touchmove.owl.core', $.proxy(this.onDragMove, this));

			if (Math.abs(delta.x) < Math.abs(delta.y) && this.is('valid')) {
				return;
			}

			event.preventDefault();

			this.enter('dragging');
			this.trigger('drag');
		}, this));
	};

	/**
	 * Handles the `touchmove` and `mousemove` events.
	 * @todo #261
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragMove = function(event) {
		var minimum = null,
			maximum = null,
			pull = null,
			delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this.difference(this._drag.stage.start, delta);

		if (!this.is('dragging')) {
			return;
		}

		event.preventDefault();

		if (this.settings.loop) {
			minimum = this.coordinates(this.minimum());
			maximum = this.coordinates(this.maximum() + 1) - minimum;
			stage.x = (((stage.x - minimum) % maximum + maximum) % maximum) + minimum;
		} else {
			minimum = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum());
			maximum = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum());
			pull = this.settings.pullDrag ? -1 * delta.x / 5 : 0;
			stage.x = Math.max(Math.min(stage.x, minimum + pull), maximum + pull);
		}

		this._drag.stage.current = stage;

		this.animate(stage.x);
	};

	/**
	 * Handles the `touchend` and `mouseup` events.
	 * @todo #261
	 * @todo Threshold for click event
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onDragEnd = function(event) {
		var delta = this.difference(this._drag.pointer, this.pointer(event)),
			stage = this._drag.stage.current,
			direction = delta.x > 0 ^ this.settings.rtl ? 'left' : 'right';

		$(document).off('.owl.core');

		this.$element.removeClass(this.options.grabClass);

		if (delta.x !== 0 && this.is('dragging') || !this.is('valid')) {
			this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed);
			this.current(this.closest(stage.x, delta.x !== 0 ? direction : this._drag.direction));
			this.invalidate('position');
			this.update();

			this._drag.direction = direction;

			if (Math.abs(delta.x) > 3 || new Date().getTime() - this._drag.time > 300) {
				this._drag.target.one('click.owl.core', function() { return false; });
			}
		}

		if (!this.is('dragging')) {
			return;
		}

		this.leave('dragging');
		this.trigger('dragged');
	};

	/**
	 * Gets absolute position of the closest item for a coordinate.
	 * @todo Setting `freeDrag` makes `closest` not reusable. See #165.
	 * @protected
	 * @param {Number} coordinate - The coordinate in pixel.
	 * @param {String} direction - The direction to check for the closest item. Ether `left` or `right`.
	 * @return {Number} - The absolute position of the closest item.
	 */
	Owl.prototype.closest = function(coordinate, direction) {
		var position = -1,
			pull = 30,
			width = this.width(),
			coordinates = this.coordinates();

		if (!this.settings.freeDrag) {
			// check closest item
			$.each(coordinates, $.proxy(function(index, value) {
				// on a left pull, check on current index
				if (direction === 'left' && coordinate > value - pull && coordinate < value + pull) {
					position = index;
				// on a right pull, check on previous index
				// to do so, subtract width from value and set position = index + 1
				} else if (direction === 'right' && coordinate > value - width - pull && coordinate < value - width + pull) {
					position = index + 1;
				} else if (this.op(coordinate, '<', value)
					&& this.op(coordinate, '>', coordinates[index + 1] !== undefined ? coordinates[index + 1] : value - width)) {
					position = direction === 'left' ? index + 1 : index;
				}
				return position === -1;
			}, this));
		}

		if (!this.settings.loop) {
			// non loop boundries
			if (this.op(coordinate, '>', coordinates[this.minimum()])) {
				position = coordinate = this.minimum();
			} else if (this.op(coordinate, '<', coordinates[this.maximum()])) {
				position = coordinate = this.maximum();
			}
		}

		return position;
	};

	/**
	 * Animates the stage.
	 * @todo #270
	 * @public
	 * @param {Number} coordinate - The coordinate in pixels.
	 */
	Owl.prototype.animate = function(coordinate) {
		var animate = this.speed() > 0;

		this.is('animating') && this.onTransitionEnd();

		if (animate) {
			this.enter('animating');
			this.trigger('translate');
		}

		if ($.support.transform3d && $.support.transition) {
			this.$stage.css({
				transform: 'translate3d(' + coordinate + 'px,0px,0px)',
				transition: (this.speed() / 1000) + 's' + (
					this.settings.slideTransition ? ' ' + this.settings.slideTransition : ''
				)
			});
		} else if (animate) {
			this.$stage.animate({
				left: coordinate + 'px'
			}, this.speed(), this.settings.fallbackEasing, $.proxy(this.onTransitionEnd, this));
		} else {
			this.$stage.css({
				left: coordinate + 'px'
			});
		}
	};

	/**
	 * Checks whether the carousel is in a specific state or not.
	 * @param {String} state - The state to check.
	 * @returns {Boolean} - The flag which indicates if the carousel is busy.
	 */
	Owl.prototype.is = function(state) {
		return this._states.current[state] && this._states.current[state] > 0;
	};

	/**
	 * Sets the absolute position of the current item.
	 * @public
	 * @param {Number} [position] - The new absolute position or nothing to leave it unchanged.
	 * @returns {Number} - The absolute position of the current item.
	 */
	Owl.prototype.current = function(position) {
		if (position === undefined) {
			return this._current;
		}

		if (this._items.length === 0) {
			return undefined;
		}

		position = this.normalize(position);

		if (this._current !== position) {
			var event = this.trigger('change', { property: { name: 'position', value: position } });

			if (event.data !== undefined) {
				position = this.normalize(event.data);
			}

			this._current = position;

			this.invalidate('position');

			this.trigger('changed', { property: { name: 'position', value: this._current } });
		}

		return this._current;
	};

	/**
	 * Invalidates the given part of the update routine.
	 * @param {String} [part] - The part to invalidate.
	 * @returns {Array.<String>} - The invalidated parts.
	 */
	Owl.prototype.invalidate = function(part) {
		if ($.type(part) === 'string') {
			this._invalidated[part] = true;
			this.is('valid') && this.leave('valid');
		}
		return $.map(this._invalidated, function(v, i) { return i });
	};

	/**
	 * Resets the absolute position of the current item.
	 * @public
	 * @param {Number} position - The absolute position of the new item.
	 */
	Owl.prototype.reset = function(position) {
		position = this.normalize(position);

		if (position === undefined) {
			return;
		}

		this._speed = 0;
		this._current = position;

		this.suppress([ 'translate', 'translated' ]);

		this.animate(this.coordinates(position));

		this.release([ 'translate', 'translated' ]);
	};

	/**
	 * Normalizes an absolute or a relative position of an item.
	 * @public
	 * @param {Number} position - The absolute or relative position to normalize.
	 * @param {Boolean} [relative=false] - Whether the given position is relative or not.
	 * @returns {Number} - The normalized position.
	 */
	Owl.prototype.normalize = function(position, relative) {
		var n = this._items.length,
			m = relative ? 0 : this._clones.length;

		if (!this.isNumeric(position) || n < 1) {
			position = undefined;
		} else if (position < 0 || position >= n + m) {
			position = ((position - m / 2) % n + n) % n + m / 2;
		}

		return position;
	};

	/**
	 * Converts an absolute position of an item into a relative one.
	 * @public
	 * @param {Number} position - The absolute position to convert.
	 * @returns {Number} - The converted position.
	 */
	Owl.prototype.relative = function(position) {
		position -= this._clones.length / 2;
		return this.normalize(position, true);
	};

	/**
	 * Gets the maximum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.maximum = function(relative) {
		var settings = this.settings,
			maximum = this._coordinates.length,
			iterator,
			reciprocalItemsWidth,
			elementWidth;

		if (settings.loop) {
			maximum = this._clones.length / 2 + this._items.length - 1;
		} else if (settings.autoWidth || settings.merge) {
			iterator = this._items.length;
			if (iterator) {
				reciprocalItemsWidth = this._items[--iterator].width();
				elementWidth = this.$element.width();
				while (iterator--) {
					reciprocalItemsWidth += this._items[iterator].width() + this.settings.margin;
					if (reciprocalItemsWidth > elementWidth) {
						break;
					}
				}
			}
			maximum = iterator + 1;
		} else if (settings.center) {
			maximum = this._items.length - 1;
		} else {
			maximum = this._items.length - settings.items;
		}

		if (relative) {
			maximum -= this._clones.length / 2;
		}

		return Math.max(maximum, 0);
	};

	/**
	 * Gets the minimum position for the current item.
	 * @public
	 * @param {Boolean} [relative=false] - Whether to return an absolute position or a relative position.
	 * @returns {Number}
	 */
	Owl.prototype.minimum = function(relative) {
		return relative ? 0 : this._clones.length / 2;
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.items = function(position) {
		if (position === undefined) {
			return this._items.slice();
		}

		position = this.normalize(position, true);
		return this._items[position];
	};

	/**
	 * Gets an item at the specified relative position.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @return {jQuery|Array.<jQuery>} - The item at the given position or all items if no position was given.
	 */
	Owl.prototype.mergers = function(position) {
		if (position === undefined) {
			return this._mergers.slice();
		}

		position = this.normalize(position, true);
		return this._mergers[position];
	};

	/**
	 * Gets the absolute positions of clones for an item.
	 * @public
	 * @param {Number} [position] - The relative position of the item.
	 * @returns {Array.<Number>} - The absolute positions of clones for the item or all if no position was given.
	 */
	Owl.prototype.clones = function(position) {
		var odd = this._clones.length / 2,
			even = odd + this._items.length,
			map = function(index) { return index % 2 === 0 ? even + index / 2 : odd - (index + 1) / 2 };

		if (position === undefined) {
			return $.map(this._clones, function(v, i) { return map(i) });
		}

		return $.map(this._clones, function(v, i) { return v === position ? map(i) : null });
	};

	/**
	 * Sets the current animation speed.
	 * @public
	 * @param {Number} [speed] - The animation speed in milliseconds or nothing to leave it unchanged.
	 * @returns {Number} - The current animation speed in milliseconds.
	 */
	Owl.prototype.speed = function(speed) {
		if (speed !== undefined) {
			this._speed = speed;
		}

		return this._speed;
	};

	/**
	 * Gets the coordinate of an item.
	 * @todo The name of this method is missleanding.
	 * @public
	 * @param {Number} position - The absolute position of the item within `minimum()` and `maximum()`.
	 * @returns {Number|Array.<Number>} - The coordinate of the item in pixel or all coordinates.
	 */
	Owl.prototype.coordinates = function(position) {
		var multiplier = 1,
			newPosition = position - 1,
			coordinate;

		if (position === undefined) {
			return $.map(this._coordinates, $.proxy(function(coordinate, index) {
				return this.coordinates(index);
			}, this));
		}

		if (this.settings.center) {
			if (this.settings.rtl) {
				multiplier = -1;
				newPosition = position + 1;
			}

			coordinate = this._coordinates[position];
			coordinate += (this.width() - coordinate + (this._coordinates[newPosition] || 0)) / 2 * multiplier;
		} else {
			coordinate = this._coordinates[newPosition] || 0;
		}

		coordinate = Math.ceil(coordinate);

		return coordinate;
	};

	/**
	 * Calculates the speed for a translation.
	 * @protected
	 * @param {Number} from - The absolute position of the start item.
	 * @param {Number} to - The absolute position of the target item.
	 * @param {Number} [factor=undefined] - The time factor in milliseconds.
	 * @returns {Number} - The time in milliseconds for the translation.
	 */
	Owl.prototype.duration = function(from, to, factor) {
		if (factor === 0) {
			return 0;
		}

		return Math.min(Math.max(Math.abs(to - from), 1), 6) * Math.abs((factor || this.settings.smartSpeed));
	};

	/**
	 * Slides to the specified item.
	 * @public
	 * @param {Number} position - The position of the item.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.to = function(position, speed) {
		var current = this.current(),
			revert = null,
			distance = position - this.relative(current),
			direction = (distance > 0) - (distance < 0),
			items = this._items.length,
			minimum = this.minimum(),
			maximum = this.maximum();

		if (this.settings.loop) {
			if (!this.settings.rewind && Math.abs(distance) > items / 2) {
				distance += direction * -1 * items;
			}

			position = current + distance;
			revert = ((position - minimum) % items + items) % items + minimum;

			if (revert !== position && revert - distance <= maximum && revert - distance > 0) {
				current = revert - distance;
				position = revert;
				this.reset(current);
			}
		} else if (this.settings.rewind) {
			maximum += 1;
			position = (position % maximum + maximum) % maximum;
		} else {
			position = Math.max(minimum, Math.min(maximum, position));
		}

		this.speed(this.duration(current, position, speed));
		this.current(position);

		if (this.isVisible()) {
			this.update();
		}
	};

	/**
	 * Slides to the next item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.next = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) + 1, speed);
	};

	/**
	 * Slides to the previous item.
	 * @public
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 */
	Owl.prototype.prev = function(speed) {
		speed = speed || false;
		this.to(this.relative(this.current()) - 1, speed);
	};

	/**
	 * Handles the end of an animation.
	 * @protected
	 * @param {Event} event - The event arguments.
	 */
	Owl.prototype.onTransitionEnd = function(event) {

		// if css2 animation then event object is undefined
		if (event !== undefined) {
			event.stopPropagation();

			// Catch only owl-stage transitionEnd event
			if ((event.target || event.srcElement || event.originalTarget) !== this.$stage.get(0)) {
				return false;
			}
		}

		this.leave('animating');
		this.trigger('translated');
	};

	/**
	 * Gets viewport width.
	 * @protected
	 * @return {Number} - The width in pixel.
	 */
	Owl.prototype.viewport = function() {
		var width;
		if (this.options.responsiveBaseElement !== window) {
			width = $(this.options.responsiveBaseElement).width();
		} else if (window.innerWidth) {
			width = window.innerWidth;
		} else if (document.documentElement && document.documentElement.clientWidth) {
			width = document.documentElement.clientWidth;
		} else {
			console.warn('Can not detect viewport width.');
		}
		return width;
	};

	/**
	 * Replaces the current content.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The new content.
	 */
	Owl.prototype.replace = function(content) {
		this.$stage.empty();
		this._items = [];

		if (content) {
			content = (content instanceof jQuery) ? content : $(content);
		}

		if (this.settings.nestedItemSelector) {
			content = content.find('.' + this.settings.nestedItemSelector);
		}

		content.filter(function() {
			return this.nodeType === 1;
		}).each($.proxy(function(index, item) {
			item = this.prepare(item);
			this.$stage.append(item);
			this._items.push(item);
			this._mergers.push(item.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}, this));

		this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0);

		this.invalidate('items');
	};

	/**
	 * Adds an item.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {HTMLElement|jQuery|String} content - The item content to add.
	 * @param {Number} [position] - The relative position at which to insert the item otherwise the item will be added to the end.
	 */
	Owl.prototype.add = function(content, position) {
		var current = this.relative(this._current);

		position = position === undefined ? this._items.length : this.normalize(position, true);
		content = content instanceof jQuery ? content : $(content);

		this.trigger('add', { content: content, position: position });

		content = this.prepare(content);

		if (this._items.length === 0 || position === this._items.length) {
			this._items.length === 0 && this.$stage.append(content);
			this._items.length !== 0 && this._items[position - 1].after(content);
			this._items.push(content);
			this._mergers.push(content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		} else {
			this._items[position].before(content);
			this._items.splice(position, 0, content);
			this._mergers.splice(position, 0, content.find('[data-merge]').addBack('[data-merge]').attr('data-merge') * 1 || 1);
		}

		this._items[current] && this.reset(this._items[current].index());

		this.invalidate('items');

		this.trigger('added', { content: content, position: position });
	};

	/**
	 * Removes an item by its position.
	 * @todo Use `item` instead of `content` for the event arguments.
	 * @public
	 * @param {Number} position - The relative position of the item to remove.
	 */
	Owl.prototype.remove = function(position) {
		position = this.normalize(position, true);

		if (position === undefined) {
			return;
		}

		this.trigger('remove', { content: this._items[position], position: position });

		this._items[position].remove();
		this._items.splice(position, 1);
		this._mergers.splice(position, 1);

		this.invalidate('items');

		this.trigger('removed', { content: null, position: position });
	};

	/**
	 * Preloads images with auto width.
	 * @todo Replace by a more generic approach
	 * @protected
	 */
	Owl.prototype.preloadAutoWidthImages = function(images) {
		images.each($.proxy(function(i, element) {
			this.enter('pre-loading');
			element = $(element);
			$(new Image()).one('load', $.proxy(function(e) {
				element.attr('src', e.target.src);
				element.css('opacity', 1);
				this.leave('pre-loading');
				!this.is('pre-loading') && !this.is('initializing') && this.refresh();
			}, this)).attr('src', element.attr('src') || element.attr('data-src') || element.attr('data-src-retina'));
		}, this));
	};

	/**
	 * Destroys the carousel.
	 * @public
	 */
	Owl.prototype.destroy = function() {

		this.$element.off('.owl.core');
		this.$stage.off('.owl.core');
		$(document).off('.owl.core');

		if (this.settings.responsive !== false) {
			window.clearTimeout(this.resizeTimer);
			this.off(window, 'resize', this._handlers.onThrottledResize);
		}

		for (var i in this._plugins) {
			this._plugins[i].destroy();
		}

		this.$stage.children('.cloned').remove();

		this.$stage.unwrap();
		this.$stage.children().contents().unwrap();
		this.$stage.children().unwrap();
		this.$stage.remove();
		this.$element
			.removeClass(this.options.refreshClass)
			.removeClass(this.options.loadingClass)
			.removeClass(this.options.loadedClass)
			.removeClass(this.options.rtlClass)
			.removeClass(this.options.dragClass)
			.removeClass(this.options.grabClass)
			.attr('class', this.$element.attr('class').replace(new RegExp(this.options.responsiveClass + '-\\S+\\s', 'g'), ''))
			.removeData('owl.carousel');
	};

	/**
	 * Operators to calculate right-to-left and left-to-right.
	 * @protected
	 * @param {Number} [a] - The left side operand.
	 * @param {String} [o] - The operator.
	 * @param {Number} [b] - The right side operand.
	 */
	Owl.prototype.op = function(a, o, b) {
		var rtl = this.settings.rtl;
		switch (o) {
			case '<':
				return rtl ? a > b : a < b;
			case '>':
				return rtl ? a < b : a > b;
			case '>=':
				return rtl ? a <= b : a >= b;
			case '<=':
				return rtl ? a >= b : a <= b;
			default:
				break;
		}
	};

	/**
	 * Attaches to an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The event handler to attach.
	 * @param {Boolean} capture - Wether the event should be handled at the capturing phase or not.
	 */
	Owl.prototype.on = function(element, event, listener, capture) {
		if (element.addEventListener) {
			element.addEventListener(event, listener, capture);
		} else if (element.attachEvent) {
			element.attachEvent('on' + event, listener);
		}
	};

	/**
	 * Detaches from an internal event.
	 * @protected
	 * @param {HTMLElement} element - The event source.
	 * @param {String} event - The event name.
	 * @param {Function} listener - The attached event handler to detach.
	 * @param {Boolean} capture - Wether the attached event handler was registered as a capturing listener or not.
	 */
	Owl.prototype.off = function(element, event, listener, capture) {
		if (element.removeEventListener) {
			element.removeEventListener(event, listener, capture);
		} else if (element.detachEvent) {
			element.detachEvent('on' + event, listener);
		}
	};

	/**
	 * Triggers a public event.
	 * @todo Remove `status`, `relatedTarget` should be used instead.
	 * @protected
	 * @param {String} name - The event name.
	 * @param {*} [data=null] - The event data.
	 * @param {String} [namespace=carousel] - The event namespace.
	 * @param {String} [state] - The state which is associated with the event.
	 * @param {Boolean} [enter=false] - Indicates if the call enters the specified state or not.
	 * @returns {Event} - The event arguments.
	 */
	Owl.prototype.trigger = function(name, data, namespace, state, enter) {
		var status = {
			item: { count: this._items.length, index: this.current() }
		}, handler = $.camelCase(
			$.grep([ 'on', name, namespace ], function(v) { return v })
				.join('-').toLowerCase()
		), event = $.Event(
			[ name, 'owl', namespace || 'carousel' ].join('.').toLowerCase(),
			$.extend({ relatedTarget: this }, status, data)
		);

		if (!this._supress[name]) {
			$.each(this._plugins, function(name, plugin) {
				if (plugin.onTrigger) {
					plugin.onTrigger(event);
				}
			});

			this.register({ type: Owl.Type.Event, name: name });
			this.$element.trigger(event);

			if (this.settings && typeof this.settings[handler] === 'function') {
				this.settings[handler].call(this, event);
			}
		}

		return event;
	};

	/**
	 * Enters a state.
	 * @param name - The state name.
	 */
	Owl.prototype.enter = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			if (this._states.current[name] === undefined) {
				this._states.current[name] = 0;
			}

			this._states.current[name]++;
		}, this));
	};

	/**
	 * Leaves a state.
	 * @param name - The state name.
	 */
	Owl.prototype.leave = function(name) {
		$.each([ name ].concat(this._states.tags[name] || []), $.proxy(function(i, name) {
			this._states.current[name]--;
		}, this));
	};

	/**
	 * Registers an event or state.
	 * @public
	 * @param {Object} object - The event or state to register.
	 */
	Owl.prototype.register = function(object) {
		if (object.type === Owl.Type.Event) {
			if (!$.event.special[object.name]) {
				$.event.special[object.name] = {};
			}

			if (!$.event.special[object.name].owl) {
				var _default = $.event.special[object.name]._default;
				$.event.special[object.name]._default = function(e) {
					if (_default && _default.apply && (!e.namespace || e.namespace.indexOf('owl') === -1)) {
						return _default.apply(this, arguments);
					}
					return e.namespace && e.namespace.indexOf('owl') > -1;
				};
				$.event.special[object.name].owl = true;
			}
		} else if (object.type === Owl.Type.State) {
			if (!this._states.tags[object.name]) {
				this._states.tags[object.name] = object.tags;
			} else {
				this._states.tags[object.name] = this._states.tags[object.name].concat(object.tags);
			}

			this._states.tags[object.name] = $.grep(this._states.tags[object.name], $.proxy(function(tag, i) {
				return $.inArray(tag, this._states.tags[object.name]) === i;
			}, this));
		}
	};

	/**
	 * Suppresses events.
	 * @protected
	 * @param {Array.<String>} events - The events to suppress.
	 */
	Owl.prototype.suppress = function(events) {
		$.each(events, $.proxy(function(index, event) {
			this._supress[event] = true;
		}, this));
	};

	/**
	 * Releases suppressed events.
	 * @protected
	 * @param {Array.<String>} events - The events to release.
	 */
	Owl.prototype.release = function(events) {
		$.each(events, $.proxy(function(index, event) {
			delete this._supress[event];
		}, this));
	};

	/**
	 * Gets unified pointer coordinates from event.
	 * @todo #261
	 * @protected
	 * @param {Event} - The `mousedown` or `touchstart` event.
	 * @returns {Object} - Contains `x` and `y` coordinates of current pointer position.
	 */
	Owl.prototype.pointer = function(event) {
		var result = { x: null, y: null };

		event = event.originalEvent || event || window.event;

		event = event.touches && event.touches.length ?
			event.touches[0] : event.changedTouches && event.changedTouches.length ?
				event.changedTouches[0] : event;

		if (event.pageX) {
			result.x = event.pageX;
			result.y = event.pageY;
		} else {
			result.x = event.clientX;
			result.y = event.clientY;
		}

		return result;
	};

	/**
	 * Determines if the input is a Number or something that can be coerced to a Number
	 * @protected
	 * @param {Number|String|Object|Array|Boolean|RegExp|Function|Symbol} - The input to be tested
	 * @returns {Boolean} - An indication if the input is a Number or can be coerced to a Number
	 */
	Owl.prototype.isNumeric = function(number) {
		return !isNaN(parseFloat(number));
	};

	/**
	 * Gets the difference of two vectors.
	 * @todo #261
	 * @protected
	 * @param {Object} - The first vector.
	 * @param {Object} - The second vector.
	 * @returns {Object} - The difference.
	 */
	Owl.prototype.difference = function(first, second) {
		return {
			x: first.x - second.x,
			y: first.y - second.y
		};
	};

	/**
	 * The jQuery Plugin for the Owl Carousel
	 * @todo Navigation plugin `next` and `prev`
	 * @public
	 */
	$.fn.owlCarousel = function(option) {
		var args = Array.prototype.slice.call(arguments, 1);

		return this.each(function() {
			var $this = $(this),
				data = $this.data('owl.carousel');

			if (!data) {
				data = new Owl(this, typeof option == 'object' && option);
				$this.data('owl.carousel', data);

				$.each([
					'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
				], function(i, event) {
					data.register({ type: Owl.Type.Event, name: event });
					data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
						if (e.namespace && e.relatedTarget !== this) {
							this.suppress([ event ]);
							data[event].apply(this, [].slice.call(arguments, 1));
							this.release([ event ]);
						}
					}, data));
				});
			}

			if (typeof option == 'string' && option.charAt(0) !== '_') {
				data[option].apply(data, args);
			}
		});
	};

	/**
	 * The constructor for the jQuery Plugin
	 * @public
	 */
	$.fn.owlCarousel.Constructor = Owl;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * AutoRefresh Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto refresh plugin.
	 * @class The Auto Refresh Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoRefresh = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Refresh interval.
		 * @protected
		 * @type {number}
		 */
		this._interval = null;

		/**
		 * Whether the element is currently visible or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._visible = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoRefresh) {
					this.watch();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoRefresh.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	AutoRefresh.Defaults = {
		autoRefresh: true,
		autoRefreshInterval: 500
	};

	/**
	 * Watches the element.
	 */
	AutoRefresh.prototype.watch = function() {
		if (this._interval) {
			return;
		}

		this._visible = this._core.isVisible();
		this._interval = window.setInterval($.proxy(this.refresh, this), this._core.settings.autoRefreshInterval);
	};

	/**
	 * Refreshes the element.
	 */
	AutoRefresh.prototype.refresh = function() {
		if (this._core.isVisible() === this._visible) {
			return;
		}

		this._visible = !this._visible;

		this._core.$element.toggleClass('owl-hidden', !this._visible);

		this._visible && (this._core.invalidate('width') && this._core.refresh());
	};

	/**
	 * Destroys the plugin.
	 */
	AutoRefresh.prototype.destroy = function() {
		var handler, property;

		window.clearInterval(this._interval);

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoRefresh = AutoRefresh;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Lazy Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the lazy plugin.
	 * @class The Lazy Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Lazy = function(carousel) {

		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Already loaded items.
		 * @protected
		 * @type {Array.<jQuery>}
		 */
		this._loaded = [];

		/**
		 * Event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel change.owl.carousel resized.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				if (!this._core.settings || !this._core.settings.lazyLoad) {
					return;
				}

				if ((e.property && e.property.name == 'position') || e.type == 'initialized') {
					var settings = this._core.settings,
						n = (settings.center && Math.ceil(settings.items / 2) || settings.items),
						i = ((settings.center && n * -1) || 0),
						position = (e.property && e.property.value !== undefined ? e.property.value : this._core.current()) + i,
						clones = this._core.clones().length,
						load = $.proxy(function(i, v) { this.load(v) }, this);
					//TODO: Need documentation for this new option
					if (settings.lazyLoadEager > 0) {
						n += settings.lazyLoadEager;
						// If the carousel is looping also preload images that are to the "left"
						if (settings.loop) {
              position -= settings.lazyLoadEager;
              n++;
            }
					}

					while (i++ < n) {
						this.load(clones / 2 + this._core.relative(position));
						clones && $.each(this._core.clones(this._core.relative(position)), load);
						position++;
					}
				}
			}, this)
		};

		// set the default options
		this._core.options = $.extend({}, Lazy.Defaults, this._core.options);

		// register event handler
		this._core.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Lazy.Defaults = {
		lazyLoad: false,
		lazyLoadEager: 0
	};

	/**
	 * Loads all resources of an item at the specified position.
	 * @param {Number} position - The absolute position of the item.
	 * @protected
	 */
	Lazy.prototype.load = function(position) {
		var $item = this._core.$stage.children().eq(position),
			$elements = $item && $item.find('.owl-lazy');

		if (!$elements || $.inArray($item.get(0), this._loaded) > -1) {
			return;
		}

		$elements.each($.proxy(function(index, element) {
			var $element = $(element), image,
                url = (window.devicePixelRatio > 1 && $element.attr('data-src-retina')) || $element.attr('data-src') || $element.attr('data-srcset');

			this._core.trigger('load', { element: $element, url: url }, 'lazy');

			if ($element.is('img')) {
				$element.one('load.owl.lazy', $.proxy(function() {
					$element.css('opacity', 1);
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this)).attr('src', url);
            } else if ($element.is('source')) {
                $element.one('load.owl.lazy', $.proxy(function() {
                    this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
                }, this)).attr('srcset', url);
			} else {
				image = new Image();
				image.onload = $.proxy(function() {
					$element.css({
						'background-image': 'url("' + url + '")',
						'opacity': '1'
					});
					this._core.trigger('loaded', { element: $element, url: url }, 'lazy');
				}, this);
				image.src = url;
			}
		}, this));

		this._loaded.push($item.get(0));
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Lazy.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this._core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Lazy = Lazy;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * AutoHeight Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the auto height plugin.
	 * @class The Auto Height Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var AutoHeight = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		this._previousHeight = null;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight) {
					this.update();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight && e.property.name === 'position'){
					this.update();
				}
			}, this),
			'loaded.owl.lazy': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoHeight
					&& e.element.closest('.' + this._core.settings.itemClass).index() === this._core.current()) {
					this.update();
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, AutoHeight.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);
		this._intervalId = null;
		var refThis = this;

		// These changes have been taken from a PR by gavrochelegnou proposed in #1575
		// and have been made compatible with the latest jQuery version
		$(window).on('load', function() {
			if (refThis._core.settings.autoHeight) {
				refThis.update();
			}
		});

		// Autoresize the height of the carousel when window is resized
		// When carousel has images, the height is dependent on the width
		// and should also change on resize
		$(window).resize(function() {
			if (refThis._core.settings.autoHeight) {
				if (refThis._intervalId != null) {
					clearTimeout(refThis._intervalId);
				}

				refThis._intervalId = setTimeout(function() {
					refThis.update();
				}, 250);
			}
		});

	};

	/**
	 * Default options.
	 * @public
	 */
	AutoHeight.Defaults = {
		autoHeight: false,
		autoHeightClass: 'owl-height'
	};

	/**
	 * Updates the view.
	 */
	AutoHeight.prototype.update = function() {
		var start = this._core._current,
			end = start + this._core.settings.items,
			lazyLoadEnabled = this._core.settings.lazyLoad,
			visible = this._core.$stage.children().toArray().slice(start, end),
			heights = [],
			maxheight = 0;

		$.each(visible, function(index, item) {
			heights.push($(item).height());
		});

		maxheight = Math.max.apply(null, heights);

		if (maxheight <= 1 && lazyLoadEnabled && this._previousHeight) {
			maxheight = this._previousHeight;
		}

		this._previousHeight = maxheight;

		this._core.$stage.parent()
			.height(maxheight)
			.addClass(this._core.settings.autoHeightClass);
	};

	AutoHeight.prototype.destroy = function() {
		var handler, property;

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] !== 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.AutoHeight = AutoHeight;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Video Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the video plugin.
	 * @class The Video Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Video = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Cache all video URLs.
		 * @protected
		 * @type {Object}
		 */
		this._videos = {};

		/**
		 * Current playing item.
		 * @protected
		 * @type {jQuery}
		 */
		this._playing = null;

		/**
		 * All event handlers.
		 * @todo The cloned content removale is too late
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this._core.register({ type: 'state', name: 'playing', tags: [ 'interacting' ] });
				}
			}, this),
			'resize.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.video && this.isInFullScreen()) {
					e.preventDefault();
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.is('resizing')) {
					this._core.$stage.find('.cloned .owl-video-frame').remove();
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position' && this._playing) {
					this.stop();
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (!e.namespace) {
					return;
				}

				var $element = $(e.content).find('.owl-video');

				if ($element.length) {
					$element.css('display', 'none');
					this.fetch($element, $(e.content));
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Video.Defaults, this._core.options);

		// register event handlers
		this._core.$element.on(this._handlers);

		this._core.$element.on('click.owl.video', '.owl-video-play-icon', $.proxy(function(e) {
			this.play(e);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Video.Defaults = {
		video: false,
		videoHeight: false,
		videoWidth: false
	};

	/**
	 * Gets the video ID and the type (YouTube/Vimeo/vzaar only).
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {jQuery} item - The item containing the video.
	 */
	Video.prototype.fetch = function(target, item) {
			var type = (function() {
					if (target.attr('data-vimeo-id')) {
						return 'vimeo';
					} else if (target.attr('data-vzaar-id')) {
						return 'vzaar'
					} else {
						return 'youtube';
					}
				})(),
				id = target.attr('data-vimeo-id') || target.attr('data-youtube-id') || target.attr('data-vzaar-id'),
				width = target.attr('data-width') || this._core.settings.videoWidth,
				height = target.attr('data-height') || this._core.settings.videoHeight,
				url = target.attr('href');

		if (url) {

			/*
					Parses the id's out of the following urls (and probably more):
					https://www.youtube.com/watch?v=:id
					https://youtu.be/:id
					https://vimeo.com/:id
					https://vimeo.com/channels/:channel/:id
					https://vimeo.com/groups/:group/videos/:id
					https://app.vzaar.com/videos/:id

					Visual example: https://regexper.com/#(http%3A%7Chttps%3A%7C)%5C%2F%5C%2F(player.%7Cwww.%7Capp.)%3F(vimeo%5C.com%7Cyoutu(be%5C.com%7C%5C.be%7Cbe%5C.googleapis%5C.com)%7Cvzaar%5C.com)%5C%2F(video%5C%2F%7Cvideos%5C%2F%7Cembed%5C%2F%7Cchannels%5C%2F.%2B%5C%2F%7Cgroups%5C%2F.%2B%5C%2F%7Cwatch%5C%3Fv%3D%7Cv%5C%2F)%3F(%5BA-Za-z0-9._%25-%5D*)(%5C%26%5CS%2B)%3F
			*/

			id = url.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

			if (id[3].indexOf('youtu') > -1) {
				type = 'youtube';
			} else if (id[3].indexOf('vimeo') > -1) {
				type = 'vimeo';
			} else if (id[3].indexOf('vzaar') > -1) {
				type = 'vzaar';
			} else {
				throw new Error('Video URL not supported.');
			}
			id = id[6];
		} else {
			throw new Error('Missing video URL.');
		}

		this._videos[url] = {
			type: type,
			id: id,
			width: width,
			height: height
		};

		item.attr('data-video', url);

		this.thumbnail(target, this._videos[url]);
	};

	/**
	 * Creates video thumbnail.
	 * @protected
	 * @param {jQuery} target - The target containing the video data.
	 * @param {Object} info - The video info object.
	 * @see `fetch`
	 */
	Video.prototype.thumbnail = function(target, video) {
		var tnLink,
			icon,
			path,
			dimensions = video.width && video.height ? 'width:' + video.width + 'px;height:' + video.height + 'px;' : '',
			customTn = target.find('img'),
			srcType = 'src',
			lazyClass = '',
			settings = this._core.settings,
			create = function(path) {
				icon = '<div class="owl-video-play-icon"></div>';

				if (settings.lazyLoad) {
					tnLink = $('<div/>',{
						"class": 'owl-video-tn ' + lazyClass,
						"srcType": path
					});
				} else {
					tnLink = $( '<div/>', {
						"class": "owl-video-tn",
						"style": 'opacity:1;background-image:url(' + path + ')'
					});
				}
				target.after(tnLink);
				target.after(icon);
			};

		// wrap video content into owl-video-wrapper div
		target.wrap( $( '<div/>', {
			"class": "owl-video-wrapper",
			"style": dimensions
		}));

		if (this._core.settings.lazyLoad) {
			srcType = 'data-src';
			lazyClass = 'owl-lazy';
		}

		// custom thumbnail
		if (customTn.length) {
			create(customTn.attr(srcType));
			customTn.remove();
			return false;
		}

		if (video.type === 'youtube') {
			path = "//img.youtube.com/vi/" + video.id + "/hqdefault.jpg";
			create(path);
		} else if (video.type === 'vimeo') {
			$.ajax({
				type: 'GET',
				url: '//vimeo.com/api/v2/video/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data[0].thumbnail_large;
					create(path);
				}
			});
		} else if (video.type === 'vzaar') {
			$.ajax({
				type: 'GET',
				url: '//vzaar.com/api/videos/' + video.id + '.json',
				jsonp: 'callback',
				dataType: 'jsonp',
				success: function(data) {
					path = data.framegrab_url;
					create(path);
				}
			});
		}
	};

	/**
	 * Stops the current video.
	 * @public
	 */
	Video.prototype.stop = function() {
		this._core.trigger('stop', null, 'video');
		this._playing.find('.owl-video-frame').remove();
		this._playing.removeClass('owl-video-playing');
		this._playing = null;
		this._core.leave('playing');
		this._core.trigger('stopped', null, 'video');
	};

	/**
	 * Starts the current video.
	 * @public
	 * @param {Event} event - The event arguments.
	 */
	Video.prototype.play = function(event) {
		var target = $(event.target),
			item = target.closest('.' + this._core.settings.itemClass),
			video = this._videos[item.attr('data-video')],
			width = video.width || '100%',
			height = video.height || this._core.$stage.height(),
			html,
			iframe;

		if (this._playing) {
			return;
		}

		this._core.enter('playing');
		this._core.trigger('play', null, 'video');

		item = this._core.items(this._core.relative(item.index()));

		this._core.reset(item.index());

		html = $( '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>' );
		html.attr( 'height', height );
		html.attr( 'width', width );
		if (video.type === 'youtube') {
			html.attr( 'src', '//www.youtube.com/embed/' + video.id + '?autoplay=1&rel=0&v=' + video.id );
		} else if (video.type === 'vimeo') {
			html.attr( 'src', '//player.vimeo.com/video/' + video.id + '?autoplay=1' );
		} else if (video.type === 'vzaar') {
			html.attr( 'src', '//view.vzaar.com/' + video.id + '/player?autoplay=true' );
		}

		iframe = $(html).wrap( '<div class="owl-video-frame" />' ).insertAfter(item.find('.owl-video'));

		this._playing = item.addClass('owl-video-playing');
	};

	/**
	 * Checks whether an video is currently in full screen mode or not.
	 * @todo Bad style because looks like a readonly method but changes members.
	 * @protected
	 * @returns {Boolean}
	 */
	Video.prototype.isInFullScreen = function() {
		var element = document.fullscreenElement || document.mozFullScreenElement ||
				document.webkitFullscreenElement;

		return element && $(element).parent().hasClass('owl-video-frame');
	};

	/**
	 * Destroys the plugin.
	 */
	Video.prototype.destroy = function() {
		var handler, property;

		this._core.$element.off('click.owl.video');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Video = Video;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Animate Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the animate plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Animate = function(scope) {
		this.core = scope;
		this.core.options = $.extend({}, Animate.Defaults, this.core.options);
		this.swapping = true;
		this.previous = undefined;
		this.next = undefined;

		this.handlers = {
			'change.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.previous = this.core.current();
					this.next = e.property.value;
				}
			}, this),
			'drag.owl.carousel dragged.owl.carousel translated.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					this.swapping = e.type == 'translated';
				}
			}, this),
			'translate.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn)) {
					this.swap();
				}
			}, this)
		};

		this.core.$element.on(this.handlers);
	};

	/**
	 * Default options.
	 * @public
	 */
	Animate.Defaults = {
		animateOut: false,
		animateIn: false
	};

	/**
	 * Toggles the animation classes whenever an translations starts.
	 * @protected
	 * @returns {Boolean|undefined}
	 */
	Animate.prototype.swap = function() {

		if (this.core.settings.items !== 1) {
			return;
		}

		if (!$.support.animation || !$.support.transition) {
			return;
		}

		this.core.speed(0);

		var left,
			clear = $.proxy(this.clear, this),
			previous = this.core.$stage.children().eq(this.previous),
			next = this.core.$stage.children().eq(this.next),
			incoming = this.core.settings.animateIn,
			outgoing = this.core.settings.animateOut;

		if (this.core.current() === this.previous) {
			return;
		}

		if (outgoing) {
			left = this.core.coordinates(this.previous) - this.core.coordinates(this.next);
			previous.one($.support.animation.end, clear)
				.css( { 'left': left + 'px' } )
				.addClass('animated owl-animated-out')
				.addClass(outgoing);
		}

		if (incoming) {
			next.one($.support.animation.end, clear)
				.addClass('animated owl-animated-in')
				.addClass(incoming);
		}
	};

	Animate.prototype.clear = function(e) {
		$(e.target).css( { 'left': '' } )
			.removeClass('animated owl-animated-out owl-animated-in')
			.removeClass(this.core.settings.animateIn)
			.removeClass(this.core.settings.animateOut);
		this.core.onTransitionEnd();
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Animate.prototype.destroy = function() {
		var handler, property;

		for (handler in this.handlers) {
			this.core.$element.off(handler, this.handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Animate = Animate;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Autoplay Plugin
 * @version 2.3.4
 * @author Bartosz Wojciechowski
 * @author Artus Kolanowski
 * @author David Deutsch
 * @author Tom De Caluwé
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	/**
	 * Creates the autoplay plugin.
	 * @class The Autoplay Plugin
	 * @param {Owl} scope - The Owl Carousel
	 */
	var Autoplay = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * The autoplay timeout id.
		 * @type {Number}
		 */
		this._call = null;

		/**
		 * Depending on the state of the plugin, this variable contains either
		 * the start time of the timer or the current timer value if it's
		 * paused. Since we start in a paused state we initialize the timer
		 * value.
		 * @type {Number}
		 */
		this._time = 0;

		/**
		 * Stores the timeout currently used.
		 * @type {Number}
		 */
		this._timeout = 0;

		/**
		 * Indicates whenever the autoplay is paused.
		 * @type {Boolean}
		 */
		this._paused = true;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'settings') {
					if (this._core.settings.autoplay) {
						this.play();
					} else {
						this.stop();
					}
				} else if (e.namespace && e.property.name === 'position' && this._paused) {
					// Reset the timer. This code is triggered when the position
					// of the carousel was changed through user interaction.
					this._time = 0;
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.autoplay) {
					this.play();
				}
			}, this),
			'play.owl.autoplay': $.proxy(function(e, t, s) {
				if (e.namespace) {
					this.play(t, s);
				}
			}, this),
			'stop.owl.autoplay': $.proxy(function(e) {
				if (e.namespace) {
					this.stop();
				}
			}, this),
			'mouseover.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'mouseleave.owl.autoplay': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.play();
				}
			}, this),
			'touchstart.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause && this._core.is('rotating')) {
					this.pause();
				}
			}, this),
			'touchend.owl.core': $.proxy(function() {
				if (this._core.settings.autoplayHoverPause) {
					this.play();
				}
			}, this)
		};

		// register event handlers
		this._core.$element.on(this._handlers);

		// set default options
		this._core.options = $.extend({}, Autoplay.Defaults, this._core.options);
	};

	/**
	 * Default options.
	 * @public
	 */
	Autoplay.Defaults = {
		autoplay: false,
		autoplayTimeout: 5000,
		autoplayHoverPause: false,
		autoplaySpeed: false
	};

	/**
	 * Transition to the next slide and set a timeout for the next transition.
	 * @private
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype._next = function(speed) {
		this._call = window.setTimeout(
			$.proxy(this._next, this, speed),
			this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()
		);

		if (this._core.is('interacting') || document.hidden) {
			return;
		}
		this._core.next(speed || this._core.settings.autoplaySpeed);
	}

	/**
	 * Reads the current timer value when the timer is playing.
	 * @public
	 */
	Autoplay.prototype.read = function() {
		return new Date().getTime() - this._time;
	};

	/**
	 * Starts the autoplay.
	 * @public
	 * @param {Number} [timeout] - The interval before the next animation starts.
	 * @param {Number} [speed] - The animation speed for the animations.
	 */
	Autoplay.prototype.play = function(timeout, speed) {
		var elapsed;

		if (!this._core.is('rotating')) {
			this._core.enter('rotating');
		}

		timeout = timeout || this._core.settings.autoplayTimeout;

		// Calculate the elapsed time since the last transition. If the carousel
		// wasn't playing this calculation will yield zero.
		elapsed = Math.min(this._time % (this._timeout || timeout), timeout);

		if (this._paused) {
			// Start the clock.
			this._time = this.read();
			this._paused = false;
		} else {
			// Clear the active timeout to allow replacement.
			window.clearTimeout(this._call);
		}

		// Adjust the origin of the timer to match the new timeout value.
		this._time += this.read() % timeout - elapsed;

		this._timeout = timeout;
		this._call = window.setTimeout($.proxy(this._next, this, speed), timeout - elapsed);
	};

	/**
	 * Stops the autoplay.
	 * @public
	 */
	Autoplay.prototype.stop = function() {
		if (this._core.is('rotating')) {
			// Reset the clock.
			this._time = 0;
			this._paused = true;

			window.clearTimeout(this._call);
			this._core.leave('rotating');
		}
	};

	/**
	 * Pauses the autoplay.
	 * @public
	 */
	Autoplay.prototype.pause = function() {
		if (this._core.is('rotating') && !this._paused) {
			// Pause the clock.
			this._time = this.read();
			this._paused = true;

			window.clearTimeout(this._call);
		}
	};

	/**
	 * Destroys the plugin.
	 */
	Autoplay.prototype.destroy = function() {
		var handler, property;

		this.stop();

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Navigation Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the navigation plugin.
	 * @class The Navigation Plugin
	 * @param {Owl} carousel - The Owl Carousel.
	 */
	var Navigation = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Indicates whether the plugin is initialized or not.
		 * @protected
		 * @type {Boolean}
		 */
		this._initialized = false;

		/**
		 * The current paging indexes.
		 * @protected
		 * @type {Array}
		 */
		this._pages = [];

		/**
		 * All DOM elements of the user interface.
		 * @protected
		 * @type {Object}
		 */
		this._controls = {};

		/**
		 * Markup for an indicator.
		 * @protected
		 * @type {Array.<String>}
		 */
		this._templates = [];

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * Overridden methods of the carousel.
		 * @protected
		 * @type {Object}
		 */
		this._overrides = {
			next: this._core.next,
			prev: this._core.prev,
			to: this._core.to
		};

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.push('<div class="' + this._core.settings.dotClass + '">' +
						$(e.content).find('[data-dot]').addBack('[data-dot]').attr('data-dot') + '</div>');
				}
			}, this),
			'added.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 0, this._templates.pop());
				}
			}, this),
			'remove.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.dotsData) {
					this._templates.splice(e.position, 1);
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name == 'position') {
					this.draw();
				}
			}, this),
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && !this._initialized) {
					this._core.trigger('initialize', null, 'navigation');
					this.initialize();
					this.update();
					this.draw();
					this._initialized = true;
					this._core.trigger('initialized', null, 'navigation');
				}
			}, this),
			'refreshed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._initialized) {
					this._core.trigger('refresh', null, 'navigation');
					this.update();
					this.draw();
					this._core.trigger('refreshed', null, 'navigation');
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Navigation.Defaults, this._core.options);

		// register event handlers
		this.$element.on(this._handlers);
	};

	/**
	 * Default options.
	 * @public
	 * @todo Rename `slideBy` to `navBy`
	 */
	Navigation.Defaults = {
		nav: false,
		navText: [
			'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
			'<span aria-label="' + 'Next' + '">&#x203a;</span>'
		],
		navSpeed: false,
		navElement: 'button type="button" role="presentation"',
		navContainer: false,
		navContainerClass: 'owl-nav',
		navClass: [
			'owl-prev',
			'owl-next'
		],
		slideBy: 1,
		dotClass: 'owl-dot',
		dotsClass: 'owl-dots',
		dots: true,
		dotsEach: false,
		dotsData: false,
		dotsSpeed: false,
		dotsContainer: false
	};

	/**
	 * Initializes the layout of the plugin and extends the carousel.
	 * @protected
	 */
	Navigation.prototype.initialize = function() {
		var override,
			settings = this._core.settings;

		// create DOM structure for relative navigation
		this._controls.$relative = (settings.navContainer ? $(settings.navContainer)
			: $('<div>').addClass(settings.navContainerClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$previous = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[0])
			.html(settings.navText[0])
			.prependTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.prev(settings.navSpeed);
			}, this));
		this._controls.$next = $('<' + settings.navElement + '>')
			.addClass(settings.navClass[1])
			.html(settings.navText[1])
			.appendTo(this._controls.$relative)
			.on('click', $.proxy(function(e) {
				this.next(settings.navSpeed);
			}, this));

		// create DOM structure for absolute navigation
		if (!settings.dotsData) {
			this._templates = [ $('<button role="button">')
				.addClass(settings.dotClass)
				.append($('<span aria-label="Another Item">'))
				.prop('outerHTML') ];
		}

		this._controls.$absolute = (settings.dotsContainer ? $(settings.dotsContainer)
			: $('<div>').addClass(settings.dotsClass).appendTo(this.$element)).addClass('disabled');

		this._controls.$absolute.on('click', 'button', $.proxy(function(e) {
			var index = $(e.target).parent().is(this._controls.$absolute)
				? $(e.target).index() : $(e.target).parent().index();

			e.preventDefault();

			this.to(index, settings.dotsSpeed);
		}, this));

		/*$el.on('focusin', function() {
			$(document).off(".carousel");

			$(document).on('keydown.carousel', function(e) {
				if(e.keyCode == 37) {
					$el.trigger('prev.owl')
				}
				if(e.keyCode == 39) {
					$el.trigger('next.owl')
				}
			});
		});*/

		// override public methods of the carousel
		for (override in this._overrides) {
			this._core[override] = $.proxy(this[override], this);
		}
	};

	/**
	 * Destroys the plugin.
	 * @protected
	 */
	Navigation.prototype.destroy = function() {
		var handler, control, property, override, settings;
		settings = this._core.settings;

		for (handler in this._handlers) {
			this.$element.off(handler, this._handlers[handler]);
		}
		for (control in this._controls) {
			if (control === '$relative' && settings.navContainer) {
				this._controls[control].html('');
			} else {
				this._controls[control].remove();
			}
		}
		for (override in this.overides) {
			this._core[override] = this._overrides[override];
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	/**
	 * Updates the internal state.
	 * @protected
	 */
	Navigation.prototype.update = function() {
		var i, j, k,
			lower = this._core.clones().length / 2,
			upper = lower + this._core.items().length,
			maximum = this._core.maximum(true),
			settings = this._core.settings,
			size = settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items;

		if (settings.slideBy !== 'page') {
			settings.slideBy = Math.min(settings.slideBy, settings.items);
		}

		if (settings.dots || settings.slideBy == 'page') {
			this._pages = [];

			for (i = lower, j = 0, k = 0; i < upper; i++) {
				if (j >= size || j === 0) {
					this._pages.push({
						start: Math.min(maximum, i - lower),
						end: i - lower + size - 1
					});
					if (Math.min(maximum, i - lower) === maximum) {
						break;
					}
					j = 0, ++k;
				}
				j += this._core.mergers(this._core.relative(i));
			}
		}
	};

	/**
	 * Draws the user interface.
	 * @todo The option `dotsData` wont work.
	 * @protected
	 */
	Navigation.prototype.draw = function() {
		var difference,
			settings = this._core.settings,
			disabled = this._core.items().length <= settings.items,
			index = this._core.relative(this._core.current()),
			loop = settings.loop || settings.rewind;

		this._controls.$relative.toggleClass('disabled', !settings.nav || disabled);

		if (settings.nav) {
			this._controls.$previous.toggleClass('disabled', !loop && index <= this._core.minimum(true));
			this._controls.$next.toggleClass('disabled', !loop && index >= this._core.maximum(true));
		}

		this._controls.$absolute.toggleClass('disabled', !settings.dots || disabled);

		if (settings.dots) {
			difference = this._pages.length - this._controls.$absolute.children().length;

			if (settings.dotsData && difference !== 0) {
				this._controls.$absolute.html(this._templates.join(''));
			} else if (difference > 0) {
				this._controls.$absolute.append(new Array(difference + 1).join(this._templates[0]));
			} else if (difference < 0) {
				this._controls.$absolute.children().slice(difference).remove();
			}

			this._controls.$absolute.find('.active').removeClass('active');
			this._controls.$absolute.children().eq($.inArray(this.current(), this._pages)).addClass('active');
		}
	};

	/**
	 * Extends event data.
	 * @protected
	 * @param {Event} event - The event object which gets thrown.
	 */
	Navigation.prototype.onTrigger = function(event) {
		var settings = this._core.settings;

		event.page = {
			index: $.inArray(this.current(), this._pages),
			count: this._pages.length,
			size: settings && (settings.center || settings.autoWidth || settings.dotsData
				? 1 : settings.dotsEach || settings.items)
		};
	};

	/**
	 * Gets the current page position of the carousel.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.current = function() {
		var current = this._core.relative(this._core.current());
		return $.grep(this._pages, $.proxy(function(page, index) {
			return page.start <= current && page.end >= current;
		}, this)).pop();
	};

	/**
	 * Gets the current succesor/predecessor position.
	 * @protected
	 * @returns {Number}
	 */
	Navigation.prototype.getPosition = function(successor) {
		var position, length,
			settings = this._core.settings;

		if (settings.slideBy == 'page') {
			position = $.inArray(this.current(), this._pages);
			length = this._pages.length;
			successor ? ++position : --position;
			position = this._pages[((position % length) + length) % length].start;
		} else {
			position = this._core.relative(this._core.current());
			length = this._core.items().length;
			successor ? position += settings.slideBy : position -= settings.slideBy;
		}

		return position;
	};

	/**
	 * Slides to the next item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.next = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(true), speed);
	};

	/**
	 * Slides to the previous item or page.
	 * @public
	 * @param {Number} [speed=false] - The time in milliseconds for the transition.
	 */
	Navigation.prototype.prev = function(speed) {
		$.proxy(this._overrides.to, this._core)(this.getPosition(false), speed);
	};

	/**
	 * Slides to the specified item or page.
	 * @public
	 * @param {Number} position - The position of the item or page.
	 * @param {Number} [speed] - The time in milliseconds for the transition.
	 * @param {Boolean} [standard=false] - Whether to use the standard behaviour or not.
	 */
	Navigation.prototype.to = function(position, speed, standard) {
		var length;

		if (!standard && this._pages.length) {
			length = this._pages.length;
			$.proxy(this._overrides.to, this._core)(this._pages[((position % length) + length) % length].start, speed);
		} else {
			$.proxy(this._overrides.to, this._core)(position, speed);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Navigation = Navigation;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Hash Plugin
 * @version 2.3.4
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {
	'use strict';

	/**
	 * Creates the hash plugin.
	 * @class The Hash Plugin
	 * @param {Owl} carousel - The Owl Carousel
	 */
	var Hash = function(carousel) {
		/**
		 * Reference to the core.
		 * @protected
		 * @type {Owl}
		 */
		this._core = carousel;

		/**
		 * Hash index for the items.
		 * @protected
		 * @type {Object}
		 */
		this._hashes = {};

		/**
		 * The carousel element.
		 * @type {jQuery}
		 */
		this.$element = this._core.$element;

		/**
		 * All event handlers.
		 * @protected
		 * @type {Object}
		 */
		this._handlers = {
			'initialized.owl.carousel': $.proxy(function(e) {
				if (e.namespace && this._core.settings.startPosition === 'URLHash') {
					$(window).trigger('hashchange.owl.navigation');
				}
			}, this),
			'prepared.owl.carousel': $.proxy(function(e) {
				if (e.namespace) {
					var hash = $(e.content).find('[data-hash]').addBack('[data-hash]').attr('data-hash');

					if (!hash) {
						return;
					}

					this._hashes[hash] = e.content;
				}
			}, this),
			'changed.owl.carousel': $.proxy(function(e) {
				if (e.namespace && e.property.name === 'position') {
					var current = this._core.items(this._core.relative(this._core.current())),
						hash = $.map(this._hashes, function(item, hash) {
							return item === current ? hash : null;
						}).join();

					if (!hash || window.location.hash.slice(1) === hash) {
						return;
					}

					window.location.hash = hash;
				}
			}, this)
		};

		// set default options
		this._core.options = $.extend({}, Hash.Defaults, this._core.options);

		// register the event handlers
		this.$element.on(this._handlers);

		// register event listener for hash navigation
		$(window).on('hashchange.owl.navigation', $.proxy(function(e) {
			var hash = window.location.hash.substring(1),
				items = this._core.$stage.children(),
				position = this._hashes[hash] && items.index(this._hashes[hash]);

			if (position === undefined || position === this._core.current()) {
				return;
			}

			this._core.to(this._core.relative(position), false, true);
		}, this));
	};

	/**
	 * Default options.
	 * @public
	 */
	Hash.Defaults = {
		URLhashListener: false
	};

	/**
	 * Destroys the plugin.
	 * @public
	 */
	Hash.prototype.destroy = function() {
		var handler, property;

		$(window).off('hashchange.owl.navigation');

		for (handler in this._handlers) {
			this._core.$element.off(handler, this._handlers[handler]);
		}
		for (property in Object.getOwnPropertyNames(this)) {
			typeof this[property] != 'function' && (this[property] = null);
		}
	};

	$.fn.owlCarousel.Constructor.Plugins.Hash = Hash;

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/**
 * Support Plugin
 *
 * @version 2.3.4
 * @author Vivid Planet Software GmbH
 * @author Artus Kolanowski
 * @author David Deutsch
 * @license The MIT License (MIT)
 */
;(function($, window, document, undefined) {

	var style = $('<support>').get(0).style,
		prefixes = 'Webkit Moz O ms'.split(' '),
		events = {
			transition: {
				end: {
					WebkitTransition: 'webkitTransitionEnd',
					MozTransition: 'transitionend',
					OTransition: 'oTransitionEnd',
					transition: 'transitionend'
				}
			},
			animation: {
				end: {
					WebkitAnimation: 'webkitAnimationEnd',
					MozAnimation: 'animationend',
					OAnimation: 'oAnimationEnd',
					animation: 'animationend'
				}
			}
		},
		tests = {
			csstransforms: function() {
				return !!test('transform');
			},
			csstransforms3d: function() {
				return !!test('perspective');
			},
			csstransitions: function() {
				return !!test('transition');
			},
			cssanimations: function() {
				return !!test('animation');
			}
		};

	function test(property, prefixed) {
		var result = false,
			upper = property.charAt(0).toUpperCase() + property.slice(1);

		$.each((property + ' ' + prefixes.join(upper + ' ') + upper).split(' '), function(i, property) {
			if (style[property] !== undefined) {
				result = prefixed ? property : true;
				return false;
			}
		});

		return result;
	}

	function prefixed(property) {
		return test(property, true);
	}

	if (tests.csstransitions()) {
		/* jshint -W053 */
		$.support.transition = new String(prefixed('transition'))
		$.support.transition.end = events.transition.end[ $.support.transition ];
	}

	if (tests.cssanimations()) {
		/* jshint -W053 */
		$.support.animation = new String(prefixed('animation'))
		$.support.animation.end = events.animation.end[ $.support.animation ];
	}

	if (tests.csstransforms()) {
		/* jshint -W053 */
		$.support.transform = new String(prefixed('transform'));
		$.support.transform3d = tests.csstransforms3d();
	}

})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(3)))

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! lightslider - v1.1.6 - 2018-11-20
* https://github.com/sachinchoolur/lightslider
* Copyright (c) 2018 Sachin N; Licensed MIT */
(function ($, undefined) {
    'use strict';
    var defaults = {
        item: 3,
        autoWidth: false,
        slideMove: 1,
        slideMargin: 10,
        addClass: '',
        mode: 'slide',
        useCSS: true,
        cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',
        easing: 'linear', //'for jquery animation',//
        speed: 400, //ms'
        auto: false,
        pauseOnHover: false,
        loop: false,
        slideEndAnimation: true,
        pause: 2000,
        keyPress: false,
        controls: true,
        prevHtml: '',
        nextHtml: '',
        rtl: false,
        adaptiveHeight: false,
        vertical: false,
        verticalHeight: 500,
        hybrid: false,
        hybridWidth: 550,
        vThumbWidth: 100,
        thumbItem: 10,
        pager: true,
        gallery: false,
        galleryMargin: 5,
        thumbMargin: 5,
        currentPagerPosition: 'middle',
        enableTouch: false,
        enableDrag: false,
        freeMove: true,
        swipeThreshold: 40,
        responsive: [],
        /* jshint ignore:start */
        onBeforeStart: function ($el) {},
        onSliderLoad: function ($el) {},
        onBeforeSlide: function ($el, scene) {},
        onAfterSlide: function ($el, scene) {},
        onBeforeNextSlide: function ($el, scene) {},
        onBeforePrevSlide: function ($el, scene) {}
        /* jshint ignore:end */
    };
    $.fn.lightSlider = function (options) {
        if (this.length === 0) {
            return this;
        }

        if (this.length > 1) {
            this.each(function () {
                $(this).lightSlider(options);
            });
            return this;
        }

        var plugin = {},
            settings = $.extend(true, {}, defaults, options),
            settingsTemp = {},
            $el = this;
            plugin.$el = this;

        if (settings.mode === 'fade') {
            settings.vertical = false;
            settings.hybrid = false;
        }
        var $children = $el.children(),
            windowW = $(window).width(),
            breakpoint = null,
            resposiveObj = null,
            length = 0,
            w = 0,
            on = false,
            elSize = 0,
            $slide = '',
            scene = 0,
            property = (settings.vertical === true || settings.hybrid === true) ? 'height' : 'width',
            galleryProperty = (settings.vertical === true) ? 'height' : 'width',
            gutter = (settings.vertical === true || settings.hybrid === true) ? 'margin-bottom' : 'margin-right',
            slideValue = 0,
            pagerWidth = 0,
            slideWidth = 0,
            thumbWidth = 0,
            interval = null,
            isTouch = ('ontouchstart' in document.documentElement);
        var refresh = {};

        refresh.chbreakpoint = function () {
            windowW = $(window).width();
            if (settings.responsive.length) {
                var item;
                if (settings.autoWidth === false) {
                    item = settings.item;
                }
                if (windowW < settings.responsive[0].breakpoint) {
                    for (var i = 0; i < settings.responsive.length; i++) {
                        if (windowW < settings.responsive[i].breakpoint) {
                            breakpoint = settings.responsive[i].breakpoint;
                            resposiveObj = settings.responsive[i];
                        }
                    }
                }
                if (typeof resposiveObj !== 'undefined' && resposiveObj !== null) {
                    for (var j in resposiveObj.settings) {
                        if (resposiveObj.settings.hasOwnProperty(j)) {
                            if (typeof settingsTemp[j] === 'undefined' || settingsTemp[j] === null) {
                                settingsTemp[j] = settings[j];
                            }
                            settings[j] = resposiveObj.settings[j];
                        }
                    }
                }
                if (!$.isEmptyObject(settingsTemp) && windowW > settings.responsive[0].breakpoint) {
                    for (var k in settingsTemp) {
                        if (settingsTemp.hasOwnProperty(k)) {
                            settings[k] = settingsTemp[k];
                        }
                    }
                }
                if (settings.autoWidth === false) {
                    if (slideValue > 0 && slideWidth > 0) {
                        if (item !== settings.item) {
                            scene = Math.round(slideValue / ((slideWidth + settings.slideMargin) * settings.slideMove));
                        }
                    }
                }
            }
        };

        refresh.calSW = function () {
            if (settings.autoWidth === false) {
                slideWidth = (elSize - ((settings.item * (settings.slideMargin)) - settings.slideMargin)) / settings.item;
            }
        };

        refresh.calWidth = function (cln) {
            var ln = cln === true ? $slide.find('.lslide').length : $children.length;
            if (settings.autoWidth === false) {
                w = ln * (slideWidth + settings.slideMargin);
            } else {
                w = 0;
                for (var i = 0; i < ln; i++) {
                    w += (parseInt($children.eq(i).width()) + settings.slideMargin);
                }
            }
            return w;
        };
        plugin = {
            doCss: function () {
                var support = function () {
                    var transition = ['transition', 'MozTransition', 'WebkitTransition', 'OTransition', 'msTransition', 'KhtmlTransition'];
                    var root = document.documentElement;
                    for (var i = 0; i < transition.length; i++) {
                        if (transition[i] in root.style) {
                            return true;
                        }
                    }
                };
                if (settings.useCSS && support()) {
                    return true;
                }
                return false;
            },
            keyPress: function () {
                if (settings.keyPress) {
                    $(document).on('keyup.lightslider', function (e) {
                        if (!$(':focus').is('input, textarea')) {
                            if (e.preventDefault) {
                                e.preventDefault();
                            } else {
                                e.returnValue = false;
                            }
                            if (e.keyCode === 37) {
                                $el.goToPrevSlide();
                            } else if (e.keyCode === 39) {
                                $el.goToNextSlide();
                            }
                        }
                    });
                }
            },
            controls: function () {
                if (settings.controls) {
                    $el.after('<div class="lSAction"><a class="lSPrev">' + settings.prevHtml + '</a><a class="lSNext">' + settings.nextHtml + '</a></div>');
                    if (!settings.autoWidth) {
                        if (length <= settings.item) {
                            $slide.find('.lSAction').hide();
                        }
                    } else {
                        if (refresh.calWidth(false) < elSize) {
                            $slide.find('.lSAction').hide();
                        }
                    }
                    $slide.find('.lSAction a').on('click', function (e) {
                        if (e.preventDefault) {
                            e.preventDefault();
                        } else {
                            e.returnValue = false;
                        }
                        if ($(this).attr('class') === 'lSPrev') {
                            $el.goToPrevSlide();
                        } else {
                            $el.goToNextSlide();
                        }
                        return false;
                    });
                }
            },
            initialStyle: function () {
                var $this = this;
                if (settings.mode === 'fade') {
                    settings.autoWidth = false;
                    settings.slideEndAnimation = false;
                }
                if (settings.auto) {
                    settings.slideEndAnimation = false;
                }
                if (settings.autoWidth) {
                    settings.slideMove = 1;
                    settings.item = 1;
                }
                if (settings.loop) {
                    settings.slideMove = 1;
                    settings.freeMove = false;
                }
                settings.onBeforeStart.call(this, $el);
                refresh.chbreakpoint();
                $el.addClass('lightSlider').wrap('<div class="lSSlideOuter ' + settings.addClass + '"><div class="lSSlideWrapper"></div></div>');
                $slide = $el.parent('.lSSlideWrapper');
                if (settings.rtl === true) {
                    $slide.parent().addClass('lSrtl');
                }
                if (settings.vertical) {
                    $slide.parent().addClass('vertical');
                    elSize = settings.verticalHeight;
                    $slide.css('height', elSize + 'px');
                } 
                else if(settings.hybrid) {
                    $slide.parent().addClass('hybrid');
                    elSize = settings.hybridWidth;
                    $slide.css('width', elSize + 'px');
                } 
                else {
                    elSize = $el.outerWidth();
                }
                $children.addClass('lslide');
                if (settings.loop === true && settings.mode === 'slide') {
                    refresh.calSW();
                    refresh.clone = function () {
                        if (refresh.calWidth(true) > elSize) {
                            /**/
                            var tWr = 0,
                                tI = 0;
                            for (var k = 0; k < $children.length; k++) {
                                tWr += (parseInt($el.find('.lslide').eq(k).width()) + settings.slideMargin);
                                tI++;
                                if (tWr >= (elSize + settings.slideMargin)) {
                                    break;
                                }
                            }
                            var tItem = settings.autoWidth === true ? tI : settings.item;

                            /**/
                            if (tItem < $el.find('.clone.left').length) {
                                for (var i = 0; i < $el.find('.clone.left').length - tItem; i++) {
                                    $children.eq(i).remove();
                                }
                            }
                            if (tItem < $el.find('.clone.right').length) {
                                for (var j = $children.length - 1; j > ($children.length - 1 - $el.find('.clone.right').length); j--) {
                                    scene--;
                                    $children.eq(j).remove();
                                }
                            }
                            /**/
                            for (var n = $el.find('.clone.right').length; n < tItem; n++) {
                                $el.find('.lslide').eq(n).clone().removeClass('lslide').addClass('clone right').appendTo($el);
                                scene++;
                            }
                            for (var m = $el.find('.lslide').length - $el.find('.clone.left').length; m > ($el.find('.lslide').length - tItem); m--) {
                                $el.find('.lslide').eq(m - 1).clone().removeClass('lslide').addClass('clone left').prependTo($el);
                            }
                            $children = $el.children();
                        } else {
                            if ($children.hasClass('clone')) {
                                $el.find('.clone').remove();
                                $this.move($el, 0);
                            }
                        }
                    };
                    refresh.clone();
                }
                refresh.sSW = function () {
                    length = $children.length;
                    if (settings.rtl === true && settings.vertical === false) {
                        gutter = 'margin-left';
                    }
                    if (settings.rtl === true && settings.hybrid === false) {
                        gutter = 'margin-right';
                    }
                    if (settings.autoWidth === false) {
                        $children.css(galleryProperty, slideWidth + 'px');
                    }
                    $children.css(gutter, settings.slideMargin + 'px');
                    w = refresh.calWidth(false);
                    $el.css(galleryProperty, w + 'px');
                    if (settings.loop === true && settings.mode === 'slide') {
                        if (on === false) {
                            scene = $el.find('.clone.left').length;
                        }
                    }
                };
                refresh.calL = function () {
                    $children = $el.children();
                    length = $children.length;
                };
                if (this.doCss()) {
                    $slide.addClass('usingCss');
                }
                refresh.calL();
                if (settings.mode === 'slide') {
                    refresh.calSW();
                    refresh.sSW();
                    if (settings.loop === true) {
                        slideValue = $this.slideValue();
                        this.move($el, slideValue);
                    }
                    if (settings.vertical === false || settings.hybrid === false) {
                        this.setHeight($el, false);
                    }

                } else {
                    this.setHeight($el, true);
                    $el.addClass('lSFade');
                    if (!this.doCss()) {
                        $children.fadeOut(0);
                        $children.eq(scene).fadeIn(0);
                    }
                }
                if (settings.loop === true && settings.mode === 'slide') {
                    $children.eq(scene).addClass('active');
                } else {
                    $children.first().addClass('active');
                }
            },
            pager: function () {
                var $this = this;
                refresh.createPager = function () {
                    thumbWidth = (elSize - ((settings.thumbItem * (settings.thumbMargin)) - settings.thumbMargin)) / settings.thumbItem;
                    var $children = $slide.find('.lslide');
                    var length = $slide.find('.lslide').length;
                    var i = 0,
                        pagers = '',
                        v = 0;
                    for (i = 0; i < length; i++) {
                        if (settings.mode === 'slide') {
                            // calculate scene * slide value
                            if (!settings.autoWidth) {
                                v = i * ((slideWidth + settings.slideMargin) * settings.slideMove);
                            } else {
                                v += ((parseInt($children.eq(i).width()) + settings.slideMargin) * settings.slideMove);
                            }
                        }
                        var thumb = $children.eq(i * settings.slideMove).attr('data-thumb');
                        var thumbAlt = $children.eq(i * settings.slideMove).attr('data-thumb-alt');
                        if (settings.gallery === true) {
                            pagers += '<li style="width:100%;' + gutter + ':' + settings.thumbMargin + 'px"><a href="#"><img src="' + thumb + '" alt="' + thumbAlt + '" /></a></li>';
                        } else {
                            pagers += '<li><a href="#">' + (i + 1) + '</a></li>';
                        }
                        if ( undefined === $children.eq(i * settings.slideMove).attr('data-thumb-alt') ) {
                            $children.eq(i * settings.slideMove).attr('data-thumb-alt','slider image');
                        }
                        if (settings.mode === 'slide') {
                            if ((v) >= w - elSize - settings.slideMargin) {
                                i = i + 1;
                                var minPgr = 2;
                                if (settings.autoWidth) {
                                    pagers += '<li><a href="#">' + (i + 1) + '</a></li>';
                                    minPgr = 1;
                                }
                                if (i < minPgr) {
                                    pagers = null;
                                    $slide.parent().addClass('noPager');
                                } else {
                                    $slide.parent().removeClass('noPager');
                                }
                                break;
                            }
                        }
                    }
                    var $cSouter = $slide.parent();
                    $cSouter.find('.lSPager').html(pagers); 
                    if (settings.gallery === true) {
                        if (settings.vertical === true || settings.hybrid === true) {
                            // set Gallery thumbnail width
                            $cSouter.find('.lSPager').css('width', settings.vThumbWidth + 'px');
                        }
                        pagerWidth = (i * (settings.thumbMargin + thumbWidth)) + 0.5;
                        $cSouter.find('.lSPager').css({
                            property: pagerWidth + 'px',
                            'transition-duration': settings.speed + 'ms'
                        });
                        if (settings.vertical === true) {
                            $slide.parent().css('padding-right', (settings.vThumbWidth + settings.galleryMargin) + 'px');
                        }
                        if (settings.hybrid === true) {
                            $slide.parent().css('padding-left', (settings.vThumbWidth + settings.galleryMargin) + 'px');
                        }
                        $cSouter.find('.lSPager').css(property, pagerWidth + 'px');
                    }
                    var $pager = $cSouter.find('.lSPager').find('li');
                    $pager.first().addClass('active');
                    $pager.on('click', function () {
                        if (settings.loop === true && settings.mode === 'slide') {
                            scene = scene + ($pager.index(this) - $cSouter.find('.lSPager').find('li.active').index());
                        } else {
                            scene = $pager.index(this);
                        }
                        $el.mode(false);
                        if (settings.gallery === true) {
                            $this.slideThumb();
                        }
                        return false;
                    });
                };
                if (settings.pager) {
                    var cl = 'lSpg';
                    if (settings.gallery) {
                        cl = 'lSGallery';
                    }
                    $slide.after('<ul class="lSPager ' + cl + '"></ul>');
                    var gMargin = '';
                    if(settings.vertical) {
                        gMargin = 'margin-left';
                    } else if(settings.hybrid) {
                        gMargin = 'margin-right';
                    } else {
                        gMargin = 'margin-top';
                    }
                    $slide.parent().find('.lSPager').css(gMargin, settings.galleryMargin + 'px');
                    refresh.createPager();
                }

                setTimeout(function () {
                    refresh.init();
                }, 0);
            },
            setHeight: function (ob, fade) {
                var obj = null,
                    $this = this;
                if (settings.loop) {
                    obj = ob.children('.lslide ').first();
                } else {
                    obj = ob.children().first();
                }
                var setCss = function () {
                    var tH = obj.outerHeight(),
                        tP = 0,
                        tHT = tH;
                    if (fade) {
                        tH = 0;
                        tP = ((tHT) * 100) / elSize;
                    }
                    ob.css({
                        'height': tH + 'px',
                        'padding-bottom': tP + '%'
                    });
                };
                setCss();
                if (obj.find('img').length) {
                    if ( obj.find('img')[0].complete) {
                        setCss();
                        if (!interval) {
                            $this.auto();
                        }   
                    }else{
                        obj.find('img').on('load', function () {
                            setTimeout(function () {
                                setCss();
                                if (!interval) {
                                    $this.auto();
                                }
                            }, 100);
                        });
                    }
                }else{
                    if (!interval) {
                        $this.auto();
                    }
                }
            },
            active: function (ob, t) {
                if (this.doCss() && settings.mode === 'fade') {
                    $slide.addClass('on');
                }
                var sc = 0;
                if (scene * settings.slideMove < length) {
                    ob.removeClass('active');
                    if (!this.doCss() && settings.mode === 'fade' && t === false) {
                        ob.fadeOut(settings.speed);
                    }
                    if (t === true) {
                        sc = scene;
                    } else {
                        sc = scene * settings.slideMove;
                    }
                    //t === true ? sc = scene : sc = scene * settings.slideMove;
                    var l, nl;
                    if (t === true) {
                        l = ob.length;
                        nl = l - 1;
                        if (sc + 1 >= l) {
                            sc = nl;
                        }
                    }
                    if (settings.loop === true && settings.mode === 'slide') {
                        //t === true ? sc = scene - $el.find('.clone.left').length : sc = scene * settings.slideMove;
                        if (t === true) {
                            sc = scene - $el.find('.clone.left').length;
                        } else {
                            sc = scene * settings.slideMove;
                        }
                        if (t === true) {
                            l = ob.length;
                            nl = l - 1;
                            if (sc + 1 === l) {
                                sc = nl;
                            } else if (sc + 1 > l) {
                                sc = 0;
                            }
                        }
                    }

                    if (!this.doCss() && settings.mode === 'fade' && t === false) {
                        ob.eq(sc).fadeIn(settings.speed);
                    }
                    ob.eq(sc).addClass('active');
                } else {
                    ob.removeClass('active');
                    ob.eq(ob.length - 1).addClass('active');
                    if (!this.doCss() && settings.mode === 'fade' && t === false) {
                        ob.fadeOut(settings.speed);
                        ob.eq(sc).fadeIn(settings.speed);
                    }
                }
            },
            move: function (ob, v, slide) {
                if (settings.rtl === true) {
                    v = -v;
                }
                if (this.doCss()) {
                    if (settings.vertical === true) {
                        ob.css({
                            'transform': 'translate3d(0px, ' + (-v) + 'px, 0px)',
                            '-webkit-transform': 'translate3d(0px, ' + (-v) + 'px, 0px)'
                        });
                    } else if (settings.hybrid === true) {
                        if(slide) {
                            ob.css({
                                'transform': 'translate3d(' + (-v) + 'px, 0px, 0px)',
                                '-webkit-transform': 'translate3d(' + (-v) + 'px, 0px, 0px)',
                            });
                        } else {
                            ob.css({
                                'transform': 'translate3d(0px, ' + (-v) + 'px, 0px)',
                                '-webkit-transform': 'translate3d(0px, ' + (-v) + 'px, 0px)'
                            });
                        }
                    } else {
                        ob.css({
                            'transform': 'translate3d(' + (-v) + 'px, 0px, 0px)',
                            '-webkit-transform': 'translate3d(' + (-v) + 'px, 0px, 0px)',
                        });
                    }
                } else {
                    if (settings.vertical === true) {
                        ob.css('position', 'relative').animate({
                            top: -v + 'px'
                        }, settings.speed, settings.easing);
                    } else if (settings.hybrid === true) {
                        ob.css('position', 'relative').animate({
                            left: -v + 'px'
                        }, settings.speed, settings.easing);
                    } else {
                        ob.css('position', 'relative').animate({
                            left: -v + 'px'
                        }, settings.speed, settings.easing);
                    }
                }
                var $thumb = $slide.parent().find('.lSPager').find('li');
                this.active($thumb, true);
            },
            fade: function () {
                this.active($children, false);
                var $thumb = $slide.parent().find('.lSPager').find('li');
                this.active($thumb, true);
            },
            slide: function () {
                var $this = this;
                refresh.calSlide = function () {
                    if (w > elSize) {
                        slideValue = $this.slideValue();
                        $this.active($children, false);
                        if ((slideValue) > w - elSize - settings.slideMargin) {
                            slideValue = w - elSize - settings.slideMargin;
                        } else if (slideValue < 0) {
                            slideValue = 0;
                        }
                        $this.move($el, slideValue, true);
                        if (settings.loop === true && settings.mode === 'slide') {
                            if (scene >= (length - ($el.find('.clone.left').length / settings.slideMove))) {
                                $this.resetSlide($el.find('.clone.left').length);
                            }
                            if (scene === 0) {
                                $this.resetSlide($slide.find('.lslide').length);
                            }
                        }
                    }
                };
                refresh.calSlide();
            },
            resetSlide: function (s) {
                var $this = this;
                $slide.find('.lSAction a').addClass('disabled');
                setTimeout(function () {
                    scene = s;
                    $slide.css('transition-duration', '0ms');
                    slideValue = $this.slideValue();
                    $this.active($children, false);
                    plugin.move($el, slideValue);
                    setTimeout(function () {
                        $slide.css('transition-duration', settings.speed + 'ms');
                        $slide.find('.lSAction a').removeClass('disabled');
                    }, 50);
                }, settings.speed + 100);
            },
            slideValue: function () {
                var _sV = 0;
                if (settings.autoWidth === false) {
                    _sV = scene * ((slideWidth + settings.slideMargin) * settings.slideMove);
                } else {
                    _sV = 0;
                    for (var i = 0; i < scene; i++) {
                        _sV += (parseInt($children.eq(i).width()) + settings.slideMargin);
                    }
                }
                return _sV;
            },
            slideThumb: function () {
                var position;
                switch (settings.currentPagerPosition) {
                case 'left':
                    position = 0;
                    break;
                case 'middle':
                    position = (elSize / 2) - (thumbWidth / 2);
                    break;
                case 'right':
                    position = elSize - thumbWidth;
                }
                var sc = scene - $el.find('.clone.left').length;
                var $pager = $slide.parent().find('.lSPager');
                if (settings.mode === 'slide' && settings.loop === true) {
                    if (sc >= $pager.children().length) {
                        sc = 0;
                    } else if (sc < 0) {
                        sc = $pager.children().length;
                    }
                }
                var thumbSlide = sc * ((thumbWidth + settings.thumbMargin)) - (position);
                console.log(thumbSlide);
                if ((thumbSlide + elSize) > pagerWidth) {
                    thumbSlide = pagerWidth - elSize - settings.thumbMargin;
                    // console.log(thumbSlide);
                }
                if (thumbSlide < 0) {
                    thumbSlide = 0;
                }
                this.move($pager, thumbSlide);
            },
            auto: function () {
                if (settings.auto) {
                    clearInterval(interval);
                    interval = setInterval(function () {
                        $el.goToNextSlide();
                    }, settings.pause);
                }
            },
            pauseOnHover: function(){
                var $this = this;
                if (settings.auto && settings.pauseOnHover) {
                    $slide.on('mouseenter', function(){
                        $(this).addClass('ls-hover');
                        $el.pause();
                        settings.auto = true;
                    });
                    $slide.on('mouseleave',function(){
                        $(this).removeClass('ls-hover');
                        if (!$slide.find('.lightSlider').hasClass('lsGrabbing')) {
                            $this.auto();
                        }
                    });
                }
            },
            touchMove: function (endCoords, startCoords) {
                $slide.css('transition-duration', '0ms');
                if (settings.mode === 'slide') {
                    var distance = endCoords - startCoords;
                    var swipeVal = slideValue - distance;
                    if ((swipeVal) >= w - elSize - settings.slideMargin) {
                        if (settings.freeMove === false) {
                            swipeVal = w - elSize - settings.slideMargin;
                        } else {
                            var swipeValT = w - elSize - settings.slideMargin;
                            swipeVal = swipeValT + ((swipeVal - swipeValT) / 5);

                        }
                    } else if (swipeVal < 0) {
                        if (settings.freeMove === false) {
                            swipeVal = 0;
                        } else {
                            swipeVal = swipeVal / 5;
                        }
                    }
                    this.move($el, swipeVal);
                }
            },

            touchEnd: function (distance) {
                $slide.css('transition-duration', settings.speed + 'ms');
                if (settings.mode === 'slide') {
                    var mxVal = false;
                    var _next = true;
                    slideValue = slideValue - distance;
                    if ((slideValue) > w - elSize - settings.slideMargin) {
                        slideValue = w - elSize - settings.slideMargin;
                        if (settings.autoWidth === false) {
                            mxVal = true;
                        }
                    } else if (slideValue < 0) {
                        slideValue = 0;
                    }
                    var gC = function (next) {
                        var ad = 0;
                        if (!mxVal) {
                            if (next) {
                                ad = 1;
                            }
                        }
                        if (!settings.autoWidth) {
                            var num = slideValue / ((slideWidth + settings.slideMargin) * settings.slideMove);
                            scene = parseInt(num) + ad;
                            if (slideValue >= (w - elSize - settings.slideMargin)) {
                                if (num % 1 !== 0) {
                                    scene++;
                                }
                            }
                        } else {
                            var tW = 0;
                            for (var i = 0; i < $children.length; i++) {
                                tW += (parseInt($children.eq(i).width()) + settings.slideMargin);
                                scene = i + ad;
                                if (tW >= slideValue) {
                                    break;
                                }
                            }
                        }
                    };
                    if (distance >= settings.swipeThreshold) {
                        gC(false);
                        _next = false;
                    } else if (distance <= -settings.swipeThreshold) {
                        gC(true);
                        _next = false;
                    }
                    $el.mode(_next);
                    this.slideThumb();
                } else {
                    if (distance >= settings.swipeThreshold) {
                        $el.goToPrevSlide();
                    } else if (distance <= -settings.swipeThreshold) {
                        $el.goToNextSlide();
                    }
                }
            },



            enableDrag: function () {
                var $this = this;
                if (!isTouch) {
                    var startCoords = 0,
                        endCoords = 0,
                        isDraging = false;
                    $slide.find('.lightSlider').addClass('lsGrab');
                    $slide.on('mousedown', function (e) {
                        if (w < elSize) {
                            if (w !== 0) {
                                return false;
                            }
                        }
                        if ($(e.target).attr('class') !== ('lSPrev') && $(e.target).attr('class') !== ('lSNext')) {
                            startCoords = (settings.vertical === true || settings.hybrid === true) ? e.pageY : e.pageX;
                            isDraging = true;
                            if (e.preventDefault) {
                                e.preventDefault();
                            } else {
                                e.returnValue = false;
                            }
                            // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
                            $slide.scrollLeft += 1;
                            $slide.scrollLeft -= 1;
                            // *
                            $slide.find('.lightSlider').removeClass('lsGrab').addClass('lsGrabbing');
                            clearInterval(interval);
                        }
                    });
                    $(window).on('mousemove', function (e) {
                        if (isDraging) {
                            endCoords = (settings.vertical === true || settings.vertical === true) ? e.pageY : e.pageX;
                            $this.touchMove(endCoords, startCoords);
                        }
                    });
                    $(window).on('mouseup', function (e) {
                        if (isDraging) {
                            $slide.find('.lightSlider').removeClass('lsGrabbing').addClass('lsGrab');
                            isDraging = false;
                            endCoords = (settings.vertical === true || settings.hybrid === true) ? e.pageY : e.pageX;
                            var distance = endCoords - startCoords;
                            if (Math.abs(distance) >= settings.swipeThreshold) {
                                $(window).on('click.ls', function (e) {
                                    if (e.preventDefault) {
                                        e.preventDefault();
                                    } else {
                                        e.returnValue = false;
                                    }
                                    e.stopImmediatePropagation();
                                    e.stopPropagation();
                                    $(window).off('click.ls');
                                });
                            }

                            $this.touchEnd(distance);

                        }
                    });
                }
            },




            enableTouch: function () {
                var $this = this;
                if (isTouch) {
                    var startCoords = {},
                        endCoords = {};
                    $slide.on('touchstart', function (e) {
                        endCoords = e.originalEvent.targetTouches[0];
                        startCoords.pageX = e.originalEvent.targetTouches[0].pageX;
                        startCoords.pageY = e.originalEvent.targetTouches[0].pageY;
                        clearInterval(interval);
                    });
                    $slide.on('touchmove', function (e) {
                        if (w < elSize) {
                            if (w !== 0) {
                                return false;
                            }
                        }
                        var orig = e.originalEvent;
                        endCoords = orig.targetTouches[0];
                        var xMovement = Math.abs(endCoords.pageX - startCoords.pageX);
                        var yMovement = Math.abs(endCoords.pageY - startCoords.pageY);
                        if (settings.vertical === true || settings.hybrid === true) {
                            if ((yMovement * 3) > xMovement) {
                                e.preventDefault();
                            }
                            $this.touchMove(endCoords.pageY, startCoords.pageY);
                        } else {
                            if ((xMovement * 3) > yMovement) {
                                e.preventDefault();
                            }
                            $this.touchMove(endCoords.pageX, startCoords.pageX);
                        }

                    });
                    $slide.on('touchend', function () {
                        if (w < elSize) {
                            if (w !== 0) {
                                return false;
                            }
                        }
                        var distance;
                        if (settings.vertical === true || settings.hybrid === true) {
                            distance = endCoords.pageY - startCoords.pageY;
                        } else {
                            distance = endCoords.pageX - startCoords.pageX;
                        }
                        $this.touchEnd(distance);
                    });
                }
            },
            build: function () {
                var $this = this;
                $this.initialStyle();
                if (this.doCss()) {

                    if (settings.enableTouch === true) {
                        $this.enableTouch();
                    }
                    if (settings.enableDrag === true) {
                        $this.enableDrag();
                    }
                }

                $(window).on('focus', function(){
                    $this.auto();
                });
                
                $(window).on('blur', function(){
                    clearInterval(interval);
                });

                $this.pager();
                $this.pauseOnHover();
                $this.controls();
                $this.keyPress();
            }
        };
        plugin.build();
        refresh.init = function () {
            refresh.chbreakpoint();
            if (settings.vertical === true) {
                if (settings.item > 1) {
                    elSize = settings.verticalHeight;
                } else {
                    elSize = $children.outerHeight();
                }
                $slide.css('height', elSize + 'px');
            } 
            else {
                elSize = $slide.outerWidth();
            }
            if (settings.loop === true && settings.mode === 'slide') {
                refresh.clone();
            }
            refresh.calL();
            if (settings.mode === 'slide') {
                $el.removeClass('lSSlide');
            }
            if (settings.mode === 'slide') {
                refresh.calSW();
                refresh.sSW();
            }
            setTimeout(function () {
                if (settings.mode === 'slide') {
                    $el.addClass('lSSlide');
                }
            }, 1000);
            if (settings.pager) {
                refresh.createPager();
            }
            if (settings.adaptiveHeight === true && settings.vertical === false && settings.hybrid === false) {
                $el.css('height', $children.eq(scene).outerHeight(true));
            }
            if (settings.adaptiveHeight === false) {
                if (settings.mode === 'slide') {
                    if (settings.vertical === false || settings.hybrid === false) {
                        plugin.setHeight($el, false);
                    }else{
                        plugin.auto();
                    }
                } else {
                    plugin.setHeight($el, true);
                }
            }
            if (settings.gallery === true) {
                plugin.slideThumb();
            }
            if (settings.mode === 'slide') {
                plugin.slide();
            }
            if (settings.autoWidth === false) {
                if ($children.length <= settings.item) {
                    $slide.find('.lSAction').hide();
                } else {
                    $slide.find('.lSAction').show();
                }
            } else {
                if ((refresh.calWidth(false) < elSize) && (w !== 0)) {
                    $slide.find('.lSAction').hide();
                } else {
                    $slide.find('.lSAction').show();
                }
            }
        };
        $el.goToPrevSlide = function () {
            if (scene > 0) {
                settings.onBeforePrevSlide.call(this, $el, scene);
                scene--;
                $el.mode(false);
                if (settings.gallery === true) {
                    plugin.slideThumb();
                }
            } else {
                if (settings.loop === true) {
                    settings.onBeforePrevSlide.call(this, $el, scene);
                    if (settings.mode === 'fade') {
                        var l = (length - 1);
                        scene = parseInt(l / settings.slideMove);
                    }
                    $el.mode(false);
                    if (settings.gallery === true) {
                        plugin.slideThumb();
                    }
                } else if (settings.slideEndAnimation === true) {
                    $el.addClass('leftEnd');
                    setTimeout(function () {
                        $el.removeClass('leftEnd');
                    }, 400);
                }
            }
        };
        $el.goToNextSlide = function () {
            var nextI = true;
            if (settings.mode === 'slide') {
                var _slideValue = plugin.slideValue();
                nextI = _slideValue < w - elSize - settings.slideMargin;
            }
            if (((scene * settings.slideMove) < length - settings.slideMove) && nextI) {
                settings.onBeforeNextSlide.call(this, $el, scene);
                scene++;
                $el.mode(false);
                if (settings.gallery === true) {
                    plugin.slideThumb();
                }
            } else {
                if (settings.loop === true) {
                    settings.onBeforeNextSlide.call(this, $el, scene);
                    scene = 0;
                    $el.mode(false);
                    if (settings.gallery === true) {
                        plugin.slideThumb();
                    }
                } else if (settings.slideEndAnimation === true) {
                    $el.addClass('rightEnd');
                    setTimeout(function () {
                        $el.removeClass('rightEnd');
                    }, 400);
                }
            }
        };
        $el.mode = function (_touch) {
            if (settings.adaptiveHeight === true && settings.vertical === false && settings.hybrid === false) {
                $el.css('height', $children.eq(scene).outerHeight(true));
            }
            if (on === false) {
                if (settings.mode === 'slide') {
                    if (plugin.doCss()) {
                        $el.addClass('lSSlide');
                        if (settings.speed !== '') {
                            $slide.css('transition-duration', settings.speed + 'ms');
                        }
                        if (settings.cssEasing !== '') {
                            $slide.css('transition-timing-function', settings.cssEasing);
                        }
                    }
                } else {
                    if (plugin.doCss()) {
                        if (settings.speed !== '') {
                            $el.css('transition-duration', settings.speed + 'ms');
                        }
                        if (settings.cssEasing !== '') {
                            $el.css('transition-timing-function', settings.cssEasing);
                        }
                    }
                }
            }
            if (!_touch) {
                settings.onBeforeSlide.call(this, $el, scene);
            }
            if (settings.mode === 'slide') {
                plugin.slide();
            } else {
                plugin.fade();
            }
            if (!$slide.hasClass('ls-hover')) {
                plugin.auto();
            }
            setTimeout(function () {
                if (!_touch) {
                    settings.onAfterSlide.call(this, $el, scene);
                }
            }, settings.speed);
            on = true;
        };
        $el.play = function () {
            $el.goToNextSlide();
            settings.auto = true;
            plugin.auto();
        };
        $el.pause = function () {
            settings.auto = false;
            clearInterval(interval);
        };
        $el.refresh = function () {
            refresh.init();
        };
        $el.getCurrentSlideCount = function () {
            var sc = scene;
            if (settings.loop) {
                var ln = $slide.find('.lslide').length,
                    cl = $el.find('.clone.left').length;
                if (scene <= cl - 1) {
                    sc = ln + (scene - cl);
                } else if (scene >= (ln + cl)) {
                    sc = scene - ln - cl;
                } else {
                    sc = scene - cl;
                }
            }
            return sc + 1;
        }; 
        $el.getTotalSlideCount = function () {
            return $slide.find('.lslide').length;
        };
        $el.goToSlide = function (s) {
            if (settings.loop) {
                scene = (s + $el.find('.clone.left').length - 1);
            } else {
                scene = s;
            }
            $el.mode(false);
            if (settings.gallery === true) {
                plugin.slideThumb();
            }
        };
        $el.destroy = function () {
            if ($el.lightSlider) {
                $el.goToPrevSlide = function(){};
                $el.goToNextSlide = function(){};
                $el.mode = function(){};
                $el.play = function(){};
                $el.pause = function(){};
                $el.refresh = function(){};
                $el.getCurrentSlideCount = function(){};
                $el.getTotalSlideCount = function(){};
                $el.goToSlide = function(){}; 
                $el.lightSlider = null;
                refresh = {
                    init : function(){}
                };
                $el.parent().parent().find('.lSAction, .lSPager').remove();
                $el.removeClass('lightSlider lSFade lSSlide lsGrab lsGrabbing leftEnd right').removeAttr('style').unwrap().unwrap();
                $el.children().removeAttr('style');
                $children.removeClass('lslide active');
                $el.find('.clone').remove();
                $children = null;
                interval = null;
                on = false;
                scene = 0;
            }

        };
        setTimeout(function () {
            settings.onSliderLoad.call(this, $el);
        }, 10);
        $(window).on('resize orientationchange', function (e) {
            setTimeout(function () {
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
                refresh.init();
            }, 200);
        });
        return this;
    };
}(jQuery));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * SimpleBar.js - v3.1.5
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).SimpleBar=e()}(this,function(){"use strict";var t=function(t){return"object"==typeof t?null!==t:"function"==typeof t},e=function(e){if(!t(e))throw TypeError(e+" is not an object!");return e},i=function(t){if(null==t)throw TypeError("Can't call method on  "+t);return t},r=function(t){return Object(i(t))},n=Math.ceil,o=Math.floor,s=function(t){return isNaN(t=+t)?0:(t>0?o:n)(t)},a=Math.min,l=function(t){return t>0?a(s(t),9007199254740991):0},c=function(t){return function(e,r){var n,o,a=String(i(e)),l=s(r),c=a.length;return l<0||l>=c?t?"":void 0:(n=a.charCodeAt(l))<55296||n>56319||l+1===c||(o=a.charCodeAt(l+1))<56320||o>57343?t?a.charAt(l):n:t?a.slice(l,l+2):o-56320+(n-55296<<10)+65536}},u=c(!0),h=function(t,e,i){return e+(i?u(t,e).length:1)},f={}.toString,d=function(t){return f.call(t).slice(8,-1)},p="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function v(t,e){return t(e={exports:{}},e.exports),e.exports}var y,b,g=v(function(t){var e=t.exports={version:"2.6.2"};"number"==typeof __e&&(__e=e)}),m=(g.version,v(function(t){var e=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=e)})),x=v(function(t){var e=m["__core-js_shared__"]||(m["__core-js_shared__"]={});(t.exports=function(t,i){return e[t]||(e[t]=void 0!==i?i:{})})("versions",[]).push({version:g.version,mode:"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})}),E=0,w=Math.random(),_=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++E+w).toString(36))},O=v(function(t){var e=x("wks"),i=m.Symbol,r="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=r&&i[t]||(r?i:_)("Symbol."+t))}).store=e}),S=O("toStringTag"),k="Arguments"==d(function(){return arguments}()),A=function(t){var e,i,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(i=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),S))?i:k?d(e):"Object"==(r=d(e))&&"function"==typeof e.callee?"Arguments":r},M=RegExp.prototype.exec,L=function(t,e){var i=t.exec;if("function"==typeof i){var r=i.call(t,e);if("object"!=typeof r)throw new TypeError("RegExp exec method returned something other than an Object or null");return r}if("RegExp"!==A(t))throw new TypeError("RegExp#exec called on incompatible receiver");return M.call(t,e)},T=RegExp.prototype.exec,j=String.prototype.replace,R=T,N=(y=/a/,b=/b*/g,T.call(y,"a"),T.call(b,"a"),0!==y.lastIndex||0!==b.lastIndex),W=void 0!==/()??/.exec("")[1];(N||W)&&(R=function(t){var i,r,n,o,s=this;return W&&(r=new RegExp("^"+s.source+"$(?!\\s)",function(){var t=e(this),i="";return t.global&&(i+="g"),t.ignoreCase&&(i+="i"),t.multiline&&(i+="m"),t.unicode&&(i+="u"),t.sticky&&(i+="y"),i}.call(s))),N&&(i=s.lastIndex),n=T.call(s,t),N&&n&&(s.lastIndex=s.global?n.index+n[0].length:i),W&&n&&n.length>1&&j.call(n[0],r,function(){for(o=1;o<arguments.length-2;o++)void 0===arguments[o]&&(n[o]=void 0)}),n});var C=R,z=function(t){try{return!!t()}catch(t){return!0}},D=!z(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}),V=m.document,B=t(V)&&t(V.createElement),P=function(t){return B?V.createElement(t):{}},F=!D&&!z(function(){return 7!=Object.defineProperty(P("div"),"a",{get:function(){return 7}}).a}),I=Object.defineProperty,H={f:D?Object.defineProperty:function(i,r,n){if(e(i),r=function(e,i){if(!t(e))return e;var r,n;if(i&&"function"==typeof(r=e.toString)&&!t(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!t(n=r.call(e)))return n;if(!i&&"function"==typeof(r=e.toString)&&!t(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")}(r,!0),e(n),F)try{return I(i,r,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(i[r]=n.value),i}},q=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},$=D?function(t,e,i){return H.f(t,e,q(1,i))}:function(t,e,i){return t[e]=i,t},X={}.hasOwnProperty,Y=function(t,e){return X.call(t,e)},G=v(function(t){var e=_("src"),i=Function.toString,r=(""+i).split("toString");g.inspectSource=function(t){return i.call(t)},(t.exports=function(t,i,n,o){var s="function"==typeof n;s&&(Y(n,"name")||$(n,"name",i)),t[i]!==n&&(s&&(Y(n,e)||$(n,e,t[i]?""+t[i]:r.join(String(i)))),t===m?t[i]=n:o?t[i]?t[i]=n:$(t,i,n):(delete t[i],$(t,i,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[e]||i.call(this)})}),U=function(t,e,i){if(function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!")}(t),void 0===e)return t;switch(i){case 1:return function(i){return t.call(e,i)};case 2:return function(i,r){return t.call(e,i,r)};case 3:return function(i,r,n){return t.call(e,i,r,n)}}return function(){return t.apply(e,arguments)}},J=function(t,e,i){var r,n,o,s,a=t&J.F,l=t&J.G,c=t&J.S,u=t&J.P,h=t&J.B,f=l?m:c?m[e]||(m[e]={}):(m[e]||{}).prototype,d=l?g:g[e]||(g[e]={}),p=d.prototype||(d.prototype={});for(r in l&&(i=e),i)o=((n=!a&&f&&void 0!==f[r])?f:i)[r],s=h&&n?U(o,m):u&&"function"==typeof o?U(Function.call,o):o,f&&G(f,r,o,t&J.U),d[r]!=o&&$(d,r,s),u&&p[r]!=o&&(p[r]=o)};m.core=g,J.F=1,J.G=2,J.S=4,J.P=8,J.B=16,J.W=32,J.U=64,J.R=128;var K=J;K({target:"RegExp",proto:!0,forced:C!==/./.exec},{exec:C});var Q=O("species"),Z=!z(function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}),tt=function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var i="ab".split(t);return 2===i.length&&"a"===i[0]&&"b"===i[1]}(),et=function(t,e,r){var n=O(t),o=!z(function(){var e={};return e[n]=function(){return 7},7!=""[t](e)}),s=o?!z(function(){var e=!1,i=/a/;return i.exec=function(){return e=!0,null},"split"===t&&(i.constructor={},i.constructor[Q]=function(){return i}),i[n](""),!e}):void 0;if(!o||!s||"replace"===t&&!Z||"split"===t&&!tt){var a=/./[n],l=r(i,n,""[t],function(t,e,i,r,n){return e.exec===C?o&&!n?{done:!0,value:a.call(e,i,r)}:{done:!0,value:t.call(i,e,r)}:{done:!1}}),c=l[0],u=l[1];G(String.prototype,t,c),$(RegExp.prototype,n,2==e?function(t,e){return u.call(t,this,e)}:function(t){return u.call(t,this)})}},it=Math.max,rt=Math.min,nt=Math.floor,ot=/\$([$&`']|\d\d?|<[^>]*>)/g,st=/\$([$&`']|\d\d?)/g;et("replace",2,function(t,i,n,o){return[function(e,r){var o=t(this),s=null==e?void 0:e[i];return void 0!==s?s.call(e,o,r):n.call(String(o),e,r)},function(t,i){var r=o(n,t,this,i);if(r.done)return r.value;var c=e(t),u=String(this),f="function"==typeof i;f||(i=String(i));var d=c.global;if(d){var p=c.unicode;c.lastIndex=0}for(var v=[];;){var y=L(c,u);if(null===y)break;if(v.push(y),!d)break;""===String(y[0])&&(c.lastIndex=h(u,l(c.lastIndex),p))}for(var b,g="",m=0,x=0;x<v.length;x++){y=v[x];for(var E=String(y[0]),w=it(rt(s(y.index),u.length),0),_=[],O=1;O<y.length;O++)_.push(void 0===(b=y[O])?b:String(b));var S=y.groups;if(f){var k=[E].concat(_,w,u);void 0!==S&&k.push(S);var A=String(i.apply(void 0,k))}else A=a(E,u,w,_,S,i);w>=m&&(g+=u.slice(m,w)+A,m=w+E.length)}return g+u.slice(m)}];function a(t,e,i,o,s,a){var l=i+t.length,c=o.length,u=st;return void 0!==s&&(s=r(s),u=ot),n.call(a,u,function(r,n){var a;switch(n.charAt(0)){case"$":return"$";case"&":return t;case"`":return e.slice(0,i);case"'":return e.slice(l);case"<":a=s[n.slice(1,-1)];break;default:var u=+n;if(0===u)return r;if(u>c){var h=nt(u/10);return 0===h?r:h<=c?void 0===o[h-1]?n.charAt(1):o[h-1]+n.charAt(1):r}a=o[u-1]}return void 0===a?"":a})}});var at=H.f,lt=Function.prototype,ct=/^\s*function ([^ (]*)/;"name"in lt||D&&at(lt,"name",{configurable:!0,get:function(){try{return(""+this).match(ct)[1]}catch(t){return""}}}),et("match",1,function(t,i,r,n){return[function(e){var r=t(this),n=null==e?void 0:e[i];return void 0!==n?n.call(e,r):new RegExp(e)[i](String(r))},function(t){var i=n(r,t,this);if(i.done)return i.value;var o=e(t),s=String(this);if(!o.global)return L(o,s);var a=o.unicode;o.lastIndex=0;for(var c,u=[],f=0;null!==(c=L(o,s));){var d=String(c[0]);u[f]=d,""===d&&(o.lastIndex=h(s,l(o.lastIndex),a)),f++}return 0===f?null:u}]});var ut=O("unscopables"),ht=Array.prototype;null==ht[ut]&&$(ht,ut,{});var ft,dt=function(t){ht[ut][t]=!0},pt=function(t,e){return{value:e,done:!!t}},vt={},yt=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==d(t)?t.split(""):Object(t)},bt=function(t){return yt(i(t))},gt=Math.max,mt=Math.min,xt=x("keys"),Et=function(t){return xt[t]||(xt[t]=_(t))},wt=(ft=!1,function(t,e,i){var r,n=bt(t),o=l(n.length),a=function(t,e){return(t=s(t))<0?gt(t+e,0):mt(t,e)}(i,o);if(ft&&e!=e){for(;o>a;)if((r=n[a++])!=r)return!0}else for(;o>a;a++)if((ft||a in n)&&n[a]===e)return ft||a||0;return!ft&&-1}),_t=Et("IE_PROTO"),Ot="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","),St=Object.keys||function(t){return function(t,e){var i,r=bt(t),n=0,o=[];for(i in r)i!=_t&&Y(r,i)&&o.push(i);for(;e.length>n;)Y(r,i=e[n++])&&(~wt(o,i)||o.push(i));return o}(t,Ot)},kt=D?Object.defineProperties:function(t,i){e(t);for(var r,n=St(i),o=n.length,s=0;o>s;)H.f(t,r=n[s++],i[r]);return t},At=m.document,Mt=At&&At.documentElement,Lt=Et("IE_PROTO"),Tt=function(){},jt=function(){var t,e=P("iframe"),i=Ot.length;for(e.style.display="none",Mt.appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),jt=t.F;i--;)delete jt.prototype[Ot[i]];return jt()},Rt=Object.create||function(t,i){var r;return null!==t?(Tt.prototype=e(t),r=new Tt,Tt.prototype=null,r[Lt]=t):r=jt(),void 0===i?r:kt(r,i)},Nt=H.f,Wt=O("toStringTag"),Ct=function(t,e,i){t&&!Y(t=i?t:t.prototype,Wt)&&Nt(t,Wt,{configurable:!0,value:e})},zt={};$(zt,O("iterator"),function(){return this});var Dt=function(t,e,i){t.prototype=Rt(zt,{next:q(1,i)}),Ct(t,e+" Iterator")},Vt=Et("IE_PROTO"),Bt=Object.prototype,Pt=Object.getPrototypeOf||function(t){return t=r(t),Y(t,Vt)?t[Vt]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?Bt:null},Ft=O("iterator"),It=!([].keys&&"next"in[].keys()),Ht=function(){return this},qt=function(t,e,i,r,n,o,s){Dt(i,e,r);var a,l,c,u=function(t){if(!It&&t in p)return p[t];switch(t){case"keys":case"values":return function(){return new i(this,t)}}return function(){return new i(this,t)}},h=e+" Iterator",f="values"==n,d=!1,p=t.prototype,v=p[Ft]||p["@@iterator"]||n&&p[n],y=v||u(n),b=n?f?u("entries"):y:void 0,g="Array"==e&&p.entries||v;if(g&&(c=Pt(g.call(new t)))!==Object.prototype&&c.next&&(Ct(c,h,!0),"function"!=typeof c[Ft]&&$(c,Ft,Ht)),f&&v&&"values"!==v.name&&(d=!0,y=function(){return v.call(this)}),(It||d||!p[Ft])&&$(p,Ft,y),vt[e]=y,vt[h]=Ht,n)if(a={values:f?y:u("values"),keys:o?y:u("keys"),entries:b},s)for(l in a)l in p||G(p,l,a[l]);else K(K.P+K.F*(It||d),e,a);return a},$t=qt(Array,"Array",function(t,e){this._t=bt(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,i=this._i++;return!t||i>=t.length?(this._t=void 0,pt(1)):pt(0,"keys"==e?i:"values"==e?t[i]:[i,t[i]])},"values");vt.Arguments=vt.Array,dt("keys"),dt("values"),dt("entries");for(var Xt=O("iterator"),Yt=O("toStringTag"),Gt=vt.Array,Ut={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},Jt=St(Ut),Kt=0;Kt<Jt.length;Kt++){var Qt,Zt=Jt[Kt],te=Ut[Zt],ee=m[Zt],ie=ee&&ee.prototype;if(ie&&(ie[Xt]||$(ie,Xt,Gt),ie[Yt]||$(ie,Yt,Zt),vt[Zt]=Gt,te))for(Qt in $t)ie[Qt]||G(ie,Qt,$t[Qt],!0)}var re=c(!0);qt(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,i=this._i;return i>=e.length?{value:void 0,done:!0}:(t=re(e,i),this._i+=t.length,{value:t,done:!1})});var ne=function(t,i,r,n){try{return n?i(e(r)[0],r[1]):i(r)}catch(i){var o=t.return;throw void 0!==o&&e(o.call(t)),i}},oe=O("iterator"),se=Array.prototype,ae=function(t,e,i){e in t?H.f(t,e,q(0,i)):t[e]=i},le=O("iterator"),ce=g.getIteratorMethod=function(t){if(null!=t)return t[le]||t["@@iterator"]||vt[A(t)]},ue=O("iterator"),he=!1;try{[7][ue]().return=function(){he=!0}}catch(t){}function fe(t,e){for(var i=0;i<e.length;i++){var r=e[i];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function de(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function pe(t){for(var e=1;e<arguments.length;e++){var i=null!=arguments[e]?arguments[e]:{},r=Object.keys(i);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(i).filter(function(t){return Object.getOwnPropertyDescriptor(i,t).enumerable}))),r.forEach(function(e){de(t,e,i[e])})}return t}K(K.S+K.F*!function(t,e){if(!e&&!he)return!1;var i=!1;try{var r=[7],n=r[ue]();n.next=function(){return{done:i=!0}},r[ue]=function(){return n},t(r)}catch(t){}return i}(function(t){}),"Array",{from:function(t){var e,i,n,o,s,a=r(t),c="function"==typeof this?this:Array,u=arguments.length,h=u>1?arguments[1]:void 0,f=void 0!==h,d=0,p=ce(a);if(f&&(h=U(h,u>2?arguments[2]:void 0,2)),null!=p&&(c!=Array||(void 0===(s=p)||vt.Array!==s&&se[oe]!==s)))for(o=p.call(a),i=new c;!(n=o.next()).done;d++)ae(i,d,f?ne(o,h,[n.value,d],!0):n.value);else for(i=new c(e=l(a.length));e>d;d++)ae(i,d,f?h(a[d],d):a[d]);return i.length=d,i}});var ve=v(function(t,e){t.exports=function(){if("undefined"==typeof document)return 0;var t,e=document.body,i=document.createElement("div"),r=i.style;return r.position="absolute",r.top=r.left="-9999px",r.width=r.height="100px",r.overflow="scroll",e.appendChild(i),t=i.offsetWidth-i.clientWidth,e.removeChild(i),t}}),ye="Expected a function",be=NaN,ge="[object Symbol]",me=/^\s+|\s+$/g,xe=/^[-+]0x[0-9a-f]+$/i,Ee=/^0b[01]+$/i,we=/^0o[0-7]+$/i,_e=parseInt,Oe="object"==typeof p&&p&&p.Object===Object&&p,Se="object"==typeof self&&self&&self.Object===Object&&self,ke=Oe||Se||Function("return this")(),Ae=Object.prototype.toString,Me=Math.max,Le=Math.min,Te=function(){return ke.Date.now()};function je(t,e,i){var r,n,o,s,a,l,c=0,u=!1,h=!1,f=!0;if("function"!=typeof t)throw new TypeError(ye);function d(e){var i=r,o=n;return r=n=void 0,c=e,s=t.apply(o,i)}function p(t){var i=t-l;return void 0===l||i>=e||i<0||h&&t-c>=o}function v(){var t=Te();if(p(t))return y(t);a=setTimeout(v,function(t){var i=e-(t-l);return h?Le(i,o-(t-c)):i}(t))}function y(t){return a=void 0,f&&r?d(t):(r=n=void 0,s)}function b(){var t=Te(),i=p(t);if(r=arguments,n=this,l=t,i){if(void 0===a)return function(t){return c=t,a=setTimeout(v,e),u?d(t):s}(l);if(h)return a=setTimeout(v,e),d(l)}return void 0===a&&(a=setTimeout(v,e)),s}return e=Ne(e)||0,Re(i)&&(u=!!i.leading,o=(h="maxWait"in i)?Me(Ne(i.maxWait)||0,e):o,f="trailing"in i?!!i.trailing:f),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,r=l=n=a=void 0},b.flush=function(){return void 0===a?s:y(Te())},b}function Re(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function Ne(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&Ae.call(t)==ge}(t))return be;if(Re(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=Re(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(me,"");var i=Ee.test(t);return i||we.test(t)?_e(t.slice(2),i?2:8):xe.test(t)?be:+t}var We=function(t,e,i){var r=!0,n=!0;if("function"!=typeof t)throw new TypeError(ye);return Re(i)&&(r="leading"in i?!!i.leading:r,n="trailing"in i?!!i.trailing:n),je(t,e,{leading:r,maxWait:e,trailing:n})},Ce="Expected a function",ze=NaN,De="[object Symbol]",Ve=/^\s+|\s+$/g,Be=/^[-+]0x[0-9a-f]+$/i,Pe=/^0b[01]+$/i,Fe=/^0o[0-7]+$/i,Ie=parseInt,He="object"==typeof p&&p&&p.Object===Object&&p,qe="object"==typeof self&&self&&self.Object===Object&&self,$e=He||qe||Function("return this")(),Xe=Object.prototype.toString,Ye=Math.max,Ge=Math.min,Ue=function(){return $e.Date.now()};function Je(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function Ke(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&Xe.call(t)==De}(t))return ze;if(Je(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=Je(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(Ve,"");var i=Pe.test(t);return i||Fe.test(t)?Ie(t.slice(2),i?2:8):Be.test(t)?ze:+t}var Qe=function(t,e,i){var r,n,o,s,a,l,c=0,u=!1,h=!1,f=!0;if("function"!=typeof t)throw new TypeError(Ce);function d(e){var i=r,o=n;return r=n=void 0,c=e,s=t.apply(o,i)}function p(t){var i=t-l;return void 0===l||i>=e||i<0||h&&t-c>=o}function v(){var t=Ue();if(p(t))return y(t);a=setTimeout(v,function(t){var i=e-(t-l);return h?Ge(i,o-(t-c)):i}(t))}function y(t){return a=void 0,f&&r?d(t):(r=n=void 0,s)}function b(){var t=Ue(),i=p(t);if(r=arguments,n=this,l=t,i){if(void 0===a)return function(t){return c=t,a=setTimeout(v,e),u?d(t):s}(l);if(h)return a=setTimeout(v,e),d(l)}return void 0===a&&(a=setTimeout(v,e)),s}return e=Ke(e)||0,Je(i)&&(u=!!i.leading,o=(h="maxWait"in i)?Ye(Ke(i.maxWait)||0,e):o,f="trailing"in i?!!i.trailing:f),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,r=l=n=a=void 0},b.flush=function(){return void 0===a?s:y(Ue())},b},Ze="Expected a function",ti="__lodash_hash_undefined__",ei="[object Function]",ii="[object GeneratorFunction]",ri=/^\[object .+?Constructor\]$/,ni="object"==typeof p&&p&&p.Object===Object&&p,oi="object"==typeof self&&self&&self.Object===Object&&self,si=ni||oi||Function("return this")();var ai,li=Array.prototype,ci=Function.prototype,ui=Object.prototype,hi=si["__core-js_shared__"],fi=(ai=/[^.]+$/.exec(hi&&hi.keys&&hi.keys.IE_PROTO||""))?"Symbol(src)_1."+ai:"",di=ci.toString,pi=ui.hasOwnProperty,vi=ui.toString,yi=RegExp("^"+di.call(pi).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),bi=li.splice,gi=ki(si,"Map"),mi=ki(Object,"create");function xi(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function Ei(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function wi(t){var e=-1,i=t?t.length:0;for(this.clear();++e<i;){var r=t[e];this.set(r[0],r[1])}}function _i(t,e){for(var i,r,n=t.length;n--;)if((i=t[n][0])===(r=e)||i!=i&&r!=r)return n;return-1}function Oi(t){return!(!Mi(t)||(e=t,fi&&fi in e))&&(function(t){var e=Mi(t)?vi.call(t):"";return e==ei||e==ii}(t)||function(t){var e=!1;if(null!=t&&"function"!=typeof t.toString)try{e=!!(t+"")}catch(t){}return e}(t)?yi:ri).test(function(t){if(null!=t){try{return di.call(t)}catch(t){}try{return t+""}catch(t){}}return""}(t));var e}function Si(t,e){var i,r,n=t.__data__;return("string"==(r=typeof(i=e))||"number"==r||"symbol"==r||"boolean"==r?"__proto__"!==i:null===i)?n["string"==typeof e?"string":"hash"]:n.map}function ki(t,e){var i=function(t,e){return null==t?void 0:t[e]}(t,e);return Oi(i)?i:void 0}function Ai(t,e){if("function"!=typeof t||e&&"function"!=typeof e)throw new TypeError(Ze);var i=function(){var r=arguments,n=e?e.apply(this,r):r[0],o=i.cache;if(o.has(n))return o.get(n);var s=t.apply(this,r);return i.cache=o.set(n,s),s};return i.cache=new(Ai.Cache||wi),i}function Mi(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}xi.prototype.clear=function(){this.__data__=mi?mi(null):{}},xi.prototype.delete=function(t){return this.has(t)&&delete this.__data__[t]},xi.prototype.get=function(t){var e=this.__data__;if(mi){var i=e[t];return i===ti?void 0:i}return pi.call(e,t)?e[t]:void 0},xi.prototype.has=function(t){var e=this.__data__;return mi?void 0!==e[t]:pi.call(e,t)},xi.prototype.set=function(t,e){return this.__data__[t]=mi&&void 0===e?ti:e,this},Ei.prototype.clear=function(){this.__data__=[]},Ei.prototype.delete=function(t){var e=this.__data__,i=_i(e,t);return!(i<0||(i==e.length-1?e.pop():bi.call(e,i,1),0))},Ei.prototype.get=function(t){var e=this.__data__,i=_i(e,t);return i<0?void 0:e[i][1]},Ei.prototype.has=function(t){return _i(this.__data__,t)>-1},Ei.prototype.set=function(t,e){var i=this.__data__,r=_i(i,t);return r<0?i.push([t,e]):i[r][1]=e,this},wi.prototype.clear=function(){this.__data__={hash:new xi,map:new(gi||Ei),string:new xi}},wi.prototype.delete=function(t){return Si(this,t).delete(t)},wi.prototype.get=function(t){return Si(this,t).get(t)},wi.prototype.has=function(t){return Si(this,t).has(t)},wi.prototype.set=function(t,e){return Si(this,t).set(t,e),this},Ai.Cache=wi;var Li=Ai,Ti=function(){if("undefined"!=typeof Map)return Map;function t(t,e){var i=-1;return t.some(function(t,r){return t[0]===e&&(i=r,!0)}),i}return function(){function e(){this.__entries__=[]}return Object.defineProperty(e.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),e.prototype.get=function(e){var i=t(this.__entries__,e),r=this.__entries__[i];return r&&r[1]},e.prototype.set=function(e,i){var r=t(this.__entries__,e);~r?this.__entries__[r][1]=i:this.__entries__.push([e,i])},e.prototype.delete=function(e){var i=this.__entries__,r=t(i,e);~r&&i.splice(r,1)},e.prototype.has=function(e){return!!~t(this.__entries__,e)},e.prototype.clear=function(){this.__entries__.splice(0)},e.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var i=0,r=this.__entries__;i<r.length;i++){var n=r[i];t.call(e,n[1],n[0])}},e}()}(),ji="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,Ri="undefined"!=typeof global&&global.Math===Math?global:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),Ni="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(Ri):function(t){return setTimeout(function(){return t(Date.now())},1e3/60)},Wi=2;var Ci=20,zi=["top","right","bottom","left","width","height","size","weight"],Di="undefined"!=typeof MutationObserver,Vi=function(){function t(){this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=function(t,e){var i=!1,r=!1,n=0;function o(){i&&(i=!1,t()),r&&a()}function s(){Ni(o)}function a(){var t=Date.now();if(i){if(t-n<Wi)return;r=!0}else i=!0,r=!1,setTimeout(s,e);n=t}return a}(this.refresh.bind(this),Ci)}return t.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},t.prototype.removeObserver=function(t){var e=this.observers_,i=e.indexOf(t);~i&&e.splice(i,1),!e.length&&this.connected_&&this.disconnect_()},t.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},t.prototype.updateObservers_=function(){var t=this.observers_.filter(function(t){return t.gatherActive(),t.hasActive()});return t.forEach(function(t){return t.broadcastActive()}),t.length>0},t.prototype.connect_=function(){ji&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),Di?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},t.prototype.disconnect_=function(){ji&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},t.prototype.onTransitionEnd_=function(t){var e=t.propertyName,i=void 0===e?"":e;zi.some(function(t){return!!~i.indexOf(t)})&&this.refresh()},t.getInstance=function(){return this.instance_||(this.instance_=new t),this.instance_},t.instance_=null,t}(),Bi=function(t,e){for(var i=0,r=Object.keys(e);i<r.length;i++){var n=r[i];Object.defineProperty(t,n,{value:e[n],enumerable:!1,writable:!1,configurable:!0})}return t},Pi=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||Ri},Fi=Yi(0,0,0,0);function Ii(t){return parseFloat(t)||0}function Hi(t){for(var e=[],i=1;i<arguments.length;i++)e[i-1]=arguments[i];return e.reduce(function(e,i){return e+Ii(t["border-"+i+"-width"])},0)}function qi(t){var e=t.clientWidth,i=t.clientHeight;if(!e&&!i)return Fi;var r=Pi(t).getComputedStyle(t),n=function(t){for(var e={},i=0,r=["top","right","bottom","left"];i<r.length;i++){var n=r[i],o=t["padding-"+n];e[n]=Ii(o)}return e}(r),o=n.left+n.right,s=n.top+n.bottom,a=Ii(r.width),l=Ii(r.height);if("border-box"===r.boxSizing&&(Math.round(a+o)!==e&&(a-=Hi(r,"left","right")+o),Math.round(l+s)!==i&&(l-=Hi(r,"top","bottom")+s)),!function(t){return t===Pi(t).document.documentElement}(t)){var c=Math.round(a+o)-e,u=Math.round(l+s)-i;1!==Math.abs(c)&&(a-=c),1!==Math.abs(u)&&(l-=u)}return Yi(n.left,n.top,a,l)}var $i="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof Pi(t).SVGGraphicsElement}:function(t){return t instanceof Pi(t).SVGElement&&"function"==typeof t.getBBox};function Xi(t){return ji?$i(t)?function(t){var e=t.getBBox();return Yi(0,0,e.width,e.height)}(t):qi(t):Fi}function Yi(t,e,i,r){return{x:t,y:e,width:i,height:r}}var Gi=function(){function t(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=Yi(0,0,0,0),this.target=t}return t.prototype.isActive=function(){var t=Xi(this.target);return this.contentRect_=t,t.width!==this.broadcastWidth||t.height!==this.broadcastHeight},t.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},t}(),Ui=function(){return function(t,e){var i,r,n,o,s,a,l,c=(r=(i=e).x,n=i.y,o=i.width,s=i.height,a="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,l=Object.create(a.prototype),Bi(l,{x:r,y:n,width:o,height:s,top:n,right:r+o,bottom:s+n,left:r}),l);Bi(this,{target:t,contentRect:c})}}(),Ji=function(){function t(t,e,i){if(this.activeObservations_=[],this.observations_=new Ti,"function"!=typeof t)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=t,this.controller_=e,this.callbackCtx_=i}return t.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof Pi(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new Gi(t)),this.controller_.addObserver(this),this.controller_.refresh())}},t.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof Pi(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},t.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},t.prototype.gatherActive=function(){var t=this;this.clearActive(),this.observations_.forEach(function(e){e.isActive()&&t.activeObservations_.push(e)})},t.prototype.broadcastActive=function(){if(this.hasActive()){var t=this.callbackCtx_,e=this.activeObservations_.map(function(t){return new Ui(t.target,t.broadcastRect())});this.callback_.call(t,e,t),this.clearActive()}},t.prototype.clearActive=function(){this.activeObservations_.splice(0)},t.prototype.hasActive=function(){return this.activeObservations_.length>0},t}(),Ki="undefined"!=typeof WeakMap?new WeakMap:new Ti,Qi=function(){return function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var i=Vi.getInstance(),r=new Ji(e,i,this);Ki.set(this,r)}}();["observe","unobserve","disconnect"].forEach(function(t){Qi.prototype[t]=function(){var e;return(e=Ki.get(this))[t].apply(e,arguments)}});var Zi=void 0!==Ri.ResizeObserver?Ri.ResizeObserver:Qi,tr=!("undefined"==typeof window||!window.document||!window.document.createElement),er=function(){function t(e,i){var r=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.onScroll=function(){r.scrollXTicking||(window.requestAnimationFrame(r.scrollX),r.scrollXTicking=!0),r.scrollYTicking||(window.requestAnimationFrame(r.scrollY),r.scrollYTicking=!0)},this.scrollX=function(){r.axis.x.isOverflowing&&(r.showScrollbar("x"),r.positionScrollbar("x")),r.scrollXTicking=!1},this.scrollY=function(){r.axis.y.isOverflowing&&(r.showScrollbar("y"),r.positionScrollbar("y")),r.scrollYTicking=!1},this.onMouseEnter=function(){r.showScrollbar("x"),r.showScrollbar("y")},this.onMouseMove=function(t){r.mouseX=t.clientX,r.mouseY=t.clientY,(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&r.onMouseMoveForAxis("x"),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&r.onMouseMoveForAxis("y")},this.onMouseLeave=function(){r.onMouseMove.cancel(),(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&r.onMouseLeaveForAxis("x"),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&r.onMouseLeaveForAxis("y"),r.mouseX=-1,r.mouseY=-1},this.onWindowResize=function(){r.scrollbarWidth=ve(),r.hideNativeScrollbar()},this.hideScrollbars=function(){r.axis.x.track.rect=r.axis.x.track.el.getBoundingClientRect(),r.axis.y.track.rect=r.axis.y.track.el.getBoundingClientRect(),r.isWithinBounds(r.axis.y.track.rect)||(r.axis.y.scrollbar.el.classList.remove(r.classNames.visible),r.axis.y.isVisible=!1),r.isWithinBounds(r.axis.x.track.rect)||(r.axis.x.scrollbar.el.classList.remove(r.classNames.visible),r.axis.x.isVisible=!1)},this.onPointerEvent=function(t){var e,i;r.axis.x.scrollbar.rect=r.axis.x.scrollbar.el.getBoundingClientRect(),r.axis.y.scrollbar.rect=r.axis.y.scrollbar.el.getBoundingClientRect(),(r.axis.x.isOverflowing||r.axis.x.forceVisible)&&(i=r.isWithinBounds(r.axis.x.scrollbar.rect)),(r.axis.y.isOverflowing||r.axis.y.forceVisible)&&(e=r.isWithinBounds(r.axis.y.scrollbar.rect)),(e||i)&&(t.preventDefault(),t.stopPropagation(),"mousedown"===t.type&&(e&&r.onDragStart(t,"y"),i&&r.onDragStart(t,"x")))},this.drag=function(e){var i=r.axis[r.draggedAxis].track,n=i.rect[r.axis[r.draggedAxis].sizeAttr],o=r.axis[r.draggedAxis].scrollbar;e.preventDefault(),e.stopPropagation();var s=(("y"===r.draggedAxis?e.pageY:e.pageX)-i.rect[r.axis[r.draggedAxis].offsetAttr]-r.axis[r.draggedAxis].dragOffset)/i.rect[r.axis[r.draggedAxis].sizeAttr]*r.contentEl[r.axis[r.draggedAxis].scrollSizeAttr];"x"===r.draggedAxis&&(s=r.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?s-(n+o.size):s,s=r.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-s:s),r.contentEl[r.axis[r.draggedAxis].scrollOffsetAttr]=s},this.onEndDrag=function(t){t.preventDefault(),t.stopPropagation(),r.el.classList.remove(r.classNames.dragging),document.removeEventListener("mousemove",r.drag),document.removeEventListener("mouseup",r.onEndDrag)},this.el=e,this.flashTimeout,this.contentEl,this.offsetEl,this.maskEl,this.globalObserver,this.mutationObserver,this.resizeObserver,this.scrollbarWidth,this.minScrollbarWidth=20,this.options=pe({},t.defaultOptions,i),this.classNames=pe({},t.defaultOptions.classNames,this.options.classNames),this.isRtl,this.axis={x:{scrollOffsetAttr:"scrollLeft",sizeAttr:"width",scrollSizeAttr:"scrollWidth",offsetAttr:"left",overflowAttr:"overflowX",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}},y:{scrollOffsetAttr:"scrollTop",sizeAttr:"height",scrollSizeAttr:"scrollHeight",offsetAttr:"top",overflowAttr:"overflowY",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}}},this.recalculate=We(this.recalculate.bind(this),64),this.onMouseMove=We(this.onMouseMove.bind(this),64),this.hideScrollbars=Qe(this.hideScrollbars.bind(this),this.options.timeout),this.onWindowResize=Qe(this.onWindowResize.bind(this),64,{leading:!0}),t.getRtlHelpers=Li(t.getRtlHelpers),this.getContentElement=this.getScrollElement,this.init()}var e,i,r;return e=t,r=[{key:"getRtlHelpers",value:function(){var e=document.createElement("div");e.innerHTML='<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';var i=e.firstElementChild;document.body.appendChild(i);var r=i.firstElementChild;i.scrollLeft=0;var n=t.getOffset(i),o=t.getOffset(r);i.scrollLeft=999;var s=t.getOffset(r);return{isRtlScrollingInverted:n.left!==o.left&&o.left-s.left!=0,isRtlScrollbarInverted:n.left!==o.left}}},{key:"initHtmlApi",value:function(){this.initDOMLoadedElements=this.initDOMLoadedElements.bind(this),"undefined"!=typeof MutationObserver&&(this.globalObserver=new MutationObserver(function(e){e.forEach(function(e){Array.from(e.addedNodes).forEach(function(e){1===e.nodeType&&(e.hasAttribute("data-simplebar")?!e.SimpleBar&&new t(e,t.getElOptions(e)):Array.from(e.querySelectorAll("[data-simplebar]")).forEach(function(e){!e.SimpleBar&&new t(e,t.getElOptions(e))}))}),Array.from(e.removedNodes).forEach(function(t){1===t.nodeType&&(t.hasAttribute("data-simplebar")?t.SimpleBar&&t.SimpleBar.unMount():Array.from(t.querySelectorAll("[data-simplebar]")).forEach(function(t){t.SimpleBar&&t.SimpleBar.unMount()}))})})}),this.globalObserver.observe(document,{childList:!0,subtree:!0})),"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(this.initDOMLoadedElements):(document.addEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.addEventListener("load",this.initDOMLoadedElements))}},{key:"getElOptions",value:function(t){return Array.from(t.attributes).reduce(function(t,e){var i=e.name.match(/data-simplebar-(.+)/);if(i){var r=i[1].replace(/\W+(.)/g,function(t,e){return e.toUpperCase()});switch(e.value){case"true":t[r]=!0;break;case"false":t[r]=!1;break;case void 0:t[r]=!0;break;default:t[r]=e.value}}return t},{})}},{key:"removeObserver",value:function(){this.globalObserver.disconnect()}},{key:"initDOMLoadedElements",value:function(){document.removeEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.removeEventListener("load",this.initDOMLoadedElements),Array.from(document.querySelectorAll("[data-simplebar]")).forEach(function(e){e.SimpleBar||new t(e,t.getElOptions(e))})}},{key:"getOffset",value:function(t){var e=t.getBoundingClientRect();return{top:e.top+(window.pageYOffset||document.documentElement.scrollTop),left:e.left+(window.pageXOffset||document.documentElement.scrollLeft)}}}],(i=[{key:"init",value:function(){this.el.SimpleBar=this,tr&&(this.initDOM(),this.scrollbarWidth=ve(),this.recalculate(),this.initListeners())}},{key:"initDOM",value:function(){var t=this;if(Array.from(this.el.children).filter(function(e){return e.classList.contains(t.classNames.wrapper)}).length)this.wrapperEl=this.el.querySelector(".".concat(this.classNames.wrapper)),this.contentEl=this.el.querySelector(".".concat(this.classNames.content)),this.offsetEl=this.el.querySelector(".".concat(this.classNames.offset)),this.maskEl=this.el.querySelector(".".concat(this.classNames.mask)),this.placeholderEl=this.el.querySelector(".".concat(this.classNames.placeholder)),this.heightAutoObserverWrapperEl=this.el.querySelector(".".concat(this.classNames.heightAutoObserverWrapperEl)),this.heightAutoObserverEl=this.el.querySelector(".".concat(this.classNames.heightAutoObserverEl)),this.axis.x.track.el=this.el.querySelector(".".concat(this.classNames.track,".").concat(this.classNames.horizontal)),this.axis.y.track.el=this.el.querySelector(".".concat(this.classNames.track,".").concat(this.classNames.vertical));else{for(this.wrapperEl=document.createElement("div"),this.contentEl=document.createElement("div"),this.offsetEl=document.createElement("div"),this.maskEl=document.createElement("div"),this.placeholderEl=document.createElement("div"),this.heightAutoObserverWrapperEl=document.createElement("div"),this.heightAutoObserverEl=document.createElement("div"),this.wrapperEl.classList.add(this.classNames.wrapper),this.contentEl.classList.add(this.classNames.content),this.offsetEl.classList.add(this.classNames.offset),this.maskEl.classList.add(this.classNames.mask),this.placeholderEl.classList.add(this.classNames.placeholder),this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl),this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);this.offsetEl.appendChild(this.contentEl),this.maskEl.appendChild(this.offsetEl),this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),this.wrapperEl.appendChild(this.maskEl),this.wrapperEl.appendChild(this.placeholderEl),this.el.appendChild(this.wrapperEl)}if(!this.axis.x.track.el||!this.axis.y.track.el){var e=document.createElement("div"),i=document.createElement("div");e.classList.add(this.classNames.track),i.classList.add(this.classNames.scrollbar),e.appendChild(i),this.axis.x.track.el=e.cloneNode(!0),this.axis.x.track.el.classList.add(this.classNames.horizontal),this.axis.y.track.el=e.cloneNode(!0),this.axis.y.track.el.classList.add(this.classNames.vertical),this.el.appendChild(this.axis.x.track.el),this.el.appendChild(this.axis.y.track.el)}this.axis.x.scrollbar.el=this.axis.x.track.el.querySelector(".".concat(this.classNames.scrollbar)),this.axis.y.scrollbar.el=this.axis.y.track.el.querySelector(".".concat(this.classNames.scrollbar)),this.options.autoHide||(this.axis.x.scrollbar.el.classList.add(this.classNames.visible),this.axis.y.scrollbar.el.classList.add(this.classNames.visible)),this.el.setAttribute("data-simplebar","init")}},{key:"initListeners",value:function(){var t=this;this.options.autoHide&&this.el.addEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick","touchstart","touchend","touchmove"].forEach(function(e){t.el.addEventListener(e,t.onPointerEvent,!0)}),this.el.addEventListener("mousemove",this.onMouseMove),this.el.addEventListener("mouseleave",this.onMouseLeave),this.contentEl.addEventListener("scroll",this.onScroll),window.addEventListener("resize",this.onWindowResize),"undefined"!=typeof MutationObserver&&(this.mutationObserver=new MutationObserver(function(e){e.forEach(function(e){(e.target===t.contentEl||t.isChildNode(e.target)||e.addedNodes.length||e.removedNodes.length)&&t.recalculate()})}),this.mutationObserver.observe(this.contentEl,{attributes:!0,childList:!0,characterData:!0,subtree:!0})),this.resizeObserver=new Zi(this.recalculate),this.resizeObserver.observe(this.el)}},{key:"recalculate",value:function(){var t=this.heightAutoObserverEl.offsetHeight<=1;this.elStyles=window.getComputedStyle(this.el),this.isRtl="rtl"===this.elStyles.direction,this.contentEl.style.padding="".concat(this.elStyles.paddingTop," ").concat(this.elStyles.paddingRight," ").concat(this.elStyles.paddingBottom," ").concat(this.elStyles.paddingLeft),this.contentEl.style.height=t?"auto":"100%",this.placeholderEl.style.width="".concat(this.contentEl.scrollWidth,"px"),this.placeholderEl.style.height="".concat(this.contentEl.scrollHeight,"px"),this.wrapperEl.style.margin="-".concat(this.elStyles.paddingTop," -").concat(this.elStyles.paddingRight," -").concat(this.elStyles.paddingBottom," -").concat(this.elStyles.paddingLeft),this.axis.x.track.rect=this.axis.x.track.el.getBoundingClientRect(),this.axis.y.track.rect=this.axis.y.track.el.getBoundingClientRect(),this.axis.x.isOverflowing=(this.scrollbarWidth?this.contentEl.scrollWidth:this.contentEl.scrollWidth-this.minScrollbarWidth)>Math.ceil(this.axis.x.track.rect.width),this.axis.y.isOverflowing=(this.scrollbarWidth?this.contentEl.scrollHeight:this.contentEl.scrollHeight-this.minScrollbarWidth)>Math.ceil(this.axis.y.track.rect.height),this.axis.x.isOverflowing="hidden"!==this.elStyles.overflowX&&this.axis.x.isOverflowing,this.axis.y.isOverflowing="hidden"!==this.elStyles.overflowY&&this.axis.y.isOverflowing,this.axis.x.forceVisible="x"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.y.forceVisible="y"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.x.scrollbar.size=this.getScrollbarSize("x"),this.axis.y.scrollbar.size=this.getScrollbarSize("y"),this.axis.x.scrollbar.el.style.width="".concat(this.axis.x.scrollbar.size,"px"),this.axis.y.scrollbar.el.style.height="".concat(this.axis.y.scrollbar.size,"px"),this.positionScrollbar("x"),this.positionScrollbar("y"),this.toggleTrackVisibility("x"),this.toggleTrackVisibility("y"),this.hideNativeScrollbar()}},{key:"getScrollbarSize",value:function(){var t,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"y",i=this.scrollbarWidth?this.contentEl[this.axis[e].scrollSizeAttr]:this.contentEl[this.axis[e].scrollSizeAttr]-this.minScrollbarWidth,r=this.axis[e].track.rect[this.axis[e].sizeAttr];if(this.axis[e].isOverflowing){var n=r/i;return t=Math.max(~~(n*r),this.options.scrollbarMinSize),this.options.scrollbarMaxSize&&(t=Math.min(t,this.options.scrollbarMaxSize)),t}}},{key:"positionScrollbar",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"y",i=this.contentEl[this.axis[e].scrollSizeAttr],r=this.axis[e].track.rect[this.axis[e].sizeAttr],n=parseInt(this.elStyles[this.axis[e].sizeAttr],10),o=this.axis[e].scrollbar,s=this.contentEl[this.axis[e].scrollOffsetAttr],a=(s="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-s:s)/(i-n),l=~~((r-o.size)*a);l="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?l+(r-o.size):l,o.el.style.transform="x"===e?"translate3d(".concat(l,"px, 0, 0)"):"translate3d(0, ".concat(l,"px, 0)")}},{key:"toggleTrackVisibility",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"y",e=this.axis[t].track.el,i=this.axis[t].scrollbar.el;this.axis[t].isOverflowing||this.axis[t].forceVisible?(e.style.visibility="visible",this.contentEl.style[this.axis[t].overflowAttr]="scroll"):(e.style.visibility="hidden",this.contentEl.style[this.axis[t].overflowAttr]="hidden"),this.axis[t].isOverflowing?i.style.visibility="visible":i.style.visibility="hidden"}},{key:"hideNativeScrollbar",value:function(){if(this.offsetEl.style[this.isRtl?"left":"right"]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"-".concat(this.scrollbarWidth||this.minScrollbarWidth,"px"):0,this.offsetEl.style.bottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"-".concat(this.scrollbarWidth||this.minScrollbarWidth,"px"):0,!this.scrollbarWidth){var t=[this.isRtl?"paddingLeft":"paddingRight"];this.contentEl.style[t]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"calc(".concat(this.elStyles[t]," + ").concat(this.minScrollbarWidth,"px)"):this.elStyles[t],this.contentEl.style.paddingBottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"calc(".concat(this.elStyles.paddingBottom," + ").concat(this.minScrollbarWidth,"px)"):this.elStyles.paddingBottom}}},{key:"onMouseMoveForAxis",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"y";this.axis[t].track.rect=this.axis[t].track.el.getBoundingClientRect(),this.axis[t].scrollbar.rect=this.axis[t].scrollbar.el.getBoundingClientRect(),this.isWithinBounds(this.axis[t].scrollbar.rect)?this.axis[t].scrollbar.el.classList.add(this.classNames.hover):this.axis[t].scrollbar.el.classList.remove(this.classNames.hover),this.isWithinBounds(this.axis[t].track.rect)?(this.showScrollbar(t),this.axis[t].track.el.classList.add(this.classNames.hover)):this.axis[t].track.el.classList.remove(this.classNames.hover)}},{key:"onMouseLeaveForAxis",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"y";this.axis[t].track.el.classList.remove(this.classNames.hover),this.axis[t].scrollbar.el.classList.remove(this.classNames.hover)}},{key:"showScrollbar",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"y",e=this.axis[t].scrollbar.el;this.axis[t].isVisible||(e.classList.add(this.classNames.visible),this.axis[t].isVisible=!0),this.options.autoHide&&this.hideScrollbars()}},{key:"onDragStart",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"y",i=this.axis[e].scrollbar.el,r="y"===e?t.pageY:t.pageX;this.axis[e].dragOffset=r-i.getBoundingClientRect()[this.axis[e].offsetAttr],this.draggedAxis=e,this.el.classList.add(this.classNames.dragging),document.addEventListener("mousemove",this.drag),document.addEventListener("mouseup",this.onEndDrag)}},{key:"getScrollElement",value:function(){return this.contentEl}},{key:"removeListeners",value:function(){var t=this;this.options.autoHide&&this.el.removeEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick","touchstart","touchend","touchmove"].forEach(function(e){t.el.removeEventListener(e,t.onPointerEvent)}),this.el.removeEventListener("mousemove",this.onMouseMove),this.el.removeEventListener("mouseleave",this.onMouseLeave),this.contentEl.removeEventListener("scroll",this.onScroll),window.removeEventListener("resize",this.onWindowResize),this.mutationObserver&&this.mutationObserver.disconnect(),this.resizeObserver.disconnect(),this.recalculate.cancel(),this.onMouseMove.cancel(),this.hideScrollbars.cancel(),this.onWindowResize.cancel()}},{key:"unMount",value:function(){this.removeListeners(),this.el.SimpleBar=null}},{key:"isChildNode",value:function(t){return null!==t&&(t===this.el||this.isChildNode(t.parentNode))}},{key:"isWithinBounds",value:function(t){return this.mouseX>=t.left&&this.mouseX<=t.left+t.width&&this.mouseY>=t.top&&this.mouseY<=t.top+t.height}}])&&fe(e.prototype,i),r&&fe(e,r),t}();return er.defaultOptions={autoHide:!0,forceVisible:!1,classNames:{content:"simplebar-content",offset:"simplebar-offset",mask:"simplebar-mask",wrapper:"simplebar-wrapper",placeholder:"simplebar-placeholder",scrollbar:"simplebar-scrollbar",track:"simplebar-track",heightAutoObserverWrapperEl:"simplebar-height-auto-observer-wrapper",heightAutoObserverEl:"simplebar-height-auto-observer",visible:"simplebar-visible",horizontal:"simplebar-horizontal",vertical:"simplebar-vertical",hover:"simplebar-hover",dragging:"simplebar-dragging"},scrollbarMinSize:25,scrollbarMaxSize:0,timeout:1e3},tr&&er.initHtmlApi(),er});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {function autoload() {
  $.each(CCL, function (section, obj) {
    if ($.isArray(obj.autoload)) {
      $.each(obj.autoload, function (key, value) {
        if ($.isArray(value)) {
          if (value[1]) {
            CCL[section][value[0]]();
          } else if (value[2]) {
            CCL[section][value[2]]();
          }
        } else {
          CCL[section][value]();
        }
      });
    }
  });
}

$(function () {
  autoload();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(jQuery, $) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* eslint-disable */
/**
 * jQuery.query - Query String Modification and Creation for jQuery
 * Written by Blair Mitchelmore (blair DOT mitchelmore AT gmail DOT com)
 * Licensed under the WTFPL (http://sam.zoy.org/wtfpl/).
 * Date: 2009/8/13
 *
 * @author Blair Mitchelmore
 * @version 2.2.3
 *
 **/
new function (settings) {
  // Various Settings
  var $separator = settings.separator || '&';
  var $spaces = settings.spaces === false ? false : true;
  var $suffix = settings.suffix === false ? '' : '[]';
  var $prefix = settings.prefix === false ? false : true;
  var $hash = $prefix ? settings.hash === true ? "#" : "?" : "";
  var $numbers = settings.numbers === false ? false : true;

  jQuery.query = new function () {
    var is = function is(o, t) {
      return o != undefined && o !== null && (!!t ? o.constructor == t : true);
    };
    var parse = function parse(path) {
      var m,
          rx = /\[([^[]*)\]/g,
          match = /^([^[]+)(\[.*\])?$/.exec(path),
          base = match[1],
          tokens = [];
      while (m = rx.exec(match[2])) {
        tokens.push(m[1]);
      }return [base, tokens];
    };
    var set = function set(target, tokens, value) {
      var o,
          token = tokens.shift();
      if ((typeof target === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(target)) != 'object') target = null;
      if (token === "") {
        if (!target) target = [];
        if (is(target, Array)) {
          target.push(tokens.length == 0 ? value : set(null, tokens.slice(0), value));
        } else if (is(target, Object)) {
          var i = 0;
          while (target[i++] != null) {}
          target[--i] = tokens.length == 0 ? value : set(target[i], tokens.slice(0), value);
        } else {
          target = [];
          target.push(tokens.length == 0 ? value : set(null, tokens.slice(0), value));
        }
      } else if (token && token.match(/^\s*[0-9]+\s*$/)) {
        var index = parseInt(token, 10);
        if (!target) target = [];
        target[index] = tokens.length == 0 ? value : set(target[index], tokens.slice(0), value);
      } else if (token) {
        var index = token.replace(/^\s*|\s*$/g, "");
        if (!target) target = {};
        if (is(target, Array)) {
          var temp = {};
          for (var i = 0; i < target.length; ++i) {
            temp[i] = target[i];
          }
          target = temp;
        }
        target[index] = tokens.length == 0 ? value : set(target[index], tokens.slice(0), value);
      } else {
        return value;
      }
      return target;
    };

    var queryObject = function queryObject(a) {
      var self = this;
      self.keys = {};

      if (a.queryObject) {
        jQuery.each(a.get(), function (key, val) {
          self.SET(key, val);
        });
      } else {
        self.parseNew.apply(self, arguments);
      }
      return self;
    };

    queryObject.prototype = {
      queryObject: true,
      parseNew: function parseNew() {
        var self = this;
        self.keys = {};
        jQuery.each(arguments, function () {
          var q = "" + this;
          q = q.replace(/^[?#]/, ''); // remove any leading ? || #
          q = q.replace(/[;&]$/, ''); // remove any trailing & || ;
          if ($spaces) q = q.replace(/[+]/g, ' '); // replace +'s with spaces

          jQuery.each(q.split(/[&;]/), function () {
            var key = decodeURIComponent(this.split('=')[0] || "");
            var val = decodeURIComponent(this.split('=')[1] || "");

            if (!key) return;

            if ($numbers) {
              if (/^[+-]?[0-9]+\.[0-9]*$/.test(val)) // simple float regex
                val = parseFloat(val);else if (/^[+-]?[1-9][0-9]*$/.test(val)) // simple int regex
                val = parseInt(val, 10);
            }

            val = !val && val !== 0 ? true : val;

            self.SET(key, val);
          });
        });
        return self;
      },
      has: function has(key, type) {
        var value = this.get(key);
        return is(value, type);
      },
      GET: function GET(key) {
        if (!is(key)) return this.keys;
        var parsed = parse(key),
            base = parsed[0],
            tokens = parsed[1];
        var target = this.keys[base];
        while (target != null && tokens.length != 0) {
          target = target[tokens.shift()];
        }
        return typeof target == 'number' ? target : target || "";
      },
      get: function get(key) {
        var target = this.GET(key);
        if (is(target, Object)) return jQuery.extend(true, {}, target);else if (is(target, Array)) return target.slice(0);
        return target;
      },
      SET: function SET(key, val) {
        var value = !is(val) ? null : val;
        var parsed = parse(key),
            base = parsed[0],
            tokens = parsed[1];
        var target = this.keys[base];
        this.keys[base] = set(target, tokens.slice(0), value);
        return this;
      },
      set: function set(key, val) {
        return this.copy().SET(key, val);
      },
      REMOVE: function REMOVE(key, val) {
        if (val) {
          var target = this.GET(key);
          if (is(target, Array)) {
            for (tval in target) {
              target[tval] = target[tval].toString();
            }
            var index = $.inArray(val, target);
            if (index >= 0) {
              key = target.splice(index, 1);
              key = key[index];
            } else {
              return;
            }
          } else if (val != target) {
            return;
          }
        }
        return this.SET(key, null).COMPACT();
      },
      remove: function remove(key, val) {
        return this.copy().REMOVE(key, val);
      },
      EMPTY: function EMPTY() {
        var self = this;
        jQuery.each(self.keys, function (key, value) {
          delete self.keys[key];
        });
        return self;
      },
      load: function load(url) {
        var hash = url.replace(/^.*?[#](.+?)(?:\?.+)?$/, "$1");
        var search = url.replace(/^.*?[?](.+?)(?:#.+)?$/, "$1");
        return new queryObject(url.length == search.length ? '' : search, url.length == hash.length ? '' : hash);
      },
      empty: function empty() {
        return this.copy().EMPTY();
      },
      copy: function copy() {
        return new queryObject(this);
      },
      COMPACT: function COMPACT() {
        function build(orig) {
          var obj = (typeof orig === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(orig)) == "object" ? is(orig, Array) ? [] : {} : orig;
          if ((typeof orig === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(orig)) == 'object') {
            var add = function add(o, key, value) {
              if (is(o, Array)) o.push(value);else o[key] = value;
            };

            jQuery.each(orig, function (key, value) {
              if (!is(value)) return true;
              add(obj, key, build(value));
            });
          }
          return obj;
        }
        this.keys = build(this.keys);
        return this;
      },
      compact: function compact() {
        return this.copy().COMPACT();
      },
      toString: function toString() {
        var i = 0,
            queryString = [],
            chunks = [],
            self = this;
        var encode = function encode(str) {
          str = str + "";
          str = encodeURIComponent(str);
          if ($spaces) str = str.replace(/%20/g, "+");
          return str;
        };
        var addFields = function addFields(arr, key, value) {
          if (!is(value) || value === false) return;
          var o = [encode(key)];
          if (value !== true) {
            o.push("=");
            o.push(encode(value));
          }
          arr.push(o.join(""));
        };
        var build = function build(obj, base) {
          var newKey = function newKey(key) {
            return !base || base == "" ? [key].join("") : [base, "[", key, "]"].join("");
          };
          jQuery.each(obj, function (key, value) {
            if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) == 'object') build(value, newKey(key));else addFields(chunks, newKey(key), value);
          });
        };

        build(this.keys);

        if (chunks.length > 0) queryString.push($hash);
        queryString.push(chunks.join($separator));

        return queryString.join("");
      }
    };

    return new queryObject(location.search, location.hash);
  }();
}(jQuery.query || {}); // Pass in jQuery.query as settings object
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3), __webpack_require__(3)))

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* eslint-disable */
/*
 *  jQuery StarRatingSvg v1.2.0
 *
 *  http://github.com/nashio/star-rating-svg
 *  Author: Ignacio Chavez
 *  hello@ignaciochavez.com
 *  Licensed under MIT
 */

;(function ($, window, document, undefined) {

  'use strict';

  // Create the defaults once

  var pluginName = 'starRating';
  var noop = function noop() {};
  var defaults = {
    totalStars: 5,
    useFullStars: false,
    starShape: 'straight',
    emptyColor: 'white',
    hoverColor: '#10559a',
    activeColor: '#10559a',
    ratedColor: '#10559a',
    useGradient: true,
    readOnly: false,
    disableAfterRate: true,
    baseUrl: false,
    starGradient: {
      start: '#10559a',
      end: '#10559a'
    },
    strokeWidth: 30,
    strokeColor: 'gray',
    initialRating: 0,
    starSize: 30,
    callback: noop,
    onHover: noop,
    onLeave: noop,
    onClick: noop
  };

  // The actual plugin constructor
  var Plugin = function Plugin(element, options) {
    var _rating;
    var newRating;
    var roundFn;

    this.element = element;
    this.$el = $(element);
    this.settings = $.extend({}, defaults, options);

    // grab rating if defined on the element
    _rating = this.$el.data('rating') || this.settings.initialRating;

    // round to the nearest half
    roundFn = this.settings.forceRoundUp ? Math.ceil : Math.round;
    newRating = (roundFn(_rating * 2) / 2).toFixed(1);
    this._state = {
      rating: newRating
    };

    // create unique id for stars
    this._uid = Math.floor(Math.random() * 999);

    // override gradient if not used
    if (!options.starGradient && !this.settings.useGradient) {
      this.settings.starGradient.start = this.settings.starGradient.end = this.settings.activeColor;
    }

    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  };

  var methods = {
    init: function init() {
      this.renderMarkup();
      this.addListeners();
      this.initRating();
    },

    addListeners: function addListeners() {
      if (this.settings.readOnly) {
        return;
      }
      this.$stars.on('mouseover', this.hoverRating.bind(this));
      this.$stars.on('mouseout', this.restoreState.bind(this));
      this.$stars.on('click', this.handleRating.bind(this));
    },

    // apply styles to hovered stars
    hoverRating: function hoverRating(e) {
      var index = this.getIndex(e);
      this.paintStars(index, 'hovered');
      this.settings.onHover(index + 1, this._state.rating, this.$el);
    },

    // clicked on a rate, apply style and state
    handleRating: function handleRating(e) {
      var index = this.getIndex(e);
      var rating = index + 1;

      this.settings.onClick(rating, this.$el);
      this.applyRating(rating, this.$el);
      this.executeCallback(rating, this.$el);

      if (this.settings.disableAfterRate) {
        this.$stars.off();
      }
    },

    applyRating: function applyRating(rating) {
      var index = rating - 1;
      // paint selected and remove hovered color
      this.paintStars(index, 'rated');
      this._state.rating = index + 1;
      this._state.rated = true;
    },

    restoreState: function restoreState(e) {
      var index = this.getIndex(e);
      var rating = this._state.rating || -1;
      // determine star color depending on manually rated
      var colorType = this._state.rated ? 'rated' : 'active';
      this.paintStars(rating - 1, colorType);
      this.settings.onLeave(index + 1, this._state.rating, this.$el);
    },

    getIndex: function getIndex(e) {
      var $target = $(e.currentTarget);
      var width = $target.width();
      var side = $(e.target).attr('data-side');
      var minRating = this.settings.minRating;

      // hovered outside the star, calculate by pixel instead
      side = !side ? this.getOffsetByPixel(e, $target, width) : side;
      side = this.settings.useFullStars ? 'right' : side;

      // get index for half or whole star
      var index = $target.index() - (side === 'left' ? 0.5 : 0);

      // pointer is way to the left, rating should be none
      index = index < 0.5 && e.offsetX < width / 4 ? -1 : index;

      // force minimum rating
      index = minRating && minRating <= this.settings.totalStars && index < minRating ? minRating - 1 : index;
      return index;
    },

    getOffsetByPixel: function getOffsetByPixel(e, $target, width) {
      var leftX = e.pageX - $target.offset().left;
      return leftX <= width / 2 && !this.settings.useFullStars ? 'left' : 'right';
    },

    initRating: function initRating() {
      this.paintStars(this._state.rating - 1, 'active');
    },

    paintStars: function paintStars(endIndex, stateClass) {
      var $polygonLeft;
      var $polygonRight;
      var leftClass;
      var rightClass;

      $.each(this.$stars, function (index, star) {
        $polygonLeft = $(star).find('[data-side="left"]');
        $polygonRight = $(star).find('[data-side="right"]');
        leftClass = rightClass = index <= endIndex ? stateClass : 'empty';

        // has another half rating, add half star
        leftClass = index - endIndex === 0.5 ? stateClass : leftClass;

        $polygonLeft.attr('class', 'svg-' + leftClass + '-' + this._uid);
        $polygonRight.attr('class', 'svg-' + rightClass + '-' + this._uid);
      }.bind(this));
    },

    renderMarkup: function renderMarkup() {
      var s = this.settings;
      var baseUrl = s.baseUrl ? location.href.split('#')[0] : '';

      // inject svg markup
      var starsMarkup = '';
      for (var i = 0; i < s.totalStars; i++) {
        starsMarkup += '<div class="jq-star" style="width:' + s.starSize + 'px;  height:' + s.starSize + 'px;"><svg version="1.0" class="jq-star-svg" shape-rendering="geometricPrecision" xmlns="http://www.w3.org/2000/svg" ' + this.getSvgDimensions(s.starShape) + ' stroke-width:' + s.strokeWidth + 'px;" xml:space="preserve"><style type="text/css">.svg-empty-' + this._uid + '{fill:url(' + baseUrl + '#' + this._uid + '_SVGID_' + i + '_1_);}.svg-hovered-' + this._uid + '{fill:url(' + baseUrl + '#' + this._uid + '_SVGID_' + i + '_2_);}.svg-active-' + this._uid + '{fill:url(' + baseUrl + '#' + this._uid + '_SVGID_' + i + '_3_);}.svg-rated-' + this._uid + '{fill:' + s.ratedColor + ';}</style>' + this.getLinearGradient(this._uid + '_SVGID_' + i + '_1_', s.emptyColor, s.emptyColor, s.starShape) + this.getLinearGradient(this._uid + '_SVGID_' + i + '_2_', s.hoverColor, s.hoverColor, s.starShape) + this.getLinearGradient(this._uid + '_SVGID_' + i + '_3_', s.starGradient.start, s.starGradient.end, s.starShape) + this.getVectorPath(this._uid, {
          starShape: s.starShape,
          strokeWidth: s.strokeWidth,
          strokeColor: s.strokeColor
        }) + '</svg></div>';
      }
      this.$el.append(starsMarkup);
      this.$stars = this.$el.find('.jq-star');
    },

    getVectorPath: function getVectorPath(id, attrs) {
      return attrs.starShape === 'rounded' ? this.getRoundedVectorPath(id, attrs) : this.getSpikeVectorPath(id, attrs);
    },

    getSpikeVectorPath: function getSpikeVectorPath(id, attrs) {
      return '<polygon data-side="center" class="svg-empty-' + id + '" points="281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 212.9,181.1 213.9,181 306.5,241 " style="fill: transparent; stroke: ' + attrs.strokeColor + ';" />' + '<polygon data-side="left" class="svg-empty-' + id + '" points="281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 213.9,181.1 213.9,181 306.5,241 " style="stroke-opacity: 0;" />' + '<polygon data-side="right" class="svg-empty-' + id + '" points="364,55.7 255.5,46.8 214,-59 213.9,181 306.5,241 281.1,129.8 " style="stroke-opacity: 0;" />';
    },

    getRoundedVectorPath: function getRoundedVectorPath(id, attrs) {
      var fullPoints = 'M520.9,336.5c-3.8-11.8-14.2-20.5-26.5-22.2l-140.9-20.5l-63-127.7 c-5.5-11.2-16.8-18.2-29.3-18.2c-12.5,0-23.8,7-29.3,18.2l-63,127.7L28,314.2C15.7,316,5.4,324.7,1.6,336.5S1,361.3,9.9,370 l102,99.4l-24,140.3c-2.1,12.3,2.9,24.6,13,32c5.7,4.2,12.4,6.2,19.2,6.2c5.2,0,10.5-1.2,15.2-3.8l126-66.3l126,66.2 c4.8,2.6,10,3.8,15.2,3.8c6.8,0,13.5-2.1,19.2-6.2c10.1-7.3,15.1-19.7,13-32l-24-140.3l102-99.4 C521.6,361.3,524.8,348.3,520.9,336.5z';

      return '<path data-side="center" class="svg-empty-' + id + '" d="' + fullPoints + '" style="stroke: ' + attrs.strokeColor + '; fill: transparent; " /><path data-side="right" class="svg-empty-' + id + '" d="' + fullPoints + '" style="stroke-opacity: 0;" /><path data-side="left" class="svg-empty-' + id + '" d="M121,648c-7.3,0-14.1-2.2-19.8-6.4c-10.4-7.6-15.6-20.3-13.4-33l24-139.9l-101.6-99 c-9.1-8.9-12.4-22.4-8.6-34.5c3.9-12.1,14.6-21.1,27.2-23l140.4-20.4L232,164.6c5.7-11.6,17.3-18.8,30.2-16.8c0.6,0,1,0.4,1,1 v430.1c0,0.4-0.2,0.7-0.5,0.9l-126,66.3C132,646.6,126.6,648,121,648z" style="stroke: ' + attrs.strokeColor + '; stroke-opacity: 0;" />';
    },

    getSvgDimensions: function getSvgDimensions(starShape) {
      return starShape === 'rounded' ? 'width="550px" height="500.2px" viewBox="0 146.8 550 500.2" style="enable-background:new 0 0 550 500.2;' : 'x="0px" y="0px" width="305px" height="305px" viewBox="60 -62 309 309" style="enable-background:new 64 -59 305 305;';
    },

    getLinearGradient: function getLinearGradient(id, startColor, endColor, starShape) {
      var height = starShape === 'rounded' ? 500 : 250;
      return '<linearGradient id="' + id + '" gradientUnits="userSpaceOnUse" x1="0" y1="-50" x2="0" y2="' + height + '"><stop  offset="0" style="stop-color:' + startColor + '"/><stop  offset="1" style="stop-color:' + endColor + '"/> </linearGradient>';
    },

    executeCallback: function executeCallback(rating, $el) {
      var callback = this.settings.callback;
      callback(rating, $el);
    }

  };

  var publicMethods = {

    unload: function unload() {
      var _name = 'plugin_' + pluginName;
      var $el = $(this);
      var $starSet = $el.data(_name).$stars;
      $starSet.off();
      $el.removeData(_name).remove();
    },

    setRating: function setRating(rating, round) {
      var _name = 'plugin_' + pluginName;
      var $el = $(this);
      var $plugin = $el.data(_name);
      if (rating > $plugin.settings.totalStars || rating < 0) {
        return;
      }
      if (round) {
        rating = Math.round(rating);
      }
      $plugin.applyRating(rating);
    },

    getRating: function getRating() {
      var _name = 'plugin_' + pluginName;
      var $el = $(this);
      var $starSet = $el.data(_name);
      return $starSet._state.rating;
    },

    resize: function resize(newSize) {
      var _name = 'plugin_' + pluginName;
      var $el = $(this);
      var $starSet = $el.data(_name);
      var $stars = $starSet.$stars;

      if (newSize <= 1 || newSize > 200) {
        console.log('star size out of bounds');
        return;
      }

      $stars = Array.prototype.slice.call($stars);
      $stars.forEach(function (star) {
        $(star).css({
          'width': newSize + 'px',
          'height': newSize + 'px'
        });
      });
    },

    setReadOnly: function setReadOnly(flag) {
      var _name = 'plugin_' + pluginName;
      var $el = $(this);
      var $plugin = $el.data(_name);
      if (flag === true) {
        $plugin.$stars.off('mouseover mouseout click');
      } else {
        $plugin.settings.readOnly = false;
        $plugin.addListeners();
      }
    }

  };

  // Avoid Plugin.prototype conflicts
  $.extend(Plugin.prototype, methods);

  $.fn[pluginName] = function (options) {

    // if options is a public method
    if (!$.isPlainObject(options)) {
      if (publicMethods.hasOwnProperty(options)) {
        return publicMethods[options].apply(this, Array.prototype.slice.call(arguments, 1));
      } else {
        $.error('Method ' + options + ' does not exist on ' + pluginName + '.js');
      }
    }

    return this.each(function () {
      // preventing against multiple instantiations
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });
  };
})(jQuery, window, document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.carousel = {
  autoload: [['carousel2', $('.owl-carousel-2').length > 0], ['carousel3', $('.owl-carousel-3').length > 0], ['carousel4', $('.owl-carousel-4').length > 0], ['carousel5', $('.owl-carousel-5').length > 0], ['carousel6', $('.owl-carousel-6').length > 0], ['carouselcruise', $('.owl-carousel-cruise').length > 0], ['carousel1', $('.owl-carousel').length > 0], ['bulletsContext', $('.owl-theme').length > 0], ['carousel6Navigation', $('.owl-carousel-6').length > 0], ['carousel3_4Navigation', $('body').length > 0], ['carouselNavigation', $('.owl-carousel').length > 0], ['carouselCruiseNavigation', $('.owl-carousel-cruise').length > 0]],

  carousel2: function carousel2() {
    $('.owl-carousel-2').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });
  },
  carousel3: function carousel3() {
    $('.owl-carousel-3').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 3
        }
      }
    });
  },
  carousel4: function carousel4() {
    $('.owl-carousel-4').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });
  },
  carousel5: function carousel5() {
    $('.owl-carousel-5').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 5
        }
      }
    });
  },
  carousel6: function carousel6() {
    $('.owl-carousel-6').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 2
        },
        768: {
          items: 3
        },
        1024: {
          items: 4
        },
        1200: {
          items: 6
        }
      }
    });
  },
  carouselcruise: function carouselcruise() {
    $('.owl-carousel-cruise').owlCarousel({
      loop: false,
      nav: true,
      margin: 0,
      touchDrag: true,
      mouseDrag: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      items: 1,
      onInitialized: CCL.carousel.counterLoad,
      onTranslate: CCL.carousel.counter
    });
  },
  carousel1: function carousel1() {
    $('.owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      items: 1
    });
  },
  counterLoad: function counterLoad(event) {
    $('.owl-carousel-cruise .owl-nav').prepend('<span class="counter"></span>');
    $('.owl-carousel-cruise .owl-nav').prepend('<span class="counter-hidden ccl-srOnly"></span>');
    CCL.carousel.counter(event);
  },
  counter: function counter(event) {
    var element = event.target;
    var items = event.item.count;
    var item = event.item.index + 1;

    if (item > items) {
      item -= items;
    }
    $('.owl-carousel-cruise .owl-nav .counter-hidden').removeAttr('role', 'alert');
    $('.owl-carousel-cruise .owl-nav .counter-hidden').text('Current Slide ' + item + ' of ' + items);
    $('.owl-carousel-cruise .owl-nav .counter').text(item + ' of ' + items);
    $('.owl-carousel-cruise .owl-nav .counter').removeAttr('tabindex').removeAttr('data-tabindex');
    $('.owl-carousel-cruise .owl-nav .counter-hidden').removeAttr('tabindex').removeAttr('data-tabindex');

    setTimeout(function () {
      $('.owl-carousel-cruise .owl-nav .counter-hidden').attr('role', 'alert');
    }, 200);
  },
  calculatePageBullet: function calculatePageBullet(dots) {
    var items = dots.find('.owl-dot');
    var n = items.length;

    if (n > 0) {
      items.each(function (index2, i) {
        var bullet = $(i);
        var current = '';
        if (bullet.hasClass('active')) {
          current = '- Current page';
        }
        bullet.attr('aria-label', 'Slide ' + (index2 + 1) + ' of ' + n + ' ' + current);
      });
    }
  },
  bulletsContext: function bulletsContext() {
    var _this = this;

    setTimeout(function () {
      $('.owl-dots').each(function (index, e) {
        var dots = $(e);
        _this.calculatePageBullet(dots);
      });
    }, 400);

    // On next item click
    $('.owl-dots button').click(function (e) {
      var currentTarget = $(e.currentTarget);
      setTimeout(function () {
        _this.calculatePageBullet(currentTarget.parent());
      }, 200);
    });
  },


  // Get focusable elements given a parent carousel
  getFocusable: function getFocusable(carousel, pos) {
    var tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled)';
    var items = carousel.find('> .owl-stage-outer > .owl-stage > .owl-item.active');
    var firstFocusable = items.find(tabbables).first();
    var lastFocusable = items.find(tabbables).last();
    return pos === 'last' ? lastFocusable : firstFocusable;
  },
  getLastFocusable: function getLastFocusable(carousel, pos) {
    var tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled)';
    var items = carousel.find('> .owl-stage-outer > .owl-stage > .owl-item.active').last();
    var firstFocusable = items.find(tabbables).first();
    var lastFocusable = items.find(tabbables).last();
    return pos === 'last' ? lastFocusable : firstFocusable;
  },


  // Carousel 6 Navigation
  navigationBackwards: function navigationBackwards(prevItem, selElement, carouselTop) {
    if (prevItem.length > 0) {
      selElement.attr('tabindex', '-1').attr('data-tabindex', '-1').removeClass('active');
      prevItem.find('.c-category-card a').addClass('active ada-element-focus').focus();
      carouselTop.find('.c-category-card a.active').attr('tabindex', '0').attr('data-tabindex', '0');
    }
    setTimeout(function () {
      if (carouselTop.find('.owl-item').first().hasClass('active')) {
        carouselTop.find('.owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'true');
      }
    }, 200);
  },
  navigationForward: function navigationForward(nextItem, selElement, carouselTop) {
    if (nextItem.length > 0) {
      selElement.attr('tabindex', '-1').attr('data-tabindex', '-1').removeClass('active');
      nextItem.find('.c-category-card a').addClass('active ada-element-focus').focus();
      carouselTop.find('.c-category-card a.active').attr('tabindex', '0').attr('data-tabindex', '0');
    }
    if (carouselTop.find('.owl-item').first().not('active')) {
      carouselTop.find('.owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('.owl-prev').attr('aria-disabled', 'false');
    }
  },
  carousel6Navigation: function carousel6Navigation() {
    var _this2 = this;

    var carouselTop = $('.owl-carousel-6');
    var selElement = carouselTop.find('.c-category-card a');

    // Arrow Order
    var clonedObj = carouselTop.find('.owl-nav').clone();
    clonedObj.prependTo(carouselTop);

    // Arrow Purge
    carouselTop.find('.owl-nav button.owl-next').first().remove();
    carouselTop.find('.owl-nav button.owl-prev').last().remove();

    setTimeout(function () {
      selElement.attr('tabindex', '-1').attr('data-tabindex', '-1').removeClass('active');
      selElement.first().attr('tabindex', '0').attr('data-tabindex', '0').addClass('active');
    }, 50);

    carouselTop.keydown(function (e) {
      var nextItem = carouselTop.find('.c-category-card a.active').parent().parent().next();
      var prevItem = carouselTop.find('.c-category-card a.active').parent().parent().prev();

      if (e.keyCode === 37 || e.keyCode === 38) {
        e.preventDefault();
        _this2.navigationBackwards(prevItem, selElement, carouselTop);
      } else if (e.keyCode === 39 || e.keyCode === 40) {
        e.preventDefault();
        _this2.navigationForward(nextItem, selElement, carouselTop);
      }
    });

    // On next item click
    carouselTop.find('.owl-next').click(function (e) {
      e.preventDefault();
      var nextItem = carouselTop.find('.c-category-card a.active').parent().parent().next();
      _this2.navigationForward(nextItem, selElement, carouselTop);
    });
    // On previous item click
    carouselTop.find('.owl-prev').click(function (e) {
      e.preventDefault();
      carouselTop.trigger('prev.owl.carousel');
      var prevItem = carouselTop.find('.c-category-card a.active').parent().parent().prev();
      _this2.navigationBackwards(prevItem, selElement, carouselTop);
    });
  },


  // .owl-carousel-4 .owl-carousel-3
  navigationBackwards_3_4: function navigationBackwards_3_4(carouselTop) {
    this.enableButtons(carouselTop);
    setTimeout(function () {
      if (carouselTop.find('.owl-stage .owl-item:first').hasClass('active')) {
        carouselTop.find('> .owl-nav .owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'true');
      }
    }, 200);
  },
  navigationForward_3_4: function navigationForward_3_4(carouselTop) {
    this.enableButtons(carouselTop);
    setTimeout(function () {
      if (!carouselTop.find('.owl-stage .owl-item:first').hasClass('active')) {
        carouselTop.find('> .owl-nav .owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'false');
      }
    }, 200);
  },
  enableButtons: function enableButtons(carouselTop) {
    carouselTop.find('.owl-dot').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.general-add-to-cart-btn').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.btn-more-details').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.title a').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item').find('.be-first-to-review').attr('tabindex', '-1').attr('data-tabindex', '-1');
    carouselTop.find('.owl-stage .owl-item.active').find('.general-add-to-cart-btn').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-stage .owl-item.active').find('.btn-more-details').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-stage .owl-item.active').find('.title a').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-stage .owl-item.active').find('.be-first-to-review').attr('tabindex', '0').attr('data-tabindex', '0');
  },
  carousel3_4Navigation: function carousel3_4Navigation() {
    var _this3 = this;

    setTimeout(function () {
      $('body .owl-carousel-3, body .owl-carousel-4, body .owl-carousel-2').each(function (index, e) {
        var carouselTop = $(e);
        _this3.enableButtons(carouselTop);
        if (carouselTop.find('> .owl-nav').length < 2) {
          var clonedObj = carouselTop.find('> .owl-nav').clone();
          clonedObj.prependTo(carouselTop);
          carouselTop.find('> .owl-nav button.owl-next').first().remove();
          carouselTop.find('> .owl-nav button.owl-prev').last().remove();
          carouselTop.find('.c-product-card .owl-nav').remove();
          //  carouselTop.find('.c-product-card .owl-dots').remove();
        }

        carouselTop.keydown(function (event) {
          if (event.keyCode === 37 || event.keyCode === 38) {
            _this3.navigationBackwards_3_4(carouselTop);
          } else if (event.keyCode === 39 || event.keyCode === 40) {
            _this3.navigationForward_3_4(carouselTop);
          } else if (event.keyCode === 9 && event.shiftKey) {
            _this3.navigationBackwards_3_4(carouselTop);
          } else if (event.keyCode === 9 && !event.shiftKey) {
            _this3.navigationForward_3_4(carouselTop);
          }
        });

        // On next item click
        carouselTop.find('.owl-next').click(function (event) {
          _this3.navigationForward_3_4(carouselTop);
          setTimeout(function () {
            _this3.getLastFocusable(carouselTop).focus();
          }, 200);
        });
        // On previous item click
        carouselTop.find('.owl-prev').click(function (event) {
          _this3.navigationBackwards_3_4(carouselTop);
          carouselTop.trigger('prev.owl.carousel');
          _this3.getFocusable(carouselTop).focus();
        });
      });
      $('body .owl-carousel-3 .owl-item:nth-child(4)').removeClass('active');
    }, 1000);
  },


  // .owl-carousel
  enablingSlideButtons: function enablingSlideButtons(carouselTop) {
    setTimeout(function () {
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.ccl_product_title').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.general-add-to-cart-btn').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.btn-more-details').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.be-first-to-review').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').find('.general-rating-product-card').attr('tabindex', '-1').attr('data-tabindex', '-1');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.ccl_product_title').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.general-add-to-cart-btn').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.btn-more-details').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.be-first-to-review').attr('tabindex', '0').attr('data-tabindex', '0');
      carouselTop.find('> .owl-stage-outer .owl-stage .owl-item.active').find('.general-rating-product-card').attr('tabindex', '0').attr('data-tabindex', '0');
    }, 300);

    if (carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').length > 0) {
      if (carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').first().not('active')) {
        carouselTop.find('.owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'false');
      }
      if (carouselTop.find('> .owl-stage-outer .owl-stage .owl-item').first().hasClass('active')) {
        carouselTop.find('.owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
        carouselTop.find('.owl-prev').attr('aria-disabled', 'true');
      }
    }
  },
  carouselNavigation: function carouselNavigation() {
    var _this4 = this;

    setTimeout(function () {
      $('.product-carousel-container.owl-carousel, .cruise-carousel-container.owl-carousel').each(function (index, e) {
        var carouselTop = $(e);

        // Arrow Order
        var clonedObj = carouselTop.find('.owl-nav').eq(index).clone();
        clonedObj.prependTo(carouselTop);

        // Arrow Purge
        carouselTop.find('.owl-nav button.owl-next').first().remove();
        carouselTop.find('.owl-nav button.owl-prev').last().remove();
        carouselTop.find('.c-product-card .owl-nav').remove();
        carouselTop.find('.c-product-card .owl-dots').remove();

        // this.enablingSlideButtons(carouselTop);

        // On next item click
        carouselTop.find('.owl-next').click(function (event) {
          _this4.enablingSlideButtons(carouselTop);
          setTimeout(function () {
            _this4.getFocusable(carouselTop).focus();
          }, 300);
        });
        // On previous item click
        carouselTop.find('.owl-prev').click(function (event) {
          carouselTop.trigger('prev.owl.carousel');
          _this4.enablingSlideButtons(carouselTop);
          setTimeout(function () {
            _this4.getFocusable(carouselTop).focus();
          }, 300);
        });
      });
    }, 700);
  },


  // Carousel Cruise Navigation
  setActiveElements: function setActiveElements(carouselTop) {
    carouselTop.find('.owl-item.active').find('.hero-banner-product-card-title a').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-item.active').find('.btn-redeem-gift-card').attr('tabindex', '0').attr('data-tabindex', '0');
    carouselTop.find('.owl-item.active').find('.footer a').attr('tabindex', '0').attr('data-tabindex', '0');
  },
  carouselCruiseNavigation: function carouselCruiseNavigation() {
    var _this5 = this;

    var carouselTop = $('.owl-carousel-cruise');
    // On next item click
    carouselTop.find('.owl-next').click(function (event) {
      setTimeout(function () {
        _this5.setActiveElements(carouselTop);
        _this5.getFocusable(carouselTop).focus();
      }, 100);
    });
    // On previous item click
    carouselTop.find('.owl-prev').click(function (event) {
      setTimeout(function () {
        _this5.setActiveElements(carouselTop);
        _this5.getFocusable(carouselTop).focus();
      }, 100);
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* eslint-disable */
/**
 * Aria Plugin
 * Author: Stephan Fischer
 * @since 2.0.0
 */
;(function ($, window, document, undefined) {
  var Aria = function Aria(scope) {
    var _this = this;

    this._core = scope;
    this.options = $.extend({}, Aria.Defaults, this._core.options);

    if (!this.options.aria) {
      return false;
    }

    this.setup();
    this.$element.on({
      'initialized.owl.carousel': function initializedOwlCarousel(e) {
        if (e.namespace && !_this._init) {
          _this.$stage = _this._core.$stage;
          _this.navigation();
          _this.bind();
          _this.setAria();
          _this._init = true;
        }
      },
      'changed.owl.carousel': function changedOwlCarousel(e) {
        return _this.setAria();
      }
    });
  };

  Aria.Defaults = {
    aria: true
  };

  Aria.prototype.setup = function () {
    this._init = false;
    this.$element = this._core.$element;
    // dont add tabindex on carousel container- hence commented
    // this.$element.attr('tabindex', '0').storeTabindex();
    this.$element.find('*').storeTabindex();
  };

  Aria.prototype.navigation = function () {
    this.$nav = $('.' + this.options.navContainerClass + ', .' + this.options.dotsClass, this.$element);
    var noButtonSel = ":not(button):not(input[type='submit'])";

    this.setNavAria();

    this.$nav.children().attr("role", "button").storeTabindex().filter(noButtonSel).each(function (i, e) {
      var $el = $(e);

      $el.on('keydown', function (e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
          $el.trigger('click');
          return false;
        }
      });
    });
  };

  Aria.prototype.bind = function () {
    var _this2 = this;

    this.$element.on('to.owl.carousel', function (e) {
      return e.stopPropagation();
    });
    this.$element.on('next.owl.carousel', function (e) {
      return e.stopPropagation();
    });
    this.$element.on('prev.owl.carousel', function (e) {
      return e.stopPropagation();
    });
    this.$element.on('destroy.owl.carousel', function (e) {
      return e.stopPropagation();
    });
    this.$element.on('focusin', function (e) {
      return _this2.focus(e);
    }).on('focusout', function (e) {
      return _this2.blur(e);
    }).on('keydown', function (e) {
      return _this2.keydown(e);
    });
  };

  Aria.prototype.focus = function () {
    this.$element.attr({ 'aria-live': 'polite' });
  };

  Aria.prototype.blur = function () {
    this.$element.attr({ 'aria-live': 'off' });
  };

  Aria.prototype.keydown = function (e) {
    var action = null;

    if (e.keyCode == 37 || e.keyCode == 38) {
      action = 'prev.owl.carousel';
    } else if (e.keyCode == 39 || e.keyCode == 40) {
      action = 'next.owl.carousel';
    }

    if (action !== null) {
      this.$element.trigger(action);
      return false;
    }
  };

  Aria.prototype.setNavAria = function () {
    this.$nav.children().each(function (i, el) {
      var $el = $(el);
      var isDisabled = $el.hasClass('disabled') || $el.hasClass('active');

      $el.attr('aria-disabled', isDisabled ? "true" : "false");

      if (isDisabled) {
        $el.attr("tabindex", "-1");
        $el.attr("data-tabindex", $el.attr('tabindex'));
      } else {

        $el.attr("tabindex", "0");
        $el.attr("data-tabindex", $el.attr('tabindex'));
      }
    });
  };

  Aria.prototype.setAria = function () {
    var _this3 = this;

    if (!this.$stage || !this.$stage.length) {
      return false;
    }

    this.setNavAria();

    setTimeout(function () {

      _this3.$stage.children().each(function (i, el) {
        var $item = $(el);
        var isActive = $item.hasClass('active');

        $item.attr('aria-hidden', !isActive ? "true" : "false");
        $item.find('*').each(function (i, e) {
          var $el = $(e);

          if (isActive === false) {

            $el.storeTabindex();
            $el.attr("tabindex", "-1");
          } else {
            $el.restoreTabindex();
          }
        });
      });
    });
  };

  Aria.prototype.destroy = function () {
    var _this4 = this;

    this.$element.removeAttr('aria-live');
    this.$element.removeAttr('tabindex');
    this.$element.children().removeAttr('aria-hidden');
    this.$element.find('[data-tabindex]').restoreTabindex();
    this.$element.off('focusin', function (e) {
      return _this4.focus(e);
    }).off('focusout', function (e) {
      return _this4.blur(e);
    }).off('keydown', function (e) {
      return _this4.keydown(e);
    });
  };

  $.fn.extend({
    restoreTabindex: function restoreTabindex() {
      return this.each(function () {
        var $el = $(this);

        if (!$el.is('[data-tabindex]')) {
          $el.removeAttr("tabindex");
        } else {
          $el.attr("tabindex", $el.attr('data-tabindex'));
        }
      });
    },
    storeTabindex: function storeTabindex() {
      return this.each(function () {
        var $el = $(this);

        if ($el.is('[tabindex]') && !$el.is('[data-tabindex]')) {
          $el.attr("data-tabindex", $el.attr('tabindex'));
        }
      });
    }
  });

  $.fn.owlCarousel.Constructor.Plugins['Aria'] = Aria;
})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generalFunctions__ = __webpack_require__(4);



CCL.login = {
  autoload: [['loginAPICall', $('.login-form').length > 0]],

  loginAPICall: function loginAPICall() {
    $('.login-form').submit(function (event) {
      event.preventDefault();
      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["showLoader"]();
      var dataObj = {
        username: $('#username').val(),
        password: $('#password').val(),
        cookieless: false
      };
      var loginCall = $.ajax({
        type: 'POST',
        url: 'https://dev.bookedguest.com/cclcommercewebservices/v2/ccl/user/login',
        dataType: 'json',
        contentType: 'application/json',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj)
      });

      loginCall.done(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["hideLoader"]();
        var message = response.success === false ? 'Authentication Failed' : 'Authentication Sucess';
        $('.login-form-callback').text(message);
      });

      loginCall.fail(function () {
        __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["hideLoader"]();
        console.log('Something went wrong');
      });
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(8);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(289);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(291), __esModule: true };

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86);
__webpack_require__(50);
__webpack_require__(83);
__webpack_require__(292);
__webpack_require__(296);
__webpack_require__(297);
module.exports = __webpack_require__(8).Promise;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(33);
var global = __webpack_require__(12);
var ctx = __webpack_require__(27);
var classof = __webpack_require__(87);
var $export = __webpack_require__(15);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(53);
var anInstance = __webpack_require__(137);
var forOf = __webpack_require__(88);
var speciesConstructor = __webpack_require__(170);
var task = __webpack_require__(171).set;
var microtask = __webpack_require__(294)();
var newPromiseCapabilityModule = __webpack_require__(138);
var perform = __webpack_require__(172);
var userAgent = __webpack_require__(295);
var promiseResolve = __webpack_require__(173);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(11)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(139)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(40)($Promise, PROMISE);
__webpack_require__(174)(PROMISE);
Wrapper = __webpack_require__(8)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(106)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 293 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var macrotask = __webpack_require__(171).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(38)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(15);
var core = __webpack_require__(8);
var global = __webpack_require__(12);
var speciesConstructor = __webpack_require__(170);
var promiseResolve = __webpack_require__(173);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(15);
var newPromiseCapability = __webpack_require__(138);
var perform = __webpack_require__(172);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generalFunctions__ = __webpack_require__(4);




CCL.addToCart = {
  autoload: [['addToCart', $('body').length > 0], ['addToCartFS', $('body').length > 0], ['cruiseAddToCart', $('.c-cruise-manager').length > 0], ['RestrictUser', $('body').length > 0]],

  priceValue: null,
  variantQuantity: null,
  funshopcategorycode: '',

  addToCart: function addToCart() {
    var _this = this;

    $('body, #addToCartModal, #vibeDropdwonDynamic, .c-pdp-card, .c-product-card, .c-booking-buddy-modal, .c-tc-modal, .c-product-card-3, #upsell-product-modal, .clp-add-to-cart-modal').on('click', '.btn-add-cart', function (event) {
      _this.closePreviousModal();
      _this.globalAddToCart(event);
      event.stopImmediatePropagation();
    });
  },
  cruiseAddToCart: function cruiseAddToCart() {
    var _this2 = this;

    $('.c-cruise-manager').on('click', '.btn-add-cart', function (event) {
      _this2.closePreviousModal();
      _this2.globalAddToCart(event);
      event.stopImmediatePropagation();
    });
  },
  addToCartFS: function addToCartFS() {
    var _this3 = this;

    $('body').on('click', '.fs-btn-add-cart', function (event) {
      _this3.closePreviousModal();
      _this3.FSAddToCartModal(event);
      var pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        var productPosition = Number($(event.target).data('productposition')) + 1;
        var pageNumber = Number($(event.target).data('currentpage')) + 1;
        var categoryName = $(event.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
      event.stopImmediatePropagation();
    });
  },
  closePreviousModal: function closePreviousModal() {
    if ($('#addToCartModal').hasClass('show')) {
      __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('addToCartModal');
    }
    if ($('#alcoholAtcModal').hasClass('show')) {
      __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('alcoholAtcModal');
    }
    if ($('#clpAddToCartModal').hasClass('show')) {
      __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('clpAddToCartModal');
    }
  },
  FSAddToCartModal: function FSAddToCartModal(event) {
    var _this4 = this;

    $.ajax({
      type: 'GET',
      url: '/shop/cart/regularfs/modal/' + $(event.target).data('productcode')
    }).done(function (response) {
      _this4.funshopcategorycode = $(event.target).data('funshopcategorycode');
      if (response.baseProduct === false) {
        CCL.addToCart.variantsModal(response, event);
        __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
      } else {
        CCL.addToCart.populateNoVariantsModal(response, event);
        __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
      }
    }).fail(function () {
      console.log('Something went wrong');
      __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
    });
  },
  globalAddToCart: function globalAddToCart(event) {
    var _this5 = this;

    /* if button has attr hasUpsell then open upsell modal */
    var productCode = $(event.target).data('productcode');
    var hasupsell = $(event.target).attr('data-hasupsell');
    /* if sailing info required is true open booking buddy modal */
    var sailingInfoNeeded = $(event.target).attr('data-sailingInfoNeeded');
    var isBrowseMode = $(event.target).attr('data-userMode');
    var isPDP = $(event.target).attr('data-isPDP');

    if (hasupsell === 'true' && (typeof hasupsell === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(hasupsell)) !== ( true ? 'undefined' : _typeof(undefined)) && hasupsell !== false && (sailingInfoNeeded === 'false' || (typeof sailingInfoNeeded === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sailingInfoNeeded)) === ( true ? 'undefined' : _typeof(undefined)))) {
      CCL.upSellProductModal.loadGlobalUpsellModal(event);
      return;
    }

    if (sailingInfoNeeded === 'true' && (typeof sailingInfoNeeded === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sailingInfoNeeded)) !== ( true ? 'undefined' : _typeof(undefined)) && sailingInfoNeeded !== false && (isBrowseMode === 'loggedInBrowse' || isBrowseMode === 'browse')) {
      CCL.bookingBuddyObj.includeAUSailings = false;
      CCL.bookingBuddyObj.loadInitialModal(true, productCode, isPDP);
      return;
    }

    event.preventDefault();
    __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["showLoader"]();
    var csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
    var targetElement = $(event.target).data('hasvariants');
    var pageType = $('#pagetype').data('pagetype');

    var quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    var variantId = $(event.target).attr('data-variantids');
    var isSpecialService = $(event.target).attr('data-specialService');
    var bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : '';
    var guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
    var dataObj = {
      productCodePost: $(event.target).data('productcode'),
      CSRFToken: csrf,
      qty: quantity || 1,
      variantIds: variantId,
      bookingIds: bookingIdsArray,
      guestIds: guestIdsArray,
      specialService: isSpecialService,
      pageType: pageType
    };

    if (pageType === 'CATEGORY') {
      dataObj.productPosition = localStorage.getItem('productposition');
      dataObj.pageNumber = localStorage.getItem('pageNumber');
      dataObj.categoryName = localStorage.getItem('sascategorycode');
    }

    if (targetElement === undefined || targetElement === '') {
      $.ajax({
        type: 'POST',
        url: '/shop/cart/add',
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        data: dataObj
      }).done(function (response) {
        if (response.addedToCart === true) {
          // $('.modal').modal('hide');
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('termsAndConditionsModal');
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('clpAddToCartModal');
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('alcoholAtcModal');
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('diningAtcModal');
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideModal"]('globalUpsellProductModal');
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["updateHeaderCartWidget"](response);
          CCL.addToCart.successModal(response);
          if ($('.quantity-input')) {
            $('.quantity-input')[0].value = 1;
          }
          // make cruise cash localstorage update call
          var funshopcategorycode = $(event.target).data('funshopcategorycode');
          if (funshopcategorycode && funshopcategorycode === 'cruise-cash' || dataObj.categoryName && dataObj.categoryName === 'cruise-cash') {
            __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["ajaxForCruiseCashCartAmount"]().then(function () {
              $('.c-pdp-card .quantity-btn-wrap').find('.quantity-input').val(1);
              CCL.pdpSfPackage.pdpCruiseCashRestrication(true);
            });
          }
        }
        __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
        if ($('.quantity-input')) {
          $('.quantity-input')[0].value = 1;
        }
        console.log('Something went wrong');
      });
    } else {
      $.ajax({
        type: 'GET',
        url: '/shop/cart/regularfs/modal/' + $(event.target).data('productcode')
      }).done(function (response) {
        _this5.funshopcategorycode = $(event.target).data('funshopcategorycode');
        if (response.baseProduct === false) {
          CCL.addToCart.variantsModal(response, event);
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
        } else {
          CCL.addToCart.populateNoVariantsModal(response, event);
          __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
        }
      }).fail(function () {
        console.log('Something went wrong');
        __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["hideLoader"]();
      });
    }
  },
  showCruiseCashError: function showCruiseCashError() {
    $('.increment-btn').attr('disabled', 'disabled');
    $('.increment-btn').addClass('disabled');
    $('.increment-btn').css('pointer-events', 'none');
    setTimeout(function () {
      $('.cc-error').remove();
      $('<div class=\'cc-error\' aria-live=\'assertive\'\n    role=\'alert\' style=\'color:darkred; padding-top:10px;\'>\n      Cruise Cash limit is $500 per stateroom.\n      </div>').insertAfter('#addToCartModal .quantity-btn-wrap');
    }, 500);
  },
  hideCruiseCashError: function hideCruiseCashError() {
    $('.cc-error').remove();
    $('.increment-btn').removeAttr('disabled');
    $('.increment-btn').removeClass('disabled');
    $('.increment-btn').css('pointer-events', 'auto');
  },


  /* eslint-disable */
  RestrictUser: function RestrictUser() {
    var _this6 = this;

    __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["ajaxForCruiseCashCartAmount"]();
    $('#addToCartModal').on('click', '.increment-btn', function (event) {
      if ($(event.target).hasClass('ada-disabled')) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      if ($('#addToCartModal .general-add-to-cart-btn')[0].dataset.funshopcategorycode && $('#addToCartModal .general-add-to-cart-btn')[0].dataset.funshopcategorycode === 'cruise-cash') {
        var targetElement = $(event.target).parents('.quantity-btn-wrap').find('.quantity-input');
        _this6.variantQuantity = Number($(targetElement).val());
        var priceValue = 0;
        if ($('#addToCartModal .selectable-link.active ').length) {
          priceValue = Number($('#addToCartModal .selectable-link.active ').data('price').split('$')[1]);
        } else {
          priceValue = Number($('#addToCartModal .price').html().split('$')[1]);
        }
        var reqdQty = (500 - Number(localStorage.getItem('cruisecashcartamount'))) / priceValue;
        reqdQty = Math.floor(reqdQty);
        if (_this6.variantQuantity + 1 > Number(reqdQty)) {
          _this6.showCruiseCashError();
          $('#addToCartModal .btn-add-cart').attr('disabled', 'disabled');
        } else if (_this6.variantQuantity + 1 === Number(reqdQty)) {
          _this6.showCruiseCashError();
        } else {
          _this6.hideCruiseCashError();
        }
      }
    });
    // When user clicks on decrement button enable increment button
    $('#addToCartModal').on('click', '.decrement-btn', function (event) {
      _this6.hideCruiseCashError();
    });
  },

  /* eslint-enable */

  variantsModal: function variantsModal(res, clickEvent) {
    var _this7 = this;

    var variants = '';
    var noItems = '';
    var data = res.funshopVariantList && res.funshopVariantList !== null ? res.funshopVariantList : res;

    $('#addToCartModal .btn-add-cart').attr('data-funshopcategorycode', this.funshopcategorycode);
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap').html('');
    CCL.addToCart.changeVariants(data[0].productCode, data[0].productName, data[0].variantCategoryName, data[0].price, data[0].imageUrl, data[0].strikeOutPrice, data[0].promotionResultsData, clickEvent);

    if (data[0].hasUpsell) {
      $('#addToCartModal .modal-footer .btn-red').attr('data-hasupsell', 'true');
    }
    $.each(data, function (index, item) {
      var hasupsellAttr = item.hasUpsell ? 'data-hasupsell="true"' : '';
      variants += '<a class="selectable-link" href="#" data-productcode="' + item.productCode + '" data-productname="' + item.productName + '" data-variantcategoryname="' + item.variantCategoryName + '" data-rootcategoryname="' + item.rootCategoryName + '" data-strikeoutprice="' + item.strikeOutPrice + '" data-price="' + item.price + '" data-imageurl="' + item.imageUrl + '" data-promotionresultsdata=\'' + item.promotionResultsData + '\' ' + hasupsellAttr + '>' + item.categoryName + '</a>';
      noItems = index;
    });
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap').append(variants);
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first').addClass('active');
    $('#addToCartModal .modal-body .cart-card-body .quantity-btn-wrap input').val(1);
    // $('.decrement-btn').addClass('disabled');
    // $('.decrement-btn').attr('disabled', 'disabled');
    // $('.increment-btn').removeAttr('disabled');
    // $('.increment-btn').removeClass('disabled');
    // $('.increment-btn').css('pointer-events', 'auto');
    // $('.cc-error').remove();
    var firstVar = $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first').data('variantcategoryname');
    var priceValue = $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first')[0].innerHTML;
    $('#addToCartModal .modal-body .cart-card-body .xyz').remove();
    $('#addToCartModal .modal-body .cart-card-body .sub-title').before('<div class="sr-only xyz" tabindex="0">select ' + firstVar + ' group with ' + (noItems + 1) + ' items</div>');
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a:first').attr('aria-label', 'selected ' + priceValue);
    $('#addToCartModal').modal();

    $('#addToCartModal').on('click', '.selectable-link', function (event) {
      event.preventDefault();
      var targetElement = $(event.target).parents('.modal-body').find('.quantity-input');
      $(targetElement).val(1);
      $('.c-add-to-cart-modal .decrement-btn').addClass('disabled');
      $('.c-add-to-cart-modal .decrement-btn').attr('disabled', 'disabled');
      _this7.hideCruiseCashError();
      $('#addToCartModal .modal-footer .btn-red').removeAttr('data-hasupsell');
      $('#addToCartModal .modal-body .cart-card-body .selectable-wrap a').removeClass('active');
      $(event.target).addClass('active');
      var variantcategoryname = $(event.target).data('variantcategoryname');
      var priceVal = $(event.target)[0].innerHTML;
      $('.selectable-link').removeAttr('aria-label');
      $('.selectable-wrap a').each(function (i, e) {
        var price = e.innerText;
        $(e).attr('aria-label', price);
      });
      $(event.target).attr('aria-label', 'selected ' + priceVal);
      $('#addToCartModal .modal-footer .btn-red').data('productcode', $(event.target).data('productcode'));
      if (event.target.dataset.hasupsell === 'true') {
        $('#addToCartModal .modal-footer .btn-red')[0].dataset.hasupsell = 'true';
      }
      var tempPromoData = data.filter(function (x) {
        return x.productCode === $(event.target).data('productcode');
      });
      var promoData = tempPromoData.length ? tempPromoData[0].promotionResultsData : null;
      CCL.addToCart.changeVariants($(event.target).data('productcode'), $(event.target).data('productname'), $(event.target).data('variantcategoryname'), $(event.target).data('price'), $(event.target).data('imageurl'), $(event.target).data('strikeoutprice'), promoData, clickEvent);
    });
    $('.keepShopingLink').attr('href', res.redirectUrl);
  },
  populateNoVariantsModal: function populateNoVariantsModal(res, clickEvent) {
    var data = res.baseProductInfo;
    $('#addToCartModal .btn-add-cart').attr('data-funshopcategorycode', this.funshopcategorycode);
    $('.decrement-btn').addClass('disabled');
    $('.decrement-btn').attr('disabled', 'disabled');
    $('.increment-btn').removeAttr('disabled');
    $('.increment-btn').removeClass('disabled');
    $('.increment-btn').css('pointer-events', 'auto');
    $('.cc-error').remove();
    $('#addToCartModal .modal-body .cart-card-body .quantity-btn-wrap input').val(1);
    $('#addToCartModal .modal-body .cart-card-body .selectable-wrap').html('');
    $('#addToCartModal .modal-body .cart-card-image').attr('aria-label', data.productName + ' image');
    if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', data.imageUrl + '?w=142&h=86');
    } else {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', data.imageUrl + '&w=142&h=86');
    }
    $('#addToCartModal .modal-body .cart-card-body .title').text(data.productName);
    if (data.strikeOutPrice) {
      $('#addToCartModal .modal-body .cart-card-body .price').html('\n      <div class="strikeout-text greytext" aria-label="Before the price was ' + data.strikeOutPrice + '" role="textbox">\n        ' + data.strikeOutPrice + '\n      </div>\n      <div aria-label="Current price is ' + data.price + '" role="textbox">\n        ' + data.price + '\n      </div>\n      ');
    } else {
      $('#addToCartModal .modal-body .cart-card-body .price').text('' + data.price).attr('aria-label', 'Price is ' + data.price);
    }
    $('.promo-texts').remove();
    var tempHtmlCode = '';
    if (data.promotionResultsData !== '' && data.promotionResultsData !== null) {
      data.promotionResultsData.forEach(function (element) {
        tempHtmlCode += '<div class="best-seller general-best-seller" role="textbox" aria-label="' + element.description + '"\n                style="background-color: #10559a">\n                <span class="info-icon" aria-hidden="true">\n                  <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="' + element.description + '" width="11"\n                    height="12">\n                </span>\n                ' + element.description + '\n              </div>';
      });
    }

    $('<div class="promo-texts">' + tempHtmlCode + '</div>').insertAfter($('#addToCartModal .modal-body .cart-card-body .title'));

    $('#addToCartModal .modal-footer .btn-red').data('productcode', data.productCode);
    if (data.hasUpsell) {
      $('#addToCartModal .modal-footer .btn-red')[0].dataset.hasupsell = 'true';
    } else {
      $('#addToCartModal .modal-footer .btn-red')[0].dataset.hasupsell = 'false';
      $('#addToCartModal .modal-footer .btn-red').removeAttr('data-hasupsell');
    }
    $('#addToCartModal .modal-body .sub-title').hide();
    $('#addToCartModal').modal();

    $('#addToCartModal .btn-add-cart').attr('aria-label', 'Add ' + data.productName + ' to the cart with price ' + data.price);

    $('.keepShopingLink').attr('href', res.redirectUrl);

    if (clickEvent.target.dataset.funshopcategorycode && clickEvent.target.dataset.funshopcategorycode === 'cruise-cash') {
      this.checkCruiseCashCondition(data.price);
    }
  },
  checkCruiseCashCondition: function checkCruiseCashCondition(price) {
    var _this8 = this;

    $('#addToCartModal .btn-add-cart').removeAttr('disabled');
    var cruiseCashAmt = Number(price.split('$')[1].trim()) + Number(localStorage.getItem('cruisecashcartamount'));
    var cruiseCashAmtIntoTwo = Number(price.split('$')[1].trim()) * 2 + Number(localStorage.getItem('cruisecashcartamount'));

    if (cruiseCashAmt > 500) {
      setTimeout(function () {
        _this8.showCruiseCashError();
        $('#addToCartModal .btn-add-cart').attr('disabled', 'disabled');
      }, 500);
    } else if (cruiseCashAmt === 500) {
      setTimeout(function () {
        _this8.showCruiseCashError();
      }, 500);
    } else {
      this.hideCruiseCashError();
    }

    if (cruiseCashAmtIntoTwo > 500) {
      console.log('going inside');
      CCL.addToCart.showCruiseCashError();
    }
  },
  changeVariants: function changeVariants(productCode, productName, variantCategoryName, price, imageUrl) {
    var strikeOutPrice = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var promotionResultsData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var clickEvent = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    if (clickEvent.target.dataset.funshopcategorycode && clickEvent.target.dataset.funshopcategorycode === 'cruise-cash') {
      this.checkCruiseCashCondition(price);
    }
    $('#addToCartModal .modal-body .cart-card-image').attr('aria-label', productName + ' image');
    if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', imageUrl + '?w=142&h=86');
    } else {
      $('#addToCartModal .modal-body .cart-card-image img').attr('src', imageUrl + '&w=142&h=86');
    }
    $('#addToCartModal .modal-body .cart-card-body .title').text(productName);
    if (promotionResultsData !== '' && promotionResultsData !== null) {
      $('.promo-texts').remove();
      var tempHtmlCode = '';
      promotionResultsData.forEach(function (element) {
        tempHtmlCode += '<div class="best-seller general-best-seller" role="textbox" aria-label="' + element.description + '"\n                style="background-color: #10559a">\n                <span class="info-icon" aria-hidden="true">\n                  <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="' + element.description + '" width="11"\n                    height="12">\n                </span>\n                ' + element.description + '\n              </div>';
      });

      $('<div class="promo-texts">' + tempHtmlCode + '</div>').insertAfter($('#addToCartModal .modal-body .cart-card-body .title'));
    }
    $('#addToCartModal .modal-body .cart-card-body .sub-title').text('Select ' + variantCategoryName);
    if (strikeOutPrice) {
      $('#addToCartModal .modal-body .cart-card-body .price').html('\n      <div class="strikeout-text greytext" aria-label="Before the price was ' + strikeOutPrice + '" role="textbox">\n        ' + strikeOutPrice + '\n      </div>\n      <div aria-label="Current price is ' + price + '" role="textbox">\n        ' + price + '\n      </div>\n      ');
    } else {
      $('#addToCartModal .modal-body .cart-card-body .price').text('' + price).attr('aria-label', 'Price is ' + price);
    }
    $('#addToCartModal .modal-footer .btn-red').data('productcode', productCode);
    $('#addToCartModal .btn-add-cart').attr('aria-label', 'Add ' + productName + ' to the cart with price ' + price);
  },

  successModal: function successModal(data) {
    $('.modal').modal('hide');
    // SAS Event for add to cart
    if (data && data.cclSasAnalyticsJsonData) {
      __WEBPACK_IMPORTED_MODULE_2__generalFunctions__["sasEvents"]('send', data.cclSasAnalyticsJsonData);
    }

    // if this is FBT Add to Cart response
    if (data.cartModification && data.cartModification.cartModificationDetails && data.cartModification.cartModificationDetails.length) {
      var addedProducts = data.cartModification.cartModificationDetails.filter(function (x) {
        return x.quantityAdded > 0;
      });
      if (addedProducts.length) {
        // unselect selected and select unselected
        $('.fbt-product-names-section .product-name input').trigger('click');

        var modalBodyStart = '<div class="fbt-cart-sucess">';
        var modalBodyEnd = '</div>';
        var modalBody = '';
        $.each(addedProducts, function (index, value) {
          // Remove product from list
          // $(`#productCheck-${value.product.code}`).trigger('click');
          if ($('#productImg-' + value.product.code).length && $('#productImg-' + value.product.code).parent()[0] && $('#productImg-' + value.product.code).parent()[0].previousElementSibling) {
            $('#productImg-' + value.product.code).parent()[0].previousElementSibling.remove();
          }
          $('#productImg-' + value.product.code).parent().remove();
          $('#productName-' + value.product.code).remove();
          var prodCode = value.product.code;
          if (value.product.category && value.product.category === 'shoreex') {
            prodCode = value.product.shoreExData.skuCode;
          }

          var imgSrc = value.product.imageUrl ? value.product.imageUrl : value.product.images[0].url;
          if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
            imgSrc = imgSrc + '?w=95&h=57';
          } else {
            imgSrc = imgSrc + '&w=95&h=57';
          }
          modalBody += '<div class="row mb-4">\n                          <div class="col-md-2" aria-label="" role="textbox">\n                            <img class="fbt-product-img" src="' + imgSrc + '" alt="' + value.product.name + '">\n                          </div>\n                          <div class="col-md-10 d-flex flex-column justify-content-center">\n                            <div class="title">' + value.product.name + '</div>\n                          </div>\n                        </div>';
        });

        if ($('.plus-icon:first-child').previousElementSibling === null || $('.plus-icon:first-child').previousElementSibling === undefined) {
          $('.plus-icon:first-child').remove();
        }

        // Hide FBT component if products are less than 2 after ATC
        if ($('.fbt-product-names-section .product-name').length < 2) {
          $('#fbtComponent').hide();
        }

        $('#addToCartSuccessModal .modal-body').hide();
        $('#addToCartSuccessModal .fbt-modal-body').empty().html(modalBodyStart + ' ' + modalBody + ' ' + modalBodyEnd).show();
        $('.keepShopingLink').attr('data-dismiss', '');
        $('#addToCartSuccessModal').modal();
      }
    } else {
      var name = '';
      if (data.productCard.productType === 'SF' || data.productCard.productType === 'DI' || data.productCard.productName) {
        name = data.productCard.productName;
      } else {
        name = data.productName;
      }
      $('#addToCartModal .modal-body .cart-card-image').attr('aria-label', name + ' image');
      // if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
      //   if (data.imageRealFileName) {
      //     $('#addToCartSuccessModal .modal-body .cart-card-image img').attr('src', `${data.imageRealFileName}`);
      //   } else {
      //     $('#addToCartSuccessModal .modal-body .cart-card-image img').attr('src', `/shop/media/image/${data.productCard.productId}/${name}.jpeg?w=95&h=57`);
      //   }
      // } else {
      $('#addToCartSuccessModal .modal-body .cart-card-image img').attr('src', data.productCard.imageUrl + '&w=95&h=57');
      // }

      $('#addToCartSuccessModal .modal-body .cart-card-body .title').text(name);
      if (data.productCard.productType === 'SF' || data.productCard.productType === 'DI') {
        $('#addToCartSuccessModal .modal-body .cart-card-body .title').text(name);
      }
      if (!data.qtyAdded) {
        $('#addToCartSuccessModal .modal-body .cart-card-body .quantity').hide();
      }
      $('#addToCartSuccessModal .modal-body .cart-card-body .qtyAdded').text(data.qtyAdded);

      $('.keepShopingLink').attr('href', data.redirectUrl);
      $('#addToCartSuccessModal .fbt-modal-body').empty().hide();
      $('#addToCartSuccessModal .modal-body').show();
      $('#addToCartSuccessModal').modal();
      // If user is on CMP page - dont reload page, just close the modal
      if (window.location.toString().includes('booked/home')) {
        /* eslint-disable */
        $('.keepShopingLink').attr('href', 'javascript:void(0)');
        /* eslint-enable */
        $('.keepShopingLink').attr('data-dismiss', 'modal');
      }

      // If its favorite page
      if ($('body').find('#wishlistpage').length && ($('body').find('#wishlistpage')[0].dataset.wishlistpage === true || $('body').find('#wishlistpage')[0].dataset.wishlistpage === 'true')) {
        this.favPagePostAddToCart(data);
      }
    }
  },

  favPagePostAddToCart: function favPagePostAddToCart(response) {
    $('body').find('.favorite-card-' + response.productCard.productId + ' .in-cart-pill').removeClass('d-none');
    $('body').find('.favorite-card-' + response.productCard.productId + ' .btn-red').text('Add To Cart Again');
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(300);
var RequestBase = __webpack_require__(301);
var isObject = __webpack_require__(175);
var ResponseBase = __webpack_require__(302);
var Agent = __webpack_require__(304);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(175);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(303);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 304 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generalFunctions__ = __webpack_require__(4);





CCL.removeFromCart = {
  autoload: [['removeFromCart', $('.c-cart').length > 0]],

  removeFromCart: function removeFromCart() {
    var _this = this;

    $('.c-cart').on('click', '.btn-remove-from-cart', function (event) {
      var presalesid = $(event.target).data('presalesid');
      if (presalesid) {
        var getProductDiv = '.card-' + presalesid;
        $(getProductDiv).css('display', 'none');
      }
      _this.ajaxForRemove(event);
    });
  },
  ajaxForRemove: function ajaxForRemove(event) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["showLoader"]();
    var productId = $(event.target).data('productid');
    var token = $('#csrfSessionToken').data('csrf');
    var spaResHoldId = $(event.target).data('sparesholdid');
    var presalesid = $(event.target).data('presalesid');
    var shoreex = $(event.target).data('shoreex');
    var wishList2Entry = $(event.target).data('wishlist2entry');
    var backToCart = $(event.target).hasClass('backToCart');
    var dataObj = {
      productId: productId
    };
    if (spaResHoldId) {
      dataObj.spaResHoldId = spaResHoldId;
    }
    if (presalesid) {
      dataObj.preSalesId = presalesid.toString();
    }

    if (shoreex) {
      dataObj.shoreExProduct = true;
    }

    if (wishList2Entry) {
      /* eslint-disable */
      ga('send', 'event', 'Save For later', 'Remove from Save for Later', productId, 1);
      /* eslint-enable */
      dataObj.wishList2Entry = true;
    }

    $.ajax({
      type: 'POST',
      url: '/shop/cart/entry/execute-action/REMOVE',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(dataObj)
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["hideLoader"]();
      // Check cruise cash 500 limit on cart
      if ($(event.target).parents('.c-cart-card').find('.cruise-cash-qty-increment-btn').length) {
        CCL.cartCard.cartCruiseCashRestrictUser();
      }
      if (presalesid) {
        _this2.updateCart(response, presalesid, backToCart);
        _this2.showRemovedGuests(presalesid, response);
      } else if (spaResHoldId) {
        _this2.updateCart(response, spaResHoldId, backToCart);
      } else {
        _this2.updateCart(response, productId, backToCart);
      }

      // SAS Event for remove
      __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["sasEvents"]('send', response.cclSasAnalyticsJsonData);

      console.log('Remove from cart success');
      // Update All products again once one product is removed
      CCL.saveForLaterObj.loadSaveForLaterCartSection();
      // Below is commented to conflict of spa n shoreEx on save for later
      // CCL.editCartStateroom.createStateroomHtml();

      // update cart carousel
      if ($('body').find('.cart-carousel').length && !wishList2Entry) {
        // update cart carousel
        CCL.cartCard.updateCartCarousel();
      }

      $('.c-cart-cards .c-cart-card').each(function (i, e) {
        var increment = $(e).find('.increment-btn-1');
        if (increment.length) {
          setTimeout(function () {
            CCL.pdpSf.disIncrement(increment);
          }, 2000);
        }
      });
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["hideLoader"]();
      console.log('Remove from cart error');
    });
  },
  updateCart: function updateCart(response, id) {
    var backToCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (response.removeSuccess) {
      var orderSummary = response.orderSummary;


      if (backToCart) {
        var titleHtml = $('#saveForLaterCartSection .card-' + id + ' .title').html();
        $('#saveForLaterCartSection .card-' + id).empty();
        $('#saveForLaterCartSection .card-' + id).css('min-height', '100px');
        $('#saveForLaterCartSection .card-' + id).html(titleHtml + ' has been moved to your shopping cart.').addClass('removed-card');
      } else {
        $('.card-' + id).remove();
      }

      var noOfCards = $('#saveForLaterCartSection .c-cart-card:not(.removed-card)').length;
      var msg = noOfCards > 0 ? noOfCards + ' ITEM(S) SAVED FOR LATER' : 'NO ITEM(S) SAVED FOR LATER';
      $('#saveForLaterCartSection .cart-page-title').html(msg);

      __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["updateHeaderCartWidget"](response);
      __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["updateCartSummary"](orderSummary);
      __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["updateProductSummary"](orderSummary);
      if (response.cartEmpty) {
        window.location.reload();
      }
    }

    if (response.couponDetails) {
      __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["updateCouponSummary"](response);
    } else {
      $('.promo-code').show();
      $('.apply-promo').removeClass('show');
      $('.apply-promo-container').hide();
      $('.another-promo').hide();
      $('.apply-promo-container .error-msg').hide();
      $('.promo-added').hide();
    }
  },
  showRemovedGuests: function showRemovedGuests(productId, data) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var ajaxUrl, inputDataObj, res, timeSlots, i, presales, bookingData, html, repanitClass, $imgArrowIcon, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["showLoader"]();
              ajaxUrl = '/_ui/responsive/ccl/assets/templates/airport-transfers/edit-guest-airport-transfers.html';
              _context.prev = 2;
              inputDataObj = {
                url: ajaxUrl,
                type: 'GET'
              };
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["doAjax"](inputDataObj);

            case 6:
              res = _context.sent;

              __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["hideLoader"]();
              timeSlots = data.timeSlotsCard;

              for (i = 0; i < timeSlots.length; i++) {
                presales = timeSlots[i].transferInformation.preSaleId;

                timeSlots[i].transferInformation.productId = data.productCard.productId;
                bookingData = timeSlots[i];
                html = __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["createDynamicHTML"](res, bookingData);
                repanitClass = '.edit-guest-snorkel-wrap.edit-guest-transfers-' + presales;

                $(repanitClass).empty().append(html);
                $imgArrowIcon = $('.c-cart-card.card-transfers.card-' + presales).find('.list-item.edit-guest-snorkel-link');

                $imgArrowIcon.removeClass('open');
                $(repanitClass).attr('style', 'display:none');
              }
              _context.next = 17;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](2);

              __WEBPACK_IMPORTED_MODULE_3__generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context.t0 };

              console.log(cartAPIError);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[2, 12]]);
    }))();
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generalFunctions__ = __webpack_require__(4);


CCL.dropdownSelect = {
  autoload: [['selectDrop', $('.c-dropdown').length > 0], ['dropImgRotate', $('.c-dropdown').length > 0], ['enableScrollToTop', $('#scrollToTop-CCL').length > 0], ['stickyOrderSummary', $('.c-order-summary').length > 0], ['collapseOpenedAccordian', $('.gift-card-balance').length > 0], ['cclAdaFocus', $('body').length > 0], ['pdpSticky', $('.c-pdp-card-move-up').length > 0], ['enableADAForModals', $('.modal').length > 0], ['pdpCardScroll', $('c-pdp-template-one'.length > 0)], ['hideEmptyPlaceholder', $('body').length > 0], ['ProcessingMessage', $('.err-text-wrapper').length > 0], ['shopByCategoryhideEmptyPlaceholder', $('.shop-by-category-empty-placeholder').length > 0], ['todoPlannerhideEmptyPlaceholder', $('.todo-planner-empty-placeholder').length > 0], ['iframeScreenHide', $('body').length > 0], ['notificationCount', $('.notification-dropdown-anchor').length > 0]],

  triggeredElementClass: '',
  scrollPosition: '',
  focusedElementClass: '',

  notificationCount: function notificationCount() {
    $.ajax({
      type: 'GET',
      url: '/shop/webinbox/messagecount'
    }).done(function (response) {
      var notContainer = $('.notification-count');
      if (response && response.unread) {
        if (response.unread > 99) {
          notContainer.text('99+');
        } else {
          notContainer.text(response.unread);
        }
        $('.notification-dropdown-anchor').attr('aria-label', 'You have ' + response.unread + ' unread notification, Visit notification center to view all notifications');
        notContainer.removeClass('d-none');
      } else {
        notContainer.addClass('d-none');
      }
      var pageName = ACC.pageName; // eslint-disable-line
      if (pageName.toLowerCase().includes('inbox')) {
        __WEBPACK_IMPORTED_MODULE_0__generalFunctions__["hideLoader"]();
      }
    }).fail(function () {
      console.log('error while loading notification count');
      __WEBPACK_IMPORTED_MODULE_0__generalFunctions__["hideLoader"]();
    });
  },
  refreshHybrisCount: function refreshHybrisCount(count) {
    var notContainer = $('.notification-count');
    notContainer.removeClass('d-none');
    if (count) {
      if (count > 99) {
        notContainer.text('99+');
      } else {
        notContainer.text(count);
      }
      $('.notification-dropdown-anchor').attr('aria-label', 'You have ' + count + ' unread notification, Visit notification center to view all notifications');
    } else {
      notContainer.addClass('d-none');
    }
  },
  enableADAForModals: function enableADAForModals() {
    var _this = this;

    $('.modal').on('hidden.bs.modal', function (e) {
      var replacedClass = _this.triggeredElementClass.replace(/\s/g, '.');
      if (replacedClass) {
        _this.focusedElementClass = '.' + replacedClass;
        $('body').addClass('ccl-ada-focus');
        //  $(`.${replacedClass}`).trigger('touchstart'); // Added for Iphone
        setTimeout(function () {
          $('.' + replacedClass).addClass('ada-element-focus');
          $('.' + replacedClass).focus();
        }, 800);
      }

      // Added this for Iphone focus
      // $(`.${replacedClass}`).on('touchstart', () => {
      //   $(`.${replacedClass}`).focus();
      // });
    });

    $('.modal').on('show.bs.modal', function (event) {
      _this.triggeredElementClass = event.delegateTarget.ownerDocument.activeElement.className;
      // this.scrollPosition = $(window).scrollTop();
    });
  },
  handleScroll_Mobile: function handleScroll_Mobile() {
    var metaTag = $('#viewport');
    console.dir(metaTag);
    // metaTag[0].attr('content', contentInfo);
  },
  ProcessingMessage: function ProcessingMessage() {
    setTimeout(function () {
      $('.err-text').attr({ role: 'alert', 'aria-live': 'assertive' });
    }, 500);
    setTimeout(function () {
      $('.err-title').attr({ role: 'alert', 'aria-live': 'assertive' });
    }, 1500);
  },
  dropImgRotate: function dropImgRotate() {
    $('.btn-dropdown').click(function (event) {
      $('.btn-dropdown img').toggleClass('img-rotate');
    });
  },
  selectDrop: function selectDrop() {
    $('.dropdown-item').click(function (event) {
      var value = event.currentTarget.dataset.value;

      $('.dropdown-val').empty().html(value);
      $('.btn-dropdown img').toggleClass('img-rotate');
    });
  },
  collapseOpenedAccordian: function collapseOpenedAccordian() {
    var $categoryFacetsGroup = $('#category-facets-accordion');
    $categoryFacetsGroup.on('show.bs.collapse', '.collapse', function () {
      $categoryFacetsGroup.find('.collapse.show').collapse('hide');
    });
  },
  enableScrollToTop: function enableScrollToTop() {
    var getScrolledPosition = $(window).scrollTop();
    if (getScrolledPosition <= 10) {
      $('#scrollToTop-CCL').fadeOut();
    }
    $(window).scroll(function () {
      var scrolledPosition = $(window).scrollTop();
      if (scrolledPosition >= 100) {
        // If page is scrolled more than 100px
        $('#scrollToTop-CCL').fadeIn(200); // Fade in the arrow
      } else {
        $('#scrollToTop-CCL').fadeOut(200); // Else fade out the arrow
      }
    });
  },
  stickyOrderSummary: function stickyOrderSummary() {
    if ($('.sticky-total').length > 0) {
      if (!$('body').find('.sticky-total-arrow').length) {
        $('.sticky-total').append('<img src="/_ui/responsive/ccl/assets/icons/down_blue.svg" alt="arrow image" class="sticky-total-arrow">');
      }
    }
    $(window).scroll(function () {
      if (window.innerWidth <= 1080) {
        if (__WEBPACK_IMPORTED_MODULE_0__generalFunctions__["isElementPartiallyInViewport"]($('.c-order-summary'))) {
          $('.mobile-sticky-order-summary').slideUp();
        } else {
          $('.mobile-sticky-order-summary').slideDown();
        }
      }
    });

    $('body').on('click keypress', '.sticky-total', function (e) {
      $('html, body').animate({
        scrollTop: $('.c-order-summary').offset().top
      }, 1200);
    });
  },
  cclAdaFocus: function cclAdaFocus() {
    $(document).on('keydown click', function (event) {
      if (event.which === 9) {
        $('body').addClass('ccl-ada-focus');
      }
    });
    $('body').on('keydown click', function (event) {
      if (event.type === 'click') {
        $('body').removeClass('ccl-ada-focus');
      } else if (event.which === 13) {
        $('body').addClass('ccl-ada-focus');
      } else {
        $('body').addClass('ccl-ada-focus');
      }
    });
  },
  hideEmptyPlaceholder: function hideEmptyPlaceholder() {
    $(window).on('load', function () {
      $('.empty-placeholder').css('display', 'none');
      $('.product-carousel-container').fadeIn('slow');

      // $('.empty-placeholder').css('display', 'none');
      // $('.product-carousel-container').fadeIn('slow');

      $('body').on('keypress', '.sharethis-inline-share-buttons .st-btn', function (e) {
        if (e.which === 13) {
          $(e.currentTarget).trigger('click');
        }
      });

      // setTimeout(() => {
      //   $('.sharethis-inline-share-buttons').addClass('d-none');
      // }, 500);

      setTimeout(function () {
        $('body').find('.sharethis-inline-share-buttons .st-btn').each(function (index, elem) {
          $(elem).attr('tabindex', '-1');
          var alt = $(elem).find('img').attr('alt');
          $(elem).find('img').attr('aria-label', alt + '. Opens a new tab to an external website.');
          $(elem).find('img').removeAttr('alt');
          $(elem).attr('role', 'button');
          $(elem).css('display', 'inline-block');
        });
        $('.sharethis-inline-share-buttons .st-btn img').attr('aria-hidden', 'true');
        $('.sharethis-inline-share-buttons .st-btn').attr('aria-hidden', 'true');
      }, 1000);

      $('body').on('click keypress', '.pdp-share-link', function (e) {
        $('.pdp-share-link').attr('aria-expanded', function (index, attr) {
          if (attr === 'false') {
            $('.add-to-fav, .remove-from-fav').attr('tabindex', '-1');
          } else {
            $('.add-to-fav, .remove-from-fav').removeAttr('tabindex');
          }
          return attr === 'true' ? 'false' : 'true';
        });
        if (!$('.sharethis-inline-share-buttons').is(':visible')) {
          $('.sharethis-inline-share-buttons').css('opacity', '1').show();
          $('body').find('.sharethis-inline-share-buttons .st-btn').each(function (index, elem) {
            $(elem).attr('tabindex', '0');
          });
          $('.sharethis-inline-share-buttons .st-btn').attr('aria-hidden', 'false');
          $('.sharethis-inline-share-buttons .st-btn img').attr('aria-hidden', 'false');
          $('.sharethis-inline-share-buttons').attr('tabindex', '0');
          // $('.pdp-social-share').trigger('focus');
        } else {
          $('.sharethis-inline-share-buttons').css('opacity', '0').hide();
          $('.sharethis-inline-share-buttons .st-btn').attr('aria-hidden', 'true');
          $('.sharethis-inline-share-buttons .st-btn img').attr('aria-hidden', 'true');
          $('body').find('.sharethis-inline-share-buttons .st-btn').each(function (index, elem) {
            $(elem).attr('tabindex', '-1');
            $('.sharethis-inline-share-buttons').attr('tabindex', '-1');
          });
        }

        // $('.sharethis-inline-share-buttons').toggleClass('d-none');
      });

      $('body').on('click keydown', '.pdp-share-link', function (e) {
        if (e.which === 9) {
          if (Number($('.sharethis-inline-share-buttons').css('opacity')) === 1) {
            e.stopPropagation();
            e.preventDefault();
            $('.st-first').trigger('focus');
          }
        }
      });

      $('body').on('click keydown', '.st-last', function (e) {
        if (e.which === 9) {
          e.stopPropagation();
          e.preventDefault();
          $('.pdp-share-link').trigger('focus');
        }
      });
    });

    // window.onload = () => {
    //   $('.empty-placeholder').css('display', 'none');
    //   $('.product-carousel-container').fadeIn('slow');

    //   $('body').find('.sharethis-inline-share-buttons .st-btn').each((index, elem) => {
    //     $(elem).attr('tabindex', '0');
    //     const alt = $(elem).find('img').attr('alt');
    //     $(elem).find('img').attr('aria-label', `${alt}. Opens a new tab to an external website.`);
    //     $(elem).find('img').removeAttr('alt').attr('role', 'button');
    //   });

    //   $('body').on('keypress', '.sharethis-inline-share-buttons .st-btn', (e) => {
    //     if (e.which === 13) {
    //       console.log('key is pressed');
    //       $(e.currentTarget).trigger('click');
    //     }
    //   });
    // };
  },
  todoPlannerhideEmptyPlaceholder: function todoPlannerhideEmptyPlaceholder() {
    $('.todo-planner-empty-placeholder').css('display', 'none');
    $('#todoPlanner').fadeIn('slow');
  },
  shopByCategoryhideEmptyPlaceholder: function shopByCategoryhideEmptyPlaceholder() {
    $('.shop-by-category-empty-placeholder').css('display', 'none');
    $('.shop-by-category-carousel').fadeIn('slow');
  },
  pdpCardScroll: function pdpCardScroll() {
    // if (!gfunctions.detectmob()) {
    //   const cardHeight = $('.c-pdp-card').height();
    //   if (cardHeight > window.innerHeight) {
    //     $('.c-pdp-card').css('height', `${window.innerHeight - 10}px`);
    //   }
    // }
  },
  pdpSticky: function pdpSticky() {
    // $(window).scroll(() => {
    //   if (!gfunctions.detectmob()) {
    //     const offset = 0;
    //     let sticky = false;
    //     const top = $(window).scrollTop();
    //     const $container = $('.c-pdp-card').closest('.container');
    //     const elemTop = $('.c-pdp-card').position().top;
    //     const elemBottom = elemTop + $('.c-pdp-card').height();
    //     const $productDetailsTop = $('.c-product-details').offset().top;
    //     const $productDetailsHeight = $('.c-product-details').height();
    //     const $productDetailsBottom = $productDetailsTop + $productDetailsHeight;
    //     const conPosRight = ($(window).width() - $container.outerWidth()) / 2;
    //     if ((elemBottom + top) > $productDetailsBottom) {
    //       $('.c-pdp-card').addClass('banner-card-sticky');
    //     } else {
    //       $('.c-pdp-card').removeClass('banner-card-sticky');
    //     }
    //     if (($('.pdp-sticky-wrap').offset().top - 650) < top + 32) {
    //       $('.c-pdp-card').addClass('banner-card-fixed');
    //       $('.c-pdp-card').css('right', `${conPosRight}px`);
    //       sticky = true;
    //     } else {
    //       $('.c-pdp-card').removeClass('banner-card-fixed');
    //       $('.c-pdp-card').css('right', '0');
    //     }
    //   }
    // });
  },
  iframeScreenHide: function iframeScreenHide() {
    $('#st_gdpr_iframe').attr('tabindex', '-1');
    $('#st_gdpr_iframe').attr('aria-hidden', 'true');
    $('#st_gdpr_iframe').attr('hidden', 'hidden');
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__);
var _this = this;



__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('math', function (lvalue, operator, rvalue, options) {
  var leftValue = parseFloat(lvalue);
  var rightValue = parseFloat(rvalue);
  return {
    '+': leftValue + rightValue,
    '-': leftValue - rightValue,
    '*': leftValue * rightValue,
    '/': leftValue / rightValue,
    '%': leftValue % rightValue
  }[operator];
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('getTimeSlot', function (TimeSlot, options) {
  var text = TimeSlot.split('-');
  return (text[0].replace(/\s/g, '') + ' - ' + text[1].replace(/\s/g, '')).toLowerCase();
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('showMinimumAge', function (age, options) {
  return Number(age) === 0 ? 'No Minimum Age' : 'Must be +' + age + ' years old';
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('removeHtmlTags', function (content, options) {
  // adding span so it will work for normal string also
  return $('<span>' + content + '</span>').text();
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('createImageURL', function (imageUrl, options) {
  if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
    return imageUrl + '?w=361&h=235';
  }
  return imageUrl + '&w=361&h=235';
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('createProductCartImageURL', function (imageUrl, options) {
  if ($('#cloudMediaConversionFlag').data('cloudmediaconversionflag') === true) {
    return imageUrl + '?w=224&h=128';
  }
  return imageUrl + '&w=224&h=128';
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('addVibeProductURL', function (vibeProductType, productUrl, variantId, options) {
  var VibeProductURL = productUrl;
  if (vibeProductType === 'EX') {
    VibeProductURL = VibeProductURL + '?selectedVariant=' + variantId;
  }
  return VibeProductURL;
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('addStartingFrom', function (category, hasVariant, options) {
  var returnValue = '';
  if (category !== 'Bottomless Bubbles Package' && hasVariant === 'true') {
    returnValue = 'Starting From';
  }
  return returnValue;
});
__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('perPersonCond', function (vibeProductType, perSalesDescription, options) {
  var returnValue = '';
  if (vibeProductType !== 'SP' && perSalesDescription !== '' && perSalesDescription !== null) {
    returnValue = '/ ' + perSalesDescription;
  }
  return returnValue;
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('encryptedIdDisplay', function (displayBookingId, bookingId, options) {
  var returnValue = '';
  if (displayBookingId) {
    returnValue = displayBookingId;
  } else {
    returnValue = bookingId;
  }
  return returnValue;
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('availableTickets', function (tickets, options) {
  var ticketText = Number(tickets) > 1 ? 'Tickets' : 'Ticket';
  return tickets + ' ' + ticketText + ' Available';
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('ccl_if_eq', function (a, b, opts) {
  if (a === b) {
    return opts.fn(_this);
  }
  return opts.inverse(_this);
});
__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('calc', function (lvalue, operator, rvalue, options) {
  console.log('operation:', operator);
  var lval = parseInt(lvalue, 10);
  var rval = parseInt(rvalue, 10);
  return {
    '+': lval + rval,
    '-': lval - rval,
    '*': lval * rval,
    '/': lval / rval,
    '%': lval % rval
  }[operator];
});
__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('ifCond', function (v1, operator, v2, options) {
  switch (operator) {
    case '===':
      return v1 === v2 ? options.fn(_this) : options.inverse(_this);
    case '!==':
      return v1 !== v2 ? options.fn(_this) : options.inverse(_this);
    case '<':
      return v1 < v2 ? options.fn(_this) : options.inverse(_this);
    case '<=':
      return v1 <= v2 ? options.fn(_this) : options.inverse(_this);
    case '>':
      return v1 > v2 ? options.fn(_this) : options.inverse(_this);
    case '>=':
      return v1 >= v2 ? options.fn(_this) : options.inverse(_this);
    case '&&':
      return v1 && v2 ? options.fn(_this) : options.inverse(_this);
    case '||':
      return v1 || v2 ? options.fn(_this) : options.inverse(_this);
    default:
      return options.inverse(_this);
  }
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('checkIf', function (v1, o1, v2, mainOperator, v3, o2, v4, options) {
  var operators = {
    '===': function _(a, b) {
      return a === b;
    },
    '!==': function _(a, b) {
      return a !== b;
    },
    '<': function _(a, b) {
      return a < b;
    },
    '<=': function _(a, b) {
      return a <= b;
    },
    '>': function _(a, b) {
      return a > b;
    },
    '>=': function _(a, b) {
      return a >= b;
    },
    '&&': function _(a, b) {
      return a && b;
    },
    '||': function _(a, b) {
      return a || b;
    }
  };
  var a1 = operators[o1](v1, v2);
  var a2 = operators[o2](v3, v4);
  var isTrue = operators[mainOperator](a1, a2);
  return isTrue ? options.fn(_this) : options.inverse(_this);
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('ccl_or', function (v1, v2, options) {
  if (v1 || v2) {
    return options.fn(_this);
  }
  return options.inverse(_this);
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('removeSpace', function (value, options) {
  return value ? value.replace(/[^A-Z0-9]+/ig, '_') : '';
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('firstLetterCapital', function (value, options) {
  var newValue = value;
  if (value) {
    var firstChartext = value.slice(0, 1).toUpperCase();
    var remainingText = value.slice(1);
    newValue = firstChartext.concat(remainingText);
  }

  return newValue;
});

__WEBPACK_IMPORTED_MODULE_0_handlebars_dist_handlebars_js__["registerHelper"]('addPipeSeperator', function (audultPrice, childPrice, options) {
  var returnValue = '';
  if (audultPrice && childPrice) {
    returnValue = '|';
  }
  return returnValue;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__);


CCL.TopNavHeader = {
  autoload: [['headerValue', $('.c-main-nav').length > 0]],

  headerValue: function headerValue() {
    var headerType = $('#headerType').val();
    window.addEventListener('unload', function (event) {
      event.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["set"]('headerType', headerType);
    });
    /* eslint-disable */
    // const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
    // const eventName = isOnIOS ? 'pagehide' : 'beforeunload';
    // if (isOnIOS) {
    //   window.addEventListener('unload', (event) => {
    //     event.preventDefault();
    //     deloitteCookies.set('headerType', headerType);
    //   });
    // } else {
    //   this.setHeaderType(headerType);
    // }
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__ = __webpack_require__(4);




CCL.videoPlayerModal = {
  autoload: [['openVideoPlayer', $('.CCL-youtube-link').length > 0]],

  dynamicURLData: {},

  openVideoPlayer: function openVideoPlayer() {
    var _this = this;

    $('.CCL-youtube-link').click(function (event) {
      event.preventDefault();
      var embedOnURL = _this.generateEmbedURl($(event.currentTarget).attr('data-audioonurl'));
      var embedOffURL = _this.generateEmbedURl($(event.currentTarget).attr('data-audiooffurl'));
      _this.dynamicURLData = {
        audioOnUrl: embedOnURL,
        audioOffUrl: embedOffURL
      };
      _this.playCarnivalVideo(_this.dynamicURLData);
    });
  },
  generateEmbedURl: function generateEmbedURl(url) {
    var getID = this.getVideoId(url);
    var videoURL = '//www.youtube.com/embed/' + getID;
    return videoURL;
  },
  getVideoId: function getVideoId(videoUrl) {
    /* eslint-disable */
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = videoUrl.match(regExp);
    if (match && match[2].length === 11) {
      return match[2];
    } else {
      return 'error';
    }
    /* eslint-enable */
  },
  playCarnivalVideo: function playCarnivalVideo(dynamicData) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var inputHtmlObj, response, html, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["showLoader"]();
              _context.prev = 1;
              inputHtmlObj = {
                url: '/_ui/responsive/ccl/assets/templates/video-modals/ccl-video-modal.html',
                type: 'GET'
              };
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["doAjax"](inputHtmlObj);

            case 5:
              response = _context.sent;
              html = __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["createDynamicHTML"](response, dynamicData);

              $('#video-player-ccl').empty().append(html);
              __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["showModal"]('video-player-modal');
              __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"](); // call all javascript event after above html load
              _this2.modalClickEvents();
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](1);

              __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context.t0 };

              console.log(cartAPIError);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 13]]);
    }))();
  },
  modalClickEvents: function modalClickEvents() {
    var _this3 = this;

    $('#video-player-modal').on('hidden.bs.modal', function () {
      $('#iframeYoutube').attr('src', '#');
    });

    $('.videoCloseBtn').click(function (e) {
      $('#iframeYoutube').attr('src', '#');
      if (__WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["detectmob"]()) {
        $('.mobileComponent .CCL-youtube-link').addClass('video-focus');
        setTimeout(function () {
          $('.mobileComponent .CCL-youtube-link').focus();
        });
      } else {
        $('.desktopComponent .CCL-youtube-link').addClass('video-focus');
        setTimeout(function () {
          $('.desktopComponent .CCL-youtube-link').focus();
        });
      }
    });

    $('.radio-toggle').click(function (e) {
      var getSelectedRadio = e.currentTarget.innerText.trim();
      if (getSelectedRadio === 'off') {
        $('#iframeYoutube').attr('src', _this3.dynamicURLData.audioOffUrl);
      } else {
        $('#iframeYoutube').attr('src', _this3.dynamicURLData.audioOnUrl);
      }
      $('.audio-desc-toggle').find('input:checked').focus();
    });

    $('#ad-disabled0').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        $(function () {
          $('.videoCloseBtn').focus();
        });
      }
    });
    $('#ad-enabled0').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        $(function () {
          $('.videoCloseBtn').focus();
        });
      }
    });
    $('#closeBtn').on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        $('.audio-desc-toggle').find('input:checked').focus();
      }
    });
    // $('body').on('keydown', e => {
    //   if (e.which === 27) { // Esc Key
    //     e.preventDefault();
    //     e.stopPropagation();
    //     gfunctions.hideModal('cclVideoModal');
    //   }
    // });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__ = __webpack_require__(4);





CCL.upSellProductModal = {
  autoload: [
  // ['test', $('.upsellProduct-description').length > 0]
  ['modalEvents', $('.upsellProduct-description').length > 0]],

  isOutSideClick: true,

  // test() {
  //   gfunctions.seeMoreLess('.upsellProduct-description', 'test'); // Apply SeeMore or SeeLess
  // },

  loadUpsellModal: function loadUpsellModal(productCode) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    var ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/upsell-product.json';
    } else {
      ajaxUrl = '/shop/cart/getupsellproduct?productCode=' + productCode;
    }
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      _this.openUpsellModal(response);
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      console.log('error Occured');
    });
  },
  openUpsellModal: function openUpsellModal(dynamicData) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var inputHtmlObj, response, html, prodTitle, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              _context.prev = 1;
              inputHtmlObj = {
                url: '/_ui/responsive/ccl/assets/templates/cart-modals/upsell-product-modal.html',
                type: 'GET'
              };
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputHtmlObj);

            case 5:
              response = _context.sent;
              html = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](response, dynamicData);

              $('#upsell-product-modal').empty().append(html);
              prodTitle = dynamicData.productCard.title;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showModal"]('upsellProductModal');
              _this2.isOutSideClick = true;
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"](); // call all javascript event after above html load
              _this2.modalClickEvents(prodTitle);
              _context.next = 20;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](1);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context.t0 };

              console.log(cartAPIError);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 15]]);
    }))();
  },
  modalClickEvents: function modalClickEvents(prodTitle) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["seeMoreLess"]('.upsellProduct-description', prodTitle); // Apply SeeMore or SeeLess

    $('#upsell-product-modal').on('hidden.bs.modal', function (e) {
      if (_this3.isOutSideClick) {
        $('.upSellCloseBtn .checkoutConflictBtn').trigger('click');
      }
    });
    $('#upsell-product-modal').on('click', '.upSellCloseBtn', function (e) {
      _this3.isOutSideClick = false;
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('upsellProductModal');
    });

    $('#upsell-product-modal').on('click', '.globalUpSellCloseBtn', function (e) {
      $('.more-details-btn').trigger('click');
    });

    $('#upsell-product-modal').on('click', '.more-details-btn', function (e) {
      _this3.isOutSideClick = false;
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('upsellProductModal');
    });

    $('#upsell-product-modal').on('click', '.upsell-add-to-cart-btn', function (e) {
      _this3.isOutSideClick = false;
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('upsellProductModal');
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#upsellProductModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  },
  loadGlobalUpsellModal: function loadGlobalUpsellModal(event) {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    var ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/upsell-product.json';
    } else {
      ajaxUrl = '/shop/cart/productreference';
    }

    var quantity = null;

    if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').length) {
      quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    } else if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').length) {
      quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').val();
    }

    var bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : [];
    var guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : [];

    var dataObj = {
      productCode: $(event.target).data('productcode'),
      referenceType: 'UPSELLING',
      qty: quantity || 1,
      encBookingIds: bookingIdsArray,
      encGuestIds: guestIdsArray
    };
    var csrf = $('#csrfSessionToken').data('csrf');

    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj),
      headers: {
        CSRFToken: csrf
      },
      contentType: 'application/json'
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      if (response.productValid) {
        _this4.openGlobalUpsellModal(response);
      } else {
        $(event.target).attr('data-hasupsell', 'false');
        $(event.target).trigger('click');
      }
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      console.log('error Occured');
      $(event.target).attr('data-hasupsell', 'false');
      $(event.target).trigger('click');
    });
  },
  openGlobalUpsellModal: function openGlobalUpsellModal(dynamicData) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var inputHtmlObj, targetProduct, sourceProduct, response, html, prodTitle, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              _context2.prev = 1;
              inputHtmlObj = {
                url: '/_ui/responsive/ccl/assets/templates/cart-modals/global-upsell-product-modal.html',
                type: 'GET'
              };
              targetProduct = dynamicData.targetProduct, sourceProduct = dynamicData.sourceProduct;

              targetProduct.addCartBtnClass = _this5.getBtnClass(targetProduct);
              sourceProduct.addCartBtnClass = _this5.getBtnClass(sourceProduct);

              _context2.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputHtmlObj);

            case 8:
              response = _context2.sent;
              html = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](response, dynamicData);

              $('#upsell-product-modal').empty().append(html);
              prodTitle = dynamicData.targetProduct.productName;

              //  gfunctions.hideModal('termsAndConditionsModal');

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('alcoholAtcModal');
              //  gfunctions.hideModal('diningAtcModal');
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('clpAddToCartModal');
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showModal"]('globalUpsellProductModal');

              setTimeout(function () {
                $('body').addClass('modal-open');
              }, 1000);
              _this5.isOutSideClick = true;
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"](); // call all javascript event after above html load
              _this5.modalClickEvents(prodTitle);
              _context2.next = 26;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2['catch'](1);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context2.t0 };

              console.log(cartAPIError);

            case 26:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this5, [[1, 21]]);
    }))();
  },
  getBtnClass: function getBtnClass(product) {
    var btnClass = 'btn-add-cart';
    if (product.productType === 'SFP') {
      btnClass = 'add-to-cart-sfp';
    } else if (product.productType === 'SFAP' || product.alcoholic === true || product.productType !== 'FTF' && product.productType !== '' || product.productType !== '') {
      btnClass = 'terms-conditions-btn';
    }

    return btnClass;
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.faqSlider = {
  autoload: [['faqSlide', $('body').length > 0], ['handleShowFAQs', $('body').length > 0]],

  readAllFAQText: '',
  readTopFAQText: '',

  faqSlide: function faqSlide() {
    $('body').find('.faq-button').click(function () {
      $('body').find('.category-overlay').remove();
      $('body').find('.c-products-faq').addClass('open');
      $('body').find('.faq-back-link').addClass('ada-highlighted');
      $('body').find('.faq-back-link').focus();
      $('body').append('<div class="category-overlay" style="z-index:9998"><div>');
      $('body').addClass('add-category-overlay');
    });
    $('.faq-back-link').click(function () {
      $('body').find('.c-products-faq').toggleClass('open');
      $('body').find('.faq-button').addClass('ada-highlighted');
      $('body').find('.faq-button').focus();
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
    });
  },
  handleShowFAQs: function handleShowFAQs() {
    var _this = this;

    $('body').on('click', '.all-faq-link', function (e) {
      _this.readTopFAQText = $(e.currentTarget).attr('data-faqtext');
      if (e.currentTarget.textContent === _this.readTopFAQText) {
        $('.read-top-faq').css('display', 'block');
        $('.read-all-faq').css('display', 'none');
        e.currentTarget.textContent = _this.readAllFAQText;
      } else {
        $('.read-top-faq').css('display', 'none');
        $('.read-all-faq').css('display', 'block');
        _this.readAllFAQText = e.currentTarget.textContent;
        e.currentTarget.textContent = _this.readTopFAQText;
      }
    });
    $('.all-faq-link').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        $(function () {
          $('.faq-back-link').addClass('ada-highlighted');
          $('.faq-back-link').focus();
        });
      }
    });
    $('.faq-back-link').on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        $(function () {
          $('.all-faq-link').addClass('ada-highlighted');
          $('.all-faq-link').focus();
        });
      }
    });

    var lastCard = $('.c-products-faq .read-top-faq .card').last();
    var faqEl = $(lastCard).find('.card-header');
    console.dir(lastCard);
    $(faqEl).on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        if (!$('.all-faq-link').length) {
          $(function () {
            $('.faq-back-link').addClass('ada-highlighted');
            $('.faq-back-link').focus();
          });
        }
      }
    });

    $('.accordion-toggle').click(function (e) {
      $(e.currentTarget).addClass('ada-highlighted');
      $(e.currentTarget).focus();
      var expanded = $(e.currentTarget).attr('aria-expanded');
      if (expanded === 'true') {
        $(e.currentTarget).attr('aria-expanded', 'false');
      } else {
        $(e.currentTarget).attr('aria-expanded', 'true');
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.categoryCarousel = {
  autoload: [['categoryStick', $('.sticky-container').length > 0]],

  categoryStick: function categoryStick() {
    var stickyOffset = $('.sticky-container').offset().top;
    $(window).scroll(function () {
      var sticky = $('.sticky-container');
      var scroll = $(window).scrollTop();
      if (scroll >= stickyOffset) {
        sticky.addClass('sticky-fixed');
        $('.sticky-fixed').next().addClass('addPadding-after-scroll');
      } else {
        $('.sticky-fixed').next().removeClass('addPadding-after-scroll');
        sticky.removeClass('sticky-fixed');
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

CCL.bevergeTable = {
  autoload: [['tableSlider', $('.checktable').length > 0], ['onDrinkPackagesLoad', $('.c-beverages-cards').length > 0]],

  onDrinkPackagesLoad: function onDrinkPackagesLoad() {
    if ($('#promotionURL').data('promotionurl') && $('#promotionURL').data('promotionurl') !== '') {
      this.drinkPackagePromotionPricingAjax();
    }
  },
  drinkPackagePromotionPricingAjax: function drinkPackagePromotionPricingAjax() {
    var _this = this;

    var token = $('#csrfSessionToken').data('csrf');
    var promoUrl = $('#promotionURL').data('promotionurl');
    var ajaxUrl = promoUrl;
    var ajaxType = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/ajax-clp/promo-price.json';
      ajaxType = 'GET';
    }

    var products = [];
    var promotionalSailingData = '';
    if ($('#maskedSailingData').length && $('#maskedSailingData').data('sailingdata') !== '') {
      promotionalSailingData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()($('#maskedSailingData').data('sailingdata')));
    }

    $('.c-beverages-cards .c-product-card .btn.btn-red.general-add-to-cart-btn').each(function (index, element) {
      console.dir(element);
      products.push({
        productCode: element.dataset.productcode,
        productBaseCode: element.dataset.productcode,
        productType: 'FS',
        productSubType: element.dataset.productcode === 'BB_1' ? 'BUBBLES' : null
      });
    });

    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ products: products, promotionalSailingData: promotionalSailingData })
    }).then(function (res) {
      if (res && res.promotionsData.length) {
        $.each(res.promotionsData, function (key, val) {
          // show promoPill for all the CLP products
          $('body').find('.' + val.productBaseCode + ' .pills-wrap').append('<div class="best-seller general-best-seller">\n              <span class="info-icon" aria-hidden="true">\n                  <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="Featured" width="11" height="12">\n              </span>\n              ' + val.promotionResultsData[0].description + '\n            </div>');

          // code to replace html
          _this.drinkPackagesPromoPriceHtml(val);
        });
      }
    }).catch(function (error) {
      console.log('error occured');
    });
  },


  /* eslint-disable */
  drinkPackagesPromoPriceHtml: function drinkPackagesPromoPriceHtml(productPromoData) {
    if (productPromoData.discountedPrice.length > 1) {
      // if both values are not same that means we have separate adult & child
      if (productPromoData.discountedPrice[0].value !== productPromoData.discountedPrice[1].value) {
        var adultHtml = '';
        var childHtml = '';
        var oldAdultPriceObj = productPromoData.originalPrice.filter(function (x) {
          return x.priceGroupType === 'A';
        })[0];
        var oldChildPriceObj = productPromoData.originalPrice.filter(function (x) {
          return x.priceGroupType === 'C';
        })[0];

        var newAdultPriceObj = productPromoData.discountedPrice.filter(function (x) {
          return x.priceGroupType === 'A';
        })[0];
        var newChildPriceObj = productPromoData.discountedPrice.filter(function (x) {
          return x.priceGroupType === 'C';
        })[0];

        adultHtml = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ' + oldAdultPriceObj.formattedValue + '" role="textbox"> <b>' + oldAdultPriceObj.formattedValue + '</b></span > / Adult Per Day</span ></p> <b aria-label="current price is ' + newAdultPriceObj.formattedValue + '" role="textbox">' + newAdultPriceObj.formattedValue + '</b></div>';

        childHtml = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ' + oldChildPriceObj.formattedValue + '" role="textbox"> <b>' + oldChildPriceObj.formattedValue + '</b></span > / Child Per Day</span ></p> <b aria-label="current price is ' + newChildPriceObj.formattedValue + '" role="textbox">' + newChildPriceObj.formattedValue + '</b></div>';

        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-adult').replaceWith(adultHtml);
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-child').replaceWith(childHtml);
      } else {
        var priceHtml = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox"><b>' + productPromoData.originalPrice[0].formattedValue + '</b></span> / Person</span></p></div><b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">' + productPromoData.discountedPrice[0].formattedValue + '</b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-adult').replaceWith(priceHtml);
      }
    } else {
      if (productPromoData.salesPerUnitDescription) {
        var _priceHtml = '<div>\n        <p class="price-person general-price-person ccl-d-inline-flex">\n        <span class="general-price-drinks">\n        <span class="strikeoutprice greytext" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox"><b>' + productPromoData.originalPrice[0].formattedValue + '</b></span> / ' + productPromoData.salesPerUnitDescription + '</span></p></div><b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox"> ' + productPromoData.discountedPrice[0].formattedValue + '</b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-adult').replaceWith(_priceHtml);
      } else {
        var _priceHtml2 = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-drinks"><span class="strikeoutprice greytext" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox"><b>' + productPromoData.originalPrice[0].formattedValue + '</b></span> / Person</span></p></div><b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">' + productPromoData.discountedPrice[0].formattedValue + '</b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-adult').replaceWith(_priceHtml2);
      }
    }
  },

  /* eslint-enable */

  tableSlider: function tableSlider() {
    $('.up-button').click(function (event) {
      var link = null;
      event.preventDefault();
      $('.checktable tr:gt(4) td').slideToggle('fast', 'linear');
      $('.up-button').toggleClass('up-button-reverse');
      if ($('.up-button').hasClass('up-button-reverse')) {
        link = $('.c-beverage-table').offset().top;
      } else {
        link = 2200; // $('.up-button').offset().top;
      }

      $('html, body').animate({
        scrollTop: link
      }, 200);

      var expand = $('.up-button').attr('aria-expanded');
      $('.up-button').addClass('ada-element-focus');
      setTimeout(function () {
        $(function () {
          if (expand === 'false') {
            $('.up-button').attr('aria-expanded', 'true');
            $('.up-button').attr('aria-label', 'View less information');
          } else {
            $('.up-button').attr('aria-expanded', 'false');
            $('.up-button').attr('aria-label', 'View more information');
          }
          $('.up-button').focus();
        });
      }, 300);
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.categoryFacets = {
  autoload: [['facetsToggle', $('body').length > 0]],

  facetsToggle: function facetsToggle() {
    $('body').on('click keypress', '.filter-btn', function (e) {
      $(e.currentTarget).attr('aria-label', 'Filter button that contain options to see is expanded');
      $('body').find('.c-category-facets').show();
      $('body').find('.c-category-facets .btn-blue').focus();
    });
    // $('.filter-btn-wrap .btn-blue-link').click(() => {
    //   $('.c-category-facets').hide();
    // });
    // $('.filter-btn-wrap .btn-blue').click(() => {
    //   $('.c-category-facets').hide();
    // });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.cartCard = {
  autoload: [['counter', $('body').length > 0], ['toggleBundles', $('.bundle-link').length > 0], ['toggleEditGuestBeverage', $('.c-cart').length > 0], ['toggleEditGuestSnorkel', $('.c-cart').length > 0], ['toggleEditGuestxDining', $('.c-cart').length > 0], ['toggleEditTime', $('.edit-time-link').length > 0], ['toggleEditGuestTimeShorexCart', $('.c-cart').length > 0], ['toggleEditGuestAirport', $('.c-cart').length > 0], ['toggleCartEditStateroom', $('.c-cart').length > 0], ['removeProduct_DiningBtnClick', $('.dining-remove').length > 0], ['updateCss', $('.c-edit-guest-beverage').length > 0], ['removeProduct_xDiningBtnClick', $('.xdining-remove').length > 0], ['cartUpdatesClose', $('.cart-updates-close').length > 0], ['bannerClose', $('.banner-close').length > 0]],

  cartUpdatesClose: function cartUpdatesClose() {
    $('body').on('click', '.cart-updates-close', function (event) {
      $('.cart-updates').fadeOut();
    });
  },
  bannerClose: function bannerClose() {
    $('body').on('click', '.banner-close', function (event) {
      $(event.currentTarget).parents('.general-promo-banner').fadeOut();
    });
  },
  toggleEditGuestxDining: function toggleEditGuestxDining() {
    var _this = this;

    $('body').on('click', '.edit-guest-xdining-link', function (event) {
      // $(element).click((event) => {
      event.preventDefault();
      $(event.target).toggleClass('open');
      _this.enable_ADA_ForGuests(event.currentTarget);
      var targetElement = $(event.currentTarget).parents('.c-cart-card').find('.cart-edit-stateroom-wrap');
      $(targetElement).slideToggle();
      // });
    });
  },
  removeProduct_xDiningBtnClick: function removeProduct_xDiningBtnClick() {
    var _this2 = this;

    $('body').on('click', '.xdining-remove', function (e) {
      var productId = $(e.currentTarget).attr('data-productId');
      var serviceTimeSlot = $(e.currentTarget).data('servicetimeslot');
      var buyerId = $(e.currentTarget).data('buyerid');
      var getProductDiv = '.card-' + productId + '-' + serviceTimeSlot + '-' + buyerId;
      $(getProductDiv).css('display', 'none');
      _this2.removeBtn_xDining_CartAjax(productId, serviceTimeSlot, buyerId);
    });
  },
  removeBtn_xDining_CartAjax: function removeBtn_xDining_CartAjax(productId, serviceTimeSlot, buyerId) {
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    var jsonObjects = { productId: productId, serviceTimeSlot: serviceTimeSlot, buyerId: buyerId };
    var token = $('#csrfSessionToken').data('csrf');
    var getProductDiv = '.card-' + productId + '-' + serviceTimeSlot + '-' + buyerId;
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/entry/execute-action/REMOVE',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonObjects),
      dataType: 'json',
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: function success(res) {
        if (res.removeSuccess) {
          // Update the cart alert message also and remove this product from alert msg
          $('.cart-updates #cart-alert-' + productId + '-' + serviceTimeSlot + '-' + buyerId).remove();
          var msgLength = $('.cart-updates .unavailable-item').length;
          $('.cart-updates .available').html(msgLength + ' item(s) in your cart has a conflict that needs to be resolved before you can proceed to checkout.');
          if (msgLength === 0) {
            $('.cart-updates').remove();
          }

          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCartSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateProductSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          // update cart carousel
          if ($('body').find('.cart-carousel').length) {
            // update cart carousel
            CCL.cartCard.updateCartCarousel();
          }
          console.log('Something went well on Remove Click for Dining product ' + productId);
        } else {
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCartSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateProductSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          $('' + getProductDiv).css('display', 'block'); // Keep the card from DOM if RemoveSuccess is false
        }
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      },
      error: function error(_error) {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong on Remove Click for Dining product ' + productId);
      }
    });
  },
  counter: function counter() {
    var _this3 = this;

    /* eslint-disable */
    $('body').on('click keypress', '.increment-btn', function (event) {
      if ((event.which === 13 || event.which === 1) && ($(event.target).hasClass('disabled') || $(event.target).attr('disabled'))) {
        if ($(event.target).hasClass('ada-disabled')) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
        $(event.target).addClass('ada-disabled');
      }
      if ($(event.target).hasClass('cart-qty-increment-btn') && $(event.target).attr('disabled')) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      event.preventDefault();
      var targetElement = $(event.target).parents('.quantity-btn-wrap').find('.quantity-input');
      var quantity = $(targetElement).val();
      quantity++;
      if ($(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('disabled')) {
        $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').removeAttr('disabled');
      }
      $(targetElement).val(quantity);
      $(targetElement).attr('aria-label', 'quantity value is ' + quantity);
      $(event.currentTarget).attr('aria-label', 'increment quantity with current value ' + quantity);
      console.log(event.currentTarget);
      $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('aria-label', 'decrement quantity with current value ' + quantity);
      setTimeout(function () {
        $(event.target).focus();
        $(event.target).addClass('ada-element-focus');
      }, 400);
      if (quantity > 1) {
        $('.decrement-btn').removeClass('disabled');
      }
    });
    /* eslint-enable */
    $('body').on('click keypress', '.decrement-btn', function (event) {
      event.preventDefault();
      $('.increment-btn').removeClass('ada-disabled');
      var targetElement = $(event.target).parents('.quantity-btn-wrap').find('.quantity-input');
      var quantity = $(targetElement).val();
      if (quantity > 1) {
        quantity--;
      }
      $(targetElement).val(quantity);
      $(targetElement).attr('aria-label', 'quantity value is ' + quantity);
      $(event.currentTarget).attr('aria-label', 'decrement quantity with current value ' + quantity);
      $(event.target).parents('.quantity-btn-wrap').find('.increment-btn').attr('aria-label', 'increment quantity with current value ' + quantity);
      if (quantity === 0 || quantity === 1 || quantity === '1') {
        $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('disabled', 'disabled');
      }
      setTimeout(function () {
        $(event.target).focus();
        $(event.target).addClass('ada-element-focus');
      }, 400);
      $('.decrement-btn').addClass('disabled');
      if (quantity > 1) {
        $('.decrement-btn').removeClass('disabled');
      }
      if ($(event.target).parents('.quantity-btn-wrap').find('.quantity-input').val() === '1') {
        $(event.target).parents('.quantity-btn-wrap').find('.decrement-btn').attr('disabled', 'disabled');
      }
    });

    $('body').on('click', '.cart-qty-increment-btn:not(.wishlist-increment-btn)', function (event) {
      var qty = $(event.currentTarget).prev().val();
      var productId = event.currentTarget.dataset.productid;
      _this3.ajaxForCartQty(qty, productId, event);
    });

    $('body').on('click', '.cart-qty-decrement-btn:not(.wishlist-decrement-btn)', function (event) {
      var qty = $(event.currentTarget).next().val();
      var productId = event.currentTarget.dataset.productid;
      _this3.ajaxForCartQty(qty, productId, event);
    });

    $('body').on('click', '.wishlist-decrement-btn', function (event) {
      var qty = $(event.currentTarget).next().val();
      var productId = event.currentTarget.dataset.productid;
      _this3.ajaxForWishListUpdate(qty, productId);
    });

    $('body').on('click', '.wishlist-increment-btn', function (event) {
      var qty = $(event.currentTarget).prev().val();
      var productId = event.currentTarget.dataset.productid;
      _this3.ajaxForWishListUpdate(qty, productId);
    });

    $('body').on('click', '.wishListEditCartStateroom', function (event) {
      var parentElement = $(event.currentTarget).parents('.cart-edit-stateroom-wrap');
      var productId = parentElement[0].dataset.productid;
      var bookingIdsArray = [];
      var guestIdsArray = [];
      var qty = 0;
      if ($('.c-cart').find('#cart-edit-' + productId + ' .custom-checkbox .parent-check').length) {
        $('.c-cart').find('#cart-edit-' + productId + ' .custom-checkbox .parent-check:checked').not(':disabled').each(function (index, element) {
          if (element.hasAttribute('data-bookingid')) {
            bookingIdsArray.push(element.getAttribute('data-bookingid'));
          }
        });
      }
      if ($('.c-cart').find('#cart-edit-' + productId + ' .custom-checkbox .guests-check input[type="checkbox"]').length) {
        $('.c-cart').find('#cart-edit-' + productId + ' .custom-checkbox .guests-check input[type="checkbox"]:checked').not(':disabled').each(function (i, elem) {
          if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
            guestIdsArray.push(elem.getAttribute('data-guestid'));
          }
        });
      }

      if ($('#saveForLaterCartSection').find('.card-' + productId + ' .cart-card-body .wishlistqty').length) {
        qty = $('#saveForLaterCartSection').find('.card-' + productId + ' .cart-card-body .wishlistqty').val();
      }

      _this3.ajaxForWishListUpdate(qty, productId, bookingIdsArray, guestIdsArray);
    });

    $('body').on('click', '.wishlistSaveEditGuest_ShoreEx', function (e) {
      var productId = $(e.currentTarget).attr('data-productId');
      var parentElement = $(e.currentTarget).parents('.edit-guest-time-shorex-cart-wrap');
      var changedDiv = '.guest_' + productId + ' .custom-checkbox';
      var selecteditems = [];
      $(changedDiv).each(function (index, val) {
        $(val).find('input:checked').each(function (i, ob) {
          selecteditems.push(val.id);
        });
      });
      var shoreExData = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getSelectedGuests"](selecteditems);

      _this3.ajaxForWishListUpdate(0, productId, [], [], shoreExData);
    });

    $('body').on('click', '.moveToCart_ShoreEx', function (e) {
      var productId = $(e.currentTarget).attr('data-productid');
      var changedDiv = '.guest_' + productId + ' .custom-checkbox';
      var selecteditems = [];
      $('body').find(changedDiv).each(function (index, val) {
        $(val).find('input:checked').each(function (i, ob) {
          selecteditems.push(val.id);
        });
      });

      var productCard = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getSelectedGuests"](selecteditems);
      _this3.wishListMoveToCart(0, productId, [], [], productCard);
    });

    $('body').on('click', '.moveToCart_FunShop', function (e) {
      var productId = $(e.currentTarget).attr('data-productid');
      var productType = $(e.currentTarget).attr('data-producttype');
      var qty = 1;
      var sfDataObj = {};
      if ($(e.currentTarget).parents('.c-cart-card').find('.quantity-input').length) {
        qty = $(e.currentTarget).parents('.c-cart-card').find('.quantity-input').val();
      } else if ($(e.currentTarget).parents('.c-cart-card').find('.quantity-input-1').length) {
        qty = $(e.currentTarget).parents('.c-cart-card').find('.quantity-input-1').val();
      }

      if (productType === 'SF' || productType === 'SFP' || productType === 'SFAP') {
        sfDataObj = JSON.parse(CCL.pdpSfPackage.bookingData(productId, e, $(e.currentTarget)));
        $.each(sfDataObj.bookings, function (id, value) {
          value.qty = qty;
        });
        sfDataObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sfDataObj);
      }
      var selecteditems = [];
      var bookingIdsArray = [];
      var guestIdsArray = [];
      $('#cart-edit-' + productId + ' .custom-checkbox input[type="checkbox"]:checked').each(function (index, element) {
        if (element.hasAttribute('data-bookingid')) {
          bookingIdsArray.push(element.getAttribute('data-bookingid'));
          if (productType === 'SF') {
            var requestObject = JSON.parse(sfDataObj);
            $.each(requestObject.bookings, function (id, value) {
              if (element.getAttribute('data-bookingid') === value.bookingId && element.hasAttribute('data-qtyadded')) {
                value.qty = Number(element.getAttribute('data-qtyadded')) <= 2 ? Number(element.getAttribute('data-qtyadded')) : 2;
              }
            });
            sfDataObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(requestObject);
          }
        }
      });

      if ($('#cart-edit-' + productId + ' .custom-checkbox .guests-check input[type="checkbox"]').length) {
        $('#cart-edit-' + productId + ' .custom-checkbox .guests-check input[type="checkbox"]:checked').each(function (i, elem) {
          if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
            guestIdsArray.push(elem.getAttribute('data-guestid'));
          }
        });
      }

      var parentProductCode = null;
      if (productType === 'BUBBLES') {
        parentProductCode = $(e.currentTarget).attr('data-parentcode');
      }

      _this3.wishListMoveToCart(qty, productId, bookingIdsArray, guestIdsArray, null, productType, parentProductCode, sfDataObj);
    });
  },
  wishListMoveToCart: function wishListMoveToCart() {
    var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var productId = arguments[1];
    var bookingIdsArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var guestIdsArray = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var shoreExproductData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var productType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    var _this4 = this;

    var parentProductCode = arguments[6];
    var sfDataObj = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    var ajaxType = 'application/json';
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    var ajaxUrl = '';
    var token = $('#csrfSessionToken').data('csrf');
    var dataObj = {};

    if (productType === 'CHEERS' || productType === 'BUBBLES' || productType === 'FS' || productType === 'FSV' || productType === 'INTERNET' || productType === 'FTF') {
      ajaxUrl = '/shop/cart/add';
      ajaxType = 'application/x-www-form-urlencoded; charset=UTF-8';
      dataObj.CSRFToken = token;
      dataObj.productCodePost = productType === 'BUBBLES' ? parentProductCode : productId;
      dataObj.qty = quantity > 0 ? quantity : 1;
      dataObj.bookingIds = bookingIdsArray.length ? bookingIdsArray : [];
      dataObj.guestIds = guestIdsArray.length ? guestIdsArray : [];
    } else if (productType === 'SF' || productType === 'SFP' || productType === 'SFAP') {
      ajaxUrl = '/shop/cart/specialFS/add';
      dataObj = sfDataObj;
    } else if (shoreExproductData) {
      dataObj.productCard = shoreExproductData;
      dataObj.productId = productId;
      dataObj.wishList2Entry = true;
      ajaxUrl = '/shop/cart/shoreex/updateSelection';
      dataObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj);
    }

    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      contentType: ajaxType,
      headers: {
        CSRFToken: token
      },
      data: dataObj
    }).done(function (response) {
      // remove product from save for later section
      if (response.qtyAdded || response.addedToCart) {
        $('#saveForLaterCartSection .btn-remove-from-cart.btn-' + productId).addClass('backToCart').trigger('click');
        // if cart is empty then reload the cart page to get order summary section
        if ($('.cart-entries').length) {
          setTimeout(function () {
            _this4.loadCartSection();
          }, 500);
          _this4.updateCartCarousel();
        } else {
          window.location.reload();
        }
      }
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    });
  },
  loadCartSection: function loadCartSection() {
    var fbt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var ajaxUrl = fbt ? '/shop/cart' : '/shop/cart?ajax=true';
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      contentType: 'text/html'
    }).done(function (response) {
      // Update cart section
      var responseHtml = response;
      var cartEntries = $('<div> ' + responseHtml + '</div>').find('.cart-entries').html();
      $('.cart-entries').empty().html(cartEntries);
      CCL.editCartStateroom.createStateroomHtml();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    });
  },
  shoreExLoadWishlist: function shoreExLoadWishlist() {
    if ($('body').find('.moveToCart_ShoreEx').length) {
      $('body').find('.moveToCart_ShoreEx').each(function (index, val) {
        var productId = $(val).attr('data-productid');
        CCL.guestEditConflicts.cancel_addToCartAjax(productId, true);
      });
    }
  },
  ajaxForWishListUpdate: function ajaxForWishListUpdate() {
    var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var productId = arguments[1];
    var bookingIdsArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var guestIdsArray = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var shoreExproductData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    var token = $('#csrfSessionToken').data('csrf');
    var dataObj = {
      qty: quantity,
      productCode: productId,
      encryptedGuestIds: guestIdsArray,
      encryptedBookingIds: bookingIdsArray,
      variantInfo: shoreExproductData
    };
    $.ajax({
      type: 'POST',
      url: '/shop/cart/update/wishlist',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj)
    }).done(function (response) {
      // Update complate save for later section directly
      if (response.updateSuccess) {
        CCL.saveForLaterObj.loadSaveForLaterCartSection();
      }
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('QTY update from cart ajax success');
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('QTY update from cart ajax error');
    });
  },
  cartCruiseCashRestrictUser: function cartCruiseCashRestrictUser() {
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["ajaxForCruiseCashCartAmount"]().then(function () {
      $('body').find('.cruise-cash-cart-price').each(function (index, element) {
        $(element).parents('.cart-card-body').find('.cart-qty-increment-btn').removeAttr('disabled');
        if (Number($(element).parents('.cart-card-body').find('.base-price').data('baseprice')) + Number(localStorage.getItem('cruisecashcartamount')) > 500) {
          $(element).parents('.cart-card-body').find('.cart-qty-increment-btn').attr('disabled', 'disabled');
        }
      });
    });
  },
  ajaxForCartQty: function ajaxForCartQty(quantity, productId, event) {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    var token = $('#csrfSessionToken').data('csrf');
    var dataObj = {
      quantity: quantity,
      productId: productId
    };
    $.ajax({
      type: 'POST',
      url: '/shop/cart/update/quantity',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj)
    }).done(function (response) {
      var orderSummary = response.orderSummary;

      if ($(event.target).hasClass('cruise-cash-qty-increment-btn') || $(event.target).hasClass('cruise-cash-qty-decrement-btn')) {
        _this5.cartCruiseCashRestrictUser();
        CCL.saveForLaterObj.loadSaveForLaterCartSection();
      }
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCartSummary"](orderSummary);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateProductSummary"](orderSummary);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCouponSummary"](response);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('QTY update from cart ajax success');
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('QTY update from cart ajax error');
    });
  },
  toggleBundles: function toggleBundles() {
    var _this6 = this;

    $('.bundle-link').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        _this6.enable_ADA_ForGuests(element);
        var targetElement = $(event.target).parents('.c-cart-card').find('.bundle-card-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditGuestBeverage: function toggleEditGuestBeverage() {
    var _this7 = this;

    $('.edit-guest-beverage-link').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        _this7.enable_ADA_ForGuests(element);
        var targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-beverage-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditGuestSnorkel: function toggleEditGuestSnorkel() {
    var _this8 = this;

    $('.edit-guest-snorkel-link').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        _this8.enable_ADA_ForGuests(element);
        var targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-snorkel-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditTime: function toggleEditTime() {
    var _this9 = this;

    $('.edit-time-link').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        _this9.enable_ADA_ForGuests(element);
        var targetElement = $(event.target).parents('.c-cart-card').find('.edit-time-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleEditGuestTimeShorexCart: function toggleEditGuestTimeShorexCart() {
    var _this10 = this;

    // $('.edit-guest-time-shorex-cart-link').each((index, element) => {
    $('body').on('click', '.edit-guest-time-shorex-cart-link', function (event) {
      event.preventDefault();
      $(event.target).parents('.c-cart-card').find('.edit-guest-time-shorex-cart-link').toggleClass('open');
      _this10.enable_ADA_ForGuests(event.target);
      var targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-time-shorex-cart-wrap');
      $(targetElement).slideToggle();

      if (event.target.dataset.wishlist2entry === 'true' && event.target.dataset.productcode) {
        CCL.guestEditConflicts.cancel_addToCartAjax(event.target.dataset.productcode, event.target.dataset.wishlist2entry);
      }
    });
    // });
  },
  toggleEditGuestAirport: function toggleEditGuestAirport() {
    var _this11 = this;

    $('.edit-guest-airport-transfers-link').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        _this11.enable_ADA_ForGuests(element);
        var targetElement = $(event.target).parents('.c-cart-card').find('.edit-guest-airport-transfers-wrap');
        $(targetElement).slideToggle();
      });
    });
  },
  toggleCartEditStateroom: function toggleCartEditStateroom() {
    var _this12 = this;

    $('body').on('click', '.cart-edit-stateroom-link', function (event) {
      event.preventDefault();
      $('body').find('.cart-edit-stateroom-link').toggleClass('open');
      _this12.enable_ADA_ForGuests(event.currentTarget);
      var targetElement = $(event.target).parents('.c-cart-card').find('.cart-edit-stateroom-wrap');
      $(targetElement).slideToggle();
    });
  },
  removeProduct_DiningBtnClick: function removeProduct_DiningBtnClick() {
    var _this13 = this;

    $('body').on('click', '.dining-remove', function (e) {
      console.log('hi');
      var productId = $(e.currentTarget).attr('data-productId');
      var variantId = $(e.currentTarget).attr('data-variantid');
      var getProductDiv = '.card-' + variantId;
      $(getProductDiv).css('display', 'none');
      _this13.removeBtn_Dining_CartAjax(productId, variantId);
    });
  },
  enable_ADA_ForGuests: function enable_ADA_ForGuests(element) {
    var ariaExpanded = $(element).attr('aria-expanded');
    if (ariaExpanded === 'false') {
      $(element).attr('aria-expanded', 'true');
    } else {
      $(element).attr('aria-expanded', 'false');
    }
  },
  removeBtn_Dining_CartAjax: function removeBtn_Dining_CartAjax(productId, variantId) {
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    var jsonObjects = { productId: productId, variantCode: variantId };
    var token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/dining/removeBaseProduct',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonObjects),
      dataType: 'json',
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: function success(res) {
        if (res.removeSuccess) {
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCartSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateProductSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](res);
          // SAS Event for remove
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["sasEvents"]('send', res.cclSasAnalyticsJsonData);
          if (res.cartEmpty) {
            window.location.reload();
          }
          // update cart carousel
          if ($('body').find('.cart-carousel').length) {
            // update cart carousel
            CCL.cartCard.updateCartCarousel();
          }
          console.log('Something went well on Remove Click for Dining product ' + productId + ' ');
        } else {
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCartSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateProductSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          $('.card-' + variantId).css('display', 'block'); // Keep the card from DOM if RemoveSuccess is false
        }
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      },
      error: function error(_error2) {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong on Remove Click for Dining product ' + productId + ' ');
      }
    });
  },
  updateCss: function updateCss() {
    $('.c-edit-guest-beverage .stateroom').last().css('border-bottom', 'none');
  },
  updateCartCarousel: function updateCartCarousel() {
    var token = $('#csrfSessionToken').data('csrf');
    var componentUid = $('body').find('.cart-carousel #componentUid').data('componentuid');
    $.ajax({
      type: 'GET',
      url: '/shop/view/CCLProductCarouselComponentController?componentUid=' + componentUid,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      $('body').find('.cart-carousel').replaceWith(response);
      $('body').find('.cart-carousel .empty-placeholder').hide();
      $('body').find('.cart-carousel .product-carousel-container').show();
      CCL.cruiseManager.carouselFunctions();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__ = __webpack_require__(4);





/* eslint-disable */

CCL.pdpCard = {
  autoload: [['toggleDepartureTime', $('.departure-link').length > 0], ['btnClick', $('#calendarModal').length > 0], ['customClickEvents', $('#calendarModal').length > 0], ['toggleBookingDropdown', $('body').length > 0], ['toggleWheelChair', $('.wheel-chair0').length > 0], ['toggleSpecialService', $('.wheel-chair1').length > 0], ['pdpGetSelected', $('.pdp-add-to-cart-btn').length > 0], ['pdpReadError', $('.general-add-to-cart-btn').length > 0], ['addedToCartExperience', $('.pdp-conflict-check').length > 0], ['addedToCartExperienceForCarousel', $('body').length > 0], ['onCheckboxCheck', $('.custom-control.custom-checkbox.stateroom-check').length > 0], ['scrollToReviews', $('.c-pdp-card').length > 0], ['addStickyToAddToCart', $('.c-pdp-card').length > 0], ['ajaxForRecentView', $('.c-pdp-card').length > 0], ['toReviews', $('.c-product-card').length > 0], ['calendarModalEvents', $('#calendarModal').length > 0]],
  updatedIdArray: [],
  jsonData: {},
  currentUserId: '',
  currentResHoldId: '',
  productId: '',
  dataObj: {},
  calendarError: false,
  isCruisePass: false,

  ajaxForRecentView: function ajaxForRecentView() {
    var productId = $('body').find('.c-pdp-card').data('productcardid');
    if (productId && productId !== '') {
      var token = $('#csrfSessionToken').data('csrf');
      $.ajax({
        type: 'GET',
        url: '/shop/update/recentlyViewedProducts?productId=' + productId,
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      }).done(function (response) {
        console.log('Sent prod id of recently viewed');
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
        console.log('Error - prod id of recently viewed');
      });
    }
  },
  addedToCartExperienceForCarousel: function addedToCartExperienceForCarousel() {
    var _this = this;

    $('.pdp-carousel-atc').click(function (e) {
      if ($(e.currentTarget).hasClass('conflict-check-from-carousel')) {
        $('#addToCartSuccessModal .close').addClass('check-pdp-conflicts').addClass('reload-carousel');
        if (e.type === 'click' || e.keyCode === 13) {
          _this.dataObj.productCode = $('body').find('.c-pdp-card .btn-red.general-add-to-cart-btn').data('productcode');
        }
      } else {
        $('#addToCartSuccessModal .close').addClass('reload-carousel');
      }
    });

    $('body').on('click keypress', '.reload-carousel', function (e) {
      var token = $('#csrfSessionToken').data('csrf');
      var productId = $('body').find('.c-pdp-card .btn-red.general-add-to-cart-btn').data('productcode');
      var componentUid = $('body').find('.pdp-carousel #componentUid').data('componentuid');
      $.ajax({
        type: 'GET',
        url: '/shop/view/CCLProductCarouselComponentController?componentUid=' + componentUid + '&productId=' + productId,
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      }).done(function (response) {
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
        $('body').find('.pdp-carousel').replaceWith(response);
        $('body').find('.pdp-carousel .empty-placeholder').hide();
        $('body').find('.pdp-carousel .product-carousel-container').show();

        CCL.cruiseManager.carouselFunctions();
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
        console.log('error while fetching data');
      });
    });
  },
  addedToCartExperience: function addedToCartExperience() {
    var _this2 = this;

    $('.pdp-conflict-check').click(function (e) {
      $('#addToCartSuccessModal .close').addClass('check-pdp-conflicts');
      //  $('body').on('click keypress', '.pdp-conflict-check', (e) => {
      if (e.type === 'click' || e.keyCode === 13) {
        _this2.dataObj.productCode = $(e.currentTarget).data('productcode');
      }
    });

    $('body').on('click keypress', '.check-pdp-conflicts', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        $('#clpAddToCartModal #clpAddToCartModalContent').empty();
        _this2.checkPdpConflicts(_this2.dataObj);
      }
    });
  },
  checkPdpConflicts: function checkPdpConflicts(ajaxDataObj) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();

    var token = $('#csrfSessionToken').data('csrf');
    var ajaxUrl = '';
    var ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/clp-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }

    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(ajaxDataObj)
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      _this3.showPdpConflicts(response);
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  showPdpConflicts: function showPdpConflicts(response) {
    $.each(response.bookingInformation, function (index, value) {
      if (response.productType === 'SF') {
        $($('#' + value.bookingId)[0])[0].dataset.qty = response.bookingInformation[index].purchasedQuantity;
        if ($('.restrict-quantity').length > 0) {
          $('.restrict-quantity input .quantity-input-1').val('1');
          $('.alcohol-error-msg').hide();
        }
      }
      if (response.globalErrorMessage && response.globalErrorMessage !== '') {
        $($('#' + value.bookingId)[0].parentElement).find('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg').addClass('gray');
        if ($('.restrict-quantity').length > 0) {
          $('.restrict-quantity').hide();
          $('.terms-conditions-btn').attr('disabled', 'disabled');
        }
        if ($('.static-qty').length > 0) {
          $('.static-qty').hide();
        }
        $($('#' + value.bookingId)[0].parentElement).addClass('stateroom-disabled');
        $('#' + value.bookingId)[0].checked = false;
        $('#' + value.bookingId)[0].disabled = true;
        $($('#' + value.bookingId)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
        $('.error-msg-' + value.bookingId + ' span').html('');
        if (index === 0) {
          $('.inner-pdp-error-msg span').html('');
          $('.inner-pdp-error-msg').removeAttr('tabindex');
          $('.pdp-error-msg span').html('');
          $('.pdp-error-msg span').removeAttr('tabindex');
          $('.pdp-add-to-cart-btn').before('\n            <div class="inner-pdp-error-msg" role="alert" aria-live="assertive">\n            <span>\n                <div class="content">' + response.globalErrorMessage + '</div>\n            </span>\n            </div>');
        }
        $('.pdp-add-to-cart-btn').attr('disabled', 'disabled');
        $('.stateroom-check .booking-toggle').removeAttr('tabindex');
      } else {
        if (value.errorMessage) {
          var bookingId = $('#' + value.bookingId)[0].id;
          $('.error-msg-' + value.bookingId + ' span').html(value.errorMessage);
          $($('#' + value.bookingId)[0].parentElement).addClass('stateroom-disabled');
          $($('#' + value.bookingId)[0].parentElement).find('.booking-toggle').removeAttr('tabindex');
          $($('#' + value.bookingId)[0].parentElement).find('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg').addClass('gray');
          $($('#' + value.bookingId)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
          if (response.guestSelectable || response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP') {
            $.each(value.guestInformation, function (guestIndex, guestValue) {
              var guestCheckBox = '';
              if (response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP') {
                guestCheckBox = $('#' + guestValue.guestId);
              } else {
                guestCheckBox = $('#' + guestValue.guestId);
              }
              if (guestCheckBox.length > 0) {
                $(guestCheckBox)[0].checked = false;
              }
            });
          }
          $('#' + value.bookingId)[0].checked = false;
          $('#' + value.bookingId)[0].disabled = true;
        } else {
          // $(`#${value.bookingId}`)[0].checked = true;
          // $(`#${value.bookingId}`).attr('checked', 'checked');
          $('#' + value.bookingId).removeAttr('disabled');
        }
        if (value.guestInformation.length) {
          $.each(value.guestInformation, function (guestIndex, guestValue) {
            if (guestValue.errorText && !value.errorMessage && response.guestSelectable) {
              $('.error-msg-' + guestValue.guestId + ' span').html(guestValue.errorText);
              $($('#' + guestValue.guestId)[0].parentElement).addClass('stateroom-disabled');
              $($('#' + guestValue.guestId)[0].parentElement).addClass('div-disabled');
              $('#' + guestValue.guestId)[0].checked = false;
              $('#' + guestValue.guestId)[0].disabled = true;
              //  $($(`#${value.bookingId}`)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
            } else if (!guestValue.errorText && !value.errorMessage && (response.productType === 'SF' || response.productType === 'SFP' || response.productType === 'SFAP')) {
              // const bookingId = $(`#${value.bookingId}`)[0].id;
              // $(`#${bookingId + guestValue.guestId}`).removeAttr('disabled');

              if ($('#' + guestValue.guestId).length) {
                $('#' + guestValue.guestId)[0].disabled = false;
                $('#' + guestValue.guestId).removeAttr('disabled');
              }
            }
            if ((!guestValue.errorText || guestValue.errorText === '') && !(response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP')) {
              // $(`#${guestValue.guestId}`)[0].checked = true;
              // $(`#${guestValue.guestId}`).attr('checked', 'checked');
              if ($('#' + guestValue.guestId).length) {
                $('#' + guestValue.guestId)[0].disabled = false;
                $('#' + guestValue.guestId).removeAttr('disabled');
              }
            }
          });
          if (value.errorMessage) {
            $($('#' + value.bookingId)[0].parentElement).find('.booking-dropdown .guests-check input').attr('disabled', 'disabled').removeAttr('checked');
          } else if (!value.errorMessage && $($('#' + value.bookingId)[0].parentElement).find('.booking-dropdown .guests-check input:not(:checked)').length === $($('#' + value.bookingId)[0].parentElement).find('.booking-dropdown .guests-check input').length) {
            $('#' + value.bookingId)[0].checked = false;
            $('#' + value.bookingId).removeAttr('checked');
          }
        }
      }
    });
    this.pdpGetSelected();
  },
  pdpGetSelected: function pdpGetSelected() {
    __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["pdpGetSelectedData"]();
  },
  pdpReadError: function pdpReadError() {
    setTimeout(function () {
      $('.common-pdp-error-message').attr({ "role": "alert", "aria-live": "assertive" });
      $('.inner-pdp-error-msg').attr({ "role": "alert", "aria-live": "assertive" });
      $('.error-message').attr({ "role": "alert", "aria-live": "assertive" });
    }, 2000);
  },
  onCheckboxCheck: function onCheckboxCheck() {
    __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["checkboxCheck"]();
  },
  btnClick: function btnClick() {
    var _this4 = this;

    $('body').on('click keypress', '.calendarOpenBtn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        _this4.loadData(false, event);
      }
    });
  },
  calendarFocusable: function calendarFocusable() {
    setTimeout(function () {
      var calendar = $('#calendarModalHtml');
      if (calendar.length > 0) {
        calendar.find('.price-box').attr('tabindex', '0');
      }
    }, 1000);
  },
  addStickyToAddToCart: function addStickyToAddToCart() {
    var $addToCartParentEle = $('.general-add-to-cart-btn').parent('.inner-wrap');
    if ($(window).outerWidth() <= 768) {
      $addToCartParentEle.css({ 'position': 'sticky', 'z-index': '1', 'bottom': '0' });
    }
    $(window).resize(function () {
      if ($(window).outerWidth() <= 768) {
        $addToCartParentEle.css({ 'position': 'sticky', 'z-index': '1', 'bottom': '0' });
      } else {
        $addToCartParentEle.css({ 'position': '', 'z-index': '', 'bottom': '' });
      }
    });
  },


  /**
  * Ajax request to load all the calendar data
  */
  loadData: function loadData(userId, event) {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
    if (event) {
      this.productId = event.currentTarget.dataset.productcode;
    }
    var productId = this.productId ? this.productId : event.currentTarget.dataset.productcode;
    var uID = !userId ? 'default' : userId;
    var ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/c-spa-calendar/calendar-' + uID + '.json';
    } else {
      ajaxUrl = '/spa/getAvailability/' + uID + '/' + productId;
    }
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done(function (res) {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res).length !== 0 && res.constructor === Object && res.availability) {
        res.availability.currentUserId = res.availability.guestData.guestId;
        _this5.getData(res);
      } else if (res.error) {
        _this5.getData(res);
      }
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      console.log('Something went wrong');
    });
  },


  /**
  * get data from ajax request
  * @param {Object} data
  */
  getData: function getData(data) {
    var _this6 = this;

    if (data.availability) {
      $.each(data.availability.guestData.days, function (index, value) {
        value.hasSelectedTimings = false;
        value.treatments = value.treatments.sort(function (a, b) {
          return new Date(a.time) - new Date(b.time);
        });
        $.each(value.treatments, function (i, v) {
          v.addedTocart = false;
        });
      });
      var end = Number(data.availability.timeSlots.endTime.split(':')[0]);
      if (end <= 21) {
        end += 2;
      } else if (end <= 22) {
        end += 1;
      }
      var starttime = data.availability.timeSlots.startTime.split(':')[0] + ':00:00';
      var endtime = end + ':00:00';
      var interval = '60';
      var timeslots = [starttime];
      while (starttime !== endtime) {
        starttime = this.getTimeslots(starttime, interval);
        timeslots.push(starttime);
      }
      var tmpTime = [];
      $.each(timeslots, function (ind, val) {
        tmpTime.push(_this6.tConv24(val));
      });
      data.availability.updatedSlots = tmpTime;

      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
      $.each(data.availability.guestData.days, function (index, value) {
        $.each(value.treatments, function (i, v) {
          // set hasSeletedTiming = true to show small green dot on day
          if (v.addedToCart) {
            value.hasSelectedTimings = true;
          }
        });
        var d = new Date(value.date);
        value.date = monthNames[d.getMonth()] + ' ' + d.getDate();
      });

      if (data.availability.bookingInformation && data.availability.isCruisePass) {
        data.availability.description = 'Select your guest to book now!';
        $.each(data.availability.bookingInformation, function (bookingIndex, bookingValue) {
          $.each(bookingValue.guestInformation, function (guestIndex, guestValue) {
            var guest = data.availability.guests.filter(function (x) {
              return x.id === guestValue.guestId;
            })[0];
            if (guest) {
              guest.resHoldId = guestValue.resHoldId;
              guest.guestAdded = guestValue.guestAdded;
              guest.errorText = guestValue.errorText;
              if (guest.id === data.availability.guestData.guestId) {
                guest.selected = true;
              }
            }
          });
        });
      }
      if (window.location.pathname.includes('booked/home')) {
        data.availability.isCMPPage = true;
      } else {
        data.availability.isCMPPage = false;
      }
    }
    if (data.error) {
      this.calendarError = true;
    }
    if (data.availability && data.availability.isCruisePass) {
      this.isCruisePass = true;
    }
    this.jsonData = data;
    this.loadTemplate(data);
    // $('#calendarModal').modal();
    $('.loader').hide();
    $('#overlay').hide();
  },
  tConv24: function tConv24(time24) {
    var ts = time24;
    var H = +ts.substr(0, 2);
    var h = H % 12 || 12;
    h = h < 10 ? '0' + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? ' am' : ' pm';
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  },
  getTimeslots: function getTimeslots(time, minutes) {
    var date = new Date(new Date('01/01/2019 ' + time).getTime() + minutes * 60000);
    var one = date.getHours().toString().length === 1 ? '0' + date.getHours() : date.getHours();
    var two = date.getMinutes().toString().length === 1 ? '0' + date.getMinutes() : date.getMinutes();
    var three = date.getSeconds().toString().length === 1 ? '0' + date.getSeconds() : date.getSeconds();
    var tempTime = one + ':' + two + ':' + three;

    return tempTime;
  },


  /**
  * ajax request to load HTML template for spa-calendar
  * @param {Object} data
  */
  loadTemplate: function loadTemplate(data) {
    var _this7 = this;

    $('#calendarModal .custom-modal').removeClass('cruise-custom-modal');
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/c-spa-calendar/calendar.html'
    }).done(function (response) {
      var templateScript = __WEBPACK_IMPORTED_MODULE_2_handlebars_dist_handlebars_js__["compile"](response);
      var html = templateScript(data);
      $('#calendarHtml').empty().append(html);
      // call all javascript event after above html load
      if (data.availability && data.availability.isCruisePass || data.error) {
        $('#calendarModal .custom-modal').addClass('cruise-custom-modal');
      }
      $('#calendarModal').modal();
      $('#calendarModal .header-content .close').addClass('ada-element-focus');
      setTimeout(function () {
        $('#calendarModal .header-content .close').focus();
      }, 800);

      setTimeout(function () {
        $('.spa-error').attr('role', 'alert');
        $('.spa-error').attr('aria-live', 'assertive');
      }, 3000);
      if ($('.header-success-text').length) {
        setTimeout(function () {
          $('.header-success-text').attr('role', 'alert');
          $('.header-success-text').attr('aria-live', 'assertive');
        }, 3000);
      }
      _this7.clickEvents();
      // load crousel on dynamic html
      _this7.loadCarousel();
      _this7.calendarFocusable();
      _this7.modalEvents();
    }).fail(function () {
      console.log('Something went wrong');
    });
  },
  getFocusableElements: function getFocusableElements(modalEl, pos) {
    var tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled)';
    var firstFocusable = modalEl.find(tabbables).first();
    var lastFocusable = modalEl.find(tabbables).last();
    return pos === 'last' ? lastFocusable : firstFocusable;
  },
  customClickEvents: function customClickEvents() {
    var _this8 = this;

    $('body').on('click keypress', '#calendarModalHtml .userSelect-item', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        $('#calendarMenu')[0].innerText = e.currentTarget.innerText;
        $('.dropdown-menu button').removeClass('active');
        e.currentTarget.className += ' active'; // Append active class to selected
        _this8.loadData(e.currentTarget.id);
        _this8.currentUserId = e.currentTarget.id;
      }
    });

    $('body').on('click keypress', '.mobile-day', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        $('.mobile-day').css('border', '1px solid #ECECEC');
        e.currentTarget.style.border = '2px solid #10559A';
        var dayVal = $(e.currentTarget.children)[0].innerText;
        $('.mobile-day').removeAttr('aria-label');
        $('.mobile-day a').removeAttr('aria-label');
        var dayCount = $('.mobile-day').length;
        var currentPos = $(e.currentTarget)[0].id.substring(0, 1);
        $(e.currentTarget)[0].children[0].setAttribute('aria-live', 'assertive');
        $('.mobile-day').each(function (index) {
          $('#' + (index + 1) + '-mobile-day a').attr('aria-label', 'Day ' + (index + 1) + ' of ' + dayCount);
        });
        $(e.currentTarget)[0].children[0].setAttribute('aria-label', dayVal + ' selected ' + dayVal + ' of ' + dayCount);

        var position = $('.owl-carousel-7').find('.owl-item').eq(currentPos - 1);
        //this.getFocusableElements(position).focus();

        _this8.calendarFocusable();
      }
    });

    $('body').on('click keypress', '.header-atc-btn', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        _this8.cruisePassAddToCart(e);
      }
    });

    $('body').on('click keypress', '.price-box:not(.selected)', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        _this8.showSelected(e);
      }
      console.dir($($('#1-day')[0].previousElementSibling.previousElementSibling).attr('aria-label'));
    });
    $('body').on('click keypress', '.price-box .close', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        var currentTarget = e.currentTarget;

        e.preventDefault();
        e.stopPropagation();
        _this8.removeProduct(e);
        setTimeout(function () {
          $('#' + e.currentTarget.id).parent().focus();
        }, 600);
      }
    });
  },
  clickEvents: function clickEvents() {
    var _this9 = this;

    var dayCount = $('.mobile-day').length;
    $('.mobile-day').each(function (index) {
      $('#' + (index + 1) + '-mobile-day a').attr('aria-label', 'Day ' + (index + 1) + ' of ' + dayCount);
    });
    $('.mobile-day:first-child a').attr('aria-label', 'Day 1 selected day 1 of ' + dayCount);
    setTimeout(function () {
      $('.mobile-day').each(function (index, element) {
        if ($(element)[0].className == "mobile-day mobile-green-dot") {
          var MobLabel = $($('#' + (index + 1) + '-mobile-day')[0].firstElementChild).attr('aria-label');
          $($('#' + (index + 1) + '-mobile-day')[0].firstElementChild).attr('aria-label', MobLabel + ' has selected slots');
        }
      });
    }, 1000);
    if (this.jsonData.availability) {
      this.currentUserId = this.jsonData.availability.guestData.guestId;
      $.each(this.jsonData.availability.guestData.days, function (i, v) {
        if (v.treatments.some(function (x) {
          return x.addedTocart;
        })) {
          $('#checkoutButton').removeAttr('disabled');
        }
      });
    }
    // update data again on close click

    $('.price-box').each(function (index, val) {
      if (val.dataset.time) {
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var _val$dataset = val.dataset,
            duration = _val$dataset.duration,
            time = _val$dataset.time;

        var timeObj = new Date(time);
        var month = monthNames[timeObj.getMonth()]; // get month name from array
        // convert time into AM or PM format - Ex- 10:00 AM
        var appmTime = timeObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        $(val).find('.c-table-time').empty().html(appmTime.toLowerCase());
        var formattedDate = month + ' ' + timeObj.getDate() + ', ' + timeObj.getFullYear();
        // new Date(`${formattedDate} ${this.jsonData.availability.timeSlots.startTime}`);
        var dt1 = new Date(formattedDate + ' ' + _this9.jsonData.availability.timeSlots.startTime.split(':')[0] + ':00'); // Ex- November 29, 2018 8:00:00'
        var dt2 = timeObj;
        // Get difference in minutes between dates below
        var diff = (dt2.getTime() - dt1.getTime()) / 1000 / 60;
        var timeDiff = Math.abs(Math.round(diff)); // rounding off values
        val.style.top = timeDiff + 1 + 'px';
        val.style.height = val.dataset.duration - 2 + 'px';
        val.title = 'Time: ' + appmTime + ' - Duration: ' + duration + ' minutes';
        if (Number(duration) < 45) {
          val.classList.add('small-price-box');
        }
        if (Number(duration) >= 90 && Number(duration) < 100) {
          val.style.padding = '22px 2px 10px 20px';
        }
        if (Number(duration) > 90) {
          val.style.padding = '36px 2px 10px 20px';
        }
      }
    });
  },
  cruisePassAddToCart: function cruisePassAddToCart(event) {
    var _this10 = this;

    var resHoldId = event.currentTarget.dataset.resholdid;
    var userId = event.currentTarget.id;
    var currentTreatment = [];
    $.each(this.jsonData.availability.guestData.days, function (i, v) {
      var temp = v.treatments.filter(function (x) {
        return x.resHoldId === resHoldId;
      });
      if (temp.length) {
        currentTreatment = temp[0];
      }
    });
    var ajaxData = {
      CSRFToken: $('#csrfSessionToken').data('csrf'),
      resHoldId: resHoldId,
      spaGuestId: userId,
      quantity: 1,
      spaBundleEligible: currentTreatment.bundleEligible,
      spaProductPrice: currentTreatment.price.value,
      spaServiceDuration: currentTreatment.duration,
      productCodePost: currentTreatment.id,
      spaServiceDate: this.formatDate(currentTreatment.time),
      spaServiceTime: this.formatTime(currentTreatment.time)
    };
    var pageType = $('#pagetype').data('pagetype');
    ajaxData.pageType = pageType;
    if (pageType === 'CATEGORY') {
      ajaxData.productPosition = localStorage.getItem('productposition');
      ajaxData.pageNumber = localStorage.getItem('pageNumber');
      ajaxData.categoryName = localStorage.getItem('sascategorycode');
    }
    $.ajax({
      type: 'POST',
      url: '/shop/cart/add',
      data: ajaxData
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["updateHeaderCartWidget"](response);
      console.log('success');
      _this10.loadData(userId);
    }).fail(function () {
      //  gfunctions.hideLoader();
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showToast"]('#snackbar', 4000);
      console.log('Something went wrong on Add to Cart');
    });
  },
  removeProduct: function removeProduct(event) {
    var _this11 = this;

    __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
    var productId = $(event.currentTarget).data('productid');
    var token = $('#csrfSessionToken').data('csrf');
    var spaResHoldId = event.currentTarget.id;
    var dataObj = {
      productId: productId,
      spaResHoldId: spaResHoldId
    };
    $.ajax({
      type: 'POST',
      url: '/shop/cart/entry/execute-action/REMOVE',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj)
    }).done(function (response) {
      _this11.prepareData(event.currentTarget.parentElement.id, 'remove');
      $(event.currentTarget.parentElement).removeClass('selected');
      $(event.currentTarget).removeClass('.show-close').hide();
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      _this11.loadData(_this11.currentUserId);
      console.log('SPA remove success');
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showToast"]('#snackbar', 4000);
      console.log('SPA remove error');
    });
  },


  /**
  * load owl-carousel options
  */
  loadCarousel: function loadCarousel() {
    var _this12 = this;

    if (!__WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["detectmob"]()) {
      if (this.jsonData.availability) {
        var extraWidth = 0;
        if (this.jsonData.availability.guestData.days.length === 2) {
          extraWidth = 150;
        } else if (this.jsonData.availability.guestData.days.length === 3) {
          extraWidth = 100;
        } else if (this.jsonData.availability.guestData.days.length === 4) {
          extraWidth = 30;
        }
        var divWidth = this.jsonData.availability.guestData.days.length * 2 * 100 + extraWidth;
        $('.modal-body-wrapper').css('width', divWidth + 'px');
        $('.owl-carousel-7').owlCarousel({
          loop: false,
          nav: true,
          margin: 16,
          responsiveClass: true,
          autoWidth: true,
          mergeFit: false,
          dots: false,
          navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 3
            },
            1024: {
              items: 5
            },
            1200: {
              items: 7
            }
          }
        });
      }
    } else {
      $('.owl-carousel-7').owlCarousel({
        loop: false,
        nav: true,
        margin: 16,
        responsiveClass: true,
        dots: false,
        navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 3
          },
          1024: {
            items: 5
          },
          1200: {
            items: 7
          }
        },
        onDragged: function onDragged(e) {
          $('.mobile-day').css('border', '1px solid #ECECEC');
          $('#' + (e.item.index + 1) + '-mobile-day').css('border', '2px solid #10559A');
          _this12.calendarFocusable();
        }
      });
    }
  },


  /**
  * show/hide selected mark
  * @param {CustomEvent} e
  */
  showSelected: function showSelected(e) {
    var _this13 = this;

    var currentTarget = e.currentTarget;

    $(currentTarget).find('.c-table-time').hide();
    $(currentTarget).find('.c-table-price').hide();
    $(currentTarget).find('.loading-cart').css('display', 'flex');

    // TODO - need to write ajax POST data request here
    if (!$(currentTarget).hasClass('selected')) {
      var currentTreatment = void 0;
      $.each(this.jsonData.availability.guestData.days, function (index, value) {
        if (value.treatments.filter(function (x) {
          return x.uniqueId === currentTarget.id;
        }).length) {
          currentTreatment = value.treatments.filter(function (x) {
            return x.uniqueId === currentTarget.id;
          });
        }
      });
      // Preparing ajax data object for POST request
      var ajaxData = {
        productCodePost: currentTreatment[0].id,
        CSRFToken: $('#csrfSessionToken').data('csrf'),
        spaProductPrice: currentTreatment[0].price.value,
        quantity: 1,
        spaServiceDuration: currentTreatment[0].duration,
        spaServiceDate: this.formatDate(currentTreatment[0].time),
        spaServiceTime: this.formatTime(currentTreatment[0].time),
        spaBundleEligible: currentTreatment[0].bundleEligible.toString(),
        resHoldId: currentTreatment[0].resHoldId,
        spaGuestId: '' + this.currentUserId
      };
      var pageType = $('#pagetype').data('pagetype');
      ajaxData.pageType = pageType;
      if (pageType === 'CATEGORY') {
        ajaxData.productPosition = localStorage.getItem('productposition');
        ajaxData.pageNumber = localStorage.getItem('pageNumber');
        ajaxData.categoryName = localStorage.getItem('sascategorycode');
      }
      $.ajax({
        type: 'POST',
        url: '/shop/cart/add',
        data: ajaxData
      }).done(function (response) {
        if (response.addedToCart) {

          // Below if block is for YMALT carousel
          if ($('body').find('.cart-carousel').length) {
            $('#calendarHtml .close').addClass('refresh-window');
            $('#calendarHtml .modal').attr('data-keyboard', 'false');
          } else if ($('body').find('.pdp-carousel').length) {
            $('#calendarHtml .modal').attr('data-keyboard', 'false');
            $('#calendarHtml .close').addClass('reload-carousel');
          }
          $('#spaAddedAlert').empty().append('<span role=\'alert\'>Item Added To cart</span>');
          $(currentTarget).addClass('selected');
          $(currentTarget).attr('aria-Label', 'price ' + currentTarget.dataset.price + ' already added to cart');
          $(currentTarget).find('.close').show();
          $(currentTarget).find('.loading-cart').hide();
          if (Number(currentTreatment[0].duration) >= 45) {
            $(currentTarget).find('.c-table-time').show();
          }
          $(currentTarget).find('.c-table-price').show();
          _this13.prepareData(currentTarget.id, 'add');
          __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["updateHeaderCartWidget"](response);
        } else {
          __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showToast"]('#snackbar', 4000);
        }
      }).fail(function () {
        console.log('Something went wrong');
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showToast"]('#snackbar', 4000);
        $(currentTarget).find('.loading-cart').hide();
        if (Number(currentTreatment[0].duration) >= 45) {
          $(currentTarget).find('.c-table-time').show();
        }
        $(currentTarget).find('.c-table-price').show();
        $(currentTarget).removeClass('selected');
        $(currentTarget).find('.close').hide();
      });
    }
  },
  formatDate: function formatDate(date) {
    var today = new Date(date);
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return dd + '-' + mm + '-' + yyyy;
  },
  formatTime: function formatTime(time) {
    var today = new Date(time);
    var hours = today.getHours();
    var min = today.getMinutes();
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (min < 10) {
      min = '0' + min;
    }
    return hours + ':' + min;
  },


  /**
   * Prepare ajax data
   * @param {String} id
   * @param {String} action
   */
  prepareData: function prepareData(id, action) {
    var _this14 = this;

    $.each(this.jsonData.availability.guestData.days, function (i, v) {
      if (v.treatments.filter(function (x) {
        return x.uniqueId === id;
      }).length) {
        if (action === 'add') {
          v.treatments.filter(function (x) {
            return x.uniqueId === id;
          })[0].addedTocart = true;
          v.hasSelectedTimings = true;
          _this14.showGreenDot(v.id, 'add');
        } else {
          v.treatments.filter(function (x) {
            return x.uniqueId === id;
          })[0].addedTocart = false;
          if (v.treatments.some(function (time) {
            return time.addedTocart;
          })) {
            v.hasSelectedTimings = true;
            _this14.showGreenDot(v.id, 'add');
          } else {
            v.hasSelectedTimings = false;
            _this14.showGreenDot(v.id, 'remove');
          }
        }
      }
    });
    this.disableEnableCheckoutBtn();
  },


  /**
  * Disable or enable checkout btn
  */
  disableEnableCheckoutBtn: function disableEnableCheckoutBtn() {
    var temp = [];
    $.each(this.jsonData.availability.guestData.days, function (i, v) {
      if (v.treatments.some(function (x) {
        return x.addedTocart;
      })) {
        temp.push(true);
      }
    });
    // check if anything is added in cart then change checkout button
    if (temp.some(function (x) {
      return x;
    })) {
      $('#checkoutButton').removeAttr('disabled');
    } else {
      $('#checkoutButton').prop('disabled', true);
    }
  },


  /**
  * show/hide selected mark
  * @param {CustomEvent} e
  * @param {String} action
  */
  showGreenDot: function showGreenDot(id, action) {
    var mobileDayElement = $('#' + id + '-mobile-day');
    var desktopDayElement = $('#' + id + '-day');
    if (action === 'add') {
      if (!mobileDayElement.hasClass('mobile-green-dot')) {
        mobileDayElement.addClass('mobile-green-dot');
        var MobLabel = $($('#' + id + '-mobile-day')[0].firstElementChild).attr('aria-label');
        $($('#' + id + '-mobile-day')[0].firstElementChild).attr('aria-label', MobLabel + ' has selected slots');
      }
      if (!desktopDayElement.hasClass('has-selected-times')) {
        desktopDayElement.addClass('has-selected-times');
        var label = $($('#' + id + '-day')[0].previousElementSibling.previousElementSibling).attr('aria-label');
        $($('#' + id + '-day')[0].previousElementSibling.previousElementSibling).attr('aria-label', label + ' has selected slots');
      }
    } else {
      mobileDayElement.removeClass('mobile-green-dot');
      desktopDayElement.removeClass('has-selected-times');
      var label2 = $($('#' + id + '-day')[0].previousElementSibling.previousElementSibling).attr('aria-label');
      var finalLabel = label2.replace('has', '').replace('selected', '').replace('slots', '');
      $($('#' + id + '-day')[0].previousElementSibling.previousElementSibling).attr('aria-label', finalLabel);
    }
  },
  toggleDepartureTime: function toggleDepartureTime() {
    //  $('.departure-link').each((index, element) => {
    $('body').on('click keypress', '.departure-link', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        $('.departure-link').toggleClass('open');
        var targetElement = $(event.target).parents('.c-pdp-card').find('.departure-dropdown');
        if ($('.departure-link').hasClass('open')) {
          $('.departure-link a').attr('aria-label', 'View departure time expanded');
        } else {
          $('.departure-link a').attr('aria-label', 'View departure time collapsed');
        }
        $(targetElement).slideToggle();
        $('.departure-link a').addClass('ada-highlighted');
        setTimeout(function () {
          $('.departure-link a').focus();
        }, 400);
      }
    });
  },
  toggleWheelChair: function toggleWheelChair() {
    $('body').on('click keypress', '.wheel-chair-arrow0', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        var expanded = $(event.currentTarget).attr('aria-expanded');
        console.log(expanded);
        $('.wheel-chair-arrow0').toggleClass('open');
        var targetElement = $(event.target).parents('.c-pdp-card').find('.wheel-chair0 .wheel-chair-content');
        console.log('targetElement : ', $(targetElement));
        $(targetElement).slideToggle();
        if (expanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      }
    });
    // });
  },
  toggleSpecialService: function toggleSpecialService() {
    $('#wheel-chair1')[0].checked = true;
    // $('.wheel-chair-arrow1').each((index, element) => {
    $('body').on('click keypress', '.wheel-chair-arrow1', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        var expanded = $(event.currentTarget).attr('aria-expanded');
        console.log(expanded);
        $('.wheel-chair-arrow1').toggleClass('open');
        var targetElement = $(event.target).parents('.c-pdp-card').find('.wheel-chair1 .wheel-chair-content');
        $(targetElement).slideToggle();
        if (expanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      }
    });
    // });
  },
  toggleBookingDropdown: function toggleBookingDropdown() {
    $('body').on('click keypress', '.booking-toggle', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $(event.currentTarget.lastElementChild).toggleClass('open');
        // const targetElement = $(event.target).parents('.c-pdp-card').find('.booking-dropdown');
        $(event.currentTarget.nextElementSibling).slideToggle();
        var ariaExpanded = $(event.currentTarget).attr('aria-expanded');
        if (ariaExpanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      }
    });
  },
  scrollToReviews: function scrollToReviews() {
    $('.c-pdp-card .details-rating').on('click', function () {
      $('html, body').animate({
        scrollTop: $('#BVRRSearchContainer').offset().top
      }, 1200);
    });
    $(window).on('load', function () {
      $.ready.then(function () {
        // Both ready and loaded
        var tScroll = __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["get"]('scrollToTarget');
        if (tScroll) {
          var tDiv = '#' + tScroll;
          var scrollValue = $(tDiv).offset().top;
          if (tScroll) {
            $('html, body').animate({
              scrollTop: scrollValue
            }, 1200);
            __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["remove"]('scrollToTarget');
          }
        }
      });
    });
  },
  toReviews: function toReviews() {
    $('.c-product-card .rating, .c-product-card .be-first-to-review').on('click', function (event) {
      var scrollToTarget = $(event.currentTarget).data('scroll');
      __WEBPACK_IMPORTED_MODULE_3_js_cookie_src_js_cookie_js__["set"]('scrollToTarget', scrollToTarget);
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#calendarModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["getFocusableElements"](modalEl, 'last');
    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  },
  calendarModalEvents: function calendarModalEvents() {
    $('#calendarModal').on('shown.bs.modal', function (e) {
      var isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
      if (isOnIOS && isOnIOS.length && !CCL.pdpCard.calendarError && !CCL.pdpCard.isCruisePass) {
        // if (!this.calendarError || !this.isCruisePass) {
        $('body.modal-open').addClass('position-fixed-style');
      }
    });
    $('#calendarModal').on('hide.bs.modal', function (e) {
      var isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
      if (isOnIOS && isOnIOS.length && !CCL.pdpCard.calendarError && !CCL.pdpCard.isCruisePass) {
        // if (!this.calendarError || !this.isCruisePass) {
        $('body.modal-open').removeClass('position-fixed-style');
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(318);
module.exports = __webpack_require__(8).Object.keys;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(28);
var $keys = __webpack_require__(34);

__webpack_require__(141)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, __webpack_provided_window_dot_jQuery) {CCL.imageGallery = {
  autoload: [['imageGallery', $('.c-image-gallery').length > 0], ['getAriaLabel', $('.image-gallery-wrap').length > 0]],

  totalImagesCount: '',
  cuurentSlideCount: '',
  clickCount: 0,
  prevStart: 0,
  tabStarting: 1,
  currentSlideNo: 0,
  firstPrevClicked: false,

  getAriaLabel: function getAriaLabel() {
    setTimeout(function () {
      var listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
      if (listArray.length) {
        for (var i = 0; i < listArray.length; i++) {
          var imageName = listArray[i].querySelector('a img').getAttribute('alt');
          var current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
          $(listArray[i].querySelector('a')).attr('aria-label', imageName + ' of ' + listArray.length + ' ' + current);
        }
      }
    }, 300);
  },
  imageGallery: function imageGallery() {
    var _this = this;

    var slider = $('#c-image-gallery').lightSlider({
      gallery: true,
      item: 1,
      hybrid: true,
      // loop: true,
      hybridWidth: 656,
      vThumbWidth: 80,
      thumbItem: 9,
      thumbMargin: 8,
      slideMargin: 0,
      onBeforeStart: function onBeforeStart($el) {
        var srcImg = $el.find('li img').first().attr('data-src');
        var $img = $el.find('li img').first();
        $img.attr('src', srcImg);
        $img.css('display', 'initial');
      },
      onAfterSlide: function onAfterSlide($el, scene) {
        var $img = $el.find('img').eq($el.getCurrentSlideCount() - 1);
        var $imgSrc = $img.attr('data-src');
        $img.attr('src', $imgSrc);
        $img.css('display', 'initial');
        if ($el.getCurrentSlideCount() === 1) {
          $('.lSPrev').hide();
        } else if (Number($el.getCurrentSlideCount()) === Number($el.find('li').length)) {
          $('.lSNext').hide();
        } else {
          $('.lSPrev').show();
          $('.lSNext').show();
        }

        this.totalImagesCount = slider.getTotalSlideCount();
        this.cuurentSlideCount = slider.getCurrentSlideCount();
        if (this.cuurentSlideCount > 1 && this.totalImagesCount > 7) {
          // if max image count increases display up arrow
          $('#goToPrevSlide').css('display', 'block');
        } else {
          $('#goToPrevSlide').css('display', 'none');
        }
      },
      onSliderLoad: function onSliderLoad($el) {
        $('.lSPrev').hide();
        $('#c-image-gallery').removeClass('cS-hidden');

        $('.lSPager.lSGallery li a').on('click', function (e) {
          setTimeout(function () {
            if (document.querySelector('.image-gallery-wrap')) {
              var listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
              if (listArray.length) {
                for (var i = 0; i < listArray.length; i++) {
                  var imageName = listArray[i].querySelector('a img').getAttribute('alt');
                  var current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
                  $(listArray[i].querySelector('a')).attr('aria-label', imageName + ' of ' + listArray.length + ' ' + current);
                }
              }
            }
          }, 300);
        });
      }
    });

    this.totalImagesCount = slider.getTotalSlideCount();
    if (this.totalImagesCount > 7) {
      // if max image count increases display down arrow
      $('#goToNextSlide').css('display', 'block');
    } else {
      $('#goToNextSlide').css('display', 'none');
    }

    $('#goToNextSlide').on('focus', function (e) {
      var getCurrentImageCount = slider.getCurrentSlideCount();
      _this.totalSlides = slider.getTotalSlideCount();
      var itemlist = $('.lSPager.lSGallery li a img');
      _this.getAriaLabel();
      if (getCurrentImageCount + 1 === _this.totalSlides) {
        var item = itemlist[0].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + item + '. Next Slide 1 of ' + _this.totalSlides);
      } else if (getCurrentImageCount === _this.totalSlides) {
        var _item = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + _item + '. Next Slide 2 of ' + _this.totalSlides);
      } else if (getCurrentImageCount + 1 < _this.totalSlides) {
        var _item2 = itemlist[getCurrentImageCount + 1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + _item2 + '. Next Slide  ' + (getCurrentImageCount + 2) + ' of ' + _this.totalSlides);
      }
    });

    $('#goToNextSlide').on('click keypress', function (e) {
      var getCurrentImageCount = slider.getCurrentSlideCount();
      _this.totalSlides = slider.getTotalSlideCount();
      var itemlist = $('.lSPager.lSGallery li a img');
      _this.getAriaLabel();
      if (getCurrentImageCount + 1 === _this.totalSlides) {
        var item = itemlist[0].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + item + '. Next Slide 1 of ' + _this.totalSlides);
      } else if (getCurrentImageCount === _this.totalSlides) {
        var _item3 = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + _item3 + '. Next Slide 2 of ' + _this.totalSlides);
      } else if (getCurrentImageCount + 1 < _this.totalSlides) {
        var _item4 = itemlist[getCurrentImageCount + 1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + _item4 + '. Next Slide ' + (getCurrentImageCount + 2) + ' of ' + _this.totalSlides);
      }
      if (getCurrentImageCount === _this.totalImagesCount) {
        slider.goToSlide(0);
        _this.clickCount = 0;
        _this.tabStarting = 1;
        var visibleItems = e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelectorAll('li');
        for (var i = 0; i < visibleItems.length; i++) {
          visibleItems[i].querySelector('a').tabIndex = -1;
          visibleItems[i].classList.add('hiddenn');
        }
        for (var j = 0; j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
          visibleItems[j].querySelector('a').tabIndex = 0;
          visibleItems[j].classList.remove('hiddenn');
        }
      } else {
        _this.clickCount++;
        slider.goToNextSlide();
      }
      if (_this.clickCount >= 5) {
        var _visibleItems = e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelectorAll('li');
        if (Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) - 1 + _this.tabStarting <= _visibleItems.length - 1) {
          for (var _i = 0; _i < _visibleItems.length; _i++) {
            _visibleItems[_i].querySelector('a').tabIndex = -1;
            _visibleItems[_i].classList.add('hiddenn');
          }

          if (Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) - 1 + _this.tabStarting === _visibleItems.length - 1 && Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) === 7) {
            for (var _j = 0; _j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) - 1; _j++) {
              _visibleItems[_j + _this.tabStarting].querySelector('a').tabIndex = 0;
              _visibleItems[_j + _this.tabStarting].classList.remove('hiddenn');
            }
          } else {
            for (var _j2 = 1; _j2 < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); _j2++) {
              _visibleItems[_j2 + _this.tabStarting].querySelector('a').tabIndex = 0;
              _visibleItems[_j2 + _this.tabStarting].classList.remove('hiddenn');
            }
          }
          _this.tabStarting++;
        }
      }
    });

    $('#goToPrevSlide').on('focus', function (e) {
      var getCurrentImageCount = slider.getCurrentSlideCount();
      _this.totalSlides = slider.getTotalSlideCount();
      var itemlist = $('.lSPager.lSGallery li a img');
      _this.getAriaLabel();
      if (getCurrentImageCount === 1) {
        $(e.currentTarget).attr('aria-label', '');
      } else if (getCurrentImageCount === _this.totalSlides) {
        var item = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + item + '. Previous Slide 2 of ' + _this.totalSlides);
      } else if (getCurrentImageCount - 1 < _this.totalSlides) {
        var _item5 = itemlist[getCurrentImageCount - 2].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + _item5 + '. Previous Slide ' + (getCurrentImageCount - 1) + ' of ' + _this.totalSlides);
      }
    });

    $('#goToPrevSlide').on('click keypress', function (e) {
      slider.goToPrevSlide();
      _this.totalSlides = slider.getTotalSlideCount();
      var itemlist = $('.lSPager.lSGallery li a img');
      _this.getAriaLabel();
      if (_this.tabStarting !== 1) {
        _this.tabStarting--;
      }
      if (_this.clickCount !== 0) {
        _this.clickCount--;
      }
      var visibleItems = e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelectorAll('li');
      for (var i = 0; i < visibleItems.length; i++) {
        if (visibleItems[i] === e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelector('li.active')) {
          _this.prevStart = i;
        }
        if (visibleItems[i] === e.currentTarget.parentElement.querySelector(':scope > .lSSlideOuter').querySelector(':scope > .lSPager ').querySelector('li:not(.hiddenn)')) {
          _this.currentSlideNo = i;
        }
      }

      var getCurrentImageCount = slider.getCurrentSlideCount();
      _this.totalSlides = slider.getTotalSlideCount();
      if (getCurrentImageCount === 1) {
        $(e.currentTarget).attr('aria-label', '');
      } else if (getCurrentImageCount === _this.totalSlides) {
        var item = itemlist[1].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + item + '. Previous Slide 2 of ' + _this.totalSlides);
      } else if (getCurrentImageCount - 1 < _this.totalSlides) {
        var _item6 = itemlist[getCurrentImageCount - 2].getAttribute('alt');
        $(e.currentTarget).attr('aria-label', 'Go To ' + _item6 + '. Previous Slide ' + (getCurrentImageCount - 1) + ' of ' + _this.totalSlides);
      }
      // if (this.firstPrevClicked) {
      //   if (this.currentSlideNo === 1) {
      //     this.firstPrevClicked = false;
      //   }
      //   for (let i = 0; i < visibleItems.length; i++) {
      //     visibleItems[i].querySelector('a').tabIndex = -1;
      //     visibleItems[i].classList.add('hiddenn');
      //   }
      //   for (let j = (this.currentSlideNo - 1); j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
      //     visibleItems[j].querySelector('a').tabIndex = 0;
      //     visibleItems[j].classList.remove('hiddenn');
      //   }
      // }
      if (_this.prevStart > 3 && _this.prevStart < 7) {
        // this.firstPrevClicked = true;
        for (var _i2 = 0; _i2 < visibleItems.length; _i2++) {
          visibleItems[_i2].querySelector('a').tabIndex = -1;
          visibleItems[_i2].classList.add('hiddenn');
        }
        if (Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54) === 7 && _this.prevStart !== 4) {
          for (var j = 0; j < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); j++) {
            visibleItems[_this.currentSlideNo - 2 + j].querySelector('a').tabIndex = 0;
            visibleItems[_this.currentSlideNo - 2 + j].classList.remove('hiddenn');
          }
        } else {
          for (var _j3 = 0; _j3 < Math.floor(e.currentTarget.parentElement.querySelectorAll(':scope > .lSSlideOuter')[0].offsetHeight / 54); _j3++) {
            visibleItems[_this.currentSlideNo - 1 + _j3].querySelector('a').tabIndex = 0;
            visibleItems[_this.currentSlideNo - 1 + _j3].classList.remove('hiddenn');
          }
        }
      }
    });
  }
};

/* eslint-disable */

;
(function ($, window, document) {
  var vListFlag = true;
  $(document.body).on('click', function (e) {
    if (vListFlag && document.querySelector('.image-gallery-wrap')) {
      var listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
      if (listArray.length) {
        var arrayEnd = Math.floor(document.querySelectorAll('.lSSlideOuter')[0].offsetHeight / 54);
        for (var i = arrayEnd; i < listArray.length; i++) {
          listArray[i].querySelector('a').tabIndex = -1;
          listArray[i].classList.add("hiddenn");
        }
        // var pathname = window.location.pathname.split('/')
        for (var i = 0; i < listArray.length; i++) {
          var imageName = listArray[i].querySelector('a img').getAttribute('alt');
          var current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
          $(listArray[i].querySelector('a')).attr({ href: 'javascript:;', role: 'button' });
          $(listArray[i].querySelector('a')).attr('aria-label', imageName + ' of ' + listArray.length + ' ' + current);
        }
        vListFlag = false;
      }
    }
  });
  $(document.body).on('keyup', function (e) {

    if (vListFlag && document.querySelector('.image-gallery-wrap')) {
      var listArray = document.querySelectorAll('.lSSlideOuter .lSPager li');
      var arrayEnd = Math.floor(document.querySelectorAll('.lSSlideOuter')[0].offsetHeight / 54);
      for (var i = arrayEnd; i < listArray.length; i++) {
        listArray[i].querySelector('a').tabIndex = -1;
        listArray[i].classList.add("hiddenn");
      }
      // var pathname = window.location.pathname.split('/')
      if (listArray.length > 0) {
        for (var i = 0; i < listArray.length; i++) {
          var imageName = listArray[i].querySelector('a img').getAttribute('alt');
          var current = $(listArray[i]).hasClass('active') ? ' - Current Slide' : '';
          $(listArray[i].querySelector('a')).attr({ href: 'javascript:;', role: 'button' });
          $(listArray[i].querySelector('a')).attr('aria-label', imageName + ' of ' + listArray.length + ' ' + current);
        }
      }

      vListFlag = false;
    }
  });
})(window.Zepto || __webpack_provided_window_dot_jQuery, window, document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(3)))

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__ = __webpack_require__(4);




CCL.mainNav = {
  autoload: [['mobileMenu', $('.header').length > 0], ['bindsailingContextClick', $('.sailing-context .sailing-id').length > 0], ['mNavSearch', $('.search .m-nav-search').length > 0], ['categoryOverlay', $('#dropdown-categories').length > 0], ['searchResult', $('.search-results').length > 0]],
  timer: '',
  searchOptions: {
    minLength: 3,
    displayProductImages: true,
    delay: 1000,
    autocompleteUrl: ''
  },
  mobileMenu: function mobileMenu() {
    $('.menu-toggle').attr('aria-expanded', 'false');
    $('.menu-toggle').click(function () {
      $('.menu-toggle').attr('aria-expanded', 'true');
      $('body').toggleClass('menu-open');
    });
    $('.mobile-nav .close').click(function () {
      $('body').toggleClass('menu-open');
      $('.menu-toggle').focus().css('border', '2px solid #00b5cb');
      $('.menu-toggle').attr('aria-expanded', 'false');
    });
    $('.buy-mode .dropdown-menu').click(function (e) {
      e.stopPropagation();
    });
    $('.categories .dropdown-toggle').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        $(function () {
          $('.search-mob').focus();
        });
      }
    });
    $('.search-mob').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        $(function () {
          $('.cart-mob a').focus();
        });
      }
      if (event.keyCode === 9 && event.shiftKey) {
        $(function () {
          $('.categories .dropdown-toggle').focus();
        });
      }
    });
    $('.cart-mob a').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        $(function () {
          $('.my-cruise a').focus();
        });
      }
      if (event.keyCode === 9 && event.shiftKey) {
        $(function () {
          $('.search-mob').focus();
        });
      }
    });
    $('.my-cruise a').on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        $(function () {
          $('.cart-mob a').focus();
        });
      }
    });
  },
  bindsailingContextClick: function bindsailingContextClick() {
    $('.sailing-context .sailing-id').each(function (index, element) {
      if ($(element).hasClass('active')) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["remove"]('SailingContextCookie');
        __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["set"]('SailingContextCookie', $(element).data('code'));
      }
      $(element).on('click', function (event) {
        $('.sailing-context .sailing-id').removeClass('active');
        $(element).addClass('active');
        if (__WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["get"]('SailingContextCookie')) {
          __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["remove"]('SailingContextCookie');
          __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["set"]('SailingContextCookie', $(event.currentTarget).data('code'));
        } else {
          __WEBPACK_IMPORTED_MODULE_0_js_cookie_src_js_cookie_js__["set"]('SailingContextCookie', $(event.currentTarget).data('code'));
        }
        window.location.reload(true);
      });
    });
  },
  mNavSearch: function mNavSearch() {
    $('.search .m-nav-search').focus(function () {
      $('.search').addClass('focused');
    });
    $('.search .m-nav-search').focusout(function () {
      $('.search').removeClass('focused');
    });
    $('body').on('click keypress', '.category-overlay', function (e) {
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
      $('body').find('.search-results').hide();
    });
  },
  searchResult: function searchResult() {
    var _this = this;

    var option = $('#searchTopHeader').data('options');
    if (option) {
      this.searchOptions.minLength = option.minCharactersBeforeRequest;
      this.searchOptions.displayProductImages = option.displayProductImages;
      this.searchOptions.delay = option.waitTimeBeforeRequest;
      this.searchOptions.autocompleteUrl = option.autocompleteUrl;
    }

    $('#dropdown-categories').on('click', function (e) {
      $('.search-results').hide();
      $('body').removeClass('add-category-overlay');
      $('body').find('.category-overlay').remove();
    });

    $('#searchTopHeader').on('keyup', function (e) {
      var searchTerm = $('#searchTopHeader').val();
      var keycode = e.keyCode ? e.keyCode : e.which;
      if (searchTerm.length) {
        $('.search-clear-icon').show();
        if (keycode === 13) {
          _this.formQuery();
        } else {
          _this.triggerSearchCall();
        }
      } else {
        $('.search-clear-icon').hide();
        $('.search-results').hide();
        $('body').removeClass('add-category-overlay');
        $('body').find('.category-overlay').remove();
      }
    });

    $('.search-clear-icon').on('click keypress', function (e) {
      $('#searchTopHeader').val('');
      $('.search-clear-icon').hide();
      $('.search-results').hide();
      $('body').removeClass('add-category-overlay');
      $('body').find('.category-overlay').remove();

      $('#searchTopHeader').focus();
    });

    $('.mobile-search').hide();
    $('.search-mob').attr('role', 'button').attr('aria-expanded', 'false').attr('tabindex', '0');
    $('.search-mob').attr('aria-label', 'Search gifts and services');
    $('.search-mob a').attr('tabindex', '-1');
    $('.search-mob').on('click keypress', function (e) {
      if ($('.form-group.search').is(':visible')) {
        $('.search-mob').focus();
        $('.search-mob').attr('aria-expanded', 'false');
      } else {
        $('.m-nav-search').attr('aria-label', 'Search Text field. Type what you are looking for gifts and services');
        $('.search-mob').attr('aria-expanded', 'true');
      }
      $('.form-group').toggle();
      $('.m-nav-search').focus();
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
      $('body').find('.search-results').hide();
    });

    $('.search .search-link').on('click keypress', function (e) {
      var searchTerm = $('#searchTopHeader').val();
      if (searchTerm.length) {
        _this.formQuery();
      }
    });

    $('body').on('click keypress', '.search-results .suggested-item', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        $('#searchTopHeader').val(e.currentTarget.innerText);
        _this.formQuery();
      }
    });
  },
  formQuery: function formQuery() {
    var search = $('#searchTopHeader').val();
    var patt = new RegExp(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]+$/i);
    if (!patt.test(search)) {
      search = encodeURIComponent(search.replace(/[/\\#+()$~%.,'":*?<>{}]/g, '').toLocaleLowerCase());
    }
    window.location = '/shop/search?text=' + search;
  },
  triggerSearchCall: function triggerSearchCall() {
    var searchTerm = $('#searchTopHeader').val();
    clearTimeout(this.timer); // clear timer
    if (searchTerm.length >= this.searchOptions.minLength) {
      this.timer = setTimeout(this.triggerSearch, this.searchOptions.delay);
    }
  },
  triggerSearch: function triggerSearch() {
    var searchTermNew = $('#searchTopHeader').val();
    // Atleast on letter + atleast one number
    var patt = new RegExp(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]+$/i);
    if (!patt.test(searchTermNew)) {
      searchTermNew = encodeURIComponent(searchTermNew.replace(/[/\\#+()$~%.,'":*?<>{}]/g, '').toLocaleLowerCase());
    }
    var url = $('#searchTopHeader').data('options');
    var ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/search/search-suggestion.json';
    } else {
      ajaxUrl = url.autocompleteUrl + '?term=' + searchTermNew;
    }
    $.ajax({
      type: 'GET',
      contentType: 'application/json',
      url: ajaxUrl,
      dataType: 'json'
    }).done(function (res) {
      if (res.products.length || res.suggestions.length) {
        $('body').find('.category-overlay').remove();
        $('body').append('<div class="category-overlay"><div>');
        $('body').addClass('add-category-overlay');
        // Trigger ajax to get the HTML
        $.ajax({
          type: 'GET',
          url: '/_ui/responsive/ccl/assets/templates/search/search-suggestion.html'
        }).done(function (response) {
          var templateScript = __WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js__["compile"](response);
          var html = templateScript(res);
          $('.search-results').empty().append(html);
          $('.search-results').fadeIn('fast');
          var i = 0;
          while ($('.suggested-item').eq(i).html() !== undefined) {
            if ($('.suggested-item').eq(i).html().indexOf(searchTermNew) !== -1 && $('.suggested-item').eq(i).html().indexOf(searchTermNew) === 0) {
              var searchSubstr = $('.suggested-item').eq(i).html().substr(0, searchTermNew.length);
              var concatSubstr = $('.suggested-item').eq(i).html().substr(searchTermNew.length);
              $('.suggested-item').eq(i).html('<b>' + searchSubstr + '</b>' + concatSubstr);
            }
            i++;
          }
          CCL.mainNav.focusOrder();
        }).fail(function () {
          __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
          console.log('error Occured');
        });
      }
    }).fail(function () {
      console.log('error Occured in search');
    });
  },
  focusOrder: function focusOrder() {
    var lastFocusItem = $('.product-suggestions .suggested-product-item').last();
    var lastFocus = lastFocusItem.find('.product-name a');
    // $('.search').on('keydown', (e) => {
    //   if ((e.keyCode === 9) && (e.shiftKey)) {
    //     e.preventDefault();
    //     $(lastFocus).focus();
    //   }
    // });
    $(lastFocus).on('keydown', function (e) {
      if (e.keyCode === 9 && !e.shiftKey) {
        e.preventDefault();
        $('.search').addClass('focused');
        $('.search .form-control').focus();
      }
    });
  },
  categoryOverlay: function categoryOverlay() {
    $('.categories.dropup').on('shown.bs.dropdown', function () {
      $('body').append('<div class="category-overlay"><div>');
      $('body').addClass('add-category-overlay');
    });
    $('.categories.dropup').on('hidden.bs.dropdown', function () {
      $('.category-overlay').remove();
      $('body').removeClass('add-category-overlay');
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.sortingCategory = {
  autoload: [
  // ['sorting', $('.sorting').length > 0],
  ['selectableDropdown', $('.sortby').length > 0]],

  // sorting() {
  //   let que = '';
  //   $('.sorting').change((event) => {
  //     que = '';
  //     if ($.query.get('page')) {
  //       $.query.REMOVE('page');
  //     }
  //     if ($.query.get('page')) {
  //       que = $.query.set('sort', $('.sorting option:selected').val());
  //     } else {
  //       que = $.query.set('sort', $('.sorting option:selected').val()).set('q', $(event.target).data('defaultsort'));
  //     }
  //     document.location.search = que;
  //   });
  // },
  selectableDropdown: function selectableDropdown() {
    $('.sortby .selected-item').click(function (e) {
      $('#sorting')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected

      var cuurentValue = $(e.currentTarget).data('query').trim();
      var selectedBtnValue = $(e.currentTarget).attr('value');
      var que = '';
      if ($.query.get('page')) {
        $.query.REMOVE('page');
      }
      if ($.query.get('page')) {
        que = $.query.set('sort', selectedBtnValue);
      } else {
        que = $.query.set('sort', selectedBtnValue).set('q', cuurentValue);
      }
      // $.query.set('q', $(e.target).data('query'));
      document.location.search = que;
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.facetCard = {
  autoload: [['filtering', $('.c-category-facets').length > 0],
  // ['rating', $('.facets-rating').length > 0],
  ['onFilterApplyBtn', $('.btn.btn-blue.btn-full').length > 0], ['onFilterCancelBtn', $('.btn.btn-blue-link.btn-full').length > 0], ['clickFacetHeader', $('.facet-header').length > 0]],

  finalQuery: '',
  firsttime: true,

  collapsing: function collapsing() {
    var cardDoms = document.getElementsByClassName('c-facet-card');

    var _loop = function _loop(p) {
      // Execute a function when the user releases a key on the keyboard
      document.getElementById('c-facet-card_'.concat(p)).addEventListener('keyup', function (event) {
        // Cancel the default action, if needed
        event.preventDefault();
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13) {
          if (event.path[1].className.indexOf('custom-checkbox') === -1) {
            // Trigger the button element with a click
            document.getElementById('c-facet-card-header_'.concat(p)).click();
          } else {
            event.path[0].checked = !event.path[0].checked;
            if ($.query.get('sort')) {
              $.query.REMOVE('sort');
            }
            if ($.query.get('page')) {
              $.query.REMOVE('page');
            }
            document.location.search = $.query.set('q', $(event.target).data('query'));
          }
        }
      });
    };

    for (var p = 1; p <= cardDoms.length; p++) {
      _loop(p);
    }
  },
  clickFacetHeader: function clickFacetHeader() {
    $('.facet-header').on('click keypress', function (element) {
      if (element.type === 'click' || element.keyCode === 13) {
        setTimeout(function () {
          $(element).css('background-color', 'white');
        }, 300);
      }
    });
  },
  filtering: function filtering() {
    var _this = this;

    $('.facet-query').change(function (event) {
      if ($.query.get('sort')) {
        $.query.REMOVE('sort');
      }
      if ($.query.get('page')) {
        $.query.REMOVE('page');
      }
      if (__WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["detectmob"]()) {
        if (_this.finalQuery) {
          if (event.target.checked) {
            var getCurrentQuery = '';
            getCurrentQuery = $(event.target).data('query');
            _this.finalQuery = getCurrentQuery.replace(':recommended', _this.finalQuery);
          } else {
            var getCurrQuery = '';
            getCurrQuery = $(event.target).data('query');
            var queryText = getCurrQuery.replace(':recommended', '').trim();
            if (_this.finalQuery.includes(queryText)) {
              _this.finalQuery = _this.finalQuery.split(queryText).join(''); // remove filter query if checkox un checked
            }
          }
        } else {
          _this.finalQuery = $(event.target).data('query');
        }
        console.log(_this.finalQuery);
      } else {
        document.location.search = $.query.set('q', $(event.target).data('query'));
      }
    });

    $('body').on('click keypress', '.view-more-destination', function (e) {
      console.log('view-more-destination');
      if (!$(e.currentTarget).hasClass('expanded')) {
        $(e.currentTarget).attr('aria-expanded', true);
        $(e.currentTarget).addClass('expanded');
        $(e.currentTarget).prev().addClass('expanded-section');
        $(e.currentTarget).attr('aria-label', 'View Less ' + e.currentTarget.dataset.type + ' destinations');
        $(e.currentTarget.parentElement).find('.custom-checkbox').each(function (index, element) {
          if (index + 1 > 10) {
            $(element).fadeIn('fast');
            $(element).removeAttr('tabindex');
            $(element).removeAttr('aria-hidden');
            $(element).find('input').removeAttr('tabindex');
            $(element).find('label').removeAttr('aria-hidden');
          }
        });
        $(e.currentTarget).html('View Less');
      } else {
        $(e.currentTarget).attr('aria-expanded', false);
        $(e.currentTarget).removeClass('expanded');
        $(e.currentTarget).prev().removeClass('expanded-section');
        $(e.currentTarget).attr('aria-label', 'View More ' + e.currentTarget.dataset.type + ' destinations');
        _this.firsttime = true;

        $(e.currentTarget.parentElement).find('.custom-checkbox').each(function (index, element) {
          if (index + 1 > 10) {
            $(element).fadeOut('fast');
            $(element).attr('tabindex', '-1');
            $(element).attr('aria-hidden', 'true');
            $(element).find('input').attr('tabindex', '-1');
            $(element).find('label').attr('aria-hidden', 'true');
          }
        });
        $(e.currentTarget).html('View More');
      }

      $(e.currentTarget).addClass('ada-element-focus');
      setTimeout(function () {
        $(function () {
          $(e.currentTarget).focus();
        });
      }, 100);
    });

    $('body').on('keydown', '.view-more-destination', function (e) {
      if ($(e.currentTarget).hasClass('expanded') && _this.firsttime === true) {
        e.preventDefault();
        if (Number(e.which) === 9) {
          $(e.currentTarget).parents('.facet-collapse-section').find('.facet-checkbox-div:nth-child(11) input').focus();
          _this.firsttime = false;
        }
      }
    });
    $('body').on('click', '.expand-facet-section', function (e) {
      var parentSection = $(e.currentTarget.parentElement).prev();
      if (!$(e.currentTarget).hasClass('expanded')) {
        $(e.currentTarget).addClass('expanded');
        $(e.currentTarget).prev().addClass('expanded-section');
        $(e.currentTarget).html('View Less');
        $(e.currentTarget).attr('aria-label', 'View Less ' + e.currentTarget.dataset.type + ' expanded link');
        $(e.currentTarget.parentElement.parentElement).find('.custom-checkbox').each(function (index, element) {
          if (index + 1 > 20) {
            $(element).fadeIn('slow');
            $(element).removeAttr('tabindex');
            $(element).removeAttr('aria-hidden');
            $(element).find('input').removeAttr('tabindex');
            $(element).find('label').removeAttr('aria-hidden');
          }
        });
        $('html, body').animate({
          scrollTop: parentSection.offset().top + (parentSection[0].clientHeight - 100)
        }, 200);
      } else {
        $(e.currentTarget).removeClass('expanded');
        $(e.currentTarget).prev().removeClass('expanded-section');
        $(e.currentTarget).html('View More');
        $(e.currentTarget).attr('aria-label', 'View More ' + e.currentTarget.dataset.type + ' collapsed link');
        $(e.currentTarget.parentElement.parentElement).find('.custom-checkbox').each(function (index, element) {
          if (index + 1 > 20) {
            $(element).fadeOut('slow');
            $(element).attr('tabindex', '-1');
            $(element).attr('aria-hidden', 'true');
            $(element).find('input').attr('tabindex', '-1');
            $(element).find('label').attr('aria-hidden', 'true');
          }
        });
        setTimeout(function () {
          $('html, body').animate({
            scrollTop: parentSection.offset().top + (parentSection[0].clientHeight - 100)
          }, 200);
        }, 800);
      }

      $(e.currentTarget).addClass('ada-element-focus');
      setTimeout(function () {
        $(function () {
          $(e.currentTarget).focus();
        });
      }, 100);
    });
  },
  onFilterApplyBtn: function onFilterApplyBtn() {
    $('.filter-btn-wrap .btn.btn-blue.btn-full').click(function (event) {
      $('.c-category-facets').hide();
    });
  },
  onFilterCancelBtn: function onFilterCancelBtn() {
    $('.filter-btn-wrap .btn.btn-blue-link.btn-full').click(function (event) {
      $('.c-category-facets').hide();
      $('.filter-btn').attr('aria-label', 'Filter button that contain options to see is collapsed');
      $('body').find('.filter-btn').focus();
    });
  },
  rating: function rating() {
    var self = this;
    var SelectedRating = sessionStorage.getItem('SelectedRating');
    if (!SelectedRating) {
      SelectedRating = 0;
    }
    var ratingText = SelectedRating < 5 ? SelectedRating + ' AND UP' : SelectedRating;
    $('.review').find('.review-text').text(ratingText);
    // sessionStorage.removeItem('SelectedRating');
    $('.facets-rating').starRating({
      starSize: 23,
      disableAfterRate: false,
      initialRating: SelectedRating,
      callback: function callback(currentRating, $el) {
        // make a server call here
      },
      onHover: function onHover(currentIndex, currentRating, $el) {
        var text = currentIndex < 5 ? currentIndex + ' AND UP' : currentIndex;
        $($el).parents('.review').find('.review-text').text(text);
      },
      onLeave: function onLeave(currentIndex, currentRating, $el) {
        var text = currentRating < 5 ? currentRating + ' AND UP' : currentRating;
        $($el).parents('.review').find('.review-text').text(text);
      },
      onClick: function onClick(currentRating, $el) {
        if ($.query.get('sort')) {
          $.query.REMOVE('sort');
        }
        if ($.query.get('page')) {
          $.query.REMOVE('page');
        }
        var rating = currentRating.toString();
        rating = rating.includes('.') ? rating.replace('.', '') : rating;
        sessionStorage.setItem('SelectedRating', rating);
        // for mobile
        if (__WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["detectmob"]()) {
          if (self.finalQuery) {
            var getCurrentQuery = '';
            getCurrentQuery = $($el).data('rating' + rating);
            var curQueryText = getCurrentQuery.replace(':recommended', '').trim();
            if (!self.finalQuery.includes(curQueryText)) {
              self.finalQuery = getCurrentQuery.replace(':recommended', self.finalQuery);
            } else {
              self.finalQuery = self.finalQuery.split(curQueryText).join('');
              self.finalQuery = self.finalQuery.concat(curQueryText);
            }
          } else {
            self.finalQuery = $($el).data('rating' + rating);
          }
          console.log(self.finalQuery);
        } else {
          document.location.search = $.query.set('q', $($el).data('rating' + rating));
        }

        var text = currentRating < 5 ? currentRating + ' AND UP' : currentRating;
        $($el).parents('.review').find('.review-text').text(text);
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.recipientInfoForm = {
  autoload: [['toggleDescription', $('.info-null').length > 0], ['selectableDropdown', $('.c-recipient-info-form').length > 0]],

  toggleDescription: function toggleDescription() {
    $('.info-null').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        var targetElement = $(event.target).parents('.info-null').find('.info-description');
        $(targetElement).slideToggle();
      });
    });
  },
  selectableDropdown: function selectableDropdown() {
    $('.booking-month .selected-item').click(function (e) {
      $('#sailingMonths')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.productDetails = {
  autoload: [['enableAddToCard', $('.flavor-wrap.selectable-wrap').length > 0]],

  enableAddToCard: function enableAddToCard() {
    // $('.general-add-to-cart-btn').attr('disabled', 'disabled');
    // const $activeElements = $('.flavor-wrap.selectable-wrap').find('.active');
    // const toDisableButton = $('#hideAddToCartButton').val();
    // if ($activeElements.length && !toDisableButton) {
    //   $('.general-add-to-cart-btn').removeAttr('disabled');
    // }
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

CCL.countryRegionMapping = CCL.countryRegionMapping || {};
CCL.checkoutPaymentCard = {
  /* eslint-disable */

  autoload: [['giftCardToggle', $('.toggle-btn').length > 0], ['initiateOnboardCredit', $('.onboard-credit').length > 0], ['addValidations', $('.payment-card-body').length > 0], ['shiftingWatermark', $('.payment-card-body').length > 0], ['validateCardDetails', $('.payment-card-body').length > 0], ['placeOrder', $('.payment-card-body').length > 0], ['checkInfo', $('.payment-card-body').length > 0], ['validateYtd', $('.zeroAmountPlaceOrder').length > 0]],

  expiry: false,
  creditChange: false,
  placeOrderDisable: false,
  reg: /^[0-9\\/]*$/, // regex to accept only numbers
  alphaNumReg: /^[- a-zA-Z0-9]{1,10}$/, //regex to accept both numbers, alphabets, space and -
  alphaReg: /^[a-zA-Z\s]*$/, // regex to accept only alphabets and space
  emailReg: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/, // regex to accept email
  phoneReg: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, // regex for phone number

  initiateOnboardCredit: function initiateOnboardCredit() {
    $('body').on('keydown', '.tooltip-onboard-credit', function (e) {
      if (Number(e.which) === 9 && !event.shiftKey && !(event.shiftKey && event.keyCode == 9)) {
        e.preventDefault();
        $('.tooltip-onboard-credit .tooltip_text').toggleClass('open');
        $('.tooltip-onboard-credit a').focus();
      }
    });
  },
  validateYtd: function validateYtd() {
    var _this = this;

    this.validateYtdInputs();
    $('#billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('blur, keyup', function (event) {
      _this.validateYtdInputs();
    });

    $('.zeroAmountPlaceOrder').click(function (e) {
      $("#silentOrderPostForm").submit();
    });
  },
  validateYtdInputs: function validateYtdInputs() {
    var email = $('#billTo_email').val();
    var fname = $('#billTo_firstName').val();
    var lname = $('#billTo_lastName').val();
    var phoneNo = $('#billTo_phoneNumberFormator').val();
    if (email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
      $('.zeroAmountPlaceOrder').removeAttr('disabled');
    } else {
      $('.zeroAmountPlaceOrder').attr('disabled', 'disabled');
    }
  },
  giftCardToggle: function giftCardToggle() {
    $('.toggle-btn').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        $('.gift-card-balance .error-msg').remove();
      });
    });

    $('.collapse-header').find('.toggle-btn').on('click', function (e) {
      CCL.checkoutPaymentCard.addCountryRegionData();
      if (e.currentTarget.getAttribute('aria-expanded') !== "false") {
        $('.gift-card-address').addClass('d-none');
      } else {
        $('.gift-card-address').removeClass('d-none');
      }
    });
  },
  addCountryRegionData: function addCountryRegionData() {
    if ($.isEmptyObject(CCL.countryRegionMapping)) {
      $.ajax({
        type: "GET",
        url: "/shop/checkout/multi/payment-method/country-region",
        dataType: "json",
        success: function success(data) {
          CCL.countryRegionMapping = data;
          CCL.checkoutPaymentCard.addCountries();
        }
      });
    } else {
      CCL.checkoutPaymentCard.addCountries();
    }
  },
  addCountries: function addCountries() {
    $.each(CCL.countryRegionMapping, function (index, countryData) {
      $('#gc-country').append('<option value="' + countryData["countryCode"] + '">' + countryData["countryName"] + '</option>');
    });
  },
  addValidations: function addValidations() {
    var _this2 = this;

    $(document).ready(function () {
      var appliedGiftcards = $('.add-gift-card');
      if (appliedGiftcards.length) {
        CCL.checkoutPaymentCard.addCountryRegionData();
      }
    });

    $(document).on('change', '#gc-country', function (e) {
      $('#gc-state').empty();
      $('#gc-state').parent().css('display', 'inline-block');
      var countryCode = $('#gc-country').val();
      if (!CCL.countryRegionMapping || !countryCode) return;

      $.each(CCL.countryRegionMapping, function (index, country) {

        if (country["countryCode"] === countryCode) {
          if ($.isEmptyObject(country["regions"])) {
            $('#gc-state').append('<option value="XX">Others</option>');
            $('#gc-state').val('XX');
            $('#gc-state').parent().css('display', 'none');
          } else {
            $.each(country["regions"], function (index, region) {
              $('#gc-state').append('<option value="' + region["regionCode"] + '">' + region["regionName"] + '</option>');
            });
          }
          return false;
        }
      });

      $('#gc-state').siblings(".floating-label").addClass('selectFocus');
      $('#gc-state').siblings(".floating-label").addClass('inputFocus');
      $('#gc-state').siblings(".floating-label").removeClass('inputBlur');

      //validation to disable place
      var inputValue = $('#gc-country').val();
      CCL.checkoutPaymentCard.inputEmptyAddressValidation(inputValue, e);
    });
    $('#billTo_firstName').attr('maxlength', '20');
    $('#billTo_lastName').attr('maxlength', '20');
    $('#billTo_phoneNumber').attr('maxlength', '10');
    $('#billTo_phoneNumberFormator').attr('maxlength', '14');
    $('.apply-total').prop('disabled', true);
    $('.gift-card-balance .btn-link').addClass('disable-link');
    $(document).ready(function () {
      $('.gw-proxy-number').attr('title', 'Card Number'); // Adding title to iframe
    });

    var phoneNumberValue = $('#billTo_phoneNumberFormator').val();
    if (phoneNumberValue && phoneNumberValue.length === 10) {
      phoneNumberValue = '(' + phoneNumberValue.slice(0, 3) + ') ' + phoneNumberValue.slice(3, 6) + '-'.concat(phoneNumberValue.slice(6));
      $('#billTo_phoneNumberFormator').val(phoneNumberValue);
    }

    $('#billTo_phoneNumberFormator').on('change', function (e) {
      var phoneNumberValue = $('#billTo_phoneNumberFormator').val();
      var tempNumberValue = phoneNumberValue.replace(/[^0-9]/g, "");
      if (phoneNumberValue) {
        phoneNumberValue = '(' + tempNumberValue.slice(0, 3) + ') ' + tempNumberValue.slice(3, 6) + '-'.concat(tempNumberValue.slice(6));
        $('#billTo_phoneNumberFormator').val(phoneNumberValue);
      }
    });

    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #cardNumber, #pinNumber, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('blur', function (e) {
      var inputValue = $('#' + e.currentTarget.id).val();
      _this2.inputEmptyValidation(inputValue, e);
      if (inputValue.length !== 0) {
        _this2.inputLengthValidation(inputValue, e);
      }

      if (e.currentTarget.id === 'card_expiryInfo' && !inputValue) {
        $('#' + e.currentTarget.id).parent().find('.floating-label').text('MM/YYYY');
      }
    });

    $('#card_expiryInfo').on('focus', function (e) {
      $('#' + e.currentTarget.id).parent().find('.floating-label').text('Expiration Date');
    });

    $('#gc-address, #gc-city, #gc-zip, #gc-country, #gc-state').on('blur', function (e) {
      var inputValue = $('#' + e.currentTarget.id).val();
      _this2.inputEmptyAddressValidation(inputValue, e);
      var orderValue = $('.order-summary-total').text();

      if (orderValue.toString() !== 'orderGCFulfilled') {
        _this2.inputLengthValidation(inputValue, e);
      }
    });

    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator, #cardNumber, #pinNumber, #gc-address, #gc-city, #gc-zip').on('blur', function (e) {
      if (e.currentTarget.parentElement.lastElementChild.style.cssText.split(' ')[1] === 'visible;') {
        var tempErVal = e.currentTarget.parentElement.lastElementChild.textContent;
        var tempAriaVal = $('#' + e.currentTarget.id).attr('aria-label');
        if (!tempAriaVal.includes(tempErVal)) {
          $('#' + e.currentTarget.id).attr('aria-label', tempAriaVal + ' ' + tempErVal);
        }
        e.currentTarget.parentElement.lastElementChild.removeAttribute('aria-live');
        e.currentTarget.parentElement.lastElementChild.removeAttribute('role');
      } else {
        if (!e.currentTarget.parentElement.lastElementChild.hasAttribute('aria-live')) {
          // if errors are already removed
          var ariaValueInput = $('#' + e.currentTarget.id).attr('aria-label');
          if (e.currentTarget.id != 'card_cvNumber' && e.currentTarget.id != 'pinNumber' && e.currentTarget.id != 'billTo_email' && e.currentTarget.id != 'gc-address' && e.currentTarget.id != 'gc-city' && e.currentTarget.id != 'gc-zip' && e.currentTarget.id != 'cardNumber') {
            var mainInputAriaValue = ariaValueInput.split(' ');
            var newAriaLabelValue = mainInputAriaValue[0] + ' ' + mainInputAriaValue[1];
            $('#' + e.currentTarget.id).attr('aria-label', '' + newAriaLabelValue);
            e.currentTarget.parentElement.lastElementChild.setAttribute('aria-live', 'assertive');
            e.currentTarget.parentElement.lastElementChild.setAttribute('role', 'alert');
          } else if (e.currentTarget.id === 'cardNumber') {
            var _mainInputAriaValue = ariaValueInput.split(' ');
            var _newAriaLabelValue = _mainInputAriaValue[0] + ' ' + _mainInputAriaValue[1] + ' ' + _mainInputAriaValue[1];
            $('#' + e.currentTarget.id).attr('aria-label', '' + _newAriaLabelValue);
            e.currentTarget.parentElement.lastElementChild.setAttribute('aria-live', 'assertive');
            e.currentTarget.parentElement.lastElementChild.setAttribute('role', 'alert');
          } else {
            var _mainInputAriaValue2 = ariaValueInput.split(' ');
            var _newAriaLabelValue2 = _mainInputAriaValue2[0];
            $('#' + e.currentTarget.id).attr('aria-label', '' + _newAriaLabelValue2);
            e.currentTarget.parentElement.lastElementChild.setAttribute('aria-live', 'assertive');
            e.currentTarget.parentElement.lastElementChild.setAttribute('role', 'alert');
          }
        }
      }
    });

    $("#billTo_phoneNumberFormator").on("paste", function (e) {
      setTimeout(function () {
        var inputValue = $('#' + e.currentTarget.id).val();
        if (inputValue.length === 10) {
          inputValue = '(' + inputValue.slice(0, 3) + ') ' + inputValue.slice(3, 6) + '-'.concat(inputValue.slice(6));
          $('#' + e.currentTarget.id).val(inputValue);
        }
      }, 1);
    });

    // Disabling place order if the field is not correct
    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #cardNumber, #pinNumber, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('keyup', function (e) {
      var inputValue = $('#' + e.currentTarget.id).val();
      _this2.inputEmptyValidation(inputValue, e);
      _this2.inputValidation(inputValue, e);

      if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 9) {
        if (e.which === 8) {
          inputValue = inputValue.substr(0, 8);
          $('#' + e.currentTarget.id).val(inputValue);
        }
      } else if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 5) {
        if (e.which === 8) {
          inputValue = inputValue.substr(1, 2);
          $('#' + e.currentTarget.id).val(inputValue);
        }
      }

      if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 3 && inputValue[0] != '(') {
        inputValue = '(' + inputValue + ') ';
        $('#' + e.currentTarget.id).val(inputValue);
      } else if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 9) {
        inputValue = inputValue + '-';
        $('#' + e.currentTarget.id).val(inputValue);
      }
      if (e.currentTarget.id === 'cardNumber') {
        if (!inputValue.match(/^\d+$/) || inputValue.length > 16 || inputValue.length < 6 || $('#pinNumber').val().length < 4 || $('#pinNumber').val().length > 4) {
          $('.apply-total').prop('disabled', true);
          $('.gift-card-balance .btn-link').addClass('disable-link');
          e.currentTarget.parentElement.lastElementChild.textContent = 'Should be 6-16 digits';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else {
          $('.gift-card-balance .btn-link').removeClass('disable-link');
          $('.apply-total').prop('disabled', false);
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
        }
      }

      if (e.currentTarget.id === 'pinNumber') {
        if (!inputValue.match(/^\d+$/) || inputValue.length < 4 || inputValue.length > 4 || !$('#cardNumber').val().length || !$('#cardNumber').val().match(/^\d+$/) || $('#cardNumber').val().length > 16 || $('#cardNumber').val().length < 6) {
          $('.gift-card-balance .btn-link').addClass('disable-link');
          $('.apply-total').prop('disabled', true);
          e.currentTarget.parentElement.lastElementChild.textContent = 'Should be 4 digits';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else {
          $('.gift-card-balance .btn-link').removeClass('disable-link');
          $('.apply-total').prop('disabled', false);
          e.currentTarget.parentElement.lastElementChild.textContent = 'Should be 4 digits';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
        }
      }
    });

    $('#gc-address, #gc-city, #gc-zip, #gc-country, #gc-state').on('keyup', function (e) {
      var inputValue = $('#' + e.currentTarget.id).val();
      _this2.inputEmptyAddressValidation(inputValue, e);
    });

    // Displaying error if the field contains text
    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #cardNumber, #pinNumber, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('keyup', function (e) {
      var inputValue = $('#' + e.currentTarget.id).val();
      _this2.inputEmptyValidation(inputValue, e);
      if (e.currentTarget.id === 'card_expiryInfo') {
        if (inputValue.length === 2) {
          if (inputValue > 0 && inputValue <= 12) {
            $('#card_expiryInfo').val(inputValue + '/');
            e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
            _this2.expiry = false;
          } else {
            _this2.expiry = true;
            e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Month';
            e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
          }
        }

        if (!_this2.expiry || inputValue.length === 0) {
          _this2.inputValidation(inputValue, e);
        }
      } else {
        _this2.inputValidation(inputValue, e);
      }
    });

    $('#gc-address, #gc-city, #gc-zip').on('keyup', function (e) {
      var inputValue = $('#' + e.currentTarget.id).val();
      if (e.currentTarget.id === 'gc-address') {
        $('#gc_form_street').val(inputValue);
      } else if (e.currentTarget.id === 'gc-city') {
        $('#gc_form_city').val(inputValue);
      } else if (e.currentTarget.id === 'gc-zip') {
        $('#gc_form_zipcode').val(inputValue);
      }

      _this2.inputAddressValidation(inputValue, e);
    });
  },
  inputAddressValidation: function inputAddressValidation(inputValue, e) {
    if (e.currentTarget.id === 'gc-address') {
      var regExPattern = /^[a-zA-Z0-9\-, ]+$/;
      if (!regExPattern.test(inputValue)) {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Address';
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        $('.placeOrder').attr('disabled', 'disabled');
      } else {
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      }
    } else if (!this.alphaNumReg.test(inputValue) && e.currentTarget.id === 'gc-zip') {
      e.currentTarget.parentElement.lastElementChild.textContent = 'Only Numerics Allowed';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    } else if (!this.alphaReg.test(inputValue) && e.currentTarget.id === 'gc-city') {
      if (inputValue.length !== 0) {

        e.currentTarget.parentElement.lastElementChild.textContent = 'Only Alphabets Allowed';
      }
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    } else {
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
    }
  },
  inputValidation: function inputValidation(inputValue, e) {
    if (!this.emailReg.test(inputValue) && e.currentTarget.id === 'billTo_email') {
      if (inputValue.length !== 0) {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Incorrect Email';
      }
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    } else if (!this.alphaReg.test(inputValue) && (e.currentTarget.id === 'billTo_firstName' || e.currentTarget.id === 'billTo_lastName')) {
      if (inputValue.length !== 0) {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Only Alphabets Allowed';
      }
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    } else if (!this.phoneReg.test(inputValue) && e.currentTarget.id === 'billTo_phoneNumberFormator') {
      if (inputValue.length !== 0) {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Phone Number';
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      }
      $('.placeOrder').attr('disabled', 'disabled');
    } else if (this.phoneReg.test(inputValue) && e.currentTarget.id === 'billTo_phoneNumberFormator') {
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      var unformatedNumber = inputValue.replace(/[^0-9]/g, "").slice(0, 10);
      $('#billTo_phoneNumber').val(unformatedNumber); // Form element which is in hidden state, when we click place order form will pick ph no from this
    } else if (!this.reg.test(inputValue) && e.currentTarget.id !== 'billTo_firstName' && e.currentTarget.id !== 'billTo_lastName' && e.currentTarget.id !== 'billTo_email' && e.currentTarget.id !== 'billTo_phoneNumberFormator' && e.currentTarget.id !== 'billTo_postalCode') {
      e.currentTarget.parentElement.lastElementChild.textContent = 'Only Numerics Allowed';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    } else {
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      if (e.currentTarget.id === 'card_expiryInfo' && inputValue.length === 7) {
        var currentDate = new Date();
        var dateFormat = inputValue.split('/');
        if (Number(dateFormat[0]) > 12) {
          e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Month';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
          $('.placeOrder').attr('disabled', 'disabled');
        } else if (Number(dateFormat[1]) < Number(currentDate.getFullYear()) || Number(dateFormat[1] > 2100)) {
          e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Year';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
          $('.placeOrder').attr('disabled', 'disabled');
        } else if (Number(dateFormat[1]) === Number(currentDate.getFullYear())) {
          if (Number(dateFormat[0]) < Number(currentDate.getMonth()) + 1) {
            e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Month';
            e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
            $('.placeOrder').attr('disabled', 'disabled');
          } else {
            $('#card_expirationMonth').val(dateFormat[0]);
            $('#card_expirationYear').val(dateFormat[1]);
          }
        } else {
          $('#card_expirationMonth').val(dateFormat[0]);
          $('#card_expirationYear').val(dateFormat[1]);
        }
      }
    }
  },
  inputEmptyValidation: function inputEmptyValidation(inputValue, e) {
    if (inputValue.length === 0) {
      // e.currentTarget.parentElement.lastElementChild.textContent = 'It is a required field';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
    }
    this.disablingPlaceOrder();
  },
  inputEmptyAddressValidation: function inputEmptyAddressValidation(inputValue, e) {
    if (inputValue.length === 0) {
      // e.currentTarget.parentElement.lastElementChild.textContent = 'It is a required field';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
    }
    this.disablingAdressPlaceOrder();
  },
  inputLengthValidation: function inputLengthValidation(inputValue, e) {
    if (e.currentTarget.parentElement.lastElementChild.style.cssText.split(' ')[1] != 'visible;') {
      if (inputValue.length < 7 && e.currentTarget.id === 'card_expiryInfo') {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Should be MM/YYYY';
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      } else if (inputValue.length < 3 && e.currentTarget.id === 'card_cvNumber') {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Should be 3 or 4 digits';
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      } else if (inputValue.length !== 4 && e.currentTarget.id === 'pinNumber') {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Should be 4 digits';
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      } else if ((inputValue.length > 16 || inputValue.length < 6) && e.currentTarget.id === 'cardNumber') {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Should be 6-16 digits';
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      }
    }
  },
  disablingPlaceOrder: function disablingPlaceOrder() {
    var _this3 = this;

    var iLength = false;
    $('.payment-card .user-input-wrp').find('input').each(function (index, e) {
      if (e.value.length === 0 && e.id !== 'card_accountNumber') {
        iLength = true;
      } else {
        if (e.value.length < 7 && e.id === 'card_expiryInfo') {
          iLength = true;
        } else if (e.value.length === 7 && e.id === 'card_expiryInfo') {
          var dateField = e.value.split('/');
          for (var i = 0; i < dateField.length; i++) {
            if (!_this3.reg.test(dateField[i])) {
              iLength = true;
            }
          }
        } else if ((e.value.length < 3 || !_this3.reg.test(e.value)) && e.id === 'card_cvNumber') {
          iLength = true;
        } else if ((e.value.length == 0 || !_this3.alphaNumReg.test(e.value)) && e.id === 'billTo_postalCode') {
          iLength = true;
        } else if ((e.value.length == 0 || !_this3.phoneReg.test(e.value)) && e.id === 'billTo_phoneNumberFormator') {
          iLength = true;
        } else if (!_this3.emailReg.test(e.value) && e.id === 'billTo_email') {
          iLength = true;
        } else if ((e.value.length == 0 || !_this3.alphaReg.test(e.value)) && e.id === 'billTo_firstName') {
          iLength = true;
        } else if ((e.value.length == 0 || !_this3.alphaReg.test(e.value)) && e.id === 'billTo_lastName') {
          iLength = true;
        }
        $('.gift-card-address').find('input').each(function (index, e) {
          var regExPattern = /^[a-zA-Z0-9\-, ]+$/;
          if (e.value.length !== 0 && !regExPattern.test(e.value) && e.id === 'gc-address') {
            iLength = true;
          }
        });

        $('.card-div').find('input').each(function (index, e) {
          if (e.value.length === 7 && e.id === 'card_expiryInfo') {
            var val = e.value.split('/');
            if (Number(val[0]) > 12 || Number(val[1]) > 2100) {
              iLength = true;
            }
          }
        });
      }
    });

    if (iLength) {
      $('.placeOrder').attr('disabled', 'disabled');
      var orderValue = $('.order-summary-total').text();
      var email = $('#billTo_email').val();
      var fname = $('#billTo_firstName').val();
      var lname = $('#billTo_lastName').val();
      var phoneNo = $('#billTo_phoneNumberFormator').val();
      if ((orderValue.toString() === 'orderGCFulfilled' || $('.order-summary-total')[0].dataset.obc === 'OBC') && email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
        $('.placeOrder').removeAttr('disabled');
      }
    } else {
      var appliedGiftcards = $('.add-gift-card');
      if (appliedGiftcards.length && !this.placeOrderDisable) {
        this.disablingAdressPlaceOrder();
      } else {
        $('.placeOrder').removeAttr('disabled');
      }
    }
  },
  disablingAdressPlaceOrder: function disablingAdressPlaceOrder() {
    var _this4 = this;

    var iLength = false;
    var orderValue = $('.order-summary-total').text();
    $('.gift-card-address').find('input, select').each(function (index, e) {
      if ((e.value.length === 0 || !_this4.alphaReg.test(e.value)) && e.id === 'gc-city') {
        iLength = true;
      } else if ((e.value.length === 0 || !_this4.alphaNumReg.test(e.value)) && e.id === 'gc-zip') {
        iLength = true;
      } else if (e.value.length === 0 && e.id === 'gc-zip') {
        iLength = true;
      } else if (e.value.length === 0 && (e.id === 'gc-country' || e.id === 'gc-state')) {
        iLength = true;
      } else if (e.value.length === 0) {
        iLength = true;
      }
    });

    if (iLength) {
      $('.gift-card-address .gift-card-title .error-message').css('display', 'inline-block');
      $('.placeOrder').attr('disabled', 'disabled');
    } else {
      $('.gift-card-address .gift-card-title .error-message').css('display', 'none');
      var _orderValue = $('.order-summary-total').text();
      var email = $('#billTo_email').val();
      var fname = $('#billTo_firstName').val();
      var lname = $('#billTo_lastName').val();
      var phoneNo = $('#billTo_phoneNumberFormator').val();
      if ((_orderValue.toString() === 'orderGCFulfilled' || $('.order-summary-total')[0].dataset.obc === 'OBC') && email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
        $('.placeOrder').removeAttr('disabled');
      } else {
        this.placeOrderDisable = true;
        this.disablingPlaceOrder();
      }
    }
  },
  shiftingWatermark: function shiftingWatermark() {
    var _this5 = this;

    $('.payment-card-body .user-input-wrp, .apply-promo .user-input-wrp, .gift-card-body .user-input-wrp').find('input').each(function (index, e) {
      var $targetElement = $('#' + e.id).parent().find('.floating-label');
      if (!e.value.length) {
        e.nextElementSibling.classList.add('inputBlur');
        e.nextElementSibling.classList.remove('inputFocus');
        if (e.id === 'card_expiryInfo') {
          $targetElement.attr('style', 'top:5px !important');
        } else if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:12px !important');
        }
      } else {
        e.nextElementSibling.classList.add('inputFocus');
        e.nextElementSibling.classList.remove('inputBlur');
        if (e.id === 'card_expiryInfo') {
          $targetElement.attr('style', 'top:-14px !important');
        } else if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:-4px !important');
        }
      }

      if (e.value.length) {
        if (!_this5.alphaReg.test(e.value) && (e.id === 'billTo_firstName' || e.id === 'billTo_lastName')) {
          e.parentElement.lastElementChild.textContent = 'Only Alphabets Allowed';
          e.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else if (!_this5.phoneReg.test(e.value) && e.id === 'billTo_phoneNumberFormator') {
          e.parentElement.lastElementChild.textContent = 'Invalid Phone Number';
          e.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else if (!_this5.emailReg.test(e.value) && e.id === 'billTo_email') {
          e.parentElement.lastElementChild.textContent = 'Incorrect Email';
          e.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        }
      }
    });

    $('.gift-card-body .user-input-wrp').find('select').each(function (index, e) {
      var $targetElement = $('#' + e.id).parent().find('.floating-label');
      if (!e.value.length) {
        e.nextElementSibling.classList.add('inputBlur', 'selectBlur');
        e.nextElementSibling.classList.remove('inputFocus', 'selectFocus');
      } else {
        e.nextElementSibling.classList.add('inputBlur', 'selectBlur');
        e.nextElementSibling.classList.remove('inputFocus', 'selectFocus');
        $targetElement.attr('style', 'top:13px !important');
      }
    });

    $('.payment-card-body .user-input-wrp, .apply-promo .user-input-wrp, .gift-card-body .user-input-wrp').find('input').on('focusout', function (e) {
      var $targetElement = $('#' + e.currentTarget.id).parent().find('.floating-label');
      if (!e.currentTarget.value.length) {
        e.currentTarget.nextElementSibling.classList.add('inputBlur');
        e.currentTarget.nextElementSibling.classList.remove('inputFocus');
        if (e.currentTarget.id === 'card_expiryInfo') {
          $targetElement.attr('style', 'top:5px !important');
        } else if (e.currentTarget.id === 'promo-id') {
          $targetElement.attr('style', 'top:12px !important');
        }
      }
    });

    $('.gift-card-body .user-input-wrp').find('select').on('focusout', function (e) {
      var $targetElement = $('#' + e.currentTarget.id).parent().find('.floating-label');
      if (!e.currentTarget.value.length) {
        _this5.inputEmptyAddressValidation(e.currentTarget.value, e);
        e.currentTarget.nextElementSibling.classList.add('inputBlur', 'selectBlur');
        e.currentTarget.nextElementSibling.classList.remove('inputFocus', 'selectFocus');
      } else {
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      }
    });

    $('.payment-card-body .user-input-wrp, .apply-promo .user-input-wrp, .gift-card-body .user-input-wrp').find('input').on('focus', function (e) {
      var $targetElement = $('#' + e.currentTarget.id).parent().find('.floating-label');
      e.currentTarget.nextElementSibling.classList.add('inputFocus');
      e.currentTarget.nextElementSibling.classList.remove('inputBlur');
      if (e.currentTarget.id === 'card_expiryInfo') {
        $targetElement.attr('style', 'top:-14px !important');
      } else if (e.currentTarget.id === 'promo-id') {
        $targetElement.attr('style', 'top:-4px !important');
      }
    });

    $('.gift-card-body .user-input-wrp').find('select').on('change', function (e) {
      if (!e.currentTarget.value.length) {
        _this5.inputEmptyAddressValidation(e.currentTarget.value, e);
      } else {
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      }
    });
    $('.gift-card-body .user-input-wrp').find('select').on('focus', function (e) {
      var $targetElement = $('#' + e.currentTarget.id).parent().find('.floating-label');
      e.currentTarget.nextElementSibling.classList.add('inputFocus', 'selectFocus');
      e.currentTarget.nextElementSibling.classList.remove('inputBlur', 'selectBlur');
    });
  },
  placeOrder: function placeOrder(e) {
    var _this6 = this;

    // After complete page load
    window.onload = function () {
      $('.c-checkout-payment-card .error-message').removeAttr('aria-live');
      $('.c-checkout-payment-card .error-message').removeAttr('role');
      setTimeout(function () {
        $('.c-checkout-payment-card .error-message').attr('aria-live', 'assertive');
        $('.c-checkout-payment-card .error-message').attr('role', 'alert');
      }, 3500);
    };

    $('.placeOrder, .placeOrderCartSummary').click(function (e) {
      var orderValue = $('.order-summary-total').text();
      var stateValue = $('#gc-state').val();
      var countryValue = $('#gc-country').val();
      var appliedGiftcards = $('.add-gift-card');
      if (orderValue.toString() === 'orderGCFulfilled' && appliedGiftcards.length || $('.order-summary-total').length && $('.order-summary-total')[0].dataset.obc === 'OBC') {
        $('#gc_form_state').val(stateValue);
        $('#gc_form_country').val(countryValue);

        $("#silentOrderPostForm").submit();
      } else {
        $('#gc_form_state').val(stateValue);
        $('#gc_form_country').val(countryValue);
        _this6.pay(e);
      }
    });
  },
  validateCardDetails: function validateCardDetails() {
    var self = this;
    PaymentSession.configure({

      fields: {
        // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
        card: {
          number: "#card_accountNumber"
        }
      },
      //SPECIFY YOUR MITIGATION OPTION HERE
      frameEmbeddingMitigation: ["javascript"],
      callbacks: {
        initialized: function initialized(response) {
          // HANDLE INITIALIZATION RESPONSE
        },
        formSessionUpdate: function formSessionUpdate(response) {
          // console.log(response);
          // HANDLE RESPONSE FOR UPDATE SESSION
          if (response.status) {
            if ("fields_in_error" == response.status) {
              console.log("Session update failed with field errors.");
              if (response.errors.cardNumber) {
                var $cardElement = $('#card_accountNumber').siblings(".inputErrorField");
                $cardElement.attr('role', 'alert');
                $cardElement.attr('aria-live', 'assertive');
                $cardElement.text('Card Number invalid or missing');
                $cardElement.attr('style', 'visibility:visible');
                console.log("Card number invalid or missing.");
                setTimeout(function () {
                  PaymentSession.setFocus('card.number');
                }, 3000);
              }
            } else if ("request_timeout" == response.status) {
              console.log("Session update failed with request timeout: " + response.errors.message);
            } else if ("system_error" == response.status) {
              console.log("Session update failed with system error: " + response.errors.message);
            } else if (response.status) {
              console.log(response);
              document.getElementById("tokenRes").value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response);
              $("#silentOrderPostForm").submit();
              console.log("Session updated with data: " + response.session.id);

              //check if the security code was provided by the user
              if (response.sourceOfFunds.provided.card.securityCode) {
                console.log("Security code was provided.");
              }

              //check if the user entered a Mastercard credit card
              if (response.sourceOfFunds.provided.card.scheme == 'MASTERCARD') {
                console.log("The user entered a Mastercard credit card.");
              }
            }
          } else {
            console.log("Session update failed: " + response);
          }
        }
      }
    });
    PaymentSession.onFocus(['card.number'], function (selector) {
      //handle focus event
      $(selector).css({
        'border': 'rgb(0, 181, 203) solid 3px'
      });
      $(selector).siblings('.floating-label').addClass('inputFocus');
      $(selector).siblings('.floating-label').removeClass('inputBlur');
    });

    PaymentSession.onChange(['card.number'], function (selector) {
      // console.log([PaymentSession]);
      self.creditChange = false;
    });

    PaymentSession.onBlur(['card.number'], function (selector) {
      //handle blur event
      $(selector).css({
        'border': 'none',
        'border-bottom': '1px solid #595959'
      });
      if (self.creditChange) {
        $(selector).siblings('.floating-label').addClass('inputBlur');
        $(selector).siblings('.floating-label').removeClass('inputFocus');
      }
    });
  },
  pay: function pay(event) {
    event.preventDefault();
    // UPDATE THE SESSION WITH THE INPUT FROM HOSTED FIELDS
    PaymentSession.updateSessionFromForm('card');
  },
  checkInfo: function checkInfo() {
    var _this7 = this;

    $('#billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('blur, keyup', function (e) {
      var orderValue = $('.order-summary-total').text();
      var email = $('#billTo_email').val();
      var fname = $('#billTo_firstName').val();
      var lname = $('#billTo_lastName').val();
      var phoneNo = $('#billTo_phoneNumberFormator').val();
      if ((orderValue.toString() === 'orderGCFulfilled' || $('.order-summary-total')[0].dataset.obc === 'OBC') && email.length && _this7.emailReg.test(email) && fname.length && _this7.alphaReg.test(fname) && lname.length && _this7.alphaReg.test(lname) && phoneNo.length && _this7.phoneReg.test(phoneNo)) {
        $('.placeOrder').removeAttr('disabled');
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__ = __webpack_require__(4);





CCL.checkoutGiftCard = {
  autoload: [['addGiftCard', $('.apply-total').length > 0], ['removeGiftCard', $('.c-gift-card').length > 0], ['getGiftCardBalance', $('.gift-card-balance').length > 0], ['obcCredit', $('.apply-obc-credit').length > 0]],
  targetElement: {},
  /* eslint-disable */
  alphaReg: /^[a-zA-Z\s]*$/, // regex to accept only alphabets and space
  emailReg: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/, // regex to accept email
  phoneReg: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, // regex for phone number
  /* eslint-enable */

  obcCredit: function obcCredit() {
    var _this = this;

    $('body').on('click', '.apply-obc-credit', function (event) {
      _this.applyObcCredit(event);
    });

    $('body').on('focus blur', '.ccl_tooltip button', function (event) {
      $('.tooltip-onboard-credit .tooltip_text').toggleClass('open');
    });
  },
  checkNameValidation: function checkNameValidation() {
    var email = $('#billTo_email').val();
    var fname = $('#billTo_firstName').val();
    var lname = $('#billTo_lastName').val();
    var phoneNo = $('#billTo_phoneNumberFormator').val();
    if (email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
      return true;
    }
    return false;
  },
  applyObcCredit: function applyObcCredit(event) {
    var _this2 = this;

    var ajaxUrl = '/shop/checkout/multi/payment-method/apply/obc';
    if ($(event.currentTarget).hasClass('remove')) {
      ajaxUrl = '/shop/checkout/multi/payment-method/remove/obc';
    }
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done(function (res) {
      if (res.orderSummary.obcApplied) {
        $('.order-summary-total').text('');
        $('.js-obc-message').html(res.orderSummary.appliedOBCAmountDescription);
        $('.gift-card-body').removeClass('disable-payment-div');
        $('.payment-card-body.card-div').removeClass('disable-payment-div');
        $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').removeAttr('tabindex').removeAttr('aria-disabled');
        $('.btn.placeOrder').attr('disabled', 'disabled');
        $(event.target).addClass('remove');
        $(event.target).html('Remove');
        $(event.target).attr('aria-label', 'Remove applied onboard credit');
        $('.obc-summary-container').removeClass('d-none');
        $('.obc-summary-container .cost-value').html('-$' + res.orderSummary.obcAmount.toFixed(2));
        if (Number(res.orderSummary.totalPriceWithTax) === 0) {
          $('.gift-card-body').addClass('disable-payment-div');
          $('.payment-card-body.card-div').addClass('disable-payment-div');
          $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').attr('tabindex', '-1').attr('aria-disabled', 'true');
          if (_this2.checkNameValidation()) {
            $('.btn.placeOrder').removeAttr('disabled');
          }
          $('.order-summary-total').attr('data-obc', 'OBC');
        }
        // Remove GIFT CARD on obc applied
        _this2.removeAllGC();
      } else {
        $('.js-obc-message').html(res.orderSummary.applicableOBCAmountDescription);
        $(event.target).removeClass('remove');
        $(event.target).html('Apply');
        $(event.target).attr('aria-label', 'Apply onboard credit');
        $('.obc-summary-container').addClass('d-none');
        $('.gift-card-body').removeClass('disable-payment-div');
        $('.payment-card-body.card-div').removeClass('disable-payment-div');
        $('.btn.placeOrder').attr('disabled', 'disabled');
        $('.order-summary-total').data('obc', '');
        $('.order-summary-total')[0].dataset.obc = '';
        $('body').find('#order-bal').hide();
        $('.gift-card-body').removeClass('disable-payment-div');
        $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').removeAttr('tabindex').removeAttr('aria-disabled');
        $('body').find('.gift-card-body').removeClass('gift-card-disabled');
      }
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](res.orderSummary);
      $(event.target).toggleClass('btn-outline-black');
      $(event.target).toggleClass('btn-link');
      CCL.checkoutPaymentCard.disablingPlaceOrder();
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      console.log('error occured on OBC flow');
    });
  },
  removeAllGC: function removeAllGC() {
    // Remove GIFT CARD on obc applied
    $('body').find('.add-gift-card').remove();
    $('body').find('.gift-card-body').removeClass('gift-card-disabled');
    $('body').find('#order-bal').hide();
    $('body').find('.gift-card-address').addClass('d-none');
    $('.gc-summary-container').addClass('d-none');
    $('.gc-summary-container .cost-value').html('');

    var $toggleButton = $('.toggle-btn');
    $toggleButton.removeClass('open');
    $toggleButton.addClass('collapsed');
    $toggleButton.removeAttr('aria-hidden');
    $toggleButton.attr('aria-expanded', 'false');
    $('body').find('.gift-card-body .collapse').removeClass('show');
  },
  addGiftCard: function addGiftCard() {
    var _this3 = this;

    $('body').on('click', '.apply-total', function (event) {
      event.preventDefault();
      _this3.targetElement = $(event.target).parents('.gift-card').find('.gift-card-title');
      _this3.submitGiftCard();
    });
  },
  removeGiftCard: function removeGiftCard() {
    var _this4 = this;

    $('body').on('click', '.remove-gift-card', function (e) {
      var currentGiftCardNumber = $(e.currentTarget).parent().find('.giftCardNumber')[0].textContent;
      _this4.removedCurrentGiftCard(currentGiftCardNumber);
      $(e.currentTarget).parent().remove();
    });
  },
  removedCurrentGiftCard: function removedCurrentGiftCard(giftCardNumber) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var token, endUrl, inputDataObj, responseData, orderSummary, disableGiftCardApply, orderGCFulfilled, appliedGiftCards, orderBalance, totalPrice, $toggleButton, $selectElement, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = $('#csrfSessionToken').data('csrf');
              endUrl = '/shop/checkout/multi/payment-method/remove/gift-card/' + giftCardNumber;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              _context.prev = 3;
              inputDataObj = {
                url: endUrl,
                type: 'GET',
                contentType: 'application/json',
                headers: {
                  CSRFToken: token
                }
              };
              _context.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 7:
              responseData = _context.sent;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](responseData.orderSummary);
              orderSummary = responseData.orderSummary;
              disableGiftCardApply = orderSummary.disableGiftCardApply, orderGCFulfilled = orderSummary.orderGCFulfilled, appliedGiftCards = orderSummary.appliedGiftCards, orderBalance = orderSummary.orderBalance, totalPrice = orderSummary.totalPrice;

              _this5.displayOrderBalance(totalPrice);
              $toggleButton = $('.toggle-btn');

              if (!orderGCFulfilled) {
                $('.order-summary-total').text('');
                // $('.placeOrder').attr('disabled', 'disabled');
              }
              if (!disableGiftCardApply) {
                $('.gift-card').find('.gift-card-body').removeClass('gift-card-disabled');

                if (!appliedGiftCards.length) {
                  $('#gift-card-bal').hide();
                  $('#order-bal').hide();
                  $('.gift-card-address').addClass('d-none');
                  $toggleButton.removeClass('open');
                  $toggleButton.addClass('collapsed');
                  $toggleButton.removeAttr('aria-hidden');
                  $toggleButton.attr('aria-expanded', 'false');
                  setTimeout(function () {
                    $toggleButton.addClass('ada-highlighted');
                    $toggleButton.focus();
                  }, 2000);
                  $('#giftCardCollapse').removeClass('show');
                  $('.gift-card-body .user-input-wrp').find('input').each(function (index, e) {
                    $('#' + e.id).val('');
                    var $inputElement = $('#' + e.id).parent().find('.floating-label');
                    $inputElement.removeClass('inputFocus');
                    $inputElement.addClass('inputBlur');
                  });
                  $('#gc-state').prop('selectedIndex', 0);
                  $selectElement = $('#gc-state').parent().find('.floating-label');

                  $selectElement.removeClass('inputFocus selectFocus');
                  $selectElement.addClass('inputBlur selectBlur');
                  // $selectElement.attr('style', 'top:31px !important');
                }
              }

              if (orderSummary.appliedGCAmount) {
                $('.gc-summary-container').removeClass('d-none');
                $('.gc-summary-container .cost-value').html('-$' + orderSummary.appliedGCAmount);
              } else {
                $('.gc-summary-container').addClass('d-none');
              }

              $('.payment-card-body.card-div').removeClass('disable-payment-div');
              $('.payment-card-body.card-div.disable-payment-div input, .payment-card-body.card-div.disable-payment-div a').removeAttr('tabindex');
              $('.btn.placeOrder').attr('disabled', 'disabled');

              CCL.checkoutPaymentCard.disablingPlaceOrder();
              $toggleButton.removeAttr('aria-hidden');
              $toggleButton.attr('aria-expanded', 'false');
              $toggleButton.removeAttr('tabindex');
              setTimeout(function () {
                $toggleButton.addClass('ada-highlighted');
                $toggleButton.focus();
              }, 2000);
              _context.next = 32;
              break;

            case 27:
              _context.prev = 27;
              _context.t0 = _context['catch'](3);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context.t0 };

              console.log(cartAPIError);

            case 32:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5, [[3, 27]]);
    }))();
  },
  displayOrderBalance: function displayOrderBalance(orderBalance) {
    console.log(orderBalance);
    if (orderBalance.trim() !== '') {
      var orderTotal = document.getElementById('order-bal');
      var orderTotalLabel = document.createTextNode(orderBalance);
      if (orderTotal.childNodes.length === 1) {
        orderTotal.appendChild(orderTotalLabel);
      } else if (orderTotal.childNodes.length > 1) {
        orderTotal.replaceChild(orderTotalLabel, orderTotal.childNodes[1]);
      }
      orderTotal.style.display = '';
    }

    /*
      We do not need to show order balance as per new req.
      so keeping all code as it is and just hiding it with js as of now
    */
    $('body').find('#order-bal').hide();
  },
  getGiftCardBalance: function getGiftCardBalance() {
    var _this6 = this;

    $('body').on('click', '.gift-card-balance .btn-link', function (e) {
      _this6.giftCardBalance();
    });
  },
  giftCardBalance: function giftCardBalance() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var code, pin, ajaxUrl, jsonData, inputDataObj, responseData, giftCardBal, gcBalLabel, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              code = document.getElementById('cardNumber').value;
              pin = document.getElementById('pinNumber').value;
              ajaxUrl = '/shop/checkout/multi/payment-method/check/gift-card/' + code + '/' + pin;
              jsonData = {};

              jsonData.giftCardNumber = code;
              jsonData.giftCardPin = pin;
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              $('.gift-card-balance .error-msg').remove();
              _context2.prev = 8;
              inputDataObj = {
                url: ajaxUrl,
                type: 'GET',
                contentType: 'application/json'
              };
              _context2.next = 12;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 12:
              responseData = _context2.sent;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              if (responseData.gcBalance) {
                giftCardBal = document.getElementById('gift-card-bal');
                gcBalLabel = document.createTextNode(responseData.gcBalance);

                if (giftCardBal.childNodes.length === 1) {
                  giftCardBal.appendChild(gcBalLabel);
                } else if (giftCardBal.childNodes.length > 1) {
                  giftCardBal.replaceChild(gcBalLabel, giftCardBal.childNodes[1]);
                }
                giftCardBal.style.display = '';
              } else {
                /* eslint-disable */
                if (responseData.errors && responseData.errors.errors.length) {
                  $.each(responseData.errors.errors, function (index, value) {
                    $('.gift-card-balance').append('<span class="error-msg">' + value.message + '</span>');
                  });
                }
                /* eslint-enable */
              }
              _context2.next = 22;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2['catch'](8);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context2.t0 };

              console.log(cartAPIError);

            case 22:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this7, [[8, 17]]);
    }))();
  },
  submitGiftCard: function submitGiftCard() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var code, pin, endUrl, token, jsonData, inputDataObj, responseData, orderSummary, errorMsg, appliedGiftCards, disableGiftCardApply, orderBalance, appliedGCAmount, totalPrice, i, currentGiftCard, giftCardNumber, formattedDeductedGiftCardAmount, formattedRemainingGiftCardAmount, $toggleButton, _$toggleButton, streetAddress, city, country, state, zip, cartAPIError;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              code = document.getElementById('cardNumber').value;
              pin = document.getElementById('pinNumber').value;
              endUrl = '/shop/checkout/multi/payment-method/add/gift-card/';
              token = $('#csrfSessionToken').data('csrf');
              jsonData = {
                cardNumber: code,
                pinNumber: pin
              };
              _context3.prev = 6;
              inputDataObj = {
                url: endUrl,
                type: 'POST',
                data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonData),
                contentType: 'application/json',
                headers: {
                  CSRFToken: token
                }
              };
              _context3.next = 10;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 10:
              responseData = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              $('#giftCardCollapse .user-input-wrp').find('input').each(function (index, e) {
                $('#' + e.id).val('');
                var $inputElement = $('#' + e.id).parent().find('.floating-label');
                $inputElement.removeClass('inputFocus');
                $inputElement.addClass('inputBlur');
              });
              orderSummary = responseData.orderSummary, errorMsg = responseData.errorMsg;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](orderSummary);
              appliedGiftCards = orderSummary.appliedGiftCards, disableGiftCardApply = orderSummary.disableGiftCardApply, orderBalance = orderSummary.orderBalance, appliedGCAmount = orderSummary.appliedGCAmount, totalPrice = orderSummary.totalPrice;

              _this8.displayOrderBalance(totalPrice);
              $('span.gift-card-error-message').remove();

              if (!errorMsg) {
                $('.gc-summary-container').removeClass('d-none');
                $('.gc-summary-container .cost-value').html('-$' + appliedGCAmount);
              }
              if (errorMsg) {
                $('.gift-card .gift-card-title').attr('role', 'alert');
                $('.gift-card .gift-card-title').attr('aria-live', 'assertive');
                $('.gift-card .gift-card-title').append($('<span class="gift-card-error-message error-message pl-4 ml-4" role="alert">' + errorMsg + '</span>'));
                $('#cardNumber').addClass('ada-element-focus');
                setTimeout(function () {
                  $('#cardNumber').focus();
                }, 3000);
              }
              $('div.add-gift-card').remove();
              $('#gift-card-bal').hide();
              for (i = 0; i < appliedGiftCards.length; i++) {
                currentGiftCard = appliedGiftCards[i];
                giftCardNumber = currentGiftCard.giftCardNumber, formattedDeductedGiftCardAmount = currentGiftCard.formattedDeductedGiftCardAmount, formattedRemainingGiftCardAmount = currentGiftCard.formattedRemainingGiftCardAmount;

                if (formattedRemainingGiftCardAmount.toString() === ('0' || '0.0')) {
                  $(_this8.targetElement).after('<div class="add-gift-card"><div><span class="name">Gift Card</span><span class="giftCardNumber">' + giftCardNumber + '</span></div><div><span class="name">Applied</span><span>$ ' + formattedDeductedGiftCardAmount + '</span><br><span class="remaining">Remaining on gift card:</span><span> $ 0.00</span></div><a href="javascript:;" aria-label="Remove applied gift card" class="remove-gift-card" style="color: #0056b3;">Remove</a></div>');
                } else {
                  $(_this8.targetElement).after('<div class="add-gift-card"><div><span class="name">Gift Card</span><span class="giftCardNumber">' + giftCardNumber + '</span></div><div><span class="name">Applied</span><span>$ ' + formattedDeductedGiftCardAmount + '</span><br><span class="remaining">Remaining on gift card:</span><span> $ ' + formattedRemainingGiftCardAmount + '</span></div><a href="javascript:;" aria-label="Remove applied gift card" class="remove-gift-card" style="color: #0056b3;">Remove</a></div>');
                }
              }
              $('.remove-gift-card').addClass('ada-highlighted');
              $('.remove-gift-card').focus();
              if (disableGiftCardApply || Number(orderSummary.totalPriceWithTax) === 0) {
                $('.gift-card').find('.gift-card-body').addClass('gift-card-disabled');
                $toggleButton = $('.toggle-btn');

                $toggleButton.removeClass('open');
                $toggleButton.addClass('collapsed');
                $toggleButton.attr('aria-hidden', 'true');
                $toggleButton.attr('tabindex', '-1');
                $toggleButton.attr('aria-expanded', 'false');
                $('#giftCardCollapse').removeClass('show');
              }
              if (orderSummary.orderGCFulfilled || Number(orderSummary.totalPriceWithTax) === 0) {
                $('.payment-card-body.card-div').addClass('disable-payment-div');
                $('.disable-payment-div input, .disable-payment-div a, .disable-payment-div iframe').attr('tabindex', '-1').attr('aria-disabled', 'true');
                $('.order-summary-total').text('orderGCFulfilled');
                _$toggleButton = $('.toggle-btn');

                _$toggleButton.removeClass('open');
                _$toggleButton.addClass('collapsed');
                // $toggleButton.addClass('ada-highlighted');
                // $toggleButton.focus();
                _$toggleButton.attr('aria-expanded', 'false');
                $('#giftCardCollapse').removeClass('show');
                setTimeout(function () {
                  $('.remove-gift-card').addClass('ada-highlighted');
                  $('.remove-gift-card').focus();
                }, 1000);
                streetAddress = document.getElementById('gc-address').value;
                city = document.getElementById('gc-city').value;
                country = document.getElementById('gc-country').value;
                state = document.getElementById('gc-state').value;
                zip = document.getElementById('gc-zip').value;

                if (country.length && streetAddress.length && city.length && state.length && zip.length && _this8.checkNameValidation()) {
                  $('.placeOrder').removeAttr('disabled');
                } else {
                  setTimeout(function () {
                    $('.gift-card-address .gift-card-title .error-message').remove();
                    $('.gift-card-address .gift-card-title').append($('<span class="error-message pl-4 ml-4" role="alert">Please enter address details</span>'));
                  }, 2000);
                  $('.placeOrder').attr('disabled', 'disabled');
                }
              } else {
                $('.placeOrder').attr('disabled', 'disabled');
              }
              // $('.placeOrder').attr('disabled', 'disabled');
              _context3.next = 34;
              break;

            case 29:
              _context3.prev = 29;
              _context3.t0 = _context3['catch'](6);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context3.t0 };

              console.log(cartAPIError);

            case 34:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this8, [[6, 29]]);
    }))();
  },
  sendGiftCardAddress: function sendGiftCardAddress() {
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    var country = document.getElementById('gc-country').value;
    var streetAddress = document.getElementById('gc-address').value;
    var city = document.getElementById('gc-city').value;
    var state = document.getElementById('gc-state').value;
    var zip = document.getElementById('gc-zip').value;
    var token = $('#csrfSessionToken').data('csrf');
    var jsonData = { country: country, streetAddress: streetAddress, city: city, state: state, zipCode: zip };
    $.ajax({
      type: 'POST',
      url: '/checkout/multi/payment-method/send/gc-address/',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonData),
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      success: function success(data) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
        console.log(data);
      },
      error: function error(_error) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
        console.log('inside error: ', _error);
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.giftLinkModal = {
  autoload: [['modalEvents', $('#giftLinkModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#giftLinkModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.removalCartModal = {
  autoload: [['modalEvents', $('#removalCartModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#removalCartModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.cheersAtcModal = {
  autoload: [['modalEvents', $('#cheersAtcModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#cheersAtcModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.cheersConflictModal = {
  autoload: [['modalEvents', $('#cheersConflictModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#cheersConflictModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.productUnavailableModal = {
  autoload: [['modalEvents', $('#productUnavailableModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#productUnavailableModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.enhancedLookupModal = {
  autoload: [['modalEvents', $('#enhancedLookupModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#enhancedLookupModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.orderSummary = {
  autoload: [['toggleCartSummaryItems', $('.items').length > 0], ['promoFunction', $('.promo-code-container').length > 0], ['enableDeliveryCheckoutButton', $('.general-onboard-delivery-title').length > 0], ['enableDeliveryPlaceOrderButton', $('.general-order-payment-section-title').length > 0]],

  maxCouponCount: 3,

  toggleCartSummaryItems: function toggleCartSummaryItems() {
    $('.items').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        var targetElement = $(event.target).parents('.c-order-summary').find('.summary-dropdown-wrap');
        $(targetElement).slideToggle();
        var ariaExpanded = $(event.currentTarget).attr('aria-expanded');
        if (ariaExpanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
          $(event.currentTarget).find('img').css('transform', 'rotate(180deg)');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
          $(event.currentTarget).find('img').css('transform', 'rotate(0deg)');
        }
      });
    });
  },
  promoFunction: function promoFunction() {
    var _this = this;

    if (!$('.promo-applied').length) {
      $('.another-promo').hide();
      $('.promo-code').show();
    }
    $(document.body).on('click keypress', '.promo-code', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        e.preventDefault();
        $(e.currentTarget).hide();
        $('.apply-promo').addClass('show');
        $('#promo-id').val('');
        $('.apply-promo-container').show();
        $('.another-promo').hide();
        $('.apply-promo .apply').addClass('div-disabled');
        setTimeout(function () {
          $('#promo-id').focus();
        }, 1000);
      }
    });

    $(document.body).on('click keypress', '.apply', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        _this.applyPromo(e);
      }
    });

    $('#promo-id').keyup(function (e) {
      if (e.currentTarget.value.length) {
        $(e.currentTarget.form.lastElementChild).removeClass('div-disabled');
      } else {
        $('.promo-code-container .error-msg').hide();
        $(e.currentTarget.form.lastElementChild).addClass('div-disabled');
      }
    });

    $(document.body).on('click', '.remove-promo', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        // make remove ajax call
        _this.removeCoupon(e);
      }
    });

    $(document.body).on('click', '.another-promo', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        $('.promo-code-container .error-msg').hide();
        $('#promo-id').val('');
        $('.apply-promo').addClass('show');
        $('.apply-promo-container').show();
        $('.another-promo').hide();
        $('.apply-promo .apply').addClass('div-disabled');
        setTimeout(function () {
          $('#promo-id').focus();
        }, 1000);
      }
    });
  },
  removeCoupon: function removeCoupon(e) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showLoader"]();
    var token = $('#checkoutCsrfToken').length ? $('#checkoutCsrfToken').data('csrf') : $('#csrfSessionToken').data('csrf');
    var voucherCode = e.currentTarget.dataset.promocode.toUpperCase();
    $.ajax({
      type: 'POST',
      url: '/shop/cart/remove/coupon',
      data: { voucherCode: voucherCode },
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
      if (response.couponRemoved) {
        // Remove GC on promo removed
        CCL.checkoutGiftCard.removeAllGC();
        // Remove OBC on promo removed
        _this2.removeOBC(response);
        $('.js-obc-message').html(response.orderSummary.applicableOBCAmountDescription);
        $('.disable-payment-div').removeClass('disable-payment-div');
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["updateCartSummary"](response.orderSummary);
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["updateProductSummary"](response.orderSummary);
        $('.row-' + voucherCode).remove();
        if ($('.promo-applied').length === _this2.maxCouponCount) {
          $('.another-promo').hide();
        } else {
          $('.another-promo').show();
        }

        if (!$('.promo-applied').length) {
          $('.another-promo').hide();
          $('.promo-code').show();
          $('.promo-code').attr('aria-live', 'assertive');
          setTimeout(function () {
            $('.promo-code').addClass('ccl-ada-focus');
            $('.promo-code').focus();
          }, 2000);
        }
      } else {
        $(e.currentTarget.parentElement.parentElement.parentElement).find('.remove-error-div').html(response.message).show();
      }
      console.log('remove promo code ajax success');
    }).fail(function (response) {
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
      console.log('remove promo code ajax error');
    });
  },
  removeOBC: function removeOBC(res) {
    if ($('.apply-obc-credit').hasClass('remove')) {
      $('.apply-obc-credit').addClass('btn-outline-black');
      $('.apply-obc-credit').removeClass('btn-link');
      $('.apply-obc-credit').removeClass('remove');
      $('.apply-obc-credit').html('Apply');
      $('.apply-obc-credit').attr('aria-label', 'Apply onboard credit');
      $('.obc-summary-container').addClass('d-none');
      var obcBeforeApplyMessage = $('#obcBeforeApplyMessage')[0].dataset.value;
      $('.onboard-credit-body .collapse-header div').html(obcBeforeApplyMessage);
      $('.btn.placeOrder').attr('disabled', 'disabled');
    }
  },
  applyPromo: function applyPromo(e) {
    var _this3 = this;

    var token = $('#checkoutCsrfToken').length ? $('#checkoutCsrfToken').data('csrf') : $('#csrfSessionToken').data('csrf');
    var voucherCode = $(e.currentTarget.parentElement).find('#promo-id').val().toUpperCase();
    __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'POST',
      url: '/shop/cart/apply/coupon',
      data: { voucherCode: voucherCode },
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
      if (response.couponApplied) {
        // remove GC on promo applied
        CCL.checkoutGiftCard.removeAllGC();

        // Remove OBC on promo applied
        _this3.removeOBC(response);

        $('.js-obc-message').html(response.orderSummary.applicableOBCAmountDescription);

        $('.apply-promo-container').hide();
        if (response.couponAmount) {
          response.couponAmount = response.couponAmount.toFixed(2);
          $('.promo-added').append('<div class="promo-applied row-' + voucherCode + '">\n            <div class="inner-promo-applied">\n              <div class="show-promo">PROMO:<span class="promo-code-text" aria-live="assertive" role="alert" aria-label="promo ' + voucherCode + ' applied">' + voucherCode + '</span>\n              <a href="#" class="remove-promo" aria-label="remove applied promo ' + voucherCode + '" data-promocode="' + voucherCode + '">Remove</a>\n              </div>\n              <div class="discount">-$' + response.couponAmount + '</div>\n            </div>\n            <div class="remove-error-div"></div>\n          </div>');

          $('.promo-added').show();
          $('.promo-added').find('.remove-promo').attr('aria-live', 'assertive');
          setTimeout(function () {
            $('.promo-added').find('.remove-promo').addClass('ccl-ada-focus');
            $('.promo-added').find('.remove-promo').focus();
          }, 3000);
        } else {
          $('.promo-added').append('<div class="promo-applied row-' + voucherCode + '">\n            <div class="inner-promo-applied">\n              <div class="show-promo">PROMO:<span class="promo-code-text"  aria-live="assertive" role="alert" aria-label="promo ' + voucherCode + ' applied">' + voucherCode + '</span>\n              <a href="#" class="remove-promo" aria-label="remove applied promo ' + voucherCode + '" data-promocode="' + voucherCode + '">Remove</a>\n              </div>\n              <div class="discount">$0.00</div>\n            </div>\n            <div class="remove-error-div"></div>\n          </div>');

          $('.promo-added').show();
          $('.promo-added').find('.remove-promo').attr('aria-live', 'assertive');
          setTimeout(function () {
            $('.promo-added').find('.remove-promo').addClass('ccl-ada-focus');
            $('.promo-added').find('.remove-promo').focus();
          }, 3000);
        }

        $('.another-promo').show();
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["updateCartSummary"](response.orderSummary);
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["updateProductSummary"](response.orderSummary);
        _this3.maxCouponCount = response.maxCouponCount;
        if ($('.promo-applied').length === _this3.maxCouponCount) {
          $('.another-promo').hide();
        } else {
          $('.another-promo').show();
        }
      } else {
        $('.error-msg').html(response.message).show();
        $('body').addClass('ccl-ada-focus');
        $('#promo-id').focus();
      }
      console.log('promo code ajax success');
    }).fail(function (response) {
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
      console.log('promo code ajax error');
    });
  },
  enableDeliveryCheckoutButton: function enableDeliveryCheckoutButton() {
    $('.c-order-summary').find('.btn-wrap').removeClass('d-none');
  },
  enableDeliveryPlaceOrderButton: function enableDeliveryPlaceOrderButton() {
    $('.c-order-summary').find('.place-order-info').removeClass('d-none');
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__ = __webpack_require__(4);







CCL.conflictModal = {
  autoload: [['conflictBtnClick', $('#conflictModal').length > 0]],

  displayedData: {},
  sendData: [],
  soldOutData: [],
  baseClass: '',
  fbtAddedProducts: [],

  conflictBtnClick: function conflictBtnClick() {
    var _this = this;

    $('body').on('click', '.checkoutConflictBtn', function (event) {
      var pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        var productPosition = Number($(event.target).data('productposition')) + 1;
        var pageNumber = Number($(event.target).data('currentpage')) + 1;
        var categoryName = $(event.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
      event.preventDefault();
      var targetElement = $(event.target).data('hasvariants');
      var quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
      var variantId = $(event.target).attr('data-variantids');
      var productCode = $(event.target).data('productcode');
      if (!productCode) {
        productCode = $(event.currentTarget).data('productcode');
      }
      var hasupsell = $(event.target).attr('data-hasupsell');
      if (hasupsell === 'true' && (typeof hasupsell === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(hasupsell)) !== ( true ? 'undefined' : _typeof(undefined)) && hasupsell !== false) {
        CCL.upSellProductModal.loadUpsellModal(productCode);
        _this.baseClass = $(event.currentTarget.classList).last();
        return;
      }
      var csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
      var dataObj = {
        productCodePost: productCode,
        CSRFToken: csrf,
        qty: quantity || 1,
        variantIds: variantId
      };
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        _this.loadModalData(dataObj);
      }
    });
    $('body').on('click', '#conflictModalClose', function (event) {
      setTimeout(function () {
        $('.' + _this.baseClass[0]).addClass('ada-element-focus');
        $('.' + _this.baseClass[0]).focus();
      }, 800);
    });
  },
  loadModalData: function loadModalData(dataObj) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var ajaxUrl, method, pageType, inputDataObj, res, excursionsCountForFacet, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["showLoader"]();
              ajaxUrl = '';
              method = 'POST';

              if (window.location.hostname === 'localhost' && window.location.port === '6565') {
                ajaxUrl = '/_ui/responsive/ccl/assets/templates/conflict-modals/checkout-conflict-modal.json';
                method = 'GET';
              } else {
                ajaxUrl = '/shop/cart/add';
              }
              _context.prev = 4;
              pageType = $('#pagetype').data('pagetype');

              dataObj.pageType = pageType;
              if (pageType === 'CATEGORY') {
                dataObj.productPosition = localStorage.getItem('productposition');
                dataObj.pageNumber = localStorage.getItem('pageNumber');
                dataObj.categoryName = localStorage.getItem('sascategorycode');
              }
              inputDataObj = {
                url: ajaxUrl,
                type: method,
                data: dataObj
              };
              _context.next = 11;
              return __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["doAjax"](inputDataObj);

            case 11:
              res = _context.sent;

              if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(res).length !== 0 && res.constructor === Object && res.isProductAdded === false) {
                _this2.displayedData = _this2.modifyConflictJSON(res);
                _this2.openConflictModal(_this2.displayedData);
                __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideLoader"]();
              } else {
                __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideLoader"]();
                if (res.addedToCart === true) {
                  __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["updateHeaderCartWidget"](res);
                  CCL.addToCart.successModal(res);
                }
                console.log('Data is empty');
              }
              excursionsCountForFacet = res.excursionsCountForFacet;

              __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["updateFacetData"](excursionsCountForFacet);
              _context.next = 22;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](4);
              cartAPIError = { customError: _context.t0 };

              __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[4, 17]]);
    }))();
  },
  modifyConflictJSON: function modifyConflictJSON(jsonData) {
    var timeSlotsCard = jsonData.timeSlotsCard;

    for (var i = 0; i < timeSlotsCard.length; i++) {
      var _timeSlotsCard$i = timeSlotsCard[i],
          ticketsAvailability = _timeSlotsCard$i.ticketsAvailability,
          bookingInformation = _timeSlotsCard$i.bookingInformation;

      for (var j = 0; j < bookingInformation.length; j++) {
        var guestInformation = bookingInformation[j].guestInformation;

        for (var k = 0; k < guestInformation.length; k++) {
          guestInformation[k].isSelected = false;
          guestInformation[k].isDisabled = false;
          guestInformation[k].isSoldOut = false;
          if (Number(ticketsAvailability) === 0) {
            guestInformation[k].isPermanentDisabled = true;
            guestInformation[k].isSoldOut = true;
          }
        }
      }
    }
    return jsonData;
  },


  /**
  * ajax request to load HTML template for conflict modal
  * @param {Object} data
  */
  openConflictModal: function openConflictModal(data) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var options, inputDataObj, response, html;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };

              data.productCard.date = new Date(data.productCard.date).toLocaleDateString('en-US', options);
              inputDataObj = {
                url: '/_ui/responsive/ccl/assets/templates/conflict-modals/checkout-conflict-modal.html',
                type: 'GET'
              };
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["doAjax"](inputDataObj);

            case 6:
              response = _context2.sent;
              html = __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["createDynamicHTML"](response, data);

              $('#conflictModalHtml').empty().append(html);
              __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["showModal"]('conflictModal');
              __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideLoader"]();
              if ($('.modal:visible').length) {
                setTimeout(function () {
                  $('body').addClass('modal-open');
                }, 500);
              }
              _this3.modalClickEvents(); // call all javascript event after above html load
              _context2.next = 19;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2['catch'](0);

              __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideLoader"]();
              __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["displayError"](_context2.t0);

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[0, 15]]);
    }))();
  },
  onAddToCart: function onAddToCart() {
    var productCard = __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["getSelectedGuests"](this.sendData);
    this.addToCartAjax(productCard);
  },
  addToCartAjax: function addToCartAjax(ajaxData) {
    var _this4 = this;

    var jsonObjects = { productCard: ajaxData };
    var pageType = $('#pagetype').data('pagetype');
    jsonObjects.pageType = pageType;
    if (pageType === 'CATEGORY') {
      jsonObjects.productPosition = localStorage.getItem('productposition');
      jsonObjects.pageNumber = localStorage.getItem('pageNumber');
      jsonObjects.categoryName = localStorage.getItem('sascategorycode');
    }
    if (this.fbtAddedProducts.length) {
      jsonObjects.fbtAddedProducts = this.fbtAddedProducts;
    }
    var token = $('#csrfSessionToken').data('csrf');
    __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/addToCart',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonObjects),
      dataType: 'json',
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: function success(res) {
        __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideLoader"]();
        if (res.addedToCart === true) {
          __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["updateHeaderCartWidget"](res);
          _this4.fbtAddedProducts = [];
          CCL.addToCart.successModal(res);

          if (jsonObjects.fbtAddedProducts && jsonObjects.fbtAddedProducts.length) {
            _this4.fbtAddedProducts = [];
            // if you are on cart page then reload the page for FBT
            if ($('body').find('.c-cart').length) {
              $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
              $('body').find('#addToCartSuccessModal .keepShopingLink').attr('href', '/booked/home');
            }
          }
        }
        _this4.sendData = [];
        console.log('Something went well');
        var excursionsCountForFacet = res.excursionsCountForFacet;

        __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["updateFacetData"](excursionsCountForFacet);
        __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideModal"]('conflictModal');
      },
      error: function error(_error) {
        __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideLoader"]();
        __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["hideModal"]('conflictModal');
        console.log('Something went wrong');
      }
    });
  },
  modalClickEvents: function modalClickEvents() {
    var _this5 = this;

    // expand first available slot by default
    this.expandFirstAvailable();

    $('#AddToCartBtn').click(function (e) {
      _this5.onAddToCart();
    });

    $('.conflict-panel-timing').click(function (e) {
      $(e.currentTarget).find('img:not(.tick-mark)').toggleClass('time-conflict-img-rotate');
    });
    /* eslint-disable */
    $('.custom-checkbox').click(function (e) {
      if (e.target.tagName === 'INPUT') {
        var cuurentID = e.currentTarget.id.split('-');
        var curVarientID = cuurentID[0];
        var curBookingID = cuurentID[1];
        var curGuestID = cuurentID[2];
        var currentBufferStartTime = '';
        var currentBufferEndTime = '';
        _this5.createSelectedGuests(curVarientID, curBookingID, curGuestID);
        var _displayedData = _this5.displayedData,
            isTransferProduct = _displayedData.isTransferProduct,
            timeSlotsCard = _displayedData.timeSlotsCard;


        for (var i = 0; i < timeSlotsCard.length; i++) {
          if (timeSlotsCard[i].variantId === curVarientID) {
            var _timeSlotsCard$i2 = timeSlotsCard[i],
                actualStartTime = _timeSlotsCard$i2.actualStartTime,
                actualEndTime = _timeSlotsCard$i2.actualEndTime;

            currentBufferStartTime = actualStartTime.split(' ')[3].split(':');
            currentBufferEndTime = actualEndTime.split(' ')[3].split(':');
          }
        }

        for (var _i = 0; _i < timeSlotsCard.length; _i++) {
          if (timeSlotsCard[_i].variantId !== curVarientID) {
            // disable guests in remaining timeslots
            var _timeSlotsCard$_i = timeSlotsCard[_i],
                bookingInformation = _timeSlotsCard$_i.bookingInformation,
                _actualStartTime = _timeSlotsCard$_i.actualStartTime,
                _actualEndTime = _timeSlotsCard$_i.actualEndTime;

            var guestBufferStartTime = _actualStartTime.split(' ')[3].split(':');
            var guestBufferEndTime = _actualEndTime.split(' ')[3].split(':');
            for (var j = 0; j < bookingInformation.length; j++) {
              var guestInformation = bookingInformation[j].guestInformation;

              for (var k = 0; k < guestInformation.length; k++) {
                var _guestInformation$k = guestInformation[k],
                    guestId = _guestInformation$k.guestId,
                    errorText = _guestInformation$k.errorText;

                if (guestId === curGuestID) {
                  if (isTransferProduct === 'true' || _this5.getTimeConflictStatus(guestBufferStartTime, guestBufferEndTime, currentBufferStartTime, currentBufferEndTime)) {
                    if ($('#' + curVarientID + curBookingID + curGuestID).is(':checked')) {
                      $('#' + timeSlotsCard[_i].variantId + bookingInformation[j].bookingId + guestId)[0].disabled = true;
                      $('#' + timeSlotsCard[_i].variantId + bookingInformation[j].bookingId + guestId)[0].checked = false;
                      $('#' + timeSlotsCard[_i].variantId + '-' + bookingInformation[j].bookingId + '-' + guestId)[0].classList.add('div-disabled');
                      guestInformation[k].isDisabled = true;
                    } else {
                      if (!errorText) {
                        $('#' + timeSlotsCard[_i].variantId + bookingInformation[j].bookingId + guestId)[0].disabled = false;
                        $('#' + timeSlotsCard[_i].variantId + '-' + bookingInformation[j].bookingId + '-' + guestId)[0].classList.remove('div-disabled');
                        guestInformation[k].isDisabled = false;
                      }
                    }
                  } else {
                    console.log('not checked');
                    if (!errorText) {
                      if (guestInformation[k].isDisabled && !guestInformation[k].isSoldOut) {
                        var ticketsAvailElement = $('#id' + timeSlotsCard[_i].variantId).find('.tickets-availability-text span');
                        if (ticketsAvailElement[0].textContent !== 'No more tickets available') {
                          // added on special purpose
                          $('#' + timeSlotsCard[_i].variantId + bookingInformation[j].bookingId + guestId)[0].disabled = false;
                          $('#' + timeSlotsCard[_i].variantId + '-' + bookingInformation[j].bookingId + '-' + guestId)[0].classList.remove('div-disabled');
                          guestInformation[k].isDisabled = false;
                        }
                      }
                    }
                  }
                  break;
                }
              }
            }
          } else {
            timeSlotsCard[_i] = _this5.updateUserselection(timeSlotsCard[_i], curBookingID, curGuestID);
          }
        }
        $('#AddToCartBtn')[0].disabled = !_this5.sendData.length;
        _this5.getCurrentSelected(timeSlotsCard); // get count of selected user
        _this5.displaySoldOut_SpecificTimeSlot(timeSlotsCard, curVarientID, curBookingID, curGuestID);
      }
    });
    /* eslint-enable */
  },
  expandFirstAvailable: function expandFirstAvailable() {
    $.each(this.displayedData.timeSlotsCard, function (index, value) {
      var notAllConflicating = value.bookingInformation.some(function (x) {
        return !x.allConflict;
      });
      // if not notAllConflicating means one checkbox is available
      if (notAllConflicating) {
        // expand the section by triggering click event
        $('#id' + value.variantId + ' .expandCollapseImage').trigger('click');
        $('#id' + value.variantId + ' .expandCollapseImage img').addClass('time-conflict-img-rotate');
        return false;
      }
      return true;
    });
  },
  getTimeConflictStatus: function getTimeConflictStatus(guestBufferStartTime, guestBufferEndTime, currentBufferStartTime, currentBufferEndTime) {
    var timeSlotConflict = false;

    var curentStartTimeConflict = new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us');
    var currentEndTimeConflict = new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us');

    var guestStartTimeConflict = new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us');
    var guestEndTimeConflict = new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us');

    if (curentStartTimeConflict || currentEndTimeConflict || guestStartTimeConflict || guestEndTimeConflict) {
      timeSlotConflict = true;
    }

    return timeSlotConflict;
  },
  updateUserselection: function updateUserselection(timeSlotsCard, curBookingID, curGuestID) {
    var bookingInformation = timeSlotsCard.bookingInformation;

    for (var x = 0; x < bookingInformation.length; x++) {
      if (bookingInformation[x].bookingId === curBookingID) {
        var guestInformation = bookingInformation[x].guestInformation;

        for (var y = 0; y < guestInformation.length; y++) {
          if (guestInformation[y].guestId === curGuestID) {
            if (!guestInformation[y].isSelected) {
              guestInformation[y].isSelected = true;
            } else {
              guestInformation[y].isSelected = false;
            }
          }
        }
      }
    }
    return timeSlotsCard;
  },
  createSelectedGuests: function createSelectedGuests(curVarientID, curBookingID, curGuestID) {
    if ($('#' + curVarientID + curBookingID + curGuestID).is(':checked')) {
      if (!this.sendData.includes(curVarientID + '-' + curBookingID + '-' + curGuestID)) {
        this.sendData.push(curVarientID + '-' + curBookingID + '-' + curGuestID);
      }
    } else {
      this.sendData = this.sendData.filter(function (el) {
        return el !== curVarientID + '-' + curBookingID + '-' + curGuestID;
      });
    }
  },
  getCurrentSelected: function getCurrentSelected(timeSlotsCard) {
    var test = __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["getSelectedGuests"](this.sendData);
    $('.current-selected').empty();
    $.each(test, function (index, value) {
      $('#currentSelected-' + value.variantId).empty();
      if (timeSlotsCard.filter(function (x) {
        return x.variantId === value.variantId;
      }).length) {
        var appendText = value.guestList.length === 1 ? 'Guest selected' : 'Guests selected';
        $('#currentSelected-' + value.variantId).html(' ' + value.guestList.length + ' ' + appendText);
      }
    });
  },
  displaySoldOut_SpecificTimeSlot: function displaySoldOut_SpecificTimeSlot(timeSlotsCard, curVarientID, curBookingID, curGuestID) {
    var getCurrentTimeSlot = timeSlotsCard.filter(function (timeSlot) {
      return timeSlot.variantId === curVarientID;
    });
    // new code to fix bug this - #770540
    var ticketsAvailability = getCurrentTimeSlot.length ? getCurrentTimeSlot[0].ticketsAvailability : 0;

    // Old code below - commented bcz of #770540
    //  const { ticketsAvailability } = getCurrentTimeSlot[0];

    var selectedGuests = __WEBPACK_IMPORTED_MODULE_5__js_generalFunctions__["getSelectedGuests"](this.sendData);
    var selectedGuestCount = null;
    $.each(selectedGuests, function (index, value) {
      if (value.variantId === curVarientID) {
        selectedGuestCount = value.guestList.length;
      }
    });

    if (ticketsAvailability === selectedGuestCount) {
      for (var i = 0; i < getCurrentTimeSlot.length; i++) {
        var bookingInformation = getCurrentTimeSlot[i].bookingInformation;

        for (var j = 0; j < bookingInformation.length; j++) {
          var guestInformation = bookingInformation[j].guestInformation;

          for (var k = 0; k < guestInformation.length; k++) {
            // if (!guestInformation[k].isSelected && !guestInformation[k].errorText && !guestInformation[k].isDisabled) {
            if (!guestInformation[k].errorText) {
              if (!guestInformation[k].isSelected) {
                $('#' + getCurrentTimeSlot[i].variantId + bookingInformation[j].bookingId + guestInformation[k].guestId)[0].disabled = true;
                var currentDivId = getCurrentTimeSlot[i].variantId + '-' + bookingInformation[j].bookingId + '-' + guestInformation[k].guestId;
                $('#' + currentDivId)[0].classList.add('div-disabled');
                guestInformation[k].isDisabled = true;
                var soldOutLabel = $('#' + currentDivId).find('.redtext');
                soldOutLabel[0].innerText = 'Sold Out';
                guestInformation[k].isSoldOut = true;
                this.soldOutData.push(currentDivId);
              }
            }
          }
        }
      }
      var ticketsAvailElement = $('#id' + curVarientID).find('.tickets-availability-text span');
      ticketsAvailElement[0].textContent = 'No more tickets available';
      ticketsAvailElement[0].classList.add('no-more-tickets');
    } else {
      var ticketsAvailElement1 = $('#id' + curVarientID).find('.tickets-availability-text span');
      if (ticketsAvailElement1.length && ticketsAvailElement1[0].textContent === 'No more tickets available') {
        // Remove Sold Out
        var remainingSoldData = [];
        $.each(this.soldOutData, function (currentIndex, soldOutID) {
          var newVarientId = soldOutID.split('-')[0];
          var newBookingId = soldOutID.split('-')[1];
          var newGuestId = soldOutID.split('-')[2];
          if (curVarientID === newVarientId) {
            $('#' + newVarientId + newBookingId + newGuestId)[0].disabled = false;
            $('#' + soldOutID)[0].classList.remove('div-disabled');
            var _soldOutLabel = $('#' + soldOutID).find('.redtext');
            _soldOutLabel[0].textContent = '';
            for (var a = 0; a < getCurrentTimeSlot.length; a++) {
              var _bookingInformation = getCurrentTimeSlot[a].bookingInformation;

              for (var b = 0; b < _bookingInformation.length; b++) {
                var _bookingInformation$b = _bookingInformation[b],
                    bookingId = _bookingInformation$b.bookingId,
                    _guestInformation = _bookingInformation$b.guestInformation;
                // if (bookingId === newBookingId) {

                for (var c = 0; c < _guestInformation.length; c++) {
                  if (_guestInformation[c].guestId === newGuestId) {
                    _guestInformation[c].isSelected = false;
                    _guestInformation[c].isDisabled = false;
                    _guestInformation[c].isSoldOut = false;
                    break;
                  }
                }
                // }
              }
            }
            // this.soldOutData.splice(currentIndex, 1);
          } else {
            remainingSoldData.push(soldOutID);
          }
        });
        this.soldOutData = remainingSoldData;
        console.log(remainingSoldData);
        var ticketText = Number(ticketsAvailability) > 1 ? 'Tickets' : 'Ticket';
        ticketsAvailElement1[0].textContent = ticketsAvailability + ' ' + ticketText + ' Available';
        ticketsAvailElement1[0].classList.remove('no-more-tickets');
      }
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.orderConfirmation = {
  autoload: [['expectToggle', $('.expectation').length > 0]],

  expectToggle: function expectToggle() {
    $('.expectation').each(function (index, element) {
      var Prodtitle = $(element).find('.what-to-expect-title').data('prodtitle');
      var descObj = $(element).children('.upsellProduct-description');
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["seeMoreLess"](descObj, Prodtitle);
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.topNav = {
  autoload: [['mNavDropdownToggle', $('.m-nav-dropdown-link').length > 0], ['notificationDropdownMenu', $('.notification-dropdown-menu').length > 0]],

  mNavDropdownToggle: function mNavDropdownToggle() {
    $('.m-nav-dropdown-link').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        $(element).toggleClass('open');
        var targetElement = $(event.target).parents('.m-nav-dropdown').find('.m-nav-dropdown-menu');
        var expanded = $(event.currentTarget).attr('aria-expanded');
        $(targetElement).slideToggle();
        if (expanded === 'false') {
          $(event.currentTarget).attr('aria-expanded', 'true');
        } else {
          $(event.currentTarget).attr('aria-expanded', 'false');
        }
      });
    });
  },
  notificationDropdownMenu: function notificationDropdownMenu() {
    $('.notification-submenu-href img, .notification-submenu-href').on('click keypress', function (event) {
      $(event.target).parents('.dropdown-submenu-wrap').find('.dropdown-menu').toggleClass('show');

      event.stopPropagation();
    });

    $('.notification-dropdown-anchor').on('click keypress', function (event) {
      $('.dropdown-submenu-wrap').find('.dropdown-menu').removeClass('show');
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.lookupLoggedinGuestModal = {
  autoload: [['radioSelect', $('.booking-info').length > 0], ['modalEvents', $('#LookupLoggedinGuestModal').length > 0]],

  radioSelect: function radioSelect() {
    $('.booking-place-date').click(function (event) {
      console.dir();
      $('.custom-control-label').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      $('.diff-booking-form').removeClass('show');
    });
    $('.diff-booking-label').click(function (event) {
      console.dir(event.currentTarget);
      $('.custom-control-label').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      $('.diff-booking-form').addClass('show');
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#LookupLoggedinGuestModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__ = __webpack_require__(4);





CCL.guestEditConflicts = {
  autoload: [['editGuestSaveBtnClick', $('.c-cart').length > 0], ['editGuestCancelBtnClick', $('.c-cart').length > 0], ['saveForLaterProduct_ShoreExBtnClick', $('.saveForLaterProduct_ShoreEx').length > 0], ['removeProduct_ShoreExBtnClick', $('.removeProduct_ShoreEx').length > 0], ['ExpandCollapseImg_timing', $('.conflict-panel-timing').length > 0], ['checkBoxClick', $('body').length > 0]],

  redTextLenght: null,

  ExpandCollapseImg_timing: function ExpandCollapseImg_timing() {
    $('body').on('click', '.conflict-panel-timing', function (e) {
      $(e.currentTarget).find('img:not(.tick-mark)').toggleClass('time-conflict-img-rotate');
    });
  },
  editGuestSaveBtnClick: function editGuestSaveBtnClick() {
    var _this = this;

    $('body').on('click', '.saveEditGuest_ShoreEx', function (e) {
      var productId = $(e.currentTarget).attr('data-productId');
      var parentElement = $(e.currentTarget).parents('.edit-guest-time-shorex-cart-wrap');
      var changedDiv = '.guest_' + productId + ' .custom-checkbox';
      var selecteditems = [];
      $(changedDiv).each(function (index, val) {
        $(val).find('input:checked').each(function (i, ob) {
          selecteditems.push(val.id);
        });
      });
      var productCard = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getSelectedGuests"](selecteditems);
      _this.save_addToCartAjax(productId, productCard);
      $(e.currentTarget).parents('.cart-card-body').find('.edit-guest-time-shorex-cart-link').attr('aria-expanded', 'false');
      setTimeout(function () {
        parentElement.siblings('.edit-guest-time-shorex-cart-link').addClass('ada-element-focus');
        parentElement.siblings('.edit-guest-time-shorex-cart-link').focus();
      }, 700);
    });
  },
  save_addToCartAjax: function save_addToCartAjax(productId, ajaxData) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var jsonObjects, token, ajaxUrl, reqContentType, method, inputDataObj, res, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              jsonObjects = { productId: productId, productCard: ajaxData };
              token = void 0;
              ajaxUrl = '';
              reqContentType = void 0;
              method = 'POST';

              if (window.location.hostname === 'localhost' && window.location.port === '6565') {
                ajaxUrl = '/_ui/responsive/ccl/assets/templates/cart-conflicts/cart-edit-guest-time.json';
                method = 'GET';
                jsonObjects = null;
              } else {
                ajaxUrl = '/shop/cart/shoreex/updateSelection';
                jsonObjects = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsonObjects);
                reqContentType = 'application/json';
                token = $('#csrfSessionToken').data('csrf');
              }
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              _context.prev = 7;
              inputDataObj = {
                url: ajaxUrl,
                type: method,
                data: jsonObjects,
                contentType: reqContentType,
                dataType: 'json',
                headers: {
                  CSRFToken: token
                }
              };
              _context.next = 11;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 11:
              res = _context.sent;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              if (res.productCard) {
                _this2.showEditGuests(productId, res);
                __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](res.orderSummary);
                __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateProductSummary"](res.orderSummary);
                __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCouponSummary"](res);
                CCL.saveForLaterObj.loadSaveForLaterCartSection();
                if (res.cartEmpty) {
                  window.location.reload();
                }
                console.log('Something went well on Save Click for product ' + productId);
              } else {
                $('.card-' + productId).css('display', 'none'); // remove the card from DOM if product card is null
                __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](res.orderSummary);
                __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateProductSummary"](res.orderSummary);
                __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCouponSummary"](res);
                if (res.cartEmpty) {
                  window.location.reload();
                }
              }
              _context.next = 22;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](7);
              cartAPIError = { customError: _context.t0 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log('Something went wrong on Save Click for product ' + productId);
              console.log(cartAPIError);

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[7, 16]]);
    }))();
  },
  saveForLaterProduct_ShoreExBtnClick: function saveForLaterProduct_ShoreExBtnClick() {
    $('body').on('click', '.saveForLaterProduct_ShoreEx', function (e) {
      var productId = $(e.currentTarget).attr('data-productId');
      var getProductDiv = '.card-' + productId;
      // $(getProductDiv).css('display', 'none');
      // code has to be implemented based on scenario
    });
  },
  removeProduct_ShoreExBtnClick: function removeProduct_ShoreExBtnClick() {
    var _this3 = this;

    $('body').on('click', '.removeProduct_ShoreEx', function (e) {
      var productId = $(e.currentTarget).attr('data-productId');
      var getProductDiv = '.card-' + productId;
      $(getProductDiv).css('display', 'none');
      _this3.removeBtn_ShoreEx_CartAjax(productId);
    });
  },
  removeBtn_ShoreEx_CartAjax: function removeBtn_ShoreEx_CartAjax(productId) {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    var jsonObjects = { productId: productId };
    var token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/shoreex/removeBaseProduct',
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsonObjects),
      dataType: 'json',
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: function success(res) {
        if (res.removeSuccess) {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateProductSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateHeaderCartWidget"](res);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCouponSummary"](res);
          _this4.showEditGuests(productId, res);
          // SAS Event for remove
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["sasEvents"]('send', res.cclSasAnalyticsJsonData);
          if (res.cartEmpty) {
            window.location.reload();
          }
          console.log('Something went well on Remove Click for ShoreEx product ' + productId);
        } else {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateProductSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateHeaderCartWidget"](res);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCouponSummary"](res);
          if (res.cartEmpty) {
            window.location.reload();
          }
          $('.card-' + productId).css('display', 'block'); // Keep the card from DOM if RemoveSuccess is false
        }
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      },
      error: function error(_error) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong on Remove Click for ShoreEx product ' + productId);
      }
    });
  },
  editGuestCancelBtnClick: function editGuestCancelBtnClick() {
    var _this5 = this;

    $('body').on('click', '.cancelEditGuest_ShoreEx', function (e) {
      var productId = $(e.currentTarget).attr('data-productId');
      var parentElement = $(e.currentTarget).parents('.edit-guest-time-shorex-cart-wrap');
      var wishList2Entry = $(e.currentTarget).parents('.cart-card-body').find('.edit-guest-time-shorex-cart-link').data('wishlist2entry');
      _this5.cancel_addToCartAjax(productId, wishList2Entry);
      setTimeout(function () {
        parentElement.siblings('.edit-guest-time-shorex-cart-link').focus();
      }, 400);
    });
  },
  cancel_addToCartAjax: function cancel_addToCartAjax(productId) {
    var _this6 = this;

    var wishList2Entry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!wishList2Entry) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    }

    var jsonObjects = { productId: productId, wishList2Entry: wishList2Entry };
    var token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/shoreex/productDetails',
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsonObjects),
      dataType: 'json',
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: function success(res) {
        _this6.showEditGuests(productId, res, wishList2Entry);

        if (!wishList2Entry) {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCartSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateProductSummary"](res.orderSummary);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateCouponSummary"](res);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
          if (res.cartEmpty) {
            window.location.reload();
          }
        }
        console.log('Something went well on Cancel click for product ' + productId);
      },
      error: function error(_error2) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong on Cancel click for product ' + productId);
      }
    });
  },
  showEditGuests: function showEditGuests(productId, data) {
    var _this7 = this;

    var wishList2Entry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/cart-conflicts/cart-edit-guest-time.html'
    }).done(function (response) {
      var html = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](response, data);
      var repanitClass = '.edit-guest-time-shorex-cart-wrap.guest_' + productId;
      if (!wishList2Entry) {
        if ($('.card-' + productId + ' .cart-card-body .departureTimeSlots').length && data.productCard.departureTimeSlots !== null) {
          $('.card-' + productId + ' .cart-card-body .departureTimeSlots')[0].innerHTML = '' + data.productCard.departureTimeSlots;
        }
      }
      if (repanitClass.length) {
        $(repanitClass).empty().append(html);
        if (!wishList2Entry) {
          var $imgArrowIcon = $('.c-cart-card.card-' + productId).find('.list-item.edit-guest-time-shorex-cart-link');
          $imgArrowIcon.removeClass('open');
          $(repanitClass).attr('style', 'display:none');
          _this7.updateSelectedGuestsCount(productId, data.qtyAdded);
        }
      }
      // call all javascript event after above html load
      var otherConflictsData = data.conflictingProductDetails;
      // repainting all the time slots which has conflicts
      $.each(otherConflictsData, function (index, item) {
        var conflictData = item;
        item.productCard = {};
        item.selectTimeAndGuest = 'SELECT TIME AND GUESTS';
        item.productCard.productId = item.productCode;
        var conflictHtml = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](response, conflictData);
        var repaintDiv = '.edit-guest-time-shorex-cart-wrap.guest_' + item.productCode;
        $(repaintDiv).empty().append(conflictHtml);
        var $ArrowIcon = $('.c-cart-card.card-' + item.productCode).find('.list-item.edit-guest-time-shorex-cart-link');
        $ArrowIcon.removeClass('open');
        $(repaintDiv).attr('style', 'display:none');
        // this.checkBoxClick();
      });

      if (wishList2Entry) {
        CCL.editCartStateroom.disableMoveToCart();
        $('.edit-guest-time-shorex-cart-wrap input[type="checkbox"]:checked:not(:disabled)').each(function (index, element) {
          $(element).trigger('click');
          setTimeout(function () {
            $(element).trigger('click');
          }, 300);
        });
      }
      // this.checkBoxClick();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      console.log('Something went wrong while loading dynamic HTML');
    });
  },
  updateSelectedGuestsCount: function updateSelectedGuestsCount(productId, qtyAdded) {
    var userCntEl = $('.quantity_' + productId);
    userCntEl[0].textContent = qtyAdded;
  },
  checkBoxClick: function checkBoxClick() {
    var _this8 = this;

    // $('.custom-checkbox').click((e) => {
    $('body').on('click', '.c-edit-guest-time-shorex-cart .custom-checkbox', function (e) {
      if (e.target.tagName === 'INPUT') {
        var currentID = e.target.id;
        var guestId = e.target.dataset.guestid;
        var $parentRoom = $('#' + currentID).parents('div.conflict-panel-timing');
        var $parentSection = $('#' + currentID).parents('div.c-cart-card');
        var ticketThreshold = Number($parentSection.data('ticketthreshold'));
        var $qtyAvailable = $parentRoom.find('.tickets-availability-text').text();

        var selectedStartTime = $parentRoom[0].dataset.starttime;
        var selectedEndTime = $parentRoom[0].dataset.endtime;
        // eslint-disable-next-line radix
        var qty = parseInt($qtyAvailable.split(' ')[0]);
        $parentRoom.find($('.custom-control.custom-checkbox > input[type="checkbox"]:checked')).each(function (index, element) {
          if (element.hasAttribute('checked')) {
            element.removeAttribute('checked');
            element.checked = true;
          }
        });

        // if ($(`#${currentID}`).find('input').prop('checked')) {
        if ($('#' + currentID).prop('checked')) {
          qty--;
          $('#' + currentID).removeAttr('checked');
          //  $(`#${currentID}`).find('input').removeAttr('checked');
          $parentRoom.find('.tickets-availability-text').not('.redtext').text(qty + ' Tickets available');
        } else {
          qty++;
          $parentRoom.find('.tickets-availability-text').not('.redtext').text(qty + ' Tickets available');
        }

        if (qty > ticketThreshold) {
          $parentRoom.find('.tickets-availability-text').hide();
          $parentRoom.find('.threshold-ticket-text').text('More than ' + ticketThreshold + ' tickets available').addClass('show');
        } else {
          $parentRoom.find('.tickets-availability-text').not('.redtext').text(qty + ' tickets available').show();
          $parentRoom.find('.threshold-ticket-text').removeClass('show');
        }

        $parentRoom.find($('.custom-control.custom-checkbox > input[type="checkbox"]')).each(function (index, element) {
          var redTextValue = $($('#' + element.parentElement.id).find('.redtext')).text();

          if (redTextValue === 'Sold Out' || redTextValue === '') {
            _this8.redTextLenght = false;
          } else {
            _this8.redTextLenght = true;
          }
          if (!_this8.redTextLenght) {
            if (!element.checked) {
              if (qty === 0) {
                element.disabled = true;
                element.parentElement.classList.add('div-disabled');
                if ($('#' + element.parentElement.id).find('span').hasClass('redtext')) {
                  $($('#' + element.parentElement.id).find('.redtext')).text('Sold Out');
                } else {
                  $('#' + element.parentElement.id).find('label').append($('<span class="redtext"></span>').text('Sold Out'));
                }
              } else {
                /* eslint-disable */
                if (!element.dataset.sameproductconflict || element.dataset.sameproductconflict === 'false') {
                  element.disabled = false;
                  element.parentElement.classList.remove('div-disabled');
                  $($('#' + element.parentElement.id).find('.redtext')).text('');
                }
                /* eslint-enable */
              }
            }
          }
        });

        $parentSection.find($('.conflict-panel-timing')).each(function (index, element) {
          if (element.id !== $parentRoom[0].id) {
            var _element$dataset = element.dataset,
                istransferproduct = _element$dataset.istransferproduct,
                starttime = _element$dataset.starttime,
                endtime = _element$dataset.endtime;

            if (istransferproduct === 'true') {
              if (!e.target.checked) {
                $('#' + element.id + ' .guest-' + guestId).each(function (ind, ele) {
                  var redTextValue = $($('#' + ele.parentElement.id).find('.redtext')).text();
                  if (!redTextValue.length) {
                    ele.disabled = false;
                    ele.parentElement.classList.remove('div-disabled');
                    ele.dataset.sameproductconflict = false;
                  }
                });
              } else {
                $('#' + element.id + ' .guest-' + guestId).each(function (i, elem) {
                  if (!elem.checked && elem.id !== currentID) {
                    elem.disabled = true;
                    elem.parentElement.classList.add('div-disabled');
                    elem.dataset.sameproductconflict = true;
                  }
                });
              }
            } else if (new Date(selectedEndTime) >= new Date(starttime)) {
              if (!e.target.checked) {
                $('#' + element.id + ' .guest-' + guestId).each(function (ind, ele) {
                  var redTextValue = $($('#' + ele.parentElement.id).find('.redtext')).text();
                  if (!redTextValue.length) {
                    ele.disabled = false;
                    ele.parentElement.classList.remove('div-disabled');
                    ele.dataset.sameproductconflict = false;
                  }
                });
              } else {
                $('#' + element.id + ' .guest-' + guestId).each(function (i, elem) {
                  if (!elem.checked && elem.id !== currentID && new Date(selectedStartTime) <= new Date(endtime)) {
                    elem.disabled = true;
                    elem.parentElement.classList.add('div-disabled');
                    elem.dataset.sameproductconflict = true;
                  }
                });
              }
            }
          }
        });
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__ = __webpack_require__(4);





CCL.cruiseManager = {
  autoload: [['load', $('.c-cruise-manager').length > 0], ['removeOverlapAndEnableSticky', $('#todoPlanner').length > 0]
  //  ['carousel2', $('.owl-carousel-2').length > 0],
  // ['bulletsContext', $('.owl-carousel-2').length > 0]
  ],

  customData: {},
  loadedCarousel: [],
  allCarouselData: [],
  isCurrentVibeLoaded: false,

  load: function load() {
    this.loadVibeCarousels();
  },
  getAllCategories: function getAllCategories() {
    var categoriesList = [];
    $('.cruisemanager-vibes').each(function (index, element) {
      var currentVibeObj = {
        categoryCode: element.dataset.categorycode,
        categoryName: element.dataset.categoryname,
        componentUid: element.id,
        coloumnGridStyle: element.dataset.coloumngridstyle
      };
      categoriesList.push(currentVibeObj);
    });
    return categoriesList;
  },
  loadVibeCarousels: function loadVibeCarousels() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var allCategories, i, LoadCarouselError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getAllCategories();

            case 3:
              allCategories = _context.sent;

              for (i = 0; i < allCategories.length; i++) {
                _this.loadCarouselData(allCategories[i].categoryCode, allCategories[i].componentUid, true);
              }
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);
              LoadCarouselError = { replaceHTMLError: _context.t0 };

              console.log(LoadCarouselError);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  sortDropDownLabels: function sortDropDownLabels(completeData) {
    var beforeData = [];
    beforeData = completeData.vibeDropdown.dropdownItems;
    beforeData.sort(function (a, b) {
      return a.label === b.label ? 0 : +(a.label > b.label) || -1;
    });
    completeData.vibeDropdown.dropdownItems = beforeData;
    return completeData;
  },
  loadCarouselData: function loadCarouselData(carouselId, componentUid, isHtmlEvents) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var ajaxUrl, inputDataObj, res, filledStars, emptyStars, splitRating, tempEmpty, totalReviews, emptyRating, LoadCarouselError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              ajaxUrl = '';

              if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
                ajaxUrl = '/_ui/responsive/ccl/assets/templates/vibe-dropdown/vibe-dropdown-' + componentUid + '.json';
              } else {
                ajaxUrl = '/shop/cclcategoryvibes/fetchProducts?componentUid=' + componentUid + '&categoryCode=' + carouselId;
              }
              _context2.prev = 2;
              inputDataObj = {
                url: ajaxUrl,
                type: 'GET',
                cache: false
              };
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 6:
              res = _context2.sent;

              if (res) {
                if (res.vibeDropdown && res.vibeDropdown.dropdownItems.length) {
                  filledStars = [];
                  emptyStars = [];
                  splitRating = [];
                  tempEmpty = [];
                  totalReviews = 5;
                  emptyRating = 0;

                  res.vibeDropdown.dropdownItems.forEach(function (element) {
                    element.productsCarousel.products.forEach(function (productElement) {
                      emptyRating = 0;
                      if (productElement.productAverageRating) {
                        filledStars = [];
                        emptyStars = [];
                        splitRating = Number(productElement.productAverageRating).toFixed(1).split('.');
                        for (var index = 0; index < Number(splitRating[0]); index++) {
                          filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/star_filled.svg' });
                        }
                        if (Number(splitRating[1]) === 5) {
                          filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/starhalf.svg' });
                        } else if (Number(splitRating[1]) > 5) {
                          filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/star_filled.svg' });
                        } else if (Number(splitRating[1]) < 5 && Number(splitRating[1]) !== 0) {
                          filledStars.push({ ratingStars: '/_ui/responsive/ccl/assets/icons/star_empty.svg' });
                        }
                        productElement.emptyRating = totalReviews - productElement.productAverageRating;
                        emptyRating = productElement[emptyRating];
                        productElement.filledStars = filledStars;
                        tempEmpty = Number(productElement.emptyRating).toFixed(1).split('.');

                        for (var idx = 0; idx < Number(tempEmpty[0]); idx++) {
                          emptyStars.push({ emptyStars: '/_ui/responsive/ccl/assets/icons/star_empty.svg' });
                        }
                        productElement.emptyStars = emptyStars;
                      }
                    });
                  });
                  if (res.vibeDropdown.dropdownItems[0].productsCarousel.products.length) {
                    res = _this2.modifyCurrentCategoryJSON(res, componentUid);
                    sessionStorage.setItem('allCarouselData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
                    _this2.allCarouselData.push(res);
                    _this2.customData.allData = res;
                    _this2.customData.allData.haveVibes = _this2.customData.allData.vibeDropdown.dropdownItems.length > 0;
                    _this2.customData.activeData = res.vibeDropdown.dropdownItems.filter(function (x) {
                      return x.active;
                    })[0].productsCarousel;
                    if (_this2.customData.activeData.type === 'owl-carousel') {
                      _this2.customData.activeData.isSingleCarousel = true;
                    } else {
                      _this2.customData.activeData.isSingleCarousel = false;
                    }
                    if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
                      _this2.customData.activeData.lazyLoadingEnabled = true;
                    } else {
                      _this2.customData.activeData.lazyLoadingEnabled = false;
                    }
                    _this2.loadHtml(_this2.customData, isHtmlEvents);
                    _this2.customData = {};
                  }
                }
              }
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](2);
              LoadCarouselError = { replaceHTMLError: _context2.t0 };

              console.log(LoadCarouselError);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 10]]);
    }))();
  },
  modifyCurrentCategoryJSON: function modifyCurrentCategoryJSON(jsonData, componentUid) {
    var modifiedJSON = jsonData;
    var newProductsCarousel = modifiedJSON.vibeDropdown.dropdownItems[0].productsCarousel;
    var vibeType = '';
    var changeAtcClass = '';
    var changedProductsCarousel = this.changeCurrentCarouselType(newProductsCarousel);
    var carouselLength = modifiedJSON.vibeDropdown.dropdownItems;
    for (var i = 0; i < carouselLength.length; i++) {
      for (var j = 0; j < carouselLength[i].productsCarousel.products.length; j++) {
        vibeType = carouselLength[i].productsCarousel.products[j].vibeProductType;
        if (carouselLength[i].productsCarousel.products[j].strikeOutPrice === null) {
          carouselLength[i].productsCarousel.products[j].strikeOutPrice = '';
        }
        if (carouselLength[i].productsCarousel.products[j].childStrikeOutPrice === null) {
          carouselLength[i].productsCarousel.products[j].childStrikeOutPrice = '';
        }
        changeAtcClass = this.addToCartClass(vibeType);
        carouselLength[i].productsCarousel.products[j].addToCartClass = changeAtcClass;
      }
    }

    modifiedJSON.vibeDropdown.dropdownItems[0].productsCarousel = changedProductsCarousel;
    modifiedJSON.componentUid = componentUid;
    return modifiedJSON;
  },
  addToCartClass: function addToCartClass(vibeType) {
    var addToCartClass = '';
    switch (vibeType) {
      case 'EX':
        addToCartClass = 'checkoutConflictBtn';
        break;
      case 'SP':
        addToCartClass = 'calendarOpenBtn';
        break;
      case 'CHEERS':case 'BUBBLES':case 'INTERNET':case 'FTTF':
        {
          addToCartClass = 'clp-add-to-cart-btn';
          break;
        }
      case 'SFP':case 'SFAP':case 'SF':
        {
          addToCartClass = 'alcohol-atc-modal-open-button';
          break;
        }
      case 'FS':
        addToCartClass = 'btn-add-cart';
        break;
      default:
        addToCartClass = 'btn-add-cart';
        break;
    }
    return addToCartClass;
  },
  changeCurrentCarouselType: function changeCurrentCarouselType(changeProductsCarousel) {
    switch (Number(changeProductsCarousel.type)) {
      case 1:
        changeProductsCarousel.type = 'owl-carousel';
        break;
      case 2:
        changeProductsCarousel.type = 'owl-carousel-2';
        break;
      case 3:
        changeProductsCarousel.type = 'owl-carousel-3';
        break;
      case 4:
        changeProductsCarousel.type = 'owl-carousel-4';
        break;
      default:
        changeProductsCarousel.type = changeProductsCarousel.type;
        break;
    }
    return changeProductsCarousel;
  },
  clickEventsOnHtml: function clickEventsOnHtml() {
    var _this3 = this;

    $(document.body).on('click keypress', '.vibe-item', function (e) {
      if (e.type === 'click' || e.keyCode === 13) {
        var currentTarget = e.currentTarget;

        e.stopImmediatePropagation();
        var id = currentTarget.parentElement.id.split(/-(.+)/)[1];

        $('#dropdownVal-' + id)[0].innerText = '';
        $('#dropdownVal-' + id)[0].innerText = currentTarget.innerText;
        $('.vibe-item').removeClass('active');
        currentTarget.className += ' active'; // Append active class to selected
        var selectedData = [];
        $.each(_this3.allCarouselData, function (index, value) {
          value.vibeDropdown.dropdownItems.forEach(function (element) {
            element.active = false;
          });
          if (value.componentUid === id) {
            _this3.customData.allData = value;
            selectedData = value.vibeDropdown.dropdownItems.filter(function (x) {
              return x.value === currentTarget.dataset.value;
            });
          }
        });
        if (selectedData.length) {
          selectedData[0].active = true;
          _this3.customData.activeData = _this3.changeCurrentCarouselType(selectedData[0].productsCarousel);
          if (_this3.customData.activeData.type === 'owl-carousel') {
            _this3.customData.activeData.isSingleCarousel = true;
          } else {
            _this3.customData.activeData.isSingleCarousel = false;
          }
        }
        _this3.replaceHtml(id, _this3.customData);
      }
    });
  },
  loadHtml: function loadHtml(jsonData, isHtmlEvents) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var replace, ajaxUrl, componentUid, inputDataObj, resp, dynamicHtml, VibeAPIError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              replace = 'assets';
              ajaxUrl = '/_ui/responsive/ccl/' + replace + '/templates/vibe-dropdown/vibe-dropdown.html';
              componentUid = jsonData.allData.componentUid;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showCustomLoader"](componentUid);
              _context3.prev = 4;
              inputDataObj = {
                url: ajaxUrl,
                type: 'GET'
              };
              _context3.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 8:
              resp = _context3.sent;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["removeCustomLoader"](componentUid);
              dynamicHtml = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](resp, jsonData);

              $('#' + componentUid).replaceWith(dynamicHtml);
              if (isHtmlEvents) {
                _this4.clickEventsOnHtml();
                CCL.carousel.carousel3_4Navigation();
                _this4.bulletsContext();
              }
              _this4.carouselFunctions(); // Load carousel jquery after bindind html

              // Switch for favorite functionality
              if ($('#isfavoritesEnabled').length) {
                console.dir($('#isfavoritesEnabled'));
                if ($('#isfavoritesEnabled')[0].dataset.enabled === true || $('#isfavoritesEnabled')[0].dataset.enabled === 'true') {
                  $('body').find('.fav-section').removeClass('d-none');
                }
              }
              _context3.next = 22;
              break;

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3['catch'](4);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["removeCustomLoader"](componentUid);
              VibeAPIError = { replaceHTMLError: _context3.t0 };

              console.log(VibeAPIError);

            case 22:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4, [[4, 17]]);
    }))();
  },
  replaceHtml: function replaceHtml(id, data) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var replace, ajaxUrl, inputDataObj, newResponse, dynamicHtml, VibeAPIError;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showCustomLoader"](id);
              replace = 'assets';
              ajaxUrl = '/_ui/responsive/ccl/' + replace + '/templates/vibe-dropdown/vibe-dropdown.html';
              _context4.prev = 3;
              inputDataObj = {
                url: ajaxUrl,
                type: 'GET'
              };
              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 7:
              newResponse = _context4.sent;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["removeCustomLoader"](id);
              dynamicHtml = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](newResponse, data);

              $('#section-' + id).replaceWith(dynamicHtml);
              _this5.carouselFunctions(); // Load carousel jquery after binding html
              // Switch for favorite functionality
              if ($('#isfavoritesEnabled').length) {
                console.dir($('#isfavoritesEnabled'));
                if ($('#isfavoritesEnabled')[0].dataset.enabled === true || $('#isfavoritesEnabled')[0].dataset.enabled === 'true') {
                  $('body').find('.fav-section').removeClass('d-none');
                }
              }
              _context4.next = 20;
              break;

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4['catch'](3);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["removeCustomLoader"](id);
              VibeAPIError = { replaceHTMLError: _context4.t0 };

              console.log(VibeAPIError);

            case 20:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this5, [[3, 15]]);
    }))();
  },
  carouselFunctions: function carouselFunctions() {
    // Lazy load images
    if ($('img.lazy').length) {
      if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
        CCL.lazyLoadInstance.update();
      }
    }

    $('.owl-carousel-2').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });

    $('.owl-carousel-3').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 3
        }
      }
    });

    $('.owl-carousel-4').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });

    $('.owl-carousel-5').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 4
        },
        1200: {
          items: 5
        }
      }
    });

    $('.owl-carousel-6').owlCarousel({
      loop: false,
      nav: true,
      margin: 16,
      touchDrag: true,
      mouseDrag: true,
      responsiveClass: true,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      responsive: {
        0: {
          items: 2
        },
        768: {
          items: 3
        },
        1024: {
          items: 4
        },
        1200: {
          items: 6
        }
      }
    });

    $('.owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      touchDrag: true,
      mouseDrag: true,
      margin: 0,
      items: 1
    });
  },
  removeOverlapAndEnableSticky: function removeOverlapAndEnableSticky() {
    $('document').ready(function () {
      if (window.innerWidth < 768) {
        if ($('.overlap-cmp').length > 0) {
          $('.overlap-cmp').each(function (index1, cmpElement) {
            $(cmpElement)[0].classList.remove('overlap-cmp');
          });
        }
        if ($('.sticky-wrap').length > 0) {
          $('.sticky-wrap').each(function (index2, cmpStickyElement) {
            $(cmpStickyElement)[0].classList.remove('sticky-wrap');
          });
        }
      } else {
        var getTodoPlanner = $('#todoPlanner');
        var parentEl = getTodoPlanner[0].parentElement;
        var nextSiblingEl = parentEl.nextSibling.nextSibling;
        nextSiblingEl.childNodes[1].classList.add('sticky-wrap');
        if (parentEl.nextElementSibling) {
          var nextElementSiblng = parentEl.nextElementSibling.nextElementSibling;
          if (nextElementSiblng.childNodes.length > 1) {
            if (nextElementSiblng.childNodes[1].classList) {
              nextElementSiblng.childNodes[1].classList.add('sticky-wrap');
            }
          }
        }
      }
    });
  },
  calculatePageBullet: function calculatePageBullet(dots) {
    var items = dots.find('.owl-dot');
    var n = items.length;

    if (n > 0) {
      items.each(function (index2, i) {
        var bullet = $(i);
        var current = '';
        if (bullet.hasClass('active')) {
          current = '- Current page';
        }
        bullet.attr('aria-label', 'Slide ' + (index2 + 1) + ' of ' + n + ' ' + current);
      });
    }
  },
  bulletsContext: function bulletsContext() {
    var _this6 = this;

    setTimeout(function () {
      $('.owl-dots').each(function (index, e) {
        var dots = $(e);
        _this6.calculatePageBullet(dots);
      });
    }, 400);

    // On next item click
    $('.owl-dots button').click(function (e) {
      var currentTarget = $(e.currentTarget);
      setTimeout(function () {
        _this6.calculatePageBullet(currentTarget.parent());
      }, 200);
    });
  },
  carousel2: function carousel2() {
    setTimeout(function () {
      var carouselTop = $('.owl-carousel-2');

      if (carouselTop.find('.owl-nav').length < 2) {
        var clonedObj = carouselTop.find('.owl-nav').eq(0).clone();
        clonedObj.prependTo(carouselTop);
        carouselTop.find('.owl-nav button.owl-next').first().remove();
        carouselTop.find('.owl-nav button.owl-prev').last().remove();
      }
    }, 1000);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.hideCurtesyHoldNotification = {
  autoload: [['hideCurtesyHoldNotification', $('.c-alert-banner-courtesy-hold-notification').length > 0]],

  hideCurtesyHoldNotification: function hideCurtesyHoldNotification() {
    $('.close-notification').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        var targetElement = $(event.target).parents('.c-alert-banner-courtesy-hold-notification');
        $(targetElement).removeClass('show');
      });
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.hideCutoffNotification = {
  autoload: [['hideCutoffNotification', $('.c-alert-banner-cut-off-notification').length > 0]],

  hideCutoffNotification: function hideCutoffNotification() {
    $('.close-notification').each(function (index, element) {
      $(element).click(function (event) {
        event.preventDefault();
        var targetElement = $(event.target).parents('.c-alert-banner-cut-off-notification');
        $(targetElement).removeClass('show');
      });
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.FasterToFunCategory = {
  autoload: [['stateRoom', $('.custom-control.custom-checkbox.stateroom-check').length > 0]],
  stateRoom: function stateRoom() {
    $.each($('.custom-control.custom-checkbox.stateroom-check'), function (index, element) {
      $(element).on('click', function (event) {
        $('#ftf-add-to-cart').css('pointer-events', 'none');
        var bookingIdArray = '';
        $.each($('.custom-control.custom-checkbox.stateroom-check'), function (i, element1) {
          if ($(element1)[0].children[0].checked) {
            $('#ftf-add-to-cart').css('pointer-events', 'all');
            var p = $(element1)[0].children[0].getAttribute('data-bookingid');
            bookingIdArray += p ? ','.concat(p) : p;
          }
        });
        $('#ftf-add-to-cart').attr('data-bookingIds', bookingIdArray);
      });
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.addAnotherAccessDetails = {
  autoload: [['addAnotherAccessDetails', $('#organizerAccessModal').length > 0], ['bookingsValidation', $('#organizerAccessModal').length > 0], ['saveOrganizerDetails', $('#organizerAccessModal').length > 0], ['modalEvents', $('#organizerAccessModal').length > 0]],

  tempArr: [],
  ajaxResponse: [],
  isorganizer: false,
  tryCount: 0,
  retryLimit: 3,

  guidGenerator: function guidGenerator() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  },
  addAnotherAccessDetails: function addAnotherAccessDetails() {
    var _this = this;

    $('body').on('click', '.organizer-access-modal-open-button', function (event) {
      // gfunctions.hideModal('bookingBuddyModal'); keeping as opeen as ccl requested.
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showModal"]('organizerAccessModal');
      _this.isorganizer = false;
      if (event.currentTarget.dataset.isorganizer && event.currentTarget.dataset.isorganizer === 'true') {
        _this.isorganizer = true;
      }
      _this.toOriginalState();
    });

    $('body').on('click', '#organizerAccessModal .close', function (event) {
      if (_this.ajaxResponse.length) {
        if (_this.ajaxResponse.some(function (x) {
          return x.success === true || x.success === 'true';
        })) {
          // everything got added successfully then set the cookie
          if (_this.ajaxResponse.length) {
            _this.setActiveSailing(_this.ajaxResponse[0].bookingNumber);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideModal"]('organizerAccessModal');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideModal"]('organizerAccessModal');
      }
      setTimeout(function () {
        $('body').addClass('modal-open');
      }, 500);
    });

    $('body').on('click', '.add-another', function (event) {
      //  $('.save-organizer-details').prop('disabled', true);

      event.preventDefault();
      var id = _this.guidGenerator();
      var getDivCount = $('#addedAccess-1').length + 1;
      var hideClass = _this.isorganizer ? 'hide-save-to-profile' : '';
      var accessform = '\n        <div class="access-form newly-added" id=\'addedAccess-' + id + '\'>\n            <div class="input-wrap">\n                <div class="user-input-wrp size-md booking-id">\n                  <label></label>\n                  <input type="text" autocomplete="off" id="bookingId-' + id + '" class="inputText booking-id-input" aria-label="Please enter booking id" required />\n                  <span class="floating-label">Booking #</span>\n                </div>\n                <div class="input-errors">\n                  <span role="alert" aria-live="assertive" aria-label="Booking number is invalid">Booking number is invalid</span>\n                </div>\n            </div>\n            <div class="input-wrap">\n                <div class="user-input-wrp size-lg">\n                  <label></label>\n                  <input type="text" autocomplete="off" id="guestName-' + id + '" class="inputText guestname-input" aria-label="Please Enter last name of guest" required />\n                  <span class="floating-label">Last Name of Guest</span>\n                </div>\n              <div class="input-errors">\n                <span role="alert" aria-live="assertive">Last Name is invalid</span>\n              </div>  \n            </div>\n            <div class="input-wrap save-to-profile-wrap">\n            This booking will be saved to your profile.\n                <div class="custom-control custom-checkbox user-input-wrp save-to-profile d-none">\n                  <input type="checkbox" checked class="custom-control-input" id="save-' + id + '">\n                  <label class="custom-control-label" for="save-' + id + '">Save this to my profile</label>\n                </div>\n            </div>    \n            <div class="error-text" role="alert" aria-live="assertive">\n              This booking number and last name combination could not be found.\n            </div>\n            <div class="user-input-wrp booking-added" style="display:none">\n              <img src="/_ui/responsive/ccl/assets/icons/check mark.svg" alt="check"/> <span>Booking Added</span>\n            </div>\n        </div>\n        ';

      if ($('.access-form').length < 7) {
        $('.add-another').show();
        $('.animation-from').append(accessform);
      }
      var accessformCount = $('.access-form').length;
      $('.add-another').attr('aria-label', accessformCount + ' of 7 maximum requests added');
      if ($('.access-form').length === 7) {
        accessformCount = 7;
        setTimeout(function () {
          $('.add-another').hide();
        }, 1000);
      }
    });
  },
  toOriginalState: function toOriginalState() {
    $('.save-organizer-details').prop('disabled', true);
    if ($('.modal:visible').length) {
      setTimeout(function () {
        $('body').addClass('modal-open');
      }, 500);
    }
    // Remove newly added and blank first row values
    $('.newly-added').remove();
    $('#bookingId-input1').val('');
    $('#guestName-input1').val('');
    $('#addedAccess-1 .booking-added').hide();
    $('#addedAccess-1 .save-to-profile-wrap').show();
    $('#addedAccess-1 .save-to-profile-input')[0].checked = true;
    $('#addedAccess-1 .error-text').hide();
    $('#addedAccess-1').removeClass('div-disable');
    if ($('.access-form').length < 7) {
      $('.add-another').show();
    }
    // if (this.isorganizer) {
    //   $('#organizerAccessModal .save-to-profile-wrap').hide();
    // }
  },
  bookingsValidation: function bookingsValidation() {
    var _this2 = this;

    $('.c-organizer-access-modal').on('keyup', '.access-form .booking-id-input', function (e) {
      $(e.currentTarget).removeClass('not-valid');
      $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).hide();
      $(e.currentTarget.offsetParent.parentElement.parentElement).find('.error-text').hide();
      $(e.currentTarget).attr('maxlength', '6');
      var regex = /^[0-9a-zA-Z]+$/;
      if (e.currentTarget.value.length < 6 && e.currentTarget.value.length > 0 && $(e.currentTarget).hasClass('booking-id-input') || !regex.test(e.currentTarget.value) && e.currentTarget.value.length > 0) {
        $(e.currentTarget).addClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).attr('aria-label', 'Booking Number ' + e.currentTarget.value + ' is invalid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).show();
      } else {
        $(e.currentTarget).removeClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).hide();
      }
      _this2.validateInputs();
    });

    $('.c-organizer-access-modal').on('keyup', '.access-form .guestname-input', function (e) {
      var regex = /^[a-zA-Z\-' ]{0,32}$/;
      $(e.currentTarget.offsetParent.parentElement.parentElement).find('.error-text').hide();
      if (regex.test(e.currentTarget.value)) {
        $(e.currentTarget).removeClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).hide();
      } else {
        $(e.currentTarget).addClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).show();
      }
      _this2.validateInputs();
    });
  },
  validateInputs: function validateInputs() {
    var isError = true;
    $('.access-form').each(function (index, element) {
      var bookingNumberElement = element.children[0].children[0].children[1];
      var lastNameElement = element.children[1].children[0].children[1];

      // check if atleast one line is correct
      // if ((bookingNumberElement.value && lastNameElement.value) && (!$(bookingNumberElement).hasClass('not-valid') && !$(lastNameElement).hasClass('not-valid'))) {
      //   isError = false;
      // }

      // check if any line has error
      // if ((bookingNumberElement.value === '' || lastNameElement.value === '') || ($(bookingNumberElement).hasClass('not-valid') || $(lastNameElement).hasClass('not-valid'))) {
      //   isError = true;
      // }
      if (bookingNumberElement.value !== '' && lastNameElement.value !== '' && !$(bookingNumberElement).hasClass('not-valid') && !$(lastNameElement).hasClass('not-valid')) {
        isError = false;
      }
    });

    if (isError) {
      $('.save-organizer-details').prop('disabled', true);
    } else {
      $('.save-organizer-details').prop('disabled', false);
    }
  },
  saveOrganizerDetails: function saveOrganizerDetails() {
    var _this3 = this;

    $('.save-organizer-details').click(function () {
      var bookings = [];
      $('.access-form').each(function (index, element) {
        var bookingNumber = element.children[0].children[0].children[1].value.toUpperCase();
        var lastName = element.children[1].children[0].children[1].value.toUpperCase();
        var saveToProfile = _this3.isorganizer ? false : element.children[2].children[0].children[0].checked;
        if (bookingNumber && lastName) {
          var bookingObj = { bookingNumber: bookingNumber, lastName: lastName, saveToProfile: saveToProfile };
          bookings.push(bookingObj);
        }
        // remove all classes starting with 'row-'
        $(element).attr('class', function (i, c) {
          return c.replace(/(^|\s)row-\S+/g, '');
        });
        // add dynamic classes to div to show error msgs on response
        if ($(element.children[0].children[0]).hasClass('booking-id')) {
          $(element).addClass('row-' + bookingNumber + '_' + lastName);
          $(element).removeClass('div-disable');
        }
      });
      _this3.orgAccessModalResponse(bookings);
    });
  },
  orgAccessModalResponse: function orgAccessModalResponse(bookings) {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();

    var ajaxUrl = '';
    var ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/organizer-access-response.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/booked/api/v1.0/bookings';
      ajaxType = 'POST';
    }
    var token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ bookings: bookings }),
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      $('.booking-added').hide();
      $('.error-text').hide();

      if (response.code && response.code === 'RequestsFailed') {
        _this4.showAddedBooking(response.innerError.data.responses);
      } else {
        _this4.showAddedBooking(response.responses);
      }
    }).fail(function (_ref) {
      var responseJSON = _ref.responseJSON;

      // When we are getting 409 but getting the response in return
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      $('.booking-added').hide();
      $('.error-text').hide();
      if (responseJSON.code && responseJSON.code === 'RequestsFailed') {
        _this4.showAddedBooking(responseJSON.innerError.data.responses);
      } else {
        _this4.showAddedBooking(responseJSON.responses);
      }
      console.log('Something went wrong while update organizer access');
    });
  },
  showAddedBooking: function showAddedBooking(responses) {
    if (responses.length) {
      this.ajaxResponse = responses;
    }
    var errCount = [];
    var focusOn = false;
    $.each(responses, function (index, cValue) {
      var curentClass = '.row-' + cValue.bookingNumber + '_' + cValue.lastName;
      if (!cValue.success || cValue.success === 'false') {
        $(curentClass).find('.error-text').html('This booking number and last name combination could not be found');
        errCount.push(cValue.success);
        if (cValue.details.length) {
          if (cValue.details[0].code.toString() === '5541') {
            var msg = cValue.details[0].message ? cValue.details[0].message : 'This booking number and last name combination could not be found';
            $(curentClass).find('.error-text').html(msg);
          }
        }
        $(curentClass).find('.error-text').show();
        if (!focusOn) {
          $(curentClass).find('.booking-id-input').addClass('ada-element-focus');
          $(curentClass).find('.booking-id-input').focus();
          focusOn = true;
        }
      } else {
        $(curentClass).addClass('div-disable');
        $(curentClass).find('.booking-added').attr('aria-label', 'booking ' + cValue.bookingNumber + ' added to profile');
        var _msg = cValue.addedTravelWith ? 'Booking added and set as travel companion' : 'Booking added';
        $(curentClass).find('.booking-added span').text(_msg);
        $(curentClass).find('.booking-added').attr('role', 'alert').attr('aria-live', 'assertive');
        $(curentClass).find('.booking-added').css('display', 'inline-block');
        $(curentClass).find('.save-to-profile-wrap').hide();
      }
    });

    if (responses.every(function (x) {
      return x.success === true || x.success === 'true';
    })) {
      if (responses.every(function (x) {
        return x.addedTravelWith === true || x.addedTravelWith === 'true';
      })) {
        $('#organizerAccessModal .booking-success-alert').find('.success-msg').hide();
        $('#organizerAccessModal .booking-success-alert').find('.success-companion-msg').show();
      } else {
        $('#organizerAccessModal .booking-success-alert').find('.success-msg').show();
        $('#organizerAccessModal .booking-success-alert').find('.success-companion-msg').hide();
      }
      // everything got added successfully then set the cookie
      if (responses.length) {
        this.setActiveSailing(responses[0].bookingNumber);
      }
    }
  },


  /* eslint-disable */
  setActiveSailing: function setActiveSailing(id) {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/refresh-sailings/' + id
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["setSailingContextCookie"](response.activeSailingId);
      $('#organizerAccessModal .booking-success-alert').removeClass('d-none');
      setTimeout(function () {
        $('#organizerAccessModal').modal('hide');
        window.location.href = '/booked/home';
      }, 4000);
    }).fail(function (xhr) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      if (xhr.status === 404) {
        _this5.tryCount++;
        if (_this5.tryCount <= _this5.retryLimit) {
          // if there was an error, wait 4 seconds and re-run the function
          setTimeout(function () {
            console.log('Retrying call again. Try - ' + _this5.tryCount);
            _this5.setActiveSailing(id);
          }, 3000);
        }
      }
      console.log('refresh sailing ajax failed');
    });
  },

  /* eslint-enable */
  modalEvents: function modalEvents() {
    var modalEl = $('#organizerAccessModal');

    modalEl.find('button.close').on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        var lastFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl, 'last');
        lastFocusable.focus();
      }
    });
    modalEl.find('.add-another').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        if (modalEl.find('.save-organizer-details:disabled').length > 0) {
          var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.save-organizer-details').focus();
        }
      }
    });
    modalEl.find('.save-organizer-details').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.airportTransfersCategoroy = {
  autoload: [['generateTripInfo', $('.round-trip').length > 0], ['wheelChair', $('.wheel-chair-service').length > 0]],

  wheelChair: function wheelChair() {
    $('.airport-add-to-cart').attr('data-specialService', JSON.parse($('.wheel-chair-service').attr('data-flag')));
    $('#wheel-chair0').change(function (event) {
      $('.airport-add-to-cart').attr('data-specialService', event.target.checked);
    });
    $('#wheel-chair1').change(function (event) {
      $('.airport-add-to-cart').attr('data-specialService', event.target.checked);
    });
  },
  generateTripInfo: function generateTripInfo() {
    $('.airport-add-to-cart').attr('disabled', 'disabled');
    $('.selectable-link').each(function (index, element) {
      element.dataset.selected = false;
    });
    $('.selectable-link').on('click keypress', function (event) {
      var p = event.target.getAttribute('data-name');
      var group = $('a'.concat('[data-name=').concat(p).concat(']'));
      if ($(event.target).hasClass('selected')) {
        $(event.target).removeClass('selected');
        $('.airport-add-to-cart').attr('disabled', 'disabled');
        $(event.currentTarget).attr('aria-label', $(event.currentTarget).attr('aria-label').replace(/selected/g, ''));
      } else {
        $(group).removeClass('selected');
        $(event.currentTarget).attr('aria-label', $(event.currentTarget).attr('aria-label') + ' selected');
        $(event.target).addClass('selected');
      }
      var a = $('.round-trip').find('.selectable-link.selected');
      if (a.length) {
        if (a[0].dataset.tripid) {
          $('.airport-add-to-cart').removeAttr('disabled');
        }
        if (!a[0].dataset.tripid) {
          $('.airport-add-to-cart').attr('disabled', 'disabled');
        }
        var variants = a[1] ? a[0].dataset.tripid.concat(','.concat(a[1].dataset.tripid)) : a[0].dataset.tripid;
        $('.airport-add-to-cart').attr('data-variantids', variants);
      } else {
        $('.airport-add-to-cart').attr('data-variantids', '');
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.HourPromo = {
  autoload: [['initialLoad', $('.promo48Hours').length > 0]],

  allData: {},

  initialLoad: function initialLoad() {
    var _this = this;

    $('.promo48Hours').click(function (e) {
      _this.loadJsonModalData();
    });
  },
  loadJsonModalData: function loadJsonModalData() {
    var _this2 = this;

    var ajaxUrl = '';
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/48-hour-promotion/48-hour-promotion.json';
    } else {
      ajaxUrl = '/shop/promotion/getProductsForPromotion';
    }
    var dataObj = {
      discount: $('.promo48Hours').data('discount')
    };
    var token = $('#csrfSessionToken').data('csrf');
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      headers: {
        CSRFToken: token
      },
      data: dataObj
    }).done(function (response) {
      _this2.loadHtmlModalData(response);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  loadHtmlModalData: function loadHtmlModalData(jsonData) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/48-hour-promotion/48-hour-promotion.html'
    }).done(function (response) {
      $.each(jsonData.portCards, function (index, value) {
        $.each(value.productCards, function (i, v) {
          v.active = i === 0;
          v.priceString = _this3.getPriceString(v);
        });
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      });
      _this3.allData = jsonData;
      var tempHtml = response.replace('{{$whyBookSection}}', _this3.allData.definiteTimePromoWhyBookDescription);
      var html = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["createDynamicHTML"](tempHtml, _this3.allData);
      $('#dynamicPromotions').empty().append(html);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showModal"]('promo48Hours');
      _this3.loadCarousel();
      _this3.activateClickEvents();
      _this3.modalEvents();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while loading html');
    });
  },
  getPriceString: function getPriceString(obj) {
    if (obj.salesPerUnitDescription) {
      return [{
        priceVal: obj.adultPriceTo,
        priceText: obj.salesPerUnitDescription
      }];
    } else if (obj.adultPriceTo === obj.childPriceTo) {
      return [{
        priceVal: obj.adultPriceTo,
        priceText: 'Person'
      }];
    }
    return [{
      priceVal: obj.adultPriceTo,
      priceText: 'Adult, '
    }, {
      priceVal: obj.childPriceTo,
      priceText: 'Child'
    }];
  },
  activateClickEvents: function activateClickEvents() {
    var _this4 = this;

    $('#addExcPromotions').click(function (e) {
      _this4.ajaxOnSubmit();
    });
  },
  loadCarousel: function loadCarousel() {
    var _this5 = this;

    var owl = $('.owl-carousel');
    owl.owlCarousel({
      loop: false,
      nav: true,
      margin: 0,
      items: 1,
      navText: ['<i class="fas fa-chevron-left" aria-label="Previous items in the Carousel"></i>', '<i class="fas fa-chevron-right" aria-label="Next items in the Carousel"></i>'],
      onDragged: function onDragged(e) {
        console.log('dragged');
        console.dir(e);
      }
    });

    setTimeout(function () {
      $('.owl-item.active .c-product-card').attr('tabindex', '0').attr('data-tabindex', '0');
      $('.c-product-card').addClass('ccl-negative-outline');

      _this5.bulletsContext();

      // On next item click
      $('.owl-dots button').click(function (e) {
        var currentTarget = $(e.currentTarget);
        setTimeout(function () {
          _this5.calculatePageBullet(currentTarget.parent());
        }, 200);
      });
    }, 500);

    var modalId = $('#promo48Hours');
    modalId.find('.owl-carousel').each(function (index, e) {
      var carouselTop = $(e);

      // Arrow Order
      var clonedObj = carouselTop.find('.owl-nav').clone();
      clonedObj.prependTo(carouselTop);

      // Arrow Purge
      carouselTop.find('.owl-nav button.owl-next').first().remove();
      carouselTop.find('.owl-nav button.owl-prev').last().remove();
    });

    $('.owl-carousel').keydown(function (event) {
      var carouselTop = $(event.currentTarget);
      if (event.keyCode === 37 || event.keyCode === 38) {
        setTimeout(function () {
          var elem = carouselTop.find('.owl-item.active .c-product-card');
          _this5.setElements(elem);
          _this5.changeActive(elem[0].id);
          _this5.enablePrevArrow(carouselTop);
          _this5.calculatePageBullet(carouselTop.find('.owl-dots'));
        }, 100);
      } else if (event.keyCode === 39 || event.keyCode === 40) {
        setTimeout(function () {
          var elem = carouselTop.find('.owl-item.active .c-product-card');
          _this5.setElements(elem);
          _this5.changeActive(elem[0].id);
          _this5.enablePrevArrow(carouselTop);
          _this5.calculatePageBullet(carouselTop.find('.owl-dots'));
        }, 100);
      }
    });

    // On next item click
    $('.owl-next').click(function (e) {
      var carouselTop = $(e.currentTarget).parent().parent();
      setTimeout(function () {
        var elem = $('#' + e.currentTarget.parentElement.offsetParent.id + ' .owl-item.active .c-product-card');
        _this5.setElements(elem);
        _this5.changeActive(elem[0].id);
        _this5.enablePrevArrow(carouselTop);
        _this5.calculatePageBullet(carouselTop.find('.owl-dots'));
      }, 100);
    });

    // On previous item click
    $('.owl-prev').click(function (e) {
      var carouselTop = $(e.currentTarget).parent().parent();
      carouselTop.trigger('prev.owl.carousel');
      setTimeout(function () {
        var elem = $('#' + e.currentTarget.parentElement.offsetParent.id + ' .owl-item.active .c-product-card');
        _this5.setElements(elem);
        _this5.changeActive(elem[0].id);
        _this5.enablePrevArrow(carouselTop);
        _this5.calculatePageBullet(carouselTop.find('.owl-dots'));
      }, 100);
    });
  },
  calculatePageBullet: function calculatePageBullet(dots) {
    var items = dots.children();
    var n = items.length;

    items.attr('tabindex', '0').attr('data-tabindex', '0');

    if (n > 0) {
      items.each(function (index2, i) {
        var bullet = $(i);
        var current = '';
        if (bullet.hasClass('active')) {
          current = '- Current slide';
        }
        bullet.attr('aria-label', 'Slide ' + (index2 + 1) + ' of ' + n + ' ' + current);
      });
    }
  },
  bulletsContext: function bulletsContext() {
    var _this6 = this;

    $('.owl-dots').each(function (index, e) {
      var dots = $(e);
      _this6.calculatePageBullet(dots);
    });

    // On next item click
    $('.owl-dots button').click(function (e) {
      var currentTarget = $(e.currentTarget);
      var carouselTop = currentTarget.parent().parent();
      setTimeout(function () {
        _this6.calculatePageBullet(currentTarget.parent());
        _this6.enablePrevArrow(carouselTop);
      }, 200);
    });
  },
  enablePrevArrow: function enablePrevArrow(carouselTop) {
    if (carouselTop.find('.owl-item').first().not('active')) {
      carouselTop.find('.owl-prev').removeClass('disabled').attr('tabindex', '0').attr('data-tabindex', '0');
    }
    if (carouselTop.find('.owl-item').first().hasClass('active')) {
      carouselTop.find('.owl-prev').addClass('disabled').attr('tabindex', '-1').attr('data-tabindex', '-1');
    }
  },
  setElements: function setElements(elem) {
    setTimeout(function () {
      elem.attr('tabindex', '0').attr('data-tabindex', '0');
      elem.focus();
    }, 500);
  },
  changeActive: function changeActive(id) {
    $.each(this.allData.portCards, function (index, value) {
      if (value.productCards.filter(function (x) {
        return x.variantId === id;
      }).length) {
        $.each(value.productCards, function (i, v) {
          v.active = v.variantId === id;
        });
      }
    });

    this.ajaxOnChange();
  },
  ajaxOnChange: function ajaxOnChange() {
    var _this7 = this;

    var ajaxData = this.getActive();
    var discountApplied = this.allData.productDiscountSummary.percentageDiscount;
    var token = $('#csrfSessionToken').data('csrf');
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      data: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ productIds: ajaxData, discount: discountApplied })),
      url: '/shop/promotion/getDiscountSummaryForPromotion',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](response);
      _this7.updateTotal(response);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error Occured');
    });
  },
  updateTotal: function updateTotal(response) {
    var productDiscountSummary = response.productDiscountSummary;

    $('.subtotal-div .subtotal')[0].firstElementChild.nextElementSibling.innerHTML = '$' + productDiscountSummary.subTotal;
    $('.subtotal-div .discount')[0].firstElementChild.nextElementSibling.innerHTML = productDiscountSummary.percentageDiscount + '%';
    $('.subtotal-div .saving')[0].firstElementChild.nextElementSibling.innerHTML = '-$' + productDiscountSummary.savings;
    $('.subtotal-div .total')[0].firstElementChild.nextElementSibling.innerHTML = '$' + productDiscountSummary.totalPrice;
  },
  ajaxOnSubmit: function ajaxOnSubmit() {
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    var ajaxData = this.getActive();
    var token = $('#csrfSessionToken').data('csrf');
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'POST',
      data: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ productIds: ajaxData })),
      url: '/shop/promotion/cart/addToCart',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideModal"]('promo48Hours');
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](response);
      $('.c-alert-banner-courtesy-hold-notification.show').hide();
      console.log('Data submit success');
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error Occured');
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    });
  },
  getActive: function getActive() {
    var tempArr = [];
    $.each(this.allData.portCards, function (index, value) {
      var isActive = value.productCards.filter(function (x) {
        return x.active;
      });
      if (isActive.length) {
        tempArr.push(isActive[0].variantId);
      }
    });

    return tempArr;
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#promo48Hours');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.multipleSailing = {
  autoload: [['dropdownClick', $('.userSelect-item').length > 0], ['modalEvents', $('#multipleSailingModal').length > 0]],
  dropdownClick: function dropdownClick() {
    $('.userSelect-item').click(function (e) {
      $('#sailingDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#multipleSailingModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.multipleSailingExtended = {
  autoload: [['ageClick', $('.age-item').length > 0], ['sailingClick', $('.sailing-item').length > 0], ['modalEvents', $('#multipleSailingExtendedModal').length > 0]],
  ageClick: function ageClick() {
    $('.age-item').click(function (e) {
      $('#ageDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  },
  sailingClick: function sailingClick() {
    $('.sailing-item').click(function (e) {
      console.dir(e.currentTarget.innerText);
      $('#sailingMenu')[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#multipleSailingExtendedModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.bookingBuddyModal = {
  autoload: [['radioSelect', $('.booking-info').length > 0], ['modalEvents', $('#BookingBuddyModal').length > 0]],
  radioSelect: function radioSelect() {
    $('body').on('click keypress', '.booking-place-date', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        console.dir();
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').removeClass('show');
      }
    });
    $('body').on('click keypress', '.booked-cruiser-label', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        console.dir(event.currentTarget);
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').addClass('show');
      }
    });
    $('body').on('click keypress', '.logged-out-user-label', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        console.dir(event.currentTarget);
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.booked-cruiser-form').removeClass('show');
        $('.logged-out-user-form').addClass('show');
      }
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#BookingBuddyModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);


/* eslint-disable */
CCL.editGuestSnorkel = {
  autoload: [['submitData', $('.saveEditGuest_Transfers').length > 0]],
  submitData: function submitData() {
    var _this = this;

    $('body').on('click', '.saveEditGuest_Transfers', function (event) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
      var guestsId = [];
      var productId = event.target.dataset.productid;
      var preSalesId = event.target.dataset.presalesid;
      var wheelchair = false;
      if ($('.card-' + preSalesId + ' .is-wheelchair').length) {
        wheelchair = $('.card-' + preSalesId + ' .is-wheelchair')[0].dataset.wheelchair === 'true' ? true : false;
      }
      $.each($('.card-' + preSalesId + ' .custom-control.custom-checkbox.box-inputs input'), function (i, element1) {
        if (element1.checked) {
          var gId = element1.dataset.guestid;
          guestsId.push(gId);
        }
      });
      var ajaxObj = {
        productId: productId,
        guestsId: guestsId,
        preSalesId: preSalesId,
        wheelchair: wheelchair
      };
      var token = $('#csrfSessionToken').data('csrf');
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
      $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/shop/cart/transfer/updateTransfersSelection',
        // url: '/_ui/responsive/ccl/assets/templates/airport-transfers/edit-guest-airport-transfers.json',
        dataType: 'json',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ajaxObj),
        headers: {
          CSRFToken: token
        }
      }).done(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        if (!res.addedGuestCount || res.addedGuestCount === 0) {
          $('.card-' + preSalesId).remove();
        }
        _this.updateHtml(res, preSalesId);
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCouponSummary"](res.conflictResponse);
        _this.showEditGuests(preSalesId, res);
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        console.log('error Occured');
      });
      var parentElement = $(event.currentTarget).parents('.edit-guest-snorkel-wrap');
      setTimeout(function () {
        parentElement.siblings('.edit-guest-snorkel-link').focus();
        parentElement.siblings('.edit-guest-snorkel-link').addClass('ada-element-focus');
        parentElement.siblings('.edit-guest-snorkel-link').attr('aria-expanded', 'false');
      }, 700);
    });

    // $('.cancelEditGuest_Transfers').on('click', (event) => {
    $('body').on('click', '.cancelEditGuest_Transfers', function (event) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
      var ajaxObj = {
        productId: event.target.dataset.productid,
        preSalesId: event.target.dataset.presalesid
      };
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
      var token = $('#csrfSessionToken').data('csrf');
      $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: '/shop/cart/transfers/productDetails',
        dataType: 'json',
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ajaxObj),
        headers: {
          CSRFToken: token
        }
      }).done(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        var presalesid = event.target.dataset.presalesid;

        _this.updateHtml(res, presalesid);
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        console.log('error Occured');
      });
      var parentElement = $(event.currentTarget).parents('.edit-guest-snorkel-wrap');
      setTimeout(function () {
        parentElement.siblings('.edit-guest-snorkel-link').focus();
        parentElement.siblings('.edit-guest-snorkel-link').addClass('ada-element-focus');
        parentElement.siblings('.edit-guest-snorkel-link').attr('aria-expanded', 'false');
      }, 700);
    });
  },
  showEditGuests: function showEditGuests(productId, data) {
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/airport-transfers/edit-guest-airport-transfers.html'
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      var timeSlots = data.conflictResponse.timeSlotsCard;
      for (var i = 0; i < timeSlots.length; i++) {
        var presales = timeSlots[i].transferInformation.preSaleId;
        timeSlots[i].transferInformation.productId = data.conflictResponse.productCard.productId;
        timeSlots[i].giftGiverFlow = data.giftGiverFlow;
        var bookingData = timeSlots[i];
        var html = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["createDynamicHTML"](response, bookingData);
        var repanitClass = '.edit-guest-snorkel-wrap.edit-guest-transfers-' + presales;
        $(repanitClass).empty().append(html);
      }
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('Something went wrong while loading dynamic HTML');
    });
  },
  updateHtml: function updateHtml(response, presalesid) {
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();

    var repanitClass = '.edit-guest-snorkel-wrap.edit-guest-transfers-' + presalesid;
    var $imgArrowIcon = $('.c-cart-card.card-' + presalesid).find('.list-item.edit-guest-snorkel-link');
    $imgArrowIcon.removeClass('open');
    $(repanitClass).slideToggle();

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateCartSummary"](response.orderSummary);
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateProductSummary"](response.orderSummary);
    if (response.cartEmpty) {
      window.location.reload();
    }
    if ($('.card-' + presalesid + ' .list-item.no-persons span').length) {
      $('.card-' + presalesid + ' .list-item.no-persons span')[0].innerText = response.addedGuestCount;
    }
    $.each($('.card-' + presalesid + ' .custom-control.custom-checkbox.box-inputs input'), function (i, element1) {
      element1.checked = false;
      $.each(response.guestInformation, function (index, value) {
        // const newGuestId = `${value.bookingId}_${value.guestId}`;
        if (element1.dataset.guestid === value.guestId) {
          element1.checked = value.guestAdded;
        }
      });
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__ = __webpack_require__(4);




/* eslint-disable */

CCL.airportAddToCart = {
  autoload: [['initialLoad', $('.airport-add-to-cart').length > 0], ['closeSuccessModal', $('.airport-add-to-cart').length > 0]],

  firstAddToCartResponse: {},
  productCode: '',
  initialLoad: function initialLoad() {
    var _this = this;

    console.log('Inside initialLoad');
    $('.airport-add-to-cart').click(function (e) {
      _this.productCode = $(e.currentTarget).data('productcode');
      console.log('conflict modal code');
      _this.loadJsonData(e);
    });
  },
  closeModal: function closeModal() {
    $('.close').click(function (e) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('transfersConflictModal');
    });
  },
  closeSuccessModal: function closeSuccessModal() {
    var _this2 = this;

    $('body').on('click', '#addToCartSuccessModal .close', function (e) {
      console.log('Success modal close button clicked');
      _this2.showConflictMessages(_this2.productCode);
    });
  },
  showConflictMessages: function showConflictMessages(ajaxObj) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var token, ajaxUrl, method, dataObject, inputDataObj, res, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              token = $('#csrfSessionToken').data('csrf');
              ajaxUrl = '';
              method = 'POST';
              dataObject = {
                productCode: ajaxObj.toString()
              };

              if (window.location.hostname === 'localhost' && window.location.port === '6565') {
                ajaxUrl = '/_ui/responsive/ccl/assets/templates/airport-close-modal/airport-close-modal.json';
                method = 'GET';
              } else {
                ajaxUrl = '/shop/cart/clp/modal';
              }
              _context.prev = 6;
              inputDataObj = {
                url: ajaxUrl,
                type: method,
                contentType: 'application/json',
                headers: {
                  CSRFToken: token
                },
                data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObject)
              };
              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](inputDataObj);

            case 10:
              res = _context.sent;

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(res);
              if (res.globalErrorMessage) {
                $('.inner-wrap.trip-options').find('.global-error-message').text(res.globalErrorMessage);
                $('.inner-wrap.trip-options').find('.global-error-message').removeClass('d-none');
                $('.inner-wrap.trip-options').find('.departure-error-message').addClass('d-none');
                $('.inner-wrap.trip-options').find('.arrival-error-message').addClass('d-none');
                _this3.disableSelectable('Departures');
                _this3.disableSelectable('Arrivals');
              } else if (res.departureConflictErrorMessage) {
                $('.inner-wrap.trip-options').find('.departure-error-message').text(res.departureConflictErrorMessage);
                $('.inner-wrap.trip-options').find('.departure-error-message').removeClass('d-none');
                _this3.disableSelectable('Departures');
              } else if (res.arrivalConflictErrorMessage) {
                $('.inner-wrap.trip-options').find('.arrival-error-message').text(res.arrivalConflictErrorMessage);
                $('.inner-wrap.trip-options').find('.arrival-error-message').removeClass('d-none');
                _this3.disableSelectable('Arrivals');
              }
              _context.next = 21;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context['catch'](6);

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              cartAPIError = { customError: _context.t0 };

              console.log(cartAPIError);

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[6, 16]]);
    }))();
  },
  disableSelectable: function disableSelectable(name) {
    var group = $('.inner-wrap.trip-options').find('a[data-name=' + name + ']');
    group.removeClass('selected');
    group.addClass('div-link');
    $('.airport-add-to-cart').attr('disabled', 'disabled');
  },
  loadJsonData: function loadJsonData(event) {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    var csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
    var targetElement = $(event.target).data('hasvariants');
    var quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    var variantId = $(event.target).attr('data-variantids');
    var isSpecialService = $(event.target).attr('data-specialService');
    var bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : '';
    var guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
    var dataObj = {
      productCodePost: $(event.target).data('productcode'),
      CSRFToken: csrf,
      qty: quantity || 1,
      variantIds: variantId,
      bookingIds: bookingIdsArray,
      guestIds: guestIdsArray,
      specialService: isSpecialService
    };

    $.ajax({
      type: 'POST',
      url: '/shop/cart/add',
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      data: dataObj,
      headers: {
        CSRFToken: csrf
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      if (!response.isProductAdded) {
        _this4.firstAddToCartResponse = response;
        _this4.loadHtmlData(response);
      } else {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('transfersConflictModal');
        CCL.addToCart.successModal(response);
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["updateHeaderCartWidget"](response);
      }
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  conflictAddToCart: function conflictAddToCart() {
    var _this5 = this;

    console.log('Inside conflictResponse');
    $('.transfer-conflict-add-to-cart').click(function (event) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
      var csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
      var guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
      var prodId = $(event.target).attr('data-productid') ? $(event.target).attr('data-productid') : '';
      var preSaleId = $(event.target).attr('data-presaleid') ? $(event.target).attr('data-presaleid') : '';
      var conflictPreSaleId = $(event.target).attr('data-conflictingpresalesid') ? $(event.target).attr('data-conflictingpresalesid') : '';
      var dataObj = {
        productCodePost: $(event.target).data('productcode'),
        CSRFToken: csrf,
        guestsId: guestIdsArray,
        productId: prodId,
        preSalesId: preSaleId,
        conflictingPreSaleId: conflictPreSaleId
      };

      $.ajax({
        type: 'POST',
        url: '/shop/cart/transfer/addTransfersGuests',
        contentType: 'application/json',
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj),
        headers: {
          CSRFToken: csrf
        }
      }).done(function (res) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
        if (res.productAdded && !res.showDepartureConflict) {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('transfersConflictModal');
          CCL.addToCart.successModal(res);
        } else {
          _this5.loadHtmlData(res.conflictResponse);
        }
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
        console.log('error while fetching data');
      });
    });
  },
  loadHtmlData: function loadHtmlData(jsonData) {
    var _this6 = this;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/transfers-conflict/transfers-conflict.html'
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      var options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
      var jsonArrivalData = jsonData.timeSlotsCard.filter(function (x) {
        return x.transferInformation.transferType.toLowerCase() === 'arrival' && (x.isConflictingTimeSlot || x.conflictingTimeSlot);
      });
      var jsonDepartureData = jsonData.timeSlotsCard.filter(function (x) {
        return x.transferInformation.transferType.toLowerCase() === 'departure' && (x.isConflictingTimeSlot || x.conflictingTimeSlot);
      });
      var arrivalPresalesId = jsonArrivalData.length ? jsonArrivalData[0].transferInformation.preSaleId : '';
      var departurePresalesId = jsonDepartureData.length ? jsonDepartureData[0].transferInformation.preSaleId : '';
      var preSalesId = void 0;
      var conflictingPresalesId = void 0;
      if (jsonArrivalData.length > 0 && jsonDepartureData.length > 0) {
        jsonData.timeSlotsCard = jsonArrivalData;
        jsonArrivalData[0].transferInformation.date = new Date(jsonArrivalData[0].transferInformation.date).toLocaleDateString('en-US', options);
        preSalesId = jsonArrivalData[0].transferInformation.preSaleId;
        var html = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](response, jsonData);
        conflictingPresalesId = jsonDepartureData[0].transferInformation.preSaleId;
        $('#transfersConflictModalContent').empty().append(html);
      } else if (jsonArrivalData.length > 0) {
        jsonData.timeSlotsCard = jsonArrivalData;
        preSalesId = jsonArrivalData[0].transferInformation.preSaleId;
        jsonArrivalData[0].transferInformation.date = new Date(jsonArrivalData[0].transferInformation.date).toLocaleDateString('en-US', options);
        var _html = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](response, jsonData);
        $('#transfersConflictModalContent').empty().append(_html);
      } else if (jsonDepartureData.length > 0) {
        jsonData.timeSlotsCard = jsonDepartureData;
        preSalesId = jsonDepartureData[0].transferInformation.preSaleId;
        jsonDepartureData[0].transferInformation.date = new Date(jsonDepartureData[0].transferInformation.date).toLocaleDateString('en-US', options);
        var _html2 = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](response, jsonData);
        $('#transfersConflictModalContent').empty().append(_html2);
      }
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showModal"]('transfersConflictModal');
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["pdpGetSelectedData"]();
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["checkboxCheck"]();
      _this6.initialLoad();
      $('.transfer-conflict-add-to-cart').attr('data-presaleid', preSalesId);
      $('.transfer-conflict-add-to-cart').attr('data-conflictingpresalesid', conflictingPresalesId);
      _this6.closeModal();
      _this6.conflictAddToCart();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      console.log('error while loading html');
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__ = __webpack_require__(4);





CCL.checkoutODG = {
  autoload: [['editDelivery', $('.delivery-details').length > 0], ['accordionSelect', $('.delivery-details-container').length > 0], ['toggleAccordion', $('.delivery-details-container').length > 0], ['editRecipient', $('.recipient-details').length > 0], ['editGiftMessage', $('.gift-options').length > 0], ['cancelEditDelivery', $('.delivery-details-container').length > 0], ['cancelEditRecipient', $('.delivery-details-container').length > 0], ['cancelEditGiftOptions', $('.delivery-details-container').length > 0], ['saveDeliverySection', $('.delivery-details-container').length > 0], ['saveRecipientSection', $('.delivery-details-container').length > 0], ['saveGiftOptionsSection', $('.delivery-details-container').length > 0], ['loadItemsToBeDeliveredOnCheck', $('.custom-control-input.delivery-option-checkbox').length > 0], ['surpriseCheckboxCall', $('.custom-checkbox .custom-control-input.surprise').length > 0], ['giftMsgCheckbox', $('.gift-options .addMessageGift').length > 0], ['getSelectedRecipientGuest', $('.delivery-details-container').length > 0], ['textAreaCharacters', $('.delivery-details-container').length > 0], ['shiftingPromoWaterMark', $('.c-checkout-onboard-delivery-card').length > 0], ['shiftingPromoWaterMark', $('.c-cart').length > 0]],

  timer: null,

  /* Suprise checkbox call */
  surpriseCheckboxCall: function surpriseCheckboxCall() {
    var _this = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.custom-checkbox .custom-control-input.surprise', function (event) {
      var deliveryType = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      var method = 'POST';
      var ajaxUrl = '/shop/checkout/saveGiftAndSurprise/' + deliveryType;
      var dataObj = {
        surprise: $(event.currentTarget).prop('checked'),
        surpriseCall: true,
        entryNumber: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('sequencenumber'),
        productId: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('productid'),
        selectedStateroom: $(event.currentTarget.parentElement.parentElement.closest('.delivery-details-container')).find('.product').data('bookingid')
      };
      _this.surpriseCheckboxAjaxCall(dataObj, event, ajaxUrl, method);
    });
  },
  surpriseCheckboxAjaxCall: function surpriseCheckboxAjaxCall(dataObj, event, ajaxUrl, methodAjax) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var token, ajaxObj, res, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = $('#csrfSessionToken').data('csrf');
              ajaxObj = {
                type: methodAjax,
                url: ajaxUrl,
                contentType: 'application/json',
                data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj),
                headers: {
                  CSRFToken: token
                }
              };
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](ajaxObj);

            case 5:
              res = _context.sent;

              _this2.loadCheckboxDataHBS(res, event);
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              _context.next = 15;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](2);
              cartAPIError = { customError: _context.t0 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[2, 10]]);
    }))();
  },

  /* Checkbox check functionality for Items to be delivered */
  loadItemsToBeDeliveredOnCheck: function loadItemsToBeDeliveredOnCheck() {
    var _this3 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.custom-control-input.delivery-option-checkbox', function (event) {
      var deliveryType = $(event.currentTarget.parentElement.parentElement.nextElementSibling).find('.delivery-details-container').data('deliverytype');
      var ajaxUrl = '';
      var method = 'GET';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-delivery-checkbox.json';
      } else {
        ajaxUrl = '/shop/checkout/toogle?deliveryType=' + deliveryType;
      }
      _this3.getItemsDelivereddData(event, ajaxUrl, method);
    });
  },
  getItemsDelivereddData: function getItemsDelivereddData(event, ajaxUrl, methodAjax) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var token, ajaxObj, res, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              token = $('#csrfSessionToken').data('csrf');
              ajaxObj = {
                type: methodAjax,
                url: ajaxUrl,
                contentType: 'application/json',
                headers: {
                  CSRFToken: token
                }
              };
              _context2.prev = 3;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](ajaxObj);

            case 6:
              res = _context2.sent;

              _this4.loadCheckboxDataHBS(res, event);
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              _context2.next = 16;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](3);
              cartAPIError = { customError: _context2.t0 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4, [[3, 11]]);
    }))();
  },
  loadCheckboxDataHBS: function loadCheckboxDataHBS(editDataObj, event) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var ajaxUrl, methodAjax, token, ajaxObj, res, html, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-delivery-checkbox-response.html';
              methodAjax = 'GET';
              token = $('#csrfSessionToken').data('csrf');
              ajaxObj = {
                type: methodAjax,
                url: ajaxUrl,
                headers: {
                  CSRFToken: token
                }
              };
              _context3.prev = 5;
              _context3.next = 8;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](ajaxObj);

            case 8:
              res = _context3.sent;
              html = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](res, editDataObj);

              $(event.target.parentNode.parentElement.nextElementSibling.closest('.delivery-details-wrapper')).empty().append(html);
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              _context3.next = 19;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3['catch'](5);
              cartAPIError = { customError: _context3.t0 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this5, [[5, 14]]);
    }))();
  },


  /* Edit Sections */
  editDelivery: function editDelivery() {
    var _this6 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click keypress', '.delivery .edit-wrap', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        var dataObj = {
          entryNumber: $(event.target.closest('.delivery-details').previousElementSibling).find('.product').attr('data-entrynumber'),
          sequenceNumber: $(event.target.closest('.delivery-details').previousElementSibling).find('.product').attr('data-sequencenumber'),
          selectedStateroom: $(event.target.closest('.delivery-details').previousElementSibling).find('.product').attr('data-bookingid')
        };
        var ajaxUrl = '';
        var method = 'POST';
        if (window.location.hostname === 'localhost' && window.location.port === '6565') {
          ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
          method = 'GET';
        } else {
          ajaxUrl = '/shop/checkout/getStateroomAndDays';
        }
        // AJAX call
        _this6.loadEditData(dataObj, event, ajaxUrl, method, $(event.currentTarget).data('editsection'), null, null);
      }
    });
  },
  editRecipient: function editRecipient() {
    var _this7 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click keypress', '.recipient .edit-wrap', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        var dataObj = {
          entryNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('entrynumber'),
          sequenceNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('sequencenumber')
        };
        var ajaxUrl = '';
        var method = 'POST';
        if (window.location.hostname === 'localhost' && window.location.port === '6565') {
          ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
          method = 'GET';
        } else {
          ajaxUrl = '/shop/checkout/getRecipientGuest';
        }
        // AJAX call
        _this7.loadEditData(dataObj, event, ajaxUrl, method, null, $(event.currentTarget).data('editsection'), null);
      }
    });
  },
  giftMsgCheckbox: function giftMsgCheckbox() {
    var _this8 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.gift-options .addMessageGift', function (event) {
      var giftMsg = $(event.currentTarget.parentElement.nextElementSibling).find('.saved-text').text();
      var checkboxElem = $(event.currentTarget).hasClass('addMessageGift');
      $(event.currentTarget.parentElement.nextElementSibling).find('.saved-text').attr('role', 'alert');
      $(event.currentTarget.parentElement.nextElementSibling).find('.saved-text').attr('aria-live', 'assertive');
      if ($(event.currentTarget).prop('checked')) {
        var result = {
          giftOptionMsg: $(event.currentTarget.parentNode.parentElement).find('.saved-text').text()
        };
        _this8.repaintSectionOnEdit(event, result, null, null, $(event.currentTarget).data('editsection'));
      } else {
        var deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
        var dataObj = {
          giftMessage: '',
          deliveryType: deliverytype, // from the data attribute of checkbox
          entryNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('entrynumber'),
          sequenceNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('sequencenumber'),
          productId: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('productid'),
          selectedStateroom: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('bookingid')
        };
        var ajaxUrl = '';
        var method = 'POST';
        if (window.location.hostname === 'localhost' && window.location.port === '6565') {
          ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
          method = 'GET';
        } else {
          ajaxUrl = '/shop/checkout/saveGiftAndSurprise/' + deliverytype;
        }
        _this8.loadSaveData(dataObj, $(event.currentTarget.parentElement.closest('.message-wrap')), ajaxUrl, method, $(event.currentTarget).data('editsection'), checkboxElem);
      }
    });
  },
  editGiftMessage: function editGiftMessage() {
    var _this9 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click keypress', '.gift-options .edit-wrap', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        event.preventDefault();
        var result = {
          giftOptionMsg: $(event.currentTarget.parentNode.parentElement).find('.saved-text').text()
        };
        $(event.currentTarget.parentNode.parentElement).find('.saved-text').hide();
        _this9.repaintSectionOnEdit(event, result, null, null, $(event.currentTarget).data('editsection'));
      }
    });
  },
  getSelectedRecipientGuest: function getSelectedRecipientGuest() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.custom-checkbox .recipient-guest', function (event) {
      var selectedGuestList = $('.custom-checkbox .recipient-guest:checked');
      if (!selectedGuestList.length) {
        $('.btn-save-recipient').attr('disabled', 'disabled');
      } else {
        $('.btn-save-recipient').removeAttr('disabled');
      }
    });
  },
  repaintSectionOnEdit: function repaintSectionOnEdit(event, result, sTypeD, sTypeR, sTypeG) {
    console.log('repaintSectionOnEdit event: ', event);
    result.sectionTypeD = sTypeD;
    result.sectionTypeR = sTypeR;
    result.sectionTypeG = sTypeG;
    var selectedGuestList = $('.custom-checkbox .recipient-guest:checked');
    result.isGuestChecked = !selectedGuestList.length;
    if (sTypeD) {
      result.productId = $(event.target.closest('.delivery-details').previousElementSibling).find('.product').data('productid');
    }
    // AJAX call for repainting edit html
    this.loadEditDataHBS(result, event);
  },
  loadEditDataHBS: function loadEditDataHBS(editDataObj, event) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var ajaxUrl, methodAjax, token, bodyBorder, ajaxObj, res, html, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboar-delivery-edit.html';
              methodAjax = 'GET';
              token = $('#csrfSessionToken').data('csrf');
              bodyBorder = $(event.target).closest('.body-border');
              ajaxObj = {
                type: methodAjax,
                url: ajaxUrl,
                headers: {
                  CSRFToken: token
                }
              };
              _context4.prev = 6;
              _context4.next = 9;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](ajaxObj);

            case 9:
              res = _context4.sent;
              html = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](res, editDataObj);

              if (editDataObj.sectionTypeG) {
                if (event.target.parentNode.closest('.message-wrap')) {
                  $(event.target.parentNode.closest('.message-wrap').nextElementSibling).empty().append(html);
                  $(event.target.parentNode.closest('.message-wrap').nextElementSibling).show();
                  $(event.target.closest('.edit-wrap')).addClass('hide');
                  _this10.calculateTextAreaCharacter($(event.currentTarget.parentNode.closest('.message-wrap').nextElementSibling).find('.gift-msg-text'));
                } else {
                  $(event.target.parentNode.closest('.message-wrap').nextElementSibling).empty().append(html);
                  $(event.target.parentNode.closest('.message-wrap').nextElementSibling).show();
                  $(event.target.closest('.edit-wrap')).addClass('hide');
                  _this10.calculateTextAreaCharacter($(event.target.parentNode.closest('.message-wrap').nextElementSibling).find('.gift-msg-text'));
                }
              } else {
                bodyBorder.next().empty().append(html);
                bodyBorder.hide();
                bodyBorder.next().show();
              }
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              _context4.next = 20;
              break;

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4['catch'](6);
              cartAPIError = { customError: _context4.t0 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 20:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this10, [[6, 15]]);
    }))();
  },
  loadEditData: function loadEditData(dataObj, editElement, ajaxUrl, methodAjax, sTypeD, sTypeR, sTypeG) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var token, ajaxObj, res, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              token = $('#csrfSessionToken').data('csrf');
              ajaxObj = {
                type: methodAjax,
                url: ajaxUrl,
                contentType: 'application/json',
                data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj),
                headers: {
                  CSRFToken: token
                }
              };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              _context5.prev = 3;
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](ajaxObj);

            case 6:
              res = _context5.sent;

              _this11.repaintSectionOnEdit(editElement, res.onBoardData, sTypeD, sTypeR, sTypeG);
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              _context5.next = 16;
              break;

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5['catch'](3);
              cartAPIError = { customError: _context5.t0 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this11, [[3, 11]]);
    }))();
  },

  /* Cancel Funtionalities */
  cancelEditDelivery: function cancelEditDelivery() {
    var _this12 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-cancel-delivery', function (event) {
      event.preventDefault();
      var ajaxUrl = '';
      var method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/getStateroomAndDays';
      }
      var dataObj = {
        entryNumber: $(event.currentTarget.closest('.delivery-details').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.delivery-details').parentElement).find('.product-wrap .product').data('sequencenumber'),
        selectedStateroom: $(event.currentTarget.closest('.delivery-details').parentElement).find('.product-wrap .product').data('bookingid')
      };
      // AJAX call
      _this12.loadCancelData(dataObj, ajaxUrl, method, event.target, 'delivery');
    });
  },
  cancelEditRecipient: function cancelEditRecipient() {
    var _this13 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-cancel-recipient', function (event) {
      event.preventDefault();
      var dataObj = {
        entryNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('sequencenumber')
      };
      var ajaxUrl = '';
      var method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/getRecipientGuest';
      }
      // AJAX call
      _this13.loadCancelData(dataObj, ajaxUrl, method, event.target, 'recipient');
    });
  },
  cancelEditGiftOptions: function cancelEditGiftOptions() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-cancel-gift', function (event) {
      event.preventDefault();
      var giftMsg = $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.saved-text').text();
      $(event.currentTarget).closest('.gift-edit-wrap').hide();
      if (giftMsg) {
        $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').removeClass('hide');
      } else {
        $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').addClass('hide');
        $(event.currentTarget.parentNode.parentElement.parentElement.previousElementSibling).find('.addMessageGift').prop('checked', false);
      }
    });
  },
  repaintDelivery: function repaintDelivery(res, target) {
    var stateroomNo = void 0;
    var mkup2 = void 0;
    var selectedStateroom = res.onBoardData.selectedStateroom;

    $.each(res.onBoardData.bookingInformation, function (i, elem) {
      if (elem.bookingId === selectedStateroom) {
        stateroomNo = elem.stateroomNumber;
        return false;
      }
      return stateroomNo;
    });
    if (selectedStateroom === 'DININGROOM') {
      mkup2 = '<div> Dining Room </div>';
    } else {
      mkup2 = '<div>Stateroom ' + stateroomNo + ': ' + res.onBoardData.selectedStateroomName + '\'s Room</div>';
    }
    var mkup1 = '<div class="flex-container">';
    var mkup3 = '<div class="edit-wrap" tabindex="0" role="button" aria-label="edit delivery details" data-editsection="delivery"><img class="edit-img" src="/_ui/responsive/ccl/assets/icons/edit.svg" alt="edit icon" role="textbox">Edit</div> </div><div>' + res.onBoardData.dayDetails + '<div>';
    $(target.parentNode.parentElement.parentElement.previousElementSibling).show();
    $(target.parentNode.parentElement.parentElement.previousElementSibling).empty().append(mkup1 + mkup2 + mkup3);
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').addClass('ada-highlighted');
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').focus();
    $(target.parentNode.parentElement.parentElement).hide();
    if (res.onBoardData.deliveryType === 'SPECIAL_TYPE_DELIVERABLE') {
      $(target.parentNode.parentElement.parentElement.previousElementSibling.closest('.delivery-details').previousElementSibling).find('.product').attr('data-bookingid', selectedStateroom);
    }
  },
  repaintRecipient: function repaintRecipient(res, target) {
    var mkup1 = '<div class="flex-container">';
    var mkup2 = '<div>' + res.onBoardData.selectedRecipientsName + '</div>';
    var mkup3 = '<div class="edit-wrap" tabindex="0" role="button" aria-label="edit recipient details" data-editsection="recipient"><img class="edit-img" src="/_ui/responsive/ccl/assets/icons/edit.svg" alt="edit icon">Edit</div> </div>';
    $(target.parentNode.parentElement.parentElement.previousElementSibling).show();
    $(target.parentNode.parentElement.parentElement.previousElementSibling).empty().append(mkup1 + mkup2 + mkup3);
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').addClass('ada-highlighted');
    $(target.parentNode.parentElement.parentElement.previousElementSibling).find('.edit-wrap').focus();
    $(target.parentNode.parentElement.parentElement).hide();
  },

  repaintGiftOptions: function repaintGiftOptions(res, target, ischeckboxElem) {
    console.log('res:', res);
    $(target.nextElementSibling).hide();
    $(target).find('.saved-text').text(res.onBoardData.giftMessage);
    $(target).find('.saved-text').attr('aria-label', 'added gift message ' + res.onBoardData.giftMessage);
    $(target).find('.saved-text').show();
    if (!res.onBoardData.giftMessage || !$(target).find('.saved-text').text()) {
      $(target).find('.edit-wrap').addClass('hide');
      $(target).find('.addMessageGift').prop('checked', false);
    } else {
      $(target).find('.edit-wrap').removeClass('hide');
      $(target).find('.edit-wrap').addClass('ada-highlighted');
      $(target).find('.edit-wrap').focus();
      if (!ischeckboxElem) {
        $(target).find('.addMessageGift').prop('checked', true);
      }
    }
  },

  loadCancelData: function loadCancelData(dataObj, ajaxUrl, methodAjax, target, section) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var token, ajaxObj, res, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              token = $('#csrfSessionToken').data('csrf');
              ajaxObj = {
                type: methodAjax,
                url: ajaxUrl,
                contentType: 'application/json',
                data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj),
                headers: {
                  CSRFToken: token
                }
              };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              _context6.prev = 3;
              _context6.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](ajaxObj);

            case 6:
              res = _context6.sent;
              _context6.t0 = section;
              _context6.next = _context6.t0 === 'delivery' ? 10 : _context6.t0 === 'recipient' ? 12 : _context6.t0 === 'giftOptions' ? 14 : 16;
              break;

            case 10:
              _this14.repaintDelivery(res, target);
              return _context6.abrupt('break', 17);

            case 12:
              _this14.repaintRecipient(res, target);
              return _context6.abrupt('break', 17);

            case 14:
              _this14.repaintGiftOptions(res, target);
              return _context6.abrupt('break', 17);

            case 16:
              return _context6.abrupt('break', 17);

            case 17:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              _context6.next = 25;
              break;

            case 20:
              _context6.prev = 20;
              _context6.t1 = _context6['catch'](3);
              cartAPIError = { customError: _context6.t1 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 25:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this14, [[3, 20]]);
    }))();
  },


  /* Save Section Functionalities */
  saveDeliverySection: function saveDeliverySection() {
    var _this15 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-save-delivery', function (event) {
      event.preventDefault();
      var deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      var dataObj = {
        selectedStateroom: $(event.currentTarget.parentElement.parentElement).find('.custom-radio .custom-control-input:checked').data('bookingid'),
        deliveryDayDetail: $(event.currentTarget.parentElement.parentElement).find('.accordion-main #sailingTime span').text(),
        deliveryType: deliverytype,
        entryNumber: $(event.currentTarget.closest('.delivery-details').previousElementSibling).find('.product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.delivery-details').previousElementSibling).find('.product').data('sequencenumber')
      };
      var ajaxUrl = '';
      var method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/saveStateroomAndDay';
      }
      // AJAX call
      _this15.loadSaveData(dataObj, event.currentTarget, ajaxUrl, method, $(event.currentTarget).data('section'), false);
    });
  },
  saveRecipientSection: function saveRecipientSection() {
    var _this16 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-save-recipient', function (event) {
      var guestIds = [];
      var deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      $.each($(event.currentTarget.parentElement.parentElement).find('.custom-checkbox .custom-control-input:checked'), function (index, elem) {
        guestIds.push($(elem).data('guestid'));
      });

      var dataObj = {
        selectedStateroom: $(event.currentTarget).data('selectedstaterooms'), // radio button stateroom,
        deliveryDayDetail: $(event.currentTarget).data('daydetails'), // selected from accordion,
        deliveryType: deliverytype, // from the data attribute of checkbox
        entryNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.recipient-details').parentElement).find('.product-wrap .product').data('sequencenumber'),
        bookingIdAppendedGuestIds: guestIds

      };
      var ajaxUrl = '';
      var method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/saveRecipientGuest';
      }
      _this16.loadSaveData(dataObj, event.currentTarget, ajaxUrl, method, $(event.currentTarget).data('section'), false);
    });
  },
  saveGiftOptionsSection: function saveGiftOptionsSection() {
    var _this17 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('click', '.btn-save-gift', function (event) {
      var deliverytype = $(event.currentTarget.closest('.delivery-details-container')).data('deliverytype');
      var isGiftChecked = $(event.currentTarget.parentElement.parentElement.parentElement.previousElementSibling).find('.addMessageGift').prop('checked');
      var dataObj = {
        giftMessage: $(event.currentTarget.parentNode.parentElement).find('.gift-input').val(),
        deliveryType: deliverytype, // from the data attribute of checkbox
        entryNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('entrynumber'),
        sequenceNumber: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('sequencenumber'),
        productId: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('productid'),
        selectedStateroom: $(event.currentTarget.closest('.gift-options').parentElement).find('.product-wrap .product').data('bookingid')
      };
      var ajaxUrl = '';
      var method = 'POST';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/_ui/responsive/ccl/assets/templates/checkout-onboard-delivery/checkout-onboard-delivery.json';
        method = 'GET';
      } else {
        ajaxUrl = '/shop/checkout/saveGiftAndSurprise/' + deliverytype;
      }
      $(event.currentTarget.parentNode.parentElement).find('.saved-text').show();
      _this17.loadSaveData(dataObj, $(event.currentTarget.parentElement.parentElement.parentElement.previousElementSibling), ajaxUrl, method, $(event.currentTarget).data('section'), isGiftChecked);
    });
  },
  loadSaveData: function loadSaveData(dataObj, target, ajaxUrl, methodAjax, section, ischeckboxElem) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var token, ajaxObj, res, cartAPIError;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
              token = $('#csrfSessionToken').data('csrf');
              ajaxObj = {
                type: methodAjax,
                url: ajaxUrl,
                contentType: 'application/json',
                data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj),
                headers: {
                  CSRFToken: token
                }
              };
              _context7.prev = 3;
              _context7.next = 6;
              return __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["doAjax"](ajaxObj);

            case 6:
              res = _context7.sent;
              _context7.t0 = section;
              _context7.next = _context7.t0 === 'delivery' ? 10 : _context7.t0 === 'recipient' ? 13 : _context7.t0 === 'giftOptions' ? 15 : 17;
              break;

            case 10:
              _this18.repaintDelivery(res, target);
              // Repainting Recipient details
              $(target.parentElement.closest('.delivery-details').nextElementSibling).find('.recipient .flex-container div')[0].innerText = res.onBoardData.selectedRecipientsName;
              return _context7.abrupt('break', 18);

            case 13:
              _this18.repaintRecipient(res, target);
              return _context7.abrupt('break', 18);

            case 15:
              _this18.repaintGiftOptions(res, target[0], ischeckboxElem);
              return _context7.abrupt('break', 18);

            case 17:
              return _context7.abrupt('break', 18);

            case 18:
              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              _context7.next = 26;
              break;

            case 21:
              _context7.prev = 21;
              _context7.t1 = _context7['catch'](3);
              cartAPIError = { customError: _context7.t1 };

              __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
              console.log(cartAPIError);

            case 26:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this18, [[3, 21]]);
    }))();
  },


  /* accordion functionality */
  toggleAccordion: function toggleAccordion() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '#dropdownDate .accordion', function (event) {
      event.preventDefault();
      $(event.currentTarget).toggleClass('active');
      $(event.currentTarget).attr('aria-live', 'assertive');
      var ariaExpanded = $(event.currentTarget).attr('aria-expanded');
      if (ariaExpanded === 'false') {
        $(event.currentTarget).attr('aria-expanded', 'true');
      } else {
        $(event.currentTarget).attr('aria-expanded', 'false');
      }
      var panel = $(event.currentTarget.nextElementSibling);
      if ($(event.currentTarget).hasClass('active')) {
        panel.removeClass('hide');
        // panel.addClass('show');
        $(panel).slideDown('slow');
        $(event.currentTarget).find('img').addClass('rotate-chevron');
      } else {
        // panel.removeClass('show');
        panel.addClass('hide');
        $(panel).slideUp('slow');
        $(event.currentTarget).find('img').removeClass('rotate-chevron');
      }
    });
  },
  accordionSelect: function accordionSelect() {
    $('.c-checkout-odg-sailing-nonsailing').on('click', '.accordion-panel .selected-item', function (e) {
      e.preventDefault();
      var parentElement = $(e.currentTarget).closest('.accordion-main');
      var elementTarget = parentElement.find('.accordion');
      var valueSelector = e.currentTarget.innerText;
      elementTarget.find('span').html(valueSelector);
      elementTarget.find('span').attr('aria-label', valueSelector + ' selected');
      elementTarget.attr('aria-label', valueSelector + ' selected');
      setTimeout(function () {
        elementTarget.addClass('ada-highlighted');
        elementTarget.focus();
      }, 200);
      $(e.currentTarget).closest('.accordion-panel').addClass('hide');
      elementTarget.removeClass('active').attr('aria-expanded', 'false');
      elementTarget.find('.drop-icon').removeClass('rotate-chevron');
      $('.accordion-panel button').removeClass('active');
      e.currentTarget.className += ' active';
    });
  },
  textAreaCharacters: function textAreaCharacters() {
    var _this19 = this;

    $('.c-checkout-odg-sailing-nonsailing').on('input keyup paste', 'textarea.gift-msg-text', function (event) {
      _this19.calculateTextAreaCharacter($(event.currentTarget));
    });

    $('.c-checkout-odg-sailing-nonsailing').on('keyup paste', 'textarea.gift-msg-text', function (event) {
      _this19.triggerValidationCall($(event.currentTarget));
    });
  },
  triggerValidationCall: function triggerValidationCall(textareaElement) {
    var _this20 = this;

    clearTimeout(this.timer); // clear timer
    this.timer = setTimeout(function () {
      _this20.triggerValidation(textareaElement);
    }, 1000);
  },
  triggerValidation: function triggerValidation(textareaElement) {
    $(textareaElement).parents('.gift-edit-wrap').find('.gift-error-msg').remove();
    $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').removeAttr('disabled');
    var giftMessage = $(textareaElement).val().toString();
    if (giftMessage && giftMessage.length > 0) {
      $.ajax({
        type: 'GET',
        contentType: 'application/json',
        url: '/shop/checkout/validateGiftMessage?giftMessage=' + giftMessage,
        dataType: 'json'
      }).done(function (res) {
        if (!res) {
          $(textareaElement).parents('.gift-edit-wrap').find('.btn-wrap .btn-save-gift').before('<div class="gift-error-msg" role="alert">There’s a problem with what you entered. Please try again</div>');
          $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', true);
        }
      }).fail(function () {
        console.log('error Occured in validation');
        $(textareaElement).parents('.gift-edit-wrap').find('.btn-wrap .btn-save-gift').before('<div class="gift-error-msg" role="alert">There’s a problem with what you entered. Please try again</div>');
        $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', true);
      });
    }
  },
  calculateTextAreaCharacter: function calculateTextAreaCharacter(textareaElement) {
    var reg = /^[\w \u000-\u109F {Nd} _,.'\-: @/’()!&]*$/;
    // const reg = $('#giftMsgRegex').data('giftmsgregex');
    var regExPattern = new RegExp(reg);
    var textValue = $(textareaElement).val().toString();
    this.triggerValidationCall(textareaElement);
    if (textValue.length > 100) {
      var newtextValue = textValue.slice(0, textValue.length - 1);
      $(textareaElement).val(newtextValue);
    }
    // if (!regExPattern.test(textValue) && textValue.length) {
    //   $(textareaElement).parents('.gift-edit-wrap').find('.gift-error-msg').remove();
    //   $(textareaElement).parents('.gift-edit-wrap').find('.btn-wrap .btn-save-gift').before('<div class="gift-error-msg" role="alert">There’s a problem with what you entered. Please try again</div>');
    //   $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', true);
    // } else {
    //   $(textareaElement).parents('.gift-edit-wrap').find('.gift-error-msg').remove();
    //   $(textareaElement).parents('.gift-edit-wrap').find('.btn-save-gift').prop('disabled', false);
    // }
    var textlimit = parseInt($(textareaElement).attr('maxlength'), 0);
    var tlength = $(textareaElement).val().length;
    $(textareaElement).val($(textareaElement).val().substring(0, textlimit));
    tlength = $(textareaElement).val().length;
    var remain = textlimit - parseInt(tlength, 0);
    var typed = textlimit - remain;
    $(textareaElement).parents('.gift-edit-wrap').find('.charac-text-remaining').attr('aria-label', typed + ' Characters typed and ' + remain + ' Characters remaining');
    $(textareaElement).parents('.gift-edit-wrap').find('.charac-text-remaining').text(remain + ' Characters remaining');
  },
  shiftingPromoWaterMark: function shiftingPromoWaterMark() {
    $('.apply-promo .user-input-wrp').find('input').each(function (index, e) {
      var $targetElement = $('#' + e.id).parent().find('.floating-label');
      if (!e.value.length) {
        e.nextElementSibling.classList.add('inputBlur');
        e.nextElementSibling.classList.remove('inputFocus');
        if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:28px !important');
        }
      } else {
        e.nextElementSibling.classList.add('inputFocus');
        e.nextElementSibling.classList.remove('inputBlur');
        if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:11px !important');
        }
      }
    });

    $('.apply-promo .user-input-wrp').find('input').on('focusout', function (e) {
      var $targetElement = $('#' + e.currentTarget.id).parent().find('.floating-label');
      if (!e.currentTarget.value.length) {
        e.currentTarget.nextElementSibling.classList.add('inputBlur');
        e.currentTarget.nextElementSibling.classList.remove('inputFocus');
        if (e.currentTarget.id === 'promo-id') {
          $targetElement.attr('style', 'top:28px !important');
        }
      }
    });

    $('.apply-promo .user-input-wrp').find('input').on('focus', function (e) {
      var $targetElement = $('#' + e.currentTarget.id).parent().find('.floating-label');
      e.currentTarget.nextElementSibling.classList.add('inputFocus');
      e.currentTarget.nextElementSibling.classList.remove('inputBlur');
      if (e.currentTarget.id === 'promo-id') {
        $targetElement.attr('style', 'top:11px !important');
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__ = __webpack_require__(4);





CCL.bookingBuddyObj = {
  autoload: [['initialLoad', $('.openBookingBuddyModal').length > 0], ['checkoutBBLoad', $('#chekoutBbDiv').length > 0], ['navCruiseClose', $('#navCruiseClose').length > 0]],
  selectedMonth: '',
  activeSailingId: null,
  bookingAdded: false,
  currentProductCode: false,
  giftGiver: null,
  checkout: false,
  allData: {},
  firstTime: false,
  loggedInUser: false,
  hasSailings: false,
  isCruiseManager: false,
  isPDP: false,
  includeAUSailings: false,
  data: {
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  },
  selectInitialShop: 'browseAllCheckBox',
  ajaxData: {
    firstName: '',
    lastName: '',
    bookingNumber: '',
    sailingStartDate: '',
    sailingEndDate: '',
    shipCode: '',
    email: '',
    phoneNumber: '',
    ageRangeBegin: '',
    ageRangeEnd: '',
    dateOfBirth: '',
    embarkationPortCode: '',
    travellingCompanionFirstName: '',
    travellingCompanionLastName: '',
    productCode: '',
    ageCode: ''
  },

  emptyObj: {
    firstName: '',
    lastName: '',
    bookingNumber: '',
    sailingStartDate: '',
    sailingEndDate: '',
    shipCode: '',
    email: '',
    phoneNumber: '',
    ageRangeBegin: '',
    ageRangeEnd: '',
    dateOfBirth: '',
    embarkationPortCode: '',
    travellingCompanionFirstName: '',
    travellingCompanionLastName: '',
    productCode: '',
    ageCode: ''
  },

  getMonthList: function getMonthList() {
    var _this = this;

    var d = new Date();
    var currentMonth = d.toLocaleString('en-us', { month: 'short' });
    var currentYear = d.getFullYear();
    var currentMonthIndex = d.getMonth(); // this.data.months.indexOf(String(currentMonth));
    var arrFromCurrentMonth = this.data.months.slice(currentMonthIndex, 12);
    var temp1 = [];
    var temp2 = [];
    $(arrFromCurrentMonth).each(function (i, v) {
      var index = _this.data.months.indexOf(_this.data.months.filter(function (x) {
        return x === v;
      })[0]);
      var selectedMonth = index + 1;
      temp1.push({
        label: v + ' ' + currentYear,
        key: selectedMonth < 10 ? '0' + selectedMonth + '-01-' + currentYear : selectedMonth + '-01-' + currentYear
      });
    });
    $(this.data.months).each(function (i, v) {
      var index = _this.data.months.indexOf(_this.data.months.filter(function (x) {
        return x === v;
      })[0]);
      var selectedMonth = index + 1;
      temp2.push({
        label: v + ' ' + (currentYear + 1),
        key: selectedMonth < 10 ? '0' + selectedMonth + '-01-' + (currentYear + 1) : selectedMonth + '-01-' + (currentYear + 1)
      });
    });
    return [].concat(temp1, temp2);
  },
  navCruiseClose: function navCruiseClose() {
    var _this2 = this;

    $('#navCruiseClose').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this2.cruiseCloseAjax();
    });
  },
  checkoutBBLoad: function checkoutBBLoad() {
    this.checkout = true;
    this.includeAUSailings = false;
    this.loadInitialModal();
  },
  loadBookinBuddyModal: function loadBookinBuddyModal(e) {
    e.preventDefault();
    this.selectInitialShop = $(e.currentTarget).data('selectshopvalue');
    if (e.currentTarget.dataset.iscruisemanager && e.currentTarget.dataset.iscruisemanager === 'true') {
      this.isCruiseManager = true;
    }
    this.loadInitialModal();
  },
  initialLoad: function initialLoad() {
    var _this3 = this;

    this.bbCarnivalGiftingBookingCookieCall();
    $(document.body).on('click keypress', '.openBookingBuddyModal', function (customEvent) {
      if (customEvent.type === 'click' || customEvent.keyCode === 13) {
        _this3.includeAUSailings = true;
        _this3.loadBookinBuddyModal(customEvent);
      }
    });
  },
  bbCarnivalGiftingBookingCookieCall: function bbCarnivalGiftingBookingCookieCall() {
    var _this4 = this;

    // check if we are on shop page
    if (/shop/i.test(window.location.pathname)) {
      var ajaxUrl = '';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = 'json-data/booking-buddy.json';
      } else {
        ajaxUrl = '/shop/gifting/getInfo';
      }
      $.ajax({
        type: 'GET',
        url: ajaxUrl
      }).done(function (response) {
        if (response.sailings && response.sailings.length) {
          if (!response.sailings.some(function (x) {
            return x.giftGiver;
          }) && __WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js__["get"]('carnivalGiftingBookingCookie-' + response.vifp)) {
            if (response.userMode === 'LOGGED_IN_NON_BOOKED_GUEST' || response.userMode === 'LOGGED_IN_BOOKED_GUEST') {
              var requestParams = __WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js__["getJSON"]('carnivalGiftingBookingCookie-' + response.vifp);
              __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this4.ajaxData, requestParams);
              _this4.save(true);
            }
          }
        }
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      });
    }
  },
  loadInitialModal: function loadInitialModal() {
    var isLbMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _this5 = this;

    var productCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isPDP = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    this.isLbMode = isLbMode;
    this.isPDP = isPDP;
    this.currentProductCode = productCode;
    //  empty data every time first modal opens
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.ajaxData, this.emptyObj); // assign empty obj
    // $.each(this.ajaxData, (k, v) => {
    //   this.ajaxData[k] = '';
    // });
    var ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/booking-buddy.json';
    } else {
      ajaxUrl = this.includeAUSailings ? '/shop/gifting/getInfo?includeAUSailings=true' : '/shop/gifting/getInfo';
    }
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getBookingBuddyModalHtml"](null, function (res) {
        response.months = _this5.getMonthList();
        response.checkout = _this5.checkout;
        // if any of the booking have giftGiver hide firstName/lastname form
        if (response.sailings) {
          _this5.bookingAdded = !response.sailings.some(function (x) {
            return x.giftGiver;
          });
        } else {
          _this5.bookingAdded = true;
        }
        response.bookingAdded = _this5.bookingAdded;
        var compiledHtml = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](res, response);
        _this5.allData = response;
        if (_this5.checkout) {
          $('#chekoutBbDiv').html(compiledHtml);
        } else {
          $('#bbModalDynamicHtmlDiv').html(compiledHtml);
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showModal"]('bookingBuddyModal');
          _this5.modalEvents();
        }
        if (response.activeSailingId && $('#' + response.activeSailingId).length) {
          $('#' + response.activeSailingId)[0].checked = true;
          _this5.activeSailingId = response.activeSailingId;
        }
        // attach click events only one time or else it will trigger multiple call
        // if (!this.firstTime) {

        //   this.firstTime = true;
        // }
        _this5.allClickEvents();
        _this5.radioSelect();

        _this5.loggedInUser = response.loggedInUser;
        _this5.hasSailings = response.hasSailings;

        // if user is in browseMode then browse option should be selected
        if (!response.loggedInUser || response.loggedInUser && !response.hasSailings) {
          $('#label-browseAllCheckBox').trigger('click');
        }

        // on checkout page open the form by default
        if (_this5.checkout) {
          $('#giftLinkFormCheckBoxLabel').trigger('click');
        }

        // if user is in cruise manager page hide right side section
        if (_this5.isCruiseManager) {
          $('.rightSidebar').hide();
          $('#BookingBuddyModalTitle').html(response.headerTextCMP);
        }
        $('.link-a-booking').hide();
        _this5.selectRadioBrowseOrGift(response);
        _this5.showComponentIfBrowseOrLoggedin(response);
        _this5.showComponentIfBookedGuestOrNotBookedG(response);
        _this5.showComponentsIfOrganizer(response);
      });

      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  selectRadioBrowseOrGift: function selectRadioBrowseOrGift(response) {
    // select the proper radio button if click in modal or gift-link in browse mode
    if (response.userMode === 'GUEST' || response.userMode === 'ANONYMOUS' || response.userMode === 'LOGGED_IN_NON_BOOKED_GUEST') {
      var radio = document.getElementById(this.selectInitialShop);
      if (!radio) {
        radio = document.getElementById('giftLinkFormCheckBox');
      }
      if (radio) {
        radio.checked = true;
        $(radio).trigger('click');
        $(radio).focus();
      }
    }
  },
  showComponentsIfOrganizer: function showComponentsIfOrganizer(response) {
    // show or hide components if the userMode is organizer
    $('.link-a-booking').removeAttr('data-isorganizer');
    if (response.userMode === 'ORGANIZER') {
      $('#linkBookinFormCheckboxContainer').hide();
      $('.link-a-booking').show();
      $('.link-a-booking').attr('data-isorganizer', 'true');
    }
  },
  showComponentIfBookedGuestOrNotBookedG: function showComponentIfBookedGuestOrNotBookedG(response) {
    // show link-a-booking component if the usermode is LOGGED_IN_BOOKED_GUEST or LOGGED_IN_NON_BOOKED_GUEST
    if (response.userMode === 'LOGGED_IN_BOOKED_GUEST' || response.userMode === 'LOGGED_IN_NON_BOOKED_GUEST') {
      $('.link-a-booking').show();
    }
  },
  showComponentIfBrowseOrLoggedin: function showComponentIfBrowseOrLoggedin(response) {
    // if user is in browseMode then browse option should be selected
    if (response.userMode === 'GUEST' || response.userMode === 'ANONYMOUS' || response.userMode === 'LOGGED_IN_BOOKED_GUEST') {
      $('#linkBookinFormCheckboxContainer').hide();
    }
  },
  fetchBooking: function fetchBooking() {
    if (this.activeSailingId === 1) {
      this.save();
    } else if (this.activeSailingId === 0) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["setSailingContextCookie"]('browse');
      this.browseAjaxCall();
    } else if (this.activeSailingId === 2) {
      this.linkBookingSubmit();
    } else {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["setSailingContextCookie"](this.activeSailingId);
      if (this.checkout) {
        this.bbSailingCheckoutAjax();
      } else if (this.isLbMode) {
        this.bbLbAddToCartAjax(this.activeSailingId);
      } else if (!this.checkout) {
        if (this.giftGiver === 'true') {
          __WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js__["set"]('giftGiver', 'true');
          window.location.href = '/shop';
        } else {
          window.location.href = '/booked/home';
        }
      }
    }
  },
  setBBActiveSailing: function setBBActiveSailing(id) {
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/refresh-sailings/' + id
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["setSailingContextCookie"](response.activeSailingId);
      setTimeout(function () {
        window.location.href = '/booked/home';
      }, 3000);
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  linkBookingSubmit: function linkBookingSubmit() {
    var _this6 = this;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    var token = $('#csrfSessionToken').data('csrf');
    var bookingNumber = $('.link-booking-number').val();
    var lastName = $('.link-last-name').val();
    var saveToProfile = $('#bb_save-to-profile-input')[0].checked;
    var bookings = [{
      bookingNumber: bookingNumber.toUpperCase(),
      lastName: lastName.toUpperCase(),
      saveToProfile: saveToProfile
    }];
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'POST',
      url: '/booked/api/v1.0/bookings',
      xhrFields: { withCredentials: true },
      crossDomain: true,
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ bookings: bookings }),
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      if (response.responses.filter(function (x) {
        return x.success;
      }).length) {
        _this6.setBBActiveSailing(response.responses[0].bookingNumber);
      } else {
        $('.link-error-text').show();
      }
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  save: function save() {
    var _this7 = this;

    var giftingSailingLookup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    var token = $('#csrfSessionToken').data('csrf');
    if ($('#checkoutCsrfToken').length) {
      token = $('#checkoutCsrfToken').data('csrf');
    }

    if (this.isLbMode) {
      this.ajaxData.productCode = this.currentProductCode;
    }

    this.ajaxData.giftingSailingLookup = giftingSailingLookup;

    // first modal data
    this.ajaxData.checkout = this.checkout;

    this.ajaxData.firstName = $('#giftLinkForm .recipient-f-name').val() ? $('#giftLinkForm .recipient-f-name').val() : this.ajaxData.firstName;
    this.ajaxData.lastName = $('#giftLinkForm .recipient-l-name').val() ? $('#giftLinkForm .recipient-l-name').val() : this.ajaxData.lastName;
    this.ajaxData.bookingNumber = $('#giftLinkForm .booking-number').val() ? $('#giftLinkForm .booking-number').val() : this.ajaxData.bookingNumber;

    this.ajaxData.bookingNumber = this.ajaxData.bookingNumber && this.ajaxData.bookingNumber !== '' ? this.ajaxData.bookingNumber.toUpperCase() : this.ajaxData.bookingNumber;
    this.ajaxData.sailingStartDate = this.selectedMonth;

    // second modal data
    this.ajaxData.shipCode = this.ajaxData.shipCode ? this.ajaxData.shipCode : '';
    this.ajaxData.email = $('.multiple-sailing-modal-dialog #emailAddress').val() ? $('.multiple-sailing-modal-dialog #emailAddress').val() : this.ajaxData.email;
    this.ajaxData.phoneNumber = $('.multiple-sailing-modal-dialog #phoneNumber').val() ? $('.multiple-sailing-modal-dialog #phoneNumber').val() : this.ajaxData.phoneNumber;

    // third modal data
    this.ajaxData.ageCode = this.ajaxData.ageCode ? this.ajaxData.ageCode : '';
    this.ajaxData.dateOfBirth = $('#sailingInfoForm #dob').val() ? $('#sailingInfoForm #dob').val() : this.ajaxData.dateOfBirth;
    this.ajaxData.embarkationPortCode = this.ajaxData.embarkationPortCode ? this.ajaxData.embarkationPortCode : '';

    this.ajaxData.travellingCompanionFirstName = $('#sailingInfoForm #travelPartnerFname').val() ? $('#sailingInfoForm #travelPartnerFname').val() : this.ajaxData.travellingCompanionFirstName;

    this.ajaxData.travellingCompanionLastName = $('#sailingInfoForm #travelPartnerLname').val() ? $('#sailingInfoForm #travelPartnerLname').val() : this.ajaxData.travellingCompanionLastName;

    var ajaxUrl = '';
    var ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/booking-buddy-1.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/gifting/booking-lookup';
      ajaxType = 'POST';
    }
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.ajaxData),
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      if (response.activeSailingId) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["setCarnivalGiftingBookingCookie"](response.vifp, _this7.ajaxData);
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["setSailingContextCookie"](response.activeSailingId);
      }
      _this7.checkNextModal(response);
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  browseAjaxCall: function browseAjaxCall() {
    var _this8 = this;

    var token = $('#csrfSessionToken').data('csrf');
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/browse-mode',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js__["remove"]('carnivalGiftingBookingCookie-' + response.vifp);
      if (!_this8.loggedInUser || _this8.loggedInUser && !_this8.hasSailings) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
      } else {
        window.location.href = '/shop';
      }
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
      // do nothing on error
    });
  },
  checkNextModal: function checkNextModal(response) {
    var _this9 = this;

    if (response.errors && response.errors.errors.length) {
      var errorhtml = '';
      $.each(response.errors.errors, function (k, v) {
        errorhtml += '\n        <img src="/_ui/responsive/ccl/assets/icons/16x16px/info_16x16px.svg" alt="error info icon">\n        <p>' + v.message + '</p><br/>';
      });

      $('body').find('#bbModalError').empty().html(errorhtml);
      $('body').find('#bbModalError').show();
      $('body').find('.btn-submit').prop('disabled', true);
      $('body').find('#checkoutBBflow').prop('disabled', true);
    } else {
      if (response.productAvailable) {
        if (response.redirectUrl) {
          // redirect to the url
          window.location.href = response.redirectUrl;
        } else {
          this.createAddToCart(response);
        }
        // checkFlag is for if user didn't select the product
      } else if (Number(response.statusCode) === 3 && !response.productAvailable && (!response.checkFlag || this.isPDP)) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
        this.openProductUnAvailableModal();
      }

      if (response.closeModal && this.checkout) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
        window.location.reload();
      }

      if (response.closeModal && !this.checkout) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
        window.location.href = '/shop';
      }
      $('.c-booking-buddy-modal #bbModalError').hide();
      if ((Number(response.statusCode) !== 2 || Number(response.statusCode) !== 3) && response.message) {
        if (Number(response.statusCode) === 4) {
          $('body').find('#bbModalError p').empty().html(response.message);
          $('body').find('#bbModalError').show();
          $('.c-booking-buddy-modal .recipient-f-name').addClass('outline').focus();
        }
        // if there is an error then empty previous data from ajax object
        // temp fix
        //  Object.assign(this.ajaxData, this.emptyObj); // assign empty obj
      }

      // second Modal
      if ((Number(response.statusCode) === 1 || Number(response.statusCode) === 2) && response.shipInfo && !response.portInfo) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getBookingBuddyModalHtml"](2, function (res) {
          var compiledHtml = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](res, response);
          $('#bbModalDynamicHtmlDiv').html(compiledHtml);
          if (_this9.checkout) {
            __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showModal"]('bookingBuddyModal');
          }
        });
      }

      // thirdModal Modal
      if ((Number(response.statusCode) === 1 || Number(response.statusCode) === 2) && response.portInfo && response.ageInfo) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getBookingBuddyModalHtml"](3, function (res) {
          var compiledHtml = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](res, response);
          $('#bbModalDynamicHtmlDiv').html(compiledHtml);
          if (_this9.checkout) {
            __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showModal"]('bookingBuddyModal');
          }
        });
      }
    }
  },
  openProductUnAvailableModal: function openProductUnAvailableModal() {
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/product-unavailable/product-unavailable.html'
    }).done(function (res) {
      var compiledHtml = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["createDynamicHTML"](res, 'response');
      $('#dynamicProductUnavailableModal').html(compiledHtml);
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showModal"]('productUnavailableModal');
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  createAddToCart: function createAddToCart(response) {
    var token = $('#csrfSessionToken').data('csrf');
    if (response.redirectUrl) {
      // redirect to the url
      window.location.href = response.redirectUrl;
    } else if (response.productAvailable) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');

      $('#addToCartSuccessModal').addClass('bbFlow');
      if (response.productType === 'FTF' || response.productType === 'CHEERS' || response.productType === 'INTERNET' || response.productType === 'BUBBLES' || response.productType === 'TR') {
        var dataObj = {};
        dataObj.productCode = response.productType === 'FTF' ? response.variantId : response.productCode;
        if (this.isPDP) {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#clpAddToCartModal').addClass('bbFlow');
          $('#termsAndConditionsModal').addClass('bbFlow');
          // open generic addToCart/coflict clp modal
          CCL.clpAddToCart.loadJsonData(dataObj);
        }
      } else if (response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP') {
        if (this.isPDP) {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#alcoholAtcModal').addClass('bbFlow');
          $('#termsAndConditionsModal').addClass('bbFlow');
          // open alcohol atc modal
          CCL.atcAlcohol.loadAlcoholJsonData(response.productCode);
        }
      } else if (response.productType === 'DI') {
        if (this.isPDP) {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#diningAtcModal').addClass('bbFlow');
          // open dining atc modal
          CCL.atcDining.loadDiningJsonData(response.productCode);
        }
      } else if (response.productType === 'XD') {
        if (this.isPDP) {
          __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#diningAtcModal').addClass('bbFlow');
          // open dining atc modal
          CCL.atcxDining.loadDiningJsonData(response.productCode);
        }
      } else {
        var data = {
          CSRFToken: token,
          productCodePost: response.variantId
        };
        // open shoreEx conflict modal
        CCL.conflictModal.loadModalData(data);
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('bookingBuddyModal');
      this.openProductUnAvailableModal();
    }
  },
  bbLbAddToCartAjax: function bbLbAddToCartAjax(activeSailingId) {
    var _this10 = this;

    var token = $('#csrfSessionToken').data('csrf');
    var dataObj = {
      productCode: this.currentProductCode
    };
    if (activeSailingId) {
      dataObj.sailingId = activeSailingId;
    }
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'POST',
      url: '/shop/gifting/sailing/check-product',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj)
    }).done(function (response) {
      _this10.createAddToCart(response);
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  bbSailingCheckoutAjax: function bbSailingCheckoutAjax() {
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/checkout/add-sailing',
      contentType: 'application/json'
    }).done(function (response) {
      window.location.reload();
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  valiateInputs: function valiateInputs() {
    var isValid = true;
    var p = /[^a-zA-Z\-']/;
    $('#giftLinkForm input[required]').each(function (i, v) {
      var t = $(v).val();
      // restrict special char in fname and lname
      if (p.test(t)) {
        $(v).addClass('invalid-input');
        $('#bbModalError p').html('Numbers or special characters are not allowed');
        $('#bbModalError').show();
        $('#saveButtonOne').prop('disabled', true);
        $('body').find('#checkoutBBflow').prop('disabled', true);

        isValid = false;
      }

      if ($(v).val().length > 24) {
        $('#bbModalError p').html('First name & last name should be less than 24 characters');
        $('#bbModalError').show();
        isValid = false;
      }

      if ($(v).val() === '') {
        isValid = false;
      }
    });
    if (isValid && ($('#giftLinkForm .booking-number').val() && $('#giftLinkForm .booking-number').val().match(/^[a-zA-Z0-9]{6,6}$/) || this.selectedMonth)) {
      $('#saveButtonOne').prop('disabled', false);
      $('body').find('#checkoutBBflow').prop('disabled', false);
    } else {
      $('#saveButtonOne').prop('disabled', true);
      $('body').find('#checkoutBBflow').prop('disabled', true);
    }
  },
  validateThirdModal: function validateThirdModal() {
    var dob = $('.multiple-sailing-extended-modal-dialog #dob').val();
    var isDobValid = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["validateDob"](dob);
    if (dob && !isDobValid) {
      $('.multiple-sailing-extended-modal-dialog #dob').addClass('invalid-input');
    } else {
      $('.multiple-sailing-extended-modal-dialog #dob').removeClass('invalid-input');
    }
    if (this.ajaxData.ageCode || dob) {
      $('#saveButtonThree').prop('disabled', false);
    } else {
      $('#saveButtonThree').prop('disabled', true);
    }

    if (dob && !isDobValid) {
      $('#saveButtonThree').prop('disabled', true);
    }
  },
  cruiseCloseAjax: function cruiseCloseAjax() {
    __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/remove-booking'
    }).done(function (res) {
      __WEBPACK_IMPORTED_MODULE_2_js_cookie_src_js_cookie_js__["remove"]('carnivalGiftingBookingCookie-' + res.vifp);
      if (res.activeSailingId) {
        __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["setSailingContextCookie"](res.activeSailingId);
        window.location.reload();
      } else if (res.activeSailingId === '') {
        window.location.reload();
      }
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideLoader"]();
    });
  },
  radioSelect: function radioSelect() {
    var _this11 = this;

    $(document.body).on('click keypress', '.browse-all-products-label, .browse-all-products-input', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').removeClass('show');
        _this11.activeSailingId = 0;
        _this11.giftGiver = null;
        if (!_this11.bookingAdded) {
          $('.browse-all-error').fadeIn('slow');
        }
        $('#saveButtonOne').prop('disabled', false);
        $('#checkoutBBflow').prop('disabled', false);
      }
    });

    $(document.body).on('click keypress', '.booking-place-date, .booking-place-date-input', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.browse-all-error').hide();
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').removeClass('show');
        var tempArr = event.currentTarget.id.split('-');
        _this11.activeSailingId = tempArr[tempArr.length - 1];
        _this11.giftGiver = event.currentTarget.dataset.giftgiver;
        $('#saveButtonOne').prop('disabled', false);
        $('#checkoutBBflow').prop('disabled', false);
      }
    });
    // $(document.body).on('keypress','.booking-number',(event)=>{

    // });
    $(document.body).on('click keypress', '#giftLinkFormCheckBox', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $(event.currentTarget.nextSibling.nextElementSibling).attr('aria-label', 'Expanded I want to give a gift to booked cruiser that has info to complete inside');
        $('.browse-all-error').hide();
        _this11.activeSailingId = 1;
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').addClass('show');
        $('.link-error-text').hide();
        _this11.giftGiver = null;
        //  $('#saveButtonOne').prop('disabled', true);
      }
    });
    $(document.body).on('click keypress', '.booked-cruiser-label', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.browse-all-error').hide();
        _this11.activeSailingId = 1;
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').addClass('show');
        $('.link-error-text').hide();
        _this11.giftGiver = null;
      }
    });

    $(document.body).on('click keypress', '#linkBookinFormCheckbox', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $(event.currentTarget.nextSibling.nextElementSibling).attr('aria-label', 'Expanded Link a booking to my profile that has info to complete inside');
        $('.browse-all-error').hide();
        _this11.activeSailingId = 2;
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.booked-cruiser-form').removeClass('show');
        $('.logged-out-user-form').addClass('show');
        _this11.giftGiver = null;
      }
    });
  },
  allClickEvents: function allClickEvents() {
    var _this12 = this;

    this.valiateInputs();
    $('.booking-info .custom-control-label, .browse-all-products .custom-control-label, .logged-out-user .custom-control-label').click(function (e) {
      $('#saveButtonOne').prop('disabled', false);
    });

    $(document.body).on('click keypress', '#giftLinkFormCheckBox, .booked-cruiser .custom-control-label', function (event) {
      $('#saveButtonOne').prop('disabled', true);
    });

    $('.c-recipient-info-form .info-null').click(function () {
      $('.c-recipient-info-form .info-description').slideToggle();
    });

    // When click on dropdown items
    $('.month-item').click(function (e) {
      $('#sailingMonths')[0].innerText = e.currentTarget.innerText;
      $('.month-item').removeClass('active');
      e.currentTarget.className += ' active';
      _this12.selectedMonth = e.currentTarget.dataset.month;
      _this12.valiateInputs();
      $(e.currentTarget.closest('.dropdown-menu').previousElementSibling).focus();
    });

    // When click on ship dropdown items
    $(document.body).on('click', '.ship-item', function (e) {
      $('#shipDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.ship-item').removeClass('active');
      e.currentTarget.className += ' active';
      _this12.ajaxData.shipCode = e.currentTarget.id;
      $('#saveButtonTwo').prop('disabled', false);
    });

    // When click on ship dropdown items
    $(document.body).on('click', '.age-item', function (e) {
      $('#ageDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.age-item').removeClass('active');
      e.currentTarget.className += ' active';
      _this12.ajaxData.ageCode = e.currentTarget.id;
      $('#saveButtonThree').prop('disabled', false);
    });

    // When click on age dropdown items
    $(document.body).on('click', '.sailingPort-item', function (e) {
      $('#sailingPortMenu')[0].innerText = e.currentTarget.innerText;
      $('.sailingPort-item').removeClass('active');
      e.currentTarget.className += ' active';
      _this12.ajaxData.embarkationPortCode = e.currentTarget.id;
      $('#saveButtonThree').prop('disabled', false);
    });

    // When user types in input
    $('#giftLinkForm input[type=text]').keyup(function (e) {
      var patt = /^\S*$/;
      $('#bbModalError').hide();
      $('#saveButtonOne').prop('disabled', false);
      $('#checkoutBBflow').prop('disabled', false);
      if ($(e.currentTarget)[0].hasAttribute('required') && !e.currentTarget.value) {
        $(e.currentTarget).addClass('invalid-input');
      } else {
        $(e.currentTarget).removeClass('invalid-input');
        if (!patt.test(e.currentTarget.value)) {
          $(e.currentTarget).addClass('invalid-input');
          $('#bbModalError p').html('Whitespace not allowed');
          $('#bbModalError').show();
          $('#saveButtonOne').prop('disabled', true);
          $('#checkoutBBflow').prop('disabled', true);
          return;
        }

        if ($(e.currentTarget).hasClass('booking-number') && e.currentTarget.value.length) {
          var bookingNumRegex = /^[a-zA-Z0-9]{6}$/;
          if (!bookingNumRegex.test(e.currentTarget.value)) {
            $('#bbModalError p').html('Invalid booking number');
            $('#bbModalError').show();
            $('#saveButtonOne').prop('disabled', true);
            $('#checkoutBBflow').prop('disabled', true);

            return;
          }
        }
      }
      _this12.valiateInputs();
    });

    $(document.body).on('#shipInfoForm input[type=text]').keyup(function (e) {
      var email = $('.multiple-sailing-modal-dialog #emailAddress').val();
      var phone = $('.multiple-sailing-modal-dialog #phoneNumber').val();
      var isEmailValid = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["validateEmail"](email);
      if (email && !isEmailValid) {
        $('.multiple-sailing-modal-dialog #emailAddress').addClass('invalid-input');
      } else {
        $('.multiple-sailing-modal-dialog #emailAddress').removeClass('invalid-input');
      }
      if (email || phone || _this12.ajaxData.shipCode) {
        $('#saveButtonTwo').prop('disabled', false);
      } else {
        $('#saveButtonTwo').prop('disabled', true);
      }
      if (email && !isEmailValid) {
        $('#saveButtonTwo').prop('disabled', true);
      }
    });

    $(document.body).on('#sailingInfoForm input[type=text]').keyup(function (e) {
      _this12.validateThirdModal();
    });

    // When click on checkout page save and continue
    $('#checkoutBBflow').click(function (e) {
      _this12.ajaxData.step = 'first';
      _this12.fetchBooking();
    });

    // When click on 1st modal save
    $('#saveButtonOne').click(function (e) {
      _this12.ajaxData.step = 'first';
      _this12.fetchBooking();
    });

    // When user click on 2nd modal save
    $(document.body).on('click', '#saveButtonTwo', function (e) {
      _this12.ajaxData.step = 'second';
      _this12.save();
    });

    // When user click on 3rd modal save
    $(document.body).on('click', '#saveButtonThree', function (e) {
      _this12.ajaxData.step = 'third';
      _this12.save();
    });

    // When user click on product not availble close click
    $(document.body).on('click', '#productUnavailableModalClose', function (e) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('productUnavailableModal');
      if (_this12.isPDP) {
        window.location.href = '/shop';
      } else {
        window.location.reload();
      }
    });

    // When user click on product not availble Keep Shopping btn
    $(document.body).on('click', '.keep-shopping-btn', function (e) {
      __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["hideModal"]('productUnavailableModal');
      if (_this12.isPDP) {
        window.location.href = '/shop';
      } else {
        window.location.reload();
      }
    });

    // When user click on booking buddy close
    $(document.body).on('click', '#bookingBuddyModal .close', function (e) {
      $.each(_this12.ajaxData, function (k, v) {
        _this12.ajaxData[k] = '';
      });
    });

    // When user click on added to cart success close
    $(document.body).on('click', '#addToCartSuccessModal.bbFlow .close', function (e) {
      window.location.reload();
    });

    // When user click on clp Add to Cart close
    $(document.body).on('click', '#clpAddToCartModal.bbFlow .close', function (e) {
      window.location.reload();
    });

    // When user click on alcohol Add to Cart close
    $(document.body).on('click', '#alcoholAtcModal.bbFlow .close', function (e) {
      window.location.reload();
    });

    // When user click on added to cart success close
    $(document.body).on('click', '#termsAndConditionsModal.bbFlow .close', function (e) {
      window.location.reload();
    });

    $(document.body).on('click', '#termsAndConditionsModal.bbFlow .btn-cancel', function (e) {
      window.location.reload();
    });

    if ($(document.body).find('.goto-cruise-manager .rightSidebar').css('display') === 'block') {
      $('.goto-cruise-manager a').on('keydown', function (event) {
        if (event.keyCode === 9 && !event.shiftKey) {
          $(function () {
            $('.close').focus();
          });
        }
        if (event.keyCode === 9 && event.shiftKey) {
          $(function () {
            $('.custom_tooltip').focus();
          });
        }
      });
      $('.close').on('keydown', function (event) {
        if (event.keyCode === 9 && event.shiftKey) {
          $(function () {
            $('.goto-cruise-manager a').focus();
          });
        }
      });
    } else if ($(document.body).find('.goto-cruise-manager .rightSidebar').length === 0) {
      $('.custom_tooltip').on('keydown', function (event) {
        if (event.keyCode === 9 && !event.shiftKey) {
          $(function () {
            $('.close').focus();
          });
        }
      });
      $('.close').on('keydown', function (event) {
        if (event.keyCode === 9 && event.shiftKey) {
          $(function () {
            $('.custom_tooltip').focus();
          });
        }
      });
    }
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#bookingBuddyModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_3__js_generalFunctions__["getFocusableElements"](modalEl, 'last');
    var cruiseAnchor = $('#cruiseManagerLink');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        if (cruiseAnchor.attr('id') === lastFocusable.attr('id') && $('.rightSidebar:visible').length === 0) {
          $('a.organizer-access-modal-open-button').focus();
        } else {
          lastFocusable.focus();
        }
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {CCL.footer = {
  autoload: [['funBrowserDropdown', $('.fun-browser .mdropdown').length > 0]],
  funBrowserDropdown: function funBrowserDropdown() {
    $('.fun-browser .mdropdown').click(function (e) {
      e.preventDefault();
      var parent = $('.mdropdown-menu');
      var expand = $(e.currentTarget).attr('aria-expanded');
      if ($(window).width() < 768) {
        $(parent).slideToggle();
        $(e.currentTarget).toggleClass('show');
      }
      if (expand === 'false') {
        $(e.currentTarget).attr('aria-expanded', 'true');
      } else {
        $(e.currentTarget).attr('aria-expanded', 'false');
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.pdpSf = {
  autoload: [['quantityRestrict', $('#alcoholAtcModal').length > 0], ['increment', $('#alcoholAtcModal').length > 0], ['decrement', $('#alcoholAtcModal').length > 0], ['allDisabled', $('.restrict-quantity').length > 0], ['checkConditions', $('.terms-conditions-btn').length > 0]],

  increment: function increment() {
    var _this = this;

    $('body').on('click', '.increment-btn-1', function (event) {
      event.preventDefault();
      var targetElement = $(event.currentTarget).parents('.restrict-quantity').find('.quantity-input-1');
      var q = $(targetElement).val();
      var current = event.currentTarget;
      var arr = [];
      setTimeout(function () {
        $(targetElement).parents('.c-cart-card').find('.cart-edit-stateroom-wrap').css('display', 'block');
        $(targetElement).parents('.c-cart-card').find('.cart-edit-stateroom-link').attr('aria-expanded', 'true');
      }, 2000);
      if ($(targetElement).parents('.restrict-quantity').data('iscart') === (true || 'true')) {
        setTimeout(function () {
          $(event.target).parents('.restrict-quantity').after('<div class="sr-only" role="alert" aria-live="assertive">edit stateroom dropdown expanded</div>');
        }, 500);
      }
      $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each(function (index, element) {
        var qty = element.dataset.qty;

        if (qty === '') {
          qty = 2;
        }
        arr.push(qty);
        if (Number(qty) === 1) {
          $(element.parentElement).find('.alcohol-error-msg').show();
        }
      });
      if (arr.every(function (x) {
        return x >= 1;
      })) {
        q = 1;
      } else if (q <= 1) {
        q++;
      }
      $(targetElement).val(q);
      _this.disableButton(q, current);
      $(event.currentTarget).addClass('ada-element-focus');
      $(targetElement).attr('aria-label', 'quantity value is ' + q);
      $(event.currentTarget).attr('aria-label', 'increment quantity with current value ' + q);
      $(event.currentTarget).parents('.restrict-quantity').find('.decrement-btn-1').attr('aria-label', 'decrement quantity with current value ' + q);
      setTimeout(function () {
        $(event.currentTarget).focus();
      }, 100);
    });
  },
  decrement: function decrement() {
    var _this2 = this;

    $('body').on('click', '.decrement-btn-1', function (event) {
      event.preventDefault();
      var current = event.currentTarget;
      var targetElement = $(event.target).parents('.restrict-quantity').find('.quantity-input-1');
      var q = $(targetElement).val();
      q--;
      var arr = [];
      $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each(function (index, element) {
        var qty = element.dataset.qty;

        arr.push(qty);
      });
      if (q === 0) {
        $('.decrement-btn-1').attr('disabled', 'disabled');
        return;
      }
      $(targetElement).val(q);
      _this2.disableButton(q, current);
      $(event.currentTarget).addClass('ada-element-focus');
      $(targetElement).attr('aria-label', 'quantity value is ' + q);
      $(event.currentTarget).attr('aria-label', 'decrement quantity with current value ' + q);
      $(event.currentTarget).parents('.restrict-quantity').find('.increment-btn-1').attr('aria-label', 'increment quantity with current value ' + q);
      setTimeout(function () {
        $(event.currentTarget).focus();
      }, 100);
    });
  },
  allDisabled: function allDisabled() {
    var isCart = $('.restrict-quantity').data('iscart');
    if (isCart !== 'true' && isCart !== true) {
      var stateroomLength = $('.custom-control.custom-checkbox.stateroom-check').length;
      var disableLength = $('.custom-control.custom-checkbox.stateroom-check.stateroom-disabled').length;
      if (stateroomLength === disableLength) {
        $('.restrict-quantity').hide();
        $('.common-pdp-error-message').show();
        $('.pdp-error-msg').hide();
      } else {
        $('.common-pdp-error-message').hide();
        $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each(function (ind, ele) {
          if ($(ele).data('qty') === '') {
            $(ele.parentElement.nextElementSibling).show();
          }
        });
      }
    }
  },
  checkConditions: function checkConditions() {
    var hasVariant = $('#hasVariant').val();
    if ($('.flavor-wrap').length > 0) {
      if (hasVariant === 'false') {
        $('.terms-conditions-btn').removeAttr('disabled');
        if ($('.terms-conditions-btn').attr('data-bookingIds') === '') {
          $('.terms-conditions-btn').attr('disabled', 'disabled');
        }
      } else {
        $('.terms-conditions-btn').attr('disabled', 'disabled');
        $('.stateroom-check').addClass('stateroom-disabled');
        $('.stateroom-check .booking-toggle').removeAttr('tabindex');
        $('.stateroom-check').find('.parent-check').attr('disabled', 'disabled');
        $('.stateroom-check').find('.parent-check').removeAttr('checked');
        $('.guests-check').find('input').removeAttr('checked').attr('disabled', 'disabled');
        $('.inner-pdp-error-msg').hide();
        $('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg');
        $('.drop-icon').addClass('gray');
      }
    } else if ($('.terms-conditions-btn').attr('data-bookingIds') === '') {
      $('.terms-conditions-btn').attr('disabled', 'disabled');
    } else {
      $('.terms-conditions-btn').removeAttr('disabled');
    }
  },
  quantityRestrict: function quantityRestrict() {
    $('body').on('click', '.add-to-cart-sf', function (event) {
      var csrf = $('.add-to-cart-sf').data('csrf') ? $('.add-to-cart-sf').data('csrf') : $('#csrfSessionToken').data('csrf');
      var targetElement = $(event.target).data('hasvariants');
      var dataObj = sessionStorage.getItem('sessionTemplateObj');
      var pageType = $('#pagetype').data('pagetype');
      dataObj = JSON.parse(dataObj);
      dataObj.pageType = pageType;
      if (pageType === 'CATEGORY') {
        dataObj.productPosition = Number(localStorage.getItem('productposition'));
        dataObj.pageNumber = Number(localStorage.getItem('pageNumber'));
        dataObj.categoryName = localStorage.getItem('sascategorycode');
      }
      dataObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj);
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: '/shop/cart/specialFS/add',
          contentType: 'application/json',
          data: dataObj,
          headers: {
            CSRFToken: csrf
          }
        }).done(function (response) {
          if (response.addedToCart === true) {
            __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](response);
            __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideModal"]('alcoholAtcModal');
            CCL.addToCart.successModal(response);
          }
        }).fail(function () {
          console.log('Something went wrong');
        });
      }
    });
  },
  disableButton: function disableButton(inputVal, current) {
    if (Number(inputVal) === 1) {
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.decrement-btn-1').attr('disabled', 'disabled');
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.increment-btn-1').removeAttr('disabled');
    } else {
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.increment-btn-1').attr('disabled', 'disabled');
      $(current).parents('.c-cart-card,.c-atc-card,.c-pdp-card').find('.decrement-btn-1').removeAttr('disabled');
    }
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__ = __webpack_require__(4);




CCL.pdpSfPackage = {
  autoload: [['oneQuantity', $('.static-qty').length > 0], ['oneQuantity', $('.terms-conditions-btn').length > 0], ['pdpPackageAjax', $('#alcoholAtcModal').length > 0], ['buttonDisableConidtions', $('.add-to-cart-sfp').length > 0], ['RestrictUserFromPDP', $('.c-pdp-card').length > 0], ['RestrictUserMinus', $('.c-pdp-card').length > 0]],

  VariantQuantity: null,

  oneQuantity: function oneQuantity() {
    var stateroomLength = $('.custom-control.custom-checkbox.stateroom-check').length;
    var disableLength = $('.custom-control.custom-checkbox.stateroom-check.stateroom-disabled').length;

    if (stateroomLength === disableLength) {
      $('.static-qty').hide();
      if ($('#specialFunshopCaseInput').val() === 'true') {
        $('.common-pdp-error-message').hide();
        $('.pdp-error-msg').show();
      } else {
        $('.common-pdp-error-message').show();
        $('.pdp-error-msg').hide();
      }
    } else {
      $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each(function (ind, ele) {
        if ($(ele.parentElement).hasClass('stateroom-disabled')) {
          $(ele.parentElement.nextElementSibling).show();
        }
      });
    }
  },
  RestrictUserFromPDP: function RestrictUserFromPDP() {
    var _this = this;

    $('.c-pdp-card').on('click', '.increment-btn', function (event) {
      _this.pdpCruiseCashRestrication();
    });
  },
  pdpCruiseCashRestrication: function pdpCruiseCashRestrication() {
    var afterAjax = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if ($('.c-pdp-card .general-add-to-cart-btn')[0].dataset.funshopcategorycode && $('.c-pdp-card .general-add-to-cart-btn')[0].dataset.funshopcategorycode === 'cruise-cash') {
      // run this only for price values variant not for other variants
      var variantValue = Number($('.c-pdp-card .btn-add-cart').data('price'));
      if (!isNaN(variantValue)) {
        // eslint-disable-line
        var targetElement = $('.c-pdp-card .quantity-btn-wrap').find('.quantity-input');
        this.VariantQuantity = afterAjax ? Number($(targetElement).val()) : Number($(targetElement).val()) + 1;
        var price = Number(variantValue);
        var localAmount = Number(localStorage.getItem('cruisecashcartamount'));
        var reqdQty = (500 - localAmount) / variantValue;
        reqdQty = Math.floor(reqdQty);
        if (this.VariantQuantity >= Number(reqdQty)) {
          $('.increment-btn').attr('disabled', 'disabled');
          $('.increment-btn').css('pointer-events', 'none');
          $('.increment-btn').css('opacity', '0.4');
          $('.cc-error').remove();
          setTimeout(function () {
            $('<div class=\'cc-error\'\n                aria-live=\'assertive\'\n                role=\'alert\'\n                style=\'color:darkred\'>\n        Cruise Cash limit is $500 per stateroom.\n        </div>').insertAfter('.c-pdp-card .quantity-btn-wrap');
          }, 500);
        } else {
          $('.increment-btn').removeAttr('disabled');
          $('.increment-btn').css('pointer-events', 'auto');
          $('.increment-btn').css('opacity', '1');
        }

        if (price + localAmount > 500) {
          $('.c-pdp-card .btn-add-cart').attr('disabled', 'disabled');
        }
      }
    }
  },
  RestrictUserMinus: function RestrictUserMinus() {
    $('.c-pdp-card').on('click', '.decrement-btn', function (event) {
      $('.cc-error').remove();
      $('.increment-btn').css('pointer-events', 'auto');
      $('.increment-btn').css('opacity', '1');
      $('.increment-btn').removeAttr('disabled');
    });
  },
  buttonDisableConidtions: function buttonDisableConidtions() {
    var hasVariant = $('#hasVariant').val();
    if ($('.flavor-wrap').length > 0) {
      if (hasVariant === 'false') {
        $('.add-to-cart-sfp').removeAttr('disabled');
        if ($('.add-to-cart-sfp').attr('data-bookingIds') === '') {
          $('.add-to-cart-sfp').attr('disabled', 'disabled');
        }
      } else {
        $('.add-to-cart-sfp').attr('disabled', 'disabled');
        $('.stateroom-check').addClass('stateroom-disabled');
        $('.stateroom-check').find('.parent-check').attr('disabled', 'disabled');
        $('.stateroom-check').find('.parent-check').removeAttr('checked');
        $('.drop-icon').attr('src', '/_ui/responsive/ccl/assets/icons/down_gray.svg');
        $('.drop-icon').addClass('gray');
      }
    } else if ($('.add-to-cart-sfp').attr('data-bookingIds') === '') {
      $('.add-to-cart-sfp').attr('disabled', 'disabled');
    } else {
      $('.add-to-cart-sfp').removeAttr('disabled');
    }
  },
  bookingData: function bookingData(productCodePost, event, currentElement) {
    var bookings = [];
    var dataObj = {};
    var booking = currentElement.parents('.c-cart-card,.c-pdp-card,.alcohol-atc-modal-dialog').find('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]:checked');
    booking.each(function (index, element) {
      var bookingIdValue = element.dataset.bookingid;
      var guestArray = [];
      var quantity = '';
      var ac = '';
      if (event.target.dataset.ispdp === 'true') {
        ac = $(element.parentElement.children[3]);
        quantity = $('#maxQuantitySfp').val();
      } else {
        ac = $(element.parentElement);
        quantity = 1;
      }
      ac.find('.guests-check > input[type="checkbox"]:checked').each(function (i, elem) {
        if (!$(elem).prop('disabled')) {
          var guestValue = elem.dataset.guestid;
          var guestObj = {
            guestId: guestValue
          };
          guestArray.push(guestObj);
        }
      });
      var bookingData = {
        bookingId: bookingIdValue,
        qty: quantity,
        guestIds: guestArray
      };
      bookings.push(bookingData);
    });
    dataObj.bookings = bookings;
    dataObj.productCodePost = productCodePost;
    dataObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj);
    return dataObj;
  },
  pdpPackageAjax: function pdpPackageAjax() {
    var _this2 = this;

    $('body').on('click', '.add-to-cart-sfp', function (event) {
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["showLoader"]();
      var hasupsell = $(event.target).attr('data-hasupsell');
      var sailingInfoNeeded = $(event.target).attr('data-sailingInfoNeeded');
      var csrf = $('.add-to-cart-sfp').data('csrf') ? $('.add-to-cart-sfp').data('csrf') : $('#csrfSessionToken').data('csrf');
      var targetElement = '';
      var dataObj = void 0;

      if (sessionStorage.getItem('producttype') === 'SFAP') {
        dataObj = sessionStorage.getItem('sessionTemplateObj');
        sessionStorage.removeItem('producttype');
      } else {
        targetElement = $(event.target).data('hasvariants');
        var productCodePost = $(event.target).data('productcode');
        dataObj = _this2.bookingData(productCodePost, event, $('.add-to-cart-sfp'));
      }

      var pageType = $('#pagetype').data('pagetype');
      dataObj = JSON.parse(dataObj);
      dataObj.pageType = pageType;
      if (pageType === 'CATEGORY') {
        dataObj.productPosition = localStorage.getItem('productposition');
        dataObj.pageNumber = localStorage.getItem('pageNumber');
        dataObj.categoryName = localStorage.getItem('sascategorycode');
        dataObj.pageType = pageType;
      }
      dataObj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj);

      if (hasupsell === 'true' && (typeof hasupsell === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(hasupsell)) !== ( true ? 'undefined' : _typeof(undefined)) && hasupsell !== false && (sailingInfoNeeded === 'false' || (typeof sailingInfoNeeded === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(sailingInfoNeeded)) === ( true ? 'undefined' : _typeof(undefined)))) {
        CCL.upSellProductModal.loadGlobalUpsellModal(event);
        return;
      }

      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: '/shop/cart/specialFS/add',
          contentType: 'application/json',
          data: dataObj,
          headers: {
            CSRFToken: csrf
          }
        }).done(function (response) {
          __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
          if (response.addedToCart === true) {
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["updateHeaderCartWidget"](response);
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideModal"]('alcoholAtcModal');
            CCL.addToCart.successModal(response);
          }
        }).fail(function () {
          __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
          console.log('Something went wrong');
        });
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__ = __webpack_require__(4);




CCL.termsAndConditions = {
  autoload: [['initialLoad', $('#termsAndConditionsModal').length > 0]],

  initialLoad: function initialLoad() {
    var _this = this;

    $('body').on('click', '.terms-conditions-btn', function (e) {
      _this.loadJsonData(e);
    });
  },
  closeModal: function closeModal() {
    $('.close').click(function (e) {
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideModal"]('transfersConflictModal');
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideModal"]('alcoholAtcModal');
    });
  },
  checkboxEvent: function checkboxEvent() {
    $('.read-check input[type="checkbox"]').click(function (e) {
      if ($('.read-check input[type="checkbox"]').length === $('.read-check input[type="checkbox"]:checked').length) {
        $('.btn-tc-add-cart').removeClass('btn-disable');
      } else {
        $('.btn-tc-add-cart').addClass('btn-disable');
      }
    });
  },
  quantitySet: function quantitySet(productCodePost, event, currentElement) {
    var bookings = [];
    var dataObj = {};
    sessionStorage.clear();
    var booking = currentElement.parents('.c-cart-card,.c-pdp-card,.alcohol-atc-modal-dialog').find('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]:checked');
    booking.each(function (index, element) {
      var quantity = '';
      if (currentElement[0].dataset.ispdp === ('true' || true)) {
        quantity = currentElement.parents('.c-pdp-card').find('.quantity-input-1').val();
      } else {
        quantity = currentElement.parents('.alcohol-atc-modal-dialog,.c-cart-card').find('.quantity-input-1').val();
      }
      var bookingIdValue = element.dataset.bookingid;
      var addedQty = element.dataset.qty;
      var guestArray = [];
      if (element.parentElement.classList.contains('stateroom-disabled')) {
        quantity = 0;
      }
      if (Number(quantity) === 2 && Number(addedQty) === 1) {
        quantity = 1;
      }
      var abc = $(element);
      if (!abc.is(':checked')) {
        quantity = 0;
      }
      var ac = '';
      if (currentElement[0].dataset.ispdp === ('true' || true)) {
        ac = $(element.parentElement.children[3]);
      } else {
        ac = $(element.parentElement);
      }
      ac.find('.guests-check > input[type="checkbox"]:checked').each(function (i, elem) {
        if (!$(elem).prop('disabled')) {
          var guestValue = elem.dataset.guestid;
          var guestObj = {
            guestId: guestValue
          };
          guestArray.push(guestObj);
        }
      });
      var q = 0;
      if ($('.terms-conditions-btn').data('producttype') === 'SF' || $('.c-cart-card .time-conflict-panel-heading').data('producttype') === 'SF') {
        q = Number(quantity);
      } else {
        q = 1;
        sessionStorage.setItem('producttype', 'SFAP');
      }
      var qtyAdded = element.dataset.qtyadded;
      var purchaseQty = element.dataset.purchaseqty;
      var qty = $(element).closest('.c-cart-card').find('.quantity-input-1').val();
      if (qtyAdded !== (null || undefined) && purchaseQty !== (null || undefined)) {
        if (qty !== (null || undefined) && qtyAdded === purchaseQty) {
          q = qty;
        } else if (purchaseQty - qtyAdded === 1) {
          q = 1;
        }
      }

      // currentElement.each((ind, elemnt) => {
      //   /* eslint-disable */
      //   if (isNaN(q) && elemnt.dataset.upsellqty) {
      //     q = elemnt.dataset.upsellqty;
      //   }
      //   /* eslint-enable */
      // });
      var bookingData = {
        qty: q,
        bookingId: bookingIdValue,
        guestIds: guestArray
      };
      bookings.push(bookingData);
    });
    dataObj.bookings = bookings;
    dataObj.productCodePost = productCodePost;
    sessionStorage.setItem('sessionTemplateObj', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObj));
  },
  loadJsonData: function loadJsonData(event) {
    var _this2 = this;

    var hasupsell = $(event.target).attr('data-hasupsell');
    if (hasupsell === 'true' && (typeof hasupsell === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(hasupsell)) !== ( true ? 'undefined' : _typeof(undefined)) && hasupsell !== false) {
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["showLoader"]();
      var ajaxUrlTmp = '';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrlTmp = 'json-data/upsell-product.json';
      } else {
        ajaxUrlTmp = '/shop/cart/productreference';
      }

      var quantityTmp = 1;

      if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').length) {
        quantityTmp = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
      } else if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').length) {
        quantityTmp = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').val();
      }

      var bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : [];
      var guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : [];
      var ispdp = event.target.dataset.ispdp;

      var dataObjTmp = {
        productCode: $(event.target).data('productcode'),
        referenceType: 'UPSELLING',
        qty: quantityTmp || 1,
        encBookingIds: bookingIdsArray,
        encGuestIds: guestIdsArray,
        pdpPage: ispdp === 'true' && (typeof ispdp === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ispdp)) !== ( true ? 'undefined' : _typeof(undefined)) && ispdp !== false
      };

      $.ajax({
        type: 'POST',
        url: ajaxUrlTmp,
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataObjTmp),
        headers: {
          CSRFToken: $('#csrfSessionToken').data('csrf')
        },
        contentType: 'application/json'
      }).done(function (response) {
        __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
        if (response.productValid) {
          CCL.upSellProductModal.openGlobalUpsellModal(response);
        } else {
          _this2.loadTnC(event);
        }
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
        console.log('error Occured');
        _this2.loadTnC(event);
      });
    } else {
      this.loadTnC(event);
    }
  },
  loadTnC: function loadTnC(event) {
    var _this3 = this;

    var csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
    var targetElement = $(event.target).data('hasvariants');
    var quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    var variantId = $(event.target).attr('data-variantids');
    var isSpecialService = $(event.target).attr('data-specialService');
    var bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : '';
    var guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : '';
    var productCode = $(event.target).data('productcode');
    var dataObj = {
      productCodePost: $(event.target).data('productcode'),
      CSRFToken: csrf,
      qty: quantity || 1,
      variantIds: variantId,
      bookingIds: bookingIdsArray,
      guestIds: guestIdsArray,
      specialService: isSpecialService
    };
    if ($('.terms-conditions-btn').data('producttype') === 'SF' || $('.terms-conditions-btn').data('producttype') === 'SFAP') {
      var currentElement = $('.terms-conditions-btn');
      this.quantitySet(productCode, event, currentElement);
    }
    var ajaxUrl = '';
    var ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/terms-conditions-modal/terms-conditions.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/termsconditions';
      ajaxType = 'POST';
    }
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      data: dataObj,
      headers: {
        CSRFToken: csrf
      }
    }).done(function (res) {
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideModal"]('clpAddToCartModal');
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideModal"]('alcoholAtcModal');
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideModal"]('globalUpsellProductModal');
      // $('.modal').modal('hide');
      _this3.loadHtmlData(res);
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  loadHtmlData: function loadHtmlData(jsonData) {
    var _this4 = this;

    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/terms-conditions-modal/terms-conditions.html'
    }).done(function (response) {
      // append the booking ids and the guest ids to the Add to Cart btn
      var html = __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["createDynamicHTML"](response, jsonData);
      $('#termsAndConditionsModal').empty().append(html);
      $('.pdp-add-to-cart-btn').attr('data-bookingIds', jsonData.bookingIds);
      $('.pdp-add-to-cart-btn').attr('data-guestIds', jsonData.guestIds);
      $('.pdp-add-to-cart-btn').attr('data-productcode', jsonData.code);
      if (jsonData.productType.toLowerCase() === 'cheers' || jsonData.productType.toLowerCase() === 'bubble') {
        $('.read-check >input').attr('checked', 'checked');
        $('.btn-tc-add-cart').removeClass('btn-disable');
      }
      _this4.checkboxEvent();
      _this4.closeModal();
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["showModal"]('termsAndConditionsModal');
      _this4.modalEvents();

      setTimeout(function () {
        $('body').addClass('modal-open');
      }, 600);
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
      console.log('error while loading html');
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#termsAndConditionsModal');

    modalEl.find('button.close').on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        var lastFocusable = __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["getFocusableElements"](modalEl, 'last');
        lastFocusable.focus();
        if (modalEl.find('.general-add-to-cart-btn:disabled').length > 0 || modalEl.find('.general-add-to-cart-btn.btn-disable').length > 0) {
          modalEl.find('.btn-cancel').focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.btn-cancel').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        if (modalEl.find('.general-add-to-cart-btn:disabled').length > 0 || modalEl.find('.general-add-to-cart-btn.btn-disable').length > 0) {
          var firstFocusable = __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["getFocusableElements"](modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.general-add-to-cart-btn').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        var firstFocusable = __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["getFocusableElements"](modalEl);
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.Dining = {
  autoload: [['adultincrement', $('#diningAtcModal').length > 0], ['childincrement', $('#diningAtcModal').length > 0], ['adultdecrement', $('#diningAtcModal').length > 0], ['childdecrement', $('#diningAtcModal').length > 0], ['dropdownSelect', $('#diningAtcModal').length > 0], ['priceShow', $('#diningAtcModal').length > 0], ['addToCartDining', $('#diningAtcModal').length > 0]],

  adultincrement: function adultincrement() {
    $('body').on('click keypress', '.adult-increment-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.adult-decrement-btn').css('opacity', '1');
        $('.adult-decrement-btn').css('pointer-events', 'auto');
        var maxcount = '';
        var capAmount = Number($('#diningCapAmount').val());
        var diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          var childVal = $('.child-quantity-input').val();
          var adultVal = $('.adult-quantity-input').val();
          if (adultVal < maxcount - childVal) {
            adultVal++;
            console.dir(event.currentTarget.previousElementSibling);
            event.currentTarget.previousElementSibling.firstElementChild.value = adultVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', 'adult quantity value is ' + adultVal);
            $(event.target).attr('aria-label', 'increase adult quantity with current value ' + adultVal);
            $(event.target).parents('.adult-quantity-wrap').find('.adult-decrement-btn').attr('aria-label', 'decrease adult quantity with current value ' + adultVal);
          } else {
            $('.adult-increment-btn').css('opacity', '0.5');
            $('.adult-increment-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  childincrement: function childincrement() {
    $('body').on('click keypress', '.child-increment-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.child-decrement-btn').css('opacity', '1');
        $('.child-decrement-btn').css('pointer-events', 'auto');
        var maxcount = '';
        var capAmount = Number($('#diningCapAmount').val());
        var diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          var childVal = $('.child-quantity-input').val();
          var adultVal = $('.adult-quantity-input').val();
          if (childVal < maxcount - adultVal) {
            childVal++;
            event.currentTarget.previousElementSibling.firstElementChild.value = childVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', 'child quantity value is ' + childVal);
            $(event.target).attr('aria-label', 'increase child quantity with current value ' + childVal);
            $(event.target).parents('.child-quantity-wrap').find('.child-decrement-btn').attr('aria-label', 'decrease child quantity with current value ' + childVal);
          } else {
            $('.child-increment-btn').css('opacity', '0.5');
            $('.child-increment-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  adultdecrement: function adultdecrement() {
    $('body').on('click keypress', '.adult-decrement-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.adult-increment-btn').css('opacity', '1');
        $('.adult-increment-btn').css('pointer-events', 'auto');
        var maxcount = '';
        var capAmount = Number($('#diningCapAmount').val());
        var diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          var childVal = $('.child-quantity-input').val();
          var adultVal = $('.adult-quantity-input').val();
          if (adultVal > 1) {
            adultVal--;
            event.currentTarget.nextElementSibling.firstElementChild.value = adultVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', 'quantity value is ' + adultVal);
            $(event.target).attr('aria-label', 'decrease adult quantity with current value ' + adultVal);
            $(event.target).parents('.adult-quantity-wrap').find('.adult-increment-btn').attr('aria-label', 'increase adult quantity with current value ' + adultVal);
          }if (childVal < maxcount - adultVal) {
            $('.child-increment-btn').css('opacity', '1');
            $('.child-increment-btn').css('pointer-events', 'auto');
          }if (adultVal <= 1) {
            $('.adult-decrement-btn').css('opacity', '0.5');
            $('.adult-decrement-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  childdecrement: function childdecrement() {
    $('body').on('click keypress', '.child-decrement-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.child-increment-btn').css('opacity', '1');
        $('.child-increment-btn').css('pointer-events', 'auto');
        var maxcount = '';
        var capAmount = Number($('#diningCapAmount').val());
        var diningStock = Number($('#diningStock').val());
        if (diningStock > 0) {
          maxcount = capAmount >= diningStock ? diningStock : capAmount;
          var childVal = $('.child-quantity-input').val();
          var adultVal = $('.adult-quantity-input').val();
          if (childVal > 0) {
            childVal--;
            event.currentTarget.nextElementSibling.firstElementChild.value = childVal;
            $(event.currentTarget).addClass('ada-highlighted');
            $(event.currentTarget).focus();
            $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', 'quantity value is ' + childVal);
            $(event.target).attr('aria-label', 'decrease child quantity with current value ' + childVal);
            $(event.target).parents('.child-quantity-wrap').find('.child-increment-btn').attr('aria-label', 'increase child quantity with current value ' + childVal);
          }if (adultVal < maxcount - childVal) {
            $('.adult-increment-btn').css('opacity', '1');
            $('.adult-increment-btn').css('pointer-events', 'auto');
          }if (childVal <= 0) {
            $('.child-decrement-btn').css('opacity', '0.5');
            $('.child-decrement-btn').css('pointer-events', 'none');
          }
        }
      }
    });
  },
  priceShow: function priceShow() {
    if ($('body').find('.c-pdp-template-reserve-dining #adultVariantPrice').length || $('body').find('#diningAtcModal #adultVariantPrice').length) {
      var priceAdult = $('#adultVariantPrice').val();
      var priceChild = $('#childVariantPrice').val();
      if (priceAdult === priceChild && priceAdult !== '' && priceChild !== '') {
        $('.c-pdp-template-reserve-dining .per-price,#diningAtcModal .per-price').hide();
        $('.c-pdp-template-reserve-dining .price-per-person,#diningAtcModal .price-per-person').addClass('show');
        $('.c-pdp-template-reserve-dining #personPrice,#diningAtcModal #personPrice').val(priceAdult);
      } else if (priceAdult !== '' && priceChild === '') {
        $('.c-pdp-template-reserve-dining .price-per-person,#diningAtcModal .price-per-person').addClass('show');
        $('.c-pdp-template-reserve-dining .per-price,#diningAtcModal .per-price').hide();
        $('.c-pdp-template-reserve-dining #personPrice,#diningAtcModal #personPrice').val(priceAdult);
      } else {
        $('.c-pdp-template-reserve-dining .per-price,#diningAtcModal .per-price').addClass('show');
        $('.c-pdp-template-reserve-dining .price-per-person,#diningAtcModal .price-per-person').hide();
      }
    }
  },
  dropdownSelect: function dropdownSelect() {
    var noDayTimeSlotsAvailable = $('#noDayTimeSlotsAvailable').val();
    var diningStock = Number($('#diningStock').val());
    var chefProduct = $('#isLiveChefProduct').val();
    $('.select-day-dropdown.dining .dropdown-toggle').attr('aria-live', 'assertive');
    $('.select-time-dropdown.dining .dropdown-toggle').attr('aria-live', 'assertive');
    if (noDayTimeSlotsAvailable === 'true' || noDayTimeSlotsAvailable === true) {
      $('.adult-child-wrap').hide();
      $('.day-time-wrap').hide();
      $('.atc-dining').attr('disabled', 'disabled');
      $('.sold-out').addClass('show');
      $('.per-price').hide();
      $('.price-per-person').hide();
    } else if (diningStock === 0 && chefProduct === '') {
      $('.adult-child-wrap').hide();
      $('.atc-dining').attr('disabled', 'disabled');
      $('.sold-out').addClass('show');
      $('.per-price').hide();
      $('.price-per-person').hide();
    } else if (diningStock === 0 && chefProduct === 'true') {
      $('.adult-child-wrap').hide();
      $('.atc-dining').attr('disabled', 'disabled');
      $('.sold-out').addClass('show');
      $('.per-price').hide();
      $('.price-per-person').hide();
      $('.day-time-wrap').hide();
      $('.reservation-pill').hide();
    }
    $('body').on('click keypress', '.select-day-dropdown.dining .dropdown-item', function (e) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
      console.dir($(e.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling)[0].children[0].innerText);
      $(e.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.previousElementSibling)[0].children[0].innerText = e.currentTarget.innerText;
      $('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
      $('.adult-quantity-input').val('1');
      $('.child-quantity-input').val('0');
      var selectedDataId = e.currentTarget.dataset.dayid;
      $('.select-day-dropdown.dining #select-day')[0].dataset.selectedday = selectedDataId;
      $('.select-day-dropdown.dining .dropdown-toggle').addClass('ada-highlighted');
      var selectDay = e.currentTarget.innerText;
      $('.select-day-dropdown.dining .dropdown-toggle').attr('aria-label', 'Select day: ' + selectDay + ' selected');
      setTimeout(function () {
        $('.select-day-dropdown.dining .dropdown-toggle').focus();
      }, 100);
      var parentProdCode = $('#parent-product-code').val();
      var dataObj = {
        parentProductCode: parentProdCode,
        selectedDay: selectedDataId
      };
      $.ajax({
        type: 'GET',
        url: '/shop/getTimeSlots',
        contentType: 'application/json',
        data: dataObj
      }).done(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        $('.diningErrorMsg').html('');
        if (!$.isEmptyObject(res)) {
          $('.atc-dining').removeAttr('disabled');
          $('.sold-out').removeClass('show');
          $('.adult-child-wrap').show();
          $('.select-time-dropdown.dining').show();
          var tempHtml = '';
          var preSelectedTimeKey = '';
          var preSelectedTimeValue = '';
          $.each(res, function (key, value) {
            if (preSelectedTimeKey === '' && preSelectedTimeValue === '') {
              preSelectedTimeKey = key;
              preSelectedTimeValue = value;
              $.ajax({
                type: 'GET',
                url: '/shop/getUpdatedPriceForDining',
                contentType: 'application/json',
                data: { variantId: preSelectedTimeKey }
              }).done(function (response) {
                __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
                var updatestock = $('#diningStock');
                updatestock.val(Number(response.stockLevel));
                if (Number(updatestock.val()) !== 0) {
                  if (response.priceForAdult === response.priceForChild && response.priceForAdult !== '' && response.priceForChild !== '') {
                    $('.price-per-person #personPrice').html(response.priceForAdult);
                    $('.per-price').hide();
                    $('.price-per-person').show();
                    if (response.strikeOutAdultVariantPrice > 0 && response.strikeOutAdultVariantPrice) {
                      if ($('.price-per-person .strikeoutprice').length > 0) {
                        $('.price-per-person .strikeoutprice').html(response.strikeOutAdultVariantPrice);
                      } else {
                        $('.price-per-person #personPrice').before('<span class="strikeoutprice">' + response.strikeOutAdultVariantPrice + '</span');
                      }
                    }
                  } else if (response.priceForAdult !== '' && response.priceForChild === '') {
                    $('.price-per-person #personPrice').html(response.priceForAdult);
                    $('.per-price').hide();
                    $('.price-per-person').show();
                    if (response.strikeOutAdultVariantPrice > 0 && response.strikeOutAdultVariantPrice) {
                      if ($('.price-per-person .strikeoutprice').length > 0) {
                        $('.price-per-person .strikeoutprice').html(response.strikeOutAdultVariantPrice);
                      } else {
                        $('.price-per-person #personPrice').before('<span class="strikeoutprice">' + response.strikeOutAdultVariantPrice + '</span');
                      }
                    }
                  } else {
                    $('.per-price #adultPrice').html(response.priceForAdult);
                    $('.per-price #childPrice').html(response.priceForChild);
                    $('.per-price').show();
                    $('.price-per-person').hide();
                    if (response.strikeOutAdultVariantPrice > 0 && response.strikeOutChildVariantPrice > 0) {
                      if ($('.per-price .strikeoutprice').length > 0) {
                        $('.price-per-adult .strikeoutprice').html(response.strikeOutAdultVariantPrice);
                        $('.price-per-child .strikeoutprice').html(response.strikeOutChildVariantPrice);
                      } else {
                        $('.price-per-adult #adultPrice').before('<span class="strikeoutprice">' + response.strikeOutAdultVariantPrice + '</span');
                        $('.price-per-child #childPrice').before('<span class="strikeoutprice">' + response.strikeOutChildVariantPrice + '</span');
                      }
                    }
                  }
                } else {
                  $('.adult-child-wrap').hide();
                  $('.atc-dining').attr('disabled', 'disabled');
                  $('.sold-out').addClass('show');
                  $('.per-price').hide();
                  $('.price-per-person').hide();
                }
              });
            }
            tempHtml += '<button id="' + key + '" class="dropdown-item"  data-variantid="' + key + '" type="button">' + value + '</button>';
          });
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
          $('.select-time-dropdown.dining #select-time').data('variantid', preSelectedTimeKey);
          $('.select-time-dropdown.dining #select-time>span').html(preSelectedTimeValue);
          $('.select-time-dropdown.dining .dropdown-menu .simplebar-content').empty().html(tempHtml);
          $('#variantProductCode').val(preSelectedTimeKey);
        } else {
          $('.atc-dining').attr('disabled', 'disabled');
          $('.sold-out').addClass('show');
          $('.adult-child-wrap').hide();
          $('.select-time-dropdown.dining').hide();
          $('.per-price').hide();
          $('.price-per-person').hide();
        }
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong in day-dropdown ajax');
      });
    });
    $('body').on('click keypress', '.select-time-dropdown.dining .dropdown-item', function (e) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
      $('.adult-quantity-input').val('1');
      $('.child-quantity-input').val('0');
      var selectedVariantId = $(e.currentTarget).data('variantid');
      $('.select-time-dropdown.dining #select-time').attr('data-variantid', selectedVariantId);
      console.dir($('.select-time-dropdown.dining #select-time>span'));
      $('.select-time-dropdown.dining #select-time>span').html($(e.currentTarget).html());
      $('.select-time-dropdown.dining .dropdown-toggle').addClass('ada-highlighted');
      var selectTime = e.currentTarget.innerText;
      if ($('.select-cabana').length) {
        $('.select-time-dropdown.dining .dropdown-toggle').attr('aria-label', 'Select Cabana: ' + selectTime + ' selected');
      } else {
        $('.select-time-dropdown.dining .dropdown-toggle').attr('aria-label', 'Select time: ' + selectTime + ' selected');
      }
      setTimeout(function () {
        $('.select-time-dropdown.dining .dropdown-toggle').focus();
      }, 100);
      $('.dropdown-menu button').removeClass('active');
      $.ajax({
        type: 'GET',
        url: '/shop/getUpdatedPriceForDining',
        contentType: 'application/json',
        data: { variantId: selectedVariantId }
      }).done(function (res) {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        $('.diningErrorMsg').html('');
        var updatestock = $('#diningStock');
        updatestock.val(Number(res.stockLevel));
        if (Number(updatestock.val()) !== 0) {
          if (res.priceForAdult === res.priceForChild && res.priceForAdult !== '' && res.priceForChild !== '') {
            $('.price-per-person #personPrice').html('<b>' + res.priceForAdult + '</b>');
            $('.per-price').hide();
            $('.price-per-person').show();
            if (res.strikeOutAdultVariantPrice) {
              if ($('.price-per-person .strikeoutprice').length > 0) {
                $('.price-per-person .strikeoutprice').html('<b>' + res.strikeOutAdultVariantPrice + '</b>');
              } else {
                $('.price-per-person #personPrice').before('<span class="strikeoutprice"><b>' + res.strikeOutAdultVariantPrice + '</b></span>');
              }
            }
          } else if (res.priceForAdult !== '' && res.priceForChild === '') {
            $('.price-per-person #personPrice').html('<b>' + res.priceForAdult + '</b>');
            $('.per-price').hide();
            $('.price-per-person').show();
            if (res.strikeOutAdultVariantPrice) {
              if ($('.price-per-person .strikeoutprice').length > 0) {
                $('.price-per-person .strikeoutprice').html('<b>' + res.strikeOutAdultVariantPrice + '</b>');
              } else {
                $('.price-per-person #personPrice').before('<span class="strikeoutprice"><b>' + res.strikeOutAdultVariantPrice + '</b></span');
              }
            }
          } else {
            $('.per-price #adultPrice').html('<b>' + res.priceForAdult + '</b>');
            $('.per-price #childPrice').html('<b>' + res.priceForChild + '</b>');
            $('.per-price').show();
            $('.price-per-person').hide();
            if (res.strikeOutAdultVariantPrice && res.strikeOutChildVariantPrice) {
              if ($('.per-price .strikeoutprice').length > 0) {
                $('.price-per-adult .strikeoutprice').html('<b>' + res.strikeOutAdultVariantPrice + '</b>');
                $('.price-per-child .strikeoutprice').html('<b>' + res.strikeOutChildVariantPrice + '</b>');
              } else {
                $('.price-per-adult #adultPrice').before('<span class="strikeoutprice"><b>' + res.strikeOutAdultVariantPrice + '</b></span');
                $('.price-per-child #childPrice').before('<span class="strikeoutprice"><b>' + res.strikeOutChildVariantPrice + '</b></span');
              }
            }
          }
          $('#variantProductCode').val(res.variantId);
          $('.atc-dining').removeAttr('disabled');
          $('.sold-out').removeClass('show');
          $('.adult-child-wrap').show();
        } else {
          $('.adult-child-wrap').hide();
          $('.atc-dining').attr('disabled', 'disabled');
          $('.sold-out').addClass('show');
          $('.per-price').hide();
          $('.price-per-person').hide();
        }
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong in time-dropdown ajax');
      });
    });
  },
  addToCartDining: function addToCartDining() {
    $('body').on('click', '.atc-dining', function (e) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
      var csrf = $('.atc-dining').data('csrf') ? $('.atc-dining').data('csrf') : $('#csrfSessionToken').data('csrf');
      var targetElement = $(e.target).data('hasvariants');
      var productCodePost = $('#variantProductCode').val();
      var adultVal = $('.adult-quantity-input').val();
      var childVal = $('.child-quantity-input').val();
      var selectedDay = '';
      var selectedTime = '';
      if ($('.select-day-dropdown.dining').length > 0) {
        selectedDay = $('.select-day-dropdown.dining #select-day')[0].dataset.selectedday;
      }
      if ($('.select-time-dropdown.dining').length > 0) {
        selectedTime = $('.select-time-dropdown.dining #select-time')[0].innerText;
      }
      var sendData = {
        productcode: productCodePost,
        daySelected: selectedDay,
        timeSelected: selectedTime,
        adultQty: adultVal,
        childQty: childVal
      };
      var pageType = $('#pagetype').data('pagetype');
      sendData.pageType = pageType;
      if (pageType === 'CATEGORY') {
        sendData.productPosition = localStorage.getItem('productposition');
        sendData.pageNumber = localStorage.getItem('pageNumber');
        sendData.categoryName = localStorage.getItem('sascategorycode');
      }
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: '/shop/cart/dining/add',
          contentType: 'application/json',
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(sendData),
          headers: {
            CSRFToken: csrf
          }
        }).done(function (response) {
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
          if (response.diningError) {
            $('.diningErrorMsg').html(response.diningErrorText);
          } else if (response.addedToCart) {
            __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](response);
            __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideModal"]('diningAtcModal');
            CCL.addToCart.successModal(response);
            $('.diningErrorMsg').html('');
          }
        }).fail(function () {
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
          console.log('Something went wrong');
        });
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.clpAddToCart = {
  autoload: [['initialDataLoad', $('#clpAddToCartModal').length > 0], ['collapseStateroom', $('.collapsible-link').length > 0]],

  initialDataLoad: function initialDataLoad() {
    var _this = this;

    $('body').on('click', '.clp-add-to-cart-btn', function (e) {
      var dataObj = {
        productCode: $(e.currentTarget).data('productcode')
      };
      var pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        var productPosition = Number($(e.target).data('productposition')) + 1;
        var pageNumber = Number($(e.target).data('currentpage')) + 1;
        var categoryName = $(e.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
      _this.loadJsonData(dataObj);
    });
  },
  collapseStateroom: function collapseStateroom() {
    $('.collapsible-link').click(function (e) {
      $(e.currentTarget.parentElement.parentElement).find('.arrow-link img').toggleClass('time-conflict-img-rotate');
    });
  },
  loadJsonData: function loadJsonData(ajaxDataObj) {
    var _this2 = this;

    var token = $('#csrfSessionToken').data('csrf');
    var ajaxUrl = '';
    var ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/clp-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ajaxDataObj)
    }).done(function (response) {
      if (response.productCard.variantPriceList) {
        var arr = [];
        $.each(response.productCard.variantPriceList, function (i, value) {
          var t = value.split('/');
          arr.push({ priceText: t[0], priceDesc: t[1] });
        });
        response.productCard.variantPriceListNew = arr;
      }

      // Checking for conflict error msgs
      var isConflictError = void 0;
      $.each(response.bookingInformation, function (i, elem) {
        if (elem.errorMessage) {
          isConflictError = true;
          return false;
        } else if (!elem.errorMessage) {
          $.each(elem.guestInformation, function (j, guest) {
            if (guest.errorText) {
              isConflictError = true;
              return false;
            }
            return true;
          });
        }
        return true;
      });
      response.isError = isConflictError;
      _this2.loadHtmlTamplate(response);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  loadHtmlTamplate: function loadHtmlTamplate(jsonData) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/clp-atc-modal/clp-atc.html'
    }).done(function (response) {
      var html = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["createDynamicHTML"](response, jsonData);
      $('#clpAddToCartModalContent').empty().append(html);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showModal"]('clpAddToCartModal');
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["pdpGetSelectedData"]();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["checkboxCheck"]();
      _this3.modalEvents();
      // wait for things to settle down
      /* This below code is added specailly for BB modal flow
         As we are opening this modal from boooking buddy modal scroll will not work on clp atc modal
         So to fix scroll below code will work
      */
      if ($('.modal:visible').length) {
        setTimeout(function () {
          $('body').addClass('modal-open');
        }, 500);
      }
      _this3.collapseStateroom();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while loading html');
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#clpAddToCartModal');

    modalEl.find('button.close').on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        var lastFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl, 'last');
        lastFocusable.focus();
      }
    });
    modalEl.find('.general-continue-shopping').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        if (modalEl.find('.general-add-to-cart-btn:disabled').length > 0) {
          var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.general-add-to-cart-btn').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.atcAlcohol = {
  autoload: [['initialDataLoad', $('#alcoholAtcModal').length > 0]],

  initialDataLoad: function initialDataLoad() {
    var _this = this;

    $('body').on('click', '.alcohol-atc-modal-open-button', function (e) {
      var prodId = $(e.currentTarget).data('productcode');
      _this.loadAlcoholJsonData(prodId);
    });
  },
  collapseStateroom: function collapseStateroom() {
    $('.collapsible-link').click(function (e) {
      console.log('Inside collapseStateroom');
      $(e.currentTarget.parentElement.parentElement).find('.arrow-link img').toggleClass('time-conflict-img-rotate');
    });
  },
  loadAlcoholJsonData: function loadAlcoholJsonData(prodId) {
    var _this2 = this;

    var token = $('#csrfSessionToken').data('csrf');
    var ajaxUrl = '';
    var ajaxType = '';
    var dataObj = { productCode: prodId };
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/alcohol-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj),
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      _this2.loadHtmlTamplate(response);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  loadHtmlTamplate: function loadHtmlTamplate(jsonData) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/alcohol-atc-modal/alcohol-atc-modal.html'
    }).done(function (response) {
      var html = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["createDynamicHTML"](response, jsonData);
      $('#dynamicPackageAtcModal').empty().append(html);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showModal"]('alcoholAtcModal');
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["pdpGetSelectedData"]();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["checkboxCheck"]();
      _this3.variantAjax(jsonData);
      _this3.collapseStateroom();
      _this3.modalEvents();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while loading html');
    });
  },
  variantAjax: function variantAjax(jsonData) {
    if ($('.atc-card-body').children('.common-plp-error-msg').length) {
      $('.static-qty').hide();
      $('.restrict-quantity').hide();
    } else {
      $('.static-qty').show();
      $('.restrict-quantity').show();
    }
    if ($('.flavor-wrap').length > 0) {
      var ac = $('.selectable-link')[0];
      $('.add-to-cart-sfp').attr('data-hasupsell', ac.dataset.hasupsell);
      var linkVal = $('.selectable-link')[0].innerHTML;
      $(ac).addClass('active').attr('aria-label', 'active ' + linkVal);
      // ON CLICK OF SELECTABLE LINK
      $('.selectable-wrap').on('click', '.selectable-link', function (event) {
        $('.restrict-quantity .quantity-input-1').val('1');
        $('.restrict-quantity .increment-btn-1').removeAttr('disabled');
        $('.restrict-quantity .decrement-btn-1').attr('disabled', 'disabled');
        $('.terms-conditions-btn').removeAttr('disabled');
        $('.add-to-cart-sfp').removeAttr('disabled');
        var selectedlink = $(event.target).innerHTML;
        $(event.target).attr('aria-label', 'active ' + selectedlink);
        __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["pdpGetSelectedData"]();
        $('.stateroom-info .stateroom-check .parent-check').each(function (i, e) {
          $(e.offsetParent).find('.quantity-input-1').val();
          $(e.parentElement).find('.stateroom-error-msg').html('');
          $(e).removeAttr('disabled');
          $(e.parentElement).removeClass('stateroom-disabled').removeClass('all-disabled');
          $(e.parentElement).find('.alcohol-error-msg').hide();
          $(e.parentElement).find('.guest-title').removeClass('guest-disabled');
          $(e.parentElement).find('.guests .guests-check').each(function (ind, ele) {
            if ($(ele).find('.guest-error-msg')[0].innerHTML === '') {
              $(ele).removeClass('guest-disabled').removeClass('div-disabled');
              $(ele).find('.custom-control-input').removeAttr('disabled');
            }
          });
        });
        $('.selectable-link').removeClass('active');
        $(event.currentTarget).addClass('active');
        if (event.currentTarget.dataset.strikeoutprice !== '') {
          if ($('.atc-card-body .price').length > 1) {
            $('.atc-card-body .price:first-of-type').remove();
          }
          $('.atc-card-body .price').empty().html('\n          <div class="strikeout-text greytext">\n            ' + event.currentTarget.dataset.strikeoutprice + '\n          </div>\n          <div>\n            ' + event.currentTarget.dataset.price + '\n          </div>\n          ');
        } else {
          if ($('.atc-card-body .price').length > 1) {
            $('.atc-card-body .price:first-of-type').remove();
          }
          $('.atc-card-body .price').empty().html(event.currentTarget.dataset.price);
        }

        if (jsonData.variants) {
          var tempPromoData = jsonData.variants.filter(function (x) {
            return x.code === event.currentTarget.dataset.code;
          });
          if (tempPromoData.length) {
            var tempHtmlCode = '';
            if (tempPromoData[0].promotionResultsData !== null) {
              tempPromoData[0].promotionResultsData.forEach(function (element) {
                tempHtmlCode += '<div class="best-seller general-best-seller" role="textbox" aria-label="' + element.description + '"\n                          style="background-color: #10559a">\n                          <span class="info-icon" aria-hidden="true">\n                            <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="' + element.description + '" width="11"\n                              height="12">\n                          </span>\n                          ' + element.description + '\n                        </div>';
              });

              $('.promo-texts').empty().html(tempHtmlCode);
            }
          }
        }

        var variantName = event.currentTarget.dataset.producttitle;
        var atcCode = event.currentTarget.dataset.variantcode;
        var moreDetails = event.currentTarget.dataset.producturl;
        var hasUpsell = event.currentTarget.dataset.hasupsell;
        var imgUrl = event.currentTarget.dataset.imageurl;
        $('.atc-card-body .title').html(variantName);
        if (imgUrl) {
          $('.atc-card-image img').attr('src', imgUrl + '&w=224&h=128');
        }
        $('.atc-card-image').attr('aria-label', '' + variantName);
        $('.terms-conditions-btn').attr('data-productcode', atcCode);
        // $('.add-to-cart-sfp').attr('data-productcode', atcCode);
        // $('.add-to-cart-sfp').attr('data-hasupsell', hasUpsell);
        $('.alcohol-atc-modal-dialog .general-add-to-cart-btn').attr('data-productcode', atcCode);
        $('.alcohol-atc-modal-dialog .general-add-to-cart-btn').attr('data-hasupsell', hasUpsell);
        var dataObj = {
          variantId: atcCode
        };
        $.ajax({
          type: 'GET',
          url: '/shop/getconflictmessage',
          contentType: 'application/json',
          data: dataObj
        }).done(function (res) {
          $('.stateroom-info .stateroom-check .parent-check').each(function (i, e) {
            $.each(res.conflictsMap, function (key, value) {
              if (e.id === key) {
                $(e.parentElement).find('.guest-title').addClass('guest-disabled');
                $(e.parentElement).find('.stateroom-error-msg').html(value);
                $(e).attr('disabled', 'disabled').removeAttr('checked');
                $(e.parentElement).addClass('stateroom-disabled').addClass('all-disabled');
                $(e.parentElement).find('.guests .guests-check').addClass('guest-disabled');
                $(e.parentElement).find('.guests .guests-check > input').removeAttr('checked').attr('disabled', 'disabled');
              }
            });
          });
          if (res.allConflict === 'true') {
            $('.terms-conditions-btn').attr('disabled', 'disabled');
            $('.add-to-cart-sfp').attr('disabled', 'disabled');
            $('.static-qty').hide();
            $('.restrict-quantity').hide();
            if ($('body .common-plp-error-msg').length > 0 && res.allConflictMsg !== '') {
              $('.common-plp-error-msg').html(res.allConflictMsg);
            } else if ($('body .common-plp-error-msg').length === 0 && res.allConflictMsg !== '') {
              var tempHtml = '<div class="common-plp-error-msg">' + res.allConflictMsg + '</div>';
              $('.alcohol-Atc-modal-body').append(tempHtml);
            }
          } else {
            $('.terms-conditions-btn').removeAttr('disabled');
            // $('.add-to-cart-sfp').removeAttr('disabled');
            $('.common-plp-error-msg').empty();
            $('.static-qty').show();
            $('.restrict-quantity').show();
          }
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
        }).fail(function () {
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
          console.log('Something went wrong in variant ajax');
        });
      });
    }
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#alcoholAtcModal');

    modalEl.find('button.close').on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        var lastFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl, 'last');
        lastFocusable.focus();
      }
    });
    modalEl.find('.general-continue-shopping').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        if (modalEl.find('.general-add-to-cart-btn:disabled').length > 0) {
          var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.general-add-to-cart-btn').on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);
/*eslint-disable*/

CCL.heroBannerCardContainer = {
  autoload: [['heroBannerCardContainerHeight', $('.c-hero-banner-cruise-manager .hero-banner-card-container').length > 0], ['heroBannerCardContainerHeight', $('.hero-banner-small-card-container').length > 0]],
  heroBannerCardContainerHeight: function heroBannerCardContainerHeight() {
    var heroBannerCardContainerHeight = $('.hero-banner-card-container').outerHeight();
    if ($('.hero-banner-card-container')) {
      if (__WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["detectmob"]()) {
        $('.c-hero-banner-cruise-manager').css('height', heroBannerCardContainerHeight + 201 + 'px');
      }
    }

    // Executes when complete page is fully loaded, including
    // all frames, objects and images
    $(window).on('load', function () {
      $('.c-hero-banner-cruise-manager .hero-banner-card-container').css('overflow', 'visible');
      $('.hero-banner-small-card-container').fadeIn();
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($, jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__ = __webpack_require__(4);



/* eslint-disable */
CCL.editCartStateroom = {
    autoload: [['createStateroomHtml', $('.c-cart-cards').length > 0], ['allClickEvents', $('.c-cart').length > 0]],

    createStateroomHtml: function createStateroomHtml() {
        var _this = this;

        if ($('body').find('.cart-edit-stateroom-wrap').length) {
            $('body').find('.cart-edit-stateroom-wrap').each(function (i, element) {
                _this.ajaxForInitialData(element.dataset.productid, false, [], element.dataset.wishlist2entry, element.dataset.servicetimeslot, element.dataset.buyerid);
            });
        }
    },


    stateroomSelected: 0,

    ajaxForInitialData: function ajaxForInitialData(productId) {
        var orderSummaryRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var bookingIdsArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var wishList2Entry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var _this2 = this;

        var serviceTimeSlot = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var buyerId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

        var token = $('#csrfSessionToken').data('csrf');

        var dataObj = {
            productCode: productId,
            cartPage: true,
            orderSummaryRequired: orderSummaryRequired,
            wishList2Entry: wishList2Entry,
            serviceTimeSlot: serviceTimeSlot,
            buyerId: buyerId
        };
        var ajaxUrl = '';
        var ajaxType = '';
        if (window.location.hostname === 'localhost' || window.location.port === '6565') {
            ajaxUrl = '/_ui/responsive/ccl/assets/templates/cart-edit-stateroom/cart-edit-stateroom.json';
            ajaxType = 'GET';
        } else {
            ajaxUrl = '/shop/cart/clp/modal';
            ajaxType = 'POST';
        }

        $.ajax({
            type: ajaxType,
            contentType: 'application/json',
            url: ajaxUrl,
            data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj),
            headers: {
                CSRFToken: token
            }
        }).done(function (res) {
            var orderSummary = res.orderSummary;

            _this2.ajaxForRepaintHtml(res, productId, serviceTimeSlot, buyerId);
            if (orderSummaryRequired) {
                var cartQtyClass = serviceTimeSlot ? '.cart-product-qty-' + productId + '-' + serviceTimeSlot + '-' + buyerId : '.cart-product-qty-' + productId;
                if ($(cartQtyClass).length && bookingIdsArray.length) {
                    $(cartQtyClass)[0].innerText = bookingIdsArray.length;
                    __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["updateCartSummary"](orderSummary);
                    __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["updateProductSummary"](orderSummary);
                    __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["updateCouponSummary"](res);
                }
            }
        }).fail(function () {
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
            console.log('error Occured');
        });
    },
    ajaxForRepaintHtml: function ajaxForRepaintHtml(data, productId) {
        var _this3 = this;

        var serviceTimeSlot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var buyerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

        var ajaxUrl = '/_ui/responsive/ccl/assets/templates/cart-edit-stateroom/cart-edit-stateroom.html';
        if (data.productCard.productType === 'XD' && serviceTimeSlot) {
            ajaxUrl = '/_ui/responsive/ccl/assets/templates/cart-edit-stateroom/xdining-cart-edit-stateroom.html';
        }
        $.ajax({
            type: 'GET',
            url: ajaxUrl
        }).done(function (response) {
            if ($('#cost-text-' + productId).length) {
                data.costText = $('#cost-text-' + productId).html();
            }
            if ($('#beverage-condition-' + productId).length) {
                data.beverageConditionText = $('#beverage-condition-' + productId + ' .content').html();
            }
            var templateScript = __WEBPACK_IMPORTED_MODULE_1_handlebars_dist_handlebars_js__["compile"](response);
            var html = templateScript(data);
            if (data.productCard.productType === 'XD' && serviceTimeSlot && buyerId) {
                $('#cart-edit-' + productId + '-' + serviceTimeSlot + '-' + buyerId).empty().append(html);
                if ($('.card-' + productId + '-' + serviceTimeSlot + '-' + buyerId).find('.global-red-text.xdining-unavailable').length) {
                    $('#cart-edit-' + productId + '-' + serviceTimeSlot + '-' + buyerId).find('.selection-btn').removeAttr('disabled');
                }
            } else {
                $('#cart-edit-' + productId).empty().append(html);
            }

            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["pdpGetSelectedData"]();
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["checkboxCheck"]();
            _this3.disableMoveToCart();
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
        }).fail(function () {
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
            console.log('error Occured');
        });
    },
    disableMoveToCart: function disableMoveToCart() {
        $('#saveForLaterCartSection').find('.c-cart-card').each(function (index, element) {

            if ($(element).find('.custom-checkbox .parent-check').length) {
                var stateRoomCheckLength = $(element).find('.custom-checkbox .parent-check:checked').not(':disabled').length;

                if (stateRoomCheckLength < 1) {
                    $(element).find('.moveToCart_FunShop').attr('disabled', 'disabled');
                } else {
                    $(element).find('.moveToCart_FunShop').removeAttr('disabled');
                }
            } else if ($(element).find('.c-edit-guest-time-shorex-cart').length) {
                var guestIds = $(element).find('.custom-checkbox').length;
                var checkedGuestLength = $(element).find('.custom-checkbox input:checked').length;
                var conflictingGuestIds = $(element).find('.div-disabled').length;

                if (guestIds === conflictingGuestIds || checkedGuestLength < 1) {
                    $(element).find('.moveToCart_ShoreEx').attr('disabled', 'disabled');
                } else {
                    $(element).find('.moveToCart_ShoreEx').removeAttr('disabled');
                }
            }
        });
    },
    removeProduct: function removeProduct(entryId, productId, BBparentProductCode, ajaxUrl, ajaxType, sfDataObj) {
        var producttype = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        var serviceTimeSlot = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
        var selectedServiceTimeSlot = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
        var buyerId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;

        var _this4 = this;

        var selectedBuyerId = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
        var wheelChairRequired = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;

        var token = $('#csrfSessionToken').data('csrf');
        var bookingIdsArray = [];
        var guestIdsArray = [];
        var cardId = producttype == 'XD' && serviceTimeSlot ? '#cart-edit-' + productId + '-' + serviceTimeSlot + '-' + buyerId : '#cart-edit-' + productId;
        $(cardId + ' .custom-checkbox input[type="checkbox"]:checked').each(function (index, element) {
            if (element.hasAttribute('data-bookingid')) {
                bookingIdsArray.push(element.getAttribute('data-bookingid'));
            }
        });

        if ($(cardId + ' .custom-checkbox .guests-check input[type="checkbox"]').length) {
            $(cardId + ' .custom-checkbox .guests-check input[type="checkbox"]:checked').each(function (i, elem) {
                if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
                    guestIdsArray.push(elem.getAttribute('data-guestid'));
                }
            });
        }

        var removeObj = {
            productId: entryId
        };

        if (producttype == 'XD' && serviceTimeSlot) {
            removeObj.serviceTimeSlot = serviceTimeSlot;
            removeObj.buyerId = buyerId;
        }
        $.ajax({
            type: 'POST',
            url: '/shop/cart/entry/execute-action/REMOVE',
            contentType: 'application/json',
            headers: {
                CSRFToken: token
            },
            data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(removeObj)
        }).done(function (response) {
            // If booking arrays is empty that means user did not select any stateroom
            // and we now we need to actually remove that product from cart
            if (bookingIdsArray.length) {
                _this4.addProduct(productId, BBparentProductCode, ajaxUrl, ajaxType, bookingIdsArray, guestIdsArray, sfDataObj, producttype, serviceTimeSlot, selectedServiceTimeSlot, buyerId, selectedBuyerId, wheelChairRequired);
            } else {
                CCL.removeFromCart.updateCart(response, productId);
                _this4.createStateroomHtml();
            }
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
        }).fail(function () {
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
            console.log('Remove from cart error');
        });
    },
    addProduct: function addProduct(productId, BBparentProductCode, ajaxUrl, ajaxType, bookingIdsArray, guestIdsArray, sfDataObj) {
        var producttype = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
        var serviceTimeSlot = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
        var selectedServiceTimeSlot = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
        var buyerId = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;

        var _this5 = this;

        var selectedBuyerId = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
        var wheelChairRequired = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : null;

        var token = $('#csrfSessionToken').data('csrf');
        var prodCode = '';
        var dataObj = {};
        if (BBparentProductCode !== '') {
            prodCode = BBparentProductCode;
        } else {
            prodCode = productId;
        }
        if (!jQuery.isEmptyObject(sfDataObj)) {
            dataObj = sfDataObj;
        } else if (producttype == 'XD' && serviceTimeSlot && selectedServiceTimeSlot && selectedBuyerId) {

            var parentElement = $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdining-cart-edit-stateroom-wrap');
            var childAnonymousGuests = parentElement.find('.child-quantity-input').val();
            var adultAnonymousGuests = parentElement.find('.adult-quantity-input').val();
            var wheelChair = parentElement.find('.js-wheelchair-cartEdit').is(':checked');

            dataObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                productId: productId,
                bookingIds: bookingIdsArray,
                guestIds: guestIdsArray,
                timeSlot: selectedServiceTimeSlot,
                buyerId: selectedBuyerId,
                isCartPage: 'true',
                childAnonymousGuests: childAnonymousGuests,
                adultAnonymousGuests: adultAnonymousGuests,
                wheelChairRequired: wheelChair
            });
        } else dataObj = {
            productCodePost: prodCode,
            CSRFToken: token,
            qty: 1,
            bookingIds: bookingIdsArray,
            guestIds: guestIdsArray,
            wheelChairRequired: wheelChairRequired
        };
        $.ajax({
            type: 'POST',
            url: ajaxUrl,
            contentType: ajaxType,
            data: dataObj,
            headers: {
                CSRFToken: token
            }
        }).done(function (response) {

            if (producttype == 'XD' && serviceTimeSlot && selectedServiceTimeSlot && selectedBuyerId) {
                _this5.updateXdiningProductTile(prodCode, serviceTimeSlot, selectedServiceTimeSlot, response, buyerId, selectedBuyerId);

                // Update ShoreExProducts for any conflicts with xdining
                $('.cart-entries').find('.c-cart-card').each(function (index, element) {
                    if ($(element).find('.cancelEditGuest_ShoreEx').length) {
                        $(element).find('.cancelEditGuest_ShoreEx').trigger('click');
                    }
                });
            }

            _this5.ajaxForInitialData(productId, true, bookingIdsArray, false, selectedServiceTimeSlot, selectedBuyerId);

            var carId = producttype == 'XD' && selectedServiceTimeSlot && selectedBuyerId ? '.c-cart-card.card-' + productId + '-' + selectedServiceTimeSlot + '-' + selectedBuyerId : '.c-cart-card.card-' + productId;

            var $imgArrowIcon = $(carId).find('.cart-edit-stateroom-link');
            $imgArrowIcon.removeClass('open');
            var parentElement1 = $(carId).find('.cart-edit-stateroom-wrap');
            $(parentElement1).slideToggle();

            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
            // Update All products again once one product is removed
            CCL.saveForLaterObj.loadSaveForLaterCartSection();
            // Below is commented to conflict of spa n shoreEx on save for later
            // this.createStateroomHtml();
        }).fail(function () {
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["hideLoader"]();
            console.log('Add from cart error');
        });
    },
    updateXdiningProductTile: function updateXdiningProductTile(prodCode, serviceTimeSlot, selectedServiceTimeSlot, response, buyerId, selectedBuyerId) {
        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdining-cart-edit-stateroom-wrap')[0].dataset.servicetimeslot = selectedServiceTimeSlot;

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdining-cart-edit-stateroom-wrap')[0].dataset.buyerid = selectedBuyerId;

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId).find('.global-red-text.xdining-unavailable').remove();

        // Update the cart alert message also and remove this product from alert msg
        $('.cart-updates #cart-alert-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId).remove();
        var msgLength = $('.cart-updates .unavailable-item').length;
        $('.cart-updates .available').html(msgLength + ' item(s) in your cart has a conflict that needs to be resolved before you can proceed to checkout.');

        if (msgLength === 0) {
            $('.cart-updates').remove();
        }

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdiningDate span').removeClass('strikeout-text').html(response.xDiningDate);
        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdiningTime span').removeClass('strikeout-text').html(response.xDiningTime);

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdiningDate').attr('aria-label', response.xDiningDate);
        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdiningTime').attr('aria-label', response.xDiningTime);

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdining-remove')[0].dataset.servicetimeslot = selectedServiceTimeSlot;

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdining-remove')[0].dataset.buyerid = selectedBuyerId;

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .xdining-cart-edit-stateroom-wrap')[0].id = 'cart-edit-' + prodCode + '-' + selectedServiceTimeSlot + '-' + selectedBuyerId;

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId + ' .cart-product-qty-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId).removeClass('cart-product-qty-' + prodCode + '-' + serviceTimeSlot).addClass('cart-product-qty-' + prodCode + '-' + selectedServiceTimeSlot + '-' + selectedBuyerId);

        $('.card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId).removeClass('card-' + prodCode + '-' + serviceTimeSlot + '-' + buyerId).addClass('card-' + prodCode + '-' + selectedServiceTimeSlot + '-' + selectedBuyerId);

        // if user selected same timeslot then merge products and remove one extra card from cart
        if ($('.card-' + prodCode + '-' + selectedServiceTimeSlot + '-' + selectedBuyerId).length > 1) {
            $($('.card-' + prodCode + '-' + selectedServiceTimeSlot + '-' + selectedBuyerId)[1]).remove();
        }
    },
    allClickEvents: function allClickEvents() {
        var _this6 = this;

        $('body').on('click', '#saveForLaterCartSection .custom-checkbox .custom-control-input', function (event) {
            _this6.disableMoveToCart();
        });

        $('body').on('click', '.saveEditCartStateroom', function (event) {
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["showLoader"]();
            var parentElement = $(event.currentTarget).parents('.cart-edit-stateroom-wrap');
            var entryId = parentElement.data('entryid');
            var productId = parentElement[0].dataset.productid;
            var serviceTimeSlot = parentElement[0].dataset.servicetimeslot;
            var wheelChairRequired = $(event.target).closest('.cart-edit-stateroom').find('.js-wheelchair-cartEdit').is(':checked');

            var selectedServiceTimeSlot = $(parentElement).find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot');

            var buyerId = parentElement[0].dataset.buyerid;
            var selectedBuyerId = null;
            if ($(event.currentTarget).parents('.cart-edit-stateroom-wrap').find('.selected-buyer-id').length) {
                selectedBuyerId = $(event.currentTarget).parents('.cart-edit-stateroom-wrap').find('.selected-buyer-id')[0].dataset.selectedbuyerid;
            }

            var producttype = parentElement[0].dataset.producttype;
            var BBparentProductCode = '';
            var ajaxUrl = '';
            var sfDataObj = {};
            var ajaxType = '';
            var current = $(event.currentTarget);
            $(event.currentTarget).parents('.cart-card-body').find('.cart-edit-stateroom-link').attr('aria-expanded', 'false');
            if (parentElement[0].dataset.isbb === 'true') {
                BBparentProductCode = parentElement[0].dataset.parentcode;
            }
            if ((producttype !== '' || producttype !== null) && (producttype === 'SFP' || producttype === 'SF' || producttype === 'SFAP')) {
                ajaxUrl = '/shop/cart/specialFS/add';
                ajaxType = 'application/json';
                if (producttype === 'SFP') {
                    sfDataObj = CCL.pdpSfPackage.bookingData(productId, event, current);
                } else {
                    CCL.termsAndConditions.quantitySet(productId, event, current);
                    sfDataObj = sessionStorage.getItem('sessionTemplateObj');
                }
            } else if ((producttype !== '' || producttype !== null) && producttype === 'XD' && serviceTimeSlot) {
                ajaxUrl = '/shop/cart/xDining/add';
                ajaxType = 'application/json';
            } else {
                ajaxUrl = '/shop/cart/add';
                ajaxType = 'application/x-www-form-urlencoded; charset=UTF-8';
            }
            _this6.removeProduct(entryId, productId, BBparentProductCode, ajaxUrl, ajaxType, sfDataObj, producttype, serviceTimeSlot, selectedServiceTimeSlot, buyerId, selectedBuyerId, wheelChairRequired);
            setTimeout(function () {
                parentElement.siblings('.cart-edit-stateroom-link').focus();
                parentElement.siblings('.cart-edit-stateroom-link').addClass('ada-element-focus');
            }, 700);
        });

        $('body').on('click', '.cancelEditCartStateroom', function (event) {
            __WEBPACK_IMPORTED_MODULE_2__js_generalFunctions__["showLoader"]();
            var parentElement = $(event.currentTarget).parents('.cart-edit-stateroom-wrap');
            var productId = parentElement[0].dataset.productid;
            var serviceTimeSlot = parentElement[0].dataset.servicetimeslot;
            var buyerId = parentElement[0].dataset.buyerid;
            _this6.ajaxForInitialData(productId, false, [], parentElement[0].dataset.wishlist2entry, serviceTimeSlot, buyerId);

            var id = serviceTimeSlot && buyerId ? productId + '-' + serviceTimeSlot + '-' + buyerId : productId;

            $(event.currentTarget).parents('.cart-card-body').find('.cart-edit-stateroom-link').attr('aria-expanded', 'false');
            var $imgArrowIcon = $('.c-cart-card.card-' + id).find('.cart-edit-stateroom-link');
            $imgArrowIcon.removeClass('open');
            var parentElement1 = $('.c-cart-card.card-' + id).find('.cart-edit-stateroom-wrap');
            $(parentElement1).slideToggle();
            setTimeout(function () {
                parentElement.siblings('.cart-edit-stateroom-link').focus();
                parentElement.siblings('.cart-edit-stateroom-link').addClass('ada-element-focus');
            }, 700);
        });

        $('body').on('change', '.js-wheelchair-cartEdit', function (e) {
            var selectDateTime = $(e.target).closest('.cart-edit-stateroom').find('.selected-buyer-id');
            if (!$(e.target).closest('.cart-edit-stateroom').find('.day-time-wrap').is(':visible')) {
                if (selectDateTime.prop('disabled')) {
                    selectDateTime.prop('disabled', false);
                }
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3), __webpack_require__(3)))

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.atcDining = {
  autoload: [['initialDataLoad', $('#diningAtcModal').length > 0]],

  initialDataLoad: function initialDataLoad() {
    var _this = this;

    $('body').on('click', '.dining-atc-modal-open-button', function (e) {
      var prodId = $(e.currentTarget).data('productcode');
      _this.loadDiningJsonData(prodId);
    });
  },
  initialValuesTimeDay: function initialValuesTimeDay() {
    var selectDay = $('#select-day');
    var selectTime = $('#select-time');
    var dayValue = selectDay.find('> span').text();
    var timeValue = selectTime.find('> span').text();

    setTimeout(function () {
      selectDay.attr('aria-label', 'Select day: ' + dayValue + ' selected');
      if ($('.select-cabana').length) {
        selectTime.attr('aria-label', 'Select Cabana: ' + timeValue + ' selected');
      } else {
        selectTime.attr('aria-label', 'Select time: ' + timeValue + ' selected');
      }
    }, 200);
  },
  loadDiningJsonData: function loadDiningJsonData(prodId) {
    var _this2 = this;

    var token = $('#csrfSessionToken').data('csrf');
    var ajaxUrl = '';
    var ajaxType = '';
    var dataObj = { productCode: prodId };
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/dining-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj),
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      _this2.loadHtmlTamplate(response);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  loadHtmlTamplate: function loadHtmlTamplate(jsonData) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/dining-atc-modal/dining-atc-modal.html'
    }).done(function (response) {
      var html = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["createDynamicHTML"](response, jsonData);
      $('#dynamicDiningAtcModal').empty().append(html);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showModal"]('diningAtcModal');
      CCL.Dining.priceShow();
      CCL.Dining.dropdownSelect();
      _this3.modalEvents();
      _this3.initialValuesTimeDay();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while loading html');
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#diningAtcModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.addToCartModal = {
  autoload: [['modalEvents', $('#addToCartModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#addToCartModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.addToCartSuccessModal = {
  autoload: [['modalEvents', $('#addToCartSuccessModal').length > 0]],

  modalEvents: function modalEvents() {
    var modalEl = $('#addToCartSuccessModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.FlyToFun = {
  autoload: [['dropdownSelect', $('.select-booking-dropdown').length > 0], ['searchFlightsBtn', $('#searchFlightsBtn').length > 0]],

  dropdownSelect: function dropdownSelect() {
    $('#redirectLink').remove();
    $('body').on('click', '.select-booking-dropdown .dropdown-menu .dropdown-item', function (e) {
      $('#searchFlightsBtn').attr('data-flight-booking-id', e.target.innerText.replace(/^#/, ''));
      $('.select-booking-dropdown #select-booking span').html(e.target.innerText);
      $('.search-flight-error').css('display', 'none');
      $('.select-booking-dropdown .dropdown-toggle').addClass('ada-element-focus');
      var selectBooking = e.currentTarget.innerText;
      $('.select-booking-dropdown .dropdown-toggle span').attr('aria-label', 'Select booking: ' + selectBooking + ' selected');
      $('.select-booking-dropdown .dropdown-toggle span').attr('role', 'alert');
      $('.select-booking-dropdown .dropdown-toggle span').attr('aria-live', 'assertive');
      setTimeout(function () {
        $('.select-booking-dropdown .dropdown-toggle').focus();
      }, 100);
    });
  },
  searchFlightsBtn: function searchFlightsBtn() {
    $('body').on('click', '#searchFlightsBtn', function (e) {
      var flightBookingId = $('#searchFlightsBtn').attr('data-flight-booking-id');
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showLoader"]();
      $('#redirectLink').remove();
      $.ajax({
        type: 'GET',
        url: '/shop/searchFlights?bookingid=' + flightBookingId,
        contentType: 'application/json'
      }).done(function (res) {
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
        if (res.Status === true) {
          if (window.matchMedia('(max-width: 767px)').matches) {
            $('#searchFlightsBtn').after('<button \n            onclick=window.open(\'' + res.redirectURL + '\',\'_self\')\n            id="redirectLink" style="display:none">test</button>');
            $('#redirectLink').trigger('click');
          } else {
            $('#searchFlightsBtn').after('<button \n        onclick=window.open(\'' + res.redirectURL + '\')\n        id="redirectLink" style="display:none">test</button>');
            $('#redirectLink').trigger('click');
          }
        } else {
          console.log('Sorry No flight available for selected booking.');
          if (res.response) {
            $('.search-flight-error').html(res.response[0].errorDescription).css('display', 'block');
          } else if (res.displayErrorMessage) {
            $('.search-flight-error').html(res.displayErrorMessage).css('display', 'block');
          }
        }
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong in Search Flights AJAX');
      });
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__ = __webpack_require__(4);






CCL.ajaxCLP = {
  autoload: [['initialCLPDataLoad', $('.c-plp-products-ajax').length > 0]],

  currentPage: 0,
  selectedRating: 0,
  initialResponse: {},
  promise: {},
  promoResponse: {},

  // Load initial json data
  initialCLPDataLoad: function initialCLPDataLoad(query) {
    var _this = this;

    var firstTimeLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
    var ajaxUrl = '';
    var ajaxType = '';
    var categoryId = $('.c-plp-products-ajax').data('categoryid');
    var rootCategoryCode = $('.c-plp-products-ajax').data('parentcategoryid');
    var token = $('#csrfSessionToken').data('csrf');
    var finalQuery = '';
    if (rootCategoryCode) {
      finalQuery = query ? '?q=' + query + '&rootCategoryCode=' + rootCategoryCode : '?rootCategoryCode=' + rootCategoryCode;
    } else {
      finalQuery = query ? '?q=' + query : '';
    }

    // take query from browser URL bar
    if (finalQuery) {
      window.history.replaceState(null, null, finalQuery);
    } else {
      finalQuery = window.location.search ? window.location.search : finalQuery;
    }

    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = finalQuery ? '/_ui/responsive/ccl/assets/templates/ajax-clp/shoreex.json?q=' + finalQuery : '/_ui/responsive/ccl/assets/templates/ajax-clp/shoreex.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = finalQuery ? '/shop/plp/search/' + categoryId + finalQuery : '/shop/plp/search/' + categoryId;
      ajaxType = 'GET';
    }

    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      if (response.showPresaleCutoffAlert) {
        $('.c-alert-banner-cut-off-notification').css('display', 'block');
      }
      _this.currentPage = 0;
      if (response && response.productCategorySearchPageData && response.productCategorySearchPageData.pagination) {
        // Update current page on every call
        _this.currentPage = response.productCategorySearchPageData.pagination.currentPage;
      }

      _this.initialResponse = response;

      if (response.userFlowType === 'LOGGED_IN_BUY' && $('#promotionURL').data('promotionurl') && $('#promotionURL').data('promotionurl') !== '') {
        // If we have strike-through promotional pricing
        _this.promise = _this.promotionPricingAjax(response);
      }

      // Deal of the day Data
      var dealOfTheDayProduct = response.dealOfTheDayProduct;

      if (dealOfTheDayProduct) {
        // Get Deal of the day pills
        dealOfTheDayProduct.pillsData = {};
        dealOfTheDayProduct.pillsData.isFeatured = _this.isFeaturedPill(dealOfTheDayProduct);
        dealOfTheDayProduct.pillsData.isNew = _this.isNewPill(dealOfTheDayProduct);
        dealOfTheDayProduct.pillsData.showLimitedAvailability = dealOfTheDayProduct.showLimitedAvailability;
        dealOfTheDayProduct.pillsData.isdDiscounteligible = _this.isDiscounteligiblePill(dealOfTheDayProduct);
        dealOfTheDayProduct.pillsData.isSoldOut = _this.isSoldOutPill(dealOfTheDayProduct, response);

        // Get HTML for price - deal Of The Day
        var dealOfTheDayProductPrice = _this.priceHtml(dealOfTheDayProduct, response);
        dealOfTheDayProduct.priceDiv = dealOfTheDayProductPrice.priceDiv;
        dealOfTheDayProduct.priceADA = dealOfTheDayProductPrice.priceADA;

        // Get classes and attributes based on product data
        var dealOfTheDayProductBtn = _this.addToCartBtnClasses(dealOfTheDayProduct, response);
        dealOfTheDayProduct.addToCartBtnClass = dealOfTheDayProductBtn.addToCartBtnClass;
        dealOfTheDayProduct.addToCartBtnAttributes = dealOfTheDayProductBtn.addToCartBtnAttributes;

        // Get EyeBrow HTML
        dealOfTheDayProduct.eyeBrowHtml = _this.eyeBrowHtml(dealOfTheDayProduct);

        // Get Carousel HTML
        dealOfTheDayProduct.carouselHtml = _this.getCarouselHtml(dealOfTheDayProduct, response) + '?w="848"&h="430"';

        // Get Rating stars HTML
        if ((dealOfTheDayProduct.ratingsEnabled || response.ratingsEnabled) && dealOfTheDayProduct.productAverageRating !== null) {
          dealOfTheDayProduct.ratingStars = _this.tilesRating(dealOfTheDayProduct.productAverageRating, dealOfTheDayProduct.code);
        }

        // Description
        if (dealOfTheDayProduct.description !== null) {
          dealOfTheDayProduct.smallDescription = dealOfTheDayProduct.description.substring(0, 120) + '...';
        }
      }

      response.paginationFooterHtml = _this.getPaginationFooterHtml(response);

      if (response.productCategorySearchPageData) {
        $.each(response.productCategorySearchPageData.results, function (key, val) {
          // Get HTML for price
          val.pillsData = {};
          val.pillsData.isFeatured = _this.isFeaturedPill(val);
          val.pillsData.isNew = _this.isNewPill(val);
          val.pillsData.showLimitedAvailability = val.showLimitedAvailability;
          val.pillsData.isdDiscounteligible = _this.isDiscounteligiblePill(val);
          val.pillsData.isSoldOut = _this.isSoldOutPill(val, response);

          // Get HTML for price
          var price = _this.priceHtml(val, response);
          val.priceDiv = price.priceDiv;
          val.priceADA = price.priceADA;

          // Get classes and attributes based on product data
          var btn = _this.addToCartBtnClasses(val, response);
          val.addToCartBtnClass = btn.addToCartBtnClass;
          val.addToCartBtnAttributes = btn.addToCartBtnAttributes;

          // Get Carousel HTML
          val.carouselHtml = _this.getCarouselHtml(val, response);

          // is wheelchair
          val.isWheelChair = _this.isWheelChair(val);

          // Get EyeBrow Text HTML
          val.eyeBrowHtml = _this.eyeBrowHtml(val);

          if ((val.ratingsEnabled || response.ratingsEnabled) && val.productAverageRating !== null) {
            val.productAverageRating = val.productAverageRating.toFixed(1);
            val.ratingStars = _this.tilesRating(val.productAverageRating, val.code);
          }

          if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
            val.lazyLoadingEnabled = true;
          } else {
            val.lazyLoadingEnabled = false;
          }
        });
      }
      // Group ports by region
      response.portByRegionArr = _this.groupPortByRegion(response);

      // load all the product tiles html
      _this.loadCLPTiles(response);

      // load all the product facets html
      if (response.productCategorySearchPageData && response.productCategorySearchPageData.pagination.totalNumberOfResults > 0) {
        _this.loadCLPFacets(response, firstTimeLoad);
      }

      // load sorting options for first time
      if (firstTimeLoad) {
        _this.loadSortingDropdown(response);
      }

      // load click event for pagination
      _this.showPagination(response, firstTimeLoad);
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      console.log('error while fetching clp data');
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
    });
  },
  loadCLPTiles: function loadCLPTiles(jsonData) {
    var _this2 = this;

    var pageName = ACC.pageName; // eslint-disable-line
    if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
    }
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/ajax-clp/ajax-clp.html'
    }).done(function (response) {
      var html = __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["createDynamicHTML"](response, jsonData);
      $('.c-plp-products-ajax').empty().append(html);
      if (jsonData.productCategorySearchPageData && jsonData.productCategorySearchPageData.breadcrumbs && !jsonData.productCategorySearchPageData.breadcrumbs.length) {
        $('.c-sorting-category').css('border-bottom', 'none');
        $('.tag-wrap').css('padding', '5px 0');
      } else {
        $('.c-sorting-category').css('border-bottom', '1px solid #ececec');
        $('.tag-wrap').css('padding', '16px 0');
      }
      // if (jsonData.atcDisabledDomains && jsonData.atcDisabledDomains.length && jsonData.sessionLanguageCurrency !== null) {
      // if (jsonData.atcDisabledDomains.includes(jsonData.sessionLanguageCurrency)) {
      // $('.general-add-to-cart-btn').hide();
      // }
      // }
      _this2.tilesClickEvents();

      if (jsonData.userFlowType === 'LOGGED_IN_BUY' && $('#promotionURL').data('promotionurl') && $('#promotionURL').data('promotionurl') !== '') {
        // using promise from promo ajax call
        _this2.promise.then(function (res) {
          _this2.promoResponse = res;
          if (_this2.promoResponse && _this2.promoResponse.promotionsData.length) {
            $.each(_this2.promoResponse.promotionsData, function (key, val) {
              // show promoPill for all the CLP products
              $('body').find('.' + val.productBaseCode + ' .pills-wrap').append('<div class="best-seller general-best-seller">\n                  <span class="info-icon" aria-hidden="true">\n                      <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="Featured" width="11" height="12">\n                  </span>\n                  ' + val.promotionResultsData[0].description + '\n                </div>');

              if (val.productType === 'EX' || val.productType === 'DI') {
                _this2.shoreExPromoPriceHtml(val);
              }

              if (val.productType === 'FS') {
                _this2.funshopPromoPriceHTML(val);
              }
            });
          }
        }).catch(function () {
          console.log('error while fetching clp data');
          __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
        });
      }

      // Switch for favorite functionality
      if ($('#isfavoritesEnabled').length) {
        if ($('#isfavoritesEnabled')[0].dataset.enabled === true || $('#isfavoritesEnabled')[0].dataset.enabled === 'true') {
          $('body').find('.fav-section').removeClass('d-none');
        }
      }
      if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      }
    }).fail(function () {
      console.log('error while loading html');
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
    });
  },
  loadCLPFacets: function loadCLPFacets(jsonData, firstTimeLoad) {
    var _this3 = this;

    var pageName = ACC.pageName; // eslint-disable-line
    if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
    }
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/ajax-clp/facets-ajax-clp.html'
    }).done(function (response) {
      var html = __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["createDynamicHTML"](response, jsonData);
      $('.c-category-facets #category-facets-accordion').empty().append(html);

      if (firstTimeLoad) {
        _this3.facetsClickEvents();
      }
      if (jsonData.productCategorySearchPageData.facets.length && jsonData.productCategorySearchPageData.facets.filter(function (x) {
        return x.code === 'averageReview';
      }).length > 0) {
        $('.facets-rating').starRating({
          starSize: 25,
          disableAfterRate: false,
          callback: function callback(currentRating, $el) {
            _this3.selectedRating = currentRating;
            var query = _this3.getQuery(_this3.initialResponse.productCategorySearchPageData.currentQuery.query.value);
            _this3.initialCLPDataLoad(query, false);
          },
          onHover: function onHover(currentIndex, currentRating, $el) {
            var text = currentIndex < 5 ? currentIndex + ' AND UP' : currentIndex;
            $($el).parents('.review').find('.review-text').text(text);
          },
          onLeave: function onLeave(currentIndex, currentRating, $el) {
            var text = currentRating < 5 ? currentRating + ' AND UP' : currentRating;
            $($el).parents('.review').find('.review-text').text(text);
          }
        });
        $('.facets-rating').starRating('setRating', jsonData.selectedRating ? jsonData.selectedRating : 0);
      }
      if (!firstTimeLoad) {
        setTimeout(function () {
          $('#facetSearchResult').empty().append('<span role=\'alert\'>' + jsonData.productCategorySearchPageData.pagination.totalNumberOfResults + ' items found</span>');
        }, 300);
      }
      if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
      }
    }).fail(function () {
      console.log('error while loading html');
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
    });
  },
  loadSortingDropdown: function loadSortingDropdown(jsonData) {
    var _this4 = this;

    $('body').on('click keypress', '.c-sorting-category button.dropdown-item', function (e) {
      $('.c-sorting-category button.dropdown-item').removeClass('active');
      $(e.currentTarget).addClass('active');
      $('.c-sorting-category .dropdown-toggle')[0].innerText = $('.c-sorting-category button.dropdown-item.active')[0].innerText;
      var query = _this4.getQuery(_this4.initialResponse.productCategorySearchPageData.currentQuery.query.value);
      _this4.initialCLPDataLoad(query, false);
      var selectedSort = e.currentTarget.innerText;
      setTimeout(function () {
        $(function () {
          $('.c-sorting-category .dropdown-toggle').addClass('ada-highlighted');
          $('.c-sorting-category .dropdown-toggle').attr('aria-label', 'Sort option ' + selectedSort + ' selected');
          $('.c-sorting-category .dropdown-toggle').focus();
        });
      }, 3000);
    });
  },
  showPagination: function showPagination(jsonData, firstTimeLoad) {
    var _this5 = this;

    if (jsonData && jsonData.productCategorySearchPageData && jsonData.productCategorySearchPageData.pagination) {
      var pages = jsonData.productCategorySearchPageData.pagination.numberOfPages;
      var numberPagesShown = jsonData.numberPagesShown;

      numberPagesShown = pages < numberPagesShown ? pages : numberPagesShown;
      var tmp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(this.currentPage / numberPagesShown) ? this.currentPage / numberPagesShown + 0.1 : this.currentPage / numberPagesShown;
      var range = Math.ceil(tmp);
      var start = range * numberPagesShown - numberPagesShown + 1;
      var end = range * numberPagesShown < pages ? range * numberPagesShown : pages;

      var html = '';
      if (pages > 1) {
        html = '<li class="page-item previous" value="' + (this.currentPage - 1) + '">\n      <a class="page-link previous" href="javascript:;" aria-label="go to previous page"><span class="general-pagination-previous">Previous</span>\n      </a></li>';

        if (this.currentPage < numberPagesShown) {
          for (var i = 1; i <= numberPagesShown; i++) {
            if (i - 1 === this.currentPage) {
              html += '<li class="page-item active" value="' + (i - 1) + '"><a class="page-link" href="javascript:;">' + i + '<span class="sr-only general-pagination-current">(current page ' + i + ' out of ' + pages + ')</span> </a></li>';
            } else {
              html += '<li class="page-item" value="' + (i - 1) + '"><a class="page-link" href="javascript:;" aria-label="' + i + ' out of ' + pages + ' pages">' + i + '</a></li>';
            }
          }
        } else {
          for (var _i = start; _i <= end; _i++) {
            if (_i - 1 === this.currentPage) {
              html += '<li class="page-item active" value="' + (_i - 1) + '"><a class="page-link" href="javascript:;">' + _i + '<span class="sr-only general-pagination-current">(current page ' + _i + ' out of ' + pages + ')</span></a></li>';
            } else {
              html += '<li class="page-item" value="' + (_i - 1) + '"><a class="page-link" href="javascript:;" aria-label="' + _i + ' out of ' + pages + ' pages">' + _i + '</a></li>';
            }
          }
        }

        html += '<li class="page-item next" value="' + (this.currentPage + 1) + '">\n      <a href="javascript:;" class="page-link next" aria-label="go to next page"><span class="general-pagination-next">Next</span>\n         </a>\n      </li>';
      }
      $('.c-pagination .pagination').empty().append(html);
      if (this.currentPage === 0) {
        $('.pagination .next').removeClass('disabled');
        $('.pagination .previous').addClass('disabled');
        $('.pagination .previous').attr('tabindex', '-1');
        $('.pagination .next').removeAttr('tabindex');
      } else if (this.currentPage + 1 === pages) {
        $('.pagination .next').addClass('disabled');
        $('.pagination .previous').removeClass('disabled');
        $('.pagination .next').attr('tabindex', '-1');
        $('.pagination .previous').removeAttr('tabindex');
      }

      // register click event one time only
      if (firstTimeLoad) {
        $('body').on('click keypress', '.pagination .page-link', function (e) {
          var pageName = ACC.pageName; // eslint-disable-line
          if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
            __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
          }
          $('.pagination .page-item').removeClass('active');
          $(e.currentTarget).parents('.page-item').addClass('active');

          if (Number(e.currentTarget.innerText) === pages) {
            $('.pagination .next').addClass('disabled');
            $('.pagination .previous').removeClass('disabled');
          } else if (Number(e.currentTarget.innerText) === 1) {
            $('.pagination .next').removeClass('disabled');
            $('.pagination .previous').addClass('disabled');
          } else {
            $('.pagination .next').removeClass('disabled');
            $('.pagination .previous').removeClass('disabled');
          }
          var query = _this5.getQuery(_this5.initialResponse.productCategorySearchPageData.currentQuery.query.value);
          _this5.initialCLPDataLoad(query, false);

          $('html, body').animate({
            scrollTop: $('.c-sorting-category').offset().top + ($('.c-sorting-category')[0].clientHeight - 100)
          }, 500);

          setTimeout(function () {
            $(function () {
              $('body').addClass('ccl-ada-focus');
              $('.c-plp-products-ajax .ccl_product_title:first').addClass('ada-highlighted');
              $('.c-plp-products-ajax .ccl_product_title:first').focus();
            });
          }, 1500);
          if (!pageName.toLowerCase().includes('spa') || !pageName.toLowerCase().includes('dining')) {
            __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
          }
        });
      }
    }
  },


  // get query for ajax call-facet, sort, pagination
  getQuery: function getQuery() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var fromFacets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // generate facet query
    var selectedSortData = this.initialResponse.productCategorySearchPageData.sorts.filter(function (x) {
      return x.selected;
    })[0].code;
    var facetQuery = '';
    var finalQuery = '';
    if (query) {
      /* eslint-disable */
      facetQuery = query.split(selectedSortData)[1] ? query.split(selectedSortData)[1] : '';
      /* eslint-enable */
    } else {
      $('.facet-body-section .facet-checkbox').each(function (index, element) {
        if (element.checked) {
          if (element.dataset.query) {
            var elementQuery = element.dataset.truncatequery.split(selectedSortData)[1] ? element.dataset.truncatequery.split(selectedSortData)[1] : element.dataset.truncatequery.split(selectedSortData)[0];
            facetQuery += elementQuery;
          }
        }
      });
    }

    // generate sort query
    var selectedSort = $('.c-sorting-category button.dropdown-item.active').length ? $('.c-sorting-category button.dropdown-item.active')[0].value : $('.c-sorting-category button.dropdown-item')[0].value;

    // generate pagination query
    var selectedPage = $('.page-link').length ? $('.pagination .active')[0].value : 0;
    if (fromFacets) {
      selectedPage = 0;
    }

    if (this.selectedRating > 0) {
      if (facetQuery.includes('averageReview')) {
        var strLength = 'averageReview'.length;
        var indexAVR = facetQuery.indexOf('averageReview');
        var totalIndex = strLength + indexAVR + 1;
        var previousSelectedRating = Number(this.initialResponse.selectedRating);

        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(previousSelectedRating)) {
          facetQuery = '' + facetQuery.slice(0, totalIndex) + this.selectedRating + facetQuery.slice(totalIndex + 1);
        } else {
          facetQuery = '' + facetQuery.slice(0, totalIndex) + this.selectedRating + facetQuery.slice(totalIndex + 3);
        }

        finalQuery = ':' + selectedSortData + facetQuery + '&sort=' + selectedSort + '&page=' + selectedPage;
      } else {
        finalQuery = ':' + selectedSortData + facetQuery + ':averageReview:' + this.selectedRating + '&sort=' + selectedSort + '&page=' + selectedPage;
      }
    } else {
      finalQuery = ':' + selectedSortData + facetQuery + '&sort=' + selectedSort + '&page=' + selectedPage;
    }

    return finalQuery;
  },


  // All click events on facets
  facetsClickEvents: function facetsClickEvents() {
    var _this6 = this;

    var queryToSend = '';
    $('body').on('click keypress', '.facet-checkbox', function (e) {
      if (e.currentTarget.checked) {
        var selectedSort = _this6.initialResponse.productCategorySearchPageData.sorts.filter(function (x) {
          return x.selected;
        })[0].code;

        var currentQueryFromResponse = _this6.initialResponse.productCategorySearchPageData.currentQuery.query.value;
        var currentQueryFromFacet = e.currentTarget.dataset.truncatequery.split(selectedSort)[1];
        queryToSend = '' + currentQueryFromResponse + currentQueryFromFacet;
      } else {
        queryToSend = e.currentTarget.dataset.query;
      }
      var queryTest = _this6.getQuery(queryToSend, true);
      _this6.initialCLPDataLoad(queryTest, false);

      $('html, body').animate({
        scrollTop: $('.c-sorting-category').offset().top + ($('.c-sorting-category')[0].clientHeight - 100)
      }, 500);
      var checkboxId = e.currentTarget.id;
      setTimeout(function () {
        $(function () {
          $('#' + checkboxId).addClass('ada-highlighted');
          $('#' + checkboxId).focus();
        });
      }, 3000);
    });

    $('body').on('click keypress', '.remove-facet', function (e) {
      if ($(e.currentTarget).hasClass('facet-star-close')) {
        _this6.selectedRating = 0;
      }
      var filter = $(e.currentTarget).parents('.selected-tag').text();
      $(e.currentTarget).parents('.tag-wrap').find('.sr-only').empty().text('removed filter ' + filter);
      var query = _this6.getQuery(e.currentTarget.dataset.query);
      _this6.initialCLPDataLoad(query, false);
    });

    $('body').on('keypress', '.facet-header', function (e) {
      $(e.currentTarget).trigger('click');
    });

    $('body').on('click keypress', '.c-plp-products-ajax .btn-red.general-add-to-cart-btn', function (event) {
      var pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        var productPosition = Number($(event.target).data('productposition')) + 1;
        var pageNumber = Number($(event.target).data('currentpage')) + 1;
        var categoryName = $(event.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
    });
  },
  isFeaturedPill: function isFeaturedPill(productTileData) {
    if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && productTileData.shoreExData !== null && productTileData.shoreExData.isFeatured === true || (productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.diningData !== null && productTileData.diningData.isFeatured === true || (productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel') && productTileData.spaData !== null && productTileData.spaData.isFeatured === true) {
      return true;
    }
    return false;
  },
  isNewPill: function isNewPill(productTileData) {
    if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && productTileData.shoreExData !== null && productTileData.shoreExData.isNew === true || (productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.diningData !== null && productTileData.diningData.isNew === true || (productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel') && productTileData.spaData !== null && productTileData.spaData.isNew === true) {
      return true;
    }
    return false;
  },
  isDiscounteligiblePill: function isDiscounteligiblePill(productTileData) {
    if ((productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel') && productTileData.spaData !== null && productTileData.spaData.discountEligible === true) {
      return true;
    }
    return false;
  },
  isSoldOutPill: function isSoldOutPill(productTileData, response) {
    var isStockAvailable = true;
    if (productTileData.stock && productTileData.stock.stockLevelStatus && productTileData.stock.stockLevelStatus.code === 'outOfStock') {
      isStockAvailable = false;
    }
    if (response.userFlowType && response.userFlowType !== 'BROWSE' && response.userFlowType !== 'LOGGED_IN_BROWSE') {
      /* eslint-disable */
      if (!isStockAvailable && (productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel' || (productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && (productTileData.productType.code === 'DI' || productTileData.productType.code === 'XD'))) {
        return true;
      }
      /* eslint-enable */
    }
    return false;
  },
  tilesRating: function tilesRating(averageRating, productCode) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= averageRating) {
        html += ' <span> <img src="/_ui/responsive/ccl/assets/icons/star_filled.svg" width="12" height="11" alt="rating">\n      </span>';
      }
      if (i > averageRating) {
        if (i - 1 <= averageRating) {
          html += ' <span> <img src="/_ui/responsive/ccl/assets/icons/starhalf.svg" width="12" height="11" alt="rating">\n        </span>';
        } else {
          html += ' <span> <img src="/_ui/responsive/ccl/assets/icons/star_empty.svg" width="12" height="11" alt="rating">\n        </span>';
        }
      }
    }

    return html;
  },
  priceHtml: function priceHtml(val, response) {
    var itemType = val.itemType;

    var price = {};
    // if it is shoreEx product
    if (itemType !== null && (itemType === 'ShoreExProduct' || itemType === 'ShoreExProductModel') && val.shoreExData !== null) {
      price = this.shorexPriceHtml(val, response);
    } else if (itemType !== null && (itemType === 'SpaProduct' || itemType === 'SpaProductModel')) {
      price = this.spaPriceHTML(val, response);
    } else if (itemType !== null && (itemType === 'FunShopProduct' || itemType === 'FunShopProductModel' || itemType === 'FunShopVariantProduct' || itemType === 'FunShopVariantProductModel')) {
      price = this.funshopPriceHTML(val, response);
    } else if (itemType !== null && (itemType === 'DiningProduct' || itemType === 'DiningProductModel') && val.productType.code === 'DI') {
      price = this.diningPriceHTML(val, response);
    } else if (itemType !== null && (itemType === 'DiningProduct' || itemType === 'DiningProductModel') && val.productType.code === 'XD') {
      price = this.xDiningPriceHTML(val, response);
    }
    return price;
  },
  promotionPricingAjax: function promotionPricingAjax(initialResData) {
    var token = $('#csrfSessionToken').data('csrf');
    var promoUrl = $('#promotionURL').data('promotionurl');
    var ajaxUrl = promoUrl;
    var ajaxType = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/ajax-clp/promo-price.json';
      ajaxType = 'GET';
    }
    var products = [];
    var promotionalSailingData = '';
    if ($('#maskedSailingData').length && $('#maskedSailingData').data('sailingdata') !== '') {
      promotionalSailingData = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()($('#maskedSailingData').data('sailingdata')));
    }
    if (initialResData && initialResData.productCategorySearchPageData && initialResData.productCategorySearchPageData.results.length) {
      $.each(initialResData.productCategorySearchPageData.results, function (key, val) {
        var prodCode = val.code;
        var salesPerUnitDescription = null;
        if (val.itemType === 'ShoreExProduct' && val.shoreExData) {
          prodCode = val.shoreExData.variantData.skuCode;
          salesPerUnitDescription = val.shoreExData && val.shoreExData.salesPerUnitDescription ? val.shoreExData.salesPerUnitDescription : null;
        } else if (val.itemType === 'FunShopProduct' && val.funShopData) {
          prodCode = val.funShopData && val.funShopData.variantCode ? val.funShopData.variantCode : prodCode;
          salesPerUnitDescription = val.funShopData && val.funShopData.salesPerUnitDescription ? val.funShopData.salesPerUnitDescription : null;
        } else if (val.itemType === 'DiningProduct' && val.diningData && val.productType.code !== 'XD') {
          prodCode = val.diningData && val.diningData.variantData.skuCode ? val.diningData.variantData.skuCode : prodCode;
        }
        if (val.productType.code !== 'XD') {
          products.push({
            productCode: prodCode,
            productBaseCode: val.code,
            productType: val.productType.code,
            salesPerUnitDescription: salesPerUnitDescription
          });
        }
      });
    }

    return $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ products: products, promotionalSailingData: promotionalSailingData })
    });
  },


  /* eslint-disable */
  shoreExPromoPriceHtml: function shoreExPromoPriceHtml(productPromoData) {
    if (productPromoData.discountedPrice.length > 1) {
      // if both values are not same that means we have separate adult & child
      if (productPromoData.discountedPrice[0].value !== productPromoData.discountedPrice[1].value) {
        var adultHtml = '';
        var childHtml = '';
        var oldAdultPriceObj = productPromoData.originalPrice.filter(function (x) {
          return x.priceGroupType === 'A';
        })[0];
        var oldChildPriceObj = productPromoData.originalPrice.filter(function (x) {
          return x.priceGroupType === 'C';
        })[0];

        var newAdultPriceObj = productPromoData.discountedPrice.filter(function (x) {
          return x.priceGroupType === 'A';
        })[0];
        var newChildPriceObj = productPromoData.discountedPrice.filter(function (x) {
          return x.priceGroupType === 'C';
        })[0];

        adultHtml = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ' + oldAdultPriceObj.formattedValue + '" role="textbox"> <b>' + oldAdultPriceObj.formattedValue + '</b></span > / Adult</span ></p> <b aria-label="current price is ' + newAdultPriceObj.formattedValue + '" role="textbox">' + newAdultPriceObj.formattedValue + '</b></div>';

        childHtml = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ' + oldChildPriceObj.formattedValue + '" role="textbox"> <b>' + oldChildPriceObj.formattedValue + '</b></span > / Child</span ></p> <b aria-label="current price is ' + newChildPriceObj.formattedValue + '" role="textbox">' + newChildPriceObj.formattedValue + '</b></div>';

        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-adult').replaceWith(adultHtml);
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-child').replaceWith(childHtml);
      } else {
        var priceHtml = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox"><b>' + productPromoData.originalPrice[0].formattedValue + '</b></span> / Person</span></p></div><b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">' + productPromoData.discountedPrice[0].formattedValue + '</b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .single-row-price').replaceWith(priceHtml);
      }
    } else {
      if (productPromoData.salesPerUnitDescription) {
        var _priceHtml = '<div>\n        <p class="price-person general-price-person ccl-d-inline-flex">\n        <span class="general-price-ShoreExProduct">\n        <span class="strikeoutprice greytext" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox"><b>' + productPromoData.originalPrice[0].formattedValue + '</b></span> / ' + productPromoData.salesPerUnitDescription + '</span></p></div><b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox"> ' + productPromoData.discountedPrice[0].formattedValue + '</b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .single-row-price').replaceWith(_priceHtml);
      } else {
        var _priceHtml2 = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-ShoreExProduct"><span class="strikeoutprice greytext" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox"><b>' + productPromoData.originalPrice[0].formattedValue + '</b></span> / Person</span></p></div><b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">' + productPromoData.discountedPrice[0].formattedValue + '</b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .single-row-price').replaceWith(_priceHtml2);
      }
    }
  },
  funshopPromoPriceHTML: function funshopPromoPriceHTML(productPromoData) {
    var adultDiv = '';
    var childDiv = '';
    var salesPerUnitDescription = productPromoData.salesPerUnitDescription ? productPromoData.salesPerUnitDescription : '';
    if (productPromoData.discountedPrice.length > 1) {
      if (productPromoData.discountedPrice[0].value !== productPromoData.discountedPrice[1].value) {
        adultDiv = '<span class="general-price-FunShopProduct" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox">\n          <span class="strikeoutprice greytext">\n          <b> ' + productPromoData.originalPrice[0].formattedValue + '</b>\n          </span>\n          ' + salesPerUnitDescription + '\n          </span>\n          <b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">\n          ' + productPromoData.discountedPrice[0].formattedValue + '\n          </b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike').replaceWith(adultDiv);

        childDiv = '<span class="general-price-FunShopProduct" aria-label="before the price was ' + productPromoData.originalPrice[1].formattedValue + '" role="textbox">\n        <span class="strikeoutprice greytext">\n        <b>' + productPromoData.originalPrice[1].formattedValue + '</b>\n        </span>\n        ' + salesPerUnitDescription + '\n        </span>\n        ' + parentPrice + '\n        <b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">' + productPromoData.discountedPrice[0].formattedValue + '</b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike-child').replaceWith(childDiv);
      } else {
        adultDiv = '<span class="general-price-FunShopProduct" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox">\n          <span class="strikeoutprice greytext">\n          <b> ' + productPromoData.originalPrice[0].formattedValue + '</b>\n          </span>\n          ' + salesPerUnitDescription + '\n          </span>\n          <b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">\n          ' + productPromoData.discountedPrice[0].formattedValue + '\n          </b>';
        $('body').find('.' + productPromoData.productBaseCode + ' .no-strike').replaceWith(adultDiv);
      }

      $('body').find('.' + productPromoData.productBaseCode + ' .btn-red').attr('aria-label', 'Add ' + productPromoData.name + ' to the cart with price ' + productPromoData.discountedPrice[0].formattedValue);
    } else {
      adultDiv = '<span class="general-price-FunShopProduct" aria-label="before the price was ' + productPromoData.originalPrice[0].formattedValue + '" role="textbox">\n          <span class="strikeoutprice greytext">\n          <b> ' + productPromoData.originalPrice[0].formattedValue + '</b>\n          </span>\n          ' + salesPerUnitDescription + '\n          </span>\n          <b aria-label="current price is ' + productPromoData.discountedPrice[0].formattedValue + '" role="textbox">\n          ' + productPromoData.discountedPrice[0].formattedValue + '\n          </b>';
      $('body').find('.' + productPromoData.productBaseCode + ' .no-strike').replaceWith(adultDiv);

      $('body').find('.' + productPromoData.productBaseCode + ' .btn-red').attr('aria-label', 'Add ' + productPromoData.name + ' to the cart with price ' + productPromoData.discountedPrice[0].formattedValue);
    }
  },
  shorexPriceHtml: function shorexPriceHtml(val, response) {
    var priceDiv = '';
    var priceADA = '';
    if (response.userFlowType === null || response.userFlowType !== null && response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE' || response.userFlowType === 'ORGANIZER') {
      // price for any type of sales per unit
      if (val.shoreExData.salesPerUnitDescription !== null && val.shoreExData.basePriceData !== null) {
        priceDiv = '<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-' + val.itemType + '"><b class="price-val">' + val.shoreExData.basePriceData.formattedValue + '</b> ' + val.shoreExData.salesPerUnitDescription + '</span></p></div>';
        priceADA = 'with price Starting At ' + val.shoreExData.basePriceData.formattedValue + ' ' + val.shoreExData.salesPerUnitDescription;
      } else if (val.shoreExData.basePriceData !== null && val.shoreExData.childBasePriceData !== null) {
        if (val.shoreExData.basePriceData.formattedValue === val.shoreExData.childBasePriceData.formattedValue) {
          // price when both base price and child are present but both are equal we show per person
          priceDiv = '<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-' + val.itemType + '"><b class="person-price-val">' + val.shoreExData.basePriceData.formattedValue + '</b> / Person</span></p></div>';

          priceADA = 'with price Starting At ' + val.shoreExData.basePriceData.formattedValue + ' per Person';
        } else {
          // price when both base price and child are present but both are not equal we show per adult and per child
          priceDiv = '<p class="per-adult-starting-at"><span class="starting-at-cls starting-at general-starting-at">Starting At</span></p><div><span class="general-price-' + val.itemType + '"><b class="adult-price-val">' + val.shoreExData.basePriceData.formattedValue + '</b> / Adult</span></div><div><span class="general-price-' + val.itemType + '"><b class="child-price-val">' + val.shoreExData.childBasePriceData.formattedValue + '</b> / Child</span></div>';
          priceADA = 'with price Starting At ' + val.shoreExData.basePriceData.formattedValue + ' per Adult and ' + val.shoreExData.childBasePriceData.formattedValue + ' per Child';
        }
      }
    } else {
      // when shoreEx variant data is present
      if (val.shoreExData.variantData !== null) {
        // price for any type of sales per unit
        if (val.shoreExData.salesPerUnitDescription !== null && val.shoreExData.variantData.basePriceData !== null) {
          // when strikeout price is present for variant data show both strikeout and persales description
          if (val.strikeOutPrice !== null && val.strikeOutPrice.value !== null && val.strikeOutPrice.value > 0) {
            priceDiv = '<div>\n            <p class="price-person general-price-person ccl-d-inline-flex">\n            <span class="general-price-' + val.itemType + '">\n            <span class="strikeoutprice greytext" aria-label="before the price was ' + val.strikeOutPrice.formattedValue + '" role="textbox"><b>' + val.strikeOutPrice.formattedValue + '</b></span> / ' + val.shoreExData.salesPerUnitDescription + '</span></p></div><b aria-label="current price is ' + val.shoreExData.variantData.basePriceData.formattedValue + '" role="textbox"> ' + val.shoreExData.variantData.basePriceData.formattedValue + '</b>';
            priceADA = 'with price ' + val.shoreExData.variantData.basePriceData.formattedValue + ' per ' + val.shoreExData.salesPerUnitDescription;
          } else {
            // when strikeout is not present
            priceDiv = '<div class="single-row-price"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-' + val.itemType + '"><b aria-label="current price is ' + val.shoreExData.variantData.basePriceData.formattedValue + '" role="textbox">' + val.shoreExData.variantData.basePriceData.formattedValue + '</b> / ' + val.shoreExData.salesPerUnitDescription + '</span></p></div>';
            priceADA = 'with price ' + val.shoreExData.variantData.basePriceData.formattedValue + ' per ' + val.shoreExData.salesPerUnitDescription;
          }
        } else if (val.shoreExData.variantData.basePriceData !== null && val.shoreExData.variantData.childBasePriceData !== null && val.shoreExData.variantData.basePriceData.formattedValue === val.shoreExData.variantData.childBasePriceData.formattedValue) {
          // sales per unit is not present and child price is equal to base price show per person price
          // when strikeout price is present
          if (val.strikeOutPrice !== null && val.strikeOutPrice.value !== null && val.strikeOutPrice.value > 0) {
            priceDiv = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-' + val.itemType + '"><span class="strikeoutprice greytext" aria-label="before the price was ' + val.strikeOutPrice.formattedValue + '" role="textbox"><b>' + val.strikeOutPrice.formattedValue + '</b></span> / Person</span></p></div><b aria-label="current price is ' + val.shoreExData.variantData.basePriceData.formattedValue + '" role="textbox">' + val.shoreExData.variantData.basePriceData.formattedValue + '</b>';
            priceADA = 'with price ' + val.shoreExData.variantData.basePriceData.formattedValue + ' per Person';
          } else {
            // when strikeout is not present
            priceDiv = '<div class="single-row-price"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-' + val.itemType + '"><b aria-label="current price is ' + val.shoreExData.variantData.basePriceData.formattedValue + '" role="textbox">' + val.shoreExData.variantData.basePriceData.formattedValue + '</b> / Person</span></p></div>';

            priceADA = 'with price ' + val.shoreExData.variantData.basePriceData.formattedValue + ' per Person';
          }
        } else {
          // when both adult and child price are present and both are not equal
          var startDiv = '<div class="ccl-d-inline-flex">';
          var endDiv = '</div>';
          var adultDiv = '';
          var childDiv = '';
          // when strikeout price is present
          if (val.shoreExData.variantData.basePriceData !== null) {
            if (val.strikeOutPrice !== null && val.strikeOutPrice.value !== null && val.strikeOutPrice.value > 0) {
              adultDiv = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-' + val.itemType + '"><span class="strikeoutprice greytext" aria-label="before the price was ' + val.strikeOutPrice.formattedValue + '" role="textbox" > <b>' + val.strikeOutPrice.formattedValue + '</b></span > / Adult</span ></p > <b aria-label="current price is ' + val.shoreExData.variantData.basePriceData.formattedValue + '" role="textbox">' + val.shoreExData.variantData.basePriceData.formattedValue + '</b></div > ';
            } else {
              // when strikeout price is not present
              adultDiv = '<div class="no-strike-adult"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-' + val.itemType + '"><b aria-label=" current price is ' + val.shoreExData.variantData.basePriceData.formattedValue + '" role = "textbox" > ' + val.shoreExData.variantData.basePriceData.formattedValue + '</b > / Adult</span ></p ></div >';
            }
          }
          // when child strikeout price is present
          if (val.shoreExData.variantData.childBasePriceData !== null) {
            if (val.childStrikeOutPrice !== null && val.childStrikeOutPrice.value !== null && val.childStrikeOutPrice.value > 0) {
              childDiv = '<div><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-' + val.itemType + '"><span class="strikeoutprice greytext" aria-label="before the price was ' + val.childStrikeOutPrice.formattedValue + '" role = "textbox" > <b>' + val.childStrikeOutPrice.formattedValue + '</b></span > / Child</span ></p > <b aria-label="current price is ' + val.shoreExData.variantData.childBasePriceData.formattedValue + '" role="textbox">' + val.shoreExData.variantData.childBasePriceData.formattedValue + '</b></div >';
            } else {
              // when child strikeout price is not present
              childDiv = '<div class="no-strike-child"><p class="price-person general-price-person ccl-d-inline-flex"><span class="general-price-' + val.itemType + '"><b aria-label=" current price is ' + val.shoreExData.variantData.childBasePriceData.formattedValue + '" role = "textbox" > ' + val.shoreExData.variantData.childBasePriceData.formattedValue + '</b > / Child</span ></p ></div >';
            }
          }
          priceDiv = startDiv + adultDiv + childDiv + endDiv;
          if (val.shoreExData.variantData.basePriceData !== null && val.shoreExData.variantData.childBasePriceData !== null) {
            priceADA = 'with price ' + val.shoreExData.variantData.basePriceData.formattedValue + ' per adult and ' + val.shoreExData.variantData.childBasePriceData.formattedValue + ' per child';
          }
        }
      }
    }
    priceDiv = '' + priceDiv;
    return { priceDiv: priceDiv, priceADA: priceADA };
  },


  // Get price HTML for SPA
  spaPriceHTML: function spaPriceHTML(val, response) {
    var priceDiv = '';
    var priceADA = '';
    if (val.price !== null && val.price.formattedValue !== null) {
      // price when both base price and child are present but both are equal we show per person
      priceDiv = '<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-' + val.itemType + '"><b>' + val.price.formattedValue + '</b> </span></p></div>';

      priceADA = 'with price Starting At ' + val.price.formattedValue;
    }

    return { priceDiv: priceDiv, priceADA: priceADA };
  },


  // Get price HTML for Funshop
  funshopPriceHTML: function funshopPriceHTML(productData, response) {
    var priceDiv = '';
    var priceADA = '';
    var startDiv = '<p class="price-person general-price-person ccl-d-inline-flex">';
    var endDiv = '</p>';
    var adultDiv = '';
    var childDiv = '';

    var salesPerUnitDescription = productData.funShopData.salesPerUnitDescription ? '/' + productData.funShopData.salesPerUnitDescription : '';

    var childSalesPerUnitDescription = productData.funShopData.childSalesPerUnitDescription ? '/ ' + productData.funShopData.childSalesPerUnitDescription : '';

    var parentPrice = productData.price ? '<span class="general-pipe-separator pipe-separator"> | </span>' : '';

    var hasVariant = productData.hasVariant === 'FALSE' || productData.category && productData.category.trim() === 'Bottomless Bubbles Package' ? '' : 'Starting From';

    if (response.userFlowType !== null && productData.browseModePrice && productData.browseModePrice !== null && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
      adultDiv = '<span class="general-price-' + productData.itemType + ' text general-starting-at"  aria-label="current price Starting At ' + productData.browseModePrice.formattedValue + '" role="textbox">\n      <div>Starting At</div>\n      <b>' + productData.browseModePrice.formattedValue + '</b>\n      ' + salesPerUnitDescription + '\n      </span>';

      hasVariant = 'Starting At';
      productData.price.formattedValue = productData.browseModePrice.formattedValue;
    } else {
      if (productData.childBasePrice !== null) {

        if (productData.childStrikeOutPrice !== null && productData.childStrikeOutPrice.value !== null && productData.childStrikeOutPrice.value > 0) {

          childDiv = '<span class="general-price-' + productData.itemType + '" aria-label="before the price was ' + productData.childStrikeOutPrice.formattedValue + '" role="textbox">\n              <span class="strikeoutprice greytext">\n              <b>' + productData.childStrikeOutPrice.formattedValue + '</b>\n              </span>\n              ' + childSalesPerUnitDescription + '\n            </span>\n            ' + parentPrice + '\n            <b aria-label="current price is ' + productData.childBasePrice.childFormattedPrice + '" role="textbox">' + productData.childBasePrice.childFormattedPrice + '</b>';
        } else {
          childDiv = '<span class="general-price-' + productData.itemType + ' no-strike-child">\n          <b aria-label="Current price is ' + productData.childBasePrice.childFormattedPrice + '" role="textbox">\n          ' + productData.funShopData.childBasePrice.childFormattedPrice + '\n          </b>\n          ' + childSalesPerUnitDescription + '\n          </span>\n          ' + parentPrice;
        }
      } else if (productData.price !== null) {
        if (productData.strikeOutPrice !== null && productData.strikeOutPrice.value !== null && productData.strikeOutPrice.value > 0) {
          adultDiv = '<span class="general-price-' + productData.itemType + '" aria-label="before the price was ' + productData.strikeOutPrice.formattedValue + '" role="textbox">\n            ' + hasVariant + '\n            <span class="strikeoutprice greytext">\n            <b> ' + productData.strikeOutPrice.formattedValue + '</b>\n            </span>\n            ' + salesPerUnitDescription + '\n            </span>\n            <b aria-label="current price is ' + productData.price.formattedValue + '" role="textbox">\n            ' + productData.price.formattedValue + '\n            </b>';
        } else {
          adultDiv = '<span class="general-price-' + productData.itemType + ' no-strike" aria-label="current price is ' + productData.price.formattedValue + '" role="textbox">\n          ' + hasVariant + '\n          <b>' + productData.price.formattedValue + '</b>\n          ' + salesPerUnitDescription + '\n          </span>';
        }
      }
    }

    var priceLabel = productData.strikeOutPrice ? productData.strikeOutPrice.formattedValue : productData.price.formattedValue;
    priceDiv = startDiv + adultDiv + childDiv + endDiv;
    priceADA = 'with price ' + hasVariant + ' ' + priceLabel + ' ' + salesPerUnitDescription;

    return { priceDiv: priceDiv, priceADA: priceADA };
  },


  // Get price HTML for Dining
  diningPriceHTML: function diningPriceHTML(productTileData, response) {
    var priceDiv = '';
    var priceADA = '';
    var adultDiv = '';
    var childDiv = '';
    if (response.userFlowType !== null && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
      if (productTileData.diningData.basePriceData !== null && productTileData.diningData.childBasePriceData !== null && productTileData.diningData.basePriceData.formattedValue === productTileData.diningData.childBasePriceData.formattedValue || productTileData.diningData.basePriceData !== null && !productTileData.diningData.childBasePriceData) {

        priceDiv = '<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-' + productTileData.itemType + '"><b>' + productTileData.diningData.basePriceData.formattedValue + '</b> / Person</span></p></div>';

        priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' Per Person';
      } else {
        priceDiv = '<p class="per-adult-starting-at"><span class="starting-at-cls starting-at general-starting-at">Starting At</span></p><div><span class="general-price-' + productTileData.itemType + '"><b>' + productTileData.diningData.basePriceData.formattedValue + '</b> / Adult</span></div><div><span class="general-price-' + productTileData.itemType + '"><b>' + productTileData.diningData.childBasePriceData.formattedValue + '</b> / Child</span></div>';
        priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' per Adult and ' + productTileData.diningData.childBasePriceData.formattedValue + ' per Child';
      }
    }
    if (response.userFlowType === 'LOGGED_IN_BUY' || response.userFlowType === 'FUNMAIL') {
      if (productTileData.diningData.variantData.basePriceData !== null && productTileData.diningData.variantData.childBasePriceData !== null && productTileData.diningData.variantData.basePriceData.formattedValue === productTileData.diningData.variantData.childBasePriceData.formattedValue) {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value !== null && productTileData.strikeOutPrice.value > 0 && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue) {

          priceDiv = '<div>\n\t\t\t\t\t\t<p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>\n\t\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n              <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.strikeOutPrice.formattedValue + '" role="textbox">\n              <b>' + productTileData.strikeOutPrice.formattedValue + '</b>\n              </span>\n\t\t\t\t\t\t\t/ Person\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.variantData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.variantData.basePriceData.formattedValue + '</b>';

          priceADA = 'with price Starting At ' + productTileData.diningData.variantData.basePriceData.formattedValue + ' per person';
        } else {
          priceDiv = '<div class="single-row-price">\n\t\t\t\t\t\t<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>\n              <span class="general-price-' + productTileData.itemType + '">\n              <b aria-label=" current price is ' + productTileData.diningData.variantData.basePriceData.formattedValue + '" role = "textbox" > ' + productTileData.diningData.variantData.basePriceData.formattedValue + '</b > / Person\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n          </div>';
          priceADA = 'with price Starting At ' + productTileData.diningData.variantData.basePriceData.formattedValue + ' per person';
        }
      } else if (productTileData.diningData.variantData.basePriceData !== null && !productTileData.diningData.variantData.childBasePriceData) {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0 && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue) {
          priceDiv = '<div>\n            <p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>\n              <span class="general-price-' + productTileData.itemType + '">\n              <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.strikeOutPrice.formattedValue + '" role="textbox">\n              <b>' + productTileData.strikeOutPrice.formattedValue + '</b>\n              </span>\n              / Person\n              </span>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.variantData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.variantData.basePriceData.formattedValue + '</b>';

          priceADA = 'with price Starting At ' + productTileData.diningData.variantData.basePriceData.formattedValue + ' per person';
        } else {

          priceDiv = '<div class="single-row-price">\n\t\t\t\t\t\t<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>\n              <span class="general-price-' + productTileData.itemType + '">\n              <b aria-label=" current price is ' + productTileData.diningData.variantData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.variantData.basePriceData.formattedValue + '</b> / Person\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n          </div>';
          priceADA = 'with price Starting At ' + productTileData.diningData.variantData.basePriceData.formattedValue + ' per person';
        }
      } else {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0 && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue) {

          adultDiv = '<div>\n            <p class="per-adult-starting-at ccl-d-inline-flex">\n            <span class="starting-at general-starting-at">Starting At</span>\n\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n            <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.strikeOutPrice.formattedValue + '" role="textbox">\n            <b>' + productTileData.strikeOutPrice.formattedValue + '</b>\n            </span>\n\t\t\t\t\t\t\t/ Adult\n\t\t\t\t\t\t</span>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.variantData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.variantData.basePriceData.formattedValue + '</b>';
        } else {

          adultDiv = '\n            <p class="per-adult-starting-at"><span class="starting-at general-starting-at">Starting At</span></p>\n            <div class="no-strike-adult">\n\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n\t\t\t\t\t\t\t<b aria-label="Currrent price is ' + productTileData.diningData.variantData.basePriceData.formattedValue + '" role="textbox">' + productTileData.diningData.variantData.basePriceData.formattedValue + '</b>\n\t\t\t\t\t\t\t/ Adult\n            </span>\n            </div>\n\t\t\t\t\t';
        }

        if (productTileData.childStrikeOutPrice !== null && productTileData.childStrikeOutPrice.value > 0 && productTileData.diningData.variantData.basePriceData.formattedValue !== productTileData.strikeOutPrice.formattedValue) {

          childDiv = '<div>\n            <p class="per-child-starting-at ccl-d-inline-flex">\n\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n            <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.childStrikeOutPrice.formattedValue + '" role="textbox">\n            <b>' + productTileData.childStrikeOutPrice.formattedValue + '</b>\n            </span>\n\t\t\t\t\t\t\t/ Child\n\t\t\t\t\t\t</span>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.variantData.childBasePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.variantData.childBasePriceData.formattedValue + '</b>';
        } else {
          childDiv = '<div class="no-strike-child">\n          <span class="general-price-' + productTileData.itemType + '" aria-label="Current price is ' + productTileData.diningData.variantData.childBasePriceData.formattedValue + 'role="textbox">\n            <b>' + productTileData.diningData.variantData.childBasePriceData.formattedValue + '</b>\n            / Child\n          </span>\n        </div>';
        }

        priceDiv = adultDiv + childDiv;

        priceADA = 'with price Starting At ' + productTileData.diningData.variantData.basePriceData.formattedValue + ' per adult and ' + productTileData.diningData.variantData.childBasePriceData.formattedValue + ' per child';
      }
    }

    return { priceDiv: priceDiv, priceADA: priceADA };
  },


  // Get price HTML for xDining
  xDiningPriceHTML: function xDiningPriceHTML(productTileData, response) {
    var priceDiv = '';
    var priceADA = '';
    var adultDiv = '';
    var childDiv = '';
    if (response.userFlowType !== null && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
      if (productTileData.diningData.basePriceData !== null && productTileData.diningData.childBasePriceData !== null && productTileData.diningData.basePriceData.formattedValue === productTileData.diningData.childBasePriceData.formattedValue || productTileData.diningData.basePriceData !== null && !productTileData.diningData.childBasePriceData) {

        priceDiv = '<div><p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span><span class="general-price-' + productTileData.itemType + '"><b>' + productTileData.diningData.basePriceData.formattedValue + '</b> / Person</span></p></div>';

        priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' Per Person';
      } else {
        priceDiv = '<p class="per-adult-starting-at"><span class="starting-at-cls starting-at general-starting-at">Starting At</span></p><div><span class="general-price-' + productTileData.itemType + '"><b>' + productTileData.diningData.basePriceData.formattedValue + '</b> / Adult</span></div><div><span class="general-price-' + productTileData.itemType + '"><b>' + productTileData.diningData.childBasePriceData.formattedValue + '</b> / Child</span></div>';
        priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' per Adult and ' + productTileData.diningData.childBasePriceData.formattedValue + ' per Child';
      }
    }
    if (response.userFlowType === 'LOGGED_IN_BUY' || response.userFlowType === 'FUNMAIL') {
      if (productTileData.diningData.basePriceData !== null && productTileData.diningData.childBasePriceData !== null && productTileData.diningData.basePriceData.formattedValue === productTileData.diningData.childBasePriceData.formattedValue) {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value !== null && productTileData.strikeOutPrice.value > 0) {

          if (productTileData.strikeOutPrice.value !== productTileData.childStrikeOutPrice.value) {
            adultDiv = '<div>\n              <p class="per-adult-starting-at ccl-d-inline-flex">\n              <span class="starting-at general-starting-at">Starting At</span>\n              <span class="general-price-' + productTileData.itemType + '">\n              <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.strikeOutPrice.formattedValue + '" role="textbox">\n              <b>' + productTileData.strikeOutPrice.formattedValue + '</b>\n              </span>\n                / Adult\n              </span>\n            </div>\n            <b aria-label="current price is ' + productTileData.diningData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.basePriceData.formattedValue + '</b>';

            childDiv = '<div>\n            <p class="per-child-starting-at ccl-d-inline-flex">\n\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n            <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.childStrikeOutPrice.formattedValue + '" role="textbox">\n            <b>' + productTileData.childStrikeOutPrice.formattedValue + '</b>\n            </span>\n\t\t\t\t\t\t\t/ Child\n\t\t\t\t\t\t</span>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.childBasePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.childBasePriceData.formattedValue + '</b>';

            priceDiv = adultDiv + childDiv;
          } else {
            priceDiv = '<div>\n              <p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>\n                <span class="general-price-' + productTileData.itemType + '">\n                <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.strikeOutPrice.formattedValue + '" role="textbox">\n                <b>' + productTileData.strikeOutPrice.formattedValue + '</b>\n                </span>\n                / Person\n                </span>\n              </p>\n            </div>\n            <b aria-label="current price is ' + productTileData.diningData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.basePriceData.formattedValue + '</b>';

            priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' per person';
          }
        } else {
          priceDiv = '<div>\n\t\t\t\t\t\t<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>\n              <span class="general-price-' + productTileData.itemType + '">\n              <b aria-label=" current price is ' + productTileData.diningData.basePriceData.formattedValue + '" role = "textbox" > ' + productTileData.diningData.basePriceData.formattedValue + '</b > / Person\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n          </div>';
          priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' per person';
        }
      } else if (productTileData.diningData.basePriceData !== null && !productTileData.diningData.childBasePriceData) {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0) {
          priceDiv = '<div>\n            <p class="per-person-starting-at ccl-d-inline-flex"><span class="starting-at-cls general-starting-at">Starting At</span>\n              <span class="general-price-' + productTileData.itemType + '">\n              <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.strikeOutPrice.formattedValue + '" role="textbox">\n              <b>' + productTileData.strikeOutPrice.formattedValue + '</b>\n              </span>\n              / Person\n              </span>\n            </p>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.basePriceData.formattedValue + '</b>';

          priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' per person';
        } else {

          priceDiv = '<div>\n\t\t\t\t\t\t<p class="per-person-starting-at"><span class="starting-at-cls general-starting-at">Starting At</span>\n              <span class="general-price-' + productTileData.itemType + '">\n              <b aria-label=" current price is ' + productTileData.diningData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.basePriceData.formattedValue + '</b> / Person\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</p>\n          </div>';
          priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' per person';
        }
      } else {
        if (productTileData.strikeOutPrice !== null && productTileData.strikeOutPrice.value > 0) {

          adultDiv = '<div>\n            <p class="per-adult-starting-at ccl-d-inline-flex">\n            <span class="starting-at general-starting-at">Starting At</span>\n\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n            <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.strikeOutPrice.formattedValue + '" role="textbox">\n            <b>' + productTileData.strikeOutPrice.formattedValue + '</b>\n            </span>\n\t\t\t\t\t\t\t/ Adult\n\t\t\t\t\t\t</span>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.basePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.basePriceData.formattedValue + '</b>';
        } else {

          adultDiv = '\n            <p class="per-adult-starting-at"><span class="starting-at general-starting-at">Starting At</span></p>\n            <div>\n\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n\t\t\t\t\t\t\t<b aria-label="Currrent price is ' + productTileData.diningData.basePriceData.formattedValue + '" role="textbox">' + productTileData.diningData.basePriceData.formattedValue + '</b>\n\t\t\t\t\t\t\t/ Adult\n            </span>\n            </div>\n\t\t\t\t\t';
        }

        if (productTileData.childStrikeOutPrice !== null && productTileData.childStrikeOutPrice.value > 0) {

          childDiv = '<div>\n            <p class="per-child-starting-at ccl-d-inline-flex">\n\t\t\t\t\t\t<span class="general-price-' + productTileData.itemType + '">\n            <span class="strikeoutprice greytext" aria-label="before the price was ' + productTileData.childStrikeOutPrice.formattedValue + '" role="textbox">\n            <b>' + productTileData.childStrikeOutPrice.formattedValue + '</b>\n            </span>\n\t\t\t\t\t\t\t/ Child\n\t\t\t\t\t\t</span>\n          </div>\n          <b aria-label="current price is ' + productTileData.diningData.childBasePriceData.formattedValue + '" role="textbox"> ' + productTileData.diningData.childBasePriceData.formattedValue + '</b>';
        } else {
          childDiv = '<div>\n          <span class="general-price-' + productTileData.itemType + '" aria-label="Current price is ' + productTileData.diningData.childBasePriceData.formattedValue + 'role="textbox">\n            <b>' + productTileData.diningData.childBasePriceData.formattedValue + '</b>\n            / Child\n          </span>\n        </div>';
        }

        priceDiv = adultDiv + childDiv;

        priceADA = 'with price Starting At ' + productTileData.diningData.basePriceData.formattedValue + ' per adult and ' + productTileData.diningData.childBasePriceData.formattedValue + ' per child';
      }
    }

    return { priceDiv: priceDiv, priceADA: priceADA };
  },
  addToCartBtnClasses: function addToCartBtnClasses(productTileData, response) {
    /** SETTING UP SOME INITIAL VARIABLES START */
    var CSRFToken = $('#csrfSessionToken').data('csrf');
    var addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-add-cart btn-full';
    var addToCartBtnAttributes = '';
    var addToCartUniqueClass = 'add-to-cart-' + productTileData.code;

    // check if product is FTF
    var isFTFProduct = false;
    if (productTileData.shoreExData && productTileData.shoreExData.variantData && productTileData.rootCategoryName && productTileData.rootCategoryName.toLowerCase().replace(' ', '-') === 'faster-to-the-fun') {
      isFTFProduct = true;
    }
    if (response.productCategorySearchPageData) {
      var categoryCode = response.productCategorySearchPageData.categoryCode;
      if (categoryCode.toLowerCase() === 'faster-to-the-fun') {
        isFTFProduct = true;
      }
    }

    // check if product if FunshopProduct
    var isInternetProduct = false;
    if ((productTileData.itemType === 'FunShopProduct' || productTileData.itemType === 'FunShopProductModel') && productTileData.rootCategoryName && productTileData.rootCategoryName.toLowerCase().replace(' ', '-') === 'internet-plans') {
      isInternetProduct = true;
    }

    // check if product is drinkPackage product
    var isDrinkPackageProduct = false;
    if ((productTileData.itemType === 'FunShopProduct' || productTileData.itemType === 'FunShopProductModel') && productTileData.rootCategoryName && productTileData.rootCategoryName.toLowerCase().replace(' ', '-') === 'drink-packages') {
      isDrinkPackageProduct = true;
    }

    // Getting correct prodCode of different product type
    var prodCode = productTileData.code;
    if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && productTileData.shoreExData && productTileData.shoreExData.variantData) {
      prodCode = productTileData.shoreExData.variantData.skuCode;
    } else if ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.diningData && productTileData.diningData.variantData) {
      prodCode = productTileData.diningData.variantData.skuCode;
    } else {
      prodCode = productTileData.code;
    }

    // Check if product has variant
    var hasProductVariant = false;
    if (productTileData.hasVariant === 'TRUE') {
      hasProductVariant = true;
    }

    // check for stock availibility
    var isStockAvailable = true;
    if (productTileData.stock && productTileData.stock.stockLevelStatus && productTileData.stock.stockLevelStatus.code === 'outOfStock') {
      isStockAvailable = false;
    }
    /** SETTING UP SOME INITIAL VARIABLES END */

    if ((response.allBookingsOnCourtesyHold || productTileData.addToCartDisabled || !isStockAvailable) && response.userFlowType !== null && response.userFlowType !== 'BROWSE' && response.userFlowType !== 'LOGGED_IN_BROWSE' && (productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel' || isFTFProduct === true || productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel') {
      // If All booking CourtesyHold & stock not available
      addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full ' + addToCartUniqueClass;
      addToCartBtnAttributes = 'disabled="disabled"';
    } else if ((response.allBookingsOnCourtesyHold || productTileData.addToCartDisabled) && response.userFlowType !== null && response.userFlowType !== 'BROWSE' && response.userFlowType !== 'LOGGED_IN_BROWSE' && productTileData.itemType !== 'ShoreExProduct' && productTileData.itemType !== 'ShoreExProductModel' && isFTFProduct === false && productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel') {
      // If All booking CourtesyHold
      addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full ' + addToCartUniqueClass;
      addToCartBtnAttributes = 'disabled="disabled"';
    } else if ((response.userFlowType && response.userFlowType === 'BROWSE' || response.userFlowType === null) && productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel') {
      // if BROWSE Mode
      addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-add-cart btn-full ' + addToCartUniqueClass;
      addToCartBtnAttributes = 'data-productcode="' + productTileData.code + '"\n                                data-csrf="' + CSRFToken + '"\n                                data-usermode="browse"\n                                data-funshopcategorycode="' + response.categoryCode + '"\n                                data-hasVariants="' + hasProductVariant + '"\n                                data-sailingInfoNeeded="' + productTileData.sailingInfoNeeded + '"';
    } else if (response.userFlowType !== null && response.userFlowType === 'LOGGED_IN_BROWSE') {
      // if LOGGED_IN_BROWSE mode
      addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-add-cart btn-full ' + addToCartUniqueClass;
      addToCartBtnAttributes = 'data-productcode="' + productTileData.code + '"\n                                data-hasvariants="' + hasProductVariant + '"\n                                data-csrf="' + CSRFToken + '"\n                                data-usermode="loggedInBrowse"\n                                data-funshopcategorycode="' + response.categoryCode + '"\n                                data-sailingInfoNeeded="' + productTileData.sailingInfoNeeded + '"';
    } else {
      if (productTileData.itemType === 'SpaProduct' || productTileData.itemType === 'SpaProductModel') {
        // if is SPA product
        addToCartBtnClass = 'btn btn-full btn-red general-add-to-cart-btn calendarOpenBtn modalOpenBtn' + prodCode + ' ' + addToCartUniqueClass;
        addToCartBtnAttributes = 'data-productcode="' + prodCode + '"\n                                  data-csrf="' + CSRFToken + '"';
      } else if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && isFTFProduct === true) {
        // if is ShoreEX FTF product
        addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full clp-add-to-cart-btn ' + addToCartUniqueClass;
        addToCartBtnAttributes = 'data-csrf="' + CSRFToken + '"\n                                  data-productcode="' + prodCode + '"';
      } else if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && isFTFProduct === false) {
        // ShoreEx but not FTF product
        addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full checkoutConflictBtn ' + addToCartUniqueClass;
        addToCartBtnAttributes = 'data-csrf="' + CSRFToken + '"\n                                  data-productcode="' + prodCode + '"\n\t\t\t\t\t\t\t\t\t\t              data-hasupsell="' + productTileData.hasUpsell + '"';
      } else if ((productTileData.itemType === 'FunShopProduct' || productTileData.itemType === 'FunShopProductModel') && (productTileData.isFunshopAlchohol === true || productTileData.isFunshopPackage === true)) {
        // Fun shop alcohol product
        addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full alcohol-atc-modal-open-button ' + addToCartUniqueClass + '"';
        addToCartBtnAttributes = 'data-productcode="' + productTileData.code + '"\n                                data-csrf="' + CSRFToken + '"\n                                data-usermode="loggedInBuy"\n\t\t\t\t\t\t\t\t\t\t            data-sailingInfoNeeded="' + productTileData.sailingInfoNeeded + '"';
      } else if (isInternetProduct === true) {
        // internet product
        addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full clp-add-to-cart-btn ' + addToCartUniqueClass;
        addToCartBtnAttributes = 'data-csrf="' + CSRFToken + '"\n                                data-hasvariants="' + hasProductVariant + '"\n\t\t\t\t\t\t\t\t\t\t            data-productcode="' + productTileData.code + '"';
      } else if (isDrinkPackageProduct === true) {
        addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full clp-add-to-cart-btn ' + addToCartUniqueClass;
        addToCartBtnAttributes = 'data-csrf="' + CSRFToken + '"\n                                data-hasvariants="' + hasProductVariant + '"\n                                data-productcode="' + productTileData.code + '"';
      } else if ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.productType.code === 'DI') {
        addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full dining-atc-modal-open-button ' + addToCartUniqueClass;
        addToCartBtnAttributes = 'data-productcode="' + productTileData.code + '"\n                                data-csrf="' + CSRFToken + '"\n                                data-usermode="loggedInBuy"\n                                data-sailingInfoNeeded="' + productTileData.sailingInfoNeeded + '"';
      } else if ((productTileData.itemType === 'DiningProduct' || productTileData.itemType === 'DiningProductModel') && productTileData.productType.code === 'XD') {
        addToCartBtnClass = 'btn btn-red general-add-to-cart-btn btn-full xdining-atc-modal-open-button ' + addToCartUniqueClass;
        addToCartBtnAttributes = 'data-productcode="' + productTileData.code + '"\n                                data-csrf="' + CSRFToken + '"\n                                data-usermode="loggedInBuy"\n                                data-sailingInfoNeeded="' + productTileData.sailingInfoNeeded + '"';
      } else {
        if (productTileData.itemType !== 'TransfersProduct' && productTileData.itemType !== 'TransfersProductModel') {
          addToCartBtnClass = 'btn btn-red general-add-to-cart-btn fs-btn-add-cart btn-full ' + addToCartUniqueClass;
          addToCartBtnAttributes = 'data-csrf="' + CSRFToken + '"\n                                  data-funshopcategorycode="' + response.categoryCode + '"\n                                  data-hasvariants="' + hasProductVariant + '"\n                                  data-productcode="' + prodCode + '"';
        }
      }
    }

    return { addToCartBtnClass: addToCartBtnClass, addToCartBtnAttributes: addToCartBtnAttributes };
  },
  getCarouselHtml: function getCarouselHtml(productTileData, response) {
    var width = 400;
    var height = 225;
    var src = '';

    if (productTileData.images[0] !== null) {
      src = productTileData.images[0].url + '&w=' + width + '&h=' + height;
    } else {
      src = '/shop/medias/missing-store-300x300.jpg?context=bWFzdGVyfGltYWdlc3wxNTk2NTN8aW1hZ2UvanBlZ3xoZDYvaDZhLzg3OTgxMjQ3MzY1NDIvbWlzc2luZy1zdG9yZS0zMDB4MzAwLmpwZ3wyOTcyMGExMGYyNzRlZDM5OTkyNDdhNGFhMjAyMGVlNDhmODYwOGU1MmQxY2U4MTNjYzVkN2I1YzJhY2Q5MWFl&w=' + width + '&h=' + height;
    }

    return src;
  },
  eyeBrowHtml: function eyeBrowHtml(productTileData) {
    var start = '<span class="ccl_product_type general-ccl-product-type">';
    var html = '';
    var end = '</span>';

    if (productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') {
      // display port name along with category
      html += '<span class="ccl_productSuperCategory general-product-supercategory">\n        ' + productTileData.rootCategoryName + '\n      </span>\n      <span class="ccl_productCategory general-product-category">\n        <span class="general-hyphen">-</span>\n        ' + productTileData.shoreExData.portData.name + '\n      </span>';
    }

    if (productTileData.itemType !== 'ShoreExProduct' && productTileData.itemType !== 'ShoreExProductModel') {
      if (productTileData.categoryHierarchy !== null) {
        html += '<span class="ccl_productSuperCategory general-product-supercategory">' + productTileData.superCategory + '</span>';
        if (productTileData.category !== null) {
          html += '<span class="ccl_productCategory general-product-category">\n          <span class="general-hyphen">-</span> ' + productTileData.category + '</span>';
        }
        if (productTileData.subCategory !== null) {
          html += '<span class="ccl_productSubCategory general-product-subcategory">\n          <span class="general-hyphen">-</span> ' + productTileData.subCategory + '</span>';
        }
      } else {
        html += '<span class="ccl_productSuperCategory general-product-supercategory">' + productTileData.rootCategoryName + '</span>';
      }
    }

    return start + ' ' + html + ' ' + end;
  },

  /* eslint-enable */

  isWheelChair: function isWheelChair(productTileData) {
    if ((productTileData.itemType === 'ShoreExProduct' || productTileData.itemType === 'ShoreExProductModel') && productTileData.shoreExData.wheelchairAccessable != null && productTileData.shoreExData.wheelchairAccessable === true) {
      return true;
    }
    return false;
  },
  tilesClickEvents: function tilesClickEvents() {
    $('.owl-carousel').owlCarousel({
      loop: false,
      nav: true,
      touchDrag: true,
      mouseDrag: true,
      margin: 0,
      items: 1
    });

    // Lazy load images
    if ($('img.lazy').length) {
      if ($('#lazyLoadingEnabled').data('enabled') === 'true' || $('#lazyLoadingEnabled').data('enabled') === true) {
        CCL.lazyLoadInstance.update();
      }
    }
    window.googleAnalytics();
  },
  getPaginationFooterHtml: function getPaginationFooterHtml(response) {
    if (response && response.productCategorySearchPageData && response.productCategorySearchPageData.pagination) {
      var _response$productCate = response.productCategorySearchPageData.pagination,
          totalNumberOfResults = _response$productCate.totalNumberOfResults,
          currentPage = _response$productCate.currentPage,
          pageSize = _response$productCate.pageSize;

      var newPageSize = totalNumberOfResults < pageSize ? totalNumberOfResults : pageSize;
      var start = newPageSize * (currentPage + 1) - (newPageSize - 1);
      var end = newPageSize * (currentPage + 1);
      end = totalNumberOfResults < end ? totalNumberOfResults : end;
      if (totalNumberOfResults === 0 || totalNumberOfResults === null) {
        return '';
      } else if (totalNumberOfResults === 1) {
        return '<b>1</b> Out of <b>' + totalNumberOfResults + ' Results</b>';
      }
      return '<b>' + start + '-' + end + '</b> Out of <b>' + totalNumberOfResults + ' Results</b>';
    }

    return '';
  },
  sortRegionByAlpha: function sortRegionByAlpha(a, b) {
    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
    if (b.name.toLowerCase() > a.name.toLowerCase()) return -1;

    return 0;
  },
  sortPortByAlpha: function sortPortByAlpha(x, y) {
    if (x.portRegionName && y.portRegionName) {
      if (x.portRegionName.toLowerCase() > y.portRegionName.toLowerCase()) return 1;
      if (y.portRegionName.toLowerCase() > x.portRegionName.toLowerCase()) return -1;
    }

    return 0;
  },
  groupPortByRegion: function groupPortByRegion(response) {
    var _this7 = this;

    var arr = [];
    var uniqueArr = [];
    response.groupPortByRegion = false;
    if (response && response.productCategorySearchPageData && response.productCategorySearchPageData.facets) {
      $.each(response.productCategorySearchPageData.facets, function (key, val) {
        if (val.code === 'port' && (response.userFlowType === 'BROWSE' || response.userFlowType === 'LOGGED_IN_BROWSE')) {
          response.groupPortByRegion = true;
          $.each(val.values, function (innerKey, innerVal) {
            var tempAr = val.values.filter(function (x) {
              return x.portRegionName === innerVal.portRegionName;
            });
            arr.push({ portRegionName: innerVal.portRegionName, data: tempAr.sort(_this7.sortRegionByAlpha) });
          });
        }
      });
      uniqueArr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(arr.map(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default.a))).map(JSON.parse);
      return uniqueArr.length ? uniqueArr.sort(this.sortPortByAlpha) : false;
    }
    return false;
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86);
__webpack_require__(50);
__webpack_require__(83);
__webpack_require__(368);
__webpack_require__(374);
__webpack_require__(377);
__webpack_require__(379);
module.exports = __webpack_require__(8).Set;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(369);
var validate = __webpack_require__(177);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(370)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(17).f;
var create = __webpack_require__(55);
var redefineAll = __webpack_require__(139);
var ctx = __webpack_require__(27);
var anInstance = __webpack_require__(137);
var forOf = __webpack_require__(88);
var $iterDefine = __webpack_require__(67);
var step = __webpack_require__(100);
var setSpecies = __webpack_require__(174);
var DESCRIPTORS = __webpack_require__(18);
var fastKey = __webpack_require__(84).fastKey;
var validate = __webpack_require__(177);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(12);
var $export = __webpack_require__(15);
var meta = __webpack_require__(84);
var fails = __webpack_require__(24);
var hide = __webpack_require__(21);
var redefineAll = __webpack_require__(139);
var forOf = __webpack_require__(88);
var anInstance = __webpack_require__(137);
var isObject = __webpack_require__(20);
var setToStringTag = __webpack_require__(40);
var dP = __webpack_require__(17).f;
var each = __webpack_require__(371)(0);
var DESCRIPTORS = __webpack_require__(18);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(27);
var IObject = __webpack_require__(69);
var toObject = __webpack_require__(28);
var toLength = __webpack_require__(56);
var asc = __webpack_require__(372);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(373);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var isArray = __webpack_require__(101);
var SPECIES = __webpack_require__(11)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(15);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(375)('Set') });


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(87);
var from = __webpack_require__(376);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(88);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(378)('Set');


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(15);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(380)('Set');


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(15);
var aFunction = __webpack_require__(53);
var ctx = __webpack_require__(27);
var forOf = __webpack_require__(88);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(382), __esModule: true };

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(383);
module.exports = __webpack_require__(8).Number.isInteger;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(15);

$export($export.S, 'Number', { isInteger: __webpack_require__(384) });


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generalFunctions__ = __webpack_require__(4);



CCL.saveForLaterObj = {
  autoload: [['saveForLater', $('.btn-save-for-later').length > 0], ['loadSaveForLaterCartSection', $('#saveForLaterCartSection').length > 0]],

  saveForLater: function saveForLater() {
    var _this = this;

    $('.c-cart').on('click', '.btn-save-for-later', function (event) {
      var presalesid = $(event.target).data('presalesid');
      if (presalesid) {
        var getProductDiv = '.card-' + presalesid;
        $(getProductDiv).css('display', 'none');
      }
      var productId = $(event.target).data('productid');
      /* eslint-disable */
      ga('send', 'event', 'Save For later', 'Add to save for later', productId, 1);
      /* eslint-enable */
      _this.saveForLaterAjax(event);
    });
  },
  saveForLaterAjax: function saveForLaterAjax(event) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["showLoader"]();
    var productId = $(event.target).data('productid');
    var token = $('#csrfSessionToken').data('csrf');
    var spaResHoldId = $(event.target).data('sparesholdid');
    var presalesid = $(event.target).data('presalesid');
    var dataObj = {
      productId: productId
    };
    if (spaResHoldId) {
      dataObj.spaResHoldId = spaResHoldId;
    }
    if (presalesid) {
      dataObj.preSalesId = presalesid.toString();
    }

    $.ajax({
      type: 'POST',
      url: '/shop/cart/entry/execute-action/SAVEFORLATER',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj)
    }).done(function (response) {
      // Check cruise cash 500 limit on cart
      if ($(event.target).parents('.c-cart-card').find('.cruise-cash-qty-increment-btn').length) {
        CCL.cartCard.cartCruiseCashRestrictUser();
      }
      // SAS Event for remove
      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["sasEvents"]('send', response.saveForLaterSasJsonData);
      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["hideLoader"]();
      if (presalesid) {
        _this2.updateCartAfterSave(response, presalesid);
      } else if (spaResHoldId) {
        _this2.updateCartAfterSave(response, spaResHoldId);
      } else {
        _this2.updateCartAfterSave(response, productId);
      }
      // Update save for later section everytime
      _this2.loadSaveForLaterCartSection();

      $('.cart-entries').find('.c-cart-card').each(function (index, element) {
        if ($(element).find('.cancelEditGuest_ShoreEx').length) {
          $(element).find('.cancelEditGuest_ShoreEx').trigger('click');
        }
      });

      // update cart carousel
      if ($('body').find('.cart-carousel').length) {
        CCL.cartCard.updateCartCarousel();
      }

      // Update All products again once one product is removed
      // CCL.editCartStateroom.createStateroomHtml();
      console.log('save for later success');
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["hideLoader"]();
      console.log('save for later error');
    });
  },
  updateCartAfterSave: function updateCartAfterSave(response, id) {
    if (response.wishList2Entries.length) {
      var orderSummary = response.orderSummary;

      var recentAdded = response.wishList2Entries.filter(function (x) {
        return x.productCode.toString() === id.toString();
      });
      if (recentAdded.length) {
        $('.card-' + id).empty();
        $('.card-' + id).css('min-height', '100px');
        $('.card-' + id).html('<a href="' + recentAdded[0].productURL + '">' + recentAdded[0].productName + '</a> has been moved to save for later section below.');
      }

      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["updateHeaderCartWidget"](response);
      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["updateCartSummary"](orderSummary);
      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["updateProductSummary"](orderSummary);
      if (response.cartEmpty) {
        window.location.reload();
      }
    }

    if (response.couponDetails) {
      __WEBPACK_IMPORTED_MODULE_1__generalFunctions__["updateCouponSummary"](response);
    } else {
      $('.promo-code').show();
      $('.apply-promo').removeClass('show');
      $('.apply-promo-container').hide();
      $('.another-promo').hide();
      $('.apply-promo-container .error-msg').hide();
      $('.promo-added').hide();
    }
  },
  loadSaveForLaterCartSection: function loadSaveForLaterCartSection() {
    var token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: 'GET',
      url: '/shop/view/CCLSaveForLaterComponentController?componentUid=cclSaveForLaterComponent',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      // update save for later section
      $('#saveForLaterCartSection').empty();
      $('#saveForLaterCartSection').html(response);

      // Call other ajax functions for click events to work
      CCL.editCartStateroom.createStateroomHtml();
      CCL.cartCard.shoreExLoadWishlist();
    }).fail(function () {
      console.log('save for later section loading error');
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.FbtObj = {
  autoload: [['initialFbtLoad', $('#fbtComponent').length > 0], ['refreshWindow', $('body').length > 0]],

  originalFbtResponse: null,

  refreshWindow: function refreshWindow() {
    $('body').on('click', '.refresh-window', function () {
      window.location.reload();
    });
  },
  initialFbtLoad: function initialFbtLoad() {
    var _this = this;

    // check if anything is not checked on first load also
    this.disableProduct();

    $('body').on('click', '.product-name input[type="checkbox"]', function (event) {
      var totalPrice = 0;
      var totalStrikeoutPrice = 0;
      var havingStikeOut = false;
      $('#fbtComponent').find('.product-name input[type="checkbox"]:checked').each(function (index, element) {
        var _element$dataset = element.dataset,
            productId = _element$dataset.productId,
            price = _element$dataset.price,
            stikeoutprice = _element$dataset.stikeoutprice;

        totalPrice += Number(price);
        if (stikeoutprice) {
          totalStrikeoutPrice += Number(stikeoutprice) > 0 ? Number(stikeoutprice) : Number(price);
          if (Number(stikeoutprice) > 0) {
            havingStikeOut = true;
          }
        }
      });
      $('#fbtTotalPrice').html('$' + totalPrice.toFixed(2));
      $('#fbtTotalPrice').attr('aria-label', 'current price is $' + totalPrice.toFixed(2) + '.');
      if (totalStrikeoutPrice > 0 && havingStikeOut && totalStrikeoutPrice !== totalPrice) {
        $('#fbtTotalStikeoutPrice').html('$' + totalStrikeoutPrice.toFixed(2));
        $('#fbtTotalStikeoutPrice').attr('aria-label', ' old price was $' + totalStrikeoutPrice.toFixed(2) + '.');
      } else {
        $('#fbtTotalStikeoutPrice').html('');
        $('#fbtTotalStikeoutPrice').removeAttr('aria-label');
      }

      _this.disableProduct();
    });

    $('body').on('click', '.fbt-atc', function (event) {
      _this.fbtAddToCart(event);
    });

    $('body').on('click', '.fbtSuccessModal', function () {
      _this.openFbtSuccessModal();
    });
  },
  openFbtSuccessModal: function openFbtSuccessModal() {
    console.log('NEED TO OPEN FBT SUCCESS MODAL');
    $('#conflictModal .close').removeClass('fbtSuccessModal');
    CCL.addToCart.successModal(this.originalFbtResponse);

    // if you are on cart page then reload the page for FBT
    if ($('body').find('.c-cart').length) {
      $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
      $('body').find('#addToCartSuccessModal .keepShopingLink').attr('href', '/booked/home');
    }
  },
  disableProduct: function disableProduct() {
    $('.fbt-img').removeClass('disable-img');
    // Loop through all Non checked to reduced iterations
    $('#fbtComponent').find('.product-name input[type="checkbox"]:not(:checked)').each(function (index, element) {
      var productId = element.dataset.productid;
      $('#productImg-' + productId).addClass('disable-img');
    });

    // Check if something is checked and then enable button
    var checkedLength = $('.product-name input[type="checkbox"]:checked').length;
    $('.fbt-atc').attr('aria-label', 'Add ' + checkedLength + ' products to cart');
    if (checkedLength) {
      $('.fbt-atc').removeAttr('disabled');
    } else {
      $('.fbt-atc').attr('disabled', 'disabled');
    }
  },
  showFbtCCerror: function showFbtCCerror() {
    $('.cc-fbt-error').remove();
    $('#fbtComponent .product-section').append('<div class=\'cc-fbt-error\'\n              aria-live=\'assertive\'\n              role=\'alert\'\n              style=\'color:darkred\'>\n      Cruise Cash limit is $500 per stateroom.\n      </div>');
  },
  fbtAddToCart: function fbtAddToCart(event) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    var token = $('#csrfSessionToken').data('csrf');
    var dataObj = {};
    var tempArr = [];

    $('#fbtComponent').find('.product-name input[type="checkbox"]:checked').each(function (index, element) {
      var productId = element.dataset.productid;
      tempArr.push({
        variantId: productId
      });
    });

    dataObj.productCard = tempArr;

    var ajaxUrl = '/shop/cart/fbt/addToCart';
    var ajaxType = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '../json-data/fbt-add-to-cart.json';
      ajaxType = 'GET';
    }
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj)
    }).done(function (response) {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["ajaxForCruiseCashCartAmount"]();
      _this2.originalFbtResponse = response;
      // if one product is having conflict then we need to open its conflict modal
      if (response.cartResponse.length) {
        if (response.cartResponse && response.cartResponse.filter(function (x) {
          return x.errorMsg.toLowerCase().includes('cruise cash');
        }).length) {
          if (!response.cartModification) {
            _this2.showFbtCCerror();
          } else {
            _this2.showFbtCCerror();
            CCL.addToCart.successModal(response);
            if (event.target.dataset.cartpage) {
              $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
            }
            if (response.orderSummary && response.orderSummary.allProductDetails) {
              var res = { totalItemsCount: response.orderSummary.allProductDetails.length };
              __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](res);
            }
          }
        } else {
          var shoreExProdsArr = response.cartResponse.filter(function (x) {
            return x.productType.code === 'EX';
          });
          if (response.cartModification && response.cartModification.cartModificationDetails.length) {
            var addedProducts = response.cartModification.cartModificationDetails.filter(function (x) {
              return x.quantityAdded > 0;
            });
            $.each(addedProducts, function (index, value) {
              CCL.conflictModal.fbtAddedProducts.push(value.product.code);
            });
          }

          // if its shorex Products
          if (shoreExProdsArr.length) {
            CCL.conflictModal.displayedData = CCL.conflictModal.modifyConflictJSON(shoreExProdsArr[0]);
            CCL.conflictModal.openConflictModal(CCL.conflictModal.displayedData);
            setTimeout(function () {
              $('#conflictModal .close').addClass('fbtSuccessModal');
            }, 300);
          }
        }
      } else {
        CCL.addToCart.successModal(response);
        if (event.target.dataset.cartpage) {
          $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
        }
        if (response.orderSummary && response.orderSummary.allProductDetails) {
          var _res = { totalItemsCount: response.orderSummary.allProductDetails.length };
          __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["updateHeaderCartWidget"](_res);
        }
      }
      console.log('FBT Add to Cart success');
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('FBT addt to cart error');
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__ = __webpack_require__(4);






CCL.xDining = {
  autoload: [['toggleDayTime', $('#xdiningAtcModal').length > 0], ['addToCartxDining', $('#xdiningAtcModal').length > 0], ['arrowSelect', $('body').length > 0], ['selectOwner', $('.pdp-xdining-btn').length > 0], ['adultIncrement', $('#xdiningAtcModal').length > 0], ['childIncrement', $('#xdiningAtcModal').length > 0], ['adultDecrement', $('#xdiningAtcModal').length > 0], ['childDecrement', $('#xdiningAtcModal').length > 0]],

  intialResponse: {},
  selectedDayID: '',
  selectedTimeID: '',

  selectOwner: function selectOwner() {
    setTimeout(function () {
      var buyerId = $('.selected-buyer-id')[0].dataset.selectedbuyerid;
      $('.guests-check input[data-guestid=\'' + buyerId + '\']').trigger('click');
    }, 300);
  },
  toggleDayTime: function toggleDayTime() {
    var _this = this;

    $('body').on('click keypress', '.custom-control.custom-checkbox > input', function (e) {
      $(e.target).parents('.xdining-parent').find('.day-time-wrap').removeClass('show');
      if ($('.c-pdp-template-reserve-dining').length) {
        $('.atc-xdining').hide();
      }

      $(e.target).parents('.xdining-parent').find('.guests-check').removeClass('dining-guest-div-disable');
      $(e.target).parents('.xdining-parent').find('.guests-check input').removeClass('dining-guest-disable');

      $(e.target).parents('.xdining-parent').find('.stateroom-check').removeClass('dining-div-disable');
      $(e.target).parents('.xdining-parent').find('.stateroom-check input').removeClass('dining-stateroom-disable');

      $(e.target).parents('.xdining-parent').find('.red-text').empty();

      setTimeout(function () {
        _this.reservationOwner(e);
        _this.disableDayBtn(e);
      }, 300);
    });

    // on owner link click
    $('body').on('click keypress', '.owner-link', function (e) {
      e.stopPropagation();
      e.preventDefault();
      $(e.target).parents('.xdining-parent').find('.day-time-wrap').removeClass('show');
      $(e.target).parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
      $(e.target).parents('.xdining-parent').find('.saveEditCartStateroom').attr('disabled', 'disabled');

      var oldGuestName = $(e.target).parents('.guests-check').find('.dining-guest-error-msg')[0].dataset.guestname;

      var newGuestName = $(e.target).parents('.xdining-parent').find('.reservation-text').parents('.guests-check').find('.dining-guest-error-msg')[0].dataset.guestname;

      $(e.target).parents('.xdining-parent').find('.reservation-text').replaceWith('<a href="#" class="owner-link" tabindex="0" aria-label="set ' + newGuestName + ' as a reservation owner" role="button">Set as Reservation Owner</a>');
      $(e.target).parents('.xdining-parent').find('.ccl_tooltip').remove();
      $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid = $(e.target).parents('.guests-check').find('input.custom-control-input')[0].dataset.guestid;

      $(e.target).parents('.xdining-parent').find('.guests-check').removeClass('dining-guest-div-disable');
      $(e.target).parents('.xdining-parent').find('.guests-check input').removeClass('dining-guest-disable');

      $(e.target).parents('.xdining-parent').find('.stateroom-check').removeClass('dining-div-disable');
      $(e.target).parents('.xdining-parent').find('.stateroom-check input').removeClass('dining-stateroom-disable');

      $(e.target).parents('.xdining-parent').find('.red-text').empty();

      $(e.target).parents('.guests-check input').focus();
      $(e.target).parents('.xdining-parent').find('.owner-change-alert').html(oldGuestName + ' is new reservation owner');

      $(e.target).parents('.guests-check').find('.owner-div').empty().html('<span class="reservation-text">Reservation Owner</span>\n        <div class="ccl_tooltip" role="button" aria-describedby="reservation-tooltip" tabindex="0" aria-label="Reservation owner has ability to manage dining reservation">\n          <img src="/_ui/responsive/ccl/assets/icons/Oval 3 Copy 2.svg" height="12px" width="12px" alt="">\n          <div class="tooltip_text" id="reservation-tooltip" aria-live="assertive">\n              Reservation owner has ability to manage dining reservation.\n          </div>\n        </div>');
    });

    // On select day and time button click
    $('body').on('click keypress', '.selection-btn', function (e) {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
      var checkedLength = $(e.target).parents('.xdining-parent').find('.custom-control.custom-checkbox.guests-check > input[type="checkbox"]:checked').length;
      var productId = e.target.dataset.productid ? e.target.dataset.productid : $('#parent-product-code').val();
      var csrf = $('.atc-xdining').data('csrf') ? $('.atc-xdining').data('csrf') : $('#csrfSessionToken').data('csrf');
      var selectedbuyerid = e.target.dataset.selectedbuyerid;

      var dataObj = {
        code: productId,
        count: parseInt(checkedLength, 10) + parseInt($('.child-quantity-input').val(), 10) + parseInt($('.adult-quantity-input').val(), 10),
        buyerId: selectedbuyerid
      };
      if (e.target.dataset.iscart && e.target.dataset.iscart === 'true') {
        dataObj.cartPage = true;
        dataObj.serviceTimeSlot = $(e.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap')[0].dataset.servicetimeslot;
        dataObj.oldBuyerId = $(e.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap')[0].dataset.buyerid;

        // Loop through selected guests and pass to the api
        var guestIdsArray = [];
        if ($(e.target).parents('.xdining-parent').find('.custom-checkbox .guests-check input[type="checkbox"]').length) {
          $(e.target).parents('.xdining-parent').find('.custom-checkbox .guests-check input[type="checkbox"]:checked').each(function (i, elem) {
            if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled')) {
              guestIdsArray.push(elem.getAttribute('data-guestid'));
            }
          });
          dataObj.guestIds = guestIdsArray;
        }
      } else {
        var _guestIdsArray = $(e.target).parents('.xdining-parent').find('.atc-xdining').attr('data-guestIds') ? $(e.target).parents('.xdining-parent').find('.atc-xdining').attr('data-guestIds').split(',') : [];

        dataObj.guestIds = _guestIdsArray;
      }
      var ajaxUrl = '';
      var ajaxType = '';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/json-data/dining-daytime.json';
        ajaxType = 'GET';
      } else {
        ajaxUrl = '/shop/product/xDiningDateTime';
        ajaxType = 'POST';
      }
      $.ajax({
        type: ajaxType,
        url: ajaxUrl,
        contentType: 'application/json',
        dataType: 'json',
        data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(dataObj),
        headers: {
          CSRFToken: csrf
        }
      }).done(function (res) {
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
        $('.api-error').empty();
        if (res.xdininginventorydata && res.xdininginventorydata.failedInventoryCallMessage) {
          $(e.target).parents('.xdining-parent').find('.api-error').html(res.xdininginventorydata.failedInventoryCallMessage);
        } else if (res.xdininginventorydata && res.xdininginventorydata.emptyInventoryMessage) {
          if ($('.dining-Atc-modal-body .cart-card-body').length) {
            $('.dining-Atc-modal-body .cart-card-body').find('.red-text.api-error').text(res.xdininginventorydata.emptyInventoryMessage);
          } else {
            $('.c-pdp-template-reserve-dining .c-pdp-card').find('.red-text.api-error').text(res.xdininginventorydata.emptyInventoryMessage);
          }
        } else {
          _this.intialResponse = res;
          if ($(e.target).parents('.xdining-parent').find('.cart-card-body').length) {
            $(e.target).parents('.xdining-parent').find('.cart-card-body').find('.redtext').text('');
          } else {
            $('.c-pdp-template-reserve-dining .c-pdp-card').find('.redtext').text('');
          }

          $(e.target).parents('.xdining-parent').find('.selection-btn').attr('disabled', 'disabled');
          $(e.target).parents('.xdining-parent').find('.day-time-wrap').addClass('show');
          if ($('.c-pdp-template-reserve-dining').length) {
            $('.atc-xdining').show();
          }
          $(e.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').removeAttr('disabled');
          _this.populateDayDropdown(res.xdininginventorydata, e);
          _this.dropdownSelect();
        }
      }).fail(function () {
        __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
        console.log('Something went wrong in select button ajax');
      });
    });
  },
  reservationOwner: function reservationOwner(e) {
    if ($(e.target).parents('.xdining-parent').find('.selected-buyer-id').length) {
      var seletedBuyerId = $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid;
      var priorityList = $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.buyeridprioritypassengers;

      if (priorityList !== '') {
        var looping = true;
        var priorityArr = priorityList.split(',');

        if ($(e.target).hasClass('xdining-parent-check') && !$(e.target)[0].checked || $(e.target)[0].dataset.guestid && seletedBuyerId === $(e.target)[0].dataset.guestid) {
          $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid = '';
        }

        priorityArr.forEach(function (element) {
          if ($(e.target).parents('.xdining-parent').find('[data-guestid=\'' + element + '\']')[0].checked) {
            $(e.target).parents('.xdining-parent').find('[data-guestid=\'' + element + '\']').parents('.guests-check').find('.owner-link').attr('tabindex', '0').removeClass('disabled');
            if (looping && $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid === '') {
              $(e.target).parents('.xdining-parent').find('[data-guestid=\'' + element + '\']').parents('.guests-check').find('.owner-div').empty().html('<span class="reservation-text">Reservation Owner</span>\n              <div class="ccl_tooltip" role="button" tabindex="0" aria-describedby="reservation-tooltip" aria-label="Reservation owner has ability to manage dining reservation">\n                  <img src="/_ui/responsive/ccl/assets/icons/Oval 3 Copy 2.svg" height="12px" width="12px" alt="">\n                  <div class="tooltip_text" id="reservaion-tooltip" aria-live="assertive">\n                      Reservation owner has ability to manage dining reservation.\n                  </div>\n              </div>');
              $(e.target).parents('.xdining-parent').find('.selected-buyer-id')[0].dataset.selectedbuyerid = element;
              looping = false;
            }
          } else {
            var guestName = $(e.target).parents('.xdining-parent').find('[data-guestid=\'' + element + '\']').parents('.guests-check').find('.dining-guest-error-msg')[0].dataset.guestname;
            $(e.target).parents('.xdining-parent').find('[data-guestid=\'' + element + '\']').parents('.guests-check').find('.owner-div').empty().html('<a href="#" aria-label="set ' + guestName + ' as a reservation owner" class="owner-link disabled" tabindex="-1" role="button">Set as Reservation Owner</a>');
          }
        });
      } else {
        $('.all-conflict-msg').html('At least one guest must be 21 or over');
      }
    }
  },
  populateDayDropdown: function populateDayDropdown(diningData, event) {
    var _this2 = this;

    var daysArray = [];
    $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-menu').empty();

    /* eslint-disable */
    for (var index = 1; index <= __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(diningData.inventoriesForDay).length; index++) {
      $.each(diningData.inventoriesForDay['Day_' + index], function (ind, value) {
        var dateSplit = value.availability.substring(0, 8);
        daysArray.push(dateSplit);
      });
    }
    /* eslint-enable */
    daysArray = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(daysArray));

    $.each(daysArray, function (i, val) {
      var year = val.substring(0, 4);
      var month = val.substring(4, 6);
      var day = val.substring(6, 8);
      var date = '' + new Date(year, month - 1, day);
      var dateArray = date.split(' ');
      var formatDate = dateArray[0] + ', ' + dateArray[1] + ' ' + dateArray[2];
      var activeClass = i === 0 ? 'active' : '';
      var disabledClass = '';
      disabledClass = diningData.inventoriesForDay['Day_' + (i + 1)].some(function (x) {
        return x.status.toLowerCase() === 'available';
      }) ? '' : 'disabled-item';
      var dayHtml = '<button id=\'dayBtn' + i + '\' class="dropdown-item ' + activeClass + ' ' + disabledClass + '"\n      data-dayid="Day_' + (i + 1) + '" type="button">Day ' + (i + 1) + ', ' + formatDate + '</button>';
      if (i === 0) {
        var disabledClassBtn = diningData.inventoriesForDay['Day_' + (i + 1)].some(function (x) {
          return x.status.toLowerCase() === 'available';
        }) ? '' : 'blurred';

        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .select-day-item').addClass(disabledClassBtn);

        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').text('Day ' + (i + 1) + ', ' + formatDate);
        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').attr('aria-label', 'Day ' + (i + 1) + ', ' + formatDate + ' selected');
        $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').attr('aria-label', 'Day ' + (i + 1) + ', ' + formatDate + ' selected');
        _this2.populateTimeDropdown(diningData.inventoriesForDay.Day_1, event);
      }
      $(event.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-menu').append(dayHtml);
    });

    if (this.selectedDayID !== '' && this.selectedTimeID !== '') {
      $('.select-day-dropdown.xdining #' + this.selectedDayID).trigger('click');
      $('.select-time-dropdown.xdining #' + this.selectedTimeID).trigger('click');

      this.selectedDayID = '';
      this.selectedTimeID = '';
    }
  },
  populateTimeDropdown: function populateTimeDropdown(dayInventory, event) {
    if (dayInventory && dayInventory.filter(function (x) {
      return x.timeslot;
    }).length) {
      $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-menu').empty();
      $(event.target).parents('.xdining-parent').find('.notimeMessage').hide();
      $(event.target).parents('.xdining-parent').find('.select-time-item').show();
      $.each(dayInventory, function (i, val) {
        var activeClass = i === 0 ? 'active' : '';
        var disabledClass = val.status.toLowerCase() === 'available' ? '' : 'disabled-item';
        var soldOutHtml = val.status.toLowerCase() === 'available' ? '' : '<span class="red-text">&nbsp; Sold Out</span>';
        var timeHtml = '<button id=\'timeBtn' + i + '\' data-availability=\'' + val.availability + '\' data-status=\'' + val.status + '\'\n        class="dropdown-item ' + activeClass + ' ' + disabledClass + '"\n        type="button">' + val.timeslot + ' ' + soldOutHtml + '</button>';
        if (i === 0) {
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').text(val.timeslot);

          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('aria-label', val.timeslot + ' selected');
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').attr('aria-label', val.timeslot + ' selected');
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot', '' + val.availability);
          $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-soldout', '' + val.status);
        }
        $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-menu').append(timeHtml);
      });

      this.soldoutCondition(event);
    } else {
      var errMsg = 'Please check for availability on other days or explore other dining options.';
      $(event.target).parents('.xdining-parent').find('.select-time-item').hide();
      $(event.target).parents('.xdining-parent').find('.dining-atc-modal-dialog .sold-out-div').removeClass('show');
      $(event.target).parents('.xdining-parent').find('.notimeMessage').text(errMsg).show();
      $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
      $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
    }
  },
  disableDayBtn: function disableDayBtn(event) {
    var checkedLength = $(event.target).parents('.xdining-parent').find('.custom-control.custom-checkbox.guests-check > input[type="checkbox"]:checked').length;
    var selectedBuyer = $(event.target).parents('.xdining-parent').find('.selected-buyer-id')[0];
    var priorityList = selectedBuyer && selectedBuyer.dataset.buyeridprioritypassengers;
    $('.atc-xdining').attr('disabled', 'disabled');
    $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
    if (checkedLength > 0 && priorityList && priorityList !== '') {
      $(event.target).parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');

      this.enableButton($('.child-increment-btn'));
      this.enableButton($('.child-decrement-btn'));
      this.enableButton($('.adult-increment-btn'));
      this.enableButton($('.adult-decrement-btn'));
    } else {
      $(event.target).parents('.xdining-parent').find('.selection-btn').attr('disabled', 'disabled');

      this.disableButton($('.child-increment-btn'));
      this.disableButton($('.child-decrement-btn'));
      this.disableButton($('.adult-increment-btn'));
      this.disableButton($('.adult-decrement-btn'));
      $(event.target).parents('.xdining-parent').find('.day-time-wrap').removeClass('show');
      if ($('.c-pdp-template-reserve-dining').length) {
        $('.atc-xdining').hide();
      }
    }
  },
  enableButton: function enableButton(button) {
    button.css('opacity', '1');
    button.css('pointer-events', 'auto');
    button.prop('disabled', false);
  },
  disableButton: function disableButton(button) {
    button.css('opacity', '0.5');
    button.css('pointer-events', 'none');
    button.prop('disabled', true);
  },
  dropdownSelect: function dropdownSelect() {
    var _this3 = this;

    $('.select-day-dropdown.xdining .dropdown-toggle').attr('aria-live', 'assertive');
    $('.select-time-dropdown.xdining .dropdown-toggle').attr('aria-live', 'assertive');

    // On click of days dropdown item
    $('body').on('click keypress', '.select-day-dropdown.xdining .dropdown-item', function (e) {
      $(e.target).parents('.xdining-parent').find('.sold-out-div').removeClass('show');
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').removeClass('blurred');
      if ($(e.currentTarget).hasClass('disabled-item')) {
        $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').addClass('blurred');
      }
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').text(e.currentTarget.innerText);
      $(e.target).parents('.xdining-parent').find('.dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
      var selectedDay = $(e.currentTarget).attr('data-dayid');
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').attr('data-selectedday', '' + selectedDay);
      _this3.populateTimeDropdown(_this3.intialResponse.xdininginventorydata.inventoriesForDay[selectedDay], e);
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').addClass('ada-highlighted');
      $('.select-day-dropdown.xdining .dropdown-toggle').attr('aria-label', 'Select day: ' + e.currentTarget.innerText + ' selected');
      $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle span').attr('aria-label', 'Select day: ' + e.currentTarget.innerText + ' selected');
      setTimeout(function () {
        $(e.target).parents('.xdining-parent').find('.select-day-dropdown.xdining .dropdown-toggle').focus();
      }, 100);
    });

    // On click of time dropdown item
    $('body').on('click keypress', '.select-time-dropdown.xdining .dropdown-item', function (e) {
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').html(e.currentTarget.innerHTML);
      var selectedTime = e.currentTarget.dataset.availability;
      var status = e.currentTarget.dataset.status;

      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot', '' + selectedTime);
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-soldout', '' + status);
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-menu button').removeClass('active');
      e.currentTarget.className += ' active'; // Append active class to selected
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').addClass('ada-highlighted');
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('aria-label', 'Select Time: ' + e.currentTarget.innerText + ' selected');
      $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle span').attr('aria-label', 'Select Time: ' + e.currentTarget.innerText + ' selected');
      setTimeout(function () {
        $(e.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').focus();
      }, 100);
      _this3.soldoutCondition(e);
    });
  },
  arrowSelect: function arrowSelect() {
    $('body').on('click keypress', '.drop-icon-href', function (e) {
      if ($(e.target).attr('aria-expanded') === 'true') {
        $(e.target).attr('aria-label', 'select to expand guest view');
        $(e.target).attr('aria-expanded', 'false');
      } else {
        $(e.target).attr('aria-label', 'select to collapse guest view');
        $(e.target).attr('aria-expanded', 'true');
      }

      setTimeout(function () {
        $(e.target).addClass('ada-highlighted');
        $(e.target).focus();
      }, 2000);
    });
  },
  soldoutCondition: function soldoutCondition(event) {
    this.showConflicts(event);
  },


  // Show conflicts messages on CLP modal & PDP & Cart
  showConflicts: function showConflicts(event) {
    var _this4 = this;

    var selectedTimeSlot = $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot');
    var oldTimeSlot = $(event.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap').attr('data-servicetimeslot');

    var buyerId = $(event.target).parents('.xdining-parent').find('.xdining-cart-edit-stateroom-wrap').attr('data-buyerid');

    $(event.target).parents('.xdining-parent').find('.sold-out-div').removeClass('show');
    var soldoutData = $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').attr('data-soldout');
    if (soldoutData.toLowerCase() === 'sold out' || soldoutData.toLowerCase() === 'not available') {
      // Empty all messages if we have sold out condition
      $(event.target).parents('.xdining-parent').find('.dining-stateroom-error-msg').empty();
      $(event.target).parents('.xdining-parent').find('.dining-guest-error-msg').empty();
      $(event.target).parents('.xdining-parent').find('.all-conflict-msg').empty();

      $(event.target).parents('.xdining-parent').find('.sold-out-div').addClass('show');
      $(event.target).parents('.xdining-parent').find('.sold-out-div .sold-out-msg').html('Sold Out');
      $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').addClass('blurred');
      $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
      $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
    } else {
      $(event.target).parents('.xdining-parent').find('.sold-out-div').removeClass('show');
      $(event.target).parents('.xdining-parent').find('.select-time-dropdown.xdining .dropdown-toggle').removeClass('blurred');
      $(event.target).parents('.xdining-parent').find('.atc-xdining').removeAttr('disabled');

      // CHECK OF CONFLICTS ONLY IF ITS NOT SOLD OUT

      if (this.intialResponse.xdiningConflictsData) {
        if (this.intialResponse.xdiningConflictsData.xdiningConflicts && this.intialResponse.xdiningConflictsData.xdiningConflicts[selectedTimeSlot]) {
          var conflictData = this.intialResponse.xdiningConflictsData.xdiningConflicts;

          /* eslint-disable */
          // If everything is conflicting
          if (conflictData[selectedTimeSlot].allConflict) {
            $(event.target).parents('.xdining-parent').find('.stateroom-check').addClass('dining-div-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check input.parent-check').addClass('dining-stateroom-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check .guests-check input').addClass('dining-guest-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check .guests-check').addClass('dining-guest-div-disable');

            var allConflictMsg = this.intialResponse.conflictsMsgMap[conflictData[selectedTimeSlot].allConflictMsg];

            // show all conflict msg
            // if all are conflicting remove previous stateroom & guest error msgs also
            $(event.target).parents('.xdining-parent').find('.all-conflict-msg').text(allConflictMsg);
            $(event.target).parents('.xdining-parent').find('.dining-stateroom-error-msg').empty();
            $(event.target).parents('.xdining-parent').find('.dining-guest-error-msg').empty();
            $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
            $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
          } else {
            $(event.target).parents('.xdining-parent').find('.all-conflict-msg').empty();
            $(event.target).parents('.xdining-parent').find('.stateroom-check').removeClass('dining-div-disable');
            $(event.target).parents('.xdining-parent').find('.stateroom-check input').removeClass('dining-stateroom-disable');

            if (conflictData[selectedTimeSlot].stateroomsConflictInfo && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(conflictData[selectedTimeSlot].stateroomsConflictInfo).length > 0) {
              // loop through all the staterooms
              $.each(conflictData[selectedTimeSlot].stateroomsConflictInfo, function (i, val) {
                var stateroomBoxId = oldTimeSlot && buyerId ? val.stateroomId + '-' + oldTimeSlot + '-' + buyerId : val.stateroomId;
                // if stateroom have conflict then add a class and show message
                if (val.stateroomConflict) {

                  // show message only if stateroom is checked
                  if ($(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).is(':checked')) {
                    $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).parents('.stateroom-check').addClass('dining-div-disable');
                    $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).addClass('dining-stateroom-disable');

                    $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).parents('.stateroom-check').find('.dining-guest-error-msg').empty();

                    $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).parents('.stateroom-check').find('.guests-check input').addClass('dining-guest-disable');

                    var stateroomConflictMsg = _this4.intialResponse.conflictsMsgMap[val.stateroomConflictMsg];
                    $(event.target).parents('.xdining-parent').find('#diningStateroomErrorMsg-' + stateroomBoxId).text(stateroomConflictMsg);
                  }
                } else {
                  $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).parents('.stateroom-check').find('.guests-check input').removeClass('dining-guest-disable');

                  $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).parents('.stateroom-check').find('.guests-check').removeClass('dining-guest-div-disable');

                  $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).parents('.stateroom-check').removeClass('dining-div-disable');
                  $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).removeClass('dining-stateroom-disable');
                  $(event.target).parents('.xdining-parent').find('#diningStateroomErrorMsg-' + stateroomBoxId).empty();
                  $(event.target).parents('.xdining-parent').find('#' + stateroomBoxId).parents('.stateroom-check').find('.dining-guest-error-msg').empty();

                  // check if some guests are having conflict
                  if (val.guestPerStateroomConflictInfoMap && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(val.guestPerStateroomConflictInfoMap).length > 0) {
                    $.each(val.guestPerStateroomConflictInfoMap, function (guestId, guestVal) {
                      var guestBoxId = oldTimeSlot && buyerId ? guestId + '-' + oldTimeSlot + '-' + buyerId : guestId;
                      // Guest is having conflict
                      if (guestVal !== 'noConflicts') {
                        // show guest error only if that guest is selected
                        if ($(event.target).parents('.xdining-parent').find('#' + guestBoxId).is(':checked')) {
                          var guestConflictMsg = _this4.intialResponse.conflictsMsgMap[guestVal];
                          var guestName = $(event.target).parents('.xdining-parent').find('#diningGuestErrorMsg-' + guestBoxId).data('guestname');
                          $(event.target).parents('.xdining-parent').find('#diningGuestErrorMsg-' + guestBoxId).attr('aria-label', guestName + '. ' + guestConflictMsg).text(guestConflictMsg);
                          $(event.target).parents('.xdining-parent').find('#' + guestBoxId).parents('.guests-check').addClass('dining-guest-div-disable');
                          $(event.target).parents('.xdining-parent').find('#' + guestBoxId).addClass('dining-guest-disable');
                        } else {
                          $(event.target).parents('.xdining-parent').find('#' + guestBoxId).parents('.guests-check').removeClass('dining-guest-div-disable');
                          $(event.target).parents('.xdining-parent').find('#' + guestBoxId).removeClass('dining-guest-disable');
                        }
                      } else {
                        $(event.target).parents('.xdining-parent').find('#diningGuestErrorMsg-' + guestBoxId).empty();
                        $(event.target).parents('.xdining-parent').find('#' + guestBoxId).removeClass('dining-guest-disable');
                        $(event.target).parents('.xdining-parent').find('#' + guestBoxId).parents('.guests-check').removeClass('dining-guest-div-disable');
                      }
                    });
                  }
                }
              });
            }
          }
          /* eslint-enable */
        }
      }

      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["pdpGetSelectedData"]();

      if ($(event.target).parents('.xdining-parent').find('.dining-stateroom-disable').length || $(event.target).parents('.xdining-parent').find('.dining-guest-disable').length) {
        $(event.target).parents('.xdining-parent').find('.atc-xdining').attr('disabled', 'disabled');
        $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').attr('disabled', 'disabled');
      } else {
        $(event.target).parents('.xdining-parent').find('.atc-xdining').removeAttr('disabled');
        $(event.target).parents('.xdining-cart-edit-stateroom-wrap').find('.saveEditCartStateroom').removeAttr('disabled');
      }
    }
  },
  getNumberOfSelectedGuests: function getNumberOfSelectedGuests(eventTarget) {
    if ($('.cart-edit-stateroom').length > 0) {
      return eventTarget.closest('.cart-edit-stateroom').find('.guests-check input:checkbox:checked').length;
    }
    var guestIdsArray = eventTarget.parents('.xdining-parent').find('.atc-xdining').attr('data-guestIds') ? eventTarget.parents('.xdining-parent').find('.atc-xdining').attr('data-guestIds').split(',') : [];
    return guestIdsArray.length;
  },
  adultIncrement: function adultIncrement() {
    var _this5 = this;

    $('body').on('click keypress', '.adult-increment-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        var eTarget = $(event.target);
        var eCurrentTarget = $(event.currentTarget);
        var numberOfSelectedGuests = _this5.getNumberOfSelectedGuests($(event.target));
        var maxCount = '12';
        var adultDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-decrement-btn');
        var adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        var childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        var childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        var adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        _this5.enableButton(adultDecrementBtn);
        eCurrentTarget.removeAttr('title');
        childIncrementBtn.removeAttr('title');
        if (adultVal < maxCount - childVal - numberOfSelectedGuests) {
          adultVal++;
          event.currentTarget.previousElementSibling.firstElementChild.value = adultVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', 'adult quantity value is ' + adultVal);
          eCurrentTarget.attr('aria-label', 'increase adult quantity with current value ' + adultVal);
          eTarget.parents('.btn-functions').find('.adult-decrement-btn').attr('aria-label', 'decrease adult quantity with current value ' + adultVal);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        } else {
          eCurrentTarget.attr('aria-label', 'There is a max of ' + maxCount + ' guests');
          eCurrentTarget.attr('title', 'There is a max of ' + maxCount + ' guests');
          _this5.disableButton(adultIncrementBtn);
          adultIncrementBtn.parent().find(adultDecrementBtn).addClass('ada-highlighted').focus();
        }
      }
    });
  },
  childIncrement: function childIncrement() {
    var _this6 = this;

    $('body').on('click keypress', '.child-increment-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        var eTarget = $(event.target);
        var eCurrentTarget = $(event.currentTarget);
        var maxCount = '12';
        var numberOfSelectedGuests = _this6.getNumberOfSelectedGuests($(event.target));
        var childDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-decrement-btn');
        var adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        var childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        var adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        var childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        _this6.enableButton(childDecrementBtn);
        eCurrentTarget.removeAttr('title');
        adultIncrementBtn.removeAttr('title');
        if (childVal < maxCount - adultVal - numberOfSelectedGuests) {
          childVal++;
          event.currentTarget.previousElementSibling.firstElementChild.value = childVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.previousElementSibling.firstElementChild).attr('aria-label', 'child quantity value is ' + childVal);
          eCurrentTarget.attr('aria-label', 'increase child quantity with current value ' + childVal);
          eTarget.parents('.btn-functions').find('.child-decrement-btn').attr('aria-label', 'decrease child quantity with current value ' + childVal);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        } else {
          eCurrentTarget.attr('aria-label', 'There is a max of ' + maxCount + ' guests');
          eCurrentTarget.attr('title', 'There is a max of ' + maxCount + ' guests');
          _this6.disableButton(childIncrementBtn);
          childIncrementBtn.parent().find(childDecrementBtn).addClass('ada-highlighted').focus();
        }
      }
    });
  },
  adultDecrement: function adultDecrement() {
    var _this7 = this;

    $('body').on('click keypress', '.adult-decrement-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        var eCurrentTarget = $(event.currentTarget);
        var eTarget = $(event.target);
        var maxCount = 12;
        var numberOfSelectedGuests = _this7.getNumberOfSelectedGuests($(event.target));
        var adultDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-decrement-btn');
        var adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        var childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        var childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        var adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        _this7.enableButton(adultIncrementBtn);
        adultIncrementBtn.removeAttr('title');
        childIncrementBtn.removeAttr('title');
        if (adultVal > 0) {
          adultVal--;
          event.currentTarget.nextElementSibling.firstElementChild.value = adultVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', 'quantity value is ' + adultVal);
          eCurrentTarget.attr('aria-label', 'decrease adult quantity with current value ' + adultVal);
          eTarget.parents('.btn-functions').find('.adult-increment-btn').attr('aria-label', 'increase adult quantity with current value ' + adultVal);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        }
        if (childVal < maxCount - adultVal - numberOfSelectedGuests) {
          _this7.enableButton(childIncrementBtn);
          childIncrementBtn.attr('aria-label', 'increase child quantity with current value ' + childVal);
        }
        if (adultVal <= 0) {
          adultDecrementBtn.parent().find(adultIncrementBtn).addClass('ada-highlighted').focus();
          _this7.disableButton(adultDecrementBtn);
        }
      }
    });
  },
  childDecrement: function childDecrement() {
    var _this8 = this;

    $('body').on('click keypress', '.child-decrement-btn', function (event) {
      if (event.type === 'click' || event.keyCode === 13) {
        var eCurrentTarget = $(event.currentTarget);
        var eTarget = $(event.target);
        var numberOfSelectedGuests = _this8.getNumberOfSelectedGuests($(event.target));
        var maxCount = 12;
        var childDecrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-decrement-btn');
        var adultIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.adult-increment-btn');
        var childIncrementBtn = eTarget.closest('.additional-seats-collapsible').find('.child-increment-btn');
        var adultVal = eTarget.closest('.additional-seats-collapsible').find('.adult-quantity-input').val();
        var childVal = eTarget.closest('.additional-seats-collapsible').find('.child-quantity-input').val();
        _this8.enableButton(childIncrementBtn);
        adultIncrementBtn.removeAttr('title');
        childIncrementBtn.removeAttr('title');
        if (childVal > 0) {
          childVal--;
          event.currentTarget.nextElementSibling.firstElementChild.value = childVal;
          eCurrentTarget.addClass('ada-highlighted');
          eCurrentTarget.focus();
          $(event.currentTarget.nextElementSibling.firstElementChild).attr('aria-label', 'quantity value is ' + childVal);
          eCurrentTarget.attr('aria-label', 'decrease child quantity with current value ' + childVal);
          eTarget.parents('.btn-functions').find('.child-increment-btn').attr('aria-label', 'increase child quantity with current value ' + childVal);
          eTarget.parents('.xdining-parent').find('.selection-btn').removeAttr('disabled');
        }if (adultVal < maxCount - childVal - numberOfSelectedGuests) {
          _this8.enableButton(adultIncrementBtn);
          adultIncrementBtn.attr('aria-label', 'increase adult quantity with current value ' + adultVal);
        }if (childVal <= 0) {
          childDecrementBtn.parent().find(childIncrementBtn).addClass('ada-highlighted').focus();
          _this8.disableButton(childDecrementBtn);
        }
      }
    });
  },
  addToCartxDining: function addToCartxDining() {
    var _this9 = this;

    $('body').on('click', '.xdining-close-btn', function (e) {
      _this9.selectedDayID = $('.select-day-dropdown.xdining .dropdown-item.active')[0].id;
      _this9.selectedTimeID = $('.select-time-dropdown.xdining .dropdown-item.active')[0].id;

      $('.selection-btn').removeAttr('disabled').trigger('click');
    });

    $('body').on('click', '.atc-xdining', function (e) {
      __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["showLoader"]();
      var csrf = $('.atc-xdining').data('csrf') ? $('.atc-xdining').data('csrf') : $('#csrfSessionToken').data('csrf');
      var targetElement = $(e.target).data('hasvariants');
      var productCodePost = $(e.target).attr('data-productid');
      var selectedTime = $('.select-time-dropdown.xdining .dropdown-toggle').attr('data-timeslot');
      var guestIdsArray = $(e.target).attr('data-guestIds') ? $(e.target).attr('data-guestIds').split(',') : [];
      var selectedbuyerid = $('.selected-buyer-id')[0].dataset.selectedbuyerid;

      var childAnonymousGuests = $('.child-quantity-input').val();
      var adultAnonymousGuests = $('.adult-quantity-input').val();
      var wheelChairRequired = $('.js-wheelchair').is(':checked');
      var sendData = {
        productId: productCodePost,
        guestIds: guestIdsArray,
        timeSlot: selectedTime,
        buyerId: selectedbuyerid,
        childAnonymousGuests: childAnonymousGuests,
        adultAnonymousGuests: adultAnonymousGuests,
        wheelChairRequired: wheelChairRequired
      };
      var pageType = $('#pagetype').data('pagetype');
      sendData.pageType = pageType;
      if (pageType === 'CATEGORY') {
        sendData.productPosition = localStorage.getItem('productposition');
        sendData.pageNumber = localStorage.getItem('pageNumber');
        sendData.categoryName = localStorage.getItem('sascategorycode');
      }
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        $.ajax({
          type: 'POST',
          url: ' /shop/cart/xDining/add',
          contentType: 'application/json',
          data: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(sendData),
          headers: {
            CSRFToken: csrf
          }
        }).done(function (response) {
          __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
          if (response.diningError) {
            $('.diningErrorMsg').html(response.diningErrorText);
          } else if (response.addedToCart) {
            __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["updateHeaderCartWidget"](response);
            __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideModal"]('xdiningAtcModal');
            CCL.addToCart.successModal(response);
            $('.diningErrorMsg').html('');
            if ($(e.target).hasClass('pdp-xdining-btn')) {
              $('#addToCartSuccessModal .close').addClass('xdining-close-btn');
            }
          }
        }).fail(function () {
          __WEBPACK_IMPORTED_MODULE_4__js_generalFunctions__["hideLoader"]();
          console.log('Something went wrong');
        });
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__ = __webpack_require__(4);



CCL.atcxDining = {
  autoload: [['initialDataLoad', $('#xdiningAtcModal').length > 0]],

  firtimeload: true,

  initialDataLoad: function initialDataLoad() {
    var _this = this;

    $('body').on('click', '.xdining-atc-modal-open-button', function (e) {
      var prodId = $(e.currentTarget).data('productcode');
      _this.loadDiningJsonData(prodId);
    });
  },
  initialValuesTimeDay: function initialValuesTimeDay() {
    var selectDay = $('#select-day');
    var selectTime = $('#select-time');
    var dayValue = selectDay.find('> span').text();
    var timeValue = selectTime.find('> span').text();

    setTimeout(function () {
      selectDay.attr('aria-label', 'Select day: ' + dayValue + ' selected');
      selectTime.attr('aria-label', 'Select time: ' + timeValue + ' selected');
    }, 200);
  },
  loadDiningJsonData: function loadDiningJsonData(prodId) {
    var _this2 = this;

    var token = $('#csrfSessionToken').data('csrf');
    var ajaxUrl = '';
    var ajaxType = '';
    var dataObj = { productCode: prodId };
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/xdining-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataObj),
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      _this2.loadHtmlTamplate(response);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while fetching data');
    });
  },
  loadHtmlTamplate: function loadHtmlTamplate(jsonData) {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showLoader"]();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/xdining-atc-modal/xdining-atc-modal.html'
    }).done(function (response) {
      var html = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["createDynamicHTML"](response, jsonData);
      $('#dynamicxDiningAtcModal').empty().append(html);
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["showModal"]('xdiningAtcModal');
      // CCL.Dining.priceShow();
      // if (this.firtimeload === true) {
      //   CCL.xDining.toggleDayTime();
      //   CCL.xDining.addToCartDining();
      //   this.firtimeload = false;
      // }

      CCL.xDining.dropdownSelect();
      _this3.modalEvents();
      _this3.initialValuesTimeDay();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["pdpGetSelectedData"]();
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["checkboxCheck"]();

      setTimeout(function () {
        if ($('#' + jsonData.buyerId).length) {
          $('#' + jsonData.buyerId).trigger('click');
        }
      }, 500);
      // $(`#${jsonData.buyerId}`)[0].checked = true;
      // $(`#${jsonData.buyerId}`).closest('.stateroom-check')[0].firstElementChild.checked = true;
    }).fail(function () {
      __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["hideLoader"]();
      console.log('error while loading html');
    });
  },
  modalEvents: function modalEvents() {
    var modalEl = $('#diningAtcModal');
    var firstFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl);
    var lastFocusable = __WEBPACK_IMPORTED_MODULE_1__js_generalFunctions__["getFocusableElements"](modalEl, 'last');

    firstFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && event.shiftKey) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', function (event) {
      if (event.keyCode === 9 && !event.shiftKey) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__ = __webpack_require__(4);


CCL.favorites = {
  autoload: [['initialFavLoad', $('body').length > 0], ['favPageLoad', $('#favoritesPage').length > 0]],

  favPageLoad: function favPageLoad() {
    if (window.favoritesSasData) {
      // SAS Event for favorite page load
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["sasEvents"]('send', window.favoritesSasData);
    }
  },
  initialFavLoad: function initialFavLoad() {
    var _this = this;

    // Add to Favorites
    $('body').on('click keypress', '.add-to-fav', function (e) {
      _this.ajaxForFavorite(e, true);
    });

    // Remove from Favorites
    $('body').on('click keypress', '.remove-from-fav', function (e) {
      _this.ajaxForFavorite(e, false);
    });

    // Remove from Favorites *FROM FAVORITE PAGE
    $('body').on('click keypress', '.remove-from-favorite', function (e) {
      _this.ajaxForRemoveFromFavorite(e);
    });

    // Move to Favorites *FROM SAVE FOR LATER
    $('body').on('click keypress', '.move-to-favorites-from-cart', function (e) {
      _this.ajaxForMoveToFavoriteFromCart(e);
    });
  },
  ajaxForMoveToFavoriteFromCart: function ajaxForMoveToFavoriteFromCart(event) {
    var _this2 = this;

    var _$$0$dataset = $(event.target)[0].dataset,
        productid = _$$0$dataset.productid,
        baseproductid = _$$0$dataset.baseproductid;


    __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showLoader"]();
    var token = $('#csrfSessionToken').data('csrf');
    var ajaxUrl = '/shop/favorites/move/' + productid + '/' + baseproductid;
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      var titleHtml = $('#saveForLaterCartSection .card-' + productid + ' .title').html();
      $('#saveForLaterCartSection .card-' + productid).empty();
      $('#saveForLaterCartSection .card-' + productid).css('min-height', '100px');
      $('#saveForLaterCartSection .card-' + productid).html(titleHtml + ' has been moved to your Favorites.').addClass('removed-card');

      if (response.wishListFull) {
        _this2.openFavFullModal();
      } else {
        var msg = '<span class="white-checkmark"></span>Added to favorites: <strong>' + response.productName + '</strong>';
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showGlobalToast"]('#toastMessage', 4000, msg);
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["updateHeaderFavoriteWidget"](response);
        /* eslint-disable */
        ga('send', 'event', 'Add to Favorites', 'Add to Favorites', productid, 1);
        if (response.cclSasAnalyticsJsonData) {
          // SAS Event for favorite
          __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["sasEvents"]('send', JSON.parse(response.cclSasAnalyticsJsonData));
        }
        /* eslint-enable */
      }
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
    }).fail(function () {
      console.log('error while remove from fav');
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
    });
  },
  ajaxForRemoveFromFavorite: function ajaxForRemoveFromFavorite(event) {
    var productid = $(event.target)[0].dataset.productid;


    __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showLoader"]();
    var token = $('#csrfSessionToken').data('csrf');
    var ajaxUrl = '/shop/favorites/remove/' + productid;
    $.ajax({
      type: 'GET',
      url: ajaxUrl,
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done(function (response) {
      $('body').find('.favorite-card-' + productid).remove();
      $('body').find('.c-favorites-heading .favorites-page-title').html('YOUR FAVORITES (' + response.wishlistItemCount + ' ITEMS)');
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["updateHeaderFavoriteWidget"](response);
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
      var msg = '<span class="white-checkmark"></span>Removed from favorites: <strong>' + response.productName + '</strong>';
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showGlobalToast"]('#toastMessage', 4000, msg);
      /* eslint-disable */
      ga('send', 'event', 'Remove from Favorites', 'Remove from Favorites', productid, 1);
      if (response.cclSasAnalyticsJsonData) {
        // SAS Event for favorite
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["sasEvents"]('send', JSON.parse(response.cclSasAnalyticsJsonData));
      }
      /* eslint-enable */
      if (response.wishlistItemCount === 0) {
        window.location.reload();
      }
    }).fail(function () {
      console.log('error while remove from fav');
      __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
    });
  },
  ajaxForFavorite: function ajaxForFavorite(event) {
    var _this3 = this;

    var add = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _$$parents$find$0$dat = $(event.target).parents('.fav-section').find('.add-to-fav')[0].dataset,
        usermode = _$$parents$find$0$dat.usermode,
        productid = _$$parents$find$0$dat.productid;
    // if its browe mode then redirect user to login

    if (usermode === 'BROWSE') {
      var refUrl = window.location.pathname + window.location.search;
      var alteredURL = __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["removeParam"]('page', refUrl);
      var encodedURL = window.location.search === '' ? encodeURIComponent(alteredURL + '?ref=favorite&productId=' + productid) : encodeURIComponent(alteredURL + '&ref=favorite&productId=' + productid);
      console.log(refUrl, alteredURL);
      window.location.href = '/profilemanagement/accounts/login?returnUrl=' + encodedURL + '&eru=true';
    } else {
      if (add === true) {
        $(event.target).parents('.fav-section').find('.add-to-fav').addClass('d-none');
        $(event.target).parents('.fav-section').find('.remove-from-fav').removeClass('d-none');
      } else {
        $(event.target).parents('.fav-section').find('.add-to-fav').removeClass('d-none');
        $(event.target).parents('.fav-section').find('.remove-from-fav').addClass('d-none');
      }

      var ajaxUrl = add === true ? '/shop/favorites/add/' + productid : '/shop/favorites/remove/' + productid;
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = '/json-data/favorite.json';
      }

      var token = $('#csrfSessionToken').data('csrf');
      $.ajax({
        type: 'GET',
        url: ajaxUrl,
        contentType: 'application/json',
        headers: {
          CSRFToken: token
        }
      }).done(function (response) {
        if (response.wishListFull) {
          _this3.openFavFullModal();
          if (add === true) {
            $(event.target).parents('.fav-section').find('.add-to-fav').removeClass('d-none');
            $(event.target).parents('.fav-section').find('.remove-from-fav').addClass('d-none');
          } else {
            $(event.target).parents('.fav-section').find('.add-to-fav').addClass('d-none');
            $(event.target).parents('.fav-section').find('.remove-from-fav').removeClass('d-none');
          }
        } else {
          /* eslint-disable */
          if (add === true) {
            ga('send', 'event', 'Add to Favorites', 'Add to Favorites', productid, 1);
          } else {
            ga('send', 'event', 'Remove from Favorites', 'Remove from Favorites', productid, 1);
          }
          /* eslint-enable */
          var msg = add === true ? '<span class="white-checkmark"></span>Added to favorites: <strong>' + response.productName + '</strong>' : '<span class="white-checkmark"></span>Removed from favorites: <strong>' + response.productName + '</strong>';
          __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showGlobalToast"]('#toastMessage', 4000, msg);
          __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["updateHeaderFavoriteWidget"](response);
        }

        if (response.cclSasAnalyticsJsonData) {
          // SAS Event for favorite
          __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["sasEvents"]('send', JSON.parse(response.cclSasAnalyticsJsonData));
        }
      }).fail(function () {
        console.log('error while adding to fav');
        __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["hideLoader"]();
        if (add === true) {
          $(event.target).parents('.fav-section').find('.add-to-fav').removeClass('d-none');
          $(event.target).parents('.fav-section').find('.remove-from-fav').addClass('d-none');
        } else {
          $(event.target).parents('.fav-section').find('.add-to-fav').addClass('d-none');
          $(event.target).parents('.fav-section').find('.remove-from-fav').removeClass('d-none');
        }
      });
    }
  },
  openFavFullModal: function openFavFullModal() {
    __WEBPACK_IMPORTED_MODULE_0__js_generalFunctions__["showModal"]('favFullModal');
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(3)))

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// This will allow webpack to watch the files and re-run respective plugins for Assemble

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// This will allow webpack to watch the files and re-run respective plugins for Assemble

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// This will allow webpack to watch the files and re-run respective plugins for Assemble

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// This will allow webpack to watch the files and re-run respective plugins for Assemble

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/app.js